// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"jUsSX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _appJs = require("./components/App.js");
var _appJsDefault = parcelHelpers.interopDefault(_appJs);
var root = document.getElementById("root");
var container = (0, _client.createRoot)(root);
container.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appJsDefault.default), {}));

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-dom/client":"fG7Yo","./components/App.js":"lcG0G","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"66j3G":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"lHUh4"}],"lHUh4":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"l5IPE"}],"l5IPE":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"6WscV"}],"6WscV":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function forEach(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{"@swc/helpers/_/_type_of":"60jEQ"}],"60jEQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iRwqC":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"fG7Yo":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"lkfQ7"}],"lkfQ7":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"6mFrm"}],"6mFrm":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function get() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function onError(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, _typeOf._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, _typeOf._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function persist() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function key(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var _$d = f, _$e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, _$d))) {
                    ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = _$d ? ue(_$d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = _$d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, _$e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = _$e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(_$d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) _$d = oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function Jf(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function useCallback(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        return Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function useState() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function useState() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function Aj() {};
Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a), ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = gl(g);
                f.call(_$a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = gl(k);
            h.call(_$a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = gl(g);
                h.call(_$a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function Hc() {
    return C;
};
Ic = function Ic(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function yb(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"@swc/helpers/_/_type_of":"60jEQ","5393afc8c463ef07":"l5IPE","ece50e903283a22f":"3Uj2o"}],"3Uj2o":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"8enJS"}],"8enJS":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function S() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function S() {
        U.postMessage(null);
    };
} else S = function S() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"lcG0G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return App;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _createSuper = require("@swc/helpers/_/_create_super");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _error404 = require("./Error404");
var _error404Default = parcelHelpers.interopDefault(_error404);
var _group = require("./Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _groups = require("./Groups");
var _groupsDefault = parcelHelpers.interopDefault(_groups);
var _destinations = require("./Destinations");
var _destinationsDefault = parcelHelpers.interopDefault(_destinations);
var _destinationVideoSets = require("./Destinations/DestinationVideoSets");
var _destinationVideoSetsDefault = parcelHelpers.interopDefault(_destinationVideoSets);
var _destinationPlaylist = require("./Destinations/DestinationPlaylist");
var _destinationPlaylistDefault = parcelHelpers.interopDefault(_destinationPlaylist);
var _videoSetRundates = require("./Destinations/VideoSetRundates");
var _videoSetRundatesDefault = parcelHelpers.interopDefault(_videoSetRundates);
var _searchMultiChannel = require("./SearchMultiChannel");
var _searchMultiChannelDefault = parcelHelpers.interopDefault(_searchMultiChannel);
var _videos = require("./Videos");
var _videosDefault = parcelHelpers.interopDefault(_videos);
var _channels = require("./Channels");
var _channelsDefault = parcelHelpers.interopDefault(_channels);
var _channel = require("./Channels/Channel");
var _channelDefault = parcelHelpers.interopDefault(_channel);
var _userAdmin = require("./UserAdmin");
var _userAdminDefault = parcelHelpers.interopDefault(_userAdmin);
var _userProjects = require("./UserProjects");
var _userProjectsDefault = parcelHelpers.interopDefault(_userProjects);
var _userNoProjects = require("./UserNoProjects");
var _userNoProjectsDefault = parcelHelpers.interopDefault(_userNoProjects);
var _loginPage = require("./LoginPage");
var _loginPageDefault = parcelHelpers.interopDefault(_loginPage);
var _logoutPage = require("./LogoutPage");
var _logoutPageDefault = parcelHelpers.interopDefault(_logoutPage);
var _updateAccountPage = require("./UpdateAccountPage");
var _updateAccountPageDefault = parcelHelpers.interopDefault(_updateAccountPage);
var _reportsDashboard = require("./ReportsDashboard");
var _reportsDashboardDefault = parcelHelpers.interopDefault(_reportsDashboard);
var _reportsVideoDestinations = require("./Reports/ReportsVideoDestinations");
var _reportsVideoDestinationsDefault = parcelHelpers.interopDefault(_reportsVideoDestinations);
var _reportsChannels = require("./Reports/ReportsChannels");
var _reportsChannelsDefault = parcelHelpers.interopDefault(_reportsChannels);
var _reportsVidSetDestinations = require("./Reports/ReportsVidSetDestinations");
var _reportsVidSetDestinationsDefault = parcelHelpers.interopDefault(_reportsVidSetDestinations);
var _reportsChannelsDestinations = require("./Reports/ReportsChannelsDestinations");
var _reportsChannelsDestinationsDefault = parcelHelpers.interopDefault(_reportsChannelsDestinations);
var _reportsChannelsUse = require("./Reports/ReportsChannelsUse");
var _reportsChannelsUseDefault = parcelHelpers.interopDefault(_reportsChannelsUse);
var _reportsVideoUse = require("./Reports/ReportsVideoUse");
var _reportsVideoUseDefault = parcelHelpers.interopDefault(_reportsVideoUse);
var _reportsVideoDropOffs = require("./Reports/ReportsVideoDropOffs");
var _reportsVideoDropOffsDefault = parcelHelpers.interopDefault(_reportsVideoDropOffs);
var _stations = require("./Stations");
var _stationsDefault = parcelHelpers.interopDefault(_stations);
var _stationView = require("./Stations/StationView");
var _stationViewDefault = parcelHelpers.interopDefault(_stationView);
var _episodeView = require("./Stations/EpisodeView");
var _episodeViewDefault = parcelHelpers.interopDefault(_episodeView);
var _seriesView = require("./Stations/SeriesView");
var _seriesViewDefault = parcelHelpers.interopDefault(_seriesView);
var _resetPassword = require("./ResetPassword");
var _resetPasswordDefault = parcelHelpers.interopDefault(_resetPassword);
var _resetPasswordNoToken = require("./ResetPasswordNoToken");
var _resetPasswordEmailSent = require("./ResetPasswordEmailSent");
var _tools = require("./Tools");
var _toolsDefault = parcelHelpers.interopDefault(_tools);
var _toolsDurationMode = require("./Tools/ToolsDurationMode");
var _toolsDurationModeDefault = parcelHelpers.interopDefault(_toolsDurationMode);
var _toolsAverages = require("./Tools/ToolsAverages");
var _toolsAveragesDefault = parcelHelpers.interopDefault(_toolsAverages);
var _amzGenres = require("./AmzGenres");
var _amzGenresDefault = parcelHelpers.interopDefault(_amzGenres);
var _amzClusters = require("./Music/AmzClusters");
var _amzClustersDefault = parcelHelpers.interopDefault(_amzClusters);
var _amzSongs = require("./Music/AmzSongs");
var _amzSongsDefault = parcelHelpers.interopDefault(_amzSongs);
var _amzReports = require("./Music/AmzReports");
var _amzReportsDefault = parcelHelpers.interopDefault(_amzReports);
var _amzReportsDetails = require("./Music/AmzReportsDetails");
var _amzReportsDetailsDefault = parcelHelpers.interopDefault(_amzReportsDetails);
var _projectWrapper = require("./ProjectWrapper");
var _projectWrapperDefault = parcelHelpers.interopDefault(_projectWrapper);
// CSS // imports
var _variablesCss = require("../css/Variables.css");
var _appCss = require("../css/App.css");
var _videosPageCss = require("../css/videosPage.css");
var _videoSharedCss = require("../css/videoShared.css");
var _searchPageCss = require("../css/searchPage.css");
var _destinationsPageCss = require("../css/destinationsPage.css");
var _reportsPageCss = require("../css/reportsPage.css");
var SearchMultiChannelView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _searchMultiChannelDefault.default));
var GroupView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _groupDefault.default));
var GroupsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _groupsDefault.default));
var DestinationsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _destinationsDefault.default));
var DestinationVideoSetsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _destinationVideoSetsDefault.default));
var VideoSetRundatesView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _videoSetRundatesDefault.default));
var DestinationPlaylistView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _destinationPlaylistDefault.default));
var VideosView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _videosDefault.default));
var StationsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _stationsDefault.default));
var StationViewView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _stationViewDefault.default));
var EpisodeViewView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _episodeViewDefault.default));
var SeriesViewView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _seriesViewDefault.default));
var ChannelsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _channelsDefault.default));
var ChannelView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _channelDefault.default));
var ReportsDashboardView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsDashboardDefault.default));
var ReportsVideoDestinationsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsVideoDestinationsDefault.default));
var ReportsChannelsDestinationsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsChannelsDestinationsDefault.default));
var ReportsChannelsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsChannelsDefault.default));
var ReportsChannelsUseView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsChannelsUseDefault.default));
var ReportsVidSetDestinationsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsVidSetDestinationsDefault.default));
var ReportsVideoUseView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsVideoUseDefault.default));
var ReportsVideoDropOffsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _reportsVideoDropOffsDefault.default));
var ToolsView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _toolsDefault.default));
var ToolsDurationModeView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _toolsDurationModeDefault.default));
var ToolsAveragesView = (0, _projectWrapperDefault.default)("d157f6f8-43b7-11ea-b50b-1902bdae", (0, _toolsAveragesDefault.default));
var UserAdminView = (0, _projectWrapperDefault.default)("ea9298b7-6ddd-11ea-b7f4-008cfa070708", (0, _userAdminDefault.default));
var UpdateAccountPageView = (0, _projectWrapperDefault.default)("999999", (0, _updateAccountPageDefault.default));
var UserProjectsView = (0, _projectWrapperDefault.default)("000000", (0, _userProjectsDefault.default));
var UserNoProjectsView = (0, _projectWrapperDefault.default)("000000", (0, _userNoProjectsDefault.default));
var AmzGenreView = (0, _projectWrapperDefault.default)("dec4be2a-43b7-11ea-b50b-1902bdae", (0, _amzGenresDefault.default));
var AmzClustersView = (0, _projectWrapperDefault.default)("dec4be2a-43b7-11ea-b50b-1902bdae", (0, _amzClustersDefault.default));
var AmzSongsView = (0, _projectWrapperDefault.default)("dec4be2a-43b7-11ea-b50b-1902bdae", (0, _amzSongsDefault.default));
var AmzReportsView = (0, _projectWrapperDefault.default)("dec4be2a-43b7-11ea-b50b-1902bdae", (0, _amzReportsDefault.default));
var AmzReportsDetailsView = (0, _projectWrapperDefault.default)("dec4be2a-43b7-11ea-b50b-1902bdae", (0, _amzReportsDetailsDefault.default));
var App = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(App, _React_Component);
    var _super = (0, _createSuper._)(App);
    function App(props) {
        (0, _classCallCheck._)(this, App);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            user: {}
        };
        return _this;
    }
    (0, _createClass._)(App, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginPageDefault.default), (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/projects",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserProjectsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/notassigned",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserNoProjectsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/search",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchMultiChannelView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/videos",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(VideosView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/stations",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StationsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/stations/:stationID",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StationViewView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/stations/episode/:episodeID",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EpisodeViewView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/stations/series/:seriesID",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SeriesViewView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/destinations",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DestinationsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/destinations/videosets/:id",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DestinationVideoSetsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/destinations/rundates/:id",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(VideoSetRundatesView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/destinations/playlist/:vsbID",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DestinationPlaylistView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/groups",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GroupsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/group/:groupId",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GroupView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/channels",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChannelsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/channels/:channelID",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChannelView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsDashboardView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports/display/videosdestinations",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVideoDestinationsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports/display/channelsdestinations",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsChannelsDestinationsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports/display/channels",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsChannelsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports/display/channelsusage",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsChannelsUseView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports/display/videosetdestinations",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVidSetDestinationsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports/display/videosusage",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVideoUseView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/reports/display/videosinactive",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVideoDropOffsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/admin",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserAdminView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/update_account",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UpdateAccountPageView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/tools",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/tools/durationmode/:spreadsheetID/:sheetName",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolsDurationModeView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/tools/averages/:spreadsheetID/:sheetName",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolsAveragesView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/music",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzGenreView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/music/clusters/:id",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzClustersView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/music/songs/:id",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzSongsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/music/reports/details/:report/:id/",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzReportsDetailsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/music/reports/details/:report/:id/:genre",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzReportsDetailsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/music/reports/:report/:id",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzReportsView, (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/setpassword/",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPasswordNoToken.ResetPasswordNoToken), (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/setpassword/:pwordReqID",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPasswordDefault.default), (0, _objectSpread._)({}, this.state))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/emailsent",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPasswordEmailSent.ResetPasswordEmailSent), (0, _objectSpread._)({}, this.props))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/logout",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoutPageDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                component: (0, _error404Default.default)
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return App;
}((0, _reactDefault.default).Component);

},{"@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_create_super":"4WNpt","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./Error404":"jF7Vs","./Group":"boA4D","./Groups":"lN9sG","./Destinations":"4HPrT","./Destinations/DestinationVideoSets":"1MWQ0","./Destinations/DestinationPlaylist":"6detW","./Destinations/VideoSetRundates":"bUMo2","./SearchMultiChannel":"cbBP2","./Videos":"50JzI","./Channels":"8V1UL","./Channels/Channel":"5toJ3","./UserAdmin":"hEfIw","./UserProjects":"38dnm","./UserNoProjects":"d895D","./LoginPage":"2KEhZ","./LogoutPage":"6PxNd","./UpdateAccountPage":"4RSCV","./ReportsDashboard":"8H1vn","./Reports/ReportsVideoDestinations":"4Pu6A","./Reports/ReportsChannels":"amSfH","./Reports/ReportsVidSetDestinations":"fB4ud","./Reports/ReportsChannelsDestinations":"g33bw","./Reports/ReportsChannelsUse":"ee3Ui","./Reports/ReportsVideoUse":"8uMeP","./Reports/ReportsVideoDropOffs":"89E0Q","./Stations":"hHFhc","./Stations/StationView":"AJus3","./Stations/EpisodeView":"70p5f","./Stations/SeriesView":"3vdfC","./ResetPassword":"hKn0E","./ResetPasswordNoToken":"7lOZm","./ResetPasswordEmailSent":"c3YKH","./Tools":"1Nmb0","./Tools/ToolsDurationMode":"iU9wX","./Tools/ToolsAverages":"7IeK0","./AmzGenres":"4XDRr","./Music/AmzClusters":"fIV3Z","./Music/AmzSongs":"7SIPZ","./Music/AmzReports":"ePHwU","./Music/AmzReportsDetails":"liMRL","./ProjectWrapper":"jwuXm","../css/Variables.css":"lieWz","../css/App.css":"jY5Cf","../css/videosPage.css":"hxw3o","../css/videoShared.css":"8qWlU","../css/searchPage.css":"idP1K","../css/destinationsPage.css":"kWrfi","../css/reportsPage.css":"67ZQ7","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lXJPT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_call_check;
});
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jl0TM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_class;
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8RuOX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._)(subClass, superClass);
}

},{"./_set_prototype_of.js":"dFlVC","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dFlVC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"95yNt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread;
});
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"cmFWv","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cmFWv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _define_property;
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4WNpt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _create_super(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructJs._)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfJs._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfJs._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnJs._)(this, result);
    };
}

},{"./_get_prototype_of.js":"1Gtbx","./_is_native_reflect_construct.js":"4nCHj","./_possible_constructor_return.js":"lhJq4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1Gtbx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4nCHj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lhJq4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._)(self);
}

},{"./_assert_this_initialized.js":"3Eye5","./_type_of.js":"60jEQ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3Eye5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gMZz4":[function(require,module,exports) {
/**
 * React Router DOM v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return 0, _reactRouter.AbortedDeferredError;
});
parcelHelpers.export(exports, "Await", function() {
    return 0, _reactRouter.Await;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return 0, _reactRouter.MemoryRouter;
});
parcelHelpers.export(exports, "Navigate", function() {
    return 0, _reactRouter.Navigate;
});
parcelHelpers.export(exports, "NavigationType", function() {
    return 0, _reactRouter.NavigationType;
});
parcelHelpers.export(exports, "Outlet", function() {
    return 0, _reactRouter.Outlet;
});
parcelHelpers.export(exports, "Route", function() {
    return 0, _reactRouter.Route;
});
parcelHelpers.export(exports, "Router", function() {
    return 0, _reactRouter.Router;
});
parcelHelpers.export(exports, "Routes", function() {
    return 0, _reactRouter.Routes;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", function() {
    return 0, _reactRouter.UNSAFE_DataRouterContext;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", function() {
    return 0, _reactRouter.UNSAFE_DataRouterStateContext;
});
parcelHelpers.export(exports, "UNSAFE_LocationContext", function() {
    return 0, _reactRouter.UNSAFE_LocationContext;
});
parcelHelpers.export(exports, "UNSAFE_NavigationContext", function() {
    return 0, _reactRouter.UNSAFE_NavigationContext;
});
parcelHelpers.export(exports, "UNSAFE_RouteContext", function() {
    return 0, _reactRouter.UNSAFE_RouteContext;
});
parcelHelpers.export(exports, "UNSAFE_useRouteId", function() {
    return 0, _reactRouter.UNSAFE_useRouteId;
});
parcelHelpers.export(exports, "createMemoryRouter", function() {
    return 0, _reactRouter.createMemoryRouter;
});
parcelHelpers.export(exports, "createPath", function() {
    return 0, _reactRouter.createPath;
});
parcelHelpers.export(exports, "createRoutesFromChildren", function() {
    return 0, _reactRouter.createRoutesFromChildren;
});
parcelHelpers.export(exports, "createRoutesFromElements", function() {
    return 0, _reactRouter.createRoutesFromElements;
});
parcelHelpers.export(exports, "defer", function() {
    return 0, _reactRouter.defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _reactRouter.generatePath;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return 0, _reactRouter.isRouteErrorResponse;
});
parcelHelpers.export(exports, "json", function() {
    return 0, _reactRouter.json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _reactRouter.matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return 0, _reactRouter.matchRoutes;
});
parcelHelpers.export(exports, "parsePath", function() {
    return 0, _reactRouter.parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return 0, _reactRouter.redirect;
});
parcelHelpers.export(exports, "redirectDocument", function() {
    return 0, _reactRouter.redirectDocument;
});
parcelHelpers.export(exports, "renderMatches", function() {
    return 0, _reactRouter.renderMatches;
});
parcelHelpers.export(exports, "replace", function() {
    return 0, _reactRouter.replace;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return 0, _reactRouter.resolvePath;
});
parcelHelpers.export(exports, "useActionData", function() {
    return 0, _reactRouter.useActionData;
});
parcelHelpers.export(exports, "useAsyncError", function() {
    return 0, _reactRouter.useAsyncError;
});
parcelHelpers.export(exports, "useAsyncValue", function() {
    return 0, _reactRouter.useAsyncValue;
});
parcelHelpers.export(exports, "useBlocker", function() {
    return 0, _reactRouter.useBlocker;
});
parcelHelpers.export(exports, "useHref", function() {
    return 0, _reactRouter.useHref;
});
parcelHelpers.export(exports, "useInRouterContext", function() {
    return 0, _reactRouter.useInRouterContext;
});
parcelHelpers.export(exports, "useLoaderData", function() {
    return 0, _reactRouter.useLoaderData;
});
parcelHelpers.export(exports, "useLocation", function() {
    return 0, _reactRouter.useLocation;
});
parcelHelpers.export(exports, "useMatch", function() {
    return 0, _reactRouter.useMatch;
});
parcelHelpers.export(exports, "useMatches", function() {
    return 0, _reactRouter.useMatches;
});
parcelHelpers.export(exports, "useNavigate", function() {
    return 0, _reactRouter.useNavigate;
});
parcelHelpers.export(exports, "useNavigation", function() {
    return 0, _reactRouter.useNavigation;
});
parcelHelpers.export(exports, "useNavigationType", function() {
    return 0, _reactRouter.useNavigationType;
});
parcelHelpers.export(exports, "useOutlet", function() {
    return 0, _reactRouter.useOutlet;
});
parcelHelpers.export(exports, "useOutletContext", function() {
    return 0, _reactRouter.useOutletContext;
});
parcelHelpers.export(exports, "useParams", function() {
    return 0, _reactRouter.useParams;
});
parcelHelpers.export(exports, "useResolvedPath", function() {
    return 0, _reactRouter.useResolvedPath;
});
parcelHelpers.export(exports, "useRevalidator", function() {
    return 0, _reactRouter.useRevalidator;
});
parcelHelpers.export(exports, "useRouteError", function() {
    return 0, _reactRouter.useRouteError;
});
parcelHelpers.export(exports, "useRouteLoaderData", function() {
    return 0, _reactRouter.useRouteLoaderData;
});
parcelHelpers.export(exports, "useRoutes", function() {
    return 0, _reactRouter.useRoutes;
});
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", function() {
    return 0, _router.UNSAFE_ErrorResponseImpl;
});
//#endregion
parcelHelpers.export(exports, "BrowserRouter", function() {
    return BrowserRouter;
});
parcelHelpers.export(exports, "Form", function() {
    return Form;
});
parcelHelpers.export(exports, "HashRouter", function() {
    return HashRouter;
});
parcelHelpers.export(exports, "Link", function() {
    return Link;
});
parcelHelpers.export(exports, "NavLink", function() {
    return NavLink;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return RouterProvider;
});
parcelHelpers.export(exports, "ScrollRestoration", function() {
    return ScrollRestoration;
});
parcelHelpers.export(exports, "UNSAFE_FetchersContext", function() {
    return FetchersContext;
});
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", function() {
    return ViewTransitionContext;
});
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", function() {
    return useScrollRestoration;
});
parcelHelpers.export(exports, "createBrowserRouter", function() {
    return createBrowserRouter;
});
parcelHelpers.export(exports, "createHashRouter", function() {
    return createHashRouter;
});
parcelHelpers.export(exports, "createSearchParams", function() {
    return createSearchParams;
});
parcelHelpers.export(exports, "unstable_HistoryRouter", function() {
    return HistoryRouter;
});
parcelHelpers.export(exports, "unstable_usePrompt", function() {
    return usePrompt;
});
parcelHelpers.export(exports, "unstable_useViewTransitionState", function() {
    return useViewTransitionState;
});
parcelHelpers.export(exports, "useBeforeUnload", function() {
    return useBeforeUnload;
});
parcelHelpers.export(exports, "useFetcher", function() {
    return useFetcher;
});
parcelHelpers.export(exports, "useFetchers", function() {
    return useFetchers;
});
parcelHelpers.export(exports, "useFormAction", function() {
    return useFormAction;
});
parcelHelpers.export(exports, "useLinkClickHandler", function() {
    return useLinkClickHandler;
});
parcelHelpers.export(exports, "useSearchParams", function() {
    return useSearchParams;
});
parcelHelpers.export(exports, "useSubmit", function() {
    return useSubmit;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, _router.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
var FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var START_TRANSITION = "startTransition";
var startTransitionImpl = _react[START_TRANSITION];
var FLUSH_SYNC = "flushSync";
var flushSyncImpl = _reactDom[FLUSH_SYNC];
var USE_ID = "useId";
var useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
var Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, _slicedToArray._)(_react.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(_react.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)(_react.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, _slicedToArray._)(_react.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, _slicedToArray._)(_react.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = _react.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = _react.useCallback(function(cb) {
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = _react.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = _react.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = _react.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = _react.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, _reactRouter.useHref)(to, {
        relative: relative
    });
    var internalOnClick = useLinkClickHandler(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    var location = (0, _reactRouter.useLocation)();
    var routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    var _React_useContext = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var Form = /*#__PURE__*/ _react.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    var submit = useSubmit();
    var formAction = useFormAction(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    var ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    var state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, _reactRouter.useNavigate)();
    var location = (0, _reactRouter.useLocation)();
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative: relative
    });
    return _react.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    var defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = _react.useRef(false);
    var location = (0, _reactRouter.useLocation)();
    var searchParams = _react.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, _reactRouter.useNavigate)();
    var setSearchParams = _react.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var fetcherId = 0;
var getUniqueFetcherId = function() {
    return "__" + String(++fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    var router = useDataRouterContext(DataRouterHook.UseSubmit).router;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        var _getFormSubmissionInfo = getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, _slicedToArray._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = useDataRouterContext(DataRouterHook.UseFetcher).router;
    var state = useDataRouterState(DataRouterStateHook.UseFetcher);
    var fetcherData = _react.useContext(FetchersContext);
    var route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = useIdImpl ? useIdImpl() : "";
    var _React_useState = (0, _slicedToArray._)(_react.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = _react.useCallback(function(href, opts) {
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = useSubmit();
    var submit = _react.useCallback(function(target, opts) {
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = _react.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = _react.useMemo(function() {
        return _extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    var state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, _slicedToArray._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return _extends({}, fetcher, {
            key: key
        });
    });
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext(DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = useDataRouterState(DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var location = (0, _reactRouter.useLocation)();
    var matches = (0, _reactRouter.useMatches)();
    var navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    _react.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    _react.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    var basename = useDataRouterContext(DataRouterHook.useViewTransitionState).basename;
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"@swc/helpers/_/_async_to_generator":"2CamX","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_ts_generator":"7uYyU","react":"l5IPE","react-dom":"lkfQ7","react-router":"XccJB","@remix-run/router":"8VBj9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2CamX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_to_generator;
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9bl3C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"kd83B","./_iterable_to_array_limit.js":"8v0XP","./_non_iterable_rest.js":"dtVfB","./_unsupported_iterable_to_array.js":"hj6r8","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kd83B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8v0XP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dtVfB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hj6r8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"2PDXV","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2PDXV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7uYyU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__generator;
});
var _tslib = require("tslib");

},{"tslib":"jLxba","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jLxba":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__esDecorate", function() {
    return __esDecorate;
});
parcelHelpers.export(exports, "__runInitializers", function() {
    return __runInitializers;
});
parcelHelpers.export(exports, "__propKey", function() {
    return __propKey;
});
parcelHelpers.export(exports, "__setFunctionName", function() {
    return __setFunctionName;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
parcelHelpers.export(exports, "__addDisposableResource", function() {
    return __addDisposableResource;
});
parcelHelpers.export(exports, "__disposeResources", function() {
    return __disposeResources;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, _typeOf._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@swc/helpers/_/_type_of":"60jEQ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"XccJB":[function(require,module,exports) {
/**
 * React Router v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return 0, _router.AbortedDeferredError;
});
parcelHelpers.export(exports, "NavigationType", function() {
    return 0, _router.Action;
});
parcelHelpers.export(exports, "createPath", function() {
    return 0, _router.createPath;
});
parcelHelpers.export(exports, "defer", function() {
    return 0, _router.defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _router.generatePath;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return 0, _router.isRouteErrorResponse;
});
parcelHelpers.export(exports, "json", function() {
    return 0, _router.json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _router.matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return 0, _router.matchRoutes;
});
parcelHelpers.export(exports, "parsePath", function() {
    return 0, _router.parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return 0, _router.redirect;
});
parcelHelpers.export(exports, "redirectDocument", function() {
    return 0, _router.redirectDocument;
});
parcelHelpers.export(exports, "replace", function() {
    return 0, _router.replace;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return 0, _router.resolvePath;
});
parcelHelpers.export(exports, "Await", function() {
    return Await;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return MemoryRouter;
});
parcelHelpers.export(exports, "Navigate", function() {
    return Navigate;
});
parcelHelpers.export(exports, "Outlet", function() {
    return Outlet;
});
parcelHelpers.export(exports, "Route", function() {
    return Route;
});
parcelHelpers.export(exports, "Router", function() {
    return Router;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return RouterProvider;
});
parcelHelpers.export(exports, "Routes", function() {
    return Routes;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", function() {
    return DataRouterContext;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", function() {
    return DataRouterStateContext;
});
parcelHelpers.export(exports, "UNSAFE_LocationContext", function() {
    return LocationContext;
});
parcelHelpers.export(exports, "UNSAFE_NavigationContext", function() {
    return NavigationContext;
});
parcelHelpers.export(exports, "UNSAFE_RouteContext", function() {
    return RouteContext;
});
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", function() {
    return mapRouteProperties;
});
parcelHelpers.export(exports, "UNSAFE_useRouteId", function() {
    return useRouteId;
});
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", function() {
    return useRoutesImpl;
});
parcelHelpers.export(exports, "createMemoryRouter", function() {
    return createMemoryRouter;
});
parcelHelpers.export(exports, "createRoutesFromChildren", function() {
    return createRoutesFromChildren;
});
parcelHelpers.export(exports, "createRoutesFromElements", function() {
    return createRoutesFromChildren;
});
parcelHelpers.export(exports, "renderMatches", function() {
    return renderMatches;
});
parcelHelpers.export(exports, "useActionData", function() {
    return useActionData;
});
parcelHelpers.export(exports, "useAsyncError", function() {
    return useAsyncError;
});
parcelHelpers.export(exports, "useAsyncValue", function() {
    return useAsyncValue;
});
parcelHelpers.export(exports, "useBlocker", function() {
    return useBlocker;
});
parcelHelpers.export(exports, "useHref", function() {
    return useHref;
});
parcelHelpers.export(exports, "useInRouterContext", function() {
    return useInRouterContext;
});
parcelHelpers.export(exports, "useLoaderData", function() {
    return useLoaderData;
});
parcelHelpers.export(exports, "useLocation", function() {
    return useLocation;
});
parcelHelpers.export(exports, "useMatch", function() {
    return useMatch;
});
parcelHelpers.export(exports, "useMatches", function() {
    return useMatches;
});
parcelHelpers.export(exports, "useNavigate", function() {
    return useNavigate;
});
parcelHelpers.export(exports, "useNavigation", function() {
    return useNavigation;
});
parcelHelpers.export(exports, "useNavigationType", function() {
    return useNavigationType;
});
parcelHelpers.export(exports, "useOutlet", function() {
    return useOutlet;
});
parcelHelpers.export(exports, "useOutletContext", function() {
    return useOutletContext;
});
parcelHelpers.export(exports, "useParams", function() {
    return useParams;
});
parcelHelpers.export(exports, "useResolvedPath", function() {
    return useResolvedPath;
});
parcelHelpers.export(exports, "useRevalidator", function() {
    return useRevalidator;
});
parcelHelpers.export(exports, "useRouteError", function() {
    return useRouteError;
});
parcelHelpers.export(exports, "useRouteLoaderData", function() {
    return useRouteLoaderData;
});
parcelHelpers.export(exports, "useRoutes", function() {
    return useRoutes;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var DataRouterContext = /*#__PURE__*/ _react.createContext(null);
var DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
var AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var NavigationContext = /*#__PURE__*/ _react.createContext(null);
var LocationContext = /*#__PURE__*/ _react.createContext(null);
var RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var _React_useContext = _react.useContext(NavigationContext), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var pathname = useLocation().pathname;
    return _react.useMemo(function() {
        return (0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    var isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    var isDataRoute = _react.useContext(RouteContext).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var dataRouterContext = _react.useContext(DataRouterContext);
    var _React_useContext = _react.useContext(NavigationContext), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    var outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    var matches = _react.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = _react.useContext(NavigationContext).future;
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(function() {
        return (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var navigator = _react.useContext(NavigationContext).navigator;
    var _React_useContext = _react.useContext(RouteContext), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(RenderErrorBoundary, _React_Component);
    var _super = (0, _createSuper._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, _classCallCheck._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, _createClass._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}(_react.Component);
function RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    var ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    var state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    var route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    var state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    var dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    var state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    var _useDataRouterState = useDataRouterState(DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return _react.useMemo(function() {
        return matches.map(function(m) {
            return (0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    var state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    var state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    var state = useDataRouterState(DataRouterStateHook.UseActionData);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    var error = _react.useContext(RouteErrorContext);
    var state = useDataRouterState(DataRouterStateHook.UseRouteError);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    var value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    var value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
var blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    var _useDataRouterContext = useDataRouterContext(DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = useDataRouterState(DataRouterStateHook.UseBlocker);
    var _React_useState = (0, _slicedToArray._)(_react.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = _react.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(function() {
        var key = String(++blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    var router = useDataRouterContext(DataRouterHook.UseNavigateStable).router;
    var id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    var activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var START_TRANSITION = "startTransition";
var startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, _slicedToArray._)(_react.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    _react.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = _react.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = _react.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var _React_useContext = _react.useContext(NavigationContext), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    _react.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, _router.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = _react.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = _react.useMemo(function() {
        var trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
var neverSettledPromise = new Promise(function() {});
var AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, _createSuper._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, _classCallCheck._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, _createClass._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw neverSettledPromise;
                if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}(_react.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = useAsyncValue();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    _react.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, _toConsumableArray._)(parentPath).concat([
            index
        ]);
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}

},{"@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","@swc/helpers/_/_create_super":"4WNpt","react":"l5IPE","@remix-run/router":"8VBj9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fRXIP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableSpreadJs._)();
}

},{"./_array_without_holes.js":"aJNWK","./_iterable_to_array.js":"4dRp5","./_non_iterable_spread.js":"5bLVB","./_unsupported_iterable_to_array.js":"hj6r8","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aJNWK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._)(arr);
}

},{"./_array_like_to_array.js":"2PDXV","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4dRp5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5bLVB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8VBj9":[function(require,module,exports) {
/**
 * @remix-run/router v1.19.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return AbortedDeferredError;
});
parcelHelpers.export(exports, "Action", function() {
    return Action;
});
parcelHelpers.export(exports, "IDLE_BLOCKER", function() {
    return IDLE_BLOCKER;
});
parcelHelpers.export(exports, "IDLE_FETCHER", function() {
    return IDLE_FETCHER;
});
parcelHelpers.export(exports, "IDLE_NAVIGATION", function() {
    return IDLE_NAVIGATION;
});
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", function() {
    return UNSAFE_DEFERRED_SYMBOL;
});
parcelHelpers.export(exports, "UNSAFE_DeferredData", function() {
    return DeferredData;
});
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", function() {
    return ErrorResponseImpl;
});
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", function() {
    return convertRouteMatchToUiMatch;
});
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", function() {
    return convertRoutesToDataRoutes;
});
parcelHelpers.export(exports, "UNSAFE_decodePath", function() {
    return decodePath;
});
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", function() {
    return getResolveToMatches;
});
parcelHelpers.export(exports, "UNSAFE_invariant", function() {
    return invariant;
});
parcelHelpers.export(exports, "UNSAFE_warning", function() {
    return warning;
});
parcelHelpers.export(exports, "createBrowserHistory", function() {
    return createBrowserHistory;
});
parcelHelpers.export(exports, "createHashHistory", function() {
    return createHashHistory;
});
parcelHelpers.export(exports, "createMemoryHistory", function() {
    return createMemoryHistory;
});
parcelHelpers.export(exports, "createPath", function() {
    return createPath;
});
parcelHelpers.export(exports, "createRouter", function() {
    return createRouter;
});
parcelHelpers.export(exports, "createStaticHandler", function() {
    return createStaticHandler;
});
parcelHelpers.export(exports, "defer", function() {
    return defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return generatePath;
});
parcelHelpers.export(exports, "getStaticContextFromError", function() {
    return getStaticContextFromError;
});
parcelHelpers.export(exports, "getToPathname", function() {
    return getToPathname;
});
parcelHelpers.export(exports, "isDataWithResponseInit", function() {
    return isDataWithResponseInit;
});
parcelHelpers.export(exports, "isDeferredData", function() {
    return isDeferredData;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return isRouteErrorResponse;
});
parcelHelpers.export(exports, "joinPaths", function() {
    return joinPaths;
});
parcelHelpers.export(exports, "json", function() {
    return json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return matchRoutes;
});
parcelHelpers.export(exports, "normalizePathname", function() {
    return normalizePathname;
});
parcelHelpers.export(exports, "parsePath", function() {
    return parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return redirect;
});
parcelHelpers.export(exports, "redirectDocument", function() {
    return redirectDocument;
});
parcelHelpers.export(exports, "replace", function() {
    return replace;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return resolvePath;
});
parcelHelpers.export(exports, "resolveTo", function() {
    return resolveTo;
});
parcelHelpers.export(exports, "stripBasename", function() {
    return stripBasename;
});
parcelHelpers.export(exports, "unstable_data", function() {
    return data;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _createSuper = require("@swc/helpers/_/_create_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, _toConsumableArray._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, _toArray._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, _toConsumableArray._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, _toConsumableArray._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, _slicedToArray._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, _slicedToArray._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, _classCallCheck._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(AbortedDeferredError, Error1);
    var _super = (0, _createSuper._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, _classCallCheck._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, _wrapNativeSuper._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, _classCallCheck._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, _slicedToArray._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, _defineProperty._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, _createClass._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var aborted, onAbort;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, _slicedToArray._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, _defineProperty._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, _classCallCheck._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, _toConsumableArray._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.unstable_dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    var discoveredRoutesMaxSize = 1000;
    var discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, _defineProperty._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) initialMatches = fogOfWar1.matches;
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        var isRouteInitialized = function(m) {
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    var pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, _toConsumableArray._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, _asyncToGenerator._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, _asyncToGenerator._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, _defineProperty._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, _slicedToArray._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, _defineProperty._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, _asyncToGenerator._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, _handleDiscoverRouteError, boundaryId, error, _handleNavigational404, notFoundMatches, error1, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), boundaryId = _handleDiscoverRouteError.boundaryId, error = _handleDiscoverRouteError.error;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error1 = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error1
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, _asyncToGenerator._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _handleDiscoverRouteError, boundaryId, error, _handleNavigational404, error1, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), boundaryId = _handleDiscoverRouteError.boundaryId, error = _handleDiscoverRouteError.error;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, _defineProperty._)({}, boundaryId, error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error1 = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, _defineProperty._)({}, route.id, error1)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, _slicedToArray._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect((0, _toConsumableArray._)(loaderResults).concat((0, _toConsumableArray._)(fetcherResults)));
                        if (!redirect) return [
                            3,
                            5
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // During partial hydration, preserve SSR errors for routes that don't re-run
                        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter(function(_ref2) {
                            var _$_ref2 = (0, _slicedToArray._)(_ref2, 1), id = _$_ref2[0];
                            return !matchesToLoad.some(function(m) {
                                return m.route.id === id;
                            });
                        }).forEach(function(_ref3) {
                            var _$_ref3 = (0, _slicedToArray._)(_ref3, 2), routeId = _$_ref3[0], error = _$_ref3[1];
                            errors = Object.assign(errors || {}, (0, _defineProperty._)({}, routeId, error));
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, _asyncToGenerator._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", fetchRequest, [
                                match
                            ], requestMatches)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[0];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, _slicedToArray._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect((0, _toConsumableArray._)(loaderResults).concat((0, _toConsumableArray._)(fetcherResults)));
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, _asyncToGenerator._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, results, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", fetchRequest, [
                                match
                            ], matches)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[0];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, _asyncToGenerator._)(function(request, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, _asyncToGenerator._)(function(type, request, matchesToLoad, matches) {
            var results, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if (isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    return {
                                        type: ResultType.redirect,
                                        response: normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                                    };
                                }
                                return convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        return [
                            2,
                            matchesToLoad.map(function() {
                                return {
                                    type: ResultType.error,
                                    error: e
                                };
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, _asyncToGenerator._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var _ref, loaderResults, fetcherResults;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : []
                            ].concat((0, _toConsumableArray._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) {
                                    var fetcherRequest = createClientSideRequest(init.history, f.path, f.controller.signal);
                                    return callDataStrategy("loader", fetcherRequest, [
                                        f.match
                                    ], f.matches).then(function(r) {
                                        return r[0];
                                    });
                                } else return Promise.resolve({
                                    type: ResultType.error,
                                    error: getInternalRouterError(404, {
                                        pathname: f.path
                                    })
                                });
                            }))))
                        ];
                    case 1:
                        _ref = (0, _toArray._).apply(void 0, [
                            _state.sent()
                        ]), loaderResults = _ref[0], fetcherResults = _ref.slice(1);
                        return [
                            4,
                            Promise.all([
                                resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, _toConsumableArray._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, _defineProperty._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        var currentLocation = _ref4.currentLocation, nextLocation = _ref4.nextLocation, historyAction = _ref4.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, _slicedToArray._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: findNearestBoundary(discoverResult.partialMatches).route.id,
            error: getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, _asyncToGenerator._)(function(matches, pathname, signal) {
            var _loop, partialMatches, _ret;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, e, newMatches, newPartialMatches;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR) dataRoutes = (0, _toConsumableArray._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) {
                                            addToFifoQueue(pathname, discoveredRoutes);
                                            return [
                                                2,
                                                {
                                                    v: {
                                                        type: "success",
                                                        matches: newMatches
                                                    }
                                                }
                                            ];
                                        }
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) {
                                            addToFifoQueue(pathname, discoveredRoutes);
                                            return [
                                                2,
                                                {
                                                    v: {
                                                        type: "success",
                                                        matches: null
                                                    }
                                                }
                                            ];
                                        }
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, _tsValues._)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, _typeOf._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            var first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, _toConsumableArray._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, _asyncToGenerator._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, unstable_dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, _defineProperty._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, _defineProperty._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, _asyncToGenerator._)(function(request, _temp4) {
            var _ref, routeId, requestContext, unstable_dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, _asyncToGenerator._)(function(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `HandlerResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isHandlerResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, _asyncToGenerator._)(function(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, _defineProperty._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, _defineProperty._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, _defineProperty._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, _defineProperty._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, _asyncToGenerator._)(function(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, _defineProperty._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, _asyncToGenerator._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
            var results;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(unstable_dataStrategy || defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if (isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    // Throw redirects and let the server handle them with an HTTP redirect
                                    throw normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
                                }
                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                // directly without unwrapping
                                throw result;
                                return convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, _defineProperty._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref5) {
                var _$_ref5 = (0, _slicedToArray._)(_ref5, 2), name = _$_ref5[0], value = _$_ref5[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    var boundaryMatches = boundaryId ? getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    return _loadLazyRouteChildren.apply(this, arguments);
}
function _loadLazyRouteChildren() {
    _loadLazyRouteChildren = /**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ (0, _asyncToGenerator._)(function(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
        var key, pending;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = [
                        path
                    ].concat((0, _toConsumableArray._)(matches.map(function(m) {
                        return m.route.id;
                    }))).join("-");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        4,
                        5
                    ]);
                    pending = pendingRouteChildren.get(key);
                    if (!pending) {
                        pending = patchRoutesOnNavigationImpl({
                            path: path,
                            matches: matches,
                            patch: function(routeId, children) {
                                if (!signal.aborted) patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                            }
                        });
                        pendingRouteChildren.set(key, pending);
                    }
                    if (!(pending && isPromise(pending))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        pending
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    pendingRouteChildren.delete(key);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteChildren.apply(this, arguments);
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route_children;
        var _route$children;
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        var dataChildren = convertRoutesToDataRoutes(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) (_route_children = route.children).push.apply(_route_children, (0, _toConsumableArray._)(dataChildren));
        else route.children = dataChildren;
    } else {
        var _routesToUse;
        var dataChildren1 = convertRoutesToDataRoutes(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        (_routesToUse = routesToUse).push.apply(_routesToUse, (0, _toConsumableArray._)(dataChildren1));
    }
}
function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, _asyncToGenerator._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map(function(m) {
        return m.resolve();
    }));
}
function callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    return _callDataStrategyImpl.apply(this, arguments);
}
function _callDataStrategyImpl() {
    _callDataStrategyImpl = (0, _asyncToGenerator._)(function(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
        var routeIdsToLoad, loadedMatches, results;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeIdsToLoad = matchesToLoad.reduce(function(acc, m) {
                        return acc.add(m.route.id);
                    }, new Set());
                    loadedMatches = new Set();
                    return [
                        4,
                        dataStrategyImpl({
                            matches: matches.map(function(match) {
                                var shouldLoad = routeIdsToLoad.has(match.route.id);
                                // `resolve` encapsulates the route.lazy, executing the
                                // loader/action, and mapping return values/thrown errors to a
                                // HandlerResult.  Users can pass a callback to take fine-grained control
                                // over the execution of the loader/action
                                var resolve = function(handlerOverride) {
                                    loadedMatches.add(match.route.id);
                                    return shouldLoad ? callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                                        type: ResultType.data,
                                        result: undefined
                                    });
                                };
                                return _extends({}, match, {
                                    shouldLoad: shouldLoad,
                                    resolve: resolve
                                });
                            }),
                            request: request,
                            params: matches[0].params,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    // Throw if any loadRoute implementations not called since they are what
                    // ensures a route is fully loaded
                    matches.forEach(function(m) {
                        return invariant(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded.");
                    });
                    // Filter out any middleware-only matches for which we didn't need to run handlers
                    return [
                        2,
                        results.filter(function(_, i) {
                            return routeIdsToLoad.has(matches[i].route.id);
                        })
                    ];
            }
        });
    });
    return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, _asyncToGenerator._)(function(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<HandlerResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, _toConsumableArray._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise;
                        if (handlerOverride) handlerPromise = handlerOverride(function(ctx) {
                            return actualHandler(ctx);
                        });
                        else handlerPromise = (0, _asyncToGenerator._)(function() {
                            var val, e;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    _ref = (0, _slicedToArray._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // HandlerResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callLoaderOrAction.apply(this, arguments);
}
function convertHandlerResultToDataResult(handlerResult) {
    return _convertHandlerResultToDataResult.apply(this, arguments);
}
function _convertHandlerResultToDataResult() {
    _convertHandlerResultToDataResult = (0, _asyncToGenerator._)(function(handlerResult) {
        var result, type, data, contentType, e, _result$init2, _result$init, _result$init3, _result$init4, _result$init5, _result$init6;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = handlerResult.result, type = handlerResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                                    }
                                ];
                            }
                            // Convert thrown unstable_data() to ErrorResponse instances
                            result = new ErrorResponseImpl(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
                                headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return _convertHandlerResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, _defineProperty._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, _defineProperty._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, _toConsumableArray._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if (isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectHandlerResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return _resolveDeferredResults.apply(this, arguments);
}
function _resolveDeferredResults() {
    _resolveDeferredResults = (0, _asyncToGenerator._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    invariant(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, _tsValues._)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveDeferredResults.apply(this, arguments);
}
function resolveDeferredData(result, signal, unwrap) {
    return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
    _resolveDeferredData = (0, _asyncToGenerator._)(function(result, signal, unwrap) {
        var aborted;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, _toConsumableArray._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@swc/helpers/_/_async_to_generator":"2CamX","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_array":"eX50L","@swc/helpers/_/_to_consumable_array":"fRXIP","@swc/helpers/_/_type_of":"60jEQ","@swc/helpers/_/_wrap_native_super":"lXg1i","@swc/helpers/_/_create_super":"4WNpt","@swc/helpers/_/_ts_generator":"7uYyU","@swc/helpers/_/_ts_values":"8f3eL","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eX50L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_array(arr) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"kd83B","./_iterable_to_array.js":"4dRp5","./_non_iterable_rest.js":"dtVfB","./_unsupported_iterable_to_array.js":"hj6r8","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lXg1i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_native_super;
});
var _constructJs = require("./_construct.js");
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeFunctionJs = require("./_is_native_function.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function(Class) {
        if (Class === null || !(0, _isNativeFunctionJs._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJs._)(Class, arguments, (0, _getPrototypeOfJs._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJs._)(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}

},{"./_construct.js":"kR01v","./_get_prototype_of.js":"1Gtbx","./_is_native_function.js":"5rLSg","./_set_prototype_of.js":"dFlVC","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kR01v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _construct;
});
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _construct(Parent, args, Class) {
    if ((0, _isNativeReflectConstructJs._)()) _construct = Reflect.construct;
    else _construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfJs._)(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}

},{"./_is_native_reflect_construct.js":"4nCHj","./_set_prototype_of.js":"dFlVC","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5rLSg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_function;
});
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8f3eL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__values;
});
var _tslib = require("tslib");

},{"tslib":"jLxba","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jF7Vs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var Error = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "content",
        className: "error404page",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "No such content!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Sorry. Couldn't find that URL. Are you sure it's correct?"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/",
                    children: "Try the home page"
                })
            ]
        })
    });
};
exports.default = Error;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"boA4D":[function(require,module,exports) {
/** *
 * Group.js
 * Page component for single group page
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _groupsChannelInfo = require("./subcomponents/GroupsChannelInfo");
var _groupsChannelInfoDefault = parcelHelpers.interopDefault(_groupsChannelInfo);
var _channelsList = require("./ChannelsList");
var _channelsListDefault = parcelHelpers.interopDefault(_channelsList);
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _groupsUtils = require("../actions/GroupsUtils");
var _this = undefined;
var Group = function(props) {
    var params = props.params, onAddChannelToGroup = props.onAddChannelToGroup, onGroupChangeHandler = props.onGroupChangeHandler;
    var groupId = params.groupId;
    var oneChannelModalRef = (0, _react.useRef)(null);
    var channelsListModalRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), channelList = _useState[0], setChannelList = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        open: false,
        loading: true
    }), 2), channelModal = _useState1[0], setChannelModal = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)((0, _groupsUtils.initAllChannels)), 2), allChannels = _useState2[0], setAllChannels = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)("n"), 2), groupActive = _useState3[0], setGroupActive = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(""), 2), groupAdded = _useState4[0], setGroupAdded = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(""), 2), groupUpdated = _useState5[0], setGroupUpdated = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(""), 2), groupName = _useState6[0], setGroupName = _useState6[1];
    (0, _react.useEffect)(function() {
        if (!channelList.length) getChannelsInGroup();
    }, [
        channelList,
        allChannels
    ]);
    var onUpdateTags = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", +channelModal.channel_id);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_SETTAGS), {
            body: fd
        }, function(data) {
            if (oneChannelModalRef === null || oneChannelModalRef === void 0 ? void 0 : oneChannelModalRef.current) oneChannelModalRef.current.close();
        });
    };
    var getChannelsInGroup = function() {
        if (!Object.hasOwn(params, "groupId")) {
            alert("No group ID passed");
            return;
        }
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", +groupId);
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_CHANNELS_IN_GROUP), {
            body: fd
        }, function(data) {
            setGroupActive(data.group_active);
            setGroupAdded(data.group_dateadded);
            setGroupUpdated(data.group_datelastupdated);
            setGroupName(data.group_name);
            setChannelList(data.channelList);
        });
    };
    var getChannelInfo = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var dataset = domEvent.target.dataset;
        var channelid = dataset.channelid;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", channelid);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_INFO), {
            body: fd
        }, function(data) {
            setChannelModal((0, _objectSpread._)({}, channelModal, data));
            if (oneChannelModalRef === null || oneChannelModalRef === void 0 ? void 0 : oneChannelModalRef.current) oneChannelModalRef.current.showModal();
        });
    };
    var getChannelBatch = function() {
        if (Object.hasOwn(channelsListModalRef, "current") && channelsListModalRef.current) channelsListModalRef.current.showModal();
    };
    var onCloseChannelsList = function() {
        if (channelsListModalRef === null || channelsListModalRef === void 0 ? void 0 : channelsListModalRef.current) channelsListModalRef.current.close();
    };
    var onCloseChannelInfo = function() {
        if (oneChannelModalRef === null || oneChannelModalRef === void 0 ? void 0 : oneChannelModalRef.current) oneChannelModalRef.current.close();
    };
    var onCheckChange = function(domEvent) {
        var target = domEvent.target;
        var value = target.value;
        if (target === null || target === void 0 ? void 0 : target.checked) setAllChannels((0, _objectSpreadProps._)((0, _objectSpread._)({}, allChannels), {
            toAdd: (0, _toConsumableArray._)(allChannels.toAdd).concat([
                value
            ])
        }));
        else setAllChannels((0, _objectSpreadProps._)((0, _objectSpread._)({}, allChannels), {
            toAdd: allChannels.toAdd.filter(function(ch) {
                return ch !== value;
            })
        }));
    };
    var onChannelFromRemoveGroup = function(groupId, channelId) {
        var channel_title = channelList.filter(function(ch) {
            return ch.youtubeid == channelId;
        })[0].channel_title;
        var confirmed = window.confirm("Are you sure that you want to remove ".concat(channel_title, " from the group?"));
        if (!confirmed) return;
        var fd = new FormData();
        fd.set("group", groupId);
        fd.set("channel", channelId);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_REMOVE_CHANNEL), {
            body: fd
        }, function(response) {
            if (response.success) {
                var cl = channelList.filter(function(ch) {
                    return ch.youtubeid !== response.channel;
                });
                setChannelList(cl);
            }
            if (oneChannelModalRef === null || oneChannelModalRef === void 0 ? void 0 : oneChannelModalRef.current) oneChannelModalRef.current.close();
        });
    };
    var onShowChannels = function() {
        getChannelBatch();
    };
    var onChannelAddToGroup = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("group", groupId);
        fd.set("channels", allChannels.toAdd.join(","));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ADD_CHANNEL_TO_GROUP), {
            body: fd
        }, function(data) {
            setChannelList(data.list);
            if (channelsListModalRef === null || channelsListModalRef === void 0 ? void 0 : channelsListModalRef.current) channelsListModalRef.current.close();
        });
    };
    var onDeleteGroup = function() {
        var confirm = window.confirm('Confirm that you want to delete "'.concat(groupName, '" by clicking OK.'));
        if (!confirm) return;
        var fd = new FormData();
        fd.set("id", +groupId);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_DELETE), {
            body: fd
        }, function(response) {
            if (response.success) {
                window.alert('Group "'.concat(groupName, '" was deleted.'));
                window.location = "/groups";
            } else window.alert("Could not delete ".concat(groupName, "."));
        });
    };
    var onChannelRemoveSystem = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_REMOVE), {
            body: fd
        }, function(data) {
            var deleted_channel = domEvent.target.delete_channel.value;
            var deleted_object = (0, _toConsumableArray._)(channelList).filter(function(ch) {
                return ch.youtubeid === deleted_channel;
            });
            if (data.status === "success") _this.setState(function(state) {
                return {
                    channelList: (0, _toConsumableArray._)(state.channelList).filter(function(ch) {
                        return ch.youtubeid !== deleted_channel;
                    }),
                    channelModal: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelModal), {
                        open: false
                    })
                };
            }, function() {
                alert("".concat(deleted_object[0].channel_title, " was deleted from AVA."));
            });
        });
    };
    var makeNoChannels = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "No channels in this group."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/groups",
                        children: "Return to Groups page"
                    })
                })
            ]
        });
    };
    var makeTable = function() {
        var rows = channelList.map(function(ch, idx) {
            var onRemove = function(domEvent) {
                var c = domEvent.target.dataset.channelid;
                onChannelFromRemoveGroup(groupId, c);
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: ch.channel_title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "button__group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-sm btn--action",
                                    onClick: getChannelInfo,
                                    "data-channelid": ch.youtubeid,
                                    children: "Show Channel Info"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-sm btn--action",
                                    onClick: onRemove,
                                    "data-channelid": ch.youtubeid,
                                    children: "Remove"
                                })
                            ]
                        })
                    })
                ]
            }, idx);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "groups__table",
            style: {
                marginTop: "4rem"
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                children: "Channel Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                style: {
                                    width: "15%"
                                },
                                children: "Edit Group"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: rows
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                        children: [
                            "Channels for Group ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                                children: groupName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "button__group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: onShowChannels,
                                type: "button",
                                className: "btn btn-sm btn--action",
                                children: "Add Channel To Group"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: onDeleteGroup,
                                type: "button",
                                className: "btn btn-sm btn--action",
                                children: "Delete Group"
                            })
                        ]
                    }),
                    channelList.length ? makeTable() : makeNoChannels()
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsChannelInfoDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, channelModal), {
                modalRef: oneChannelModalRef,
                selectedGroup: groupId,
                onAddHandler: onAddChannelToGroup,
                onClose: onCloseChannelInfo,
                onRemoveFromSystem: onChannelRemoveSystem,
                onUpdateTags: onUpdateTags,
                onRemoveFromGroup: onChannelFromRemoveGroup,
                onGroupChangeHandler: onGroupChangeHandler
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelsListDefault.default), {
                group: groupId,
                modalRef: channelsListModalRef,
                onClose: onCloseChannelsList,
                groupsInChannel: channelList,
                onSubmit: onChannelAddToGroup,
                onCheckChange: onCheckChange
            })
        ]
    });
};
// eslint-disable-next-line react/display-name
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Group, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./subcomponents/GroupsChannelInfo":"gVbNH","./ChannelsList":"cn7Fd","../js/Configuration":"k3dur","../js/Utilities":"euxcI","../actions/GroupsUtils":"3T1j2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8JXDR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread_props;
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gVbNH":[function(require,module,exports) {
/**
 * GroupsChannelInfo.js
 * Displays a model on the GroupsPage info when the user clicks to get more
 * info about the channel.
 * 
 * propsis similar to, but not the same as the ChannelInfo component. Needed to be able to both retain the
 * existing channel group data _and_ update it. Since that was significantly harder to do with a shared component
 * We're using a separate one.
 * 
 * Let's try to combine those components at some point in the future. In the goals of Gittin'er done, we're making two files. 
 * - webinista
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _dateFns = require("date-fns");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _channelsUtils = require("../../actions/ChannelsUtils");
var _groupsUtils = require("../../actions/GroupsUtils");
var _groupsChannelInfoCss = require("../../css/GroupsChannelInfo.css");
var GroupsChannelInfo = function(props) {
    var DATE_FORMAT = "PP";
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), groupList = _useState[0], setGroupList = _useState[1];
    (0, _react.useEffect)(function() {
        if (!groupList.length) getAllGroups();
    }, [
        groupList
    ]);
    var getAllGroups = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ALLGROUPS), {
            body: fd
        }, function(data) {
            setGroupList(data);
        });
    };
    var makeMenuItems = function() {
        var arrayOfItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var menu = null;
        if (arrayOfItems.length) menu = arrayOfItems.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: item.group_id,
                children: item.group_name
            }, index.toString());
        });
        return menu;
    };
    var showChannelPage = function() {
        var chann_id = props.youtubeid;
        window.open("https://www.youtube.com/channel/".concat(chann_id, "/videos"), "_blank");
    };
    var formatCategoryNames = function() {
        if (props.channel_category_names !== undefined) return props.channel_category_names.sort().join(", ");
    };
    var removeFromGroup = function(domEvent) {
        domEvent.preventDefault();
        if (props.onRemoveFromGroup) props.onRemoveFromGroup(domEvent.target.elements.groupID.value, domEvent.target.elements.channelID.value);
    };
    var added = new Date(props.channel_dateaddedtosystem);
    var updated = new Date(props.channel_datelastupdated);
    var hasAdded = (0, _dateFns.isValid)(added) ? (0, _dateFns.format)(added, DATE_FORMAT) : null;
    var hasUpdated = (0, _dateFns.isValid)(updated) ? (0, _dateFns.format)(updated, DATE_FORMAT) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: props.modalRef,
        id: "GroupsChannelInfoModal",
        onClose: props.onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: props.channel_title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "GroupsChannelInfo__logo",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "https://www.youtube.com/channel/".concat(props.channel_youtubechannelid, "/videos"),
                    target: "_blank",
                    className: "channel__thumb",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: props.channel_thumbnail,
                        alt: "".concat(props.channel_title, " Thumbnail")
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                className: "channel__meta_data",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: "Channel Description:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "description",
                        contentEditable: "true",
                        dangerouslySetInnerHTML: {
                            __html: props.channel_description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                className: "channel__meta_data",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: "Channel Stats:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Date Added to System:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: hasAdded
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Date Updated in System:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: hasUpdated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Subscribers:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: (0, _utilities.numberFormat)(props.channel_subscribercount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Video Count:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: (0, _utilities.numberFormat)(props.channel_videocount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Curated Video Count:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: (0, _utilities.numberFormat)(props.curated_video_count)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Categories / Topics:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: formatCategoryNames()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Tags:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "tags listItemScrollingTextBox",
                                        children: props.channel_customtags
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Groups:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "tags listItemScrollingTextBox",
                                        children: (0, _channelsUtils.getGroupNamesFromData)(props)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Keywords:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "tags listItemScrollingTextBox",
                                        children: props.channel_keywords
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                method: "POST",
                action: "api/channeldelete",
                className: "form__action_control",
                onSubmit: props.onRemoveFromSystem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "id",
                        id: "delete_channel",
                        defaultValue: props.channel_youtubechannelid
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        children: "Remove Channel From System"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form__action_control",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        method: "post",
                        onChange: props.onGroupChangeHandler,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "modal_group_select",
                                children: "Remove Channel from Group:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                    className: "form-control",
                                    name: "modal_group_select",
                                    id: "modal_group_select",
                                    disabled: true,
                                    value: +props.selectedGroup || "",
                                    children: makeMenuItems(groupList)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        id: "add_channel_button",
                        className: "centerTxt marginTop6px button__group",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            action: "api/channelremovefromgroup",
                            method: "POST",
                            onSubmit: removeFromGroup,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "hidden",
                                    name: "channelID",
                                    defaultValue: props.channel_youtubechannelid
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "hidden",
                                    name: "groupID",
                                    defaultValue: props.selectedGroup
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn--action",
                                    name: "add_or_remove",
                                    value: "add",
                                    children: "Remove Channel from Group"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                method: "post",
                action: "api/channelsettags",
                onSubmit: props.onUpdateTags,
                className: "form__action_control",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form__input_btn",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "channel_tags",
                            children: "Add Manual Tags:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            id: "channel_tags",
                            type: "text",
                            name: "tags",
                            defaultValue: props.channel_customtags || "",
                            placeholder: "No Custom Tags, Add Comma Separated Tags"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn--action",
                            children: "Add Tags to Channel"
                        })
                    ]
                })
            })
        ]
    });
};
GroupsChannelInfo.propTypes = {
    channelData: (0, _propTypesDefault.default).any,
    open: (0, _propTypesDefault.default).bool,
    onClose: (0, _propTypesDefault.default).func,
    onRemoveFromGroup: (0, _propTypesDefault.default).func,
    onRemoveFromSystem: (0, _propTypesDefault.default).func,
    onGroupChangeHandler: (0, _propTypesDefault.default).func,
    onUpdateTags: (0, _propTypesDefault.default).func,
    onAddHandler: (0, _propTypesDefault.default).func,
    selectedGroup: (0, _propTypesDefault.default).any
};
exports.default = GroupsChannelInfo;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./ModalDialog":"72kji","date-fns":"lnGwj","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/ChannelsUtils":"5iVEd","../../actions/GroupsUtils":"3T1j2","../../css/GroupsChannelInfo.css":"w0Z2w","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fUIWk":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"89nru"}],"89nru":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"8Aejd"}],"8Aejd":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"72kji":[function(require,module,exports) {
/*
ModalDialog
Use this instead of DialogModal. Uses the HTML dialog element.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeButton = require("./CloseButton");
var _modalDialogCss = require("./css/ModalDialog.css");
var ModalDialog = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ModalDialog(props, ref) {
    var open = props.open, children = props.children, id = props.id, onClose = props.onClose;
    (0, _react.useEffect)(function() {
        var _ref_current;
        if (!open) return;
        if (Object.hasOwn(ref, "current")) (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.showModal();
    }, [
        open
    ]);
    /* onClose event on the dialog element supports confirmation and alert-style dialogs. */ return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dialog", {
        ref: ref,
        id: id,
        "aria-labelledby": "".concat(id, "_title"),
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                color: "#CBCBCB",
                className: "dialog__body__close",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dialog__body",
                role: "document",
                children: children
            })
        ]
    });
});
exports.default = ModalDialog;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./CloseButton":"3MmmO","./css/ModalDialog.css":"bwS0v","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3MmmO":[function(require,module,exports) {
/**
 * CloseButton.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseButton", function() {
    return CloseButton;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _closeButtonCss = require("./css/CloseButton.css");
var CloseButton = function(param) {
    var color = param.color, className = param.className, title = param.title, onClick = param.onClick, _param_longForm = param.longForm, longForm = _param_longForm === void 0 ? false : _param_longForm;
    var cssClasses = (0, _classnamesDefault.default)(className, {
        "close__button": true,
        "close__button--longform": longForm
    });
    var ttle, longform = "";
    ttle = title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
        children: title
    }) : "Close this modal";
    if (longForm) {
        longform = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: title
        });
        ttle = "";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        type: "button",
        className: cssClasses,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                viewBox: "0 0 300 300",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    ttle,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        fill: color,
                        points: "1.61065574 242.514344 93.8196721 150.305328 1 57.7909836 57.7909836 1 150.610656 93.5143443 242.819672 1.30532787 298.084016 56.875 205.875 149.084016 299 242.209016 242.209016 299 149.084016 205.875 56.875 298.084016"
                    })
                ]
            }),
            longform
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","./css/CloseButton.css":"7kJxJ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8N3a2":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"7kJxJ":[function() {},{}],"bwS0v":[function() {},{}],"lnGwj":[function(require,module,exports) {
"use strict";
var _index = require("bb476f479aec785f");
Object.keys(_index).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index[key];
        }
    });
});
var _index2 = require("f3c55fba68737491");
Object.keys(_index2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index2[key];
        }
    });
});
var _index3 = require("4e06aa5c5a66ee79");
Object.keys(_index3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index3[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index3[key];
        }
    });
});
var _index4 = require("320136604150f517");
Object.keys(_index4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index4[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index4[key];
        }
    });
});
var _index5 = require("9bfe5668fe1279fd");
Object.keys(_index5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index5[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index5[key];
        }
    });
});
var _index6 = require("8a5f15f49ef72b46");
Object.keys(_index6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index6[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index6[key];
        }
    });
});
var _index7 = require("ad78344e087d5dce");
Object.keys(_index7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index7[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index7[key];
        }
    });
});
var _index8 = require("c4f5940a947b78c");
Object.keys(_index8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index8[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index8[key];
        }
    });
});
var _index9 = require("f66bb3ce3ddb423a");
Object.keys(_index9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index9[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index9[key];
        }
    });
});
var _index10 = require("cf2ce1177f6f3085");
Object.keys(_index10).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index10[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index10[key];
        }
    });
});
var _index11 = require("ff27f5c5e825f426");
Object.keys(_index11).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index11[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index11[key];
        }
    });
});
var _index12 = require("9692908b0d3e69f3");
Object.keys(_index12).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index12[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index12[key];
        }
    });
});
var _index13 = require("c07b6490d53540ef");
Object.keys(_index13).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index13[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index13[key];
        }
    });
});
var _index14 = require("33ecb1182a4f61bc");
Object.keys(_index14).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index14[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index14[key];
        }
    });
});
var _index15 = require("eb6c645c302c3877");
Object.keys(_index15).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index15[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index15[key];
        }
    });
});
var _index16 = require("96a422b0dac4a654");
Object.keys(_index16).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index16[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index16[key];
        }
    });
});
var _index17 = require("41bd5ae6bd5c566d");
Object.keys(_index17).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index17[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index17[key];
        }
    });
});
var _index18 = require("1b492f1d94521a5d");
Object.keys(_index18).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index18[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index18[key];
        }
    });
});
var _index19 = require("c13fe358d89ecd81");
Object.keys(_index19).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index19[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index19[key];
        }
    });
});
var _index20 = require("ce109cc453253b85");
Object.keys(_index20).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index20[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index20[key];
        }
    });
});
var _index21 = require("d42674a0b7bfc434");
Object.keys(_index21).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index21[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index21[key];
        }
    });
});
var _index22 = require("fbdc79daa81b87b6");
Object.keys(_index22).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index22[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index22[key];
        }
    });
});
var _index23 = require("c2badf5a2b5ed454");
Object.keys(_index23).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index23[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index23[key];
        }
    });
});
var _index24 = require("9fd007b982125b9a");
Object.keys(_index24).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index24[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index24[key];
        }
    });
});
var _index25 = require("b695668577e1e7cb");
Object.keys(_index25).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index25[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index25[key];
        }
    });
});
var _index26 = require("6b399f6303d57295");
Object.keys(_index26).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index26[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index26[key];
        }
    });
});
var _index27 = require("6a61a2a843b91654");
Object.keys(_index27).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index27[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index27[key];
        }
    });
});
var _index28 = require("60b631dcb2f037ca");
Object.keys(_index28).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index28[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index28[key];
        }
    });
});
var _index29 = require("2ed27a2d4a3c6872");
Object.keys(_index29).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index29[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index29[key];
        }
    });
});
var _index30 = require("41d2eb1d2381e8a");
Object.keys(_index30).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index30[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index30[key];
        }
    });
});
var _index31 = require("c599317e8caae438");
Object.keys(_index31).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index31[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index31[key];
        }
    });
});
var _index32 = require("3b135e2b9118d1b");
Object.keys(_index32).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index32[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index32[key];
        }
    });
});
var _index33 = require("241ef3acf8caa33a");
Object.keys(_index33).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index33[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index33[key];
        }
    });
});
var _index34 = require("b76109f782422508");
Object.keys(_index34).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index34[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index34[key];
        }
    });
});
var _index35 = require("30e8f5ceefb905b2");
Object.keys(_index35).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index35[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index35[key];
        }
    });
});
var _index36 = require("20867c3d025aff9");
Object.keys(_index36).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index36[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index36[key];
        }
    });
});
var _index37 = require("366b2e75db11947a");
Object.keys(_index37).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index37[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index37[key];
        }
    });
});
var _index38 = require("4582c2f25445c44b");
Object.keys(_index38).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index38[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index38[key];
        }
    });
});
var _index39 = require("55c0b2733cdea4d1");
Object.keys(_index39).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index39[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index39[key];
        }
    });
});
var _index40 = require("74ff6cf808a390db");
Object.keys(_index40).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index40[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index40[key];
        }
    });
});
var _index41 = require("81c3475ead0f5b5a");
Object.keys(_index41).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index41[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index41[key];
        }
    });
});
var _index42 = require("cd10d76a84c94920");
Object.keys(_index42).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index42[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index42[key];
        }
    });
});
var _index43 = require("b58b90c359ac3c03");
Object.keys(_index43).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index43[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index43[key];
        }
    });
});
var _index44 = require("bcedf2167bbb0925");
Object.keys(_index44).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index44[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index44[key];
        }
    });
});
var _index45 = require("dd98d2de70848b38");
Object.keys(_index45).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index45[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index45[key];
        }
    });
});
var _index46 = require("e137338bdb2b9c68");
Object.keys(_index46).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index46[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index46[key];
        }
    });
});
var _index47 = require("d7d2b7f0a9f716a8");
Object.keys(_index47).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index47[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index47[key];
        }
    });
});
var _index48 = require("83b612a607feb7af");
Object.keys(_index48).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index48[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index48[key];
        }
    });
});
var _index49 = require("68777f2c425fee5d");
Object.keys(_index49).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index49[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index49[key];
        }
    });
});
var _index50 = require("5fe5471d81c79da6");
Object.keys(_index50).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index50[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index50[key];
        }
    });
});
var _index51 = require("c2cf95d448d96fcc");
Object.keys(_index51).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index51[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index51[key];
        }
    });
});
var _index52 = require("bdeffae0b4080a1e");
Object.keys(_index52).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index52[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index52[key];
        }
    });
});
var _index53 = require("b0814d5ce39f52b5");
Object.keys(_index53).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index53[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index53[key];
        }
    });
});
var _index54 = require("38c2fd7b5ab40bf0");
Object.keys(_index54).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index54[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index54[key];
        }
    });
});
var _index55 = require("216f5a0b7789e14");
Object.keys(_index55).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index55[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index55[key];
        }
    });
});
var _index56 = require("b3e5b40e0fbb1d44");
Object.keys(_index56).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index56[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index56[key];
        }
    });
});
var _index57 = require("e989ece2a2757bd2");
Object.keys(_index57).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index57[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index57[key];
        }
    });
});
var _index58 = require("610e7dd2284f5781");
Object.keys(_index58).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index58[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index58[key];
        }
    });
});
var _index59 = require("aee49e17aca40e68");
Object.keys(_index59).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index59[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index59[key];
        }
    });
});
var _index60 = require("ba659abbcc4b60fe");
Object.keys(_index60).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index60[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index60[key];
        }
    });
});
var _index61 = require("cc3f9c4f9c787ea6");
Object.keys(_index61).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index61[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index61[key];
        }
    });
});
var _index62 = require("40192b29822dee38");
Object.keys(_index62).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index62[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index62[key];
        }
    });
});
var _index63 = require("87e1741b0e0137ea");
Object.keys(_index63).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index63[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index63[key];
        }
    });
});
var _index64 = require("d634ea72aef4c86e");
Object.keys(_index64).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index64[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index64[key];
        }
    });
});
var _index65 = require("665bea9ec101ae55");
Object.keys(_index65).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index65[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index65[key];
        }
    });
});
var _index66 = require("4c745f864149cfd3");
Object.keys(_index66).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index66[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index66[key];
        }
    });
});
var _index67 = require("59e6129eee3b016c");
Object.keys(_index67).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index67[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index67[key];
        }
    });
});
var _index68 = require("88f236b6a61f4122");
Object.keys(_index68).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index68[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index68[key];
        }
    });
});
var _index69 = require("33f9f2f6d62dc6cc");
Object.keys(_index69).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index69[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index69[key];
        }
    });
});
var _index70 = require("5e181004291889f8");
Object.keys(_index70).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index70[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index70[key];
        }
    });
});
var _index71 = require("de24191615ebbb80");
Object.keys(_index71).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index71[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index71[key];
        }
    });
});
var _index72 = require("d63e27bbb84952ec");
Object.keys(_index72).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index72[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index72[key];
        }
    });
});
var _index73 = require("c2012a9ded2a05e4");
Object.keys(_index73).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index73[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index73[key];
        }
    });
});
var _index74 = require("6f70aef5356bf042");
Object.keys(_index74).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index74[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index74[key];
        }
    });
});
var _index75 = require("3fea09df6269258d");
Object.keys(_index75).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index75[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index75[key];
        }
    });
});
var _index76 = require("cf95b5833c75a113");
Object.keys(_index76).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index76[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index76[key];
        }
    });
});
var _index77 = require("198ca05f7c43d0c0");
Object.keys(_index77).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index77[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index77[key];
        }
    });
});
var _index78 = require("2a7b78bbeb9ac279");
Object.keys(_index78).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index78[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index78[key];
        }
    });
});
var _index79 = require("81ea02ff9efa6f86");
Object.keys(_index79).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index79[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index79[key];
        }
    });
});
var _index80 = require("129a78908bb8985b");
Object.keys(_index80).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index80[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index80[key];
        }
    });
});
var _index81 = require("f3c08909629e1f03");
Object.keys(_index81).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index81[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index81[key];
        }
    });
});
var _index82 = require("f78c22b2c30c3be8");
Object.keys(_index82).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index82[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index82[key];
        }
    });
});
var _index83 = require("885f4bbed816b7f7");
Object.keys(_index83).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index83[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index83[key];
        }
    });
});
var _index84 = require("72d271579509d098");
Object.keys(_index84).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index84[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index84[key];
        }
    });
});
var _index85 = require("dee4e1ab9bdde628");
Object.keys(_index85).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index85[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index85[key];
        }
    });
});
var _index86 = require("571218393678880d");
Object.keys(_index86).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index86[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index86[key];
        }
    });
});
var _index87 = require("2835d5a51730a5b3");
Object.keys(_index87).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index87[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index87[key];
        }
    });
});
var _index88 = require("3741eee35491c087");
Object.keys(_index88).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index88[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index88[key];
        }
    });
});
var _index89 = require("e92428f0f5974b5a");
Object.keys(_index89).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index89[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index89[key];
        }
    });
});
var _index90 = require("8523677aaea2cb20");
Object.keys(_index90).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index90[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index90[key];
        }
    });
});
var _index91 = require("22812cfff632fba0");
Object.keys(_index91).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index91[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index91[key];
        }
    });
});
var _index92 = require("a84bbb9e49250d10");
Object.keys(_index92).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index92[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index92[key];
        }
    });
});
var _index93 = require("ce1a93769edb9f74");
Object.keys(_index93).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index93[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index93[key];
        }
    });
});
var _index94 = require("c29e8ab5eeb7d4c0");
Object.keys(_index94).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index94[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index94[key];
        }
    });
});
var _index95 = require("417a881dca9183b4");
Object.keys(_index95).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index95[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index95[key];
        }
    });
});
var _index96 = require("ed18152d44e54a88");
Object.keys(_index96).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index96[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index96[key];
        }
    });
});
var _index97 = require("5ad8718b8ffbdc8");
Object.keys(_index97).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index97[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index97[key];
        }
    });
});
var _index98 = require("4885f3e1b4265446");
Object.keys(_index98).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index98[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index98[key];
        }
    });
});
var _index99 = require("21dc31ac6a839f01");
Object.keys(_index99).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index99[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index99[key];
        }
    });
});
var _index100 = require("ed69673c611caf3c");
Object.keys(_index100).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index100[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index100[key];
        }
    });
});
var _index101 = require("9a619fbde7ef4e46");
Object.keys(_index101).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index101[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index101[key];
        }
    });
});
var _index102 = require("5b4ec1d4ed18e2a5");
Object.keys(_index102).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index102[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index102[key];
        }
    });
});
var _index103 = require("ea293604faa53290");
Object.keys(_index103).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index103[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index103[key];
        }
    });
});
var _index104 = require("b884dd139cae152f");
Object.keys(_index104).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index104[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index104[key];
        }
    });
});
var _index105 = require("4c3ab9f336a7d51a");
Object.keys(_index105).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index105[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index105[key];
        }
    });
});
var _index106 = require("653e45499ad5f194");
Object.keys(_index106).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index106[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index106[key];
        }
    });
});
var _index107 = require("7ac77dc0818e9e94");
Object.keys(_index107).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index107[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index107[key];
        }
    });
});
var _index108 = require("9ebf799edec0800d");
Object.keys(_index108).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index108[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index108[key];
        }
    });
});
var _index109 = require("e9dba9b7ca1e9602");
Object.keys(_index109).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index109[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index109[key];
        }
    });
});
var _index110 = require("457b792b8a5c77fb");
Object.keys(_index110).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index110[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index110[key];
        }
    });
});
var _index111 = require("f0cf225cf98c3e8f");
Object.keys(_index111).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index111[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index111[key];
        }
    });
});
var _index112 = require("bf7e1cb6a8774a05");
Object.keys(_index112).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index112[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index112[key];
        }
    });
});
var _index113 = require("d5aea1feeaf1adbf");
Object.keys(_index113).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index113[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index113[key];
        }
    });
});
var _index114 = require("48e6ab9d727b91c9");
Object.keys(_index114).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index114[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index114[key];
        }
    });
});
var _index115 = require("c79cfd58c43d1fa4");
Object.keys(_index115).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index115[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index115[key];
        }
    });
});
var _index116 = require("c728316595f95974");
Object.keys(_index116).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index116[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index116[key];
        }
    });
});
var _index117 = require("2caa1112ba1b4508");
Object.keys(_index117).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index117[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index117[key];
        }
    });
});
var _index118 = require("9d5c85b5b30fda8b");
Object.keys(_index118).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index118[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index118[key];
        }
    });
});
var _index119 = require("c46fa1cec26cd22a");
Object.keys(_index119).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index119[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index119[key];
        }
    });
});
var _index120 = require("6c707c0047f553ac");
Object.keys(_index120).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index120[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index120[key];
        }
    });
});
var _index121 = require("b71a70253afe0556");
Object.keys(_index121).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index121[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index121[key];
        }
    });
});
var _index122 = require("e2f24260bdfcee8f");
Object.keys(_index122).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index122[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index122[key];
        }
    });
});
var _index123 = require("be2bf5e6a74e2283");
Object.keys(_index123).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index123[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index123[key];
        }
    });
});
var _index124 = require("e93db27a94ecd3d3");
Object.keys(_index124).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index124[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index124[key];
        }
    });
});
var _index125 = require("2aefde7c3914abfe");
Object.keys(_index125).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index125[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index125[key];
        }
    });
});
var _index126 = require("56b4c8eeea06f054");
Object.keys(_index126).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index126[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index126[key];
        }
    });
});
var _index127 = require("6449dde00b2f822c");
Object.keys(_index127).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index127[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index127[key];
        }
    });
});
var _index128 = require("467aa549567ca48");
Object.keys(_index128).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index128[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index128[key];
        }
    });
});
var _index129 = require("b3c68b9632f5847f");
Object.keys(_index129).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index129[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index129[key];
        }
    });
});
var _index130 = require("af086aa9222e7e7a");
Object.keys(_index130).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index130[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index130[key];
        }
    });
});
var _index131 = require("e5fdfd39e6fba6e7");
Object.keys(_index131).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index131[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index131[key];
        }
    });
});
var _index132 = require("abbe493c9dd29207");
Object.keys(_index132).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index132[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index132[key];
        }
    });
});
var _index133 = require("a5aa9970fda729b7");
Object.keys(_index133).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index133[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index133[key];
        }
    });
});
var _index134 = require("c06c3eadb4cdf4e3");
Object.keys(_index134).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index134[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index134[key];
        }
    });
});
var _index135 = require("cdc71995959dfbfa");
Object.keys(_index135).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index135[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index135[key];
        }
    });
});
var _index136 = require("4a9a53e9af17ff6f");
Object.keys(_index136).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index136[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index136[key];
        }
    });
});
var _index137 = require("59f886b13821bc45");
Object.keys(_index137).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index137[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index137[key];
        }
    });
});
var _index138 = require("f34570d87ce571d9");
Object.keys(_index138).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index138[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index138[key];
        }
    });
});
var _index139 = require("d33f52ea22bb7fd3");
Object.keys(_index139).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index139[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index139[key];
        }
    });
});
var _index140 = require("16489881fdd5bbdf");
Object.keys(_index140).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index140[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index140[key];
        }
    });
});
var _index141 = require("61b14f40f6d2e486");
Object.keys(_index141).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index141[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index141[key];
        }
    });
});
var _index142 = require("9aa6cb940f916d0a");
Object.keys(_index142).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index142[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index142[key];
        }
    });
});
var _index143 = require("b7eef910ecfacb18");
Object.keys(_index143).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index143[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index143[key];
        }
    });
});
var _index144 = require("686832f61553fbb3");
Object.keys(_index144).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index144[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index144[key];
        }
    });
});
var _index145 = require("86e637d32ee5d263");
Object.keys(_index145).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index145[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index145[key];
        }
    });
});
var _index146 = require("830824c7146bc058");
Object.keys(_index146).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index146[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index146[key];
        }
    });
});
var _index147 = require("4f0836001f7c5048");
Object.keys(_index147).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index147[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index147[key];
        }
    });
});
var _index148 = require("4d73f01e07ece752");
Object.keys(_index148).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index148[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index148[key];
        }
    });
});
var _index149 = require("423b6331ffa3e5d2");
Object.keys(_index149).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index149[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index149[key];
        }
    });
});
var _index150 = require("f9514135275b73a4");
Object.keys(_index150).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index150[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index150[key];
        }
    });
});
var _index151 = require("d2f2611a87dcb9e3");
Object.keys(_index151).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index151[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index151[key];
        }
    });
});
var _index152 = require("16575fe82c6eaba");
Object.keys(_index152).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index152[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index152[key];
        }
    });
});
var _index153 = require("123fc514f9f01a00");
Object.keys(_index153).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index153[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index153[key];
        }
    });
});
var _index154 = require("c86bcf67d45e9435");
Object.keys(_index154).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index154[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index154[key];
        }
    });
});
var _index155 = require("4821ca0dd2872a0f");
Object.keys(_index155).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index155[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index155[key];
        }
    });
});
var _index156 = require("85eb0bf7985aa70e");
Object.keys(_index156).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index156[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index156[key];
        }
    });
});
var _index157 = require("1a237db8f40f7128");
Object.keys(_index157).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index157[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index157[key];
        }
    });
});
var _index158 = require("806f1afed957366e");
Object.keys(_index158).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index158[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index158[key];
        }
    });
});
var _index159 = require("cad35743a000cb4");
Object.keys(_index159).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index159[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index159[key];
        }
    });
});
var _index160 = require("115f361c6735a6c0");
Object.keys(_index160).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index160[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index160[key];
        }
    });
});
var _index161 = require("80e94a4a0e176a8");
Object.keys(_index161).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index161[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index161[key];
        }
    });
});
var _index162 = require("780d37322e411839");
Object.keys(_index162).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index162[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index162[key];
        }
    });
});
var _index163 = require("7c96227bbd2ac57c");
Object.keys(_index163).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index163[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index163[key];
        }
    });
});
var _index164 = require("a60de3990361ba17");
Object.keys(_index164).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index164[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index164[key];
        }
    });
});
var _index165 = require("67038e2323e63ea9");
Object.keys(_index165).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index165[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index165[key];
        }
    });
});
var _index166 = require("f369bf768ced1809");
Object.keys(_index166).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index166[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index166[key];
        }
    });
});
var _index167 = require("8df5570f1a67899f");
Object.keys(_index167).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index167[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index167[key];
        }
    });
});
var _index168 = require("8be23c536e634067");
Object.keys(_index168).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index168[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index168[key];
        }
    });
});
var _index169 = require("970ab91418234ff6");
Object.keys(_index169).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index169[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index169[key];
        }
    });
});
var _index170 = require("bb6bd04224221f0f");
Object.keys(_index170).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index170[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index170[key];
        }
    });
});
var _index171 = require("83bc3c8b247c95ac");
Object.keys(_index171).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index171[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index171[key];
        }
    });
});
var _index172 = require("1b896d69ba284cd1");
Object.keys(_index172).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index172[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index172[key];
        }
    });
});
var _index173 = require("9e825321a9eac99d");
Object.keys(_index173).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index173[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index173[key];
        }
    });
});
var _index174 = require("e12f32189f9896fa");
Object.keys(_index174).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index174[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index174[key];
        }
    });
});
var _index175 = require("7679dd63eccebad1");
Object.keys(_index175).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index175[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index175[key];
        }
    });
});
var _index176 = require("a0e3c9611b9bf96c");
Object.keys(_index176).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index176[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index176[key];
        }
    });
});
var _index177 = require("eb624ca985ff10d8");
Object.keys(_index177).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index177[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index177[key];
        }
    });
});
var _index178 = require("b2b165aa2a86d7f0");
Object.keys(_index178).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index178[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index178[key];
        }
    });
});
var _index179 = require("caabce449eab8dd");
Object.keys(_index179).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index179[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index179[key];
        }
    });
});
var _index180 = require("5d1dd7f0f23ee603");
Object.keys(_index180).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index180[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index180[key];
        }
    });
});
var _index181 = require("647dcd5d2203f0b0");
Object.keys(_index181).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index181[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index181[key];
        }
    });
});
var _index182 = require("9cb02b8edba87fd");
Object.keys(_index182).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index182[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index182[key];
        }
    });
});
var _index183 = require("c3ed91fb195d875a");
Object.keys(_index183).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index183[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index183[key];
        }
    });
});
var _index184 = require("2c295112993dd62f");
Object.keys(_index184).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index184[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index184[key];
        }
    });
});
var _index185 = require("af1893c4359270d5");
Object.keys(_index185).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index185[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index185[key];
        }
    });
});
var _index186 = require("28e3998e2ecca01f");
Object.keys(_index186).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index186[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index186[key];
        }
    });
});
var _index187 = require("be774b00f21988d3");
Object.keys(_index187).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index187[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index187[key];
        }
    });
});
var _index188 = require("8b434ff09ce37dea");
Object.keys(_index188).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index188[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index188[key];
        }
    });
});
var _index189 = require("78a9f3780d7e41b8");
Object.keys(_index189).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index189[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index189[key];
        }
    });
});
var _index190 = require("fec986856a29d9dc");
Object.keys(_index190).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index190[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index190[key];
        }
    });
});
var _index191 = require("e1c425cdf1d55ab9");
Object.keys(_index191).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index191[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index191[key];
        }
    });
});
var _index192 = require("7fcca35af7611279");
Object.keys(_index192).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index192[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index192[key];
        }
    });
});
var _index193 = require("bc1b64da9d20b354");
Object.keys(_index193).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index193[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index193[key];
        }
    });
});
var _index194 = require("5ad4c5c7cdd2014a");
Object.keys(_index194).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index194[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index194[key];
        }
    });
});
var _index195 = require("9ba9585d1f939198");
Object.keys(_index195).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index195[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index195[key];
        }
    });
});
var _index196 = require("8dd9270e196da68a");
Object.keys(_index196).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index196[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index196[key];
        }
    });
});
var _index197 = require("26bfd84a78d86013");
Object.keys(_index197).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index197[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index197[key];
        }
    });
});
var _index198 = require("c7cc615446e6a2b7");
Object.keys(_index198).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index198[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index198[key];
        }
    });
});
var _index199 = require("21a79e95083ca1bc");
Object.keys(_index199).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index199[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index199[key];
        }
    });
});
var _index200 = require("20bbccaad70d3b36");
Object.keys(_index200).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index200[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index200[key];
        }
    });
});
var _index201 = require("1304f66658492899");
Object.keys(_index201).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index201[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index201[key];
        }
    });
});
var _index202 = require("e669135196dbe120");
Object.keys(_index202).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index202[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index202[key];
        }
    });
});
var _index203 = require("96e5466dc057addb");
Object.keys(_index203).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index203[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index203[key];
        }
    });
});
var _index204 = require("6511e433e11f2be4");
Object.keys(_index204).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index204[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index204[key];
        }
    });
});
var _index205 = require("f11dd2e4ce9106eb");
Object.keys(_index205).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index205[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index205[key];
        }
    });
});
var _index206 = require("d813fb5db6a646f6");
Object.keys(_index206).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index206[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index206[key];
        }
    });
});
var _index207 = require("f7134e17cdb98335");
Object.keys(_index207).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index207[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index207[key];
        }
    });
});
var _index208 = require("906e60f1e1a30c6a");
Object.keys(_index208).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index208[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index208[key];
        }
    });
});
var _index209 = require("8e42dbcd2222435d");
Object.keys(_index209).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index209[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index209[key];
        }
    });
});
var _index210 = require("3d08c235c5a0918");
Object.keys(_index210).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index210[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index210[key];
        }
    });
});
var _index211 = require("9ca3f5ebe5cbf2ef");
Object.keys(_index211).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index211[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index211[key];
        }
    });
});
var _index212 = require("9e076e569f3df020");
Object.keys(_index212).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index212[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index212[key];
        }
    });
});
var _index213 = require("997eaaf3105209be");
Object.keys(_index213).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index213[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index213[key];
        }
    });
});
var _index214 = require("5feb840f1bdd9cea");
Object.keys(_index214).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index214[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index214[key];
        }
    });
});
var _index215 = require("4437c29e1991dd08");
Object.keys(_index215).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index215[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index215[key];
        }
    });
});
var _index216 = require("faf9e1483266d8c5");
Object.keys(_index216).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index216[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index216[key];
        }
    });
});
var _index217 = require("894218cc13b5a21e");
Object.keys(_index217).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index217[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index217[key];
        }
    });
});
var _index218 = require("1ab522cddd985641");
Object.keys(_index218).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index218[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index218[key];
        }
    });
});
var _index219 = require("e30c032c55913541");
Object.keys(_index219).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index219[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index219[key];
        }
    });
});
var _index220 = require("d12684f12c863ead");
Object.keys(_index220).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index220[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index220[key];
        }
    });
});
var _index221 = require("e7e3ba1aec4ed01d");
Object.keys(_index221).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index221[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index221[key];
        }
    });
});
var _index222 = require("52ec6c389627d10b");
Object.keys(_index222).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index222[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index222[key];
        }
    });
});
var _index223 = require("8258136654b5f10e");
Object.keys(_index223).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index223[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index223[key];
        }
    });
});
var _index224 = require("b4177823b3e8302d");
Object.keys(_index224).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index224[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index224[key];
        }
    });
});
var _index225 = require("9960d9863cc3055e");
Object.keys(_index225).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index225[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index225[key];
        }
    });
});
var _index226 = require("e3c43ee26dfbcec1");
Object.keys(_index226).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index226[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index226[key];
        }
    });
});
var _index227 = require("73e772cf695ca2bb");
Object.keys(_index227).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index227[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index227[key];
        }
    });
});
var _index228 = require("ef2b183f3fde724e");
Object.keys(_index228).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index228[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index228[key];
        }
    });
});
var _index229 = require("15060203358a57e");
Object.keys(_index229).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index229[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index229[key];
        }
    });
});
var _index230 = require("67ef3ff6e2b76b4c");
Object.keys(_index230).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index230[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index230[key];
        }
    });
});
var _index231 = require("79880219f6de9c2a");
Object.keys(_index231).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index231[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index231[key];
        }
    });
});
var _index232 = require("b9bc07a05bbf8619");
Object.keys(_index232).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index232[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index232[key];
        }
    });
});
var _index233 = require("197104af79cd3bb0");
Object.keys(_index233).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index233[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index233[key];
        }
    });
});
var _index234 = require("30c7b44047d79a40");
Object.keys(_index234).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index234[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index234[key];
        }
    });
});
var _index235 = require("4285b426652f1063");
Object.keys(_index235).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index235[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index235[key];
        }
    });
});
var _index236 = require("11e1793b54905752");
Object.keys(_index236).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index236[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index236[key];
        }
    });
});
var _index237 = require("f5ad81df1b2e131c");
Object.keys(_index237).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index237[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index237[key];
        }
    });
});
var _index238 = require("f4f39753d3eb2c2");
Object.keys(_index238).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index238[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index238[key];
        }
    });
});
var _index239 = require("1562caa8174a1717");
Object.keys(_index239).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index239[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index239[key];
        }
    });
});
var _index240 = require("eea6fed85cd926ef");
Object.keys(_index240).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index240[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index240[key];
        }
    });
});
var _index241 = require("1285ad23358fbca7");
Object.keys(_index241).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index241[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index241[key];
        }
    });
});
var _index242 = require("4dba10434b646fa2");
Object.keys(_index242).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index242[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index242[key];
        }
    });
});
var _index243 = require("9a984f4c52af48f5");
Object.keys(_index243).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index243[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index243[key];
        }
    });
});
var _index244 = require("7e2283ebcb15c962");
Object.keys(_index244).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index244[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index244[key];
        }
    });
});
var _index245 = require("37dd3086962550e1");
Object.keys(_index245).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _index245[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _index245[key];
        }
    });
});

},{"bb476f479aec785f":"clHFd","f3c55fba68737491":"3jaq5","4e06aa5c5a66ee79":"4rfUY","320136604150f517":"4nx75","9bfe5668fe1279fd":"31GOg","8a5f15f49ef72b46":"6Kk2d","ad78344e087d5dce":"cxnKG","c4f5940a947b78c":"6cECY","f66bb3ce3ddb423a":"8P1Ro","cf2ce1177f6f3085":"qV0t6","ff27f5c5e825f426":"jPvAg","9692908b0d3e69f3":"fDVF0","c07b6490d53540ef":"3zqev","33ecb1182a4f61bc":"4zP4x","eb6c645c302c3877":"kZcjF","96a422b0dac4a654":"lFG4o","41bd5ae6bd5c566d":"aW36B","1b492f1d94521a5d":"9gXjy","c13fe358d89ecd81":"h2Biw","ce109cc453253b85":"frxr8","d42674a0b7bfc434":"550kA","fbdc79daa81b87b6":"2BCSg","c2badf5a2b5ed454":"6OksG","9fd007b982125b9a":"9R5oI","b695668577e1e7cb":"e4vBk","6b399f6303d57295":"aM2iH","6a61a2a843b91654":"4hKRZ","60b631dcb2f037ca":"dCDU2","2ed27a2d4a3c6872":"96JRi","41d2eb1d2381e8a":"e8894","c599317e8caae438":"1yEur","3b135e2b9118d1b":"kM6bd","241ef3acf8caa33a":"bsCCI","b76109f782422508":"cIsk3","30e8f5ceefb905b2":"dRYs4","20867c3d025aff9":"1galj","366b2e75db11947a":"f7XyR","4582c2f25445c44b":"4Pat4","55c0b2733cdea4d1":"4YOVD","74ff6cf808a390db":"jo01N","81c3475ead0f5b5a":"aZkCM","cd10d76a84c94920":"cern1","b58b90c359ac3c03":"gMzZg","bcedf2167bbb0925":"1YTKw","dd98d2de70848b38":"14wIV","e137338bdb2b9c68":"1Hvjr","d7d2b7f0a9f716a8":"fy1vF","83b612a607feb7af":"l1wr4","68777f2c425fee5d":"bDviL","5fe5471d81c79da6":"hrufR","c2cf95d448d96fcc":"iE98M","bdeffae0b4080a1e":"9drGd","b0814d5ce39f52b5":"jkwm4","38c2fd7b5ab40bf0":"ilScE","216f5a0b7789e14":"lq5Ng","b3e5b40e0fbb1d44":"hMsPJ","e989ece2a2757bd2":"e8J9b","610e7dd2284f5781":"76GOg","aee49e17aca40e68":"57VSA","ba659abbcc4b60fe":"56hQW","cc3f9c4f9c787ea6":"9aLDB","40192b29822dee38":"gNh98","87e1741b0e0137ea":"kk9sE","d634ea72aef4c86e":"jA8qR","665bea9ec101ae55":"gLY9a","4c745f864149cfd3":"21kuU","59e6129eee3b016c":"8udzM","88f236b6a61f4122":"knfYA","33f9f2f6d62dc6cc":"hUJPw","5e181004291889f8":"8VCjU","de24191615ebbb80":"eejDq","d63e27bbb84952ec":"kJ7Kp","c2012a9ded2a05e4":"xBI1j","6f70aef5356bf042":"j5ivt","3fea09df6269258d":"2QHf2","cf95b5833c75a113":"flnmM","198ca05f7c43d0c0":"g0pDX","2a7b78bbeb9ac279":"fhUMA","81ea02ff9efa6f86":"bowkl","129a78908bb8985b":"3SopR","f3c08909629e1f03":"dwXVU","f78c22b2c30c3be8":"1Cgn5","885f4bbed816b7f7":"5rOze","72d271579509d098":"4Aywj","dee4e1ab9bdde628":"68be7","571218393678880d":"9UpoQ","2835d5a51730a5b3":"1RGyx","3741eee35491c087":"g9N33","e92428f0f5974b5a":"eLGCf","8523677aaea2cb20":"bcMd7","22812cfff632fba0":"8yLyg","a84bbb9e49250d10":"9LhQ7","ce1a93769edb9f74":"dEUoh","c29e8ab5eeb7d4c0":"kpBnX","417a881dca9183b4":"cHOKA","ed18152d44e54a88":"jG0oF","5ad8718b8ffbdc8":"eC1Ii","4885f3e1b4265446":"afLVo","21dc31ac6a839f01":"j9b51","ed69673c611caf3c":"52u1y","9a619fbde7ef4e46":"8xoTX","5b4ec1d4ed18e2a5":"7ACxa","ea293604faa53290":"3w42T","b884dd139cae152f":"4ZoCh","4c3ab9f336a7d51a":"h2HAt","653e45499ad5f194":"2Vaex","7ac77dc0818e9e94":"2I4C3","9ebf799edec0800d":"1wrtN","e9dba9b7ca1e9602":"fzng2","457b792b8a5c77fb":"a5u0o","f0cf225cf98c3e8f":"byTCo","bf7e1cb6a8774a05":"22cZO","d5aea1feeaf1adbf":"g1QYr","48e6ab9d727b91c9":"14MLt","c79cfd58c43d1fa4":"hVX6E","c728316595f95974":"774cU","2caa1112ba1b4508":"94I6u","9d5c85b5b30fda8b":"1rDlJ","c46fa1cec26cd22a":"flQqx","6c707c0047f553ac":"ikEc3","b71a70253afe0556":"hVRiF","e2f24260bdfcee8f":"hYihA","be2bf5e6a74e2283":"5KIfx","e93db27a94ecd3d3":"d8tjq","2aefde7c3914abfe":"lJniy","56b4c8eeea06f054":"2wuYT","6449dde00b2f822c":"6jB9O","467aa549567ca48":"4MJIk","b3c68b9632f5847f":"4iWSY","af086aa9222e7e7a":"kZUIU","e5fdfd39e6fba6e7":"eU6Ej","abbe493c9dd29207":"gOQhx","a5aa9970fda729b7":"jlxaW","c06c3eadb4cdf4e3":"dhwJH","cdc71995959dfbfa":"17dAn","4a9a53e9af17ff6f":"brkny","59f886b13821bc45":"5lizr","f34570d87ce571d9":"c4j82","d33f52ea22bb7fd3":"5lYtr","16489881fdd5bbdf":"Eu1MQ","61b14f40f6d2e486":"9gMaA","9aa6cb940f916d0a":"3Fqpz","b7eef910ecfacb18":"gdtXT","686832f61553fbb3":"5PznH","86e637d32ee5d263":"j5jA2","830824c7146bc058":"6Uhv0","4f0836001f7c5048":"aKlha","4d73f01e07ece752":"dnDjk","423b6331ffa3e5d2":"eHJvF","f9514135275b73a4":"gd9Jf","d2f2611a87dcb9e3":"5G7yh","16575fe82c6eaba":"fs0KL","123fc514f9f01a00":"fmVPw","c86bcf67d45e9435":"2b0DW","4821ca0dd2872a0f":"lsq9Q","85eb0bf7985aa70e":"cGXyh","1a237db8f40f7128":"fiaCg","806f1afed957366e":"6TVlp","cad35743a000cb4":"adXYY","115f361c6735a6c0":"dotyf","80e94a4a0e176a8":"chMjN","780d37322e411839":"8o1Gx","7c96227bbd2ac57c":"1X0t5","a60de3990361ba17":"1K8Pj","67038e2323e63ea9":"iyuWF","f369bf768ced1809":"f52Ug","8df5570f1a67899f":"bWKPR","8be23c536e634067":"9BQAc","970ab91418234ff6":"kpjWe","bb6bd04224221f0f":"l5xGl","83bc3c8b247c95ac":"loOti","1b896d69ba284cd1":"4P73Z","9e825321a9eac99d":"dwTYx","e12f32189f9896fa":"ectON","7679dd63eccebad1":"klwaG","a0e3c9611b9bf96c":"kZXv4","eb624ca985ff10d8":"7qfmK","b2b165aa2a86d7f0":"9HIBF","caabce449eab8dd":"iAstl","5d1dd7f0f23ee603":"kfjX0","647dcd5d2203f0b0":"bLZlL","9cb02b8edba87fd":"7NBAW","c3ed91fb195d875a":"d5XXa","2c295112993dd62f":"dzqEZ","af1893c4359270d5":"ahJLV","28e3998e2ecca01f":"65s9I","be774b00f21988d3":"cMaup","8b434ff09ce37dea":"fFZCm","78a9f3780d7e41b8":"diaKm","fec986856a29d9dc":"ahOCa","e1c425cdf1d55ab9":"lQMbZ","7fcca35af7611279":"6iRsb","bc1b64da9d20b354":"lf96Z","5ad4c5c7cdd2014a":"bLZci","9ba9585d1f939198":"31TR2","8dd9270e196da68a":"pVQn8","26bfd84a78d86013":"73krW","c7cc615446e6a2b7":"dBHh4","21a79e95083ca1bc":"adMXB","20bbccaad70d3b36":"hYlD5","1304f66658492899":"3JkVP","e669135196dbe120":"kXLgm","96e5466dc057addb":"kGwR1","6511e433e11f2be4":"MMgIX","f11dd2e4ce9106eb":"iA2vh","d813fb5db6a646f6":"kPhzA","f7134e17cdb98335":"bbmV7","906e60f1e1a30c6a":"ciD3Y","8e42dbcd2222435d":"kIitV","3d08c235c5a0918":"2f8OI","9ca3f5ebe5cbf2ef":"kRqwS","9e076e569f3df020":"jwmnN","997eaaf3105209be":"5punH","5feb840f1bdd9cea":"a1sR6","4437c29e1991dd08":"gChCE","faf9e1483266d8c5":"eVqaZ","894218cc13b5a21e":"gtCKK","1ab522cddd985641":"lFp03","e30c032c55913541":"mXmxs","d12684f12c863ead":"auSUw","e7e3ba1aec4ed01d":"9gNxQ","52ec6c389627d10b":"dIHGv","8258136654b5f10e":"jx4TE","b4177823b3e8302d":"1RQd2","9960d9863cc3055e":"9EOil","e3c43ee26dfbcec1":"kIE5G","73e772cf695ca2bb":"2V5uy","ef2b183f3fde724e":"1R6hN","15060203358a57e":"hV3Jl","67ef3ff6e2b76b4c":"cvXrD","79880219f6de9c2a":"233sn","b9bc07a05bbf8619":"gmMbm","197104af79cd3bb0":"annNy","30c7b44047d79a40":"aFAQA","4285b426652f1063":"lGAwE","11e1793b54905752":"ez0sQ","f5ad81df1b2e131c":"4fGt6","f4f39753d3eb2c2":"gxXpH","1562caa8174a1717":"91P4k","eea6fed85cd926ef":"eYsCJ","1285ad23358fbca7":"hv6uH","4dba10434b646fa2":"ewYHa","9a984f4c52af48f5":"6APbZ","7e2283ebcb15c962":"lDcsj","37dd3086962550e1":"3EWMd"}],"clHFd":[function(require,module,exports) {
"use strict";
exports.add = add;
var _index = require("925991985175af2c");
var _index2 = require("13114f43603b9058");
var _index3 = require("84ab99a1072aba1a");
var _index4 = require("3067be390b31b3e6");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function add(date, duration) {
    var _duration_years = duration.years, years = _duration_years === void 0 ? 0 : _duration_years, _duration_months = duration.months, months = _duration_months === void 0 ? 0 : _duration_months, _duration_weeks = duration.weeks, weeks = _duration_weeks === void 0 ? 0 : _duration_weeks, _duration_days = duration.days, days = _duration_days === void 0 ? 0 : _duration_days, _duration_hours = duration.hours, hours = _duration_hours === void 0 ? 0 : _duration_hours, _duration_minutes = duration.minutes, minutes = _duration_minutes === void 0 ? 0 : _duration_minutes, _duration_seconds = duration.seconds, seconds = _duration_seconds === void 0 ? 0 : _duration_seconds;
    // Add years and months
    var _date = (0, _index4.toDate)(date);
    var dateWithMonths = months || years ? (0, _index2.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, _index.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = (0, _index3.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}

},{"925991985175af2c":"4rfUY","13114f43603b9058":"6cECY","84ab99a1072aba1a":"h2Biw","3067be390b31b3e6":"eYsCJ"}],"4rfUY":[function(require,module,exports) {
"use strict";
exports.addDays = addDays;
var _index = require("2cd967972a296ad9");
var _index2 = require("f0e78f9c0d91f156");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function addDays(date, amount) {
    var _date = (0, _index.toDate)(date);
    if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

},{"2cd967972a296ad9":"eYsCJ","f0e78f9c0d91f156":"h2Biw"}],"eYsCJ":[function(require,module,exports) {
"use strict";
exports.toDate = toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

},{}],"h2Biw":[function(require,module,exports) {
"use strict";
exports.constructFrom = constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

},{}],"6cECY":[function(require,module,exports) {
"use strict";
exports.addMonths = addMonths;
var _index = require("5742eeee77c6c4dd");
var _index2 = require("79294aad06ee37dd");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function addMonths(date, amount) {
    var _date = (0, _index.toDate)(date);
    if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    var dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = (0, _index2.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

},{"5742eeee77c6c4dd":"eYsCJ","79294aad06ee37dd":"h2Biw"}],"3jaq5":[function(require,module,exports) {
"use strict";
exports.addBusinessDays = addBusinessDays;
var _index = require("c4290ece85b498c3");
var _index2 = require("db98b25fdeb6f59b");
var _index3 = require("e08f244f63c0b506");
var _index4 = require("a4930da9d9021f2e");
var _index5 = require("475b8d7f409bcfa3");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function addBusinessDays(date, amount) {
    var _date = (0, _index5.toDate)(date);
    var startedOnWeekend = (0, _index4.isWeekend)(_date);
    if (isNaN(amount)) return (0, _index.constructFrom)(date, NaN);
    var hours = _date.getHours();
    var sign = amount < 0 ? -1 : 1;
    var fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    var restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, _index4.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, _index4.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, _index2.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, _index3.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}

},{"c4290ece85b498c3":"h2Biw","db98b25fdeb6f59b":"gOQhx","e08f244f63c0b506":"jlxaW","a4930da9d9021f2e":"dnDjk","475b8d7f409bcfa3":"eYsCJ"}],"gOQhx":[function(require,module,exports) {
"use strict";
exports.isSaturday = isSaturday;
var _index = require("e530b4cdc312cd61");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function isSaturday(date) {
    return (0, _index.toDate)(date).getDay() === 6;
}

},{"e530b4cdc312cd61":"eYsCJ"}],"jlxaW":[function(require,module,exports) {
"use strict";
exports.isSunday = isSunday;
var _index = require("ae830739b06efde4");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function isSunday(date) {
    return (0, _index.toDate)(date).getDay() === 0;
}

},{"ae830739b06efde4":"eYsCJ"}],"dnDjk":[function(require,module,exports) {
"use strict";
exports.isWeekend = isWeekend;
var _index = require("c698b70ee71dfca6");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function isWeekend(date) {
    var day = (0, _index.toDate)(date).getDay();
    return day === 0 || day === 6;
}

},{"c698b70ee71dfca6":"eYsCJ"}],"4nx75":[function(require,module,exports) {
"use strict";
exports.addHours = addHours;
var _index = require("1def4ce2cbf2b5a4");
var _index2 = require("c47db39c292847b5");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function addHours(date, amount) {
    return (0, _index.addMilliseconds)(date, amount * _index2.millisecondsInHour);
}

},{"1def4ce2cbf2b5a4":"6Kk2d","c47db39c292847b5":"fzK9Z"}],"6Kk2d":[function(require,module,exports) {
"use strict";
exports.addMilliseconds = addMilliseconds;
var _index = require("701ad4371d122310");
var _index2 = require("fd3355012d608a81");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(date, amount) {
    var timestamp = +(0, _index.toDate)(date);
    return (0, _index2.constructFrom)(date, timestamp + amount);
}

},{"701ad4371d122310":"eYsCJ","fd3355012d608a81":"h2Biw"}],"fzK9Z":[function(require,module,exports) {
"use strict";
exports.secondsInYear = exports.secondsInWeek = exports.secondsInQuarter = exports.secondsInMonth = exports.secondsInMinute = exports.secondsInHour = exports.secondsInDay = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInYear = exports.minutesInMonth = exports.minutesInHour = exports.minutesInDay = exports.minTime = exports.millisecondsInWeek = exports.millisecondsInSecond = exports.millisecondsInMinute = exports.millisecondsInHour = exports.millisecondsInDay = exports.maxTime = exports.daysInYear = exports.daysInWeek = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var daysInWeek = exports.daysInWeek = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ var daysInYear = exports.daysInYear = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ var maxTime = exports.maxTime = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ var minTime = exports.minTime = -maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ var millisecondsInWeek = exports.millisecondsInWeek = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ var millisecondsInDay = exports.millisecondsInDay = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ var millisecondsInMinute = exports.millisecondsInMinute = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ var millisecondsInHour = exports.millisecondsInHour = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ var millisecondsInSecond = exports.millisecondsInSecond = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ var minutesInYear = exports.minutesInYear = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ var minutesInMonth = exports.minutesInMonth = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ var minutesInDay = exports.minutesInDay = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ var minutesInHour = exports.minutesInHour = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ var monthsInQuarter = exports.monthsInQuarter = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ var monthsInYear = exports.monthsInYear = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ var quartersInYear = exports.quartersInYear = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ var secondsInHour = exports.secondsInHour = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ var secondsInMinute = exports.secondsInMinute = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ var secondsInDay = exports.secondsInDay = secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ var secondsInWeek = exports.secondsInWeek = secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ var secondsInYear = exports.secondsInYear = secondsInDay * daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ var secondsInMonth = exports.secondsInMonth = secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ var secondsInQuarter = exports.secondsInQuarter = secondsInMonth * 3;

},{}],"31GOg":[function(require,module,exports) {
"use strict";
exports.addISOWeekYears = addISOWeekYears;
var _index = require("240e5aec3c416c15");
var _index2 = require("39a8cd644c826899");
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function addISOWeekYears(date, amount) {
    return (0, _index2.setISOWeekYear)(date, (0, _index.getISOWeekYear)(date) + amount);
}

},{"240e5aec3c416c15":"1RGyx","39a8cd644c826899":"MMgIX"}],"1RGyx":[function(require,module,exports) {
"use strict";
exports.getISOWeekYear = getISOWeekYear;
var _index = require("931ddb1ed96783e");
var _index2 = require("657e416c92daae6d");
var _index3 = require("df657aff16d6d4b4");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function getISOWeekYear(date) {
    var _date = (0, _index3.toDate)(date);
    var year = _date.getFullYear();
    var fourthOfJanuaryOfNextYear = (0, _index.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index2.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = (0, _index.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index2.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"931ddb1ed96783e":"h2Biw","657e416c92daae6d":"eVqaZ","df657aff16d6d4b4":"eYsCJ"}],"eVqaZ":[function(require,module,exports) {
"use strict";
exports.startOfISOWeek = startOfISOWeek;
var _index = require("af053f1a0e32a5c7");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfISOWeek(date) {
    return (0, _index.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

},{"af053f1a0e32a5c7":"1RQd2"}],"1RQd2":[function(require,module,exports) {
"use strict";
exports.startOfWeek = startOfWeek;
var _index = require("55694623f1e86518");
var _index2 = require("95f2b89022ff2bba");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfWeek(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _index2.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _index.toDate)(date);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"55694623f1e86518":"eYsCJ","95f2b89022ff2bba":"ia1W9"}],"ia1W9":[function(require,module,exports) {
"use strict";
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{}],"MMgIX":[function(require,module,exports) {
"use strict";
exports.setISOWeekYear = setISOWeekYear;
var _index = require("b4cc3bf7048ec0f8");
var _index2 = require("63c89f9c4541591a");
var _index3 = require("1aea00dad6bb8db7");
var _index4 = require("e36603a772a1edcb");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function setISOWeekYear(date, weekYear) {
    var _date = (0, _index4.toDate)(date);
    var diff = (0, _index2.differenceInCalendarDays)(_date, (0, _index3.startOfISOWeekYear)(_date));
    var fourthOfJanuary = (0, _index.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, _index3.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

},{"b4cc3bf7048ec0f8":"h2Biw","63c89f9c4541591a":"6OksG","1aea00dad6bb8db7":"gtCKK","e36603a772a1edcb":"eYsCJ"}],"6OksG":[function(require,module,exports) {
"use strict";
exports.differenceInCalendarDays = differenceInCalendarDays;
var _index = require("1d847bb4e92f7cd2");
var _index2 = require("7c9c2b23ec3dd965");
var _index3 = require("b0f56dce4f1af165");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function differenceInCalendarDays(dateLeft, dateRight) {
    var startOfDayLeft = (0, _index2.startOfDay)(dateLeft);
    var startOfDayRight = (0, _index2.startOfDay)(dateRight);
    var timestampLeft = +startOfDayLeft - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    var timestampRight = +startOfDayRight - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / _index.millisecondsInDay);
}

},{"1d847bb4e92f7cd2":"fzK9Z","7c9c2b23ec3dd965":"5punH","b0f56dce4f1af165":"l494b"}],"5punH":[function(require,module,exports) {
"use strict";
exports.startOfDay = startOfDay;
var _index = require("b2c84f6728c789fd");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function startOfDay(date) {
    var _date = (0, _index.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"b2c84f6728c789fd":"eYsCJ"}],"l494b":[function(require,module,exports) {
"use strict";
exports.getTimezoneOffsetInMilliseconds = getTimezoneOffsetInMilliseconds;
var _index = require("dd2f8ad2d4e94e96");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    var _date = (0, _index.toDate)(date);
    var utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"dd2f8ad2d4e94e96":"eYsCJ"}],"gtCKK":[function(require,module,exports) {
"use strict";
exports.startOfISOWeekYear = startOfISOWeekYear;
var _index = require("a94c8ed604a9d595");
var _index2 = require("2ab3fd1ace85020d");
var _index3 = require("3de294871cd3bca4");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function startOfISOWeekYear(date) {
    var year = (0, _index.getISOWeekYear)(date);
    var fourthOfJanuary = (0, _index3.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _index2.startOfISOWeek)(fourthOfJanuary);
}

},{"a94c8ed604a9d595":"1RGyx","2ab3fd1ace85020d":"eVqaZ","3de294871cd3bca4":"h2Biw"}],"cxnKG":[function(require,module,exports) {
"use strict";
exports.addMinutes = addMinutes;
var _index = require("66ff9833f2a7265d");
var _index2 = require("1657f0b8a8702e8e");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function addMinutes(date, amount) {
    return (0, _index.addMilliseconds)(date, amount * _index2.millisecondsInMinute);
}

},{"66ff9833f2a7265d":"6Kk2d","1657f0b8a8702e8e":"fzK9Z"}],"8P1Ro":[function(require,module,exports) {
"use strict";
exports.addQuarters = addQuarters;
var _index = require("26f66aa2af34ef45");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function addQuarters(date, amount) {
    var months = amount * 3;
    return (0, _index.addMonths)(date, months);
}

},{"26f66aa2af34ef45":"6cECY"}],"qV0t6":[function(require,module,exports) {
"use strict";
exports.addSeconds = addSeconds;
var _index = require("7442afe167e053cc");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function addSeconds(date, amount) {
    return (0, _index.addMilliseconds)(date, amount * 1000);
}

},{"7442afe167e053cc":"6Kk2d"}],"jPvAg":[function(require,module,exports) {
"use strict";
exports.addWeeks = addWeeks;
var _index = require("bdd905550c7c5ab9");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function addWeeks(date, amount) {
    var days = amount * 7;
    return (0, _index.addDays)(date, days);
}

},{"bdd905550c7c5ab9":"4rfUY"}],"fDVF0":[function(require,module,exports) {
"use strict";
exports.addYears = addYears;
var _index = require("23e70a355800add9");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function addYears(date, amount) {
    return (0, _index.addMonths)(date, amount * 12);
}

},{"23e70a355800add9":"6cECY"}],"3zqev":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
exports.areIntervalsOverlapping = areIntervalsOverlapping;
var _index = require("2d76e30bb886efa");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    var _sort = (0, _slicedToArray._)([
        +(0, _index.toDate)(intervalLeft.start),
        +(0, _index.toDate)(intervalLeft.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), leftStartTime = _sort[0], leftEndTime = _sort[1];
    var _sort1 = (0, _slicedToArray._)([
        +(0, _index.toDate)(intervalRight.start),
        +(0, _index.toDate)(intervalRight.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), rightStartTime = _sort1[0], rightEndTime = _sort1[1];
    if (options === null || options === void 0 ? void 0 : options.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","2d76e30bb886efa":"eYsCJ"}],"4zP4x":[function(require,module,exports) {
"use strict";
exports.clamp = clamp;
var _index = require("8d0762524d7d24c3");
var _index2 = require("9daecf252ffff30");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function clamp(date, interval) {
    return (0, _index2.min)([
        (0, _index.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}

},{"8d0762524d7d24c3":"adXYY","9daecf252ffff30":"1K8Pj"}],"adXYY":[function(require,module,exports) {
"use strict";
exports.max = max;
var _index = require("f9ba4fa55e935c4f");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function max(dates) {
    var result;
    dates.forEach(function(dirtyDate) {
        var currentDate = (0, _index.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"f9ba4fa55e935c4f":"eYsCJ"}],"1K8Pj":[function(require,module,exports) {
"use strict";
exports.min = min;
var _index = require("940af7ed75f79352");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function min(dates) {
    var result;
    dates.forEach(function(dirtyDate) {
        var date = (0, _index.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

},{"940af7ed75f79352":"eYsCJ"}],"kZcjF":[function(require,module,exports) {
"use strict";
exports.closestIndexTo = closestIndexTo;
var _index = require("3196192380086bd1");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function closestIndexTo(dateToCompare, dates) {
    var date = (0, _index.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    var timeToCompare = date.getTime();
    var result;
    var minDistance;
    dates.forEach(function(dirtyDate, index) {
        var currentDate = (0, _index.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

},{"3196192380086bd1":"eYsCJ"}],"lFG4o":[function(require,module,exports) {
"use strict";
exports.closestTo = closestTo;
var _index = require("2129694b6ecff958");
var _index2 = require("f52f0bbca64b2801");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function closestTo(dateToCompare, dates) {
    var date = (0, _index2.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, _index.constructFrom)(dateToCompare, NaN);
    var timeToCompare = date.getTime();
    var result;
    var minDistance;
    dates.forEach(function(dirtyDate) {
        var currentDate = (0, _index2.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, _index.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

},{"2129694b6ecff958":"h2Biw","f52f0bbca64b2801":"eYsCJ"}],"aW36B":[function(require,module,exports) {
"use strict";
exports.compareAsc = compareAsc;
var _index = require("77d3d08d6b71c9bb");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function compareAsc(dateLeft, dateRight) {
    var _dateLeft = (0, _index.toDate)(dateLeft);
    var _dateRight = (0, _index.toDate)(dateRight);
    var diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"77d3d08d6b71c9bb":"eYsCJ"}],"9gXjy":[function(require,module,exports) {
"use strict";
exports.compareDesc = compareDesc;
var _index = require("989301f18cf866f6");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function compareDesc(dateLeft, dateRight) {
    var _dateLeft = (0, _index.toDate)(dateLeft);
    var _dateRight = (0, _index.toDate)(dateRight);
    var diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

},{"989301f18cf866f6":"eYsCJ"}],"frxr8":[function(require,module,exports) {
"use strict";
exports.constructNow = constructNow;
var _index = require("6e69866d52e4c885");
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function constructNow(date) {
    return (0, _index.constructFrom)(date, Date.now());
}

},{"6e69866d52e4c885":"h2Biw"}],"550kA":[function(require,module,exports) {
"use strict";
exports.daysToWeeks = daysToWeeks;
var _index = require("458db80672ef81c4");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function daysToWeeks(days) {
    var weeks = days / _index.daysInWeek;
    var result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"458db80672ef81c4":"fzK9Z"}],"2BCSg":[function(require,module,exports) {
"use strict";
exports.differenceInBusinessDays = differenceInBusinessDays;
var _index = require("ea3fe27b701c003c");
var _index2 = require("6f3a4a6076f75f84");
var _index3 = require("812333c7aacd1559");
var _index4 = require("d81b0b3e475edc9a");
var _index5 = require("a08b9b6aa91d4ca8");
var _index6 = require("14560170b9ef0dc7");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function differenceInBusinessDays(dateLeft, dateRight) {
    var _dateLeft = (0, _index6.toDate)(dateLeft);
    var _dateRight = (0, _index6.toDate)(dateRight);
    if (!(0, _index4.isValid)(_dateLeft) || !(0, _index4.isValid)(_dateRight)) return NaN;
    var calendarDifference = (0, _index2.differenceInCalendarDays)(_dateLeft, _dateRight);
    var sign = calendarDifference < 0 ? -1 : 1;
    var weeks = Math.trunc(calendarDifference / 7);
    var result = weeks * 5;
    _dateRight = (0, _index.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, _index3.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, _index5.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, _index.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"ea3fe27b701c003c":"4rfUY","6f3a4a6076f75f84":"6OksG","812333c7aacd1559":"hYihA","d81b0b3e475edc9a":"6Uhv0","a08b9b6aa91d4ca8":"dnDjk","14560170b9ef0dc7":"eYsCJ"}],"hYihA":[function(require,module,exports) {
"use strict";
exports.isSameDay = isSameDay;
var _index = require("404d3af83c6a3510");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function isSameDay(dateLeft, dateRight) {
    var dateLeftStartOfDay = (0, _index.startOfDay)(dateLeft);
    var dateRightStartOfDay = (0, _index.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

},{"404d3af83c6a3510":"5punH"}],"6Uhv0":[function(require,module,exports) {
"use strict";
exports.isValid = isValid;
var _index = require("187bc6a11beb8cf7");
var _index2 = require("fd0d651c7906f3f7");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function isValid(date) {
    if (!(0, _index.isDate)(date) && typeof date !== "number") return false;
    var _date = (0, _index2.toDate)(date);
    return !isNaN(Number(_date));
}

},{"187bc6a11beb8cf7":"byTCo","fd0d651c7906f3f7":"eYsCJ"}],"byTCo":[function(require,module,exports) {
"use strict";
exports.isDate = isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{}],"9R5oI":[function(require,module,exports) {
"use strict";
exports.differenceInCalendarISOWeekYears = differenceInCalendarISOWeekYears;
var _index = require("4eb2262692255916");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, _index.getISOWeekYear)(dateLeft) - (0, _index.getISOWeekYear)(dateRight);
}

},{"4eb2262692255916":"1RGyx"}],"e4vBk":[function(require,module,exports) {
"use strict";
exports.differenceInCalendarISOWeeks = differenceInCalendarISOWeeks;
var _index = require("e8e10057c2841ad2");
var _index2 = require("76e957d25fb54854");
var _index3 = require("28419d92c5150a1");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function differenceInCalendarISOWeeks(dateLeft, dateRight) {
    var startOfISOWeekLeft = (0, _index2.startOfISOWeek)(dateLeft);
    var startOfISOWeekRight = (0, _index2.startOfISOWeek)(dateRight);
    var timestampLeft = +startOfISOWeekLeft - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    var timestampRight = +startOfISOWeekRight - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / _index.millisecondsInWeek);
}

},{"e8e10057c2841ad2":"fzK9Z","76e957d25fb54854":"eVqaZ","28419d92c5150a1":"l494b"}],"aM2iH":[function(require,module,exports) {
"use strict";
exports.differenceInCalendarMonths = differenceInCalendarMonths;
var _index = require("34e2e1517bca82c6");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function differenceInCalendarMonths(dateLeft, dateRight) {
    var _dateLeft = (0, _index.toDate)(dateLeft);
    var _dateRight = (0, _index.toDate)(dateRight);
    var yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    var monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"34e2e1517bca82c6":"eYsCJ"}],"4hKRZ":[function(require,module,exports) {
"use strict";
exports.differenceInCalendarQuarters = differenceInCalendarQuarters;
var _index = require("12f69708f4660b9e");
var _index2 = require("58e123be031d7c1");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function differenceInCalendarQuarters(dateLeft, dateRight) {
    var _dateLeft = (0, _index2.toDate)(dateLeft);
    var _dateRight = (0, _index2.toDate)(dateRight);
    var yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    var quarterDiff = (0, _index.getQuarter)(_dateLeft) - (0, _index.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

},{"12f69708f4660b9e":"dEUoh","58e123be031d7c1":"eYsCJ"}],"dEUoh":[function(require,module,exports) {
"use strict";
exports.getQuarter = getQuarter;
var _index = require("ad58fc3c2407157b");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function getQuarter(date) {
    var _date = (0, _index.toDate)(date);
    var quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

},{"ad58fc3c2407157b":"eYsCJ"}],"dCDU2":[function(require,module,exports) {
"use strict";
exports.differenceInCalendarWeeks = differenceInCalendarWeeks;
var _index = require("979fbac2b02bbe0b");
var _index2 = require("902483a1e2e2edee");
var _index3 = require("2df47d81bbcabf9b");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function differenceInCalendarWeeks(dateLeft, dateRight, options) {
    var startOfWeekLeft = (0, _index2.startOfWeek)(dateLeft, options);
    var startOfWeekRight = (0, _index2.startOfWeek)(dateRight, options);
    var timestampLeft = +startOfWeekLeft - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    var timestampRight = +startOfWeekRight - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / _index.millisecondsInWeek);
}

},{"979fbac2b02bbe0b":"fzK9Z","902483a1e2e2edee":"1RQd2","2df47d81bbcabf9b":"l494b"}],"96JRi":[function(require,module,exports) {
"use strict";
exports.differenceInCalendarYears = differenceInCalendarYears;
var _index = require("9559183fd654047");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function differenceInCalendarYears(dateLeft, dateRight) {
    var _dateLeft = (0, _index.toDate)(dateLeft);
    var _dateRight = (0, _index.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

},{"9559183fd654047":"eYsCJ"}],"e8894":[function(require,module,exports) {
"use strict";
exports.differenceInDays = differenceInDays;
var _index = require("5c37c887163a278c");
var _index2 = require("9efbb8d3712b0f85");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function differenceInDays(dateLeft, dateRight) {
    var _dateLeft = (0, _index2.toDate)(dateLeft);
    var _dateRight = (0, _index2.toDate)(dateRight);
    var sign = compareLocalAsc(_dateLeft, _dateRight);
    var difference = Math.abs((0, _index.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(_dateLeft, _dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"5c37c887163a278c":"6OksG","9efbb8d3712b0f85":"eYsCJ"}],"1yEur":[function(require,module,exports) {
"use strict";
exports.differenceInHours = differenceInHours;
var _index = require("4dd5860fb0431182");
var _index2 = require("56aaea21c2c2ca02");
var _index3 = require("e5398dd549d98ad7");
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function differenceInHours(dateLeft, dateRight, options) {
    var diff = (0, _index3.differenceInMilliseconds)(dateLeft, dateRight) / _index2.millisecondsInHour;
    return (0, _index.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"4dd5860fb0431182":"8JXoo","56aaea21c2c2ca02":"fzK9Z","e5398dd549d98ad7":"bsCCI"}],"8JXoo":[function(require,module,exports) {
"use strict";
exports.getRoundingMethod = getRoundingMethod;
function getRoundingMethod(method) {
    return function(number) {
        var round = method ? Math[method] : Math.trunc;
        var result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

},{}],"bsCCI":[function(require,module,exports) {
"use strict";
exports.differenceInMilliseconds = differenceInMilliseconds;
var _index = require("8ec07446db1e8840");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, _index.toDate)(dateLeft) - +(0, _index.toDate)(dateRight);
}

},{"8ec07446db1e8840":"eYsCJ"}],"kM6bd":[function(require,module,exports) {
"use strict";
exports.differenceInISOWeekYears = differenceInISOWeekYears;
var _index = require("3478a3b03bc559c3");
var _index2 = require("217c0aa6a88937bf");
var _index3 = require("f385e83eefe5d06b");
var _index4 = require("7ed50186937b4ccf");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function differenceInISOWeekYears(dateLeft, dateRight) {
    var _dateLeft = (0, _index4.toDate)(dateLeft);
    var _dateRight = (0, _index4.toDate)(dateRight);
    var sign = (0, _index.compareAsc)(_dateLeft, _dateRight);
    var difference = Math.abs((0, _index2.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, _index3.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastISOWeekYearNotFull = Number((0, _index.compareAsc)(_dateLeft, _dateRight) === -sign);
    var result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"3478a3b03bc559c3":"aW36B","217c0aa6a88937bf":"9R5oI","f385e83eefe5d06b":"gmMbm","7ed50186937b4ccf":"eYsCJ"}],"gmMbm":[function(require,module,exports) {
"use strict";
exports.subISOWeekYears = subISOWeekYears;
var _index = require("3905690fe6f022ae");
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function subISOWeekYears(date, amount) {
    return (0, _index.addISOWeekYears)(date, -amount);
}

},{"3905690fe6f022ae":"31GOg"}],"cIsk3":[function(require,module,exports) {
"use strict";
exports.differenceInMinutes = differenceInMinutes;
var _index = require("28ce40c001fe7733");
var _index2 = require("4d59f4904ce4a6bf");
var _index3 = require("5cff05241f86c567");
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function differenceInMinutes(dateLeft, dateRight, options) {
    var diff = (0, _index3.differenceInMilliseconds)(dateLeft, dateRight) / _index2.millisecondsInMinute;
    return (0, _index.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"28ce40c001fe7733":"8JXoo","4d59f4904ce4a6bf":"fzK9Z","5cff05241f86c567":"bsCCI"}],"dRYs4":[function(require,module,exports) {
"use strict";
exports.differenceInMonths = differenceInMonths;
var _index = require("838b792ca9e8e9a9");
var _index2 = require("7cbbd162b316b88f");
var _index3 = require("7b8f4dc46ede6d38");
var _index4 = require("ea5c11a925493689");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function differenceInMonths(dateLeft, dateRight) {
    var _dateLeft = (0, _index4.toDate)(dateLeft);
    var _dateRight = (0, _index4.toDate)(dateRight);
    var sign = (0, _index.compareAsc)(_dateLeft, _dateRight);
    var difference = Math.abs((0, _index2.differenceInCalendarMonths)(_dateLeft, _dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, _index.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _index3.isLastDayOfMonth)((0, _index4.toDate)(dateLeft)) && difference === 1 && (0, _index.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"838b792ca9e8e9a9":"aW36B","7cbbd162b316b88f":"aM2iH","7b8f4dc46ede6d38":"94I6u","ea5c11a925493689":"eYsCJ"}],"94I6u":[function(require,module,exports) {
"use strict";
exports.isLastDayOfMonth = isLastDayOfMonth;
var _index = require("585928d6294ab972");
var _index2 = require("9da618b70e7537e6");
var _index3 = require("3d052479f78fcd0a");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function isLastDayOfMonth(date) {
    var _date = (0, _index3.toDate)(date);
    return +(0, _index.endOfDay)(_date) === +(0, _index2.endOfMonth)(_date);
}

},{"585928d6294ab972":"hrufR","9da618b70e7537e6":"hMsPJ","3d052479f78fcd0a":"eYsCJ"}],"hrufR":[function(require,module,exports) {
"use strict";
exports.endOfDay = endOfDay;
var _index = require("9462caeddacab7ba");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function endOfDay(date) {
    var _date = (0, _index.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"9462caeddacab7ba":"eYsCJ"}],"hMsPJ":[function(require,module,exports) {
"use strict";
exports.endOfMonth = endOfMonth;
var _index = require("4700e89a3c2bdc3a");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function endOfMonth(date) {
    var _date = (0, _index.toDate)(date);
    var month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"4700e89a3c2bdc3a":"eYsCJ"}],"1galj":[function(require,module,exports) {
"use strict";
exports.differenceInQuarters = differenceInQuarters;
var _index = require("ea003389a7c0a0c7");
var _index2 = require("65b8c31c2449132c");
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function differenceInQuarters(dateLeft, dateRight, options) {
    var diff = (0, _index2.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, _index.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"ea003389a7c0a0c7":"8JXoo","65b8c31c2449132c":"dRYs4"}],"f7XyR":[function(require,module,exports) {
"use strict";
exports.differenceInSeconds = differenceInSeconds;
var _index = require("bc308401ae80fd9e");
var _index2 = require("15eb048bf635cf19");
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function differenceInSeconds(dateLeft, dateRight, options) {
    var diff = (0, _index2.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, _index.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"bc308401ae80fd9e":"8JXoo","15eb048bf635cf19":"bsCCI"}],"4Pat4":[function(require,module,exports) {
"use strict";
exports.differenceInWeeks = differenceInWeeks;
var _index = require("1fd69438a343960a");
var _index2 = require("739c69993ece4a2d");
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function differenceInWeeks(dateLeft, dateRight, options) {
    var diff = (0, _index2.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, _index.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"1fd69438a343960a":"8JXoo","739c69993ece4a2d":"e8894"}],"4YOVD":[function(require,module,exports) {
"use strict";
exports.differenceInYears = differenceInYears;
var _index = require("26f69a00c42ae289");
var _index2 = require("a2b02090236814dd");
var _index3 = require("4c5b5f2534904213");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function differenceInYears(dateLeft, dateRight) {
    var _dateLeft = (0, _index3.toDate)(dateLeft);
    var _dateRight = (0, _index3.toDate)(dateRight);
    var sign = (0, _index.compareAsc)(_dateLeft, _dateRight);
    var difference = Math.abs((0, _index2.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, _index.compareAsc)(_dateLeft, _dateRight) === -sign;
    var result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"26f69a00c42ae289":"aW36B","a2b02090236814dd":"96JRi","4c5b5f2534904213":"eYsCJ"}],"jo01N":[function(require,module,exports) {
"use strict";
exports.eachDayOfInterval = eachDayOfInterval;
var _index = require("294c3ba44409e4b5");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function eachDayOfInterval(interval, options) {
    var startDate = (0, _index.toDate)(interval.start);
    var endDate = (0, _index.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _index.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}

},{"294c3ba44409e4b5":"eYsCJ"}],"aZkCM":[function(require,module,exports) {
"use strict";
exports.eachHourOfInterval = eachHourOfInterval;
var _index = require("3e3d97bee6e54fec");
var _index2 = require("70a05b1edbc49f28");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function eachHourOfInterval(interval, options) {
    var startDate = (0, _index2.toDate)(interval.start);
    var endDate = (0, _index2.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _index2.toDate)(currentDate));
        currentDate = (0, _index.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

},{"3e3d97bee6e54fec":"4nx75","70a05b1edbc49f28":"eYsCJ"}],"cern1":[function(require,module,exports) {
"use strict";
exports.eachMinuteOfInterval = eachMinuteOfInterval;
var _index = require("e92d00e5a4dade3b");
var _index2 = require("ecbbda7f50f7aaff");
var _index3 = require("92ed5a1225d7a241");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function eachMinuteOfInterval(interval, options) {
    var startDate = (0, _index2.startOfMinute)((0, _index3.toDate)(interval.start));
    var endDate = (0, _index3.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _index3.toDate)(currentDate));
        currentDate = (0, _index.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

},{"e92d00e5a4dade3b":"cxnKG","ecbbda7f50f7aaff":"lFp03","92ed5a1225d7a241":"eYsCJ"}],"lFp03":[function(require,module,exports) {
"use strict";
exports.startOfMinute = startOfMinute;
var _index = require("91f08d20edca7d8a");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function startOfMinute(date) {
    var _date = (0, _index.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}

},{"91f08d20edca7d8a":"eYsCJ"}],"gMzZg":[function(require,module,exports) {
"use strict";
exports.eachMonthOfInterval = eachMonthOfInterval;
var _index = require("3ff5dc84667641c0");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function eachMonthOfInterval(interval, options) {
    var startDate = (0, _index.toDate)(interval.start);
    var endDate = (0, _index.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _index.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

},{"3ff5dc84667641c0":"eYsCJ"}],"1YTKw":[function(require,module,exports) {
"use strict";
exports.eachQuarterOfInterval = eachQuarterOfInterval;
var _index = require("6cdb36513da4cc03");
var _index2 = require("a8f22af48dc25121");
var _index3 = require("8c1f502027539eb2");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function eachQuarterOfInterval(interval, options) {
    var startDate = (0, _index3.toDate)(interval.start);
    var endDate = (0, _index3.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +(0, _index2.startOfQuarter)(startDate) : +(0, _index2.startOfQuarter)(endDate);
    var currentDate = reversed ? (0, _index2.startOfQuarter)(endDate) : (0, _index2.startOfQuarter)(startDate);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _index3.toDate)(currentDate));
        currentDate = (0, _index.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

},{"6cdb36513da4cc03":"8P1Ro","a8f22af48dc25121":"auSUw","8c1f502027539eb2":"eYsCJ"}],"auSUw":[function(require,module,exports) {
"use strict";
exports.startOfQuarter = startOfQuarter;
var _index = require("e81484efabf21f26");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function startOfQuarter(date) {
    var _date = (0, _index.toDate)(date);
    var currentMonth = _date.getMonth();
    var month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"e81484efabf21f26":"eYsCJ"}],"14wIV":[function(require,module,exports) {
"use strict";
exports.eachWeekOfInterval = eachWeekOfInterval;
var _index = require("6e26efbcc307cb14");
var _index2 = require("244cdaa33af9b640");
var _index3 = require("bd21daa7da65e0eb");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function eachWeekOfInterval(interval, options) {
    var startDate = (0, _index3.toDate)(interval.start);
    var endDate = (0, _index3.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var startDateWeek = reversed ? (0, _index2.startOfWeek)(endDate, options) : (0, _index2.startOfWeek)(startDate, options);
    var endDateWeek = reversed ? (0, _index2.startOfWeek)(startDate, options) : (0, _index2.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    var endTime = +endDateWeek.getTime();
    var currentDate = startDateWeek;
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, _index3.toDate)(currentDate));
        currentDate = (0, _index.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}

},{"6e26efbcc307cb14":"jPvAg","244cdaa33af9b640":"1RQd2","bd21daa7da65e0eb":"eYsCJ"}],"1Hvjr":[function(require,module,exports) {
"use strict";
exports.eachWeekendOfInterval = eachWeekendOfInterval;
var _index = require("56a8ee095115973a");
var _index2 = require("311a5485dd7798b7");
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function eachWeekendOfInterval(interval) {
    var dateInterval = (0, _index.eachDayOfInterval)(interval);
    var weekends = [];
    var index = 0;
    while(index < dateInterval.length){
        var date = dateInterval[index++];
        if ((0, _index2.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}

},{"56a8ee095115973a":"jo01N","311a5485dd7798b7":"dnDjk"}],"fy1vF":[function(require,module,exports) {
"use strict";
exports.eachWeekendOfMonth = eachWeekendOfMonth;
var _index = require("d5fe08dd964c485c");
var _index2 = require("433b8f5e15395dd7");
var _index3 = require("c93c981052c9ccef");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function eachWeekendOfMonth(date) {
    var start = (0, _index3.startOfMonth)(date);
    var end = (0, _index2.endOfMonth)(date);
    return (0, _index.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

},{"d5fe08dd964c485c":"1Hvjr","433b8f5e15395dd7":"hMsPJ","c93c981052c9ccef":"mXmxs"}],"mXmxs":[function(require,module,exports) {
"use strict";
exports.startOfMonth = startOfMonth;
var _index = require("9b1ec7fb57278771");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfMonth(date) {
    var _date = (0, _index.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"9b1ec7fb57278771":"eYsCJ"}],"l1wr4":[function(require,module,exports) {
"use strict";
exports.eachWeekendOfYear = eachWeekendOfYear;
var _index = require("feb8e300bcf7957");
var _index2 = require("1449183f6fb1902a");
var _index3 = require("ab03b55fc28aacde");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function eachWeekendOfYear(date) {
    var start = (0, _index3.startOfYear)(date);
    var end = (0, _index2.endOfYear)(date);
    return (0, _index.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

},{"feb8e300bcf7957":"1Hvjr","1449183f6fb1902a":"gNh98","ab03b55fc28aacde":"kIE5G"}],"gNh98":[function(require,module,exports) {
"use strict";
exports.endOfYear = endOfYear;
var _index = require("bae33049518de779");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function endOfYear(date) {
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"bae33049518de779":"eYsCJ"}],"kIE5G":[function(require,module,exports) {
"use strict";
exports.startOfYear = startOfYear;
var _index = require("29a7a92b30a86c8c");
var _index2 = require("151cc5db30a5792f");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function startOfYear(date) {
    var cleanDate = (0, _index.toDate)(date);
    var _date = (0, _index2.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"29a7a92b30a86c8c":"eYsCJ","151cc5db30a5792f":"h2Biw"}],"bDviL":[function(require,module,exports) {
"use strict";
exports.eachYearOfInterval = eachYearOfInterval;
var _index = require("ce43d0e962faaa1c");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function eachYearOfInterval(interval, options) {
    var startDate = (0, _index.toDate)(interval.start);
    var endDate = (0, _index.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _index.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

},{"ce43d0e962faaa1c":"eYsCJ"}],"iE98M":[function(require,module,exports) {
"use strict";
exports.endOfDecade = endOfDecade;
var _index = require("c3f314059e7ed45");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    var decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"c3f314059e7ed45":"eYsCJ"}],"9drGd":[function(require,module,exports) {
"use strict";
exports.endOfHour = endOfHour;
var _index = require("559b27e6bd32f67a");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function endOfHour(date) {
    var _date = (0, _index.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}

},{"559b27e6bd32f67a":"eYsCJ"}],"jkwm4":[function(require,module,exports) {
"use strict";
exports.endOfISOWeek = endOfISOWeek;
var _index = require("32a570bab666f4f0");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function endOfISOWeek(date) {
    return (0, _index.endOfWeek)(date, {
        weekStartsOn: 1
    });
}

},{"32a570bab666f4f0":"9aLDB"}],"9aLDB":[function(require,module,exports) {
"use strict";
exports.endOfWeek = endOfWeek;
var _index = require("874b81e8096fd15b");
var _index2 = require("54c51a8f0276b53b");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function endOfWeek(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _index2.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _index.toDate)(date);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"874b81e8096fd15b":"eYsCJ","54c51a8f0276b53b":"ia1W9"}],"ilScE":[function(require,module,exports) {
"use strict";
exports.endOfISOWeekYear = endOfISOWeekYear;
var _index = require("fff5ebc46b4d3047");
var _index2 = require("1f630f53841125bd");
var _index3 = require("9bb8122951a915c3");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function endOfISOWeekYear(date) {
    var year = (0, _index.getISOWeekYear)(date);
    var fourthOfJanuaryOfNextYear = (0, _index3.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var _date = (0, _index2.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}

},{"fff5ebc46b4d3047":"1RGyx","1f630f53841125bd":"eVqaZ","9bb8122951a915c3":"h2Biw"}],"lq5Ng":[function(require,module,exports) {
"use strict";
exports.endOfMinute = endOfMinute;
var _index = require("61e892816ba65f75");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function endOfMinute(date) {
    var _date = (0, _index.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}

},{"61e892816ba65f75":"eYsCJ"}],"e8J9b":[function(require,module,exports) {
"use strict";
exports.endOfQuarter = endOfQuarter;
var _index = require("e4975d708a66315a");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function endOfQuarter(date) {
    var _date = (0, _index.toDate)(date);
    var currentMonth = _date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"e4975d708a66315a":"eYsCJ"}],"76GOg":[function(require,module,exports) {
"use strict";
exports.endOfSecond = endOfSecond;
var _index = require("abb2bf07f4049174");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function endOfSecond(date) {
    var _date = (0, _index.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}

},{"abb2bf07f4049174":"eYsCJ"}],"57VSA":[function(require,module,exports) {
"use strict";
exports.endOfToday = endOfToday;
var _index = require("4e7ecedb2c691b21");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function endOfToday() {
    return (0, _index.endOfDay)(Date.now());
}

},{"4e7ecedb2c691b21":"hrufR"}],"56hQW":[function(require,module,exports) {
"use strict";
exports.endOfTomorrow = endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function endOfTomorrow() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{}],"kk9sE":[function(require,module,exports) {
"use strict";
exports.endOfYesterday = endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function endOfYesterday() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{}],"jA8qR":[function(require,module,exports) {
"use strict";
exports.format = exports.formatDate = format;
Object.defineProperty(exports, "formatters", {
    enumerable: true,
    get: function get() {
        return _index3.formatters;
    }
});
Object.defineProperty(exports, "longFormatters", {
    enumerable: true,
    get: function get() {
        return _index4.longFormatters;
    }
});
var _index = require("7a797645e41ea2c2");
var _index2 = require("2ed033e42fc5189d");
var _index3 = require("e1935e40361258cf");
var _index4 = require("c46187c282bdd45");
var _index5 = require("7528fb990c5ee731");
var _index6 = require("8d66a13aebf60df9");
var _index7 = require("3b5edf3c2ddf1d76");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var defaultOptions = (0, _index2.getDefaultOptions)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.defaultLocale;
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    var originalDate = (0, _index7.toDate)(date);
    if (!(0, _index6.isValid)(originalDate)) throw new RangeError("Invalid time value");
    var parts = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = _index4.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: cleanEscapedString(substring)
        };
        if (_index3.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map(function(part) {
        if (!part.isToken) return part.value;
        var token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, _index5.isProtectedWeekYearToken)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, _index5.isProtectedDayOfYearToken)(token)) (0, _index5.warnOrThrowProtectedError)(token, formatStr, String(date));
        var formatter = _index3.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"7a797645e41ea2c2":"hyd8B","2ed033e42fc5189d":"ia1W9","e1935e40361258cf":"U7XAI","c46187c282bdd45":"c1u67","7528fb990c5ee731":"dAvxx","8d66a13aebf60df9":"6Uhv0","3b5edf3c2ddf1d76":"eYsCJ"}],"hyd8B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "defaultLocale", {
    enumerable: true,
    get: function get() {
        return _index.enUS;
    }
});
var _index = require("537dc8c80b85612c");

},{"537dc8c80b85612c":"84nSI"}],"84nSI":[function(require,module,exports) {
"use strict";
exports.enUS = void 0;
var _index = require("479d03a18c245c3e");
var _index2 = require("b9e3c763ad65c41a");
var _index3 = require("6451586d149703ed");
var _index4 = require("cbddf07e540dd382");
var _index5 = require("3002f8fbc231e7a1");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ var enUS = exports.enUS = {
    code: "en-US",
    formatDistance: _index.formatDistance,
    formatLong: _index2.formatLong,
    formatRelative: _index3.formatRelative,
    localize: _index4.localize,
    match: _index5.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

},{"479d03a18c245c3e":"6v6Oi","b9e3c763ad65c41a":"jCz6q","6451586d149703ed":"gTaPl","cbddf07e540dd382":"cmErR","3002f8fbc231e7a1":"1F7N8"}],"6v6Oi":[function(require,module,exports) {
"use strict";
exports.formatDistance = void 0;
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.formatDistance = formatDistance;

},{}],"jCz6q":[function(require,module,exports) {
"use strict";
exports.formatLong = void 0;
var _index = require("4800af73d892e7a");
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = exports.formatLong = {
    date: (0, _index.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _index.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _index.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"4800af73d892e7a":"jI7CM"}],"jI7CM":[function(require,module,exports) {
"use strict";
exports.buildFormatLongFn = buildFormatLongFn;
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{}],"gTaPl":[function(require,module,exports) {
"use strict";
exports.formatRelative = void 0;
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.formatRelative = formatRelative;

},{}],"cmErR":[function(require,module,exports) {
"use strict";
exports.localize = void 0;
var _index = require("78e7236a2f110627");
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = exports.localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _index.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _index.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _index.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _index.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _index.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"78e7236a2f110627":"bk5Lj"}],"bk5Lj":[function(require,module,exports) {
"use strict";
exports.buildLocalizeFn = buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function buildLocalizeFn(args) {
    return function(value, options) {
        var context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var defaultWidth1 = args.defaultWidth;
            var width1 = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width1] || args.values[defaultWidth1];
        }
        var index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{}],"1F7N8":[function(require,module,exports) {
"use strict";
exports.match = void 0;
var _index = require("befc9b9f4e6afb32");
var _index2 = require("be7528ef34a1226");
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = exports.match = {
    ordinalNumber: (0, _index2.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _index.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _index.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, _index.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _index.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _index.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"befc9b9f4e6afb32":"hT2rX","be7528ef34a1226":"ebfDf"}],"hT2rX":[function(require,module,exports) {
"use strict";
exports.buildMatchFn = buildMatchFn;
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{}],"ebfDf":[function(require,module,exports) {
"use strict";
exports.buildMatchPatternFn = buildMatchPatternFn;
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{}],"U7XAI":[function(require,module,exports) {
"use strict";
exports.formatters = void 0;
var _index = require("2b70b701cccd48ba");
var _index2 = require("ce71b00fa268a334");
var _index3 = require("be1f4bd5db98fc0b");
var _index4 = require("4d35ee8b95213cb2");
var _index5 = require("31a9b5233efbdb74");
var _index6 = require("c78164dd4be2dfdf");
var _index7 = require("c129443cf4e77b69");
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = exports.formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return _index7.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _index5.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _index6.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _index6.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _index3.getISOWeekYear)(date);
        // Padding
        return (0, _index6.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getFullYear();
        return (0, _index6.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _index6.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _index6.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return _index7.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _index6.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _index4.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _index6.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _index2.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _index6.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return _index7.lightFormatters.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _index.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _index6.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _index6.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _index6.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _index6.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return _index7.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return _index7.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return _index7.lightFormatters.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return _index7.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return _index7.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize) {
        var timestamp = Math.trunc(date.getTime() / 1000);
        return (0, _index6.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize) {
        var timestamp = date.getTime();
        return (0, _index6.addLeadingZeros)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.trunc(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _index6.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _index6.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _index6.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    var minutes = (0, _index6.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"2b70b701cccd48ba":"bowkl","ce71b00fa268a334":"9UpoQ","be1f4bd5db98fc0b":"1RGyx","4d35ee8b95213cb2":"eC1Ii","31a9b5233efbdb74":"j9b51","c78164dd4be2dfdf":"TLaSm","c129443cf4e77b69":"dMPPR"}],"bowkl":[function(require,module,exports) {
"use strict";
exports.getDayOfYear = getDayOfYear;
var _index = require("e4c17eecd713ff7a");
var _index2 = require("984c12d93b064944");
var _index3 = require("92e9542334495a7a");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function getDayOfYear(date) {
    var _date = (0, _index3.toDate)(date);
    var diff = (0, _index.differenceInCalendarDays)(_date, (0, _index2.startOfYear)(_date));
    var dayOfYear = diff + 1;
    return dayOfYear;
}

},{"e4c17eecd713ff7a":"6OksG","984c12d93b064944":"kIE5G","92e9542334495a7a":"eYsCJ"}],"9UpoQ":[function(require,module,exports) {
"use strict";
exports.getISOWeek = getISOWeek;
var _index = require("dd6520a678bb82fc");
var _index2 = require("4086029c683d4450");
var _index3 = require("5ae2977ff2643258");
var _index4 = require("e810a780c889259");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function getISOWeek(date) {
    var _date = (0, _index4.toDate)(date);
    var diff = +(0, _index2.startOfISOWeek)(_date) - +(0, _index3.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / _index.millisecondsInWeek) + 1;
}

},{"dd6520a678bb82fc":"fzK9Z","4086029c683d4450":"eVqaZ","5ae2977ff2643258":"gtCKK","e810a780c889259":"eYsCJ"}],"eC1Ii":[function(require,module,exports) {
"use strict";
exports.getWeek = getWeek;
var _index = require("800ec1a6edc498ae");
var _index2 = require("5469df090b94480b");
var _index3 = require("28ef936dfd692f02");
var _index4 = require("9206fd6ff40c35c");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function getWeek(date, options) {
    var _date = (0, _index4.toDate)(date);
    var diff = +(0, _index2.startOfWeek)(_date, options) - +(0, _index3.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / _index.millisecondsInWeek) + 1;
}

},{"800ec1a6edc498ae":"fzK9Z","5469df090b94480b":"1RQd2","28ef936dfd692f02":"9EOil","9206fd6ff40c35c":"eYsCJ"}],"9EOil":[function(require,module,exports) {
"use strict";
exports.startOfWeekYear = startOfWeekYear;
var _index = require("14264660eed87479");
var _index2 = require("ed79bb16479293f4");
var _index3 = require("6d62705f140db78b");
var _index4 = require("81264b991a2a077c");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function startOfWeekYear(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _index4.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var year = (0, _index2.getWeekYear)(date, options);
    var firstWeek = (0, _index.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var _date = (0, _index3.startOfWeek)(firstWeek, options);
    return _date;
}

},{"14264660eed87479":"h2Biw","ed79bb16479293f4":"j9b51","6d62705f140db78b":"1RQd2","81264b991a2a077c":"ia1W9"}],"j9b51":[function(require,module,exports) {
"use strict";
exports.getWeekYear = getWeekYear;
var _index = require("49bcd86a127941a3");
var _index2 = require("e4e186ff29cb44fa");
var _index3 = require("639f7e4c63562544");
var _index4 = require("cda7b6367e92badd");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function getWeekYear(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var _date = (0, _index3.toDate)(date);
    var year = _date.getFullYear();
    var defaultOptions = (0, _index4.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var firstWeekOfNextYear = (0, _index.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index2.startOfWeek)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = (0, _index.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index2.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"49bcd86a127941a3":"h2Biw","e4e186ff29cb44fa":"1RQd2","639f7e4c63562544":"eYsCJ","cda7b6367e92badd":"ia1W9"}],"TLaSm":[function(require,module,exports) {
"use strict";
exports.addLeadingZeros = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{}],"dMPPR":[function(require,module,exports) {
"use strict";
exports.lightFormatters = void 0;
var _index = require("90a72a8e36ccc405");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var lightFormatters = exports.lightFormatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _index.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, _index.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, _index.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, _index.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, _index.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, _index.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getMilliseconds();
        var fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"90a72a8e36ccc405":"TLaSm"}],"c1u67":[function(require,module,exports) {
"use strict";
exports.longFormatters = void 0;
var dateLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = exports.longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{}],"dAvxx":[function(require,module,exports) {
"use strict";
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.warnOrThrowProtectedError = warnOrThrowProtectedError;
var dayOfYearTokenRE = /^D+$/;
var weekYearTokenRE = /^Y+$/;
var throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    var _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    var subject = token[0] === "Y" ? "years" : "days of the month";
    return "Use `".concat(token.toLowerCase(), "` instead of `").concat(token, "` (in `").concat(format, "`) for formatting ").concat(subject, " to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md");
}

},{}],"gLY9a":[function(require,module,exports) {
"use strict";
exports.formatDistance = formatDistance;
var _index = require("76afd985fbd5e2f0");
var _index2 = require("21024a7a0ba671b5");
var _index3 = require("6be099d87c2941d5");
var _index4 = require("db428a4e351bfe8c");
var _index5 = require("e25628e46d5fa234");
var _index6 = require("25e8a16723332367");
var _index7 = require("e890155e5b3527ab");
var _index8 = require("a60baec803ff2cf8");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function formatDistance(date, baseDate, options) {
    var defaultOptions = (0, _index7.getDefaultOptions)();
    var _options_locale, _ref;
    var locale = (_ref = (_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index6.defaultLocale;
    var minutesInAlmostTwoDays = 2520;
    var comparison = (0, _index.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = Object.assign({}, options, {
        addSuffix: options === null || options === void 0 ? void 0 : options.addSuffix,
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, _index5.toDate)(baseDate);
        dateRight = (0, _index5.toDate)(date);
    } else {
        dateLeft = (0, _index5.toDate)(date);
        dateRight = (0, _index5.toDate)(baseDate);
    }
    var seconds = (0, _index4.differenceInSeconds)(dateRight, dateLeft);
    var offsetInSeconds = ((0, _index8.getTimezoneOffsetInMilliseconds)(dateRight) - (0, _index8.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options === null || options === void 0 ? void 0 : options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < _index2.minutesInDay) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < _index2.minutesInMonth) {
        var days = Math.round(minutes / _index2.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < _index2.minutesInMonth * 2) {
        months = Math.round(minutes / _index2.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, _index3.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / _index2.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

},{"76afd985fbd5e2f0":"aW36B","21024a7a0ba671b5":"fzK9Z","6be099d87c2941d5":"dRYs4","db428a4e351bfe8c":"f7XyR","e25628e46d5fa234":"eYsCJ","25e8a16723332367":"hyd8B","e890155e5b3527ab":"ia1W9","a60baec803ff2cf8":"l494b"}],"21kuU":[function(require,module,exports) {
"use strict";
exports.formatDistanceStrict = formatDistanceStrict;
var _index = require("77731e5dbddcf175");
var _index2 = require("20f92626a7750d09");
var _index3 = require("d0708329596583b6");
var _index4 = require("e63395a7a1926bcc");
var _index5 = require("ecf31216a9de7ed1");
var _index6 = require("be3762b050b26a12");
var _index7 = require("cda5e80a9a45c076");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function formatDistanceStrict(date, baseDate, options) {
    var defaultOptions = (0, _index2.getDefaultOptions)();
    var _options_locale, _ref;
    var locale = (_ref = (_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.defaultLocale;
    var comparison = (0, _index5.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = Object.assign({}, options, {
        addSuffix: options === null || options === void 0 ? void 0 : options.addSuffix,
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, _index7.toDate)(baseDate);
        dateRight = (0, _index7.toDate)(date);
    } else {
        dateLeft = (0, _index7.toDate)(date);
        dateRight = (0, _index7.toDate)(baseDate);
    }
    var _options_roundingMethod;
    var roundingMethod = (0, _index3.getRoundingMethod)((_options_roundingMethod = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options_roundingMethod !== void 0 ? _options_roundingMethod : "round");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / _index6.millisecondsInMinute;
    var timezoneOffset = (0, _index4.getTimezoneOffsetInMilliseconds)(dateRight) - (0, _index4.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / _index6.millisecondsInMinute;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < _index6.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < _index6.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < _index6.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        var seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        var roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        var hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        var days = roundingMethod(dstNormalizedMinutes / _index6.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        var months = roundingMethod(dstNormalizedMinutes / _index6.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        var years = roundingMethod(dstNormalizedMinutes / _index6.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}

},{"77731e5dbddcf175":"hyd8B","20f92626a7750d09":"ia1W9","d0708329596583b6":"8JXoo","e63395a7a1926bcc":"l494b","ecf31216a9de7ed1":"aW36B","be3762b050b26a12":"fzK9Z","cda5e80a9a45c076":"eYsCJ"}],"8udzM":[function(require,module,exports) {
"use strict";
exports.formatDistanceToNow = formatDistanceToNow;
var _index = require("cafde881e9f4b03c");
var _index2 = require("b74aefd5706bbd8c");
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function formatDistanceToNow(date, options) {
    return (0, _index2.formatDistance)(date, (0, _index.constructNow)(date), options);
}

},{"cafde881e9f4b03c":"frxr8","b74aefd5706bbd8c":"gLY9a"}],"knfYA":[function(require,module,exports) {
"use strict";
exports.formatDistanceToNowStrict = formatDistanceToNowStrict;
var _index = require("36ce334c2c1ca0b8");
var _index2 = require("21ad3b4fa8f4f584");
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function formatDistanceToNowStrict(date, options) {
    return (0, _index.formatDistanceStrict)(date, (0, _index2.constructNow)(date), options);
}

},{"36ce334c2c1ca0b8":"21kuU","21ad3b4fa8f4f584":"frxr8"}],"hUJPw":[function(require,module,exports) {
"use strict";
exports.formatDuration = formatDuration;
var _index = require("865c4fe9be22610");
var _index2 = require("4f29b112438dcac0");
/**
 * The {@link formatDuration} function options.
 */ var defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function formatDuration(duration, options) {
    var defaultOptions = (0, _index2.getDefaultOptions)();
    var _options_locale, _ref;
    var locale = (_ref = (_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.defaultLocale;
    var _options_format;
    var format = (_options_format = options === null || options === void 0 ? void 0 : options.format) !== null && _options_format !== void 0 ? _options_format : defaultFormat;
    var _options_zero;
    var zero = (_options_zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options_zero !== void 0 ? _options_zero : false;
    var _options_delimiter;
    var delimiter = (_options_delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options_delimiter !== void 0 ? _options_delimiter : " ";
    if (!locale.formatDistance) return "";
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

},{"865c4fe9be22610":"hyd8B","4f29b112438dcac0":"ia1W9"}],"8VCjU":[function(require,module,exports) {
"use strict";
exports.formatISO = formatISO;
var _index = require("6a44435540cefeea");
var _index2 = require("50b1943fc9f4c38");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function formatISO(date, options) {
    var _date = (0, _index.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    var _options_format;
    var format = (_options_format = options === null || options === void 0 ? void 0 : options.format) !== null && _options_format !== void 0 ? _options_format : "extended";
    var _options_representation;
    var representation = (_options_representation = options === null || options === void 0 ? void 0 : options.representation) !== null && _options_representation !== void 0 ? _options_representation : "complete";
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, _index2.addLeadingZeros)(_date.getDate(), 2);
        var month = (0, _index2.addLeadingZeros)(_date.getMonth() + 1, 2);
        var year = (0, _index2.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, _index2.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            var minuteOffset = (0, _index2.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, _index2.addLeadingZeros)(_date.getHours(), 2);
        var minute = (0, _index2.addLeadingZeros)(_date.getMinutes(), 2);
        var second = (0, _index2.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

},{"6a44435540cefeea":"eYsCJ","50b1943fc9f4c38":"TLaSm"}],"eejDq":[function(require,module,exports) {
"use strict";
exports.formatISO9075 = formatISO9075;
var _index = require("a53ff821fbf3766b");
var _index2 = require("7f4ae1d55b255987");
var _index3 = require("73a14fcf70d50fb2");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function formatISO9075(date, options) {
    var _date = (0, _index2.toDate)(date);
    if (!(0, _index.isValid)(_date)) throw new RangeError("Invalid time value");
    var _options_format;
    var format = (_options_format = options === null || options === void 0 ? void 0 : options.format) !== null && _options_format !== void 0 ? _options_format : "extended";
    var _options_representation;
    var representation = (_options_representation = options === null || options === void 0 ? void 0 : options.representation) !== null && _options_representation !== void 0 ? _options_representation : "complete";
    var result = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, _index3.addLeadingZeros)(_date.getDate(), 2);
        var month = (0, _index3.addLeadingZeros)(_date.getMonth() + 1, 2);
        var year = (0, _index3.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        var hour = (0, _index3.addLeadingZeros)(_date.getHours(), 2);
        var minute = (0, _index3.addLeadingZeros)(_date.getMinutes(), 2);
        var second = (0, _index3.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        var separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
    }
    return result;
}

},{"a53ff821fbf3766b":"6Uhv0","7f4ae1d55b255987":"eYsCJ","73a14fcf70d50fb2":"TLaSm"}],"kJ7Kp":[function(require,module,exports) {
"use strict";
exports.formatISODuration = formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function formatISODuration(duration) {
    var _duration_years = duration.years, years = _duration_years === void 0 ? 0 : _duration_years, _duration_months = duration.months, months = _duration_months === void 0 ? 0 : _duration_months, _duration_days = duration.days, days = _duration_days === void 0 ? 0 : _duration_days, _duration_hours = duration.hours, hours = _duration_hours === void 0 ? 0 : _duration_hours, _duration_minutes = duration.minutes, minutes = _duration_minutes === void 0 ? 0 : _duration_minutes, _duration_seconds = duration.seconds, seconds = _duration_seconds === void 0 ? 0 : _duration_seconds;
    return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
}

},{}],"xBI1j":[function(require,module,exports) {
"use strict";
exports.formatRFC3339 = formatRFC3339;
var _index = require("9301294447d1f95b");
var _index2 = require("40b9430b575cdc41");
var _index3 = require("de42c97ba518f921");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function formatRFC3339(date, options) {
    var _date = (0, _index2.toDate)(date);
    if (!(0, _index.isValid)(_date)) throw new RangeError("Invalid time value");
    var _options_fractionDigits;
    var fractionDigits = (_options_fractionDigits = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options_fractionDigits !== void 0 ? _options_fractionDigits : 0;
    var day = (0, _index3.addLeadingZeros)(_date.getDate(), 2);
    var month = (0, _index3.addLeadingZeros)(_date.getMonth() + 1, 2);
    var year = _date.getFullYear();
    var hour = (0, _index3.addLeadingZeros)(_date.getHours(), 2);
    var minute = (0, _index3.addLeadingZeros)(_date.getMinutes(), 2);
    var second = (0, _index3.addLeadingZeros)(_date.getSeconds(), 2);
    var fractionalSecond = "";
    if (fractionDigits > 0) {
        var milliseconds = _date.getMilliseconds();
        var fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, _index3.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    var offset = "";
    var tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        var absoluteOffset = Math.abs(tzOffset);
        var hourOffset = (0, _index3.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        var minuteOffset = (0, _index3.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        var sign = tzOffset < 0 ? "+" : "-";
        offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else offset = "Z";
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}

},{"9301294447d1f95b":"6Uhv0","40b9430b575cdc41":"eYsCJ","de42c97ba518f921":"TLaSm"}],"j5ivt":[function(require,module,exports) {
"use strict";
exports.formatRFC7231 = formatRFC7231;
var _index = require("80159fbf1f8ee7a1");
var _index2 = require("8dc509179adf5406");
var _index3 = require("aca1dc202b36cc1a");
var days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function formatRFC7231(date) {
    var _date = (0, _index2.toDate)(date);
    if (!(0, _index.isValid)(_date)) throw new RangeError("Invalid time value");
    var dayName = days[_date.getUTCDay()];
    var dayOfMonth = (0, _index3.addLeadingZeros)(_date.getUTCDate(), 2);
    var monthName = months[_date.getUTCMonth()];
    var year = _date.getUTCFullYear();
    var hour = (0, _index3.addLeadingZeros)(_date.getUTCHours(), 2);
    var minute = (0, _index3.addLeadingZeros)(_date.getUTCMinutes(), 2);
    var second = (0, _index3.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
}

},{"80159fbf1f8ee7a1":"6Uhv0","8dc509179adf5406":"eYsCJ","aca1dc202b36cc1a":"TLaSm"}],"2QHf2":[function(require,module,exports) {
"use strict";
exports.formatRelative = formatRelative;
var _index = require("3409df3deaea49ab");
var _index2 = require("96f9b723c8a0b63d");
var _index3 = require("13fa994e827979d5");
var _index4 = require("6aa8aa7a8956e8a1");
var _index5 = require("673378ca2fd31ed4");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function formatRelative(date, baseDate, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var _date = (0, _index3.toDate)(date);
    var _baseDate = (0, _index3.toDate)(baseDate);
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var _options_locale1, _ref;
    var locale = (_ref = (_options_locale1 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale1 !== void 0 ? _options_locale1 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index4.defaultLocale;
    var _options_weekStartsOn, _ref1, _ref2, _ref3;
    var weekStartsOn = (_ref3 = (_ref2 = (_ref1 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : 0;
    var diff = (0, _index.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    var token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    var formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, _index2.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

},{"3409df3deaea49ab":"6OksG","96f9b723c8a0b63d":"jA8qR","13fa994e827979d5":"eYsCJ","6aa8aa7a8956e8a1":"hyd8B","673378ca2fd31ed4":"ia1W9"}],"flnmM":[function(require,module,exports) {
"use strict";
exports.fromUnixTime = fromUnixTime;
var _index = require("b17c73af583a5f1e");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function fromUnixTime(unixTime) {
    return (0, _index.toDate)(unixTime * 1000);
}

},{"b17c73af583a5f1e":"eYsCJ"}],"g0pDX":[function(require,module,exports) {
"use strict";
exports.getDate = getDate;
var _index = require("99a30b597441916f");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function getDate(date) {
    var _date = (0, _index.toDate)(date);
    var dayOfMonth = _date.getDate();
    return dayOfMonth;
}

},{"99a30b597441916f":"eYsCJ"}],"fhUMA":[function(require,module,exports) {
"use strict";
exports.getDay = getDay;
var _index = require("74108f6e7f604e0c");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function getDay(date) {
    var _date = (0, _index.toDate)(date);
    var day = _date.getDay();
    return day;
}

},{"74108f6e7f604e0c":"eYsCJ"}],"3SopR":[function(require,module,exports) {
"use strict";
exports.getDaysInMonth = getDaysInMonth;
var _index = require("ce5d8149ab8c0adb");
var _index2 = require("160593c36b918fdc");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function getDaysInMonth(date) {
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    var monthIndex = _date.getMonth();
    var lastDayOfMonth = (0, _index2.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"ce5d8149ab8c0adb":"eYsCJ","160593c36b918fdc":"h2Biw"}],"dwXVU":[function(require,module,exports) {
"use strict";
exports.getDaysInYear = getDaysInYear;
var _index = require("275eab46cb701105");
var _index2 = require("f6dcd98ceb3f89a0");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function getDaysInYear(date) {
    var _date = (0, _index2.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, _index.isLeapYear)(_date) ? 366 : 365;
}

},{"275eab46cb701105":"1rDlJ","f6dcd98ceb3f89a0":"eYsCJ"}],"1rDlJ":[function(require,module,exports) {
"use strict";
exports.isLeapYear = isLeapYear;
var _index = require("1f2cd80e6083cd69");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function isLeapYear(date) {
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"1f2cd80e6083cd69":"eYsCJ"}],"1Cgn5":[function(require,module,exports) {
"use strict";
exports.getDecade = getDecade;
var _index = require("fe74f1dab16aabfd");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    var decade = Math.floor(year / 10) * 10;
    return decade;
}

},{"fe74f1dab16aabfd":"eYsCJ"}],"5rOze":[function(require,module,exports) {
"use strict";
exports.getDefaultOptions = getDefaultOptions;
var _index = require("4c8d0c918921978e");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function getDefaultOptions() {
    return Object.assign({}, (0, _index.getDefaultOptions)());
}

},{"4c8d0c918921978e":"ia1W9"}],"4Aywj":[function(require,module,exports) {
"use strict";
exports.getHours = getHours;
var _index = require("dd6beddad3762c0e");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function getHours(date) {
    var _date = (0, _index.toDate)(date);
    var hours = _date.getHours();
    return hours;
}

},{"dd6beddad3762c0e":"eYsCJ"}],"68be7":[function(require,module,exports) {
"use strict";
exports.getISODay = getISODay;
var _index = require("cc4dec4ab039fecc");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function getISODay(date) {
    var _date = (0, _index.toDate)(date);
    var day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

},{"cc4dec4ab039fecc":"eYsCJ"}],"g9N33":[function(require,module,exports) {
"use strict";
exports.getISOWeeksInYear = getISOWeeksInYear;
var _index = require("90fb06e2d0d5907e");
var _index2 = require("7e506b16fa621cd5");
var _index3 = require("bc85126805d4e6dd");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function getISOWeeksInYear(date) {
    var thisYear = (0, _index3.startOfISOWeekYear)(date);
    var nextYear = (0, _index3.startOfISOWeekYear)((0, _index.addWeeks)(thisYear, 60));
    var diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / _index2.millisecondsInWeek);
}

},{"90fb06e2d0d5907e":"jPvAg","7e506b16fa621cd5":"fzK9Z","bc85126805d4e6dd":"gtCKK"}],"eLGCf":[function(require,module,exports) {
"use strict";
exports.getMilliseconds = getMilliseconds;
var _index = require("d90c57ddf052ab34");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function getMilliseconds(date) {
    var _date = (0, _index.toDate)(date);
    var milliseconds = _date.getMilliseconds();
    return milliseconds;
}

},{"d90c57ddf052ab34":"eYsCJ"}],"bcMd7":[function(require,module,exports) {
"use strict";
exports.getMinutes = getMinutes;
var _index = require("942a2ec019737ce6");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function getMinutes(date) {
    var _date = (0, _index.toDate)(date);
    var minutes = _date.getMinutes();
    return minutes;
}

},{"942a2ec019737ce6":"eYsCJ"}],"8yLyg":[function(require,module,exports) {
"use strict";
exports.getMonth = getMonth;
var _index = require("72421b25c2b051d4");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function getMonth(date) {
    var _date = (0, _index.toDate)(date);
    var month = _date.getMonth();
    return month;
}

},{"72421b25c2b051d4":"eYsCJ"}],"9LhQ7":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
exports.getOverlappingDaysInIntervals = getOverlappingDaysInIntervals;
var _index = require("6933d52c426a98f2");
var _index2 = require("1bb45ca582d62a30");
var _index3 = require("557defd14b7a5bdb");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    var _sort = (0, _slicedToArray._)([
        +(0, _index3.toDate)(intervalLeft.start),
        +(0, _index3.toDate)(intervalLeft.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), leftStart = _sort[0], leftEnd = _sort[1];
    var _sort1 = (0, _slicedToArray._)([
        +(0, _index3.toDate)(intervalRight.start),
        +(0, _index3.toDate)(intervalRight.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), rightStart = _sort1[0], rightEnd = _sort1[1];
    // Prevent NaN result if intervals don't overlap at all.
    var isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    var overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    var left = overlapLeft - (0, _index.getTimezoneOffsetInMilliseconds)(overlapLeft);
    var overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    var right = overlapRight - (0, _index.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / _index2.millisecondsInDay);
}

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","6933d52c426a98f2":"l494b","1bb45ca582d62a30":"fzK9Z","557defd14b7a5bdb":"eYsCJ"}],"kpBnX":[function(require,module,exports) {
"use strict";
exports.getSeconds = getSeconds;
var _index = require("66e87215fb77615b");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function getSeconds(date) {
    var _date = (0, _index.toDate)(date);
    var seconds = _date.getSeconds();
    return seconds;
}

},{"66e87215fb77615b":"eYsCJ"}],"cHOKA":[function(require,module,exports) {
"use strict";
exports.getTime = getTime;
var _index = require("cdbfeffb1be44bad");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function getTime(date) {
    var _date = (0, _index.toDate)(date);
    var timestamp = _date.getTime();
    return timestamp;
}

},{"cdbfeffb1be44bad":"eYsCJ"}],"jG0oF":[function(require,module,exports) {
"use strict";
exports.getUnixTime = getUnixTime;
var _index = require("727af4f0a417140a");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function getUnixTime(date) {
    return Math.trunc(+(0, _index.toDate)(date) / 1000);
}

},{"727af4f0a417140a":"eYsCJ"}],"afLVo":[function(require,module,exports) {
"use strict";
exports.getWeekOfMonth = getWeekOfMonth;
var _index = require("e2f130fc886de9f1");
var _index2 = require("39bc8949ab4ed662");
var _index3 = require("8a37fb28123e5296");
var _index4 = require("53ea69d655b52576");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function getWeekOfMonth(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _index4.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var currentDayOfMonth = (0, _index.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    var startWeekDay = (0, _index2.getDay)((0, _index3.startOfMonth)(date));
    var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

},{"e2f130fc886de9f1":"g0pDX","39bc8949ab4ed662":"fhUMA","8a37fb28123e5296":"mXmxs","53ea69d655b52576":"ia1W9"}],"52u1y":[function(require,module,exports) {
"use strict";
exports.getWeeksInMonth = getWeeksInMonth;
var _index = require("2093bc780dc07818");
var _index2 = require("72a2b06dbcb4c199");
var _index3 = require("2b3482d506165a82");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function getWeeksInMonth(date, options) {
    return (0, _index.differenceInCalendarWeeks)((0, _index2.lastDayOfMonth)(date), (0, _index3.startOfMonth)(date), options) + 1;
}

},{"2093bc780dc07818":"dCDU2","72a2b06dbcb4c199":"2b0DW","2b3482d506165a82":"mXmxs"}],"2b0DW":[function(require,module,exports) {
"use strict";
exports.lastDayOfMonth = lastDayOfMonth;
var _index = require("ab42a2c6a54cb32e");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function lastDayOfMonth(date) {
    var _date = (0, _index.toDate)(date);
    var month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"ab42a2c6a54cb32e":"eYsCJ"}],"8xoTX":[function(require,module,exports) {
"use strict";
exports.getYear = getYear;
var _index = require("3a87a8c7949402ce");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function getYear(date) {
    return (0, _index.toDate)(date).getFullYear();
}

},{"3a87a8c7949402ce":"eYsCJ"}],"7ACxa":[function(require,module,exports) {
"use strict";
exports.hoursToMilliseconds = hoursToMilliseconds;
var _index = require("c6a2f11605eee1dc");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function hoursToMilliseconds(hours) {
    return Math.trunc(hours * _index.millisecondsInHour);
}

},{"c6a2f11605eee1dc":"fzK9Z"}],"3w42T":[function(require,module,exports) {
"use strict";
exports.hoursToMinutes = hoursToMinutes;
var _index = require("7806bd4b7c008d33");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function hoursToMinutes(hours) {
    return Math.trunc(hours * _index.minutesInHour);
}

},{"7806bd4b7c008d33":"fzK9Z"}],"4ZoCh":[function(require,module,exports) {
"use strict";
exports.hoursToSeconds = hoursToSeconds;
var _index = require("d13f2ce94270497");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function hoursToSeconds(hours) {
    return Math.trunc(hours * _index.secondsInHour);
}

},{"d13f2ce94270497":"fzK9Z"}],"h2HAt":[function(require,module,exports) {
"use strict";
exports.interval = interval;
var _index = require("1d1e2184a95f4bcb");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function interval(start, end, options) {
    var _start = (0, _index.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    var _end = (0, _index.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if ((options === null || options === void 0 ? void 0 : options.assertPositive) && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}

},{"1d1e2184a95f4bcb":"eYsCJ"}],"2Vaex":[function(require,module,exports) {
"use strict";
exports.intervalToDuration = intervalToDuration;
var _index = require("827ba40197711f17");
var _index2 = require("4670c3e5153a14f1");
var _index3 = require("4d89cf2304eec01b");
var _index4 = require("d4fa01e7bdf0d261");
var _index5 = require("c9ddd1dcdae84b00");
var _index6 = require("d480aeea2ed64577");
var _index7 = require("6a7ba40260a23b60");
var _index8 = require("b3b1015ee5b239ef");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function intervalToDuration(interval) {
    var start = (0, _index8.toDate)(interval.start);
    var end = (0, _index8.toDate)(interval.end);
    var duration = {};
    var years = (0, _index7.differenceInYears)(end, start);
    if (years) duration.years = years;
    var remainingMonths = (0, _index.add)(start, {
        years: duration.years
    });
    var months = (0, _index5.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    var remainingDays = (0, _index.add)(remainingMonths, {
        months: duration.months
    });
    var days = (0, _index2.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    var remainingHours = (0, _index.add)(remainingDays, {
        days: duration.days
    });
    var hours = (0, _index3.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    var remainingMinutes = (0, _index.add)(remainingHours, {
        hours: duration.hours
    });
    var minutes = (0, _index4.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    var remainingSeconds = (0, _index.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    var seconds = (0, _index6.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}

},{"827ba40197711f17":"clHFd","4670c3e5153a14f1":"e8894","4d89cf2304eec01b":"1yEur","d4fa01e7bdf0d261":"cIsk3","c9ddd1dcdae84b00":"dRYs4","d480aeea2ed64577":"f7XyR","6a7ba40260a23b60":"4YOVD","b3b1015ee5b239ef":"eYsCJ"}],"2I4C3":[function(require,module,exports) {
"use strict";
exports.intlFormat = intlFormat;
var _index = require("d534639a573fc6cf");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function intlFormat(date, formatOrLocale, localeOptions) {
    var formatOptions;
    if (isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions === null || localeOptions === void 0 ? void 0 : localeOptions.locale, formatOptions).format((0, _index.toDate)(date));
}
function isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}

},{"d534639a573fc6cf":"eYsCJ"}],"1wrtN":[function(require,module,exports) {
"use strict";
exports.intlFormatDistance = intlFormatDistance;
var _index = require("f683b56d8b54d7c3");
var _index2 = require("935f9cc6c5a9a358");
var _index3 = require("8a2925b448856fe2");
var _index4 = require("84a299c3d0590753");
var _index5 = require("b9bc0426e6224e82");
var _index6 = require("6742121b375dc4be");
var _index7 = require("c9619d002a71b38f");
var _index8 = require("15fe69ea99c7609f");
var _index9 = require("a52b9b370f1cb48f");
var _index10 = require("6058b1ebc4f00c8b");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function intlFormatDistance(date, baseDate, options) {
    var value = 0;
    var unit;
    var dateLeft = (0, _index10.toDate)(date);
    var dateRight = (0, _index10.toDate)(baseDate);
    if (!(options === null || options === void 0 ? void 0 : options.unit)) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        var diffInSeconds = (0, _index9.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < _index.secondsInMinute) {
            value = (0, _index9.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < _index.secondsInHour) {
            value = (0, _index8.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < _index.secondsInDay && Math.abs((0, _index2.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, _index7.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < _index.secondsInWeek && (value = (0, _index2.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < _index.secondsInMonth) {
            value = (0, _index5.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < _index.secondsInQuarter) {
            value = (0, _index3.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < _index.secondsInYear) {
            if ((0, _index4.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, _index4.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options === null || options === void 0 ? void 0 : options.unit;
        if (unit === "second") value = (0, _index9.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, _index8.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, _index7.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, _index2.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, _index5.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, _index3.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, _index4.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
    }
    var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
        localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
        numeric: (options === null || options === void 0 ? void 0 : options.numeric) || "auto",
        style: options === null || options === void 0 ? void 0 : options.style
    });
    return rtf.format(value, unit);
}

},{"f683b56d8b54d7c3":"fzK9Z","935f9cc6c5a9a358":"6OksG","8a2925b448856fe2":"aM2iH","84a299c3d0590753":"4hKRZ","b9bc0426e6224e82":"dCDU2","6742121b375dc4be":"96JRi","c9619d002a71b38f":"1yEur","15fe69ea99c7609f":"cIsk3","a52b9b370f1cb48f":"f7XyR","6058b1ebc4f00c8b":"eYsCJ"}],"fzng2":[function(require,module,exports) {
"use strict";
exports.isAfter = isAfter;
var _index = require("d53a6d6418b9cc58");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function isAfter(date, dateToCompare) {
    var _date = (0, _index.toDate)(date);
    var _dateToCompare = (0, _index.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

},{"d53a6d6418b9cc58":"eYsCJ"}],"a5u0o":[function(require,module,exports) {
"use strict";
exports.isBefore = isBefore;
var _index = require("29711cec40df889c");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function isBefore(date, dateToCompare) {
    var _date = (0, _index.toDate)(date);
    var _dateToCompare = (0, _index.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

},{"29711cec40df889c":"eYsCJ"}],"22cZO":[function(require,module,exports) {
"use strict";
exports.isEqual = isEqual;
var _index = require("b079eb760d97c297");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function isEqual(leftDate, rightDate) {
    var _dateLeft = (0, _index.toDate)(leftDate);
    var _dateRight = (0, _index.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

},{"b079eb760d97c297":"eYsCJ"}],"g1QYr":[function(require,module,exports) {
"use strict";
exports.isExists = isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function isExists(year, month, day) {
    var date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

},{}],"14MLt":[function(require,module,exports) {
"use strict";
exports.isFirstDayOfMonth = isFirstDayOfMonth;
var _index = require("e6a2c200e0f3bb19");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function isFirstDayOfMonth(date) {
    return (0, _index.toDate)(date).getDate() === 1;
}

},{"e6a2c200e0f3bb19":"eYsCJ"}],"hVX6E":[function(require,module,exports) {
"use strict";
exports.isFriday = isFriday;
var _index = require("a962d5285978468b");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function isFriday(date) {
    return (0, _index.toDate)(date).getDay() === 5;
}

},{"a962d5285978468b":"eYsCJ"}],"774cU":[function(require,module,exports) {
"use strict";
exports.isFuture = isFuture;
var _index = require("d167b947956d32f");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function isFuture(date) {
    return +(0, _index.toDate)(date) > Date.now();
}

},{"d167b947956d32f":"eYsCJ"}],"flQqx":[function(require,module,exports) {
"use strict";
exports.isMatch = isMatch;
var _index = require("ce558029b0f6cdc9");
var _index2 = require("20451a1a433763e7");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function isMatch(dateStr, formatStr, options) {
    return (0, _index.isValid)((0, _index2.parse)(dateStr, formatStr, new Date(), options));
}

},{"ce558029b0f6cdc9":"6Uhv0","20451a1a433763e7":"9HIBF"}],"9HIBF":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "longFormatters", {
    enumerable: true,
    get: function get() {
        return _index5.longFormatters;
    }
});
exports.parse = parse;
Object.defineProperty(exports, "parsers", {
    enumerable: true,
    get: function get() {
        return _index7.parsers;
    }
});
var _index = require("c53acb33da1787e9");
var _index2 = require("137ba7b89008c236");
var _index3 = require("2c4f28d92a378acf");
var _index4 = require("6071c86d3eb95bcf");
var _index5 = require("adb831f4e34cf8d0");
var _index6 = require("26eed989fb024afe");
var _index7 = require("8e4cd03974d82cc0");
var _Setter = require("264f22812daf122f");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function parse(dateStr, formatStr, referenceDate, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var defaultOptions = (0, _index2.getDefaultOptions)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index3.defaultLocale;
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, _index4.toDate)(referenceDate);
        else return (0, _index.constructFrom)(referenceDate, NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new _Setter.DateToSystemTimezoneSetter()
    ];
    var tokens = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in _index5.longFormatters) {
            var longFormatter = _index5.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var token = _step.value;
            if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, _index6.isProtectedWeekYearToken)(token)) (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
            if (!(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, _index6.isProtectedDayOfYearToken)(token)) (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
            var firstCharacter = token[0];
            var parser = _index7.parsers[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: (0, _index.constructFrom)(referenceDate, NaN)
                };
                setters.push(parseResult.setter);
                dateStr = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
                else return {
                    v: (0, _index.constructFrom)(referenceDate, NaN)
                };
            }
        };
        for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, _typeOf._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) return (0, _index.constructFrom)(referenceDate, NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _index4.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, _index.constructFrom)(referenceDate, NaN);
    var flags = {};
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = uniquePrioritySetters[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var setter = _step1.value;
            if (!setter.validate(date, subFnOptions)) return (0, _index.constructFrom)(referenceDate, NaN);
            var result = setter.set(date, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                date = result[0];
                Object.assign(flags, result[1]);
            // Result is date
            } else date = result;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return (0, _index.constructFrom)(referenceDate, date);
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@swc/helpers/_/_type_of":"60jEQ","c53acb33da1787e9":"h2Biw","137ba7b89008c236":"5rOze","2c4f28d92a378acf":"hyd8B","6071c86d3eb95bcf":"eYsCJ","adb831f4e34cf8d0":"c1u67","26eed989fb024afe":"dAvxx","8e4cd03974d82cc0":"5fEAb","264f22812daf122f":"41JFR"}],"5fEAb":[function(require,module,exports) {
"use strict";
exports.parsers = void 0;
var _EraParser = require("73877e75490bba35");
var _YearParser = require("534dbfd035c7afae");
var _LocalWeekYearParser = require("ab4450ec135364ae");
var _ISOWeekYearParser = require("85d23a44ac18532c");
var _ExtendedYearParser = require("179a88ef12f61a71");
var _QuarterParser = require("93232ed2f05ef2c3");
var _StandAloneQuarterParser = require("c7c6a63c21fda1ba");
var _MonthParser = require("9ccf03b202560527");
var _StandAloneMonthParser = require("250a7296cb9bd5d4");
var _LocalWeekParser = require("bcc281e24017fb49");
var _ISOWeekParser = require("b4a87b1ad452a0e8");
var _DateParser = require("ad6bc827b2f368e4");
var _DayOfYearParser = require("bb234ddd84c3b240");
var _DayParser = require("2d736796a40046e7");
var _LocalDayParser = require("f161fb5cee20fef5");
var _StandAloneLocalDayParser = require("3943fd5b7ea48b68");
var _ISODayParser = require("86ddbd54e3fa3dd2");
var _AMPMParser = require("b283318e653dbb40");
var _AMPMMidnightParser = require("d8c3b56df6ed7ec1");
var _DayPeriodParser = require("2c8f7cc10db4bdc2");
var _Hour1to12Parser = require("c7c3fbe3abdaa79c");
var _Hour0to23Parser = require("3a24c22368eeaf29");
var _Hour0To11Parser = require("7689b873a1aa23cf");
var _Hour1To24Parser = require("f2e24da70f1ce437");
var _MinuteParser = require("5b7be433eba9622a");
var _SecondParser = require("810daf17248738a9");
var _FractionOfSecondParser = require("7e5fdf1f35b534dd");
var _ISOTimezoneWithZParser = require("46cb8c323b79446f");
var _ISOTimezoneParser = require("1eeadf9bee6760d9");
var _TimestampSecondsParser = require("41f3d3eb54e297d3");
var _TimestampMillisecondsParser = require("85a0d4684faae6f7");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
var parsers = exports.parsers = {
    G: new _EraParser.EraParser(),
    y: new _YearParser.YearParser(),
    Y: new _LocalWeekYearParser.LocalWeekYearParser(),
    R: new _ISOWeekYearParser.ISOWeekYearParser(),
    u: new _ExtendedYearParser.ExtendedYearParser(),
    Q: new _QuarterParser.QuarterParser(),
    q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
    M: new _MonthParser.MonthParser(),
    L: new _StandAloneMonthParser.StandAloneMonthParser(),
    w: new _LocalWeekParser.LocalWeekParser(),
    I: new _ISOWeekParser.ISOWeekParser(),
    d: new _DateParser.DateParser(),
    D: new _DayOfYearParser.DayOfYearParser(),
    E: new _DayParser.DayParser(),
    e: new _LocalDayParser.LocalDayParser(),
    c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
    i: new _ISODayParser.ISODayParser(),
    a: new _AMPMParser.AMPMParser(),
    b: new _AMPMMidnightParser.AMPMMidnightParser(),
    B: new _DayPeriodParser.DayPeriodParser(),
    h: new _Hour1to12Parser.Hour1to12Parser(),
    H: new _Hour0to23Parser.Hour0to23Parser(),
    K: new _Hour0To11Parser.Hour0To11Parser(),
    k: new _Hour1To24Parser.Hour1To24Parser(),
    m: new _MinuteParser.MinuteParser(),
    s: new _SecondParser.SecondParser(),
    S: new _FractionOfSecondParser.FractionOfSecondParser(),
    X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
    x: new _ISOTimezoneParser.ISOTimezoneParser(),
    t: new _TimestampSecondsParser.TimestampSecondsParser(),
    T: new _TimestampMillisecondsParser.TimestampMillisecondsParser()
};

},{"73877e75490bba35":"87jYy","534dbfd035c7afae":"9Nz4k","ab4450ec135364ae":"20lKP","85d23a44ac18532c":"ijG8v","179a88ef12f61a71":"hUvU6","93232ed2f05ef2c3":"3PPT4","c7c6a63c21fda1ba":"b7LHU","9ccf03b202560527":"erdSo","250a7296cb9bd5d4":"g3iin","bcc281e24017fb49":"9hXi3","b4a87b1ad452a0e8":"j1ZzM","ad6bc827b2f368e4":"kuEOb","bb234ddd84c3b240":"10lnm","2d736796a40046e7":"4QBb7","f161fb5cee20fef5":"gzmgr","3943fd5b7ea48b68":"2mpqC","86ddbd54e3fa3dd2":"5uxgh","b283318e653dbb40":"gn5kS","d8c3b56df6ed7ec1":"7uRyy","2c8f7cc10db4bdc2":"e34PZ","c7c3fbe3abdaa79c":"23HIe","3a24c22368eeaf29":"ln6Mo","7689b873a1aa23cf":"a5wrZ","f2e24da70f1ce437":"9HxKY","5b7be433eba9622a":"4H0Hm","810daf17248738a9":"eCR15","7e5fdf1f35b534dd":"8oz3a","46cb8c323b79446f":"dNL9z","1eeadf9bee6760d9":"eaNE9","41f3d3eb54e297d3":"6Th0M","85a0d4684faae6f7":"18LMB"}],"87jYy":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.EraParser = void 0;
var _Parser = require("3b6644e454c96bd5");
var EraParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(EraParser, _Parser_Parser);
    var _super = (0, _createSuper._)(EraParser);
    function EraParser() {
        (0, _classCallCheck._)(this, EraParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 140);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setFullYear(value, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}(_Parser.Parser);
exports.EraParser = EraParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","3b6644e454c96bd5":"7gVcs"}],"7gVcs":[function(require,module,exports) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
"use strict";
exports.Parser = void 0;
var _Setter = require("f9ccbe426415522b");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheck._)(this, Parser);
    }
    (0, _createClass._)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new _Setter.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();
exports.Parser = Parser;

},{"@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","f9ccbe426415522b":"41JFR"}],"41JFR":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.ValueSetter = exports.Setter = exports.DateToSystemTimezoneSetter = void 0;
var _index = require("22daacd9886737df");
var _index2 = require("80c3b8dc52dd858");
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheck._)(this, Setter);
        (0, _defineProperty._)(this, "subPriority", 0);
    }
    (0, _createClass._)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
exports.Setter = Setter;
var ValueSetter = /*#__PURE__*/ function(Setter) {
    (0, _inherits._)(ValueSetter, Setter);
    var _super = (0, _createSuper._)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        (0, _classCallCheck._)(this, ValueSetter);
        var _this;
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClass._)(ValueSetter, [
        {
            key: "validate",
            value: function validate(date, options) {
                return this.validateValue(date, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(date, flags, options) {
                return this.setValue(date, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
exports.ValueSetter = ValueSetter;
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(Setter) {
    (0, _inherits._)(DateToSystemTimezoneSetter, Setter);
    var _super = (0, _createSuper._)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        (0, _classCallCheck._)(this, DateToSystemTimezoneSetter);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "subPriority", -1);
        return _this;
    }
    (0, _createClass._)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                return (0, _index2.constructFrom)(date, (0, _index.transpose)(date, Date));
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);
exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","22daacd9886737df":"hv6uH","80c3b8dc52dd858":"h2Biw"}],"hv6uH":[function(require,module,exports) {
"use strict";
exports.transpose = transpose;
var _index = require("e4cedfb3eb078b8e");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function transpose(fromDate, constructor) {
    var date = constructor instanceof Date ? (0, _index.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

},{"e4cedfb3eb078b8e":"h2Biw"}],"9Nz4k":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.YearParser = void 0;
var _Parser = require("410cdd8b24ffe202");
var _utils = require("feb431ad5324f1c2");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(YearParser, _Parser_Parser);
    var _super = (0, _createSuper._)(YearParser);
    function YearParser() {
        (0, _classCallCheck._)(this, YearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setFullYear(year, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}(_Parser.Parser);
exports.YearParser = YearParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","410cdd8b24ffe202":"7gVcs","feb431ad5324f1c2":"LSoJo"}],"LSoJo":[function(require,module,exports) {
"use strict";
exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
exports.isLeapYearIndex = isLeapYearIndex;
exports.mapValue = mapValue;
exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
exports.parseNDigits = parseNDigits;
exports.parseNDigitsSigned = parseNDigitsSigned;
exports.parseNumericPattern = parseNumericPattern;
exports.parseTimezonePattern = parseTimezonePattern;
var _index = require("730ab950da1e266b");
var _constants = require("be7ba8dce2178d09");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * _index.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern(_constants.numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern(_constants.numericPatterns.singleDigit, dateString);
        case 2:
            return parseNumericPattern(_constants.numericPatterns.twoDigits, dateString);
        case 3:
            return parseNumericPattern(_constants.numericPatterns.threeDigits, dateString);
        case 4:
            return parseNumericPattern(_constants.numericPatterns.fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern(_constants.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern(_constants.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern(_constants.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern(_constants.numericPatterns.fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"730ab950da1e266b":"fzK9Z","be7ba8dce2178d09":"klVnE"}],"klVnE":[function(require,module,exports) {
"use strict";
exports.timezonePatterns = exports.numericPatterns = void 0;
var numericPatterns = exports.numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = exports.timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{}],"20lKP":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.LocalWeekYearParser = void 0;
var _index = require("c7a1c4cdd11de749");
var _index2 = require("36ab983d3ac96e94");
var _Parser = require("2580105d5efe4503");
var _utils = require("e7bc0ea0bf35d979");
// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(LocalWeekYearParser, _Parser_Parser);
    var _super = (0, _createSuper._)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        (0, _classCallCheck._)(this, LocalWeekYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _index.getWeekYear)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setHours(0, 0, 0, 0);
                    return (0, _index2.startOfWeek)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setFullYear(year, 0, options.firstWeekContainsDate);
                date.setHours(0, 0, 0, 0);
                return (0, _index2.startOfWeek)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}(_Parser.Parser);
exports.LocalWeekYearParser = LocalWeekYearParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","c7a1c4cdd11de749":"j9b51","36ab983d3ac96e94":"1RQd2","2580105d5efe4503":"7gVcs","e7bc0ea0bf35d979":"LSoJo"}],"ijG8v":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.ISOWeekYearParser = void 0;
var _index = require("e78417787f8e8167");
var _index2 = require("ac68ccd301053769");
var _Parser = require("996e304581b01cde");
var _utils = require("338b9c7449577074");
// ISO week-numbering year
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(ISOWeekYearParser, _Parser_Parser);
    var _super = (0, _createSuper._)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        (0, _classCallCheck._)(this, ISOWeekYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utils.parseNDigitsSigned)(4, dateString);
                return (0, _utils.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var firstWeekOfYear = (0, _index2.constructFrom)(date, 0);
                firstWeekOfYear.setFullYear(value, 0, 4);
                firstWeekOfYear.setHours(0, 0, 0, 0);
                return (0, _index.startOfISOWeek)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}(_Parser.Parser);
exports.ISOWeekYearParser = ISOWeekYearParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","e78417787f8e8167":"eVqaZ","ac68ccd301053769":"h2Biw","996e304581b01cde":"7gVcs","338b9c7449577074":"LSoJo"}],"hUvU6":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.ExtendedYearParser = void 0;
var _Parser = require("14062af0868fbb7b");
var _utils = require("1b6df6d2682df22c");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(ExtendedYearParser, _Parser_Parser);
    var _super = (0, _createSuper._)(ExtendedYearParser);
    function ExtendedYearParser() {
        (0, _classCallCheck._)(this, ExtendedYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utils.parseNDigitsSigned)(4, dateString);
                return (0, _utils.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setFullYear(value, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}(_Parser.Parser);
exports.ExtendedYearParser = ExtendedYearParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","14062af0868fbb7b":"7gVcs","1b6df6d2682df22c":"LSoJo"}],"3PPT4":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.QuarterParser = void 0;
var _Parser = require("2c403512ee0b4449");
var _utils = require("16f449bb6db64ee7");
var QuarterParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(QuarterParser, _Parser_Parser);
    var _super = (0, _createSuper._)(QuarterParser);
    function QuarterParser() {
        (0, _classCallCheck._)(this, QuarterParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 120);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        return (0, _utils.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth((value - 1) * 3, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}(_Parser.Parser);
exports.QuarterParser = QuarterParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","2c403512ee0b4449":"7gVcs","16f449bb6db64ee7":"LSoJo"}],"b7LHU":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.StandAloneQuarterParser = void 0;
var _Parser = require("90bdba2189236368");
var _utils = require("ac5cbd54eec0970d");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(StandAloneQuarterParser, _Parser_Parser);
    var _super = (0, _createSuper._)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        (0, _classCallCheck._)(this, StandAloneQuarterParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 120);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        return (0, _utils.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth((value - 1) * 3, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}(_Parser.Parser);
exports.StandAloneQuarterParser = StandAloneQuarterParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","90bdba2189236368":"7gVcs","ac5cbd54eec0970d":"LSoJo"}],"erdSo":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.MonthParser = void 0;
var _constants = require("3ca19f0e27bab599");
var _Parser = require("3b0e5e45825bc96f");
var _utils = require("73c2131545335241");
var MonthParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(MonthParser, _Parser_Parser);
    var _super = (0, _createSuper._)(MonthParser);
    function MonthParser() {
        (0, _classCallCheck._)(this, MonthParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 110);
        return _this;
    }
    (0, _createClass._)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(value, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}(_Parser.Parser);
exports.MonthParser = MonthParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","3ca19f0e27bab599":"klVnE","3b0e5e45825bc96f":"7gVcs","73c2131545335241":"LSoJo"}],"g3iin":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.StandAloneMonthParser = void 0;
var _constants = require("98e1a06b2ff3c4de");
var _Parser = require("e11ccdcf59f2f7dd");
var _utils = require("e8b8449d7a3b60c1");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(StandAloneMonthParser, _Parser_Parser);
    var _super = (0, _createSuper._)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        (0, _classCallCheck._)(this, StandAloneMonthParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 110);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(value, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}(_Parser.Parser);
exports.StandAloneMonthParser = StandAloneMonthParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","98e1a06b2ff3c4de":"klVnE","e11ccdcf59f2f7dd":"7gVcs","e8b8449d7a3b60c1":"LSoJo"}],"9hXi3":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.LocalWeekParser = void 0;
var _index = require("13c2e2bf3016fdd5");
var _index2 = require("bbf7e0dcf711535f");
var _constants = require("2601195a0e99a978");
var _Parser = require("d6e7369fa8c2f278");
var _utils = require("1193e0f5bcd19001");
// Local week of year
var LocalWeekParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(LocalWeekParser, _Parser_Parser);
    var _super = (0, _createSuper._)(LocalWeekParser);
    function LocalWeekParser() {
        (0, _classCallCheck._)(this, LocalWeekParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 100);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _index2.startOfWeek)((0, _index.setWeek)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}(_Parser.Parser);
exports.LocalWeekParser = LocalWeekParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","13c2e2bf3016fdd5":"2f8OI","bbf7e0dcf711535f":"1RQd2","2601195a0e99a978":"klVnE","d6e7369fa8c2f278":"7gVcs","1193e0f5bcd19001":"LSoJo"}],"2f8OI":[function(require,module,exports) {
"use strict";
exports.setWeek = setWeek;
var _index = require("d61926e41e1e9dfc");
var _index2 = require("d8306f2d82e3f3b8");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function setWeek(date, week, options) {
    var _date = (0, _index2.toDate)(date);
    var diff = (0, _index.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

},{"d61926e41e1e9dfc":"eC1Ii","d8306f2d82e3f3b8":"eYsCJ"}],"j1ZzM":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.ISOWeekParser = void 0;
var _index = require("d0e9d8806b690ddf");
var _index2 = require("5eec22592445f1f4");
var _constants = require("1dcdea171de1c1d9");
var _Parser = require("3569999127d8de4");
var _utils = require("3c620a00554fc0c1");
// ISO week of year
var ISOWeekParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(ISOWeekParser, _Parser_Parser);
    var _super = (0, _createSuper._)(ISOWeekParser);
    function ISOWeekParser() {
        (0, _classCallCheck._)(this, ISOWeekParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 100);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _index2.startOfISOWeek)((0, _index.setISOWeek)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}(_Parser.Parser);
exports.ISOWeekParser = ISOWeekParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","d0e9d8806b690ddf":"kGwR1","5eec22592445f1f4":"eVqaZ","1dcdea171de1c1d9":"klVnE","3569999127d8de4":"7gVcs","3c620a00554fc0c1":"LSoJo"}],"kGwR1":[function(require,module,exports) {
"use strict";
exports.setISOWeek = setISOWeek;
var _index = require("8291d064c3f19d2b");
var _index2 = require("2a6c0f5e0da284fe");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function setISOWeek(date, week) {
    var _date = (0, _index2.toDate)(date);
    var diff = (0, _index.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

},{"8291d064c3f19d2b":"9UpoQ","2a6c0f5e0da284fe":"eYsCJ"}],"kuEOb":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.DateParser = void 0;
var _constants = require("e37bf0ec17405e58");
var _Parser = require("e06fd271e217a3f4");
var _utils = require("19b066b35011bfca");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
var DateParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(DateParser, _Parser_Parser);
    var _super = (0, _createSuper._)(DateParser);
    function DateParser() {
        (0, _classCallCheck._)(this, DateParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "subPriority", 1);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getFullYear();
                var isLeapYear = (0, _utils.isLeapYearIndex)(year);
                var month = date.getMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setDate(value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}(_Parser.Parser);
exports.DateParser = DateParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","e37bf0ec17405e58":"klVnE","e06fd271e217a3f4":"7gVcs","19b066b35011bfca":"LSoJo"}],"10lnm":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.DayOfYearParser = void 0;
var _constants = require("83fbe2027339aec5");
var _Parser = require("332eeceadb0ccc98");
var _utils = require("73a8ca34cfbb7597");
var DayOfYearParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(DayOfYearParser, _Parser_Parser);
    var _super = (0, _createSuper._)(DayOfYearParser);
    function DayOfYearParser() {
        (0, _classCallCheck._)(this, DayOfYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "subpriority", 1);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getFullYear();
                var isLeapYear = (0, _utils.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(0, value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}(_Parser.Parser);
exports.DayOfYearParser = DayOfYearParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","83fbe2027339aec5":"klVnE","332eeceadb0ccc98":"7gVcs","73a8ca34cfbb7597":"LSoJo"}],"4QBb7":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.DayParser = void 0;
var _index = require("b83dfcd67991d62c");
var _Parser = require("57319c0f2f714850");
// Day of week
var DayParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(DayParser, _Parser_Parser);
    var _super = (0, _createSuper._)(DayParser);
    function DayParser() {
        (0, _classCallCheck._)(this, DayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _index.setDay)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}(_Parser.Parser);
exports.DayParser = DayParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","b83dfcd67991d62c":"dBHh4","57319c0f2f714850":"7gVcs"}],"dBHh4":[function(require,module,exports) {
"use strict";
exports.setDay = setDay;
var _index = require("ea54a94a012b3b70");
var _index2 = require("e25634d79be71669");
var _index3 = require("10936b78e6318933");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function setDay(date, day, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _index3.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _index2.toDate)(date);
    var currentDay = _date.getDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var delta = 7 - weekStartsOn;
    var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, _index.addDays)(_date, diff);
}

},{"ea54a94a012b3b70":"4rfUY","e25634d79be71669":"eYsCJ","10936b78e6318933":"ia1W9"}],"gzmgr":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.LocalDayParser = void 0;
var _index = require("bb1b3f00c539097f");
var _Parser = require("6571efdf5566e23");
var _utils = require("59a554a051b6be38");
// Local day of week
var LocalDayParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(LocalDayParser, _Parser_Parser);
    var _super = (0, _createSuper._)(LocalDayParser);
    function LocalDayParser() {
        (0, _classCallCheck._)(this, LocalDayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function(value) {
                    // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _index.setDay)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}(_Parser.Parser);
exports.LocalDayParser = LocalDayParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","bb1b3f00c539097f":"dBHh4","6571efdf5566e23":"7gVcs","59a554a051b6be38":"LSoJo"}],"2mpqC":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.StandAloneLocalDayParser = void 0;
var _index = require("d9dbe8f35d194adf");
var _Parser = require("270cd8e0745b64ff");
var _utils = require("2894fe8ea24065ec");
// Stand-alone local day of week
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(StandAloneLocalDayParser, _Parser_Parser);
    var _super = (0, _createSuper._)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        (0, _classCallCheck._)(this, StandAloneLocalDayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function(value) {
                    // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _index.setDay)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}(_Parser.Parser);
exports.StandAloneLocalDayParser = StandAloneLocalDayParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","d9dbe8f35d194adf":"dBHh4","270cd8e0745b64ff":"7gVcs","2894fe8ea24065ec":"LSoJo"}],"5uxgh":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.ISODayParser = void 0;
var _index = require("8d5cfff7f7eb5ee5");
var _Parser = require("f0244744717726df");
var _utils = require("bf9b3cd7754e213e");
// ISO day of week
var ISODayParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(ISODayParser, _Parser_Parser);
    var _super = (0, _createSuper._)(ISODayParser);
    function ISODayParser() {
        (0, _classCallCheck._)(this, ISODayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        return (0, _utils.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utils.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utils.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utils.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utils.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _index.setISODay)(date, value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}(_Parser.Parser);
exports.ISODayParser = ISODayParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","8d5cfff7f7eb5ee5":"kXLgm","f0244744717726df":"7gVcs","bf9b3cd7754e213e":"LSoJo"}],"kXLgm":[function(require,module,exports) {
"use strict";
exports.setISODay = setISODay;
var _index = require("44745967f27ca3e1");
var _index2 = require("533ead4b5083b736");
var _index3 = require("3ceb9bffa1043609");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function setISODay(date, day) {
    var _date = (0, _index3.toDate)(date);
    var currentDay = (0, _index2.getISODay)(_date);
    var diff = day - currentDay;
    return (0, _index.addDays)(_date, diff);
}

},{"44745967f27ca3e1":"4rfUY","533ead4b5083b736":"68be7","3ceb9bffa1043609":"eYsCJ"}],"gn5kS":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.AMPMParser = void 0;
var _Parser = require("8a2e19df354a4acd");
var _utils = require("24e42863940456ae");
var AMPMParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(AMPMParser, _Parser_Parser);
    var _super = (0, _createSuper._)(AMPMParser);
    function AMPMParser() {
        (0, _classCallCheck._)(this, AMPMParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 80);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}(_Parser.Parser);
exports.AMPMParser = AMPMParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","8a2e19df354a4acd":"7gVcs","24e42863940456ae":"LSoJo"}],"7uRyy":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.AMPMMidnightParser = void 0;
var _Parser = require("4760f05ad38083c4");
var _utils = require("e542420b98b8b2fa");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(AMPMMidnightParser, _Parser_Parser);
    var _super = (0, _createSuper._)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        (0, _classCallCheck._)(this, AMPMMidnightParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 80);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}(_Parser.Parser);
exports.AMPMMidnightParser = AMPMMidnightParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","4760f05ad38083c4":"7gVcs","e542420b98b8b2fa":"LSoJo"}],"e34PZ":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.DayPeriodParser = void 0;
var _Parser = require("d445f4eb1b43afa9");
var _utils = require("5bc662f5d6a57c6");
// in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(DayPeriodParser, _Parser_Parser);
    var _super = (0, _createSuper._)(DayPeriodParser);
    function DayPeriodParser() {
        (0, _classCallCheck._)(this, DayPeriodParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 80);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}(_Parser.Parser);
exports.DayPeriodParser = DayPeriodParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","d445f4eb1b43afa9":"7gVcs","5bc662f5d6a57c6":"LSoJo"}],"23HIe":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.Hour1to12Parser = void 0;
var _constants = require("d7205af5d699aaaa");
var _Parser = require("72fa2cbc4fa1bbbf");
var _utils = require("554c03fdba31e004");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(Hour1to12Parser, _Parser_Parser);
    var _super = (0, _createSuper._)(Hour1to12Parser);
    function Hour1to12Parser() {
        (0, _classCallCheck._)(this, Hour1to12Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getHours() >= 12;
                if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
                else date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}(_Parser.Parser);
exports.Hour1to12Parser = Hour1to12Parser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","d7205af5d699aaaa":"klVnE","72fa2cbc4fa1bbbf":"7gVcs","554c03fdba31e004":"LSoJo"}],"ln6Mo":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.Hour0to23Parser = void 0;
var _constants = require("517fe295d5149361");
var _Parser = require("e9b40c7441c4ce4a");
var _utils = require("a8f3667076399d62");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(Hour0to23Parser, _Parser_Parser);
    var _super = (0, _createSuper._)(Hour0to23Parser);
    function Hour0to23Parser() {
        (0, _classCallCheck._)(this, Hour0to23Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}(_Parser.Parser);
exports.Hour0to23Parser = Hour0to23Parser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","517fe295d5149361":"klVnE","e9b40c7441c4ce4a":"7gVcs","a8f3667076399d62":"LSoJo"}],"a5wrZ":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.Hour0To11Parser = void 0;
var _constants = require("dc236b3b65dd7165");
var _Parser = require("110fa5ad724dd337");
var _utils = require("b31387bf6c98a135");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(Hour0To11Parser, _Parser_Parser);
    var _super = (0, _createSuper._)(Hour0To11Parser);
    function Hour0To11Parser() {
        (0, _classCallCheck._)(this, Hour0To11Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getHours() >= 12;
                if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
                else date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}(_Parser.Parser);
exports.Hour0To11Parser = Hour0To11Parser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","dc236b3b65dd7165":"klVnE","110fa5ad724dd337":"7gVcs","b31387bf6c98a135":"LSoJo"}],"9HxKY":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.Hour1To24Parser = void 0;
var _constants = require("8a98c953b97bd9d2");
var _Parser = require("1a7c1d02f575f2ef");
var _utils = require("c21199ad414d918f");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(Hour1To24Parser, _Parser_Parser);
    var _super = (0, _createSuper._)(Hour1To24Parser);
    function Hour1To24Parser() {
        (0, _classCallCheck._)(this, Hour1To24Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}(_Parser.Parser);
exports.Hour1To24Parser = Hour1To24Parser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","8a98c953b97bd9d2":"klVnE","1a7c1d02f575f2ef":"7gVcs","c21199ad414d918f":"LSoJo"}],"4H0Hm":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.MinuteParser = void 0;
var _constants = require("ebf9011e7838a79d");
var _Parser = require("4c8575a7116c3b84");
var _utils = require("e234fafa49de7d98");
var MinuteParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(MinuteParser, _Parser_Parser);
    var _super = (0, _createSuper._)(MinuteParser);
    function MinuteParser() {
        (0, _classCallCheck._)(this, MinuteParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 60);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}(_Parser.Parser);
exports.MinuteParser = MinuteParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","ebf9011e7838a79d":"klVnE","4c8575a7116c3b84":"7gVcs","e234fafa49de7d98":"LSoJo"}],"eCR15":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.SecondParser = void 0;
var _constants = require("7521dd0b4c1ed894");
var _Parser = require("6437b3e2aa607a12");
var _utils = require("c6865c0f9a49a776");
var SecondParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(SecondParser, _Parser_Parser);
    var _super = (0, _createSuper._)(SecondParser);
    function SecondParser() {
        (0, _classCallCheck._)(this, SecondParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 50);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utils.parseNumericPattern)(_constants.numericPatterns.second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utils.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}(_Parser.Parser);
exports.SecondParser = SecondParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","7521dd0b4c1ed894":"klVnE","6437b3e2aa607a12":"7gVcs","c6865c0f9a49a776":"LSoJo"}],"8oz3a":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.FractionOfSecondParser = void 0;
var _Parser = require("67c65f5bafa413a");
var _utils = require("150a83840d362903");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(FractionOfSecondParser, _Parser_Parser);
    var _super = (0, _createSuper._)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        (0, _classCallCheck._)(this, FractionOfSecondParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 30);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function(value) {
                    return Math.trunc(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}(_Parser.Parser);
exports.FractionOfSecondParser = FractionOfSecondParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","67c65f5bafa413a":"7gVcs","150a83840d362903":"LSoJo"}],"dNL9z":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.ISOTimezoneWithZParser = void 0;
var _index = require("368f4220a25e7374");
var _index2 = require("558ce65157f0e599");
var _constants = require("6a63e07f10f267b2");
var _Parser = require("ee66541a7458714a");
var _utils = require("e5626238686f2ba");
// Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(ISOTimezoneWithZParser, _Parser_Parser);
    var _super = (0, _createSuper._)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        (0, _classCallCheck._)(this, ISOTimezoneWithZParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 10);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
                    case "XXXX":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return (0, _index.constructFrom)(date, date.getTime() - (0, _index2.getTimezoneOffsetInMilliseconds)(date) - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}(_Parser.Parser);
exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","368f4220a25e7374":"h2Biw","558ce65157f0e599":"l494b","6a63e07f10f267b2":"klVnE","ee66541a7458714a":"7gVcs","e5626238686f2ba":"LSoJo"}],"eaNE9":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.ISOTimezoneParser = void 0;
var _index = require("20489a2406ed1f6");
var _index2 = require("7b0f4c2b6899a6a5");
var _constants = require("1da5ad1881c8c8be");
var _Parser = require("f83d1ed0441d94a4");
var _utils = require("3d4e56ba10e06f4a");
// Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(ISOTimezoneParser, _Parser_Parser);
    var _super = (0, _createSuper._)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        (0, _classCallCheck._)(this, ISOTimezoneParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 10);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
                    case "xxxx":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return (0, _index.constructFrom)(date, date.getTime() - (0, _index2.getTimezoneOffsetInMilliseconds)(date) - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}(_Parser.Parser);
exports.ISOTimezoneParser = ISOTimezoneParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","20489a2406ed1f6":"h2Biw","7b0f4c2b6899a6a5":"l494b","1da5ad1881c8c8be":"klVnE","f83d1ed0441d94a4":"7gVcs","3d4e56ba10e06f4a":"LSoJo"}],"6Th0M":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.TimestampSecondsParser = void 0;
var _index = require("d45a9a59d4c4a1fc");
var _Parser = require("e6a228a9048e0b92");
var _utils = require("1a8a5d87134d1ddc");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(TimestampSecondsParser, _Parser_Parser);
    var _super = (0, _createSuper._)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        (0, _classCallCheck._)(this, TimestampSecondsParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 40);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClass._)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utils.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return [
                    (0, _index.constructFrom)(date, value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}(_Parser.Parser);
exports.TimestampSecondsParser = TimestampSecondsParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","d45a9a59d4c4a1fc":"h2Biw","e6a228a9048e0b92":"7gVcs","1a8a5d87134d1ddc":"LSoJo"}],"18LMB":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
exports.TimestampMillisecondsParser = void 0;
var _index = require("de438b7eb6bce284");
var _Parser = require("ea4d3aab51a2471d");
var _utils = require("f77d6322d2335550");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser_Parser) {
    (0, _inherits._)(TimestampMillisecondsParser, _Parser_Parser);
    var _super = (0, _createSuper._)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        (0, _classCallCheck._)(this, TimestampMillisecondsParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 20);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClass._)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utils.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return [
                    (0, _index.constructFrom)(date, value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}(_Parser.Parser);
exports.TimestampMillisecondsParser = TimestampMillisecondsParser;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","de438b7eb6bce284":"h2Biw","ea4d3aab51a2471d":"7gVcs","f77d6322d2335550":"LSoJo"}],"ikEc3":[function(require,module,exports) {
"use strict";
exports.isMonday = isMonday;
var _index = require("4d45be3b46965d43");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function isMonday(date) {
    return (0, _index.toDate)(date).getDay() === 1;
}

},{"4d45be3b46965d43":"eYsCJ"}],"hVRiF":[function(require,module,exports) {
"use strict";
exports.isPast = isPast;
var _index = require("612cfa3e3a2e40bb");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function isPast(date) {
    return +(0, _index.toDate)(date) < Date.now();
}

},{"612cfa3e3a2e40bb":"eYsCJ"}],"5KIfx":[function(require,module,exports) {
"use strict";
exports.isSameHour = isSameHour;
var _index = require("92c6a40dfa7c3154");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function isSameHour(dateLeft, dateRight) {
    var dateLeftStartOfHour = (0, _index.startOfHour)(dateLeft);
    var dateRightStartOfHour = (0, _index.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

},{"92c6a40dfa7c3154":"gChCE"}],"gChCE":[function(require,module,exports) {
"use strict";
exports.startOfHour = startOfHour;
var _index = require("9638b175da3d3e66");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function startOfHour(date) {
    var _date = (0, _index.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

},{"9638b175da3d3e66":"eYsCJ"}],"d8tjq":[function(require,module,exports) {
"use strict";
exports.isSameISOWeek = isSameISOWeek;
var _index = require("7954406766bf5469");
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function isSameISOWeek(dateLeft, dateRight) {
    return (0, _index.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}

},{"7954406766bf5469":"kZUIU"}],"kZUIU":[function(require,module,exports) {
"use strict";
exports.isSameWeek = isSameWeek;
var _index = require("1599abc409fd1353");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function isSameWeek(dateLeft, dateRight, options) {
    var dateLeftStartOfWeek = (0, _index.startOfWeek)(dateLeft, options);
    var dateRightStartOfWeek = (0, _index.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

},{"1599abc409fd1353":"1RQd2"}],"lJniy":[function(require,module,exports) {
"use strict";
exports.isSameISOWeekYear = isSameISOWeekYear;
var _index = require("5a42f52d97607f01");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function isSameISOWeekYear(dateLeft, dateRight) {
    var dateLeftStartOfYear = (0, _index.startOfISOWeekYear)(dateLeft);
    var dateRightStartOfYear = (0, _index.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}

},{"5a42f52d97607f01":"gtCKK"}],"2wuYT":[function(require,module,exports) {
"use strict";
exports.isSameMinute = isSameMinute;
var _index = require("3bc0f134b347fe7b");
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function isSameMinute(dateLeft, dateRight) {
    var dateLeftStartOfMinute = (0, _index.startOfMinute)(dateLeft);
    var dateRightStartOfMinute = (0, _index.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

},{"3bc0f134b347fe7b":"lFp03"}],"6jB9O":[function(require,module,exports) {
"use strict";
exports.isSameMonth = isSameMonth;
var _index = require("23bd545f1d63f8a8");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function isSameMonth(dateLeft, dateRight) {
    var _dateLeft = (0, _index.toDate)(dateLeft);
    var _dateRight = (0, _index.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

},{"23bd545f1d63f8a8":"eYsCJ"}],"4MJIk":[function(require,module,exports) {
"use strict";
exports.isSameQuarter = isSameQuarter;
var _index = require("9629b8292d869723");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function isSameQuarter(dateLeft, dateRight) {
    var dateLeftStartOfQuarter = (0, _index.startOfQuarter)(dateLeft);
    var dateRightStartOfQuarter = (0, _index.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

},{"9629b8292d869723":"auSUw"}],"4iWSY":[function(require,module,exports) {
"use strict";
exports.isSameSecond = isSameSecond;
var _index = require("53999e672988f9a4");
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function isSameSecond(dateLeft, dateRight) {
    var dateLeftStartOfSecond = (0, _index.startOfSecond)(dateLeft);
    var dateRightStartOfSecond = (0, _index.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

},{"53999e672988f9a4":"9gNxQ"}],"9gNxQ":[function(require,module,exports) {
"use strict";
exports.startOfSecond = startOfSecond;
var _index = require("ac80d9695d08cfc2");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function startOfSecond(date) {
    var _date = (0, _index.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}

},{"ac80d9695d08cfc2":"eYsCJ"}],"eU6Ej":[function(require,module,exports) {
"use strict";
exports.isSameYear = isSameYear;
var _index = require("cf2635c669070340");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function isSameYear(dateLeft, dateRight) {
    var _dateLeft = (0, _index.toDate)(dateLeft);
    var _dateRight = (0, _index.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

},{"cf2635c669070340":"eYsCJ"}],"dhwJH":[function(require,module,exports) {
"use strict";
exports.isThisHour = isThisHour;
var _index = require("fa4f21cb15a9bfed");
var _index2 = require("7de0ff58b1d3a33e");
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function isThisHour(date) {
    return (0, _index2.isSameHour)(date, (0, _index.constructNow)(date));
}

},{"fa4f21cb15a9bfed":"frxr8","7de0ff58b1d3a33e":"5KIfx"}],"17dAn":[function(require,module,exports) {
"use strict";
exports.isThisISOWeek = isThisISOWeek;
var _index = require("7a8aac1d0eeb4b4");
var _index2 = require("24dea389c4f3208");
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function isThisISOWeek(date) {
    return (0, _index2.isSameISOWeek)(date, (0, _index.constructNow)(date));
}

},{"7a8aac1d0eeb4b4":"frxr8","24dea389c4f3208":"d8tjq"}],"brkny":[function(require,module,exports) {
"use strict";
exports.isThisMinute = isThisMinute;
var _index = require("c48e78d2aa3eb75a");
var _index2 = require("f2ca1a4c9ac3e09b");
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function isThisMinute(date) {
    return (0, _index2.isSameMinute)(date, (0, _index.constructNow)(date));
}

},{"c48e78d2aa3eb75a":"frxr8","f2ca1a4c9ac3e09b":"2wuYT"}],"5lizr":[function(require,module,exports) {
"use strict";
exports.isThisMonth = isThisMonth;
var _index = require("a0fcb49c79240b43");
var _index2 = require("dd3ba3f0986a5bca");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function isThisMonth(date) {
    return (0, _index2.isSameMonth)(date, (0, _index.constructNow)(date));
}

},{"a0fcb49c79240b43":"frxr8","dd3ba3f0986a5bca":"6jB9O"}],"c4j82":[function(require,module,exports) {
"use strict";
exports.isThisQuarter = isThisQuarter;
var _index = require("a80382a96a55ff43");
var _index2 = require("c5271e258f905e50");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function isThisQuarter(date) {
    return (0, _index2.isSameQuarter)(date, (0, _index.constructNow)(date));
}

},{"a80382a96a55ff43":"frxr8","c5271e258f905e50":"4MJIk"}],"5lYtr":[function(require,module,exports) {
"use strict";
exports.isThisSecond = isThisSecond;
var _index = require("d9fe14e9322b7992");
var _index2 = require("7a6df91b9bb7fd35");
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function isThisSecond(date) {
    return (0, _index2.isSameSecond)(date, (0, _index.constructNow)(date));
}

},{"d9fe14e9322b7992":"frxr8","7a6df91b9bb7fd35":"4iWSY"}],"Eu1MQ":[function(require,module,exports) {
"use strict";
exports.isThisWeek = isThisWeek;
var _index = require("997779426b9bab7f");
var _index2 = require("69c5a3fbdbf00c23");
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function isThisWeek(date, options) {
    return (0, _index2.isSameWeek)(date, (0, _index.constructNow)(date), options);
}

},{"997779426b9bab7f":"frxr8","69c5a3fbdbf00c23":"kZUIU"}],"9gMaA":[function(require,module,exports) {
"use strict";
exports.isThisYear = isThisYear;
var _index = require("34f43e8f14a40bff");
var _index2 = require("9f4e70430c882f21");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function isThisYear(date) {
    return (0, _index2.isSameYear)(date, (0, _index.constructNow)(date));
}

},{"34f43e8f14a40bff":"frxr8","9f4e70430c882f21":"eU6Ej"}],"3Fqpz":[function(require,module,exports) {
"use strict";
exports.isThursday = isThursday;
var _index = require("4459e1a3e1b1de53");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function isThursday(date) {
    return (0, _index.toDate)(date).getDay() === 4;
}

},{"4459e1a3e1b1de53":"eYsCJ"}],"gdtXT":[function(require,module,exports) {
"use strict";
exports.isToday = isToday;
var _index = require("426156d868cac4dc");
var _index2 = require("3eb372a0c18844be");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function isToday(date) {
    return (0, _index2.isSameDay)(date, (0, _index.constructNow)(date));
}

},{"426156d868cac4dc":"frxr8","3eb372a0c18844be":"hYihA"}],"5PznH":[function(require,module,exports) {
"use strict";
exports.isTomorrow = isTomorrow;
var _index = require("f1846e6b3d2dd7a9");
var _index2 = require("f636807af33fb01");
var _index3 = require("4ca5bd7eee26e325");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function isTomorrow(date) {
    return (0, _index3.isSameDay)(date, (0, _index.addDays)((0, _index2.constructNow)(date), 1));
}

},{"f1846e6b3d2dd7a9":"4rfUY","f636807af33fb01":"frxr8","4ca5bd7eee26e325":"hYihA"}],"j5jA2":[function(require,module,exports) {
"use strict";
exports.isTuesday = isTuesday;
var _index = require("c3ce837a6fb5ce78");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function isTuesday(date) {
    return (0, _index.toDate)(date).getDay() === 2;
}

},{"c3ce837a6fb5ce78":"eYsCJ"}],"aKlha":[function(require,module,exports) {
"use strict";
exports.isWednesday = isWednesday;
var _index = require("91710f6e1e58b24");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function isWednesday(date) {
    return (0, _index.toDate)(date).getDay() === 3;
}

},{"91710f6e1e58b24":"eYsCJ"}],"eHJvF":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
exports.isWithinInterval = isWithinInterval;
var _index = require("3b15ed0c3afb2c68");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function isWithinInterval(date, interval) {
    var time = +(0, _index.toDate)(date);
    var _sort = (0, _slicedToArray._)([
        +(0, _index.toDate)(interval.start),
        +(0, _index.toDate)(interval.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), startTime = _sort[0], endTime = _sort[1];
    return time >= startTime && time <= endTime;
}

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","3b15ed0c3afb2c68":"eYsCJ"}],"gd9Jf":[function(require,module,exports) {
"use strict";
exports.isYesterday = isYesterday;
var _index = require("a1b8ca9a4562c08d");
var _index2 = require("b3978a4bf227dee2");
var _index3 = require("cff81870f5b68f09");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function isYesterday(date) {
    return (0, _index2.isSameDay)(date, (0, _index3.subDays)((0, _index.constructNow)(date), 1));
}

},{"a1b8ca9a4562c08d":"frxr8","b3978a4bf227dee2":"hYihA","cff81870f5b68f09":"cvXrD"}],"cvXrD":[function(require,module,exports) {
"use strict";
exports.subDays = subDays;
var _index = require("e0eae9dbd8818809");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function subDays(date, amount) {
    return (0, _index.addDays)(date, -amount);
}

},{"e0eae9dbd8818809":"4rfUY"}],"5G7yh":[function(require,module,exports) {
"use strict";
exports.lastDayOfDecade = lastDayOfDecade;
var _index = require("19690e8c5b1cff89");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    var decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"19690e8c5b1cff89":"eYsCJ"}],"fs0KL":[function(require,module,exports) {
"use strict";
exports.lastDayOfISOWeek = lastDayOfISOWeek;
var _index = require("310c2c93bee18a1d");
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function lastDayOfISOWeek(date) {
    return (0, _index.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}

},{"310c2c93bee18a1d":"cGXyh"}],"cGXyh":[function(require,module,exports) {
"use strict";
exports.lastDayOfWeek = lastDayOfWeek;
var _index = require("f4ff98d39b69e8fb");
var _index2 = require("44532e3c32a807e3");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function lastDayOfWeek(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _index2.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _index.toDate)(date);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

},{"f4ff98d39b69e8fb":"eYsCJ","44532e3c32a807e3":"ia1W9"}],"fmVPw":[function(require,module,exports) {
"use strict";
exports.lastDayOfISOWeekYear = lastDayOfISOWeekYear;
var _index = require("6f2d40dbf0beeab9");
var _index2 = require("50638a52881c58b3");
var _index3 = require("c4a7659712beecae");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function lastDayOfISOWeekYear(date) {
    var year = (0, _index.getISOWeekYear)(date);
    var fourthOfJanuary = (0, _index3.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var _date = (0, _index2.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}

},{"6f2d40dbf0beeab9":"1RGyx","50638a52881c58b3":"eVqaZ","c4a7659712beecae":"h2Biw"}],"lsq9Q":[function(require,module,exports) {
"use strict";
exports.lastDayOfQuarter = lastDayOfQuarter;
var _index = require("ab0d585d78bebc2b");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function lastDayOfQuarter(date) {
    var _date = (0, _index.toDate)(date);
    var currentMonth = _date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"ab0d585d78bebc2b":"eYsCJ"}],"fiaCg":[function(require,module,exports) {
"use strict";
exports.lastDayOfYear = lastDayOfYear;
var _index = require("fc978c197d626874");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function lastDayOfYear(date) {
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"fc978c197d626874":"eYsCJ"}],"6TVlp":[function(require,module,exports) {
"use strict";
exports.lightFormat = lightFormat;
Object.defineProperty(exports, "lightFormatters", {
    enumerable: true,
    get: function get() {
        return _index3.lightFormatters;
    }
});
var _index = require("e6e1e54ff83d376f");
var _index2 = require("6dbbe26649931a76");
var _index3 = require("8c1cb87f7b9fb7dc");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function lightFormat(date, formatStr) {
    var _date = (0, _index2.toDate)(date);
    if (!(0, _index.isValid)(_date)) throw new RangeError("Invalid time value");
    var tokens = formatStr.match(formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    var result = tokens.map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = _index3.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matches = input.match(escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace(doubleQuoteRegExp, "'");
}

},{"e6e1e54ff83d376f":"6Uhv0","6dbbe26649931a76":"eYsCJ","8c1cb87f7b9fb7dc":"dMPPR"}],"dotyf":[function(require,module,exports) {
"use strict";
exports.milliseconds = milliseconds;
var _index = require("45cb8142d6d463ca");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function milliseconds(param) {
    var years = param.years, months = param.months, weeks = param.weeks, days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds;
    var totalDays = 0;
    if (years) totalDays += years * _index.daysInYear;
    if (months) totalDays += months * (_index.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    var totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}

},{"45cb8142d6d463ca":"fzK9Z"}],"chMjN":[function(require,module,exports) {
"use strict";
exports.millisecondsToHours = millisecondsToHours;
var _index = require("d1e90fa8b924dd35");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function millisecondsToHours(milliseconds) {
    var hours = milliseconds / _index.millisecondsInHour;
    return Math.trunc(hours);
}

},{"d1e90fa8b924dd35":"fzK9Z"}],"8o1Gx":[function(require,module,exports) {
"use strict";
exports.millisecondsToMinutes = millisecondsToMinutes;
var _index = require("5389415c189a3dc6");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function millisecondsToMinutes(milliseconds) {
    var minutes = milliseconds / _index.millisecondsInMinute;
    return Math.trunc(minutes);
}

},{"5389415c189a3dc6":"fzK9Z"}],"1X0t5":[function(require,module,exports) {
"use strict";
exports.millisecondsToSeconds = millisecondsToSeconds;
var _index = require("861d3d04ff9a07fa");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function millisecondsToSeconds(milliseconds) {
    var seconds = milliseconds / _index.millisecondsInSecond;
    return Math.trunc(seconds);
}

},{"861d3d04ff9a07fa":"fzK9Z"}],"iyuWF":[function(require,module,exports) {
"use strict";
exports.minutesToHours = minutesToHours;
var _index = require("b2279c5d7baaa4de");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function minutesToHours(minutes) {
    var hours = minutes / _index.minutesInHour;
    return Math.trunc(hours);
}

},{"b2279c5d7baaa4de":"fzK9Z"}],"f52Ug":[function(require,module,exports) {
"use strict";
exports.minutesToMilliseconds = minutesToMilliseconds;
var _index = require("63cd685f54f399ba");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * _index.millisecondsInMinute);
}

},{"63cd685f54f399ba":"fzK9Z"}],"bWKPR":[function(require,module,exports) {
"use strict";
exports.minutesToSeconds = minutesToSeconds;
var _index = require("46501645cea7f36c");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function minutesToSeconds(minutes) {
    return Math.trunc(minutes * _index.secondsInMinute);
}

},{"46501645cea7f36c":"fzK9Z"}],"9BQAc":[function(require,module,exports) {
"use strict";
exports.monthsToQuarters = monthsToQuarters;
var _index = require("66be799395f33ad6");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function monthsToQuarters(months) {
    var quarters = months / _index.monthsInQuarter;
    return Math.trunc(quarters);
}

},{"66be799395f33ad6":"fzK9Z"}],"kpjWe":[function(require,module,exports) {
"use strict";
exports.monthsToYears = monthsToYears;
var _index = require("4aa74b8bb4072671");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function monthsToYears(months) {
    var years = months / _index.monthsInYear;
    return Math.trunc(years);
}

},{"4aa74b8bb4072671":"fzK9Z"}],"l5xGl":[function(require,module,exports) {
"use strict";
exports.nextDay = nextDay;
var _index = require("ca24a3f0389dc83e");
var _index2 = require("69b65fb7d3c29c5e");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function nextDay(date, day) {
    var delta = day - (0, _index2.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, _index.addDays)(date, delta);
}

},{"ca24a3f0389dc83e":"4rfUY","69b65fb7d3c29c5e":"fhUMA"}],"loOti":[function(require,module,exports) {
"use strict";
exports.nextFriday = nextFriday;
var _index = require("f9faac43a000efc1");
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function nextFriday(date) {
    return (0, _index.nextDay)(date, 5);
}

},{"f9faac43a000efc1":"l5xGl"}],"4P73Z":[function(require,module,exports) {
"use strict";
exports.nextMonday = nextMonday;
var _index = require("ce06f84d344dedae");
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function nextMonday(date) {
    return (0, _index.nextDay)(date, 1);
}

},{"ce06f84d344dedae":"l5xGl"}],"dwTYx":[function(require,module,exports) {
"use strict";
exports.nextSaturday = nextSaturday;
var _index = require("8c6693c27a70e211");
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function nextSaturday(date) {
    return (0, _index.nextDay)(date, 6);
}

},{"8c6693c27a70e211":"l5xGl"}],"ectON":[function(require,module,exports) {
"use strict";
exports.nextSunday = nextSunday;
var _index = require("a0d35069d4e97420");
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function nextSunday(date) {
    return (0, _index.nextDay)(date, 0);
}

},{"a0d35069d4e97420":"l5xGl"}],"klwaG":[function(require,module,exports) {
"use strict";
exports.nextThursday = nextThursday;
var _index = require("8312401f2830d3fd");
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function nextThursday(date) {
    return (0, _index.nextDay)(date, 4);
}

},{"8312401f2830d3fd":"l5xGl"}],"kZXv4":[function(require,module,exports) {
"use strict";
exports.nextTuesday = nextTuesday;
var _index = require("a2f85d404caa8de7");
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function nextTuesday(date) {
    return (0, _index.nextDay)(date, 2);
}

},{"a2f85d404caa8de7":"l5xGl"}],"7qfmK":[function(require,module,exports) {
"use strict";
exports.nextWednesday = nextWednesday;
var _index = require("3e112ee16fcb6127");
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function nextWednesday(date) {
    return (0, _index.nextDay)(date, 3);
}

},{"3e112ee16fcb6127":"l5xGl"}],"iAstl":[function(require,module,exports) {
"use strict";
exports.parseISO = parseISO;
var _index = require("1a2fdaf01fdda35e");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function parseISO(argument, options) {
    var _options_additionalDigits;
    var additionalDigits = (_options_additionalDigits = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options_additionalDigits !== void 0 ? _options_additionalDigits : 2;
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"1a2fdaf01fdda35e":"fzK9Z"}],"kfjX0":[function(require,module,exports) {
"use strict";
exports.parseJSON = parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function parseJSON(dateStr) {
    var parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}

},{}],"bLZlL":[function(require,module,exports) {
"use strict";
exports.previousDay = previousDay;
var _index = require("6bcf4fe96e3a047");
var _index2 = require("b4986229d0d7b311");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function previousDay(date, day) {
    var delta = (0, _index.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, _index2.subDays)(date, delta);
}

},{"6bcf4fe96e3a047":"fhUMA","b4986229d0d7b311":"cvXrD"}],"7NBAW":[function(require,module,exports) {
"use strict";
exports.previousFriday = previousFriday;
var _index = require("5712eb87dec2ab5c");
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function previousFriday(date) {
    return (0, _index.previousDay)(date, 5);
}

},{"5712eb87dec2ab5c":"bLZlL"}],"d5XXa":[function(require,module,exports) {
"use strict";
exports.previousMonday = previousMonday;
var _index = require("254280db49759fbc");
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function previousMonday(date) {
    return (0, _index.previousDay)(date, 1);
}

},{"254280db49759fbc":"bLZlL"}],"dzqEZ":[function(require,module,exports) {
"use strict";
exports.previousSaturday = previousSaturday;
var _index = require("5e091e090aa006e5");
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function previousSaturday(date) {
    return (0, _index.previousDay)(date, 6);
}

},{"5e091e090aa006e5":"bLZlL"}],"ahJLV":[function(require,module,exports) {
"use strict";
exports.previousSunday = previousSunday;
var _index = require("753c79621f212dff");
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function previousSunday(date) {
    return (0, _index.previousDay)(date, 0);
}

},{"753c79621f212dff":"bLZlL"}],"65s9I":[function(require,module,exports) {
"use strict";
exports.previousThursday = previousThursday;
var _index = require("42407c55b7bd4cf3");
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function previousThursday(date) {
    return (0, _index.previousDay)(date, 4);
}

},{"42407c55b7bd4cf3":"bLZlL"}],"cMaup":[function(require,module,exports) {
"use strict";
exports.previousTuesday = previousTuesday;
var _index = require("888458f94f4d3ea4");
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function previousTuesday(date) {
    return (0, _index.previousDay)(date, 2);
}

},{"888458f94f4d3ea4":"bLZlL"}],"fFZCm":[function(require,module,exports) {
"use strict";
exports.previousWednesday = previousWednesday;
var _index = require("266acb1a1ae85529");
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function previousWednesday(date) {
    return (0, _index.previousDay)(date, 3);
}

},{"266acb1a1ae85529":"bLZlL"}],"diaKm":[function(require,module,exports) {
"use strict";
exports.quartersToMonths = quartersToMonths;
var _index = require("581e6077138d352b");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function quartersToMonths(quarters) {
    return Math.trunc(quarters * _index.monthsInQuarter);
}

},{"581e6077138d352b":"fzK9Z"}],"ahOCa":[function(require,module,exports) {
"use strict";
exports.quartersToYears = quartersToYears;
var _index = require("99a6c61d70a5ffad");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function quartersToYears(quarters) {
    var years = quarters / _index.quartersInYear;
    return Math.trunc(years);
}

},{"99a6c61d70a5ffad":"fzK9Z"}],"lQMbZ":[function(require,module,exports) {
"use strict";
exports.roundToNearestHours = roundToNearestHours;
var _index = require("86cee0e670018ac9");
var _index2 = require("23a7f1ab170cbf3a");
var _index3 = require("ac9a0cfc2939eac2");
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function roundToNearestHours(date, options) {
    var _options_nearestTo;
    var nearestTo = (_options_nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options_nearestTo !== void 0 ? _options_nearestTo : 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, _index2.constructFrom)(date, NaN);
    var _date = (0, _index3.toDate)(date);
    var fractionalMinutes = _date.getMinutes() / 60;
    var fractionalSeconds = _date.getSeconds() / 60 / 60;
    var fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    var hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    var _options_roundingMethod;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    var method = (_options_roundingMethod = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options_roundingMethod !== void 0 ? _options_roundingMethod : "round";
    var roundingMethod = (0, _index.getRoundingMethod)(method);
    // nearestTo option does not care daylight savings time
    var roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    var result = (0, _index2.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}

},{"86cee0e670018ac9":"8JXoo","23a7f1ab170cbf3a":"h2Biw","ac9a0cfc2939eac2":"eYsCJ"}],"6iRsb":[function(require,module,exports) {
"use strict";
exports.roundToNearestMinutes = roundToNearestMinutes;
var _index = require("156e571ea44e5631");
var _index2 = require("5f4467c863d899fa");
var _index3 = require("7ecafedd8c00c003");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function roundToNearestMinutes(date, options) {
    var _options_nearestTo;
    var nearestTo = (_options_nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options_nearestTo !== void 0 ? _options_nearestTo : 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, _index2.constructFrom)(date, NaN);
    var _date = (0, _index3.toDate)(date);
    var fractionalSeconds = _date.getSeconds() / 60;
    var fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    var minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    var _options_roundingMethod;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    var method = (_options_roundingMethod = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options_roundingMethod !== void 0 ? _options_roundingMethod : "round";
    var roundingMethod = (0, _index.getRoundingMethod)(method);
    var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    var result = (0, _index2.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}

},{"156e571ea44e5631":"8JXoo","5f4467c863d899fa":"h2Biw","7ecafedd8c00c003":"eYsCJ"}],"lf96Z":[function(require,module,exports) {
"use strict";
exports.secondsToHours = secondsToHours;
var _index = require("3fef9b731b720044");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function secondsToHours(seconds) {
    var hours = seconds / _index.secondsInHour;
    return Math.trunc(hours);
}

},{"3fef9b731b720044":"fzK9Z"}],"bLZci":[function(require,module,exports) {
"use strict";
exports.secondsToMilliseconds = secondsToMilliseconds;
var _index = require("a1974d1c766dbebe");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function secondsToMilliseconds(seconds) {
    return seconds * _index.millisecondsInSecond;
}

},{"a1974d1c766dbebe":"fzK9Z"}],"31TR2":[function(require,module,exports) {
"use strict";
exports.secondsToMinutes = secondsToMinutes;
var _index = require("88b262a06d5f2130");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function secondsToMinutes(seconds) {
    var minutes = seconds / _index.secondsInMinute;
    return Math.trunc(minutes);
}

},{"88b262a06d5f2130":"fzK9Z"}],"pVQn8":[function(require,module,exports) {
"use strict";
exports.set = set;
var _index = require("8ebda6aa298e3dce");
var _index2 = require("3a1600af3eb7d0e3");
var _index3 = require("1d29904d7d38b6d3");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function set(date, values) {
    var _date = (0, _index3.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, _index.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, _index2.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

},{"8ebda6aa298e3dce":"h2Biw","3a1600af3eb7d0e3":"bbmV7","1d29904d7d38b6d3":"eYsCJ"}],"bbmV7":[function(require,module,exports) {
"use strict";
exports.setMonth = setMonth;
var _index = require("389800ba113a4b05");
var _index2 = require("c6d3e16f0e9f2d5d");
var _index3 = require("3008df466d06f93a");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function setMonth(date, month) {
    var _date = (0, _index3.toDate)(date);
    var year = _date.getFullYear();
    var day = _date.getDate();
    var dateWithDesiredMonth = (0, _index.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _index2.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

},{"389800ba113a4b05":"h2Biw","c6d3e16f0e9f2d5d":"3SopR","3008df466d06f93a":"eYsCJ"}],"73krW":[function(require,module,exports) {
"use strict";
exports.setDate = setDate;
var _index = require("7057dcd16ee8e373");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function setDate(date, dayOfMonth) {
    var _date = (0, _index.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

},{"7057dcd16ee8e373":"eYsCJ"}],"adMXB":[function(require,module,exports) {
"use strict";
exports.setDayOfYear = setDayOfYear;
var _index = require("c0941b4402ad59f2");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function setDayOfYear(date, dayOfYear) {
    var _date = (0, _index.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}

},{"c0941b4402ad59f2":"eYsCJ"}],"hYlD5":[function(require,module,exports) {
"use strict";
exports.setDefaultOptions = setDefaultOptions;
var _index = require("62255328988484e4");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function setDefaultOptions(options) {
    var result = {};
    var defaultOptions = (0, _index.getDefaultOptions)();
    for(var property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(var property1 in options)if (Object.prototype.hasOwnProperty.call(options, property1)) {
        if (options[property1] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property1];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property1] = options[property1];
    }
    (0, _index.setDefaultOptions)(result);
}

},{"62255328988484e4":"ia1W9"}],"3JkVP":[function(require,module,exports) {
"use strict";
exports.setHours = setHours;
var _index = require("1d11a257f15355a4");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function setHours(date, hours) {
    var _date = (0, _index.toDate)(date);
    _date.setHours(hours);
    return _date;
}

},{"1d11a257f15355a4":"eYsCJ"}],"iA2vh":[function(require,module,exports) {
"use strict";
exports.setMilliseconds = setMilliseconds;
var _index = require("b10f979f8cdab20a");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function setMilliseconds(date, milliseconds) {
    var _date = (0, _index.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

},{"b10f979f8cdab20a":"eYsCJ"}],"kPhzA":[function(require,module,exports) {
"use strict";
exports.setMinutes = setMinutes;
var _index = require("1f70a54677cb46ac");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function setMinutes(date, minutes) {
    var _date = (0, _index.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

},{"1f70a54677cb46ac":"eYsCJ"}],"ciD3Y":[function(require,module,exports) {
"use strict";
exports.setQuarter = setQuarter;
var _index = require("f4776e1074765e6a");
var _index2 = require("f757c8c551ce95c6");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function setQuarter(date, quarter) {
    var _date = (0, _index2.toDate)(date);
    var oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, _index.setMonth)(_date, _date.getMonth() + diff * 3);
}

},{"f4776e1074765e6a":"bbmV7","f757c8c551ce95c6":"eYsCJ"}],"kIitV":[function(require,module,exports) {
"use strict";
exports.setSeconds = setSeconds;
var _index = require("d2223da5fd81400f");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function setSeconds(date, seconds) {
    var _date = (0, _index.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

},{"d2223da5fd81400f":"eYsCJ"}],"kRqwS":[function(require,module,exports) {
"use strict";
exports.setWeekYear = setWeekYear;
var _index = require("892a4f6cbe4a4851");
var _index2 = require("a4760182880db22");
var _index3 = require("68ff92802fcb77db");
var _index4 = require("7450ee1debfdb61");
var _index5 = require("78c425fb7620dd8");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function setWeekYear(date, weekYear, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var _date = (0, _index4.toDate)(date);
    var diff = (0, _index2.differenceInCalendarDays)(_date, (0, _index3.startOfWeekYear)(_date, options));
    var firstWeek = (0, _index.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, _index3.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

},{"892a4f6cbe4a4851":"h2Biw","a4760182880db22":"6OksG","68ff92802fcb77db":"9EOil","7450ee1debfdb61":"eYsCJ","78c425fb7620dd8":"ia1W9"}],"jwmnN":[function(require,module,exports) {
"use strict";
exports.setYear = setYear;
var _index = require("7614d9b80a22fd43");
var _index2 = require("6c1bb22d849e1125");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function setYear(date, year) {
    var _date = (0, _index2.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, _index.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

},{"7614d9b80a22fd43":"h2Biw","6c1bb22d849e1125":"eYsCJ"}],"a1sR6":[function(require,module,exports) {
"use strict";
exports.startOfDecade = startOfDecade;
var _index = require("510fc86ca3ee446c");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _index.toDate)(date);
    var year = _date.getFullYear();
    var decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"510fc86ca3ee446c":"eYsCJ"}],"dIHGv":[function(require,module,exports) {
"use strict";
exports.startOfToday = startOfToday;
var _index = require("4ec5e387631c3390");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function startOfToday() {
    return (0, _index.startOfDay)(Date.now());
}

},{"4ec5e387631c3390":"5punH"}],"jx4TE":[function(require,module,exports) {
"use strict";
exports.startOfTomorrow = startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function startOfTomorrow() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{}],"2V5uy":[function(require,module,exports) {
"use strict";
exports.startOfYesterday = startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function startOfYesterday() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{}],"1R6hN":[function(require,module,exports) {
"use strict";
exports.sub = sub;
var _index = require("91c2f90d56fdcf39");
var _index2 = require("e9fb52a14c73dacb");
var _index3 = require("ebf995b47bb3f8a4");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function sub(date, duration) {
    var _duration_years = duration.years, years = _duration_years === void 0 ? 0 : _duration_years, _duration_months = duration.months, months = _duration_months === void 0 ? 0 : _duration_months, _duration_weeks = duration.weeks, weeks = _duration_weeks === void 0 ? 0 : _duration_weeks, _duration_days = duration.days, days = _duration_days === void 0 ? 0 : _duration_days, _duration_hours = duration.hours, hours = _duration_hours === void 0 ? 0 : _duration_hours, _duration_minutes = duration.minutes, minutes = _duration_minutes === void 0 ? 0 : _duration_minutes, _duration_seconds = duration.seconds, seconds = _duration_seconds === void 0 ? 0 : _duration_seconds;
    // Subtract years and months
    var dateWithoutMonths = (0, _index2.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    var dateWithoutDays = (0, _index.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = (0, _index3.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

},{"91c2f90d56fdcf39":"cvXrD","e9fb52a14c73dacb":"lGAwE","ebf995b47bb3f8a4":"h2Biw"}],"lGAwE":[function(require,module,exports) {
"use strict";
exports.subMonths = subMonths;
var _index = require("fbb42da1293ae3b8");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function subMonths(date, amount) {
    return (0, _index.addMonths)(date, -amount);
}

},{"fbb42da1293ae3b8":"6cECY"}],"hV3Jl":[function(require,module,exports) {
"use strict";
exports.subBusinessDays = subBusinessDays;
var _index = require("8df6a7f983f79fd5");
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function subBusinessDays(date, amount) {
    return (0, _index.addBusinessDays)(date, -amount);
}

},{"8df6a7f983f79fd5":"3jaq5"}],"233sn":[function(require,module,exports) {
"use strict";
exports.subHours = subHours;
var _index = require("ebad1bf9dc571fa6");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function subHours(date, amount) {
    return (0, _index.addHours)(date, -amount);
}

},{"ebad1bf9dc571fa6":"4nx75"}],"annNy":[function(require,module,exports) {
"use strict";
exports.subMilliseconds = subMilliseconds;
var _index = require("7c01aad93387710b");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function subMilliseconds(date, amount) {
    return (0, _index.addMilliseconds)(date, -amount);
}

},{"7c01aad93387710b":"6Kk2d"}],"aFAQA":[function(require,module,exports) {
"use strict";
exports.subMinutes = subMinutes;
var _index = require("fd037b7c11707977");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function subMinutes(date, amount) {
    return (0, _index.addMinutes)(date, -amount);
}

},{"fd037b7c11707977":"cxnKG"}],"ez0sQ":[function(require,module,exports) {
"use strict";
exports.subQuarters = subQuarters;
var _index = require("86570987ed766639");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function subQuarters(date, amount) {
    return (0, _index.addQuarters)(date, -amount);
}

},{"86570987ed766639":"8P1Ro"}],"4fGt6":[function(require,module,exports) {
"use strict";
exports.subSeconds = subSeconds;
var _index = require("2550c81d2c438461");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function subSeconds(date, amount) {
    return (0, _index.addSeconds)(date, -amount);
}

},{"2550c81d2c438461":"qV0t6"}],"gxXpH":[function(require,module,exports) {
"use strict";
exports.subWeeks = subWeeks;
var _index = require("cd59f83469fafb63");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function subWeeks(date, amount) {
    return (0, _index.addWeeks)(date, -amount);
}

},{"cd59f83469fafb63":"jPvAg"}],"91P4k":[function(require,module,exports) {
"use strict";
exports.subYears = subYears;
var _index = require("324b48dd502ccac0");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function subYears(date, amount) {
    return (0, _index.addYears)(date, -amount);
}

},{"324b48dd502ccac0":"fDVF0"}],"ewYHa":[function(require,module,exports) {
"use strict";
exports.weeksToDays = weeksToDays;
var _index = require("359629129941baca");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function weeksToDays(weeks) {
    return Math.trunc(weeks * _index.daysInWeek);
}

},{"359629129941baca":"fzK9Z"}],"6APbZ":[function(require,module,exports) {
"use strict";
exports.yearsToDays = yearsToDays;
var _index = require("432a3015152e66ed");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function yearsToDays(years) {
    return Math.trunc(years * _index.daysInYear);
}

},{"432a3015152e66ed":"fzK9Z"}],"lDcsj":[function(require,module,exports) {
"use strict";
exports.yearsToMonths = yearsToMonths;
var _index = require("483a1f1b446e7a1c");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function yearsToMonths(years) {
    return Math.trunc(years * _index.monthsInYear);
}

},{"483a1f1b446e7a1c":"fzK9Z"}],"3EWMd":[function(require,module,exports) {
"use strict";
exports.yearsToQuarters = yearsToQuarters;
var _index = require("387b0aecfe84b867");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function yearsToQuarters(years) {
    return Math.trunc(years * _index.quartersInYear);
}

},{"387b0aecfe84b867":"fzK9Z"}],"k3dur":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VIDEOS_PER_PAGE", function() {
    return VIDEOS_PER_PAGE;
});
parcelHelpers.export(exports, "CHANNELS_PER_PAGE", function() {
    return CHANNELS_PER_PAGE;
});
parcelHelpers.export(exports, "DESTINATIONS_VIDEOS_PER_PAGE", function() {
    return DESTINATIONS_VIDEOS_PER_PAGE;
});
parcelHelpers.export(exports, "REPORTS_CHANNEL_USAGE_PER_PAGE", function() {
    return REPORTS_CHANNEL_USAGE_PER_PAGE;
});
parcelHelpers.export(exports, "LISTS_PER_PAGE", function() {
    return LISTS_PER_PAGE;
});
parcelHelpers.export(exports, "VIDEO_OPTIONS", function() {
    return VIDEO_OPTIONS;
});
parcelHelpers.export(exports, "USER_PERMISSIONS_LEVELS", function() {
    return USER_PERMISSIONS_LEVELS;
});
parcelHelpers.export(exports, "NULL_DATE_TEXT", function() {
    return NULL_DATE_TEXT;
});
parcelHelpers.export(exports, "NULL_DATE_TEXT_STATIONS", function() {
    return NULL_DATE_TEXT_STATIONS;
});
parcelHelpers.export(exports, "NULL_CHANNEL_TEXT", function() {
    return NULL_CHANNEL_TEXT;
});
parcelHelpers.export(exports, "NULL_VIDEOSET_TITLE_TEXT", function() {
    return NULL_VIDEOSET_TITLE_TEXT;
});
parcelHelpers.export(exports, "NULL_EPISODE_TITLE", function() {
    return NULL_EPISODE_TITLE;
});
parcelHelpers.export(exports, "NULL_SET_TITLE", function() {
    return NULL_SET_TITLE;
});
parcelHelpers.export(exports, "SEARCH_NO_RESULTS", function() {
    return SEARCH_NO_RESULTS;
});
parcelHelpers.export(exports, "GENERIC_NO_RESULTS", function() {
    return GENERIC_NO_RESULTS;
});
parcelHelpers.export(exports, "MESSAGE_GENERIC_ERROR", function() {
    return MESSAGE_GENERIC_ERROR;
});
parcelHelpers.export(exports, "SET_PASS_RULES", function() {
    return SET_PASS_RULES;
});
parcelHelpers.export(exports, "SET_PASS_RULES2", function() {
    return SET_PASS_RULES2;
});
parcelHelpers.export(exports, "PASSWORDS_MISMATCH", function() {
    return PASSWORDS_MISMATCH;
});
parcelHelpers.export(exports, "PASSWORD_REQUEST_EXPIRED", function() {
    return PASSWORD_REQUEST_EXPIRED;
});
parcelHelpers.export(exports, "PASSWORD_REQUEST_SENT", function() {
    return PASSWORD_REQUEST_SENT;
});
parcelHelpers.export(exports, "PASSWORD_REQUEST_NO_TOKEN", function() {
    return PASSWORD_REQUEST_NO_TOKEN;
});
parcelHelpers.export(exports, "ERROR_MISSING_USERNAME", function() {
    return ERROR_MISSING_USERNAME;
});
parcelHelpers.export(exports, "MESSAGE_ADMIN_PASSWORD_RESET", function() {
    return MESSAGE_ADMIN_PASSWORD_RESET;
});
parcelHelpers.export(exports, "MESSAGE_ERROR_GENERAL", function() {
    return MESSAGE_ERROR_GENERAL;
});
parcelHelpers.export(exports, "ERROR_LOGIN_FAILED", function() {
    return ERROR_LOGIN_FAILED;
});
parcelHelpers.export(exports, "ERROR_LOGIN_CAPSLOCK", function() {
    return ERROR_LOGIN_CAPSLOCK;
});
parcelHelpers.export(exports, "MESSAGE_USER_ACTIVATED", function() {
    return MESSAGE_USER_ACTIVATED;
});
parcelHelpers.export(exports, "MESSAGE_USER_DEACTIVATED", function() {
    return MESSAGE_USER_DEACTIVATED;
});
parcelHelpers.export(exports, "MESSAGE_USER_DELETE_CONFIRM", function() {
    return MESSAGE_USER_DELETE_CONFIRM;
});
parcelHelpers.export(exports, "MESSAGE_USER_DELETED", function() {
    return MESSAGE_USER_DELETED;
});
parcelHelpers.export(exports, "MESSAGE_USER_NOPASS", function() {
    return MESSAGE_USER_NOPASS;
});
parcelHelpers.export(exports, "MESSAGE_CLIPBOARD_OK", function() {
    return MESSAGE_CLIPBOARD_OK;
});
parcelHelpers.export(exports, "MESSAGE_CLIPBOARD_FAILED", function() {
    return MESSAGE_CLIPBOARD_FAILED;
});
parcelHelpers.export(exports, "MESSAGE_ERROR_TOO_MANY_URLS", function() {
    return MESSAGE_ERROR_TOO_MANY_URLS;
});
parcelHelpers.export(exports, "MESSAGE_CHANNEL_ADDED_GROUP", function() {
    return MESSAGE_CHANNEL_ADDED_GROUP;
});
parcelHelpers.export(exports, "MESSAGE_ERROR_TOO_MANY_SELECTED", function() {
    return MESSAGE_ERROR_TOO_MANY_SELECTED;
});
parcelHelpers.export(exports, "MESSAGE_NOT_SUBMITTED", function() {
    return MESSAGE_NOT_SUBMITTED;
});
parcelHelpers.export(exports, "MESSAGE_VIDEO_NOTE_SAVED", function() {
    return MESSAGE_VIDEO_NOTE_SAVED;
});
parcelHelpers.export(exports, "MESSAGE_DESTINATION_DELETE_CONFIRM", function() {
    return MESSAGE_DESTINATION_DELETE_CONFIRM;
});
parcelHelpers.export(exports, "MESSAGE_DESTINATION_DELETED", function() {
    return MESSAGE_DESTINATION_DELETED;
});
parcelHelpers.export(exports, "MESSAGE_DESTINATION_NOVIDEOSETS", function() {
    return MESSAGE_DESTINATION_NOVIDEOSETS;
});
parcelHelpers.export(exports, "MESSAGE_DESTINATIONS_ADDVIDEOSET", function() {
    return MESSAGE_DESTINATIONS_ADDVIDEOSET;
});
parcelHelpers.export(exports, "MESSAGE_DESTINATION_DELETE_UNNAMED", function() {
    return MESSAGE_DESTINATION_DELETE_UNNAMED;
});
parcelHelpers.export(exports, "MESSAGE_ADD_TO_AVA", function() {
    return MESSAGE_ADD_TO_AVA;
});
parcelHelpers.export(exports, "MESSAGE_VIDEO_NOTRATED", function() {
    return MESSAGE_VIDEO_NOTRATED;
});
parcelHelpers.export(exports, "MESSAGE_ERROR_NOTACHANNEL", function() {
    return MESSAGE_ERROR_NOTACHANNEL;
});
parcelHelpers.export(exports, "MESSAGE_ERROR_ADDCHANNELTOSYSTEM", function() {
    return MESSAGE_ERROR_ADDCHANNELTOSYSTEM;
});
parcelHelpers.export(exports, "MESSAGE_NO_TAGS", function() {
    return MESSAGE_NO_TAGS;
});
parcelHelpers.export(exports, "MESSAGE_VIDEO_ADDED_TO_SET", function() {
    return MESSAGE_VIDEO_ADDED_TO_SET;
});
parcelHelpers.export(exports, "API_SEARCH", function() {
    return API_SEARCH;
});
parcelHelpers.export(exports, "API_CHANNEL_BATCH", function() {
    return API_CHANNEL_BATCH;
});
parcelHelpers.export(exports, "API_CHANNEL_INFO", function() {
    return API_CHANNEL_INFO;
});
parcelHelpers.export(exports, "API_CHANNEL_DELETE", function() {
    return API_CHANNEL_DELETE;
});
parcelHelpers.export(exports, "API_CHANNEL_REMOVE", function() {
    return API_CHANNEL_REMOVE;
});
parcelHelpers.export(exports, "API_CHANNEL_SETTAGS", function() {
    return API_CHANNEL_SETTAGS;
});
parcelHelpers.export(exports, "API_CHANNEL_USAGE", function() {
    return API_CHANNEL_USAGE;
});
parcelHelpers.export(exports, "API_CHANNELS_TYPEAHEAD", function() {
    return API_CHANNELS_TYPEAHEAD;
});
parcelHelpers.export(exports, "API_CHANNEL_ADD_TO_SYSTEM", function() {
    return API_CHANNEL_ADD_TO_SYSTEM;
});
parcelHelpers.export(exports, "API_CHANNEL_GET_GROUPS", function() {
    return API_CHANNEL_GET_GROUPS;
});
parcelHelpers.export(exports, "API_CHANNEL_GET_VIDEOS", function() {
    return API_CHANNEL_GET_VIDEOS;
});
parcelHelpers.export(exports, "API_GROUPS_ALLGROUPS", function() {
    return API_GROUPS_ALLGROUPS;
});
parcelHelpers.export(exports, "API_GROUPS_ASSIGNMENTS", function() {
    return API_GROUPS_ASSIGNMENTS;
});
parcelHelpers.export(exports, "API_GROUPS_SET_TAGS", function() {
    return API_GROUPS_SET_TAGS;
});
parcelHelpers.export(exports, "API_GROUPS_ADD_CHANNEL_TO_GROUP", function() {
    return API_GROUPS_ADD_CHANNEL_TO_GROUP;
});
parcelHelpers.export(exports, "API_GROUPS_ASSIGN_CHANNEL_TO_GROUP", function() {
    return API_GROUPS_ASSIGN_CHANNEL_TO_GROUP;
});
parcelHelpers.export(exports, "API_GROUPS_CHANNELS_IN_GROUP", function() {
    return API_GROUPS_CHANNELS_IN_GROUP;
});
parcelHelpers.export(exports, "API_GROUP_ADD_NEW", function() {
    return API_GROUP_ADD_NEW;
});
parcelHelpers.export(exports, "API_GROUPS_DELETE", function() {
    return API_GROUPS_DELETE;
});
parcelHelpers.export(exports, "API_GROUPS_REMOVE_CHANNEL", function() {
    return API_GROUPS_REMOVE_CHANNEL;
});
parcelHelpers.export(exports, "API_REMOVE_CHANNEL_FROM_GROUP", function() {
    return API_REMOVE_CHANNEL_FROM_GROUP;
});
parcelHelpers.export(exports, "API_RATINGS_ALL", function() {
    return API_RATINGS_ALL;
});
parcelHelpers.export(exports, "API_RATINGS_VIDEOUPDATE", function() {
    return API_RATINGS_VIDEOUPDATE;
});
parcelHelpers.export(exports, "API_CRTAPPROVALS_OPTIONS", function() {
    return API_CRTAPPROVALS_OPTIONS;
});
parcelHelpers.export(exports, "API_CRTAPPROVALS_SETSTATUS", function() {
    return API_CRTAPPROVALS_SETSTATUS;
});
parcelHelpers.export(exports, "API_CRTAPPROVALS_GETSTATUS", function() {
    return API_CRTAPPROVALS_GETSTATUS;
});
parcelHelpers.export(exports, "API_CRTAPPROVALS_GETVIDSETSTATUS", function() {
    return API_CRTAPPROVALS_GETVIDSETSTATUS;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_ADDNEW", function() {
    return API_VIDEOSETBLOCK_ADDNEW;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_DELETE", function() {
    return API_VIDEOSETBLOCK_DELETE;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_RATING", function() {
    return API_VIDEOSETBLOCK_RATING;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_INFO", function() {
    return API_VIDEOSETBLOCK_INFO;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_UPDATE", function() {
    return API_VIDEOSETBLOCK_UPDATE;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_INFO_CSV", function() {
    return API_VIDEOSETBLOCK_INFO_CSV;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_REINIT", function() {
    return API_VIDEOSETBLOCK_REINIT;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_REVIEWED", function() {
    return API_VIDEOSETBLOCK_REVIEWED;
});
parcelHelpers.export(exports, "API_VIDEOSETBLOCK_REORDERED", function() {
    return API_VIDEOSETBLOCK_REORDERED;
});
parcelHelpers.export(exports, "API_VIDEO_ADDTOSET", function() {
    return API_VIDEO_ADDTOSET;
});
parcelHelpers.export(exports, "API_VIDEO_ADDNEW", function() {
    return API_VIDEO_ADDNEW;
});
parcelHelpers.export(exports, "API_VIDEO_DELETE", function() {
    return API_VIDEO_DELETE;
});
parcelHelpers.export(exports, "API_VIDEO_GETBATCH", function() {
    return API_VIDEO_GETBATCH;
});
parcelHelpers.export(exports, "API_VIDEO_INFO", function() {
    return API_VIDEO_INFO;
});
parcelHelpers.export(exports, "API_VIDEO_REMOVEFROMSET", function() {
    return API_VIDEO_REMOVEFROMSET;
});
parcelHelpers.export(exports, "API_VIDEO_SEARCH", function() {
    return API_VIDEO_SEARCH;
});
parcelHelpers.export(exports, "API_VIDEO_UPDATETAGS", function() {
    return API_VIDEO_UPDATETAGS;
});
parcelHelpers.export(exports, "API_VIDEO_ADDBATCH", function() {
    return API_VIDEO_ADDBATCH;
});
parcelHelpers.export(exports, "API_VIDEO_ADDNOTE", function() {
    return API_VIDEO_ADDNOTE;
});
parcelHelpers.export(exports, "API_VIDEOSET_ADDNEW", function() {
    return API_VIDEOSET_ADDNEW;
});
parcelHelpers.export(exports, "API_VIDEOSET_DELETE", function() {
    return API_VIDEOSET_DELETE;
});
parcelHelpers.export(exports, "API_VIDEOSET_RESTORE", function() {
    return API_VIDEOSET_RESTORE;
});
parcelHelpers.export(exports, "API_VIDEOSET_ASSIGNMENTS", function() {
    return API_VIDEOSET_ASSIGNMENTS;
});
parcelHelpers.export(exports, "API_VIDEOSET_REINIT", function() {
    return API_VIDEOSET_REINIT;
});
parcelHelpers.export(exports, "API_VIDEOSET_RENAME", function() {
    return API_VIDEOSET_RENAME;
});
parcelHelpers.export(exports, "API_VIDEOSET_DUPLICATE", function() {
    return API_VIDEOSET_DUPLICATE;
});
parcelHelpers.export(exports, "API_VIDEOSET_ISDUPLICATE", function() {
    return API_VIDEOSET_ISDUPLICATE;
});
parcelHelpers.export(exports, "API_DESTINATIONS_CHECKFORUPDATES", function() {
    return API_DESTINATIONS_CHECKFORUPDATES;
});
parcelHelpers.export(exports, "API_DESTINATIONS_ADDNEW", function() {
    return API_DESTINATIONS_ADDNEW;
});
parcelHelpers.export(exports, "API_DESTINATIONS_CHECKFORUPDATES_CSV", function() {
    return API_DESTINATIONS_CHECKFORUPDATES_CSV;
});
parcelHelpers.export(exports, "API_DESTINATION_DELETE", function() {
    return API_DESTINATION_DELETE;
});
parcelHelpers.export(exports, "API_DESTINATIONS_LIST", function() {
    return API_DESTINATIONS_LIST;
});
parcelHelpers.export(exports, "API_DESTINATIONS_ASSIGNMENTS", function() {
    return API_DESTINATIONS_ASSIGNMENTS;
});
parcelHelpers.export(exports, "API_DESTINATIONS_INFO", function() {
    return API_DESTINATIONS_INFO;
});
parcelHelpers.export(exports, "API_DESTINATIONS_SEARCH", function() {
    return API_DESTINATIONS_SEARCH;
});
parcelHelpers.export(exports, "API_DESTINATIONS_RENAME", function() {
    return API_DESTINATIONS_RENAME;
});
parcelHelpers.export(exports, "API_USER_CHECK_SET_PASS_ID", function() {
    return API_USER_CHECK_SET_PASS_ID;
});
parcelHelpers.export(exports, "API_USER_LOGIN", function() {
    return API_USER_LOGIN;
});
parcelHelpers.export(exports, "API_USER_PW_RESET", function() {
    return API_USER_PW_RESET;
});
parcelHelpers.export(exports, "API_USER_SET_PASS", function() {
    return API_USER_SET_PASS;
});
parcelHelpers.export(exports, "API_USER_UNAUTHED_REQUEST_TOKEN", function() {
    return API_USER_UNAUTHED_REQUEST_TOKEN;
});
parcelHelpers.export(exports, "API_USER_TEST_PASS", function() {
    return API_USER_TEST_PASS;
});
parcelHelpers.export(exports, "API_USER_SUGGEST_PASSWORD", function() {
    return API_USER_SUGGEST_PASSWORD;
});
parcelHelpers.export(exports, "API_USERS_GETALL", function() {
    return API_USERS_GETALL;
});
parcelHelpers.export(exports, "API_USERS_ADD", function() {
    return API_USERS_ADD;
});
parcelHelpers.export(exports, "API_USERS_UPDATEUSER", function() {
    return API_USERS_UPDATEUSER;
});
parcelHelpers.export(exports, "API_USERS_DELETEUSER", function() {
    return API_USERS_DELETEUSER;
});
parcelHelpers.export(exports, "API_USERS_GETUSERINFO", function() {
    return API_USERS_GETUSERINFO;
});
parcelHelpers.export(exports, "API_USER_UPDATES_SELF", function() {
    return API_USER_UPDATES_SELF;
});
parcelHelpers.export(exports, "API_USERS_DEACTIVATE", function() {
    return API_USERS_DEACTIVATE;
});
parcelHelpers.export(exports, "API_USERS_REACTIVATE", function() {
    return API_USERS_REACTIVATE;
});
parcelHelpers.export(exports, "API_USERS_RESETPASSWORD", function() {
    return API_USERS_RESETPASSWORD;
});
parcelHelpers.export(exports, "API_REPORTS", function() {
    return API_REPORTS;
});
parcelHelpers.export(exports, "API_REPORTS_DROPOFFS", function() {
    return API_REPORTS_DROPOFFS;
});
parcelHelpers.export(exports, "API_REPORTS_DROPOFFS_CSV", function() {
    return API_REPORTS_DROPOFFS_CSV;
});
parcelHelpers.export(exports, "API_REPORTS_VIDSBYDEST", function() {
    return API_REPORTS_VIDSBYDEST;
});
parcelHelpers.export(exports, "API_REPORTS_CHANNELSBYDEST", function() {
    return API_REPORTS_CHANNELSBYDEST;
});
parcelHelpers.export(exports, "API_REPORTS_DESTINATIONSBYVIDSET", function() {
    return API_REPORTS_DESTINATIONSBYVIDSET;
});
parcelHelpers.export(exports, "API_REPORTS_CHANNELS", function() {
    return API_REPORTS_CHANNELS;
});
parcelHelpers.export(exports, "API_DOWNLOAD_PREFIX", function() {
    return API_DOWNLOAD_PREFIX;
});
parcelHelpers.export(exports, "API_REPORTS_VIDSET_TYPEAHEAD", function() {
    return API_REPORTS_VIDSET_TYPEAHEAD;
});
parcelHelpers.export(exports, "API_REPORTS_VIDEO_USAGE", function() {
    return API_REPORTS_VIDEO_USAGE;
});
parcelHelpers.export(exports, "API_REPORTS_VIDEOS_TYPEAHEAD", function() {
    return API_REPORTS_VIDEOS_TYPEAHEAD;
});
parcelHelpers.export(exports, "API_STATIONS", function() {
    return API_STATIONS;
});
parcelHelpers.export(exports, "API_SAVE_SEASONEPS", function() {
    return API_SAVE_SEASONEPS;
});
parcelHelpers.export(exports, "API_SERIES", function() {
    return API_SERIES;
});
parcelHelpers.export(exports, "API_STATIONS_EPISODE_EDIT", function() {
    return API_STATIONS_EPISODE_EDIT;
});
parcelHelpers.export(exports, "API_STATIONS_SERIES_EDIT", function() {
    return API_STATIONS_SERIES_EDIT;
});
parcelHelpers.export(exports, "API_STATIONS_FIND_SERIES", function() {
    return API_STATIONS_FIND_SERIES;
});
parcelHelpers.export(exports, "API_MEOW_OPTIONS", function() {
    return API_MEOW_OPTIONS;
});
parcelHelpers.export(exports, "API_MEOW_SETSTATUS", function() {
    return API_MEOW_SETSTATUS;
});
parcelHelpers.export(exports, "API_IMPORT_EMAIL", function() {
    return API_IMPORT_EMAIL;
});
parcelHelpers.export(exports, "API_IMPORT_SPREADSHEET", function() {
    return API_IMPORT_SPREADSHEET;
});
parcelHelpers.export(exports, "API_EXPORT_DURATIONS_TO_GOOG", function() {
    return API_EXPORT_DURATIONS_TO_GOOG;
});
parcelHelpers.export(exports, "API_IMPORT_SPREADSHEET_FINDRANGES", function() {
    return API_IMPORT_SPREADSHEET_FINDRANGES;
});
parcelHelpers.export(exports, "API_IMPORT_GSHEET_TO_PLAYLIST", function() {
    return API_IMPORT_GSHEET_TO_PLAYLIST;
});
parcelHelpers.export(exports, "API_CATEGORIES", function() {
    return API_CATEGORIES;
});
parcelHelpers.export(exports, "API_CLUSTERS_GENRES", function() {
    return API_CLUSTERS_GENRES;
});
parcelHelpers.export(exports, "API_CLUSTERS_SINGLEGENRE", function() {
    return API_CLUSTERS_SINGLEGENRE;
});
parcelHelpers.export(exports, "API_CLUSTERS_GENREADD", function() {
    return API_CLUSTERS_GENREADD;
});
parcelHelpers.export(exports, "API_CLUSTERS_GENREREMOVE", function() {
    return API_CLUSTERS_GENREREMOVE;
});
parcelHelpers.export(exports, "API_CLUSTERS_SONGS", function() {
    return API_CLUSTERS_SONGS;
});
parcelHelpers.export(exports, "API_CLUSTERS_GENRESIZES", function() {
    return API_CLUSTERS_GENRESIZES;
});
parcelHelpers.export(exports, "API_CLUSTERS_SONG_GET_ASINDATA", function() {
    return API_CLUSTERS_SONG_GET_ASINDATA;
});
parcelHelpers.export(exports, "API_CLUSTERS_SONG_IMPORT", function() {
    return API_CLUSTERS_SONG_IMPORT;
});
parcelHelpers.export(exports, "API_CLUSTERS_SONG_REMOVE", function() {
    return API_CLUSTERS_SONG_REMOVE;
});
parcelHelpers.export(exports, "API_GENRES_REPORTS", function() {
    return API_GENRES_REPORTS;
});
parcelHelpers.export(exports, "API_GENRES_SONGDUPES", function() {
    return API_GENRES_SONGDUPES;
});
parcelHelpers.export(exports, "API_GENRES_ARTISTDUPES", function() {
    return API_GENRES_ARTISTDUPES;
});
parcelHelpers.export(exports, "API_CLUSTERS_SONGSREORDER", function() {
    return API_CLUSTERS_SONGSREORDER;
});
parcelHelpers.export(exports, "API_CLUSTERS_GENREIMPORT", function() {
    return API_CLUSTERS_GENREIMPORT;
});
parcelHelpers.export(exports, "API_GENRES_EXPORTCSV", function() {
    return API_GENRES_EXPORTCSV;
});
parcelHelpers.export(exports, "API_PROJECTS", function() {
    return API_PROJECTS;
});
parcelHelpers.export(exports, "API_PROJECTS_FORUSER", function() {
    return API_PROJECTS_FORUSER;
});
parcelHelpers.export(exports, "API_LANGUAGES", function() {
    return API_LANGUAGES;
});
parcelHelpers.export(exports, "API_REGIONS", function() {
    return API_REGIONS;
});
parcelHelpers.export(exports, "API_AAPL_IMPORT", function() {
    return API_AAPL_IMPORT;
});
parcelHelpers.export(exports, "API_AAPL_LIST", function() {
    return API_AAPL_LIST;
});
parcelHelpers.export(exports, "API_AAPL_EDIT", function() {
    return API_AAPL_EDIT;
});
parcelHelpers.export(exports, "API_AAPL_GETREVISION", function() {
    return API_AAPL_GETREVISION;
});
parcelHelpers.export(exports, "API_AAPL_SAVE", function() {
    return API_AAPL_SAVE;
});
parcelHelpers.export(exports, "API_AAPL_DELETE", function() {
    return API_AAPL_DELETE;
});
parcelHelpers.export(exports, "INTERSTITIAL_INDICATOR", function() {
    return INTERSTITIAL_INDICATOR;
});
parcelHelpers.export(exports, "INTERSTITIAL_NOTE", function() {
    return INTERSTITIAL_NOTE;
});
parcelHelpers.export(exports, "ERROR_UNAUTHORIZED", function() {
    return ERROR_UNAUTHORIZED;
});
parcelHelpers.export(exports, "STRIP_TAGS_REGEX", function() {
    return STRIP_TAGS_REGEX;
});
parcelHelpers.export(exports, "AAPL_ERROR_DELETE", function() {
    return AAPL_ERROR_DELETE;
});
parcelHelpers.export(exports, "DEFAULT_LABEL_TEXT", function() {
    return DEFAULT_LABEL_TEXT;
});
var VIDEOS_PER_PAGE = 24;
var CHANNELS_PER_PAGE = 24;
var DESTINATIONS_VIDEOS_PER_PAGE = 10;
var REPORTS_CHANNEL_USAGE_PER_PAGE = 10;
var LISTS_PER_PAGE = 25;
var VIDEO_OPTIONS = {
    height: "390",
    width: "640",
    playerVars: {
        autoplay: 0
    }
};
var USER_PERMISSIONS_LEVELS = [
    {
        label: "User",
        value: 1
    },
    {
        label: "Admin",
        value: 100
    },
    {
        label: "Global Admin",
        value: 255
    }
];
var NULL_DATE_TEXT = "No date set";
var NULL_DATE_TEXT_STATIONS = "[Unscheduled]";
var NULL_CHANNEL_TEXT = "No channel info";
var NULL_VIDEOSET_TITLE_TEXT = "No title was set";
var NULL_EPISODE_TITLE = "[Untitled Episode]";
var NULL_SET_TITLE = "[Untitled Set]";
var SEARCH_NO_RESULTS = "No videos found. Try changing your filters.";
var GENERIC_NO_RESULTS = "No results found.";
var MESSAGE_GENERIC_ERROR = "Whoops! Something went wrong with the API. This is a bug. Please tell an administrator.";
var SET_PASS_RULES = {
    __html: "Your password must be at least <b>12 characters long</b> and should be hard to guess. Try using a few unrelated words. You may add numbers or punctuation, or mix upper and lower case letters. Spaces are also allowed. <b>Avoid passwords</b> such as <code>p@$$w0rd123!</code> or <code>h@ppy!b1rthd@y</code>. They are not strong enough."
};
var SET_PASS_RULES2 = "Please re-type the password you entered above.";
var PASSWORDS_MISMATCH = "Your confirmation does not match your original password.";
var PASSWORD_REQUEST_EXPIRED = "Your password request has expired. Please tell an AVA administrator.";
var PASSWORD_REQUEST_SENT = "If you're still an active user, we'll send a password reset link to the email address for your AVA account.";
var PASSWORD_REQUEST_NO_TOKEN = "You didn't give me a request identifier.";
var ERROR_MISSING_USERNAME = "Please enter your user name in the correct field.";
var MESSAGE_ADMIN_PASSWORD_RESET = "I sent a password reset email to";
var MESSAGE_ERROR_GENERAL = "Something went wrong. Please tell an administrator.";
var ERROR_LOGIN_FAILED = "That user name and password did not work. Try again.";
var ERROR_LOGIN_CAPSLOCK = "Your Caps Lock key is on.";
var MESSAGE_USER_ACTIVATED = "This user is now active.";
var MESSAGE_USER_DEACTIVATED = "This user is now inactive.";
var MESSAGE_USER_DELETE_CONFIRM = "Are you sure you want to delete this user from the system?";
var MESSAGE_USER_DELETED = "User was deleted";
var MESSAGE_USER_NOPASS = "This user has not set a password.";
var MESSAGE_CLIPBOARD_OK = "The IDs have been copied to your clipboard.";
var MESSAGE_CLIPBOARD_FAILED = "Uh-oh! I couldn't copy those IDs to your clipboard.";
var MESSAGE_ERROR_TOO_MANY_URLS = [
    "Too many URLs or IDs. ",
    "Please remove a few. You should also check for and remove extra line breaks, spaces, or commas at the end of URLs/IDs."
];
var MESSAGE_CHANNEL_ADDED_GROUP = "Channel added to group.";
var MESSAGE_ERROR_TOO_MANY_SELECTED = [
    "Too many videos selected",
    "Please deselect a few."
];
var MESSAGE_NOT_SUBMITTED = "Not Submitted";
var MESSAGE_VIDEO_NOTE_SAVED = "Your note was saved.";
var MESSAGE_DESTINATION_DELETE_CONFIRM = "Are you sure that you want to delete %s?";
var MESSAGE_DESTINATION_DELETED = "%s was deleted.";
var MESSAGE_DESTINATION_NOVIDEOSETS = "This destination doesn't have any video sets.";
var MESSAGE_DESTINATIONS_ADDVIDEOSET = 'Success! "%s" was added to "%s"';
var MESSAGE_DESTINATION_DELETE_UNNAMED = "[UNNAMED DESTINATION]";
var MESSAGE_ADD_TO_AVA = "Please add this video to AVA first.";
var MESSAGE_VIDEO_NOTRATED = "Not Yet Rated";
var MESSAGE_ERROR_NOTACHANNEL = "Whoops! Something you submitted was not a valid channel URL or ID.\nPlease check what you've entered and try again.";
var MESSAGE_ERROR_ADDCHANNELTOSYSTEM = "I think something went wrong with the API. Please tell an administrator.";
var MESSAGE_NO_TAGS = "[NO TAGS]";
var MESSAGE_VIDEO_ADDED_TO_SET = "Video added to set.";
var API_SEARCH = "api/search";
var API_CHANNEL_BATCH = "api/getchannelbatch";
var API_CHANNEL_INFO = "api/channelinfo";
var API_CHANNEL_DELETE = "api/channeldelete"; // Deprecated.
var API_CHANNEL_REMOVE = "api/channelremove"; // Use this one instead.
var API_CHANNEL_SETTAGS = "api/channelsettags";
var API_CHANNEL_USAGE = "reports/channelusage";
var API_CHANNELS_TYPEAHEAD = "reports/channelstypeahead/";
var API_CHANNEL_ADD_TO_SYSTEM = "api/channeladd";
var API_CHANNEL_GET_GROUPS = "api/channelgetgroups";
var API_CHANNEL_GET_VIDEOS = "api/channelgetvideos";
var API_GROUPS_ALLGROUPS = "api/allgroups";
var API_GROUPS_ASSIGNMENTS = "api/groupassignments";
var API_GROUPS_SET_TAGS = "api/channelsettags";
var API_GROUPS_ADD_CHANNEL_TO_GROUP = "api/channeladdtogroup";
var API_GROUPS_ASSIGN_CHANNEL_TO_GROUP = "api/channelsassigngroup";
var API_GROUPS_CHANNELS_IN_GROUP = "api/groupinfo";
var API_GROUP_ADD_NEW = "api/groupadd";
var API_GROUPS_DELETE = "api/deletegroup";
var API_GROUPS_REMOVE_CHANNEL = "api/channelremovefromgroup"; // *DOES NOT* return an updated list of groups.
var API_REMOVE_CHANNEL_FROM_GROUP = "api/channelremoveassignment"; // Returns an updated list of groups.
var API_RATINGS_ALL = "api/ratings";
var API_RATINGS_VIDEOUPDATE = "api/updatevideorating";
var API_CRTAPPROVALS_OPTIONS = "api/approvalstatuses";
var API_CRTAPPROVALS_SETSTATUS = "api/approvalsetstatus";
var API_CRTAPPROVALS_GETSTATUS = "api/approvalgetstatus";
var API_CRTAPPROVALS_GETVIDSETSTATUS = "api/approvalvideosetstatus";
var API_VIDEOSETBLOCK_ADDNEW = "api/videosetaddblock";
var API_VIDEOSETBLOCK_DELETE = "api/videosetblockdelete";
var API_VIDEOSETBLOCK_RATING = "api/getvideosetblockrating";
var API_VIDEOSETBLOCK_INFO = "api/videosetblockinfo";
var API_VIDEOSETBLOCK_UPDATE = "api/videosetblockupdate";
var API_VIDEOSETBLOCK_INFO_CSV = "api/videosetblockinfo/csv";
var API_VIDEOSETBLOCK_REINIT = "api/videosetblockreinitialize";
var API_VIDEOSETBLOCK_REVIEWED = "api/videosetblockreviewed";
var API_VIDEOSETBLOCK_REORDERED = "api/videosetblockupdateorder";
var API_VIDEO_ADDTOSET = "api/videoaddtoset";
var API_VIDEO_ADDNEW = "api/videoaddnew";
var API_VIDEO_DELETE = "api/videodelete";
var API_VIDEO_GETBATCH = "api/getvideobatch";
var API_VIDEO_INFO = "api/videoinfo";
var API_VIDEO_REMOVEFROMSET = "api/videoblockremovevideo";
var API_VIDEO_SEARCH = "api/videosearch";
var API_VIDEO_UPDATETAGS = "api/videoupdatetags";
var API_VIDEO_ADDBATCH = "api/videoaddbatchbyurl";
var API_VIDEO_ADDNOTE = "api/videoaddnote";
var API_VIDEOSET_ADDNEW = "api/videosetadd";
var API_VIDEOSET_DELETE = "api/videosetdelete";
var API_VIDEOSET_RESTORE = "api/videosetrestore";
var API_VIDEOSET_ASSIGNMENTS = "api/videosetassignments";
var API_VIDEOSET_REINIT = "api/videosetreinitialize";
var API_VIDEOSET_RENAME = "api/videosetrename";
var API_VIDEOSET_DUPLICATE = "api/duplicateepisode";
var API_VIDEOSET_ISDUPLICATE = "api/isduplicateepisode";
var API_DESTINATIONS_CHECKFORUPDATES = "api/videosetcheckforupdates";
var API_DESTINATIONS_ADDNEW = "api/destinationadd";
var API_DESTINATIONS_CHECKFORUPDATES_CSV = "api/getvideohistoryascsv";
var API_DESTINATION_DELETE = "api/destinationdelete";
var API_DESTINATIONS_LIST = "api/alldestinationslist"; // Lists all destinations
var API_DESTINATIONS_ASSIGNMENTS = "api/destinationassignmentsbasic"; // Get name, set list for a destination
var API_DESTINATIONS_INFO = "api/destinationinfo"; // Get name, set list for a destination, INCLUDING how many playlists there are per run date.
var API_DESTINATIONS_SEARCH = "api/findvideosets";
var API_DESTINATIONS_RENAME = "api/destinationrename";
var API_USER_CHECK_SET_PASS_ID = "api/checksetpassid";
var API_USER_LOGIN = "api/login";
var API_USER_PW_RESET = "api/requestpass";
var API_USER_SET_PASS = "api/usersetpass";
var API_USER_UNAUTHED_REQUEST_TOKEN = "api/requesttoken";
var API_USER_TEST_PASS = "api/checkpassstrength";
var API_USER_SUGGEST_PASSWORD = "api/suggestpass";
var API_USERS_GETALL = "api/allusers";
var API_USERS_ADD = "api/useradd";
var API_USERS_UPDATEUSER = "api/useredit";
var API_USERS_DELETEUSER = "api/userdelete";
var API_USERS_GETUSERINFO = "api/userinfo";
var API_USER_UPDATES_SELF = "users/updateAccountInfo";
var API_USERS_DEACTIVATE = "api/userdeactivate";
var API_USERS_REACTIVATE = "api/userreactivate";
var API_USERS_RESETPASSWORD = "api/resetpassword";
var API_REPORTS = "api/reports";
var API_REPORTS_DROPOFFS = "reports/videodropoffs";
var API_REPORTS_DROPOFFS_CSV = "reports/videodropoffs/csv";
var API_REPORTS_VIDSBYDEST = "reports/videosbydestination";
var API_REPORTS_CHANNELSBYDEST = "reports/channelsbydestination";
var API_REPORTS_DESTINATIONSBYVIDSET = "reports/destinationsbyvideoset";
var API_REPORTS_CHANNELS = "reports/channels";
var API_DOWNLOAD_PREFIX = "/ava/api/api/";
var API_REPORTS_VIDSET_TYPEAHEAD = "reports/videosettypeahead";
var API_REPORTS_VIDEO_USAGE = "reports/videousage";
var API_REPORTS_VIDEOS_TYPEAHEAD = "reports/videostypeahead";
var API_STATIONS = "api/stations";
var API_SAVE_SEASONEPS = "api/saveseasoneps";
var API_SERIES = "api/series";
var API_STATIONS_EPISODE_EDIT = "api/episodeedit";
var API_STATIONS_SERIES_EDIT = "api/seriesedit";
var API_STATIONS_FIND_SERIES = "api/findepisodes";
var API_MEOW_OPTIONS = "api/meowstatuses";
var API_MEOW_SETSTATUS = "api/meowsetstatus";
var API_IMPORT_EMAIL = "api/spreadsheetemail";
var API_IMPORT_SPREADSHEET = "api/spreadsheetdurations";
var API_EXPORT_DURATIONS_TO_GOOG = "api/spreadsheetupdate";
var API_IMPORT_SPREADSHEET_FINDRANGES = "api/spreadsheetdurationranges";
var API_IMPORT_GSHEET_TO_PLAYLIST = "api/importplaylistfromgsheet";
var API_CATEGORIES = "api/categories";
var API_CLUSTERS_GENRES = "api/genres";
var API_CLUSTERS_SINGLEGENRE = "api/genre";
var API_CLUSTERS_GENREADD = "api/genreadd";
var API_CLUSTERS_GENREREMOVE = "api/genreremove";
var API_CLUSTERS_SONGS = "api/genresongs";
var API_CLUSTERS_GENRESIZES = "api/genresizes";
var API_CLUSTERS_SONG_GET_ASINDATA = "api/scrapeasin";
var API_CLUSTERS_SONG_IMPORT = "api/importasin";
var API_CLUSTERS_SONG_REMOVE = "api/genreremoveasin";
var API_GENRES_REPORTS = "api/genrereports";
var API_GENRES_SONGDUPES = "api/genresongdupes";
var API_GENRES_ARTISTDUPES = "api/genreartistdupes";
var API_CLUSTERS_SONGSREORDER = "api/genresongsreorder";
var API_CLUSTERS_GENREIMPORT = "api/genreimport";
var API_GENRES_EXPORTCSV = "api/genreexportcsv";
var API_PROJECTS = "api/projects";
var API_PROJECTS_FORUSER = "api/projectsforuser";
var API_LANGUAGES = "api/languages";
var API_REGIONS = "api/regions";
var API_AAPL_IMPORT = "api/aaplimport";
var API_AAPL_LIST = "api/aapllist";
var API_AAPL_EDIT = "api/aapledit";
var API_AAPL_GETREVISION = "api/aaplrevision";
var API_AAPL_SAVE = "api/aaplsave";
var API_AAPL_DELETE = "api/aapldelete";
var INTERSTITIAL_INDICATOR = "\u272A";
var INTERSTITIAL_NOTE = "(".concat(INTERSTITIAL_INDICATOR, " = contains an interstitial video)");
var ERROR_UNAUTHORIZED = {
    error: 1,
    message: "Please log in."
};
var STRIP_TAGS_REGEX = new RegExp(/<[^>]+>/g);
var AAPL_ERROR_DELETE = "Error: Something went wrong. Please tell an administrator.";
var DEFAULT_LABEL_TEXT = "CHANGE THIS LABEL.";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"euxcI":[function(require,module,exports) {
/**
* Utilities.js
* Utility functions.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", function() {
    return debounce;
});
parcelHelpers.export(exports, "getAuthData", function() {
    return getAuthData;
});
parcelHelpers.export(exports, "setAuthData", function() {
    return setAuthData;
});
parcelHelpers.export(exports, "updateAuthData", function() {
    return updateAuthData;
});
parcelHelpers.export(exports, "removeAuthData", function() {
    return removeAuthData;
});
parcelHelpers.export(exports, "numberFormat", function() {
    return numberFormat;
});
parcelHelpers.export(exports, "apirequest", function() {
    return apirequest;
});
parcelHelpers.export(exports, "csvrequest", function() {
    return csvrequest;
});
parcelHelpers.export(exports, "truncateString", function() {
    return truncateString;
});
parcelHelpers.export(exports, "rfc3339Date", function() {
    return rfc3339Date;
});
parcelHelpers.export(exports, "yyyymmdd", function() {
    return yyyymmdd;
});
parcelHelpers.export(exports, "mysqlTimeStamp", function() {
    return mysqlTimeStamp;
});
parcelHelpers.export(exports, "getSortDirection", function() {
    return getSortDirection;
});
parcelHelpers.export(exports, "totalRunTime", function() {
    return totalRunTime;
});
parcelHelpers.export(exports, "isAdmin", function() {
    return isAdmin;
});
parcelHelpers.export(exports, "canAdminProject", function() {
    return canAdminProject;
});
parcelHelpers.export(exports, "formatTime", function() {
    return formatTime;
});
parcelHelpers.export(exports, "isEmptyObject", function() {
    return isEmptyObject;
});
parcelHelpers.export(exports, "getVideoData", function() {
    return getVideoData;
});
parcelHelpers.export(exports, "meetsMinLength", function() {
    return meetsMinLength;
});
parcelHelpers.export(exports, "isSameString", function() {
    return isSameString;
});
parcelHelpers.export(exports, "forceDownload", function() {
    return forceDownload;
});
parcelHelpers.export(exports, "pushDownload", function() {
    return pushDownload;
});
parcelHelpers.export(exports, "isNumeric", function() {
    return isNumeric;
});
parcelHelpers.export(exports, "formatString", function() {
    return formatString;
});
parcelHelpers.export(exports, "range", function() {
    return range;
});
parcelHelpers.export(exports, "percentage", function() {
    return percentage;
});
parcelHelpers.export(exports, "precision", function() {
    return precision;
});
parcelHelpers.export(exports, "convertArrayToCSV", function() {
    return convertArrayToCSV;
});
parcelHelpers.export(exports, "shuffle", function() {
    return shuffle;
});
parcelHelpers.export(exports, "youtubeURL", function() {
    return youtubeURL;
});
parcelHelpers.export(exports, "youtubeThumbnailURL", function() {
    return youtubeThumbnailURL;
});
parcelHelpers.export(exports, "arraychunk", function() {
    return arraychunk;
});
parcelHelpers.export(exports, "getDuration", function() {
    return getDuration;
});
parcelHelpers.export(exports, "expandShortYouTubeUrl", function() {
    return expandShortYouTubeUrl;
});
parcelHelpers.export(exports, "extractYouTubeIdFromUrl", function() {
    return extractYouTubeIdFromUrl;
});
parcelHelpers.export(exports, "makeYouTubeUrl", function() {
    return makeYouTubeUrl;
});
parcelHelpers.export(exports, "checkAccess", function() {
    return checkAccess;
});
parcelHelpers.export(exports, "capitalize", function() {
    return capitalize;
});
parcelHelpers.export(exports, "randomString", function() {
    return randomString;
});
parcelHelpers.export(exports, "mapToObject", function() {
    return mapToObject;
});
parcelHelpers.export(exports, "getSheetId", function() {
    return getSheetId;
});
parcelHelpers.export(exports, "pathBase", function() {
    return pathBase;
});
parcelHelpers.export(exports, "prepareFileName", function() {
    return prepareFileName;
});
parcelHelpers.export(exports, "stripTags", function() {
    return stripTags;
});
parcelHelpers.export(exports, "saveCurrentPath", function() {
    return saveCurrentPath;
});
parcelHelpers.export(exports, "getTZOffsetHours", function() {
    return getTZOffsetHours;
});
parcelHelpers.export(exports, "getUTCNormalizedDate", function() {
    return getUTCNormalizedDate;
});
parcelHelpers.export(exports, "showLoader", function() {
    return showLoader;
});
parcelHelpers.export(exports, "hideLoader", function() {
    return hideLoader;
});
parcelHelpers.export(exports, "setPageNumber", function() {
    return setPageNumber;
});
parcelHelpers.export(exports, "formatDate", function() {
    return formatDate;
});
parcelHelpers.export(exports, "unique", function() {
    return unique;
});
parcelHelpers.export(exports, "stringToArray", function() {
    return stringToArray;
});
parcelHelpers.export(exports, "asyncapirequest", function() {
    return asyncapirequest;
});
parcelHelpers.export(exports, "slugify", function() {
    return slugify;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _momentDurationFormat = require("moment-duration-format");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _dateFns = require("date-fns");
var _configuration = require("../js/Configuration");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var SECONDS_HOUR = 3600;
var SECONDS_MINUTE = 60;
var SECONDS_DAY = 86400;
var debounce = function(delay, fn) {
    var timerId;
    return function debounce() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(function() {
            fn.apply(void 0, (0, _toConsumableArray._)(args));
            timerId = null;
        }, delay);
    };
};
var getAuthData = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var authd_string = window.sessionStorage.getItem("ava_auth");
    var authd_json;
    if (!authd_string) return;
    authd_json = JSON.parse(authd_string);
    if (!!item) return authd_json[item];
    else return authd_json;
};
var setAuthData = function(auth_data) {
    try {
        window.sessionStorage.setItem("ava_auth", JSON.stringify(auth_data));
    } catch (error) {
        console.log(error);
    }
};
var updateAuthData = function(data_obj) {
    var authd_string = window.sessionStorage.getItem("ava_auth");
    if (!authd_string) return;
    var authd_json = JSON.parse(authd_string);
    var updated = Object.assign(authd_json, data_obj);
    setAuthData(updated);
};
var removeAuthData = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (item) {
        var data = window.sessionStorage.getItem("ava_auth");
        if (data) {
            data = JSON.parse(data);
            delete data[item];
            setAuthData(data);
        }
    } else window.sessionStorage.removeItem("ava_auth");
};
var numberFormat = function(number) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    var num = Number.isNaN(+number) ? 0 : +number;
    var x = 0;
    var fnum = [];
    var digits = (num + "").split("");
    var seg = digits.length / 3;
    while(x < seg){
        fnum[x] = digits.splice(-3).join("");
        x++;
    }
    return fnum.reverse().join(separator);
};
var apiError = function(error) {
    console.log(error);
    alert("Oh dear. Something went wrong. This is probably an issue with the server. Please tell an administrator.");
};
var apirequest = function(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, callback = arguments.length > 2 ? arguments[2] : void 0;
    var defaultOptions = {
        method: "POST",
        mode: "cors",
        credentials: "include"
    };
    var url = "https://ava.1021creative.com/ava/api/api/".concat(path);
    return fetch(url, Object.assign(defaultOptions, options)).then(function(response1) {
        if (response1.ok) return response1.json();
        else if (+response1.status === 401) {
            window.alert("You need to log in again");
            removeAuthData();
            window.location.href = "/";
        } else {
            var error = "";
            switch(+response1.status){
                case 504:
                    error = "You asked AVA to process a lot of videos, and it's struggling. Try using two separate sheets. [ERROR: ".concat(response1.status, "]");
                    break;
                // When importing spreadsheets.
                case 403:
                    error = "".concat(response1.statusText, " [ERROR: ").concat(response1.status, "]");
                    break;
                case 460:
                    error = "".concat(response1.statusText, " [ERROR: ").concat(response1.status, "]");
                    break;
                default:
                    error = "Whoops! Look like we missed that bug in testing. [ERROR: ".concat(response1.status, "]");
            }
            window.alert(error);
        }
    }).then(callback).catch(apiError);
};
var csvrequest = function(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, callback = arguments.length > 2 ? arguments[2] : void 0;
    var defaultOptions = {
        method: "POST",
        mode: "cors",
        credentials: "include"
    };
    var url = "https://ava.1021creative.com/ava/api/api/".concat(path);
    return fetch(url, Object.assign(defaultOptions, options)).then(callback).catch(apiError);
};
var truncateString = function() {
    var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50;
    var shortened = str.length > length ? "".concat(str.substr(0, length).trim(), "...") : str;
    return shortened;
};
var rfc3339Date = function(timeStringOrStamp) {
    var output = new Date(timeStringOrStamp);
    var month = (output.getUTCMonth() + 1).toString();
    var ddate = output.getUTCDate().toString();
    var m = month.length > 1 ? month : padTimePart(month);
    var d = ddate.length > 1 ? ddate : padTimePart(ddate);
    return "".concat(output.getFullYear(), "-").concat(m, "-").concat(d, "T00:00:00Z");
};
var yyyymmdd = function(timeStringOrStamp) {
    var ts = new Date(timeStringOrStamp);
    var month = ts.getUTCMonth() + 1;
    var ddate = ts.getUTCDate();
    var m = month.toString().length > 1 ? month : padTimePart(month);
    var d = ddate.toString().length > 1 ? ddate : padTimePart(ddate);
    return "".concat(ts.getFullYear(), "-").concat(m, "-").concat(d);
};
var mysqlTimeStamp = function(timestamp) {
    // 2020-06-29 14:08:13
    return (0, _dateFns.format)(new Date(timestamp), "yyyy-LL-dd k:mm:ss");
};
var getSortDirection = function(sortdir) {
    var direction = [
        "descending",
        "ascending"
    ];
    var dirKey = +sortdir;
    return direction[dirKey];
};
var totalRunTime = function() {
    var arrayOfVideos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (arrayOfVideos.length === 0) return;
    var totalSeconds = arrayOfVideos.map(function(vid) {
        return +vid.duration || +vid.Duration || 0;
    }) // Get the durations.
    .filter(function(duration) {
        return !window.isNaN(duration);
    }) // Filter out potential NaN values
    .reduce(function(accumulator, currentValue) {
        return currentValue + accumulator;
    }); // Total it all up.
    return totalSeconds;
};
var isAdmin = function(projectId) {
    if (!projectId) throw "isAdmin needs a project identifier.";
    var returnValue = false;
    var permissions = getAuthData("permissions") || [];
    var hasAccess = permissions.find(function(p) {
        return p.pid === projectId;
    });
    if (hasAccess && hasAccess.hasOwnProperty("role")) returnValue = hasAccess.role > (0, _configuration.USER_PERMISSIONS_LEVELS)[0].value;
    return returnValue;
};
var canAdminProject = function() {
    var projectName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var perms = getAuthData("permissions");
    if (!perms) return;
    if (!perms.length) return;
    var role = perms.find(function(p) {
        return p.name === projectName;
    });
    var returnValue = false;
    if (role && role.hasOwnProperty("role")) returnValue = role.role >= (0, _configuration.USER_PERMISSIONS_LEVELS)[1].value;
    return returnValue;
};
var padTimePart = function(timepart) {
    var tp = timepart.toString();
    return tp.padStart(2, "0");
};
var formatTime = function(seconds) {
    var usedays = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var timestring = [];
    var days;
    var secs;
    if (usedays && seconds > SECONDS_DAY) {
        days = Math.floor(seconds / SECONDS_DAY);
        timestring.concat([
            "".concat(days, " days, ")
        ]);
        secs = seconds - days * SECONDS_DAY;
    } else secs = seconds;
    if (!secs) timestring = [
        "00",
        ":00"
    ];
    else if (secs < SECONDS_MINUTE) timestring = [
        "00",
        ":".concat(padTimePart(secs))
    ];
    else {
        var hours = secs / SECONDS_HOUR;
        var hh = Math.floor(hours);
        var minutes = hh >= 1 ? hours % hh * SECONDS_MINUTE : hours * SECONDS_MINUTE;
        var mm = Math.floor(minutes);
        var sseconds = +Number.parseFloat(minutes % mm).toPrecision(5);
        var ss = Number.isNaN(sseconds) ? 0 : Math.floor(sseconds * SECONDS_MINUTE);
        var hpart = hh === 0 ? null : "".concat(padTimePart(hh));
        timestring.push(":".concat(padTimePart(mm)));
        timestring.push(":".concat(padTimePart(ss)));
        if (hh > 0) timestring.unshift(hpart);
        if (days) timestring.unshift("".concat(days, "d "));
    }
    // Remove : when it's the first character.
    return timestring.join("").replace(/^:/, "");
};
var isEmptyObject = function(obj) {
    return !Object.entries(obj).length;
};
var getVideoData = function(id) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", id);
    fd.set("token", getAuthData("token"));
    var options = {
        method: "POST",
        body: fd
    };
    apirequest((0, _configuration.API_VIDEO_INFO), options, callback);
};
var meetsMinLength = function(string) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
    return string.length >= length;
};
var isSameString = function(string1, string2) {
    return string1 === string2;
};
var forceDownload = function(response1) {
    var cdheader = response1.headers.get("Content-Disposition");
    var filename = cdheader.replace('attachment; filename="', "").replace('"', "");
    response1.blob().then(function(csvblob) {
        var a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        var url = window.URL.createObjectURL(csvblob);
        a.href = url;
        a.download = filename;
        //programatically click the link to trigger the download
        a.click();
        //release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
    });
};
var pushDownload = function(data) {
    var sheetID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", sheetName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var blob = new Blob([
        convertArrayToCSV(data)
    ], {
        type: "text/csv;charset=utf-8"
    });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    // Filter out empty segments.
    var fn = [
        sheetID,
        sheetName
    ].filter(function(s) {
        return s != "";
    }).join("_");
    a.style = "display: none";
    document.body.appendChild(a);
    a.href = url;
    a.download = "".concat(fn, ".csv");
    a.click(); // programatically click the link to trigger the download
    //release the reference to the file by revoking the Object URL
    window.URL.revokeObjectURL(url);
    // Delete the link.
    document.body.removeChild(a);
};
var isNumeric = function(value) {
    return !Number.isNaN(parseFloat(value, 10));
};
var formatString = function(template) {
    var replacements = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var findRegExp = /%s/g;
    if (!template) throw new Error("formatString: Argument `template` can not be null");
    if (!replacements.length) throw new Error("formatString: Argument `replacements` can not be null");
    // Find placeholders in the template
    var finds = template.match(findRegExp);
    if (finds.length != replacements.length) throw new Error("formatString: There should be an equal number of placeholders and replacements.");
    var tpl = template;
    for(var i = 0; i < finds.length; i++)tpl = tpl.replace(finds[i], replacements[i]);
    return tpl;
};
var range = function(min, max) {
    var diff = max - min;
    var spread = (0, _toConsumableArray._)(Array(diff).keys()).map(function(n) {
        return n + min;
    });
    spread.push(max);
    return spread;
};
var percentage = function(total, portion) {
    return portion / total * 100;
};
var precision = function(floatValue) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var mult = Math.pow(10, precision);
    var prec;
    if (precision < 0) throw new Error("Argument `precision` must be greater than or equal to 0");
    if (precision == 1) prec = Math.trunc(floatValue * mult) / mult;
    else prec = Math.round(floatValue * mult) / mult;
    return prec;
};
var convertArrayToCSV = function(data) {
    return data.join("\n");
};
var shuffle = function(arrayToShuffle) {
    var tmp, current, top = arrayToShuffle.length;
    if (top) while(--top){
        current = Math.floor(Math.random() * (top + 1));
        tmp = arrayToShuffle[current];
        arrayToShuffle[current] = arrayToShuffle[top];
        arrayToShuffle[top] = tmp;
    }
    return arrayToShuffle;
};
var youtubeURL = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ytid = id.trim();
    return "https://youtube.com/watch?v=".concat(ytid);
};
var youtubeThumbnailURL = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ytid = id.trim();
    return "https://i.ytimg.com/vi/".concat(ytid, "/hqdefault.jpg");
};
var arraychunk = function(array, groupsize) {
    var sets = [];
    var chunks = array.length / groupsize;
    for(var i = 0, x = 0; i < chunks; i++, x += groupsize)sets[i] = array.slice(x, x + groupsize);
    return sets;
};
var getDuration = function getDuration(_duration) {
    if (!_duration) return "00:00";
    // temp hack fix until the database is cleared of the old dates.
    if (_duration.toString().indexOf(":") > -1) return _duration;
    var duration = (0, _momentDefault.default).duration(_duration, "seconds").format("hh:mm:ss");
    if (duration.indexOf(":") === -1) duration = "00:" + duration;
    return duration;
};
var expandShortYouTubeUrl = function(shortUrl) {
    return shortUrl.replace(/http(|s):\/\/youtu\.be\//, "https://www.youtube.com/watch?v=");
};
var extractYouTubeIdFromUrl = function(url) {
    var ytid = "";
    try {
        var urlObj = new URL(url);
        ytid = urlObj.searchParams.get("v");
    } catch (err) {
        ytid = url;
    }
    return ytid;
};
var makeYouTubeUrl = function(identifier) {
    return "https://www.youtube.com/watch?v=".concat(identifier);
};
var checkAccess = function(projectId) {
    if (!getAuthData("permissions")) return false;
    var permissions = Object.values(getAuthData("permissions"));
    return permissions.find(function(pm) {
        return projectId === pm.pid;
    });
};
var capitalize = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var randomString = function() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
    // Ripped and adapted https://gist.github.com/6174/6062387#gistcomment-2742945
    return (0, _toConsumableArray._)(Array(length)).map(function(_) {
        return (Math.random() * 36 | 0).toString(36);
    }).join(_templateObject());
};
var mapToObject = function(mapObject) {
    var returnValue = {};
    if (mapObject && Object.prototype.toString.call(mapObject) == "[object Map]") returnValue = Object.fromEntries(mapObject);
    return returnValue;
};
var getSheetId = function(url) {
    if (!url) return;
    // Uses the RegEx found here: https://developers.google.com/sheets/api/guides/concepts
    var id = url.toString().match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
    return id[1]; // Return the alpha-numeric sheet ID.
};
var pathBase = function(locationString) {
    var segments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return locationString.split("/").filter(function(f) {
        return f.length;
    }).slice(0, segments).join("/");
};
var prepareFileName = function(input) {
    return input.replace(/\s/g, "_").replace(/\W/g, "");
};
var stripTags = function(input) {
    return input.replace((0, _configuration.STRIP_TAGS_REGEX), "").trim();
};
var saveCurrentPath = function() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    window.sessionStorage.setItem("ava_last_path", path);
};
var getTZOffsetHours = function(offsetSeconds) {
    if (!offsetSeconds) return;
    return Math.floor(offsetSeconds / 60);
};
var getUTCNormalizedDate = function(date) {
    if (!date) return;
    var getTZoffset = new Date(date).getTimezoneOffset();
    var tzOffset = getTZOffsetHours(getTZoffset);
    var nDate = new Date(date).setUTCHours(tzOffset);
    return nDate;
};
var showLoader = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        loading: true
    });
};
var hideLoader = function() {
    return {
        loading: false
    };
};
var setPageNumber = function(pageValue, detailObj) {
    var pg;
    switch(pageValue){
        case "previous":
            pg = +detailObj.page - 1;
            break;
        case "next":
            pg = +detailObj.page + 1;
            break;
        case "first":
        case Number.isNaN(pageValue):
            pg = 1;
            break;
        case "last":
            pg = +detailObj.pages;
            break;
        default:
            pg = +pageValue;
    }
    return pg;
};
var formatDate = function(date, dformat) {
    var d = date;
    if ((0, _dateFns.isValid)(new Date(date))) d = (0, _dateFns.format)(new Date(date), dformat);
    return d;
};
var unique = function(inputArray) {
    var returnAsArray = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var uniq = new Set(inputArray);
    if (returnAsArray) uniq = Array.from(uniq);
    return uniq;
};
var stringToArray = function(string) {
    return string.split(/[,\s]/);
};
function asyncapirequest(path) {
    return _asyncapirequest.apply(this, arguments);
}
function _asyncapirequest() {
    _asyncapirequest = (0, _asyncToGenerator._)(function(path) {
        var options, callback, defaultOptions, url, _$error, json, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, callback = _arguments.length > 2 ? _arguments[2] : void 0;
                    defaultOptions = {
                        method: "POST",
                        mode: "cors",
                        credentials: "include"
                    };
                    url = "https://ava.1021creative.com/ava/api/api/".concat(path);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url, (0, _objectSpread._)({}, defaultOptions, options))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        ;
                        switch(+response.status){
                            case 504:
                                _$error = "You asked AVA to process a lot of videos, and it's struggling. Try using two separate sheets. [ERROR: ".concat(response.status, "]");
                                break;
                            // When importing spreadsheets.
                            case 403:
                                _$error = "".concat(response.statusText, " [ERROR: ").concat(response.status, "]");
                                break;
                            case 460:
                                _$error = "".concat(response.statusText, " [ERROR: ").concat(response.status, "]");
                                break;
                            default:
                                _$error = "Whoops! Look like we missed that bug in testing. [ERROR: ".concat(response.status, "]");
                        }
                        throw new Error(_$error);
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    callback(json);
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _asyncapirequest.apply(this, arguments);
}
var slugify = function(input) {
    return input.replace(/\s/g, "_");
};

},{"@swc/helpers/_/_async_to_generator":"2CamX","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_tagged_template_literal":"3A9LD","@swc/helpers/_/_to_consumable_array":"fRXIP","@swc/helpers/_/_ts_generator":"7uYyU","moment-duration-format":"j3R5E","moment":"dlnAo","date-fns":"lnGwj","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3A9LD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _tagged_template_literal;
});
function _tagged_template_literal(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j3R5E":[function(require,module,exports) {
/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "moment"
    ], factory);
    else // Node. Does not work with strict CommonJS, but only CommonJS-like
    // enviroments that support module.exports, like Node.
    try {
        module.exports = factory(require("c0e681fd6f9f0a08"));
    } catch (e) {
        // If moment is not available, leave the setup up to the user.
        // Like when using moment-timezone or similar moment-based package.
        module.exports = factory;
    }
    if (root) // Globals.
    root.momentDurationFormatSetup = root.moment ? factory(root.moment) : factory;
})(this, function(moment) {
    // `Number#tolocaleString` is tested on plugin initialization.
    // If the feature test passes, `toLocaleStringWorks` will be set to `true` and the
    // native function will be used to generate formatted output. If the feature
    // test fails, the fallback format function internal to this plugin will be
    // used.
    var toLocaleStringWorks = false;
    // `Number#toLocaleString` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `toLocaleString` will be used for formatting,
    // the plugin will "pre-round" number values using the fallback number format
    // function before passing them to `toLocaleString` for final formatting.
    var toLocaleStringRoundingWorks = false;
    // `Intl.NumberFormat#format` is tested on plugin initialization.
    // If the feature test passes, `intlNumberFormatRoundingWorks` will be set to
    // `true` and the native function will be used to generate formatted output.
    // If the feature test fails, either `Number#tolocaleString` (if
    // `toLocaleStringWorks` is `true`), or the fallback format function internal
    //  to this plugin will be used.
    var intlNumberFormatWorks = false;
    // `Intl.NumberFormat#format` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `Intl.NumberFormat#format` will be used for
    // formatting, the plugin will "pre-round" number values using the fallback number
    // format function before passing them to `Intl.NumberFormat#format` for final
    // formatting.
    var intlNumberFormatRoundingWorks = false;
    // Token type names in order of descending magnitude.
    var types = "escape years months weeks days hours minutes seconds milliseconds general".split(" ");
    var bubbles = [
        {
            type: "seconds",
            targets: [
                {
                    type: "minutes",
                    value: 60
                },
                {
                    type: "hours",
                    value: 3600
                },
                {
                    type: "days",
                    value: 86400
                },
                {
                    type: "weeks",
                    value: 604800
                },
                {
                    type: "months",
                    value: 2678400
                },
                {
                    type: "years",
                    value: 31536000
                }
            ]
        },
        {
            type: "minutes",
            targets: [
                {
                    type: "hours",
                    value: 60
                },
                {
                    type: "days",
                    value: 1440
                },
                {
                    type: "weeks",
                    value: 10080
                },
                {
                    type: "months",
                    value: 44640
                },
                {
                    type: "years",
                    value: 525600
                }
            ]
        },
        {
            type: "hours",
            targets: [
                {
                    type: "days",
                    value: 24
                },
                {
                    type: "weeks",
                    value: 168
                },
                {
                    type: "months",
                    value: 744
                },
                {
                    type: "years",
                    value: 8760
                }
            ]
        },
        {
            type: "days",
            targets: [
                {
                    type: "weeks",
                    value: 7
                },
                {
                    type: "months",
                    value: 31
                },
                {
                    type: "years",
                    value: 365
                }
            ]
        },
        {
            type: "months",
            targets: [
                {
                    type: "years",
                    value: 12
                }
            ]
        }
    ];
    // stringIncludes
    function stringIncludes(str, search) {
        if (search.length > str.length) return false;
        return str.indexOf(search) !== -1;
    }
    // repeatZero(qty)
    // Returns "0" repeated `qty` times.
    // `qty` must be a integer >= 0.
    function repeatZero(qty) {
        var result = "";
        while(qty){
            result += "0";
            qty -= 1;
        }
        return result;
    }
    function stringRound(digits) {
        var digitsArray = digits.split("").reverse();
        var i = 0;
        var carry = true;
        while(carry && i < digitsArray.length){
            if (i) {
                if (digitsArray[i] === "9") digitsArray[i] = "0";
                else {
                    digitsArray[i] = (parseInt(digitsArray[i], 10) + 1).toString();
                    carry = false;
                }
            } else {
                if (parseInt(digitsArray[i], 10) < 5) carry = false;
                digitsArray[i] = "0";
            }
            i += 1;
        }
        if (carry) digitsArray.push("1");
        return digitsArray.reverse().join("");
    }
    // cachedNumberFormat
    // Returns an `Intl.NumberFormat` instance for the given locale and configuration.
    // On first use of a particular configuration, the instance is cached for fast
    // repeat access.
    function cachedNumberFormat(locale, options) {
        // Create a sorted, stringified version of `options`
        // for use as part of the cache key
        var optionsString = map(keys(options).sort(), function(key) {
            return key + ":" + options[key];
        }).join(",");
        // Set our cache key
        var cacheKey = locale + "+" + optionsString;
        // If we don't have this configuration cached, configure and cache it
        if (!cachedNumberFormat.cache[cacheKey]) cachedNumberFormat.cache[cacheKey] = Intl.NumberFormat(locale, options);
        // Return the cached version of this configuration
        return cachedNumberFormat.cache[cacheKey];
    }
    cachedNumberFormat.cache = {};
    // formatNumber
    // Formats any number greater than or equal to zero using these options:
    // - userLocale
    // - useToLocaleString
    // - useGrouping
    // - grouping
    // - maximumSignificantDigits
    // - minimumIntegerDigits
    // - fractionDigits
    // - groupingSeparator
    // - decimalSeparator
    //
    // `useToLocaleString` will use `Intl.NumberFormat` or `toLocaleString` for formatting.
    // `userLocale` option is passed through to the formatting function.
    // `fractionDigits` is passed through to `maximumFractionDigits` and `minimumFractionDigits`
    // Using `maximumSignificantDigits` will override `minimumIntegerDigits` and `fractionDigits`.
    function formatNumber(number, options, userLocale) {
        var useToLocaleString = options.useToLocaleString;
        var useGrouping = options.useGrouping;
        var grouping = useGrouping && options.grouping.slice();
        var maximumSignificantDigits = options.maximumSignificantDigits;
        var minimumIntegerDigits = options.minimumIntegerDigits || 1;
        var fractionDigits = options.fractionDigits || 0;
        var groupingSeparator = options.groupingSeparator;
        var decimalSeparator = options.decimalSeparator;
        if (useToLocaleString && userLocale) {
            var localeStringOptions = {
                minimumIntegerDigits: minimumIntegerDigits,
                useGrouping: useGrouping
            };
            if (fractionDigits) {
                localeStringOptions.maximumFractionDigits = fractionDigits;
                localeStringOptions.minimumFractionDigits = fractionDigits;
            }
            // toLocaleString output is "0.0" instead of "0" for HTC browsers
            // when maximumSignificantDigits is set. See #96.
            if (maximumSignificantDigits && number > 0) localeStringOptions.maximumSignificantDigits = maximumSignificantDigits;
            if (intlNumberFormatWorks) {
                if (!intlNumberFormatRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }
                return cachedNumberFormat(userLocale, localeStringOptions).format(number);
            } else {
                if (!toLocaleStringRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }
                return number.toLocaleString(userLocale, localeStringOptions);
            }
        }
        var numberString;
        // Add 1 to digit output length for floating point errors workaround. See below.
        if (maximumSignificantDigits) numberString = number.toPrecision(maximumSignificantDigits + 1);
        else numberString = number.toFixed(fractionDigits + 1);
        var integerString;
        var fractionString;
        var exponentString;
        var temp = numberString.split("e");
        exponentString = temp[1] || "";
        temp = temp[0].split(".");
        fractionString = temp[1] || "";
        integerString = temp[0] || "";
        // Workaround for floating point errors in `toFixed` and `toPrecision`.
        // (3.55).toFixed(1); --> "3.5"
        // (123.55 - 120).toPrecision(2); --> "3.5"
        // (123.55 - 120); --> 3.549999999999997
        // (123.55 - 120).toFixed(2); --> "3.55"
        // Round by examing the string output of the next digit.
        // *************** Implement String Rounding here ***********************
        // Check integerString + fractionString length of toPrecision before rounding.
        // Check length of fractionString from toFixed output before rounding.
        var integerLength = integerString.length;
        var fractionLength = fractionString.length;
        var digitCount = integerLength + fractionLength;
        var digits = integerString + fractionString;
        if (maximumSignificantDigits && digitCount === maximumSignificantDigits + 1 || !maximumSignificantDigits && fractionLength === fractionDigits + 1) {
            // Round digits.
            digits = stringRound(digits);
            if (digits.length === digitCount + 1) integerLength = integerLength + 1;
            // Discard final fractionDigit.
            if (fractionLength) digits = digits.slice(0, -1);
            // Separate integer and fraction.
            integerString = digits.slice(0, integerLength);
            fractionString = digits.slice(integerLength);
        }
        // Trim trailing zeroes from fractionString because toPrecision outputs
        // precision, not significant digits.
        if (maximumSignificantDigits) fractionString = fractionString.replace(/0*$/, "");
        // Handle exponent.
        var exponent = parseInt(exponentString, 10);
        if (exponent > 0) {
            if (fractionString.length <= exponent) {
                fractionString = fractionString + repeatZero(exponent - fractionString.length);
                integerString = integerString + fractionString;
                fractionString = "";
            } else {
                integerString = integerString + fractionString.slice(0, exponent);
                fractionString = fractionString.slice(exponent);
            }
        } else if (exponent < 0) {
            fractionString = repeatZero(Math.abs(exponent) - integerString.length) + integerString + fractionString;
            integerString = "0";
        }
        if (!maximumSignificantDigits) {
            // Trim or pad fraction when not using maximumSignificantDigits.
            fractionString = fractionString.slice(0, fractionDigits);
            if (fractionString.length < fractionDigits) fractionString = fractionString + repeatZero(fractionDigits - fractionString.length);
            // Pad integer when using minimumIntegerDigits
            // and not using maximumSignificantDigits.
            if (integerString.length < minimumIntegerDigits) integerString = repeatZero(minimumIntegerDigits - integerString.length) + integerString;
        }
        var formattedString = "";
        // Handle grouping.
        if (useGrouping) {
            temp = integerString;
            var group;
            while(temp.length){
                if (grouping.length) group = grouping.shift();
                if (formattedString) formattedString = groupingSeparator + formattedString;
                formattedString = temp.slice(-group) + formattedString;
                temp = temp.slice(0, -group);
            }
        } else formattedString = integerString;
        // Add decimalSeparator and fraction.
        if (fractionString) formattedString = formattedString + decimalSeparator + fractionString;
        return formattedString;
    }
    // durationLabelCompare
    function durationLabelCompare(a, b) {
        if (a.label.length > b.label.length) return -1;
        if (a.label.length < b.label.length) return 1;
        // a must be equal to b
        return 0;
    }
    // durationGetLabels
    function durationGetLabels(token, localeData) {
        var labels = [];
        each(keys(localeData), function(localeDataKey) {
            if (localeDataKey.slice(0, 15) !== "_durationLabels") return;
            var labelType = localeDataKey.slice(15).toLowerCase();
            each(keys(localeData[localeDataKey]), function(labelKey) {
                if (labelKey.slice(0, 1) === token) labels.push({
                    type: labelType,
                    key: labelKey,
                    label: localeData[localeDataKey][labelKey]
                });
            });
        });
        return labels;
    }
    // durationPluralKey
    function durationPluralKey(token, integerValue, decimalValue) {
        // Singular for a value of `1`, but not for `1.0`.
        if (integerValue === 1 && decimalValue === null) return token;
        return token + token;
    }
    var engLocale = {
        durationLabelsStandard: {
            S: "millisecond",
            SS: "milliseconds",
            s: "second",
            ss: "seconds",
            m: "minute",
            mm: "minutes",
            h: "hour",
            hh: "hours",
            d: "day",
            dd: "days",
            w: "week",
            ww: "weeks",
            M: "month",
            MM: "months",
            y: "year",
            yy: "years"
        },
        durationLabelsShort: {
            S: "msec",
            SS: "msecs",
            s: "sec",
            ss: "secs",
            m: "min",
            mm: "mins",
            h: "hr",
            hh: "hrs",
            d: "dy",
            dd: "dys",
            w: "wk",
            ww: "wks",
            M: "mo",
            MM: "mos",
            y: "yr",
            yy: "yrs"
        },
        durationTimeTemplates: {
            HMS: "h:mm:ss",
            HM: "h:mm",
            MS: "m:ss"
        },
        durationLabelTypes: [
            {
                type: "standard",
                string: "__"
            },
            {
                type: "short",
                string: "_"
            }
        ],
        durationPluralKey: durationPluralKey
    };
    // isArray
    function isArray(array) {
        return Object.prototype.toString.call(array) === "[object Array]";
    }
    // isObject
    function isObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }
    // findLast
    function findLast(array, callback) {
        var index = array.length;
        while(index -= 1){
            if (callback(array[index])) return array[index];
        }
    }
    // find
    function find(array, callback) {
        var index = 0;
        var max = array && array.length || 0;
        var match;
        if (typeof callback !== "function") {
            match = callback;
            callback = function callback(item) {
                return item === match;
            };
        }
        while(index < max){
            if (callback(array[index])) return array[index];
            index += 1;
        }
    }
    // each
    function each(array, callback) {
        var index = 0, max = array.length;
        if (!array || !max) return;
        while(index < max){
            if (callback(array[index], index) === false) return;
            index += 1;
        }
    }
    // map
    function map(array, callback) {
        var index = 0, max = array.length, ret = [];
        if (!array || !max) return ret;
        while(index < max){
            ret[index] = callback(array[index], index);
            index += 1;
        }
        return ret;
    }
    // pluck
    function pluck(array, prop) {
        return map(array, function(item) {
            return item[prop];
        });
    }
    // compact
    function compact(array) {
        var ret = [];
        each(array, function(item) {
            if (item) ret.push(item);
        });
        return ret;
    }
    // unique
    function unique(array) {
        var ret = [];
        each(array, function(_a) {
            if (!find(ret, _a)) ret.push(_a);
        });
        return ret;
    }
    // intersection
    function intersection(a, b) {
        var ret = [];
        each(a, function(_a) {
            each(b, function(_b) {
                if (_a === _b) ret.push(_a);
            });
        });
        return unique(ret);
    }
    // rest
    function rest(array, callback) {
        var ret = [];
        each(array, function(item, index) {
            if (!callback(item)) {
                ret = array.slice(index);
                return false;
            }
        });
        return ret;
    }
    // initial
    function initial(array, callback) {
        var reversed = array.slice().reverse();
        return rest(reversed, callback).reverse();
    }
    // extend
    function extend(a, b) {
        for(var key in b)if (b.hasOwnProperty(key)) a[key] = b[key];
        return a;
    }
    // keys
    function keys(a) {
        var ret = [];
        for(var key in a)if (a.hasOwnProperty(key)) ret.push(key);
        return ret;
    }
    // any
    function any(array, callback) {
        var index = 0, max = array.length;
        if (!array || !max) return false;
        while(index < max){
            if (callback(array[index], index) === true) return true;
            index += 1;
        }
        return false;
    }
    // flatten
    function flatten(array) {
        var ret = [];
        each(array, function(child) {
            ret = ret.concat(child);
        });
        return ret;
    }
    function toLocaleStringSupportsLocales() {
        var number = 0;
        try {
            number.toLocaleString("i");
        } catch (e) {
            return e.name === "RangeError";
        }
        return false;
    }
    function featureTestFormatterRounding(formatter) {
        return formatter(3.55, "en", {
            useGrouping: false,
            minimumIntegerDigits: 1,
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }) === "3.6";
    }
    function featureTestFormatter(formatter) {
        var passed = true;
        // Test minimumIntegerDigits.
        passed = passed && formatter(1, "en", {
            minimumIntegerDigits: 1
        }) === "1";
        passed = passed && formatter(1, "en", {
            minimumIntegerDigits: 2
        }) === "01";
        passed = passed && formatter(1, "en", {
            minimumIntegerDigits: 3
        }) === "001";
        if (!passed) return false;
        // Test maximumFractionDigits and minimumFractionDigits.
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        }) === "100.0";
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        }) === "99.99";
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 3,
            minimumFractionDigits: 3
        }) === "99.990";
        if (!passed) return false;
        // Test maximumSignificantDigits.
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 1
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 2
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 3
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 4
        }) === "99.99";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 5
        }) === "99.99";
        if (!passed) return false;
        // Test grouping.
        passed = passed && formatter(1000, "en", {
            useGrouping: true
        }) === "1,000";
        passed = passed && formatter(1000, "en", {
            useGrouping: false
        }) === "1000";
        if (!passed) return false;
        return true;
    }
    // durationsFormat(durations [, template] [, precision] [, settings])
    function durationsFormat() {
        var args = [].slice.call(arguments);
        var settings = {};
        var durations;
        // Parse arguments.
        each(args, function(arg, index) {
            if (!index) {
                if (!isArray(arg)) throw "Expected array as the first argument to durationsFormat.";
                durations = arg;
            }
            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }
            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }
            if (isObject(arg)) extend(settings, arg);
        });
        if (!durations || !durations.length) return [];
        settings.returnMomentTypes = true;
        var formattedDurations = map(durations, function(dur) {
            return dur.format(settings);
        });
        // Merge token types from all durations.
        var outputTypes = intersection(types, unique(pluck(flatten(formattedDurations), "type")));
        var largest = settings.largest;
        if (largest) outputTypes = outputTypes.slice(0, largest);
        settings.returnMomentTypes = false;
        settings.outputTypes = outputTypes;
        return map(durations, function(dur) {
            return dur.format(settings);
        });
    }
    // durationFormat([template] [, precision] [, settings])
    function durationFormat() {
        var args = [].slice.call(arguments);
        var settings = extend({}, this.format.defaults);
        // Keep a shadow copy of this moment for calculating remainders.
        // Perform all calculations on positive duration value, handle negative
        // sign at the very end.
        var asMilliseconds = this.asMilliseconds();
        var asMonths = this.asMonths();
        // Treat invalid durations as having a value of 0 milliseconds.
        if (typeof this.isValid === "function" && this.isValid() === false) {
            asMilliseconds = 0;
            asMonths = 0;
        }
        var isNegative = asMilliseconds < 0;
        // Two shadow copies are needed because of the way moment.js handles
        // duration arithmetic for years/months and for weeks/days/hours/minutes/seconds.
        var remainder = moment.duration(Math.abs(asMilliseconds), "milliseconds");
        var remainderMonths = moment.duration(Math.abs(asMonths), "months");
        // Parse arguments.
        each(args, function(arg) {
            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }
            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }
            if (isObject(arg)) extend(settings, arg);
        });
        var momentTokens = {
            years: "y",
            months: "M",
            weeks: "w",
            days: "d",
            hours: "h",
            minutes: "m",
            seconds: "s",
            milliseconds: "S"
        };
        var tokenDefs = {
            escape: /\[(.+?)\]/,
            years: /\*?[Yy]+/,
            months: /\*?M+/,
            weeks: /\*?[Ww]+/,
            days: /\*?[Dd]+/,
            hours: /\*?[Hh]+/,
            minutes: /\*?m+/,
            seconds: /\*?s+/,
            milliseconds: /\*?S+/,
            general: /.+?/
        };
        // Types array is available in the template function.
        settings.types = types;
        var typeMap = function typeMap(token) {
            return find(types, function(type) {
                return tokenDefs[type].test(token);
            });
        };
        var tokenizer = new RegExp(map(types, function(type) {
            return tokenDefs[type].source;
        }).join("|"), "g");
        // Current duration object is available in the template function.
        settings.duration = this;
        // Eval template function and cache template string.
        var template = typeof settings.template === "function" ? settings.template.apply(settings) : settings.template;
        // outputTypes and returnMomentTypes are settings to support durationsFormat().
        // outputTypes is an array of moment token types that determines
        // the tokens returned in formatted output. This option overrides
        // trim, largest, stopTrim, etc.
        var outputTypes = settings.outputTypes;
        // returnMomentTypes is a boolean that sets durationFormat to return
        // the processed momentTypes instead of formatted output.
        var returnMomentTypes = settings.returnMomentTypes;
        var largest = settings.largest;
        // Setup stopTrim array of token types.
        var stopTrim = [];
        if (!outputTypes) {
            if (isArray(settings.stopTrim)) settings.stopTrim = settings.stopTrim.join("");
            // Parse stopTrim string to create token types array.
            if (settings.stopTrim) each(settings.stopTrim.match(tokenizer), function(token) {
                var type = typeMap(token);
                if (type === "escape" || type === "general") return;
                stopTrim.push(type);
            });
        }
        // Cache moment's locale data.
        var localeData = moment.localeData();
        if (!localeData) localeData = {};
        // Fall back to this plugin's `eng` extension.
        each(keys(engLocale), function(key) {
            if (typeof engLocale[key] === "function") {
                if (!localeData[key]) localeData[key] = engLocale[key];
                return;
            }
            if (!localeData["_" + key]) localeData["_" + key] = engLocale[key];
        });
        // Replace Duration Time Template strings.
        // For locale `eng`: `_HMS_`, `_HM_`, and `_MS_`.
        each(keys(localeData._durationTimeTemplates), function(item) {
            template = template.replace("_" + item + "_", localeData._durationTimeTemplates[item]);
        });
        // Determine user's locale.
        var userLocale = settings.userLocale || moment.locale();
        var useLeftUnits = settings.useLeftUnits;
        var usePlural = settings.usePlural;
        var precision = settings.precision;
        var forceLength = settings.forceLength;
        var useGrouping = settings.useGrouping;
        var trunc = settings.trunc;
        // Use significant digits only when precision is greater than 0.
        var useSignificantDigits = settings.useSignificantDigits && precision > 0;
        var significantDigits = useSignificantDigits ? settings.precision : 0;
        var significantDigitsCache = significantDigits;
        var minValue = settings.minValue;
        var isMinValue = false;
        var maxValue = settings.maxValue;
        var isMaxValue = false;
        // formatNumber fallback options.
        var useToLocaleString = settings.useToLocaleString;
        var groupingSeparator = settings.groupingSeparator;
        var decimalSeparator = settings.decimalSeparator;
        var grouping = settings.grouping;
        useToLocaleString = useToLocaleString && (toLocaleStringWorks || intlNumberFormatWorks);
        // Trim options.
        var trim = settings.trim;
        if (isArray(trim)) trim = trim.join(" ");
        if (trim === null && (largest || maxValue || useSignificantDigits)) trim = "all";
        if (trim === null || trim === true || trim === "left" || trim === "right") trim = "large";
        if (trim === false) trim = "";
        var trimIncludes = function trimIncludes(item) {
            return item.test(trim);
        };
        var rLarge = /large/;
        var rSmall = /small/;
        var rBoth = /both/;
        var rMid = /mid/;
        var rAll = /^all|[^sm]all/;
        var rFinal = /final/;
        var trimLarge = largest > 0 || any([
            rLarge,
            rBoth,
            rAll
        ], trimIncludes);
        var trimSmall = any([
            rSmall,
            rBoth,
            rAll
        ], trimIncludes);
        var trimMid = any([
            rMid,
            rAll
        ], trimIncludes);
        var trimFinal = any([
            rFinal,
            rAll
        ], trimIncludes);
        // Parse format string to create raw tokens array.
        var rawTokens = map(template.match(tokenizer), function(token, index) {
            var type = typeMap(token);
            if (token.slice(0, 1) === "*") {
                token = token.slice(1);
                if (type !== "escape" && type !== "general") stopTrim.push(type);
            }
            return {
                index: index,
                length: token.length,
                text: "",
                // Replace escaped tokens with the non-escaped token text.
                token: type === "escape" ? token.replace(tokenDefs.escape, "$1") : token,
                // Ignore type on non-moment tokens.
                type: type === "escape" || type === "general" ? null : type
            };
        });
        // Associate text tokens with moment tokens.
        var currentToken = {
            index: 0,
            length: 0,
            token: "",
            text: "",
            type: null
        };
        var tokens = [];
        if (useLeftUnits) rawTokens.reverse();
        each(rawTokens, function(token) {
            if (token.type) {
                if (currentToken.type || currentToken.text) tokens.push(currentToken);
                currentToken = token;
                return;
            }
            if (useLeftUnits) currentToken.text = token.token + currentToken.text;
            else currentToken.text += token.token;
        });
        if (currentToken.type || currentToken.text) tokens.push(currentToken);
        if (useLeftUnits) tokens.reverse();
        // Find unique moment token types in the template in order of
        // descending magnitude.
        var momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));
        // Exit early if there are no moment token types.
        if (!momentTypes.length) return pluck(tokens, "text").join("");
        // Calculate values for each moment type in the template.
        // For processing the settings, values are associated with moment types.
        // Values will be assigned to tokens at the last step in order to
        // assume nothing about frequency or order of tokens in the template.
        momentTypes = map(momentTypes, function(momentType, index) {
            // Is this the least-magnitude moment token found?
            var isSmallest = index + 1 === momentTypes.length;
            // Is this the greatest-magnitude moment token found?
            var isLargest = !index;
            // Get the raw value in the current units.
            var rawValue;
            if (momentType === "years" || momentType === "months") rawValue = remainderMonths.as(momentType);
            else rawValue = remainder.as(momentType);
            var wholeValue = Math.floor(rawValue);
            var decimalValue = rawValue - wholeValue;
            var token = find(tokens, function(token) {
                return momentType === token.type;
            });
            if (isLargest && maxValue && rawValue > maxValue) isMaxValue = true;
            if (isSmallest && minValue && Math.abs(settings.duration.as(momentType)) < minValue) isMinValue = true;
            // Note the length of the largest-magnitude moment token:
            // if it is greater than one and forceLength is not set,
            // then default forceLength to `true`.
            //
            // Rationale is this: If the template is "h:mm:ss" and the
            // moment value is 5 minutes, the user-friendly output is
            // "5:00", not "05:00". We shouldn't pad the `minutes` token
            // even though it has length of two if the template is "h:mm:ss";
            //
            // If the minutes output should always include the leading zero
            // even when the hour is trimmed then set `{ forceLength: true }`
            // to output "05:00". If the template is "hh:mm:ss", the user
            // clearly wanted everything padded so we should output "05:00";
            //
            // If the user wants the full padded output, they can use
            // template "hh:mm:ss" and set `{ trim: false }` to output
            // "00:05:00".
            if (isLargest && forceLength === null && token.length > 1) forceLength = true;
            // Update remainder.
            remainder.subtract(wholeValue, momentType);
            remainderMonths.subtract(wholeValue, momentType);
            return {
                rawValue: rawValue,
                wholeValue: wholeValue,
                // Decimal value is only retained for the least-magnitude
                // moment type in the format template.
                decimalValue: isSmallest ? decimalValue : 0,
                isSmallest: isSmallest,
                isLargest: isLargest,
                type: momentType,
                // Tokens can appear multiple times in a template string,
                // but all instances must share the same length.
                tokenLength: token.length
            };
        });
        var truncMethod = trunc ? Math.floor : Math.round;
        var truncate = function truncate(value, places) {
            var factor = Math.pow(10, places);
            return truncMethod(value * factor) / factor;
        };
        var foundFirst = false;
        var bubbled = false;
        var formatValue = function formatValue(momentType, index) {
            var formatOptions = {
                useGrouping: useGrouping,
                groupingSeparator: groupingSeparator,
                decimalSeparator: decimalSeparator,
                grouping: grouping,
                useToLocaleString: useToLocaleString
            };
            if (useSignificantDigits) {
                if (significantDigits <= 0) {
                    momentType.rawValue = 0;
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                } else {
                    formatOptions.maximumSignificantDigits = significantDigits;
                    momentType.significantDigits = significantDigits;
                }
            }
            if (isMaxValue && !bubbled) {
                if (momentType.isLargest) {
                    momentType.wholeValue = maxValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }
            if (isMinValue && !bubbled) {
                if (momentType.isSmallest) {
                    momentType.wholeValue = minValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }
            if (momentType.isSmallest || momentType.significantDigits && momentType.significantDigits - momentType.wholeValue.toString().length <= 0) {
                // Apply precision to least significant token value.
                if (precision < 0) momentType.value = truncate(momentType.wholeValue, precision);
                else if (precision === 0) momentType.value = truncMethod(momentType.wholeValue + momentType.decimalValue);
                else if (useSignificantDigits) {
                    if (trunc) momentType.value = truncate(momentType.rawValue, significantDigits - momentType.wholeValue.toString().length);
                    else momentType.value = momentType.rawValue;
                    if (momentType.wholeValue) significantDigits -= momentType.wholeValue.toString().length;
                } else {
                    formatOptions.fractionDigits = precision;
                    if (trunc) momentType.value = momentType.wholeValue + truncate(momentType.decimalValue, precision);
                    else momentType.value = momentType.wholeValue + momentType.decimalValue;
                }
            } else if (useSignificantDigits && momentType.wholeValue) {
                // Outer Math.round required here to handle floating point errors.
                momentType.value = Math.round(truncate(momentType.wholeValue, momentType.significantDigits - momentType.wholeValue.toString().length));
                significantDigits -= momentType.wholeValue.toString().length;
            } else momentType.value = momentType.wholeValue;
            if (momentType.tokenLength > 1 && (forceLength || foundFirst)) {
                formatOptions.minimumIntegerDigits = momentType.tokenLength;
                if (bubbled && formatOptions.maximumSignificantDigits < momentType.tokenLength) delete formatOptions.maximumSignificantDigits;
            }
            if (!foundFirst && (momentType.value > 0 || trim === "" /* trim: false */  || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) foundFirst = true;
            momentType.formattedValue = formatNumber(momentType.value, formatOptions, userLocale);
            formatOptions.useGrouping = false;
            formatOptions.decimalSeparator = ".";
            momentType.formattedValueEn = formatNumber(momentType.value, formatOptions, "en");
            if (momentType.tokenLength === 2 && momentType.type === "milliseconds") momentType.formattedValueMS = formatNumber(momentType.value, {
                minimumIntegerDigits: 3,
                useGrouping: false
            }, "en").slice(0, 2);
            return momentType;
        };
        // Calculate formatted values.
        momentTypes = map(momentTypes, formatValue);
        momentTypes = compact(momentTypes);
        // Bubble rounded values.
        if (momentTypes.length > 1) {
            var findType = function findType(type) {
                return find(momentTypes, function(momentType) {
                    return momentType.type === type;
                });
            };
            var bubbleTypes = function bubbleTypes(bubble) {
                var bubbleMomentType = findType(bubble.type);
                if (!bubbleMomentType) return;
                each(bubble.targets, function(target) {
                    var targetMomentType = findType(target.type);
                    if (!targetMomentType) return;
                    if (parseInt(bubbleMomentType.formattedValueEn, 10) === target.value) {
                        bubbleMomentType.rawValue = 0;
                        bubbleMomentType.wholeValue = 0;
                        bubbleMomentType.decimalValue = 0;
                        targetMomentType.rawValue += 1;
                        targetMomentType.wholeValue += 1;
                        targetMomentType.decimalValue = 0;
                        targetMomentType.formattedValueEn = targetMomentType.wholeValue.toString();
                        bubbled = true;
                    }
                });
            };
            each(bubbles, bubbleTypes);
        }
        // Recalculate formatted values.
        if (bubbled) {
            foundFirst = false;
            significantDigits = significantDigitsCache;
            momentTypes = map(momentTypes, formatValue);
            momentTypes = compact(momentTypes);
        }
        if (outputTypes && !(isMaxValue && !settings.trim)) {
            momentTypes = map(momentTypes, function(momentType) {
                if (find(outputTypes, function(outputType) {
                    return momentType.type === outputType;
                })) return momentType;
                return null;
            });
            momentTypes = compact(momentTypes);
        } else {
            // Trim Large.
            if (trimLarge) momentTypes = rest(momentTypes, function(momentType) {
                // Stop trimming on:
                // - the smallest moment type
                // - a type marked for stopTrim
                // - a type that has a whole value
                return !momentType.isSmallest && !momentType.wholeValue && !find(stopTrim, momentType.type);
            });
            // Largest.
            if (largest && momentTypes.length) momentTypes = momentTypes.slice(0, largest);
            // Trim Small.
            if (trimSmall && momentTypes.length > 1) momentTypes = initial(momentTypes, function(momentType) {
                // Stop trimming on:
                // - a type marked for stopTrim
                // - a type that has a whole value
                // - the largest momentType
                return !momentType.wholeValue && !find(stopTrim, momentType.type) && !momentType.isLargest;
            });
            // Trim Mid.
            if (trimMid) {
                momentTypes = map(momentTypes, function(momentType, index) {
                    if (index > 0 && index < momentTypes.length - 1 && !momentType.wholeValue) return null;
                    return momentType;
                });
                momentTypes = compact(momentTypes);
            }
            // Trim Final.
            if (trimFinal && momentTypes.length === 1 && !momentTypes[0].wholeValue && !(!trunc && momentTypes[0].isSmallest && momentTypes[0].rawValue < minValue)) momentTypes = [];
        }
        if (returnMomentTypes) return momentTypes;
        // Localize and pluralize unit labels.
        each(tokens, function(token) {
            var key = momentTokens[token.type];
            var momentType = find(momentTypes, function(momentType) {
                return momentType.type === token.type;
            });
            if (!key || !momentType) return;
            var values = momentType.formattedValueEn.split(".");
            values[0] = parseInt(values[0], 10);
            if (values[1]) values[1] = parseFloat("0." + values[1], 10);
            else values[1] = null;
            var pluralKey = localeData.durationPluralKey(key, values[0], values[1]);
            var labels = durationGetLabels(key, localeData);
            var autoLocalized = false;
            var pluralizedLabels = {};
            // Auto-Localized unit labels.
            each(localeData._durationLabelTypes, function(labelType) {
                var label = find(labels, function(label) {
                    return label.type === labelType.type && label.key === pluralKey;
                });
                if (label) {
                    pluralizedLabels[label.type] = label.label;
                    if (stringIncludes(token.text, labelType.string)) {
                        token.text = token.text.replace(labelType.string, label.label);
                        autoLocalized = true;
                    }
                }
            });
            // Auto-pluralized unit labels.
            if (usePlural && !autoLocalized) {
                labels.sort(durationLabelCompare);
                each(labels, function(label) {
                    if (pluralizedLabels[label.type] === label.label) {
                        if (stringIncludes(token.text, label.label)) // Stop checking this token if its label is already
                        // correctly pluralized.
                        return false;
                        // Skip this label if it is correct, but not present in
                        // the token's text.
                        return;
                    }
                    if (stringIncludes(token.text, label.label)) {
                        // Replece this token's label and stop checking.
                        token.text = token.text.replace(label.label, pluralizedLabels[label.type]);
                        return false;
                    }
                });
            }
        });
        // Build ouptut.
        tokens = map(tokens, function(token) {
            if (!token.type) return token.text;
            var momentType = find(momentTypes, function(momentType) {
                return momentType.type === token.type;
            });
            if (!momentType) return "";
            var out = "";
            if (useLeftUnits) out += token.text;
            if (isNegative && isMaxValue || !isNegative && isMinValue) {
                out += "< ";
                isMaxValue = false;
                isMinValue = false;
            }
            if (isNegative && isMinValue || !isNegative && isMaxValue) {
                out += "> ";
                isMaxValue = false;
                isMinValue = false;
            }
            if (isNegative && (momentType.value > 0 || trim === "" || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                out += "-";
                isNegative = false;
            }
            if (token.type === "milliseconds" && momentType.formattedValueMS) out += momentType.formattedValueMS;
            else out += momentType.formattedValue;
            if (!useLeftUnits) out += token.text;
            return out;
        });
        // Trim leading and trailing comma, space, colon, and dot.
        return tokens.join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, "");
    }
    // defaultFormatTemplate
    function defaultFormatTemplate() {
        var dur = this.duration;
        var findType = function findType(type) {
            return dur._data[type];
        };
        var firstType = find(this.types, findType);
        var lastType = findLast(this.types, findType);
        // Default template strings for each duration dimension type.
        switch(firstType){
            case "milliseconds":
                return "S __";
            case "seconds":
            case "minutes":
                return "*_MS_";
            case "hours":
                return "_HMS_";
            case "days":
                if (firstType === lastType) return "d __";
            case "weeks":
                if (firstType === lastType) return "w __";
                if (this.trim === null) this.trim = "both";
                return "w __, d __, h __";
            case "months":
                if (firstType === lastType) return "M __";
            case "years":
                if (firstType === lastType) return "y __";
                if (this.trim === null) this.trim = "both";
                return "y __, M __, d __";
            default:
                if (this.trim === null) this.trim = "both";
                return "y __, d __, h __, m __, s __";
        }
    }
    // init
    function init(context) {
        if (!context) throw "Moment Duration Format init cannot find moment instance.";
        context.duration.format = durationsFormat;
        context.duration.fn.format = durationFormat;
        context.duration.fn.format.defaults = {
            // Many options are defaulted to `null` to distinguish between
            // 'not set' and 'set to `false`'
            // trim
            // Can be a string, a delimited list of strings, an array of strings,
            // or a boolean.
            // "large" - will trim largest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "small" - will trim smallest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "both" - will execute "large" trim then "small" trim.
            // "mid" - will trim any zero-value tokens that are not the first or
            // last tokens. Usually used in conjunction with "large" or "both".
            // e.g. "large mid" or "both mid".
            // "final" - will trim the final token if it is zero-value. Use this
            // option with "large" or "both" to output an empty string when
            // formatting a zero-value duration. e.g. "large final" or "both final".
            // "all" - Will trim all zero-value tokens. Shorthand for "both mid final".
            // "left" - maps to "large" to support plugin's version 1 API.
            // "right" - maps to "large" to support plugin's version 1 API.
            // `false` - template tokens are not trimmed.
            // `true` - treated as "large".
            // `null` - treated as "large".
            trim: null,
            // stopTrim
            // A moment token string, a delimited set of moment token strings,
            // or an array of moment token strings. Trimming will stop when a token
            // listed in this option is reached. A "*" character in the format
            // template string will also mark a moment token as stopTrim.
            // e.g. "d [days] *h:mm:ss" will always stop trimming at the 'hours' token.
            stopTrim: null,
            // largest
            // Set to a positive integer to output only the "n" largest-magnitude
            // moment tokens that have a value. All lesser-magnitude moment tokens
            // will be ignored. This option takes effect even if `trim` is set
            // to `false`.
            largest: null,
            // maxValue
            // Use `maxValue` to render generalized output for large duration values,
            // e.g. `"> 60 days"`. `maxValue` must be a positive integer and is
            /// applied to the greatest-magnitude moment token in the format template.
            maxValue: null,
            // minValue
            // Use `minValue` to render generalized output for small duration values,
            // e.g. `"< 5 minutes"`. `minValue` must be a positive integer and is
            // applied to the least-magnitude moment token in the format template.
            minValue: null,
            // precision
            // If a positive integer, number of decimal fraction digits to render.
            // If a negative integer, number of integer place digits to truncate to 0.
            // If `useSignificantDigits` is set to `true` and `precision` is a positive
            // integer, sets the maximum number of significant digits used in the
            // formatted output.
            precision: 0,
            // trunc
            // Default behavior rounds final token value. Set to `true` to
            // truncate final token value, which was the default behavior in
            // version 1 of this plugin.
            trunc: false,
            // forceLength
            // Force first moment token with a value to render at full length
            // even when template is trimmed and first moment token has length of 1.
            forceLength: null,
            // userLocale
            // Formatted numerical output is rendered using `toLocaleString`
            // and the locale of the user's environment. Set this option to render
            // numerical output using a different locale. Unit names are rendered
            // and detected using the locale set in moment.js, which can be different
            // from the locale of user's environment.
            userLocale: null,
            // usePlural
            // Will automatically singularize or pluralize unit names when they
            // appear in the text associated with each moment token. Standard and
            // short unit labels are singularized and pluralized, based on locale.
            // e.g. in english, "1 second" or "1 sec" would be rendered instead
            // of "1 seconds" or "1 secs". The default pluralization function
            // renders a plural label for a value with decimal precision.
            // e.g. "1.0 seconds" is never rendered as "1.0 second".
            // Label types and pluralization function are configurable in the
            // localeData extensions.
            usePlural: true,
            // useLeftUnits
            // The text to the right of each moment token in a format string
            // is treated as that token's units for the purposes of trimming,
            // singularizing, and auto-localizing.
            // e.g. "h [hours], m [minutes], s [seconds]".
            // To properly singularize or localize a format string such as
            // "[hours] h, [minutes] m, [seconds] s", where the units appear
            // to the left of each moment token, set useLeftUnits to `true`.
            // This plugin is not tested in the context of rtl text.
            useLeftUnits: false,
            // useGrouping
            // Enables locale-based digit grouping in the formatted output. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useGrouping: true,
            // useSignificantDigits
            // Treat the `precision` option as the maximum significant digits
            // to be rendered. Precision must be a positive integer. Significant
            // digits extend across unit types,
            // e.g. "6 hours 37.5 minutes" represents 4 significant digits.
            // Enabling this option causes token length to be ignored. See  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useSignificantDigits: false,
            // template
            // The template string used to format the duration. May be a function
            // or a string. Template functions are executed with the `this` binding
            // of the settings object so that template strings may be dynamically
            // generated based on the duration object (accessible via `this.duration`)
            // or any of the other settings. Leading and trailing space, comma,
            // period, and colon characters are trimmed from the resulting string.
            template: defaultFormatTemplate,
            // useToLocaleString
            // Set this option to `false` to ignore the `toLocaleString` feature
            // test and force the use of the `formatNumber` fallback function
            // included in this plugin.
            useToLocaleString: true,
            // formatNumber fallback options.
            // When `toLocaleString` is detected and passes the feature test, the
            // following options will have no effect: `toLocaleString` will be used
            // for formatting and the grouping separator, decimal separator, and
            // integer digit grouping will be determined by the user locale.
            // groupingSeparator
            // The integer digit grouping separator used when using the fallback
            // formatNumber function.
            groupingSeparator: ",",
            // decimalSeparator
            // The decimal separator used when using the fallback formatNumber
            // function.
            decimalSeparator: ".",
            // grouping
            // The integer digit grouping used when using the fallback formatNumber
            // function. Must be an array. The default value of `[3]` gives the
            // standard 3-digit thousand/million/billion digit groupings for the
            // "en" locale. Setting this option to `[3, 2]` would generate the
            // thousand/lakh/crore digit groupings used in the "en-IN" locale.
            grouping: [
                3
            ]
        };
        context.updateLocale("en", engLocale);
    }
    // Run feature tests for `Number#toLocaleString`.
    var toLocaleStringFormatter = function toLocaleStringFormatter(number, locale, options) {
        return number.toLocaleString(locale, options);
    };
    toLocaleStringWorks = toLocaleStringSupportsLocales() && featureTestFormatter(toLocaleStringFormatter);
    toLocaleStringRoundingWorks = toLocaleStringWorks && featureTestFormatterRounding(toLocaleStringFormatter);
    // Run feature tests for `Intl.NumberFormat#format`.
    var intlNumberFormatFormatter = function intlNumberFormatFormatter(number, locale, options) {
        if (typeof window !== "undefined" && window && window.Intl && window.Intl.NumberFormat) return window.Intl.NumberFormat(locale, options).format(number);
    };
    intlNumberFormatWorks = featureTestFormatter(intlNumberFormatFormatter);
    intlNumberFormatRoundingWorks = intlNumberFormatWorks && featureTestFormatterRounding(intlNumberFormatFormatter);
    // Initialize duration format on the global moment instance.
    init(moment);
    // Return the init function so that duration format can be
    // initialized on other moment instances.
    return init;
});

},{"c0e681fd6f9f0a08":"dlnAo"}],"dlnAo":[function(require,module,exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var _typeOf = require("@swc/helpers/_/_type_of");
(function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function some(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function keys(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function func() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var _$format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (_$format || !formatUpper) return _$format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var _$format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(_$format) ? _$format(output) : _$format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function func(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function indexOf(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, _$locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                _$locale = loadLocale(split.slice(0, j).join("-"));
                if (_$locale) return _$locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var _$locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    _$locale = loadLocale(config.parentLocale);
                    if (_$locale != null) parentConfig = _$locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var _$locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                _$locale = new Locale(config);
                _$locale.parentLocale = locales[name];
                locales[name] = _$locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var _$locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            _$locale = loadLocale(key);
            if (_$locale) return _$locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, _$format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || _$format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(_$format)) configFromStringAndArray(config);
        else if (_$format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, _$weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + _$weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var _$offset = this.utcOffset(), sign = "+";
            if (_$offset < 0) {
                _$offset = -_$offset;
                sign = "-";
            }
            return sign + zeroFill(~~(_$offset / 60), 2) + separator + zeroFill(~~_$offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, _$diff;
        if (model._isUTC) {
            res = model.clone();
            _$diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + _$diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var _$offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (_$offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - _$offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? _$offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var _$diff = myMoment.diff(now, "days", true);
        return _$diff < -6 ? "sameElse" : _$diff < -1 ? "lastWeek" : _$diff < 0 ? "lastDay" : _$diff < 1 ? "sameDay" : _$diff < 2 ? "nextDay" : _$diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), _$format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[_$format]) ? formats[_$format].call(this, now) : formats[_$format]);
        return this.format(output || this.localeData().calendar(_$format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch((0, _typeOf._)(eras[i].since)){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch((0, _typeOf._)(eras[i].until)){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var _$locale = getLocale(), utc = createUTC().set(setter, index);
        return _$locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var _$locale = getLocale(), shift = localeSorted ? _$locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), _$weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || _$weeks <= 1 && [
            "w"
        ] || _$weeks < thresholds.w && [
            "ww",
            _$weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, _$locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        _$locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, _$locale);
        if (withSuffix) output = _$locale.pastFuture(+this, output);
        return _$locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

},{"@swc/helpers/_/_type_of":"60jEQ"}],"5iVEd":[function(require,module,exports) {
/*
ChannelsUtils.js

Functions that are shared between multiple views in Channels and Groups
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterCriteria", function() {
    return filterCriteria;
});
parcelHelpers.export(exports, "addChannelState", function() {
    return addChannelState;
});
parcelHelpers.export(exports, "stringToArray", function() {
    return stringToArray;
});
parcelHelpers.export(exports, "getGroupNamesFromData", function() {
    return getGroupNamesFromData;
});
parcelHelpers.export(exports, "stateOnPerPageSelect", function() {
    return stateOnPerPageSelect;
});
parcelHelpers.export(exports, "setStateOnGroupListUpdate", function() {
    return setStateOnGroupListUpdate;
});
parcelHelpers.export(exports, "setStateOnShowAddChannel", function() {
    return setStateOnShowAddChannel;
});
parcelHelpers.export(exports, "setStateOnSubmitAddChannel", function() {
    return setStateOnSubmitAddChannel;
});
parcelHelpers.export(exports, "setStateOnCloseAddChannel", function() {
    return setStateOnCloseAddChannel;
});
parcelHelpers.export(exports, "setStateOnAddChannelResponse", function() {
    return setStateOnAddChannelResponse;
});
parcelHelpers.export(exports, "setStateOnAddChannelChange", function() {
    return setStateOnAddChannelChange;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _configuration = require("../js/Configuration");
var _destinationsUtils = require("./DestinationsUtils");
var filterCriteria = {
    filterOn: "channel_title",
    hideCategories: true,
    itemsName: "Channels",
    searchValue: ""
};
var addChannelState = {
    open: false,
    channels: "",
    group: "",
    options: [],
    mode: "adding",
    max: false,
    error: false,
    response: new Map()
};
var stringToArray = function(string) {
    return string.split(/[,\s]/);
};
var getGroupNamesFromData = function(channelData) {
    /* If there's no property, return an empty array */ if (!channelData.hasOwnProperty("groupList")) return [];
    var getGroupName = function(item) {
        return item.group_name;
    };
    var gl = [];
    if (channelData.groupList && channelData.groupList.length) gl = channelData.groupList.map(getGroupName);
    return gl.join(", ");
};
var stateOnPerPageSelect = function(state, value) {
    // Calculate a new page count
    var newpagecount = Math.ceil(state.videos.total / value);
    var pg = state.videos.page;
    // If the current page value is greater than the new page count, reset the
    // new page count too. Otherwise, we'll use the existing count.
    if (state.videos.page > newpagecount) pg = newpagecount;
    return {
        videos: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videos), {
            perPage: +value,
            page: pg
        })
    };
};
var setStateOnGroupListUpdate = function(state, response) {
    var channelID = Object.keys(response.list)[0];
    return {
        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.data), {
            groupList: response.list[channelID]
        })
    };
};
var setStateOnShowAddChannel = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        open: true,
        channels: "",
        group: ""
    });
};
var setStateOnSubmitAddChannel = function(state) {
    return {
        addChannels: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addChannels), {
            mode: "working"
        })
    };
};
var setStateOnCloseAddChannel = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        open: false
    });
};
var setStateOnAddChannelResponse = function(state, response) {
    if (!response.channelsAdded) {
        window.alert((0, _configuration.MESSAGE_ERROR_ADDCHANNELTOSYSTEM));
        return;
    }
    var status = new Map(state.response);
    /*
   Creates a map of items in the form { <KEY:CHANNEL_ID>: { status: <object> }}
   where <object> contains { message: '', error: true/false, title: ''}
  */ response.channelsAdded.forEach(function(ch) {
        status.set(ch.channel_youtubechannelid, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ch.status), {
            title: ch.channel_title
        }));
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        response: status,
        mode: "response",
        open: false
    });
};
var setStateOnAddChannelChange = function(state, name, value) {
    var _obj;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), (_obj = {}, (0, _defineProperty._)(_obj, name, value), (0, _defineProperty._)(_obj, "max", (0, _destinationsUtils.tooManyURLs)(value)), _obj));
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","../js/Configuration":"k3dur","./DestinationsUtils":"5X8UE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5X8UE":[function(require,module,exports) {
/*
DestinationsUtils.js

Functions that are shared between multiple views in Destinations and/or Stations
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "playAllVideos", function() {
    return playAllVideos;
});
parcelHelpers.export(exports, "exportVideoData", function() {
    return exportVideoData;
});
parcelHelpers.export(exports, "duplicatePlaylist", function() {
    return duplicatePlaylist;
});
parcelHelpers.export(exports, "tooManyURLs", function() {
    return tooManyURLs;
});
parcelHelpers.export(exports, "getDestinations", function() {
    return getDestinations;
});
parcelHelpers.export(exports, "getRatings", function() {
    return getRatings;
});
parcelHelpers.export(exports, "getVideoSets", function() {
    return getVideoSets;
});
parcelHelpers.export(exports, "getRunDates", function() {
    return getRunDates;
});
parcelHelpers.export(exports, "deleteDestination", function() {
    return deleteDestination;
});
parcelHelpers.export(exports, "getVideoSetBreadcrumbs", function() {
    return getVideoSetBreadcrumbs;
});
parcelHelpers.export(exports, "restoreVideoSet", function() {
    return restoreVideoSet;
});
parcelHelpers.export(exports, "deleteVideoSet", function() {
    return deleteVideoSet;
});
parcelHelpers.export(exports, "findDestinationById", function() {
    return findDestinationById;
});
var _utilities = require("../js/Utilities");
var _dateFns = require("date-fns");
var _configuration = require("../js/Configuration");
var playAllVideos = function() {
    var videolist = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var videoIds = videolist.map(function(video) {
        return video.ytID;
    });
    window.open("https://www.youtube.com/watch_videos?video_ids=".concat(videoIds.join(",")), "_blank");
};
var exportVideoData = function() {
    var videolist = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var items = videolist.map(function(item) {
        return item.ytID;
    });
    var textArea = document.createElement("textarea");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999em";
    textArea.style.top = "0px";
    textArea.value = items;
    document.body.appendChild(textArea);
    textArea.select();
    try {
        var successful = document.execCommand("copy");
        if (successful) window.alert((0, _configuration.MESSAGE_CLIPBOARD_OK));
        else window.alert((0, _configuration.MESSAGE_CLIPBOARD_FAILED));
    } catch (err) {
        window.alert((0, _configuration.MESSAGE_CLIPBOARD_FAILED));
    }
    document.body.removeChild(textArea);
    textArea = null;
};
var duplicatePlaylist = function(setblockid) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", +setblockid);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_DUPLICATE), {
        body: fd
    }, callback);
};
var tooManyURLs = function(string) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50;
    return string.split(/[,\s]/).length > max;
};
var getDestinations = function() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, withstations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, inactives = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var fd = new FormData();
    fd.set("token", (0, _utilities.getAuthData)("token"));
    if (withstations) fd.set("withstations", 1);
    if (inactives) fd.set("inactives", 1);
    (0, _utilities.asyncapirequest)((0, _configuration.API_DESTINATIONS_LIST), {
        body: fd
    }, callback);
};
var getRatings = function() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var fd = new FormData();
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_RATINGS_ALL), {
        body: fd
    }, callback);
};
var getVideoSets = function(destid) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", destid);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_ASSIGNMENTS), {
        body: fd
    }, callback);
};
var getRunDates = function(setid) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", setid);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ASSIGNMENTS), {
        body: fd
    }, callback);
};
var deleteDestination = function(destinationId) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", destinationId);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_DESTINATION_DELETE), {
        body: fd
    }, callback);
};
var getVideoSetBreadcrumbs = function(videoSetId) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", videoSetId);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_SERIES), {
        body: fd
    }, callback);
};
var restoreVideoSet = function(setId) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", setId);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_RESTORE), {
        body: fd
    }, callback);
};
var deleteVideoSet = function(setId) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData();
    fd.set("id", setId);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_DELETE), {
        body: fd
    }, callback);
};
var findDestinationById = function() {
    var destinationsList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!id) return false;
    return destinationsList.find(function(dest) {
        return +dest.dID === +id;
    });
};

},{"../js/Utilities":"euxcI","date-fns":"lnGwj","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3T1j2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAllChannels", function() {
    return initAllChannels;
});
parcelHelpers.export(exports, "setStateAfterGroupDelete", function() {
    return setStateAfterGroupDelete;
});
parcelHelpers.export(exports, "deleteGroupConfirmation", function() {
    return deleteGroupConfirmation;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var initAllChannels = {
    open: false,
    loading: true,
    page: 1,
    perPage: 10,
    pageCount: 1,
    list: [],
    sortBy: "video_addeddate",
    ascending: true,
    keyword: "",
    filterOn: "",
    toAdd: []
};
var setStateAfterGroupDelete = function(state, data) {
    var groups = (0, _toConsumableArray._)(state);
    return groups.filter(function(g) {
        return +g.group_id !== +data.deleted;
    });
};
var deleteGroupConfirmation = function(group_name) {
    window.alert('Group "'.concat(group_name, '" was removed.'));
};

},{"@swc/helpers/_/_to_consumable_array":"fRXIP","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"w0Z2w":[function() {},{}],"cn7Fd":[function(require,module,exports) {
/**
 * ChannelsList.js
 * Displays the channel search modal.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utilities = require("../js/Utilities");
var _modalDialog = require("./subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _channelListTable = require("./subcomponents/ChannelListTable");
var _channelListTableDefault = parcelHelpers.interopDefault(_channelListTable);
var _channelListSearch = require("./subcomponents/ChannelListSearch");
var _channelListSearchDefault = parcelHelpers.interopDefault(_channelListSearch);
var _pagination = require("./subcomponents/Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _selectPerPage = require("./subcomponents/SelectPerPage");
var _selectPerPageDefault = parcelHelpers.interopDefault(_selectPerPage);
var _configuration = require("../js/Configuration");
var ChannelsList = function(param) {
    var groupsInChannel = param.groupsInChannel, onClose = param.onClose, onCheckChange = param.onCheckChange, onSubmit = param.onSubmit, _param_modalRef = param.modalRef, modalRef = _param_modalRef === void 0 ? null : _param_modalRef;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), channels = _useState[0], setChannels = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(10), 2), perPage = _useState1[0], setPerPage = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(1), 2), page = _useState2[0], setPage = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(1), 2), pages = _useState3[0], setPages = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(""), 2), keyword = _useState4[0], setKeyword = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState5[0], setLoading = _useState5[1]; // Do we need this?
    var onPaginationClick = function(domEvent) {
        setPage(function(pg) {
            return pg + +domEvent.target.value;
        });
        setLoading(!loading);
        setChannels([]);
    };
    var onChannelFilterChange = function(domEvent) {
        setKeyword(domEvent.target.value);
        setLoading(true);
        setChannels([]);
    };
    var getChannelBatch = function() {
        var fd = new FormData();
        fd.set("perpage", perPage);
        fd.set("page", page);
        fd.set("sort_by", null);
        fd.set("filter_by", keyword);
        fd.set("filter_on", "");
        fd.set("order", "ascending");
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_BATCH), {
            body: fd
        }, function(response) {
            setChannels(response.channels);
            setLoading(false);
            setPages(response.pages);
        });
    };
    var onPerPageChange = function(domEvent) {
        setPerPage(+domEvent.target.value);
        setChannels([]);
    };
    (0, _react.useEffect)(function() {
        if (!channels.length) getChannelBatch();
    }, [
        channels
    ]);
    var makeTableData = function() {
        var data = [];
        var curSet = groupsInChannel || [];
        if (channels.length) data = channels.map(function(item) {
            var d = {};
            d.channel_id = item.channel_id;
            d.channel_title = item.channel_title;
            d.video_count = item.channel_videocount;
            d.channel = item.channel_dateaddedtosystem;
            d.channel_youtubeID = item.channel_youtubechannelid;
            d.channel_selected = !!curSet.find(function(cs) {
                return cs.channel_youtubechannelid === item.channel_youtubechannelid;
            });
            return d;
        });
        return data;
    };
    var getModalBody = function() {
        if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelListTableDefault.default), {
            cssClass: "channel__list__table",
            headers: [
                null,
                "Channel Title",
                "Video count"
            ],
            rows: makeTableData(),
            onCheckChange: onCheckChange
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "SearchChannelsList",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "modalHeaderBtns button__group",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    className: "btn btn-sm btn--action",
                    form: "add_to_videoset",
                    children: "Submit"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Select Channels"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table__list__controls",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPerPageDefault.default), {
                        name: "video_list_pages",
                        cssClass: "table__list__perpage",
                        value: perPage,
                        onChangeHandler: onPerPageChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                        currentPage: +page,
                        totalPages: +pages,
                        onClickHandler: onPaginationClick,
                        disablePrevious: page <= 1,
                        disableNext: channels.length < perPage
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelListSearchDefault.default), {
                apiURL: "api/getchannelbatch",
                cssClass: "search__channel__list__searchform",
                limit: 50,
                datalist: null,
                isRequired: false,
                onInputHandler: onChannelFilterChange,
                labelText: "Filter channels",
                value: keyword
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                action: "api/getchannelbatch",
                method: "post",
                onSubmit: onSubmit,
                id: "add_to_videoset",
                children: [
                    getModalBody(),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "table__list__controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPerPageDefault.default), {
                                name: "video_list_pages",
                                cssClass: "table__list__perpage",
                                value: perPage,
                                onChangeHandler: onPerPageChange
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                                currentPage: +page,
                                totalPages: +pages,
                                onClickHandler: onPaginationClick,
                                disablePrevious: +page <= 1,
                                disableNext: channels.length < perPage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "button__group",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn-sm btn--action",
                            children: "Submit"
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = ChannelsList;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","../js/Utilities":"euxcI","./subcomponents/ModalDialog":"72kji","./subcomponents/LoaderSimple":"1dSHa","./subcomponents/ChannelListTable":"el8rv","./subcomponents/ChannelListSearch":"wwzpZ","./subcomponents/Pagination":"kHqdc","./subcomponents/SelectPerPage":"anMUV","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1dSHa":[function(require,module,exports) {
/**
 * LoaderSimple.js
 * A simple loader for loading search results without a modal.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _loaderSimpleCss = require("../../css/LoaderSimple.css");
var LoaderSimple = function(props) {
    var cssClasses = (0, _classnamesDefault.default)("LoaderSimple", props.cssClass);
    var title = props.title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
        children: props.title
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        hidden: !props.open,
        className: cssClasses,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: "312",
            height: "312",
            viewBox: "0 0 312 312",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                title,
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    id: "loading-group",
                    stroke: "none",
                    strokeWidth: "1",
                    fill: "none",
                    fillRule: "evenodd",
                    transform: "translate(156.000000, 156.000000) rotate(45.000000) translate(-156.000000, -156.000000) translate(46.000000, 46.000000)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            id: "top",
                            x: "0",
                            y: "0",
                            width: "103",
                            height: "103"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            id: "left",
                            x: "0",
                            y: "117",
                            width: "103",
                            height: "103"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            id: "right",
                            x: "117",
                            y: "0",
                            width: "103",
                            height: "103"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            id: "bottom",
                            x: "117",
                            y: "117",
                            width: "103",
                            height: "103"
                        })
                    ]
                })
            ]
        })
    });
};
LoaderSimple.propTypes = {
    open: (0, _propTypesDefault.default).bool,
    cssClass: (0, _propTypesDefault.default).string
};
exports.default = LoaderSimple;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../../css/LoaderSimple.css":"1e62V","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1e62V":[function() {},{}],"el8rv":[function(require,module,exports) {
/**
 * ChannelListTable.jsx
 * A no-framework table component.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var ChannelListTable = function(param) {
    var _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? null : _param_cssClass, _param_headers = param.headers, headers = _param_headers === void 0 ? [] : _param_headers, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id, _param_rows = param.rows, rows = _param_rows === void 0 ? [] : _param_rows, onCheckChange = param.onCheckChange;
    var makeHeaders = function() {
        var retval;
        if (headers) {
            var hdrs = [];
            hdrs = headers.map(function(h, idx) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                    children: h
                }, idx.toString());
            });
            retval = /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                    children: hdrs
                })
            });
        } else retval = null;
        return retval;
    };
    var makeRows = function() {
        var retval;
        if (rows) {
            var rws = [];
            rws = rows.map(function(h, idx) {
                return makeOneRow(h, idx);
            });
            retval = /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                children: rws
            });
        } else retval = null;
        return retval;
    };
    var makeOneRow = function(obj, index) {
        var tds = [];
        tds[0] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                name: "channels_to_add",
                type: "checkbox",
                defaultChecked: obj.channel_selected,
                id: obj.channel_youtubeID,
                value: obj.channel_youtubeID,
                onChange: onCheckChange
            })
        }, obj.channel_youtubeID);
        tds[1] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "".concat(obj.channel_youtubeID),
                children: obj.channel_title
            })
        }, "".concat(obj.channel_youtubeID, "_1"));
        tds[2] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: obj.video_count
        }, "".concat(obj.channel_youtubeID, "_count"));
        var tr = /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
            children: tds
        }, index.toString());
        return tr;
    };
    var cssClasses = (0, _classnamesDefault.default)("table-list", cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
        className: cssClasses,
        id: id,
        children: [
            makeHeaders(),
            makeRows()
        ]
    });
};
ChannelListTable.propTypes = {
    id: (0, _propTypesDefault.default).string,
    cssClass: (0, _propTypesDefault.default).string,
    headers: (0, _propTypesDefault.default).array,
    rows: (0, _propTypesDefault.default).array,
    onCheckChange: (0, _propTypesDefault.default).func
};
exports.default = ChannelListTable;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"wwzpZ":[function(require,module,exports) {
/**
 * ChannelListSearch
 * Search form for ChannelsList component.
 * Author: Webinista, Inc 6/11/18.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../../js/Configuration");
var _textInput = require("./TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var ChannelListSearch = function(param) {
    var _param_apiURL = param.apiURL, apiURL = _param_apiURL === void 0 ? "" : _param_apiURL, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? (0, _configuration.DEFAULT_LABEL_TEXT) : _param_labelText, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_onInputHandler = param.onInputHandler, onInputHandler = _param_onInputHandler === void 0 ? null : _param_onInputHandler, _param_onSubmitHandler = param.onSubmitHandler, onSubmitHandler = _param_onSubmitHandler === void 0 ? null : _param_onSubmitHandler, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_datalist = param.datalist, datalist = _param_datalist === void 0 ? [] : _param_datalist;
    var cssClasses = (0, _classnamesDefault.default)(cssClass, {
        "channel__list__search": true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            id: "channel_list_search",
            action: apiURL,
            method: "POST",
            className: cssClasses,
            onSubmit: onSubmitHandler,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "hidden",
                    id: "limit",
                    name: "limit",
                    value: limit
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                    labelText: labelText,
                    name: "channel_filter",
                    onInputHandler: onInputHandler,
                    value: value,
                    datalist: datalist,
                    isRequired: true
                })
            ]
        })
    });
};
ChannelListSearch.propTypes = {
    apiURL: (0, _propTypesDefault.default).string.isRequired,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    limit: (0, _propTypesDefault.default).number.isRequired,
    cssClass: (0, _propTypesDefault.default).string,
    onInputHandler: (0, _propTypesDefault.default).func,
    onSubmitHandler: (0, _propTypesDefault.default).func,
    value: (0, _propTypesDefault.default).string.isRequired,
    datalist: (0, _propTypesDefault.default).array
};
exports.default = ChannelListSearch;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../js/Configuration":"k3dur","./TextInput":"327SP","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"327SP":[function(require,module,exports) {
/**
 * TextInput.jsx
 * A no-framework text input 
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var TextInput = function(param) {
    var onInputHandler = param.onInputHandler, value = param.value, name = param.name, id = param.id, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_datalist = param.datalist, datalist = _param_datalist === void 0 ? [] : _param_datalist, _param_isRequired = param.isRequired, isRequired = _param_isRequired === void 0 ? false : _param_isRequired, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "Add label text" : _param_labelText, _param_ariaDescribedBy = param.ariaDescribedBy, ariaDescribedBy = _param_ariaDescribedBy === void 0 ? "" : _param_ariaDescribedBy;
    var cssClasses = (0, _classnamesDefault.default)("input-text", cssClass);
    var fieldId = id || name;
    var dataList = null, dataListAttr = null;
    var makeDataList = function(arrayOfOptions) {
        return arrayOfOptions.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: item.title
            }, index.toString());
        });
    };
    if (datalist === null || datalist === void 0 ? void 0 : datalist.length) {
        dataListAttr = "".concat(id, "_dl");
        dataList = /*#__PURE__*/ (0, _jsxRuntime.jsx)("datalist", {
            id: dataListAttr,
            children: makeDataList(datalist)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: labelText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "text",
                name: name,
                id: fieldId,
                list: dataListAttr,
                onChange: onInputHandler,
                defaultValue: value,
                required: isRequired,
                "aria-describedby": ariaDescribedBy
            }),
            dataList
        ]
    });
};
exports.default = TextInput;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kHqdc":[function(require,module,exports) {
/**
 * Pagination.jsx
 * A no-framework pagination component
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _paginationCss = require("../../css/pagination.css");
var Pagination = function(param) {
    var onClickHandler = param.onClickHandler, disablePrevious = param.disablePrevious, disableNext = param.disableNext;
    var getPreviousPage = function(domEvent) {
        onClickHandler(domEvent);
    };
    var getNextPage = function(domEvent) {
        onClickHandler(domEvent);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "pagination__component",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "btn btn-light pagination__previous",
                type: "button",
                onClick: getPreviousPage,
                value: "-1",
                disabled: disablePrevious,
                children: "Previous"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "btn btn-light pagination__next",
                type: "button",
                onClick: getNextPage,
                value: "+1",
                disabled: disableNext,
                children: "Next"
            })
        ]
    });
};
Pagination.propTypes = {
    currentPage: (0, _propTypesDefault.default).number.isRequired,
    onClickHandler: (0, _propTypesDefault.default).func.isRequired,
    disablePrevious: (0, _propTypesDefault.default).bool,
    disableNext: (0, _propTypesDefault.default).bool
};
exports.default = Pagination;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../../css/pagination.css":"cjyAX","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cjyAX":[function() {},{}],"anMUV":[function(require,module,exports) {
/* 
* SelectPerPage.jsx
* Creates a select menu for selecting the number of results to display 
* per screen. Used on Destinations, Search, and other pages.
* 
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utilities = require("../../js/Utilities");
var SelectPerPage = function(param) {
    var id = param.id, name = param.name, onChangeHandler = param.onChangeHandler, cssClass = param.cssClass, value = param.value, isRequired = param.isRequired, options = param.options, replace = param.replace, disabled = param.disabled;
    var makeOptions = function() {
        var defaults = [
            10,
            25,
            30,
            50,
            100
        ];
        var opts = defaults;
        if (replace) opts = options;
        else opts = defaults.concat(options);
        return opts.sort(function(a, b) {
            return a - b;
        }).map(function() {
            var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, idx = arguments.length > 1 ? arguments[1] : void 0;
            if (o === null) return null;
            if ((0, _utilities.isNumeric)(o)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: o,
                children: o
            }, idx);
            else {
                // if a string was passed in, split it on a pipe.
                // Use first part for label, second for value.
                var v = o.split("|");
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                    value: v[1],
                    children: v[0]
                }, idx);
            }
        });
    };
    var cssClasses = (0, _classnamesDefault.default)("input-select", cssClass);
    var nme = name || id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: name,
                children: "Per page"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                name: nme,
                id: id,
                value: value,
                onChange: onChangeHandler,
                required: isRequired,
                disabled: disabled,
                children: makeOptions()
            })
        ]
    });
};
SelectPerPage.propTypes = {
    id: (0, _propTypesDefault.default).string,
    name: (0, _propTypesDefault.default).string,
    onChangeHandler: (0, _propTypesDefault.default).func,
    cssClass: (0, _propTypesDefault.default).string,
    value: (0, _propTypesDefault.default).number,
    isRequired: (0, _propTypesDefault.default).bool,
    options: (0, _propTypesDefault.default).array,
    replace: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool
};
exports.default = SelectPerPage;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lN9sG":[function(require,module,exports) {
/** *
 * Groups
 * Page component for Groups tab.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _groupsPageTable = require("./subcomponents/GroupsPageTable");
var _groupsPageTableDefault = parcelHelpers.interopDefault(_groupsPageTable);
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _groupsUtils = require("../actions/GroupsUtils");
var _groupsCss = require("../css/Groups.css");
var GroupsPage = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), groupList = _useState[0], setGroupList = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showEdit = _useState1[0], setShowEdit = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(0), 2), groupItem = _useState2[0], setGroupItem = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(0), 2), addToGroupId = _useState3[0], setAddToGroupId = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showChannelInfo = _useState4[0], setShowChannelInfo = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showChannels = _useState5[0], setShowChannels = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(""), 2), groupName = _useState6[0], setGroupName = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(null), 2), groupNameError = _useState7[0], setGroupNameError = _useState7[1];
    var getAllGroups = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ALLGROUPS), {
            body: fd
        }, function(data) {
            setGroupList(data);
        });
    };
    var showGroupEdit = function() {
        console.log("IDK WHAT THIS DOES");
    };
    (0, _react.useEffect)(function() {
        if (!groupList.length) getAllGroups();
    }, [
        groupList
    ]);
    var onInputHandler = function(domEvent) {
        setGroupName(domEvent.target.value);
    };
    var makeGroupEdit = function() {
        if (showEdit) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GroupsPageEditGroups, {
            showChannelInfo: showChannelInfo,
            showChannels: showChannels,
            currentChannel: currentlyViewedChannel,
            groups: groupList,
            channels: channelList,
            currentChannelPage: +channelListCurrentPage,
            channelListPerPage: +channelListPerPage,
            channelListAscending: channelListAscending,
            channelListFilterKeyword: channelListFilterKeyword,
            channelListFilterOn: channelListFilterOn,
            channelListSortBy: channelListSortBy,
            onPerPageChange: changePerPageHandler,
            onChannelSelectChange: channelSelectChangeHandler,
            totalChannelPages: channelListPageCount,
            groupItem: groupItem
        });
        else return null;
    };
    var createGroup = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUP_ADD_NEW), {
            body: fd
        }, function(data) {
            if (data.result === "success") {
                setGroupList([]);
                setGroupName("");
            } else setGroupNameError(data.message);
        });
    };
    var deleteGroup = function(domEvent) {
        var group = groupList.filter(function(g) {
            return g.group_id === domEvent.target.dataset.groupid;
        });
        var confirm = window.confirm('Confirm that you want to delete "'.concat(group[0].group_name, '" by clicking OK.'));
        if (!confirm) return;
        var fd = new FormData();
        fd.set("id", group[0].group_id);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_DELETE), {
            body: fd
        }, function(response) {
            if (response.success) {
                setGroupList((0, _groupsUtils.setStateAfterGroupDelete)(groupList, response));
                (0, _groupsUtils.deleteGroupConfirmation)(group[0].group_name);
            } else window.alert("Could not delete ".concat(group[0].group_name, "."));
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "curationContent",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: "curationMenu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "groupHeaderParent",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            action: (0, _configuration.API_GROUP_ADD_NEW),
                            method: "post",
                            onSubmit: createGroup,
                            className: "groupHeader form__single__input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form__input_button_group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "group_name",
                                            children: "Create Group:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    name: "groupname",
                                                    id: "group_name",
                                                    value: groupName,
                                                    onInput: onInputHandler,
                                                    required: true,
                                                    type: "text"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "submit",
                                                    className: "btn btn-sm btn--action",
                                                    children: "Submit"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "msg__error",
                                    hidden: !groupNameError,
                                    children: groupNameError
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsPageTableDefault.default), {
                        groupList: groupList,
                        onDelete: deleteGroup,
                        isAdmin: (0, _utilities.isAdmin)(props.project)
                    })
                ]
            }),
            makeGroupEdit()
        ]
    });
};
exports.default = GroupsPage;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","./subcomponents/GroupsPageTable":"93v1H","../js/Configuration":"k3dur","../js/Utilities":"euxcI","../actions/GroupsUtils":"3T1j2","../css/Groups.css":"7hVKJ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"93v1H":[function(require,module,exports) {
/**
 * GroupsPageTable component 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _dateFns = require("date-fns");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _utilities = require("../../js/Utilities");
var _groupsPageTableCss = require("../../css/GroupsPageTable.css");
var GroupsPageTable = function(param) {
    var groupList = param.groupList, onDelete = param.onDelete;
    if (!groupList.length) return null;
    var groups = groupList.map(function(item, i) {
        var cCount = item.channelList.length || 0;
        /* Object ordered by where they appear in each row */ return {
            title: item.group_name,
            dateAdded: item.group_dateadded,
            dateUpdated: item.group_datelastupdated,
            channelCount: cCount,
            id: item.group_id
        };
    });
    var rows = groups.map(function(item, index) {
        var tds;
        if (Object.keys(item).length) tds = Object.keys(item).map(function(r) {
            var cell;
            switch(r){
                case "dateAdded":
                case "dateUpdated":
                    cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: (0, _dateFns.format)(new Date((0, _utilities.getUTCNormalizedDate)(item[r])), "d MMMM yyyy")
                    }, (0, _lodashUniqueidDefault.default)("gptc_"));
                    break;
                case "id":
                    cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "button__group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/group/".concat(item[r]),
                                    className: "btn btn btn-sm btn--action",
                                    children: "Edit Group"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: onDelete,
                                    type: "button",
                                    "data-groupid": item[r],
                                    className: "btn btn btn-sm btn--action",
                                    children: "Remove Group"
                                })
                            ]
                        })
                    }, (0, _lodashUniqueidDefault.default)("gptc_"));
                    break;
                default:
                    cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: item[r]
                    }, (0, _lodashUniqueidDefault.default)("gptc_"));
            }
            return cell;
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
            children: tds
        }, (0, _lodashUniqueidDefault.default)("group_"));
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
        id: "GroupsPageTable",
        className: "groups__table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Group Name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Date Added"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Date Updated"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Channel Count"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Remove Group"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                children: rows
            })
        ]
    });
};
exports.default = GroupsPageTable;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","date-fns":"1h4Hj","lodash.uniqueid":"6bf5k","../../js/Utilities":"euxcI","../../css/GroupsPageTable.css":"31J95","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1h4Hj":[function(require,module,exports) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addMjs = require("./add.mjs");
parcelHelpers.exportAll(_addMjs, exports);
var _addBusinessDaysMjs = require("./addBusinessDays.mjs");
parcelHelpers.exportAll(_addBusinessDaysMjs, exports);
var _addDaysMjs = require("./addDays.mjs");
parcelHelpers.exportAll(_addDaysMjs, exports);
var _addHoursMjs = require("./addHours.mjs");
parcelHelpers.exportAll(_addHoursMjs, exports);
var _addISOWeekYearsMjs = require("./addISOWeekYears.mjs");
parcelHelpers.exportAll(_addISOWeekYearsMjs, exports);
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
parcelHelpers.exportAll(_addMillisecondsMjs, exports);
var _addMinutesMjs = require("./addMinutes.mjs");
parcelHelpers.exportAll(_addMinutesMjs, exports);
var _addMonthsMjs = require("./addMonths.mjs");
parcelHelpers.exportAll(_addMonthsMjs, exports);
var _addQuartersMjs = require("./addQuarters.mjs");
parcelHelpers.exportAll(_addQuartersMjs, exports);
var _addSecondsMjs = require("./addSeconds.mjs");
parcelHelpers.exportAll(_addSecondsMjs, exports);
var _addWeeksMjs = require("./addWeeks.mjs");
parcelHelpers.exportAll(_addWeeksMjs, exports);
var _addYearsMjs = require("./addYears.mjs");
parcelHelpers.exportAll(_addYearsMjs, exports);
var _areIntervalsOverlappingMjs = require("./areIntervalsOverlapping.mjs");
parcelHelpers.exportAll(_areIntervalsOverlappingMjs, exports);
var _clampMjs = require("./clamp.mjs");
parcelHelpers.exportAll(_clampMjs, exports);
var _closestIndexToMjs = require("./closestIndexTo.mjs");
parcelHelpers.exportAll(_closestIndexToMjs, exports);
var _closestToMjs = require("./closestTo.mjs");
parcelHelpers.exportAll(_closestToMjs, exports);
var _compareAscMjs = require("./compareAsc.mjs");
parcelHelpers.exportAll(_compareAscMjs, exports);
var _compareDescMjs = require("./compareDesc.mjs");
parcelHelpers.exportAll(_compareDescMjs, exports);
var _constructFromMjs = require("./constructFrom.mjs");
parcelHelpers.exportAll(_constructFromMjs, exports);
var _constructNowMjs = require("./constructNow.mjs");
parcelHelpers.exportAll(_constructNowMjs, exports);
var _daysToWeeksMjs = require("./daysToWeeks.mjs");
parcelHelpers.exportAll(_daysToWeeksMjs, exports);
var _differenceInBusinessDaysMjs = require("./differenceInBusinessDays.mjs");
parcelHelpers.exportAll(_differenceInBusinessDaysMjs, exports);
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
parcelHelpers.exportAll(_differenceInCalendarDaysMjs, exports);
var _differenceInCalendarISOWeekYearsMjs = require("./differenceInCalendarISOWeekYears.mjs");
parcelHelpers.exportAll(_differenceInCalendarISOWeekYearsMjs, exports);
var _differenceInCalendarISOWeeksMjs = require("./differenceInCalendarISOWeeks.mjs");
parcelHelpers.exportAll(_differenceInCalendarISOWeeksMjs, exports);
var _differenceInCalendarMonthsMjs = require("./differenceInCalendarMonths.mjs");
parcelHelpers.exportAll(_differenceInCalendarMonthsMjs, exports);
var _differenceInCalendarQuartersMjs = require("./differenceInCalendarQuarters.mjs");
parcelHelpers.exportAll(_differenceInCalendarQuartersMjs, exports);
var _differenceInCalendarWeeksMjs = require("./differenceInCalendarWeeks.mjs");
parcelHelpers.exportAll(_differenceInCalendarWeeksMjs, exports);
var _differenceInCalendarYearsMjs = require("./differenceInCalendarYears.mjs");
parcelHelpers.exportAll(_differenceInCalendarYearsMjs, exports);
var _differenceInDaysMjs = require("./differenceInDays.mjs");
parcelHelpers.exportAll(_differenceInDaysMjs, exports);
var _differenceInHoursMjs = require("./differenceInHours.mjs");
parcelHelpers.exportAll(_differenceInHoursMjs, exports);
var _differenceInISOWeekYearsMjs = require("./differenceInISOWeekYears.mjs");
parcelHelpers.exportAll(_differenceInISOWeekYearsMjs, exports);
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
parcelHelpers.exportAll(_differenceInMillisecondsMjs, exports);
var _differenceInMinutesMjs = require("./differenceInMinutes.mjs");
parcelHelpers.exportAll(_differenceInMinutesMjs, exports);
var _differenceInMonthsMjs = require("./differenceInMonths.mjs");
parcelHelpers.exportAll(_differenceInMonthsMjs, exports);
var _differenceInQuartersMjs = require("./differenceInQuarters.mjs");
parcelHelpers.exportAll(_differenceInQuartersMjs, exports);
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
parcelHelpers.exportAll(_differenceInSecondsMjs, exports);
var _differenceInWeeksMjs = require("./differenceInWeeks.mjs");
parcelHelpers.exportAll(_differenceInWeeksMjs, exports);
var _differenceInYearsMjs = require("./differenceInYears.mjs");
parcelHelpers.exportAll(_differenceInYearsMjs, exports);
var _eachDayOfIntervalMjs = require("./eachDayOfInterval.mjs");
parcelHelpers.exportAll(_eachDayOfIntervalMjs, exports);
var _eachHourOfIntervalMjs = require("./eachHourOfInterval.mjs");
parcelHelpers.exportAll(_eachHourOfIntervalMjs, exports);
var _eachMinuteOfIntervalMjs = require("./eachMinuteOfInterval.mjs");
parcelHelpers.exportAll(_eachMinuteOfIntervalMjs, exports);
var _eachMonthOfIntervalMjs = require("./eachMonthOfInterval.mjs");
parcelHelpers.exportAll(_eachMonthOfIntervalMjs, exports);
var _eachQuarterOfIntervalMjs = require("./eachQuarterOfInterval.mjs");
parcelHelpers.exportAll(_eachQuarterOfIntervalMjs, exports);
var _eachWeekOfIntervalMjs = require("./eachWeekOfInterval.mjs");
parcelHelpers.exportAll(_eachWeekOfIntervalMjs, exports);
var _eachWeekendOfIntervalMjs = require("./eachWeekendOfInterval.mjs");
parcelHelpers.exportAll(_eachWeekendOfIntervalMjs, exports);
var _eachWeekendOfMonthMjs = require("./eachWeekendOfMonth.mjs");
parcelHelpers.exportAll(_eachWeekendOfMonthMjs, exports);
var _eachWeekendOfYearMjs = require("./eachWeekendOfYear.mjs");
parcelHelpers.exportAll(_eachWeekendOfYearMjs, exports);
var _eachYearOfIntervalMjs = require("./eachYearOfInterval.mjs");
parcelHelpers.exportAll(_eachYearOfIntervalMjs, exports);
var _endOfDayMjs = require("./endOfDay.mjs");
parcelHelpers.exportAll(_endOfDayMjs, exports);
var _endOfDecadeMjs = require("./endOfDecade.mjs");
parcelHelpers.exportAll(_endOfDecadeMjs, exports);
var _endOfHourMjs = require("./endOfHour.mjs");
parcelHelpers.exportAll(_endOfHourMjs, exports);
var _endOfISOWeekMjs = require("./endOfISOWeek.mjs");
parcelHelpers.exportAll(_endOfISOWeekMjs, exports);
var _endOfISOWeekYearMjs = require("./endOfISOWeekYear.mjs");
parcelHelpers.exportAll(_endOfISOWeekYearMjs, exports);
var _endOfMinuteMjs = require("./endOfMinute.mjs");
parcelHelpers.exportAll(_endOfMinuteMjs, exports);
var _endOfMonthMjs = require("./endOfMonth.mjs");
parcelHelpers.exportAll(_endOfMonthMjs, exports);
var _endOfQuarterMjs = require("./endOfQuarter.mjs");
parcelHelpers.exportAll(_endOfQuarterMjs, exports);
var _endOfSecondMjs = require("./endOfSecond.mjs");
parcelHelpers.exportAll(_endOfSecondMjs, exports);
var _endOfTodayMjs = require("./endOfToday.mjs");
parcelHelpers.exportAll(_endOfTodayMjs, exports);
var _endOfTomorrowMjs = require("./endOfTomorrow.mjs");
parcelHelpers.exportAll(_endOfTomorrowMjs, exports);
var _endOfWeekMjs = require("./endOfWeek.mjs");
parcelHelpers.exportAll(_endOfWeekMjs, exports);
var _endOfYearMjs = require("./endOfYear.mjs");
parcelHelpers.exportAll(_endOfYearMjs, exports);
var _endOfYesterdayMjs = require("./endOfYesterday.mjs");
parcelHelpers.exportAll(_endOfYesterdayMjs, exports);
var _formatMjs = require("./format.mjs");
parcelHelpers.exportAll(_formatMjs, exports);
var _formatDistanceMjs = require("./formatDistance.mjs");
parcelHelpers.exportAll(_formatDistanceMjs, exports);
var _formatDistanceStrictMjs = require("./formatDistanceStrict.mjs");
parcelHelpers.exportAll(_formatDistanceStrictMjs, exports);
var _formatDistanceToNowMjs = require("./formatDistanceToNow.mjs");
parcelHelpers.exportAll(_formatDistanceToNowMjs, exports);
var _formatDistanceToNowStrictMjs = require("./formatDistanceToNowStrict.mjs");
parcelHelpers.exportAll(_formatDistanceToNowStrictMjs, exports);
var _formatDurationMjs = require("./formatDuration.mjs");
parcelHelpers.exportAll(_formatDurationMjs, exports);
var _formatISOMjs = require("./formatISO.mjs");
parcelHelpers.exportAll(_formatISOMjs, exports);
var _formatISO9075Mjs = require("./formatISO9075.mjs");
parcelHelpers.exportAll(_formatISO9075Mjs, exports);
var _formatISODurationMjs = require("./formatISODuration.mjs");
parcelHelpers.exportAll(_formatISODurationMjs, exports);
var _formatRFC3339Mjs = require("./formatRFC3339.mjs");
parcelHelpers.exportAll(_formatRFC3339Mjs, exports);
var _formatRFC7231Mjs = require("./formatRFC7231.mjs");
parcelHelpers.exportAll(_formatRFC7231Mjs, exports);
var _formatRelativeMjs = require("./formatRelative.mjs");
parcelHelpers.exportAll(_formatRelativeMjs, exports);
var _fromUnixTimeMjs = require("./fromUnixTime.mjs");
parcelHelpers.exportAll(_fromUnixTimeMjs, exports);
var _getDateMjs = require("./getDate.mjs");
parcelHelpers.exportAll(_getDateMjs, exports);
var _getDayMjs = require("./getDay.mjs");
parcelHelpers.exportAll(_getDayMjs, exports);
var _getDayOfYearMjs = require("./getDayOfYear.mjs");
parcelHelpers.exportAll(_getDayOfYearMjs, exports);
var _getDaysInMonthMjs = require("./getDaysInMonth.mjs");
parcelHelpers.exportAll(_getDaysInMonthMjs, exports);
var _getDaysInYearMjs = require("./getDaysInYear.mjs");
parcelHelpers.exportAll(_getDaysInYearMjs, exports);
var _getDecadeMjs = require("./getDecade.mjs");
parcelHelpers.exportAll(_getDecadeMjs, exports);
var _getDefaultOptionsMjs = require("./getDefaultOptions.mjs");
parcelHelpers.exportAll(_getDefaultOptionsMjs, exports);
var _getHoursMjs = require("./getHours.mjs");
parcelHelpers.exportAll(_getHoursMjs, exports);
var _getISODayMjs = require("./getISODay.mjs");
parcelHelpers.exportAll(_getISODayMjs, exports);
var _getISOWeekMjs = require("./getISOWeek.mjs");
parcelHelpers.exportAll(_getISOWeekMjs, exports);
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
parcelHelpers.exportAll(_getISOWeekYearMjs, exports);
var _getISOWeeksInYearMjs = require("./getISOWeeksInYear.mjs");
parcelHelpers.exportAll(_getISOWeeksInYearMjs, exports);
var _getMillisecondsMjs = require("./getMilliseconds.mjs");
parcelHelpers.exportAll(_getMillisecondsMjs, exports);
var _getMinutesMjs = require("./getMinutes.mjs");
parcelHelpers.exportAll(_getMinutesMjs, exports);
var _getMonthMjs = require("./getMonth.mjs");
parcelHelpers.exportAll(_getMonthMjs, exports);
var _getOverlappingDaysInIntervalsMjs = require("./getOverlappingDaysInIntervals.mjs");
parcelHelpers.exportAll(_getOverlappingDaysInIntervalsMjs, exports);
var _getQuarterMjs = require("./getQuarter.mjs");
parcelHelpers.exportAll(_getQuarterMjs, exports);
var _getSecondsMjs = require("./getSeconds.mjs");
parcelHelpers.exportAll(_getSecondsMjs, exports);
var _getTimeMjs = require("./getTime.mjs");
parcelHelpers.exportAll(_getTimeMjs, exports);
var _getUnixTimeMjs = require("./getUnixTime.mjs");
parcelHelpers.exportAll(_getUnixTimeMjs, exports);
var _getWeekMjs = require("./getWeek.mjs");
parcelHelpers.exportAll(_getWeekMjs, exports);
var _getWeekOfMonthMjs = require("./getWeekOfMonth.mjs");
parcelHelpers.exportAll(_getWeekOfMonthMjs, exports);
var _getWeekYearMjs = require("./getWeekYear.mjs");
parcelHelpers.exportAll(_getWeekYearMjs, exports);
var _getWeeksInMonthMjs = require("./getWeeksInMonth.mjs");
parcelHelpers.exportAll(_getWeeksInMonthMjs, exports);
var _getYearMjs = require("./getYear.mjs");
parcelHelpers.exportAll(_getYearMjs, exports);
var _hoursToMillisecondsMjs = require("./hoursToMilliseconds.mjs");
parcelHelpers.exportAll(_hoursToMillisecondsMjs, exports);
var _hoursToMinutesMjs = require("./hoursToMinutes.mjs");
parcelHelpers.exportAll(_hoursToMinutesMjs, exports);
var _hoursToSecondsMjs = require("./hoursToSeconds.mjs");
parcelHelpers.exportAll(_hoursToSecondsMjs, exports);
var _intervalMjs = require("./interval.mjs");
parcelHelpers.exportAll(_intervalMjs, exports);
var _intervalToDurationMjs = require("./intervalToDuration.mjs");
parcelHelpers.exportAll(_intervalToDurationMjs, exports);
var _intlFormatMjs = require("./intlFormat.mjs");
parcelHelpers.exportAll(_intlFormatMjs, exports);
var _intlFormatDistanceMjs = require("./intlFormatDistance.mjs");
parcelHelpers.exportAll(_intlFormatDistanceMjs, exports);
var _isAfterMjs = require("./isAfter.mjs");
parcelHelpers.exportAll(_isAfterMjs, exports);
var _isBeforeMjs = require("./isBefore.mjs");
parcelHelpers.exportAll(_isBeforeMjs, exports);
var _isDateMjs = require("./isDate.mjs");
parcelHelpers.exportAll(_isDateMjs, exports);
var _isEqualMjs = require("./isEqual.mjs");
parcelHelpers.exportAll(_isEqualMjs, exports);
var _isExistsMjs = require("./isExists.mjs");
parcelHelpers.exportAll(_isExistsMjs, exports);
var _isFirstDayOfMonthMjs = require("./isFirstDayOfMonth.mjs");
parcelHelpers.exportAll(_isFirstDayOfMonthMjs, exports);
var _isFridayMjs = require("./isFriday.mjs");
parcelHelpers.exportAll(_isFridayMjs, exports);
var _isFutureMjs = require("./isFuture.mjs");
parcelHelpers.exportAll(_isFutureMjs, exports);
var _isLastDayOfMonthMjs = require("./isLastDayOfMonth.mjs");
parcelHelpers.exportAll(_isLastDayOfMonthMjs, exports);
var _isLeapYearMjs = require("./isLeapYear.mjs");
parcelHelpers.exportAll(_isLeapYearMjs, exports);
var _isMatchMjs = require("./isMatch.mjs");
parcelHelpers.exportAll(_isMatchMjs, exports);
var _isMondayMjs = require("./isMonday.mjs");
parcelHelpers.exportAll(_isMondayMjs, exports);
var _isPastMjs = require("./isPast.mjs");
parcelHelpers.exportAll(_isPastMjs, exports);
var _isSameDayMjs = require("./isSameDay.mjs");
parcelHelpers.exportAll(_isSameDayMjs, exports);
var _isSameHourMjs = require("./isSameHour.mjs");
parcelHelpers.exportAll(_isSameHourMjs, exports);
var _isSameISOWeekMjs = require("./isSameISOWeek.mjs");
parcelHelpers.exportAll(_isSameISOWeekMjs, exports);
var _isSameISOWeekYearMjs = require("./isSameISOWeekYear.mjs");
parcelHelpers.exportAll(_isSameISOWeekYearMjs, exports);
var _isSameMinuteMjs = require("./isSameMinute.mjs");
parcelHelpers.exportAll(_isSameMinuteMjs, exports);
var _isSameMonthMjs = require("./isSameMonth.mjs");
parcelHelpers.exportAll(_isSameMonthMjs, exports);
var _isSameQuarterMjs = require("./isSameQuarter.mjs");
parcelHelpers.exportAll(_isSameQuarterMjs, exports);
var _isSameSecondMjs = require("./isSameSecond.mjs");
parcelHelpers.exportAll(_isSameSecondMjs, exports);
var _isSameWeekMjs = require("./isSameWeek.mjs");
parcelHelpers.exportAll(_isSameWeekMjs, exports);
var _isSameYearMjs = require("./isSameYear.mjs");
parcelHelpers.exportAll(_isSameYearMjs, exports);
var _isSaturdayMjs = require("./isSaturday.mjs");
parcelHelpers.exportAll(_isSaturdayMjs, exports);
var _isSundayMjs = require("./isSunday.mjs");
parcelHelpers.exportAll(_isSundayMjs, exports);
var _isThisHourMjs = require("./isThisHour.mjs");
parcelHelpers.exportAll(_isThisHourMjs, exports);
var _isThisISOWeekMjs = require("./isThisISOWeek.mjs");
parcelHelpers.exportAll(_isThisISOWeekMjs, exports);
var _isThisMinuteMjs = require("./isThisMinute.mjs");
parcelHelpers.exportAll(_isThisMinuteMjs, exports);
var _isThisMonthMjs = require("./isThisMonth.mjs");
parcelHelpers.exportAll(_isThisMonthMjs, exports);
var _isThisQuarterMjs = require("./isThisQuarter.mjs");
parcelHelpers.exportAll(_isThisQuarterMjs, exports);
var _isThisSecondMjs = require("./isThisSecond.mjs");
parcelHelpers.exportAll(_isThisSecondMjs, exports);
var _isThisWeekMjs = require("./isThisWeek.mjs");
parcelHelpers.exportAll(_isThisWeekMjs, exports);
var _isThisYearMjs = require("./isThisYear.mjs");
parcelHelpers.exportAll(_isThisYearMjs, exports);
var _isThursdayMjs = require("./isThursday.mjs");
parcelHelpers.exportAll(_isThursdayMjs, exports);
var _isTodayMjs = require("./isToday.mjs");
parcelHelpers.exportAll(_isTodayMjs, exports);
var _isTomorrowMjs = require("./isTomorrow.mjs");
parcelHelpers.exportAll(_isTomorrowMjs, exports);
var _isTuesdayMjs = require("./isTuesday.mjs");
parcelHelpers.exportAll(_isTuesdayMjs, exports);
var _isValidMjs = require("./isValid.mjs");
parcelHelpers.exportAll(_isValidMjs, exports);
var _isWednesdayMjs = require("./isWednesday.mjs");
parcelHelpers.exportAll(_isWednesdayMjs, exports);
var _isWeekendMjs = require("./isWeekend.mjs");
parcelHelpers.exportAll(_isWeekendMjs, exports);
var _isWithinIntervalMjs = require("./isWithinInterval.mjs");
parcelHelpers.exportAll(_isWithinIntervalMjs, exports);
var _isYesterdayMjs = require("./isYesterday.mjs");
parcelHelpers.exportAll(_isYesterdayMjs, exports);
var _lastDayOfDecadeMjs = require("./lastDayOfDecade.mjs");
parcelHelpers.exportAll(_lastDayOfDecadeMjs, exports);
var _lastDayOfISOWeekMjs = require("./lastDayOfISOWeek.mjs");
parcelHelpers.exportAll(_lastDayOfISOWeekMjs, exports);
var _lastDayOfISOWeekYearMjs = require("./lastDayOfISOWeekYear.mjs");
parcelHelpers.exportAll(_lastDayOfISOWeekYearMjs, exports);
var _lastDayOfMonthMjs = require("./lastDayOfMonth.mjs");
parcelHelpers.exportAll(_lastDayOfMonthMjs, exports);
var _lastDayOfQuarterMjs = require("./lastDayOfQuarter.mjs");
parcelHelpers.exportAll(_lastDayOfQuarterMjs, exports);
var _lastDayOfWeekMjs = require("./lastDayOfWeek.mjs");
parcelHelpers.exportAll(_lastDayOfWeekMjs, exports);
var _lastDayOfYearMjs = require("./lastDayOfYear.mjs");
parcelHelpers.exportAll(_lastDayOfYearMjs, exports);
var _lightFormatMjs = require("./lightFormat.mjs");
parcelHelpers.exportAll(_lightFormatMjs, exports);
var _maxMjs = require("./max.mjs");
parcelHelpers.exportAll(_maxMjs, exports);
var _millisecondsMjs = require("./milliseconds.mjs");
parcelHelpers.exportAll(_millisecondsMjs, exports);
var _millisecondsToHoursMjs = require("./millisecondsToHours.mjs");
parcelHelpers.exportAll(_millisecondsToHoursMjs, exports);
var _millisecondsToMinutesMjs = require("./millisecondsToMinutes.mjs");
parcelHelpers.exportAll(_millisecondsToMinutesMjs, exports);
var _millisecondsToSecondsMjs = require("./millisecondsToSeconds.mjs");
parcelHelpers.exportAll(_millisecondsToSecondsMjs, exports);
var _minMjs = require("./min.mjs");
parcelHelpers.exportAll(_minMjs, exports);
var _minutesToHoursMjs = require("./minutesToHours.mjs");
parcelHelpers.exportAll(_minutesToHoursMjs, exports);
var _minutesToMillisecondsMjs = require("./minutesToMilliseconds.mjs");
parcelHelpers.exportAll(_minutesToMillisecondsMjs, exports);
var _minutesToSecondsMjs = require("./minutesToSeconds.mjs");
parcelHelpers.exportAll(_minutesToSecondsMjs, exports);
var _monthsToQuartersMjs = require("./monthsToQuarters.mjs");
parcelHelpers.exportAll(_monthsToQuartersMjs, exports);
var _monthsToYearsMjs = require("./monthsToYears.mjs");
parcelHelpers.exportAll(_monthsToYearsMjs, exports);
var _nextDayMjs = require("./nextDay.mjs");
parcelHelpers.exportAll(_nextDayMjs, exports);
var _nextFridayMjs = require("./nextFriday.mjs");
parcelHelpers.exportAll(_nextFridayMjs, exports);
var _nextMondayMjs = require("./nextMonday.mjs");
parcelHelpers.exportAll(_nextMondayMjs, exports);
var _nextSaturdayMjs = require("./nextSaturday.mjs");
parcelHelpers.exportAll(_nextSaturdayMjs, exports);
var _nextSundayMjs = require("./nextSunday.mjs");
parcelHelpers.exportAll(_nextSundayMjs, exports);
var _nextThursdayMjs = require("./nextThursday.mjs");
parcelHelpers.exportAll(_nextThursdayMjs, exports);
var _nextTuesdayMjs = require("./nextTuesday.mjs");
parcelHelpers.exportAll(_nextTuesdayMjs, exports);
var _nextWednesdayMjs = require("./nextWednesday.mjs");
parcelHelpers.exportAll(_nextWednesdayMjs, exports);
var _parseMjs = require("./parse.mjs");
parcelHelpers.exportAll(_parseMjs, exports);
var _parseISOMjs = require("./parseISO.mjs");
parcelHelpers.exportAll(_parseISOMjs, exports);
var _parseJSONMjs = require("./parseJSON.mjs");
parcelHelpers.exportAll(_parseJSONMjs, exports);
var _previousDayMjs = require("./previousDay.mjs");
parcelHelpers.exportAll(_previousDayMjs, exports);
var _previousFridayMjs = require("./previousFriday.mjs");
parcelHelpers.exportAll(_previousFridayMjs, exports);
var _previousMondayMjs = require("./previousMonday.mjs");
parcelHelpers.exportAll(_previousMondayMjs, exports);
var _previousSaturdayMjs = require("./previousSaturday.mjs");
parcelHelpers.exportAll(_previousSaturdayMjs, exports);
var _previousSundayMjs = require("./previousSunday.mjs");
parcelHelpers.exportAll(_previousSundayMjs, exports);
var _previousThursdayMjs = require("./previousThursday.mjs");
parcelHelpers.exportAll(_previousThursdayMjs, exports);
var _previousTuesdayMjs = require("./previousTuesday.mjs");
parcelHelpers.exportAll(_previousTuesdayMjs, exports);
var _previousWednesdayMjs = require("./previousWednesday.mjs");
parcelHelpers.exportAll(_previousWednesdayMjs, exports);
var _quartersToMonthsMjs = require("./quartersToMonths.mjs");
parcelHelpers.exportAll(_quartersToMonthsMjs, exports);
var _quartersToYearsMjs = require("./quartersToYears.mjs");
parcelHelpers.exportAll(_quartersToYearsMjs, exports);
var _roundToNearestHoursMjs = require("./roundToNearestHours.mjs");
parcelHelpers.exportAll(_roundToNearestHoursMjs, exports);
var _roundToNearestMinutesMjs = require("./roundToNearestMinutes.mjs");
parcelHelpers.exportAll(_roundToNearestMinutesMjs, exports);
var _secondsToHoursMjs = require("./secondsToHours.mjs");
parcelHelpers.exportAll(_secondsToHoursMjs, exports);
var _secondsToMillisecondsMjs = require("./secondsToMilliseconds.mjs");
parcelHelpers.exportAll(_secondsToMillisecondsMjs, exports);
var _secondsToMinutesMjs = require("./secondsToMinutes.mjs");
parcelHelpers.exportAll(_secondsToMinutesMjs, exports);
var _setMjs = require("./set.mjs");
parcelHelpers.exportAll(_setMjs, exports);
var _setDateMjs = require("./setDate.mjs");
parcelHelpers.exportAll(_setDateMjs, exports);
var _setDayMjs = require("./setDay.mjs");
parcelHelpers.exportAll(_setDayMjs, exports);
var _setDayOfYearMjs = require("./setDayOfYear.mjs");
parcelHelpers.exportAll(_setDayOfYearMjs, exports);
var _setDefaultOptionsMjs = require("./setDefaultOptions.mjs");
parcelHelpers.exportAll(_setDefaultOptionsMjs, exports);
var _setHoursMjs = require("./setHours.mjs");
parcelHelpers.exportAll(_setHoursMjs, exports);
var _setISODayMjs = require("./setISODay.mjs");
parcelHelpers.exportAll(_setISODayMjs, exports);
var _setISOWeekMjs = require("./setISOWeek.mjs");
parcelHelpers.exportAll(_setISOWeekMjs, exports);
var _setISOWeekYearMjs = require("./setISOWeekYear.mjs");
parcelHelpers.exportAll(_setISOWeekYearMjs, exports);
var _setMillisecondsMjs = require("./setMilliseconds.mjs");
parcelHelpers.exportAll(_setMillisecondsMjs, exports);
var _setMinutesMjs = require("./setMinutes.mjs");
parcelHelpers.exportAll(_setMinutesMjs, exports);
var _setMonthMjs = require("./setMonth.mjs");
parcelHelpers.exportAll(_setMonthMjs, exports);
var _setQuarterMjs = require("./setQuarter.mjs");
parcelHelpers.exportAll(_setQuarterMjs, exports);
var _setSecondsMjs = require("./setSeconds.mjs");
parcelHelpers.exportAll(_setSecondsMjs, exports);
var _setWeekMjs = require("./setWeek.mjs");
parcelHelpers.exportAll(_setWeekMjs, exports);
var _setWeekYearMjs = require("./setWeekYear.mjs");
parcelHelpers.exportAll(_setWeekYearMjs, exports);
var _setYearMjs = require("./setYear.mjs");
parcelHelpers.exportAll(_setYearMjs, exports);
var _startOfDayMjs = require("./startOfDay.mjs");
parcelHelpers.exportAll(_startOfDayMjs, exports);
var _startOfDecadeMjs = require("./startOfDecade.mjs");
parcelHelpers.exportAll(_startOfDecadeMjs, exports);
var _startOfHourMjs = require("./startOfHour.mjs");
parcelHelpers.exportAll(_startOfHourMjs, exports);
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
parcelHelpers.exportAll(_startOfISOWeekMjs, exports);
var _startOfISOWeekYearMjs = require("./startOfISOWeekYear.mjs");
parcelHelpers.exportAll(_startOfISOWeekYearMjs, exports);
var _startOfMinuteMjs = require("./startOfMinute.mjs");
parcelHelpers.exportAll(_startOfMinuteMjs, exports);
var _startOfMonthMjs = require("./startOfMonth.mjs");
parcelHelpers.exportAll(_startOfMonthMjs, exports);
var _startOfQuarterMjs = require("./startOfQuarter.mjs");
parcelHelpers.exportAll(_startOfQuarterMjs, exports);
var _startOfSecondMjs = require("./startOfSecond.mjs");
parcelHelpers.exportAll(_startOfSecondMjs, exports);
var _startOfTodayMjs = require("./startOfToday.mjs");
parcelHelpers.exportAll(_startOfTodayMjs, exports);
var _startOfTomorrowMjs = require("./startOfTomorrow.mjs");
parcelHelpers.exportAll(_startOfTomorrowMjs, exports);
var _startOfWeekMjs = require("./startOfWeek.mjs");
parcelHelpers.exportAll(_startOfWeekMjs, exports);
var _startOfWeekYearMjs = require("./startOfWeekYear.mjs");
parcelHelpers.exportAll(_startOfWeekYearMjs, exports);
var _startOfYearMjs = require("./startOfYear.mjs");
parcelHelpers.exportAll(_startOfYearMjs, exports);
var _startOfYesterdayMjs = require("./startOfYesterday.mjs");
parcelHelpers.exportAll(_startOfYesterdayMjs, exports);
var _subMjs = require("./sub.mjs");
parcelHelpers.exportAll(_subMjs, exports);
var _subBusinessDaysMjs = require("./subBusinessDays.mjs");
parcelHelpers.exportAll(_subBusinessDaysMjs, exports);
var _subDaysMjs = require("./subDays.mjs");
parcelHelpers.exportAll(_subDaysMjs, exports);
var _subHoursMjs = require("./subHours.mjs");
parcelHelpers.exportAll(_subHoursMjs, exports);
var _subISOWeekYearsMjs = require("./subISOWeekYears.mjs");
parcelHelpers.exportAll(_subISOWeekYearsMjs, exports);
var _subMillisecondsMjs = require("./subMilliseconds.mjs");
parcelHelpers.exportAll(_subMillisecondsMjs, exports);
var _subMinutesMjs = require("./subMinutes.mjs");
parcelHelpers.exportAll(_subMinutesMjs, exports);
var _subMonthsMjs = require("./subMonths.mjs");
parcelHelpers.exportAll(_subMonthsMjs, exports);
var _subQuartersMjs = require("./subQuarters.mjs");
parcelHelpers.exportAll(_subQuartersMjs, exports);
var _subSecondsMjs = require("./subSeconds.mjs");
parcelHelpers.exportAll(_subSecondsMjs, exports);
var _subWeeksMjs = require("./subWeeks.mjs");
parcelHelpers.exportAll(_subWeeksMjs, exports);
var _subYearsMjs = require("./subYears.mjs");
parcelHelpers.exportAll(_subYearsMjs, exports);
var _toDateMjs = require("./toDate.mjs");
parcelHelpers.exportAll(_toDateMjs, exports);
var _transposeMjs = require("./transpose.mjs");
parcelHelpers.exportAll(_transposeMjs, exports);
var _weeksToDaysMjs = require("./weeksToDays.mjs");
parcelHelpers.exportAll(_weeksToDaysMjs, exports);
var _yearsToDaysMjs = require("./yearsToDays.mjs");
parcelHelpers.exportAll(_yearsToDaysMjs, exports);
var _yearsToMonthsMjs = require("./yearsToMonths.mjs");
parcelHelpers.exportAll(_yearsToMonthsMjs, exports);
var _yearsToQuartersMjs = require("./yearsToQuarters.mjs");
parcelHelpers.exportAll(_yearsToQuartersMjs, exports);

},{"./add.mjs":"9T8my","./addBusinessDays.mjs":"90wry","./addDays.mjs":"6zihD","./addHours.mjs":"3lB5S","./addISOWeekYears.mjs":"1NJg9","./addMilliseconds.mjs":"jqa9L","./addMinutes.mjs":"EoBBG","./addMonths.mjs":"7MGhe","./addQuarters.mjs":"9dHhj","./addSeconds.mjs":"f072z","./addWeeks.mjs":"ggWxE","./addYears.mjs":"2253z","./areIntervalsOverlapping.mjs":"hCjLl","./clamp.mjs":"bo68o","./closestIndexTo.mjs":"kLjYJ","./closestTo.mjs":"kW9sH","./compareAsc.mjs":"99hec","./compareDesc.mjs":"7AnoX","./constructFrom.mjs":"aoN9f","./constructNow.mjs":"8zr8Z","./daysToWeeks.mjs":"ahN5e","./differenceInBusinessDays.mjs":"azqlr","./differenceInCalendarDays.mjs":"157c4","./differenceInCalendarISOWeekYears.mjs":"459B3","./differenceInCalendarISOWeeks.mjs":"i53Tf","./differenceInCalendarMonths.mjs":"5o9ya","./differenceInCalendarQuarters.mjs":"UvlTu","./differenceInCalendarWeeks.mjs":"ceMOy","./differenceInCalendarYears.mjs":"ePGcW","./differenceInDays.mjs":"hoq2u","./differenceInHours.mjs":"8WDQc","./differenceInISOWeekYears.mjs":"ewDOm","./differenceInMilliseconds.mjs":"f8pcK","./differenceInMinutes.mjs":"l5BaQ","./differenceInMonths.mjs":"hgqlH","./differenceInQuarters.mjs":"9p8MN","./differenceInSeconds.mjs":"7Tn5g","./differenceInWeeks.mjs":"8dzxz","./differenceInYears.mjs":"3XWcb","./eachDayOfInterval.mjs":"judLH","./eachHourOfInterval.mjs":"gPVAq","./eachMinuteOfInterval.mjs":"cnVAK","./eachMonthOfInterval.mjs":"b7b5O","./eachQuarterOfInterval.mjs":"84k5D","./eachWeekOfInterval.mjs":"6EPCV","./eachWeekendOfInterval.mjs":"e2alP","./eachWeekendOfMonth.mjs":"6qjHe","./eachWeekendOfYear.mjs":"k3Qof","./eachYearOfInterval.mjs":"eaGyr","./endOfDay.mjs":"kIbiR","./endOfDecade.mjs":"Vji9B","./endOfHour.mjs":"1Zaot","./endOfISOWeek.mjs":"NObPe","./endOfISOWeekYear.mjs":"eUYKj","./endOfMinute.mjs":"kcUt1","./endOfMonth.mjs":"8SCOH","./endOfQuarter.mjs":"1Hu4v","./endOfSecond.mjs":"53va6","./endOfToday.mjs":"1LVml","./endOfTomorrow.mjs":"gERNb","./endOfWeek.mjs":"8etTu","./endOfYear.mjs":"4OJ4u","./endOfYesterday.mjs":"91Vbe","./format.mjs":"485lL","./formatDistance.mjs":"i7xvD","./formatDistanceStrict.mjs":"9iJxw","./formatDistanceToNow.mjs":"lImTi","./formatDistanceToNowStrict.mjs":"0yBPn","./formatDuration.mjs":"iOeT5","./formatISO.mjs":"7srQr","./formatISO9075.mjs":"1dYHH","./formatISODuration.mjs":"359ht","./formatRFC3339.mjs":"4EA2z","./formatRFC7231.mjs":"kQxT1","./formatRelative.mjs":"7oFgl","./fromUnixTime.mjs":"7fHhy","./getDate.mjs":"3iDke","./getDay.mjs":"e5GCB","./getDayOfYear.mjs":"j5Ofr","./getDaysInMonth.mjs":"bXxcX","./getDaysInYear.mjs":"fPW4c","./getDecade.mjs":"2RfeO","./getDefaultOptions.mjs":"cmusC","./getHours.mjs":"fxRXK","./getISODay.mjs":"kPl3b","./getISOWeek.mjs":"hhzZS","./getISOWeekYear.mjs":"iN2l0","./getISOWeeksInYear.mjs":"1mplI","./getMilliseconds.mjs":"4bnhg","./getMinutes.mjs":"1sjZu","./getMonth.mjs":"6r8Xo","./getOverlappingDaysInIntervals.mjs":"4X1Z3","./getQuarter.mjs":"clCmJ","./getSeconds.mjs":"d5oLr","./getTime.mjs":"lpflw","./getUnixTime.mjs":"kjgRM","./getWeek.mjs":"bYzCC","./getWeekOfMonth.mjs":"48IZO","./getWeekYear.mjs":"uCMnT","./getWeeksInMonth.mjs":"j6dTC","./getYear.mjs":"3undW","./hoursToMilliseconds.mjs":"9OEBd","./hoursToMinutes.mjs":"cPXIu","./hoursToSeconds.mjs":"47cro","./interval.mjs":"8Rnpx","./intervalToDuration.mjs":"l77Rp","./intlFormat.mjs":"bI71Z","./intlFormatDistance.mjs":"6h6Jh","./isAfter.mjs":"89XEz","./isBefore.mjs":"3R0Tu","./isDate.mjs":"a8ZBt","./isEqual.mjs":"gHkqW","./isExists.mjs":"36e4b","./isFirstDayOfMonth.mjs":"k00Aa","./isFriday.mjs":"eBLgR","./isFuture.mjs":"9mTQg","./isLastDayOfMonth.mjs":"fBygP","./isLeapYear.mjs":"lMNj8","./isMatch.mjs":"wP59U","./isMonday.mjs":"4kjZc","./isPast.mjs":"5bhxL","./isSameDay.mjs":"265Cc","./isSameHour.mjs":"aBU16","./isSameISOWeek.mjs":"9p0Pa","./isSameISOWeekYear.mjs":"iUPI4","./isSameMinute.mjs":"j045I","./isSameMonth.mjs":"hV5am","./isSameQuarter.mjs":"d5Afs","./isSameSecond.mjs":"a7O5b","./isSameWeek.mjs":"kHX9m","./isSameYear.mjs":"kO2r7","./isSaturday.mjs":"1HAz4","./isSunday.mjs":"38dHR","./isThisHour.mjs":"4IZTu","./isThisISOWeek.mjs":"bENnF","./isThisMinute.mjs":"52ftk","./isThisMonth.mjs":"eKk8f","./isThisQuarter.mjs":"flZVP","./isThisSecond.mjs":"djK4R","./isThisWeek.mjs":"N4XJM","./isThisYear.mjs":"coSfR","./isThursday.mjs":"7sBv4","./isToday.mjs":"gcnmR","./isTomorrow.mjs":"dLEGn","./isTuesday.mjs":"kfkgT","./isValid.mjs":"8moLi","./isWednesday.mjs":"8FbeG","./isWeekend.mjs":"4YiqU","./isWithinInterval.mjs":"5B0CX","./isYesterday.mjs":"gW0VU","./lastDayOfDecade.mjs":"HmZaB","./lastDayOfISOWeek.mjs":"fOqx1","./lastDayOfISOWeekYear.mjs":"boXSf","./lastDayOfMonth.mjs":"5xjKA","./lastDayOfQuarter.mjs":"6h1A8","./lastDayOfWeek.mjs":"c6NJi","./lastDayOfYear.mjs":"3BZ9B","./lightFormat.mjs":"iHfft","./max.mjs":"c4ArS","./milliseconds.mjs":"deU9E","./millisecondsToHours.mjs":"kynq9","./millisecondsToMinutes.mjs":"gA0wF","./millisecondsToSeconds.mjs":"kqBpo","./min.mjs":"1gBPe","./minutesToHours.mjs":"ktxeo","./minutesToMilliseconds.mjs":"ldujC","./minutesToSeconds.mjs":"xVzzN","./monthsToQuarters.mjs":"gyKDA","./monthsToYears.mjs":"80mxc","./nextDay.mjs":"it6Fh","./nextFriday.mjs":"4Li8d","./nextMonday.mjs":"32FK2","./nextSaturday.mjs":"4wpoJ","./nextSunday.mjs":"fwB72","./nextThursday.mjs":"7BmNm","./nextTuesday.mjs":"7jUde","./nextWednesday.mjs":"lctMn","./parse.mjs":"2OEEQ","./parseISO.mjs":"agu6R","./parseJSON.mjs":"as85I","./previousDay.mjs":"4rSP6","./previousFriday.mjs":"9Nc66","./previousMonday.mjs":"e5zJz","./previousSaturday.mjs":"jayle","./previousSunday.mjs":"gKllv","./previousThursday.mjs":"b0E6W","./previousTuesday.mjs":"9WWCj","./previousWednesday.mjs":"4plUf","./quartersToMonths.mjs":"hlJcP","./quartersToYears.mjs":"jQmKr","./roundToNearestHours.mjs":"6ETGD","./roundToNearestMinutes.mjs":"kiDo1","./secondsToHours.mjs":"j8yPy","./secondsToMilliseconds.mjs":"5zEHL","./secondsToMinutes.mjs":"9ycfB","./set.mjs":"3vAo0","./setDate.mjs":"gAj5J","./setDay.mjs":"cBlks","./setDayOfYear.mjs":"34HbC","./setDefaultOptions.mjs":"4G8HK","./setHours.mjs":"2wGfp","./setISODay.mjs":"ck1p8","./setISOWeek.mjs":"gkktW","./setISOWeekYear.mjs":"ehg2H","./setMilliseconds.mjs":"c4W1y","./setMinutes.mjs":"j0ZBw","./setMonth.mjs":"kZNby","./setQuarter.mjs":"D4zeu","./setSeconds.mjs":"aCwKc","./setWeek.mjs":"bUVq6","./setWeekYear.mjs":"2SUSn","./setYear.mjs":"ktxZI","./startOfDay.mjs":"dAYr2","./startOfDecade.mjs":"4R7Sh","./startOfHour.mjs":"8ME71","./startOfISOWeek.mjs":"9qSeF","./startOfISOWeekYear.mjs":"edLgJ","./startOfMinute.mjs":"eIDyY","./startOfMonth.mjs":"9Xfx6","./startOfQuarter.mjs":"3MxaQ","./startOfSecond.mjs":"9uHeC","./startOfToday.mjs":"dqjKD","./startOfTomorrow.mjs":"hpe9L","./startOfWeek.mjs":"kLIcV","./startOfWeekYear.mjs":"2Mh6u","./startOfYear.mjs":"ceIPy","./startOfYesterday.mjs":"a41HB","./sub.mjs":"5L8RT","./subBusinessDays.mjs":"9SMWV","./subDays.mjs":"99ld1","./subHours.mjs":"5Ga3q","./subISOWeekYears.mjs":"g2YRM","./subMilliseconds.mjs":"inVDF","./subMinutes.mjs":"fF89A","./subMonths.mjs":"luWin","./subQuarters.mjs":"4fZO1","./subSeconds.mjs":"269Fi","./subWeeks.mjs":"cYQHR","./subYears.mjs":"iEtOp","./toDate.mjs":"5c6W0","./transpose.mjs":"1f8Gh","./weeksToDays.mjs":"a7XRC","./yearsToDays.mjs":"9Sgwk","./yearsToMonths.mjs":"iGKI6","./yearsToQuarters.mjs":"7Gp77","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9T8my":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ parcelHelpers.export(exports, "add", function() {
    return add;
});
var _addDaysMjs = require("./addDays.mjs");
var _addMonthsMjs = require("./addMonths.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
var _toDateMjs = require("./toDate.mjs");
function add(date, duration) {
    var _duration_years = duration.years, years = _duration_years === void 0 ? 0 : _duration_years, _duration_months = duration.months, months = _duration_months === void 0 ? 0 : _duration_months, _duration_weeks = duration.weeks, weeks = _duration_weeks === void 0 ? 0 : _duration_weeks, _duration_days = duration.days, days = _duration_days === void 0 ? 0 : _duration_days, _duration_hours = duration.hours, hours = _duration_hours === void 0 ? 0 : _duration_hours, _duration_minutes = duration.minutes, minutes = _duration_minutes === void 0 ? 0 : _duration_minutes, _duration_seconds = duration.seconds, seconds = _duration_seconds === void 0 ? 0 : _duration_seconds;
    // Add years and months
    var _date = (0, _toDateMjs.toDate)(date);
    var dateWithMonths = months || years ? (0, _addMonthsMjs.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, _addDaysMjs.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = (0, _constructFromMjs.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}
// Fallback for modularized imports:
exports.default = add;

},{"./addDays.mjs":"6zihD","./addMonths.mjs":"7MGhe","./constructFrom.mjs":"aoN9f","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6zihD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ parcelHelpers.export(exports, "addDays", function() {
    return addDays;
});
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function addDays(date, amount) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (isNaN(amount)) return (0, _constructFromMjs.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
// Fallback for modularized imports:
exports.default = addDays;

},{"./toDate.mjs":"5c6W0","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5c6W0":[function(require,module,exports) {
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
function toDate(argument) {
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
// Fallback for modularized imports:
exports.default = toDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aoN9f":[function(require,module,exports) {
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructFrom", function() {
    return constructFrom;
});
function constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
// Fallback for modularized imports:
exports.default = constructFrom;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7MGhe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ parcelHelpers.export(exports, "addMonths", function() {
    return addMonths;
});
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function addMonths(date, amount) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (isNaN(amount)) return (0, _constructFromMjs.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    var dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = (0, _constructFromMjs.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
// Fallback for modularized imports:
exports.default = addMonths;

},{"./toDate.mjs":"5c6W0","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"90wry":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ parcelHelpers.export(exports, "addBusinessDays", function() {
    return addBusinessDays;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _isSaturdayMjs = require("./isSaturday.mjs");
var _isSundayMjs = require("./isSunday.mjs");
var _isWeekendMjs = require("./isWeekend.mjs");
var _toDateMjs = require("./toDate.mjs");
function addBusinessDays(date, amount) {
    var _date = (0, _toDateMjs.toDate)(date);
    var startedOnWeekend = (0, _isWeekendMjs.isWeekend)(_date);
    if (isNaN(amount)) return (0, _constructFromMjs.constructFrom)(date, NaN);
    var hours = _date.getHours();
    var sign = amount < 0 ? -1 : 1;
    var fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    var restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, _isWeekendMjs.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, _isWeekendMjs.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, _isSaturdayMjs.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, _isSundayMjs.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}
// Fallback for modularized imports:
exports.default = addBusinessDays;

},{"./constructFrom.mjs":"aoN9f","./isSaturday.mjs":"1HAz4","./isSunday.mjs":"38dHR","./isWeekend.mjs":"4YiqU","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1HAz4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ parcelHelpers.export(exports, "isSaturday", function() {
    return isSaturday;
});
var _toDateMjs = require("./toDate.mjs");
function isSaturday(date) {
    return (0, _toDateMjs.toDate)(date).getDay() === 6;
}
// Fallback for modularized imports:
exports.default = isSaturday;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"38dHR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ parcelHelpers.export(exports, "isSunday", function() {
    return isSunday;
});
var _toDateMjs = require("./toDate.mjs");
function isSunday(date) {
    return (0, _toDateMjs.toDate)(date).getDay() === 0;
}
// Fallback for modularized imports:
exports.default = isSunday;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4YiqU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ parcelHelpers.export(exports, "isWeekend", function() {
    return isWeekend;
});
var _toDateMjs = require("./toDate.mjs");
function isWeekend(date) {
    var day = (0, _toDateMjs.toDate)(date).getDay();
    return day === 0 || day === 6;
}
// Fallback for modularized imports:
exports.default = isWeekend;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3lB5S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ parcelHelpers.export(exports, "addHours", function() {
    return addHours;
});
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
var _constantsMjs = require("./constants.mjs");
function addHours(date, amount) {
    return (0, _addMillisecondsMjs.addMilliseconds)(date, amount * (0, _constantsMjs.millisecondsInHour));
}
// Fallback for modularized imports:
exports.default = addHours;

},{"./addMilliseconds.mjs":"jqa9L","./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jqa9L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ parcelHelpers.export(exports, "addMilliseconds", function() {
    return addMilliseconds;
});
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function addMilliseconds(date, amount) {
    var timestamp = +(0, _toDateMjs.toDate)(date);
    return (0, _constructFromMjs.constructFrom)(date, timestamp + amount);
}
// Fallback for modularized imports:
exports.default = addMilliseconds;

},{"./toDate.mjs":"5c6W0","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dXQPO":[function(require,module,exports) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", function() {
    return daysInWeek;
});
parcelHelpers.export(exports, "daysInYear", function() {
    return daysInYear;
});
parcelHelpers.export(exports, "maxTime", function() {
    return maxTime;
});
parcelHelpers.export(exports, "minTime", function() {
    return minTime;
});
parcelHelpers.export(exports, "millisecondsInWeek", function() {
    return millisecondsInWeek;
});
parcelHelpers.export(exports, "millisecondsInDay", function() {
    return millisecondsInDay;
});
parcelHelpers.export(exports, "millisecondsInMinute", function() {
    return millisecondsInMinute;
});
parcelHelpers.export(exports, "millisecondsInHour", function() {
    return millisecondsInHour;
});
parcelHelpers.export(exports, "millisecondsInSecond", function() {
    return millisecondsInSecond;
});
parcelHelpers.export(exports, "minutesInYear", function() {
    return minutesInYear;
});
parcelHelpers.export(exports, "minutesInMonth", function() {
    return minutesInMonth;
});
parcelHelpers.export(exports, "minutesInDay", function() {
    return minutesInDay;
});
parcelHelpers.export(exports, "minutesInHour", function() {
    return minutesInHour;
});
parcelHelpers.export(exports, "monthsInQuarter", function() {
    return monthsInQuarter;
});
parcelHelpers.export(exports, "monthsInYear", function() {
    return monthsInYear;
});
parcelHelpers.export(exports, "quartersInYear", function() {
    return quartersInYear;
});
parcelHelpers.export(exports, "secondsInHour", function() {
    return secondsInHour;
});
parcelHelpers.export(exports, "secondsInMinute", function() {
    return secondsInMinute;
});
parcelHelpers.export(exports, "secondsInDay", function() {
    return secondsInDay;
});
parcelHelpers.export(exports, "secondsInWeek", function() {
    return secondsInWeek;
});
parcelHelpers.export(exports, "secondsInYear", function() {
    return secondsInYear;
});
parcelHelpers.export(exports, "secondsInMonth", function() {
    return secondsInMonth;
});
parcelHelpers.export(exports, "secondsInQuarter", function() {
    return secondsInQuarter;
});
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var minTime = -maxTime;
var millisecondsInWeek = 604800000;
var millisecondsInDay = 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minutesInYear = 525600;
var minutesInMonth = 43200;
var minutesInDay = 1440;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1NJg9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ parcelHelpers.export(exports, "addISOWeekYears", function() {
    return addISOWeekYears;
});
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
var _setISOWeekYearMjs = require("./setISOWeekYear.mjs");
function addISOWeekYears(date, amount) {
    return (0, _setISOWeekYearMjs.setISOWeekYear)(date, (0, _getISOWeekYearMjs.getISOWeekYear)(date) + amount);
}
// Fallback for modularized imports:
exports.default = addISOWeekYears;

},{"./getISOWeekYear.mjs":"iN2l0","./setISOWeekYear.mjs":"ehg2H","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iN2l0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ parcelHelpers.export(exports, "getISOWeekYear", function() {
    return getISOWeekYear;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _toDateMjs = require("./toDate.mjs");
function getISOWeekYear(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var fourthOfJanuaryOfNextYear = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getISOWeekYear;

},{"./constructFrom.mjs":"aoN9f","./startOfISOWeek.mjs":"9qSeF","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9qSeF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeek", function() {
    return startOfISOWeek;
});
var _startOfWeekMjs = require("./startOfWeek.mjs");
function startOfISOWeek(date) {
    return (0, _startOfWeekMjs.startOfWeek)(date, {
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = startOfISOWeek;

},{"./startOfWeek.mjs":"kLIcV","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kLIcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfWeek", function() {
    return startOfWeek;
});
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function startOfWeek(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _toDateMjs.toDate)(date);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeek;

},{"./toDate.mjs":"5c6W0","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fxdBE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", function() {
    return getDefaultOptions;
});
parcelHelpers.export(exports, "setDefaultOptions", function() {
    return setDefaultOptions;
});
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ehg2H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ parcelHelpers.export(exports, "setISOWeekYear", function() {
    return setISOWeekYear;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _startOfISOWeekYearMjs = require("./startOfISOWeekYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function setISOWeekYear(date, weekYear) {
    var _date = (0, _toDateMjs.toDate)(date);
    var diff = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_date, (0, _startOfISOWeekYearMjs.startOfISOWeekYear)(_date));
    var fourthOfJanuary = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, _startOfISOWeekYearMjs.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}
// Fallback for modularized imports:
exports.default = setISOWeekYear;

},{"./constructFrom.mjs":"aoN9f","./differenceInCalendarDays.mjs":"157c4","./startOfISOWeekYear.mjs":"edLgJ","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"157c4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInCalendarDays", function() {
    return differenceInCalendarDays;
});
var _constantsMjs = require("./constants.mjs");
var _startOfDayMjs = require("./startOfDay.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function differenceInCalendarDays(dateLeft, dateRight) {
    var startOfDayLeft = (0, _startOfDayMjs.startOfDay)(dateLeft);
    var startOfDayRight = (0, _startOfDayMjs.startOfDay)(dateRight);
    var timestampLeft = +startOfDayLeft - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    var timestampRight = +startOfDayRight - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, _constantsMjs.millisecondsInDay));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarDays;

},{"./constants.mjs":"dXQPO","./startOfDay.mjs":"dAYr2","./_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dAYr2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", function() {
    return startOfDay;
});
var _toDateMjs = require("./toDate.mjs");
function startOfDay(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDay;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bZ8h9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", function() {
    return getTimezoneOffsetInMilliseconds;
});
var _toDateMjs = require("../toDate.mjs");
function getTimezoneOffsetInMilliseconds(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"../toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"edLgJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeekYear", function() {
    return startOfISOWeekYear;
});
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function startOfISOWeekYear(date) {
    var year = (0, _getISOWeekYearMjs.getISOWeekYear)(date);
    var fourthOfJanuary = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuary);
}
// Fallback for modularized imports:
exports.default = startOfISOWeekYear;

},{"./getISOWeekYear.mjs":"iN2l0","./startOfISOWeek.mjs":"9qSeF","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"EoBBG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ parcelHelpers.export(exports, "addMinutes", function() {
    return addMinutes;
});
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
var _constantsMjs = require("./constants.mjs");
function addMinutes(date, amount) {
    return (0, _addMillisecondsMjs.addMilliseconds)(date, amount * (0, _constantsMjs.millisecondsInMinute));
}
// Fallback for modularized imports:
exports.default = addMinutes;

},{"./addMilliseconds.mjs":"jqa9L","./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9dHhj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ parcelHelpers.export(exports, "addQuarters", function() {
    return addQuarters;
});
var _addMonthsMjs = require("./addMonths.mjs");
function addQuarters(date, amount) {
    var months = amount * 3;
    return (0, _addMonthsMjs.addMonths)(date, months);
}
// Fallback for modularized imports:
exports.default = addQuarters;

},{"./addMonths.mjs":"7MGhe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"f072z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ parcelHelpers.export(exports, "addSeconds", function() {
    return addSeconds;
});
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
function addSeconds(date, amount) {
    return (0, _addMillisecondsMjs.addMilliseconds)(date, amount * 1000);
}
// Fallback for modularized imports:
exports.default = addSeconds;

},{"./addMilliseconds.mjs":"jqa9L","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ggWxE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ parcelHelpers.export(exports, "addWeeks", function() {
    return addWeeks;
});
var _addDaysMjs = require("./addDays.mjs");
function addWeeks(date, amount) {
    var days = amount * 7;
    return (0, _addDaysMjs.addDays)(date, days);
}
// Fallback for modularized imports:
exports.default = addWeeks;

},{"./addDays.mjs":"6zihD","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2253z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ parcelHelpers.export(exports, "addYears", function() {
    return addYears;
});
var _addMonthsMjs = require("./addMonths.mjs");
function addYears(date, amount) {
    return (0, _addMonthsMjs.addMonths)(date, amount * 12);
}
// Fallback for modularized imports:
exports.default = addYears;

},{"./addMonths.mjs":"7MGhe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hCjLl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ parcelHelpers.export(exports, "areIntervalsOverlapping", function() {
    return areIntervalsOverlapping;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toDateMjs = require("./toDate.mjs");
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    var _sort = (0, _slicedToArray._)([
        +(0, _toDateMjs.toDate)(intervalLeft.start),
        +(0, _toDateMjs.toDate)(intervalLeft.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), leftStartTime = _sort[0], leftEndTime = _sort[1];
    var _sort1 = (0, _slicedToArray._)([
        +(0, _toDateMjs.toDate)(intervalRight.start),
        +(0, _toDateMjs.toDate)(intervalRight.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), rightStartTime = _sort1[0], rightEndTime = _sort1[1];
    if (options === null || options === void 0 ? void 0 : options.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}
// Fallback for modularized imports:
exports.default = areIntervalsOverlapping;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bo68o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
var _maxMjs = require("./max.mjs");
var _minMjs = require("./min.mjs");
function clamp(date, interval) {
    return (0, _minMjs.min)([
        (0, _maxMjs.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}
// Fallback for modularized imports:
exports.default = clamp;

},{"./max.mjs":"c4ArS","./min.mjs":"1gBPe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"c4ArS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ parcelHelpers.export(exports, "max", function() {
    return max;
});
var _toDateMjs = require("./toDate.mjs");
function max(dates) {
    var result;
    dates.forEach(function(dirtyDate) {
        var currentDate = (0, _toDateMjs.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}
// Fallback for modularized imports:
exports.default = max;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1gBPe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ parcelHelpers.export(exports, "min", function() {
    return min;
});
var _toDateMjs = require("./toDate.mjs");
function min(dates) {
    var result;
    dates.forEach(function(dirtyDate) {
        var date = (0, _toDateMjs.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}
// Fallback for modularized imports:
exports.default = min;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kLjYJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ parcelHelpers.export(exports, "closestIndexTo", function() {
    return closestIndexTo;
});
var _toDateMjs = require("./toDate.mjs");
function closestIndexTo(dateToCompare, dates) {
    var date = (0, _toDateMjs.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    var timeToCompare = date.getTime();
    var result;
    var minDistance;
    dates.forEach(function(dirtyDate, index) {
        var currentDate = (0, _toDateMjs.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}
// Fallback for modularized imports:
exports.default = closestIndexTo;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kW9sH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ parcelHelpers.export(exports, "closestTo", function() {
    return closestTo;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _toDateMjs = require("./toDate.mjs");
function closestTo(dateToCompare, dates) {
    var date = (0, _toDateMjs.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, _constructFromMjs.constructFrom)(dateToCompare, NaN);
    var timeToCompare = date.getTime();
    var result;
    var minDistance;
    dates.forEach(function(dirtyDate) {
        var currentDate = (0, _toDateMjs.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, _constructFromMjs.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}
// Fallback for modularized imports:
exports.default = closestTo;

},{"./constructFrom.mjs":"aoN9f","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"99hec":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "compareAsc", function() {
    return compareAsc;
});
var _toDateMjs = require("./toDate.mjs");
function compareAsc(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
// Fallback for modularized imports:
exports.default = compareAsc;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7AnoX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "compareDesc", function() {
    return compareDesc;
});
var _toDateMjs = require("./toDate.mjs");
function compareDesc(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}
// Fallback for modularized imports:
exports.default = compareDesc;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8zr8Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ parcelHelpers.export(exports, "constructNow", function() {
    return constructNow;
});
var _constructFromMjs = require("./constructFrom.mjs");
function constructNow(date) {
    return (0, _constructFromMjs.constructFrom)(date, Date.now());
}
// Fallback for modularized imports:
exports.default = constructNow;

},{"./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ahN5e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ parcelHelpers.export(exports, "daysToWeeks", function() {
    return daysToWeeks;
});
var _constantsMjs = require("./constants.mjs");
function daysToWeeks(days) {
    var weeks = days / (0, _constantsMjs.daysInWeek);
    var result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = daysToWeeks;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"azqlr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ parcelHelpers.export(exports, "differenceInBusinessDays", function() {
    return differenceInBusinessDays;
});
var _addDaysMjs = require("./addDays.mjs");
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _isSameDayMjs = require("./isSameDay.mjs");
var _isValidMjs = require("./isValid.mjs");
var _isWeekendMjs = require("./isWeekend.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInBusinessDays(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    if (!(0, _isValidMjs.isValid)(_dateLeft) || !(0, _isValidMjs.isValid)(_dateRight)) return NaN;
    var calendarDifference = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_dateLeft, _dateRight);
    var sign = calendarDifference < 0 ? -1 : 1;
    var weeks = Math.trunc(calendarDifference / 7);
    var result = weeks * 5;
    _dateRight = (0, _addDaysMjs.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, _isSameDayMjs.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, _isWeekendMjs.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, _addDaysMjs.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = differenceInBusinessDays;

},{"./addDays.mjs":"6zihD","./differenceInCalendarDays.mjs":"157c4","./isSameDay.mjs":"265Cc","./isValid.mjs":"8moLi","./isWeekend.mjs":"4YiqU","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"265Cc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ parcelHelpers.export(exports, "isSameDay", function() {
    return isSameDay;
});
var _startOfDayMjs = require("./startOfDay.mjs");
function isSameDay(dateLeft, dateRight) {
    var dateLeftStartOfDay = (0, _startOfDayMjs.startOfDay)(dateLeft);
    var dateRightStartOfDay = (0, _startOfDayMjs.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}
// Fallback for modularized imports:
exports.default = isSameDay;

},{"./startOfDay.mjs":"dAYr2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8moLi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ parcelHelpers.export(exports, "isValid", function() {
    return isValid;
});
var _isDateMjs = require("./isDate.mjs");
var _toDateMjs = require("./toDate.mjs");
function isValid(date) {
    if (!(0, _isDateMjs.isDate)(date) && typeof date !== "number") return false;
    var _date = (0, _toDateMjs.toDate)(date);
    return !isNaN(Number(_date));
}
// Fallback for modularized imports:
exports.default = isValid;

},{"./isDate.mjs":"a8ZBt","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"a8ZBt":[function(require,module,exports) {
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", function() {
    return isDate;
});
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
// Fallback for modularized imports:
exports.default = isDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"459B3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", function() {
    return differenceInCalendarISOWeekYears;
});
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
function differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, _getISOWeekYearMjs.getISOWeekYear)(dateLeft) - (0, _getISOWeekYearMjs.getISOWeekYear)(dateRight);
}
// Fallback for modularized imports:
exports.default = differenceInCalendarISOWeekYears;

},{"./getISOWeekYear.mjs":"iN2l0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"i53Tf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ parcelHelpers.export(exports, "differenceInCalendarISOWeeks", function() {
    return differenceInCalendarISOWeeks;
});
var _constantsMjs = require("./constants.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function differenceInCalendarISOWeeks(dateLeft, dateRight) {
    var startOfISOWeekLeft = (0, _startOfISOWeekMjs.startOfISOWeek)(dateLeft);
    var startOfISOWeekRight = (0, _startOfISOWeekMjs.startOfISOWeek)(dateRight);
    var timestampLeft = +startOfISOWeekLeft - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    var timestampRight = +startOfISOWeekRight - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, _constantsMjs.millisecondsInWeek));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarISOWeeks;

},{"./constants.mjs":"dXQPO","./startOfISOWeek.mjs":"9qSeF","./_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5o9ya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ parcelHelpers.export(exports, "differenceInCalendarMonths", function() {
    return differenceInCalendarMonths;
});
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarMonths(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    var monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}
// Fallback for modularized imports:
exports.default = differenceInCalendarMonths;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"UvlTu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ parcelHelpers.export(exports, "differenceInCalendarQuarters", function() {
    return differenceInCalendarQuarters;
});
var _getQuarterMjs = require("./getQuarter.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarQuarters(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    var quarterDiff = (0, _getQuarterMjs.getQuarter)(_dateLeft) - (0, _getQuarterMjs.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}
// Fallback for modularized imports:
exports.default = differenceInCalendarQuarters;

},{"./getQuarter.mjs":"clCmJ","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"clCmJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ parcelHelpers.export(exports, "getQuarter", function() {
    return getQuarter;
});
var _toDateMjs = require("./toDate.mjs");
function getQuarter(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}
// Fallback for modularized imports:
exports.default = getQuarter;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ceMOy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ parcelHelpers.export(exports, "differenceInCalendarWeeks", function() {
    return differenceInCalendarWeeks;
});
var _constantsMjs = require("./constants.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
    var startOfWeekLeft = (0, _startOfWeekMjs.startOfWeek)(dateLeft, options);
    var startOfWeekRight = (0, _startOfWeekMjs.startOfWeek)(dateRight, options);
    var timestampLeft = +startOfWeekLeft - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    var timestampRight = +startOfWeekRight - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, _constantsMjs.millisecondsInWeek));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarWeeks;

},{"./constants.mjs":"dXQPO","./startOfWeek.mjs":"kLIcV","./_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ePGcW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ parcelHelpers.export(exports, "differenceInCalendarYears", function() {
    return differenceInCalendarYears;
});
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarYears(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}
// Fallback for modularized imports:
exports.default = differenceInCalendarYears;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hoq2u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ parcelHelpers.export(exports, "differenceInDays", function() {
    return differenceInDays;
});
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInDays(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var sign = compareLocalAsc(_dateLeft, _dateRight);
    var difference = Math.abs((0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(_dateLeft, _dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
// Fallback for modularized imports:
exports.default = differenceInDays;

},{"./differenceInCalendarDays.mjs":"157c4","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8WDQc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ parcelHelpers.export(exports, "differenceInHours", function() {
    return differenceInHours;
});
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _constantsMjs = require("./constants.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
function differenceInHours(dateLeft, dateRight, options) {
    var diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / (0, _constantsMjs.millisecondsInHour);
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInHours;

},{"./_lib/getRoundingMethod.mjs":"kV6yf","./constants.mjs":"dXQPO","./differenceInMilliseconds.mjs":"f8pcK","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kV6yf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", function() {
    return getRoundingMethod;
});
function getRoundingMethod(method) {
    return function(number) {
        var round = method ? Math[method] : Math.trunc;
        var result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"f8pcK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ parcelHelpers.export(exports, "differenceInMilliseconds", function() {
    return differenceInMilliseconds;
});
var _toDateMjs = require("./toDate.mjs");
function differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, _toDateMjs.toDate)(dateLeft) - +(0, _toDateMjs.toDate)(dateRight);
}
// Fallback for modularized imports:
exports.default = differenceInMilliseconds;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ewDOm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInISOWeekYears", function() {
    return differenceInISOWeekYears;
});
var _compareAscMjs = require("./compareAsc.mjs");
var _differenceInCalendarISOWeekYearsMjs = require("./differenceInCalendarISOWeekYears.mjs");
var _subISOWeekYearsMjs = require("./subISOWeekYears.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInISOWeekYears(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var sign = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight);
    var difference = Math.abs((0, _differenceInCalendarISOWeekYearsMjs.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, _subISOWeekYearsMjs.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastISOWeekYearNotFull = Number((0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight) === -sign);
    var result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = differenceInISOWeekYears;

},{"./compareAsc.mjs":"99hec","./differenceInCalendarISOWeekYears.mjs":"459B3","./subISOWeekYears.mjs":"g2YRM","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"g2YRM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ parcelHelpers.export(exports, "subISOWeekYears", function() {
    return subISOWeekYears;
});
var _addISOWeekYearsMjs = require("./addISOWeekYears.mjs");
function subISOWeekYears(date, amount) {
    return (0, _addISOWeekYearsMjs.addISOWeekYears)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subISOWeekYears;

},{"./addISOWeekYears.mjs":"1NJg9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"l5BaQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ parcelHelpers.export(exports, "differenceInMinutes", function() {
    return differenceInMinutes;
});
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _constantsMjs = require("./constants.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
function differenceInMinutes(dateLeft, dateRight, options) {
    var diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / (0, _constantsMjs.millisecondsInMinute);
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInMinutes;

},{"./_lib/getRoundingMethod.mjs":"kV6yf","./constants.mjs":"dXQPO","./differenceInMilliseconds.mjs":"f8pcK","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hgqlH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ parcelHelpers.export(exports, "differenceInMonths", function() {
    return differenceInMonths;
});
var _compareAscMjs = require("./compareAsc.mjs");
var _differenceInCalendarMonthsMjs = require("./differenceInCalendarMonths.mjs");
var _isLastDayOfMonthMjs = require("./isLastDayOfMonth.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInMonths(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var sign = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight);
    var difference = Math.abs((0, _differenceInCalendarMonthsMjs.differenceInCalendarMonths)(_dateLeft, _dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _isLastDayOfMonthMjs.isLastDayOfMonth)((0, _toDateMjs.toDate)(dateLeft)) && difference === 1 && (0, _compareAscMjs.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = differenceInMonths;

},{"./compareAsc.mjs":"99hec","./differenceInCalendarMonths.mjs":"5o9ya","./isLastDayOfMonth.mjs":"fBygP","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fBygP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ parcelHelpers.export(exports, "isLastDayOfMonth", function() {
    return isLastDayOfMonth;
});
var _endOfDayMjs = require("./endOfDay.mjs");
var _endOfMonthMjs = require("./endOfMonth.mjs");
var _toDateMjs = require("./toDate.mjs");
function isLastDayOfMonth(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    return +(0, _endOfDayMjs.endOfDay)(_date) === +(0, _endOfMonthMjs.endOfMonth)(_date);
}
// Fallback for modularized imports:
exports.default = isLastDayOfMonth;

},{"./endOfDay.mjs":"kIbiR","./endOfMonth.mjs":"8SCOH","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kIbiR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfDay", function() {
    return endOfDay;
});
var _toDateMjs = require("./toDate.mjs");
function endOfDay(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfDay;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8SCOH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfMonth", function() {
    return endOfMonth;
});
var _toDateMjs = require("./toDate.mjs");
function endOfMonth(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfMonth;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9p8MN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ parcelHelpers.export(exports, "differenceInQuarters", function() {
    return differenceInQuarters;
});
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _differenceInMonthsMjs = require("./differenceInMonths.mjs");
function differenceInQuarters(dateLeft, dateRight, options) {
    var diff = (0, _differenceInMonthsMjs.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInQuarters;

},{"./_lib/getRoundingMethod.mjs":"kV6yf","./differenceInMonths.mjs":"hgqlH","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7Tn5g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ parcelHelpers.export(exports, "differenceInSeconds", function() {
    return differenceInSeconds;
});
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
function differenceInSeconds(dateLeft, dateRight, options) {
    var diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInSeconds;

},{"./_lib/getRoundingMethod.mjs":"kV6yf","./differenceInMilliseconds.mjs":"f8pcK","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8dzxz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ parcelHelpers.export(exports, "differenceInWeeks", function() {
    return differenceInWeeks;
});
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _differenceInDaysMjs = require("./differenceInDays.mjs");
function differenceInWeeks(dateLeft, dateRight, options) {
    var diff = (0, _differenceInDaysMjs.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInWeeks;

},{"./_lib/getRoundingMethod.mjs":"kV6yf","./differenceInDays.mjs":"hoq2u","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3XWcb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInYears", function() {
    return differenceInYears;
});
var _compareAscMjs = require("./compareAsc.mjs");
var _differenceInCalendarYearsMjs = require("./differenceInCalendarYears.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInYears(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    var sign = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight);
    var difference = Math.abs((0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight) === -sign;
    var result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = differenceInYears;

},{"./compareAsc.mjs":"99hec","./differenceInCalendarYears.mjs":"ePGcW","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"judLH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachDayOfInterval", function() {
    return eachDayOfInterval;
});
var _toDateMjs = require("./toDate.mjs");
function eachDayOfInterval(interval, options) {
    var startDate = (0, _toDateMjs.toDate)(interval.start);
    var endDate = (0, _toDateMjs.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _toDateMjs.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachDayOfInterval;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gPVAq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachHourOfInterval", function() {
    return eachHourOfInterval;
});
var _addHoursMjs = require("./addHours.mjs");
var _toDateMjs = require("./toDate.mjs");
function eachHourOfInterval(interval, options) {
    var startDate = (0, _toDateMjs.toDate)(interval.start);
    var endDate = (0, _toDateMjs.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _toDateMjs.toDate)(currentDate));
        currentDate = (0, _addHoursMjs.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachHourOfInterval;

},{"./addHours.mjs":"3lB5S","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cnVAK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ parcelHelpers.export(exports, "eachMinuteOfInterval", function() {
    return eachMinuteOfInterval;
});
var _addMinutesMjs = require("./addMinutes.mjs");
var _startOfMinuteMjs = require("./startOfMinute.mjs");
var _toDateMjs = require("./toDate.mjs");
function eachMinuteOfInterval(interval, options) {
    var startDate = (0, _startOfMinuteMjs.startOfMinute)((0, _toDateMjs.toDate)(interval.start));
    var endDate = (0, _toDateMjs.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _toDateMjs.toDate)(currentDate));
        currentDate = (0, _addMinutesMjs.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachMinuteOfInterval;

},{"./addMinutes.mjs":"EoBBG","./startOfMinute.mjs":"eIDyY","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eIDyY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ parcelHelpers.export(exports, "startOfMinute", function() {
    return startOfMinute;
});
var _toDateMjs = require("./toDate.mjs");
function startOfMinute(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfMinute;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"b7b5O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachMonthOfInterval", function() {
    return eachMonthOfInterval;
});
var _toDateMjs = require("./toDate.mjs");
function eachMonthOfInterval(interval, options) {
    var startDate = (0, _toDateMjs.toDate)(interval.start);
    var endDate = (0, _toDateMjs.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _toDateMjs.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachMonthOfInterval;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"84k5D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ parcelHelpers.export(exports, "eachQuarterOfInterval", function() {
    return eachQuarterOfInterval;
});
var _addQuartersMjs = require("./addQuarters.mjs");
var _startOfQuarterMjs = require("./startOfQuarter.mjs");
var _toDateMjs = require("./toDate.mjs");
function eachQuarterOfInterval(interval, options) {
    var startDate = (0, _toDateMjs.toDate)(interval.start);
    var endDate = (0, _toDateMjs.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +(0, _startOfQuarterMjs.startOfQuarter)(startDate) : +(0, _startOfQuarterMjs.startOfQuarter)(endDate);
    var currentDate = reversed ? (0, _startOfQuarterMjs.startOfQuarter)(endDate) : (0, _startOfQuarterMjs.startOfQuarter)(startDate);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _toDateMjs.toDate)(currentDate));
        currentDate = (0, _addQuartersMjs.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachQuarterOfInterval;

},{"./addQuarters.mjs":"9dHhj","./startOfQuarter.mjs":"3MxaQ","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3MxaQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfQuarter", function() {
    return startOfQuarter;
});
var _toDateMjs = require("./toDate.mjs");
function startOfQuarter(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var currentMonth = _date.getMonth();
    var month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfQuarter;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6EPCV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachWeekOfInterval", function() {
    return eachWeekOfInterval;
});
var _addWeeksMjs = require("./addWeeks.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _toDateMjs = require("./toDate.mjs");
function eachWeekOfInterval(interval, options) {
    var startDate = (0, _toDateMjs.toDate)(interval.start);
    var endDate = (0, _toDateMjs.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var startDateWeek = reversed ? (0, _startOfWeekMjs.startOfWeek)(endDate, options) : (0, _startOfWeekMjs.startOfWeek)(startDate, options);
    var endDateWeek = reversed ? (0, _startOfWeekMjs.startOfWeek)(startDate, options) : (0, _startOfWeekMjs.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    var endTime = +endDateWeek.getTime();
    var currentDate = startDateWeek;
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, _toDateMjs.toDate)(currentDate));
        currentDate = (0, _addWeeksMjs.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachWeekOfInterval;

},{"./addWeeks.mjs":"ggWxE","./startOfWeek.mjs":"kLIcV","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"e2alP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachWeekendOfInterval", function() {
    return eachWeekendOfInterval;
});
var _eachDayOfIntervalMjs = require("./eachDayOfInterval.mjs");
var _isWeekendMjs = require("./isWeekend.mjs");
function eachWeekendOfInterval(interval) {
    var dateInterval = (0, _eachDayOfIntervalMjs.eachDayOfInterval)(interval);
    var weekends = [];
    var index = 0;
    while(index < dateInterval.length){
        var date = dateInterval[index++];
        if ((0, _isWeekendMjs.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}
// Fallback for modularized imports:
exports.default = eachWeekendOfInterval;

},{"./eachDayOfInterval.mjs":"judLH","./isWeekend.mjs":"4YiqU","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6qjHe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachWeekendOfMonth", function() {
    return eachWeekendOfMonth;
});
var _eachWeekendOfIntervalMjs = require("./eachWeekendOfInterval.mjs");
var _endOfMonthMjs = require("./endOfMonth.mjs");
var _startOfMonthMjs = require("./startOfMonth.mjs");
function eachWeekendOfMonth(date) {
    var start = (0, _startOfMonthMjs.startOfMonth)(date);
    var end = (0, _endOfMonthMjs.endOfMonth)(date);
    return (0, _eachWeekendOfIntervalMjs.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}
// Fallback for modularized imports:
exports.default = eachWeekendOfMonth;

},{"./eachWeekendOfInterval.mjs":"e2alP","./endOfMonth.mjs":"8SCOH","./startOfMonth.mjs":"9Xfx6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9Xfx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfMonth", function() {
    return startOfMonth;
});
var _toDateMjs = require("./toDate.mjs");
function startOfMonth(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfMonth;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"k3Qof":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ parcelHelpers.export(exports, "eachWeekendOfYear", function() {
    return eachWeekendOfYear;
});
var _eachWeekendOfIntervalMjs = require("./eachWeekendOfInterval.mjs");
var _endOfYearMjs = require("./endOfYear.mjs");
var _startOfYearMjs = require("./startOfYear.mjs");
function eachWeekendOfYear(date) {
    var start = (0, _startOfYearMjs.startOfYear)(date);
    var end = (0, _endOfYearMjs.endOfYear)(date);
    return (0, _eachWeekendOfIntervalMjs.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}
// Fallback for modularized imports:
exports.default = eachWeekendOfYear;

},{"./eachWeekendOfInterval.mjs":"e2alP","./endOfYear.mjs":"4OJ4u","./startOfYear.mjs":"ceIPy","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4OJ4u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfYear", function() {
    return endOfYear;
});
var _toDateMjs = require("./toDate.mjs");
function endOfYear(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfYear;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ceIPy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfYear", function() {
    return startOfYear;
});
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function startOfYear(date) {
    var cleanDate = (0, _toDateMjs.toDate)(date);
    var _date = (0, _constructFromMjs.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfYear;

},{"./toDate.mjs":"5c6W0","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eaGyr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachYearOfInterval", function() {
    return eachYearOfInterval;
});
var _toDateMjs = require("./toDate.mjs");
function eachYearOfInterval(interval, options) {
    var startDate = (0, _toDateMjs.toDate)(interval.start);
    var endDate = (0, _toDateMjs.toDate)(interval.end);
    var reversed = +startDate > +endDate;
    var endTime = reversed ? +startDate : +endDate;
    var currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    var _options_step;
    var step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    var dates = [];
    while(+currentDate <= endTime){
        dates.push((0, _toDateMjs.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachYearOfInterval;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"Vji9B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ parcelHelpers.export(exports, "endOfDecade", function() {
    return endOfDecade;
});
var _toDateMjs = require("./toDate.mjs");
function endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfDecade;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1Zaot":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ parcelHelpers.export(exports, "endOfHour", function() {
    return endOfHour;
});
var _toDateMjs = require("./toDate.mjs");
function endOfHour(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfHour;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"NObPe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfISOWeek", function() {
    return endOfISOWeek;
});
var _endOfWeekMjs = require("./endOfWeek.mjs");
function endOfISOWeek(date) {
    return (0, _endOfWeekMjs.endOfWeek)(date, {
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = endOfISOWeek;

},{"./endOfWeek.mjs":"8etTu","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8etTu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfWeek", function() {
    return endOfWeek;
});
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function endOfWeek(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _toDateMjs.toDate)(date);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfWeek;

},{"./toDate.mjs":"5c6W0","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eUYKj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ parcelHelpers.export(exports, "endOfISOWeekYear", function() {
    return endOfISOWeekYear;
});
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function endOfISOWeekYear(date) {
    var year = (0, _getISOWeekYearMjs.getISOWeekYear)(date);
    var fourthOfJanuaryOfNextYear = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var _date = (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfISOWeekYear;

},{"./getISOWeekYear.mjs":"iN2l0","./startOfISOWeek.mjs":"9qSeF","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kcUt1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ parcelHelpers.export(exports, "endOfMinute", function() {
    return endOfMinute;
});
var _toDateMjs = require("./toDate.mjs");
function endOfMinute(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfMinute;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1Hu4v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfQuarter", function() {
    return endOfQuarter;
});
var _toDateMjs = require("./toDate.mjs");
function endOfQuarter(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var currentMonth = _date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfQuarter;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"53va6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ parcelHelpers.export(exports, "endOfSecond", function() {
    return endOfSecond;
});
var _toDateMjs = require("./toDate.mjs");
function endOfSecond(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfSecond;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1LVml":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfToday", function() {
    return endOfToday;
});
var _endOfDayMjs = require("./endOfDay.mjs");
function endOfToday() {
    return (0, _endOfDayMjs.endOfDay)(Date.now());
}
// Fallback for modularized imports:
exports.default = endOfToday;

},{"./endOfDay.mjs":"kIbiR","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gERNb":[function(require,module,exports) {
/**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "endOfTomorrow", function() {
    return endOfTomorrow;
});
function endOfTomorrow() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}
// Fallback for modularized imports:
exports.default = endOfTomorrow;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"91Vbe":[function(require,module,exports) {
/**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "endOfYesterday", function() {
    return endOfYesterday;
});
function endOfYesterday() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}
// Fallback for modularized imports:
exports.default = endOfYesterday;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"485lL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "formatters", function() {
    return 0, _formattersMjs.formatters;
});
parcelHelpers.export(exports, "longFormatters", function() {
    return 0, _longFormattersMjs.longFormatters;
});
parcelHelpers.export(exports, "formatDate", function() {
    return format;
});
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ parcelHelpers.export(exports, "format", function() {
    return format;
});
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
var _formattersMjs = require("./_lib/format/formatters.mjs");
var _longFormattersMjs = require("./_lib/format/longFormatters.mjs");
var _protectedTokensMjs = require("./_lib/protectedTokens.mjs");
var _isValidMjs = require("./isValid.mjs");
var _toDateMjs = require("./toDate.mjs");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _defaultLocaleMjs.defaultLocale);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    var originalDate = (0, _toDateMjs.toDate)(date);
    if (!(0, _isValidMjs.isValid)(originalDate)) throw new RangeError("Invalid time value");
    var parts = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, _longFormattersMjs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: cleanEscapedString(substring)
        };
        if ((0, _formattersMjs.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map(function(part) {
        if (!part.isToken) return part.value;
        var token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, _protectedTokensMjs.isProtectedWeekYearToken)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, _protectedTokensMjs.isProtectedDayOfYearToken)(token)) (0, _protectedTokensMjs.warnOrThrowProtectedError)(token, formatStr, String(date));
        var formatter = (0, _formattersMjs.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = format;

},{"./_lib/defaultLocale.mjs":"gmHPE","./_lib/defaultOptions.mjs":"fxdBE","./_lib/format/formatters.mjs":"jOTf6","./_lib/format/longFormatters.mjs":"k8uXT","./_lib/protectedTokens.mjs":"4OAiy","./isValid.mjs":"8moLi","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gmHPE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLocale", function() {
    return 0, _enUSMjs.enUS;
});
var _enUSMjs = require("../locale/en-US.mjs");

},{"../locale/en-US.mjs":"36DlH","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"36DlH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", function() {
    return enUS;
});
var _formatDistanceMjs = require("./en-US/_lib/formatDistance.mjs");
var _formatLongMjs = require("./en-US/_lib/formatLong.mjs");
var _formatRelativeMjs = require("./en-US/_lib/formatRelative.mjs");
var _localizeMjs = require("./en-US/_lib/localize.mjs");
var _matchMjs = require("./en-US/_lib/match.mjs");
var enUS = {
    code: "en-US",
    formatDistance: (0, _formatDistanceMjs.formatDistance),
    formatLong: (0, _formatLongMjs.formatLong),
    formatRelative: (0, _formatRelativeMjs.formatRelative),
    localize: (0, _localizeMjs.localize),
    match: (0, _matchMjs.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
// Fallback for modularized imports:
exports.default = enUS;

},{"./en-US/_lib/formatDistance.mjs":"8s6v3","./en-US/_lib/formatLong.mjs":"80hlE","./en-US/_lib/formatRelative.mjs":"1vyNu","./en-US/_lib/localize.mjs":"1oWO1","./en-US/_lib/match.mjs":"9We7M","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8s6v3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDistance", function() {
    return formatDistance;
});
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"80hlE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLong", function() {
    return formatLong;
});
var _buildFormatLongFnMjs = require("../../_lib/buildFormatLongFn.mjs");
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"../../_lib/buildFormatLongFn.mjs":"80Qb3","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"80Qb3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFormatLongFn", function() {
    return buildFormatLongFn;
});
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1vyNu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelative", function() {
    return formatRelative;
});
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1oWO1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localize", function() {
    return localize;
});
var _buildLocalizeFnMjs = require("../../_lib/buildLocalizeFn.mjs");
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"../../_lib/buildLocalizeFn.mjs":"2oK0P","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2oK0P":[function(require,module,exports) {
/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLocalizeFn", function() {
    return buildLocalizeFn;
});
function buildLocalizeFn(args) {
    return function(value, options) {
        var context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var defaultWidth1 = args.defaultWidth;
            var width1 = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width1] || args.values[defaultWidth1];
        }
        var index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9We7M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", function() {
    return match;
});
var _buildMatchFnMjs = require("../../_lib/buildMatchFn.mjs");
var _buildMatchPatternFnMjs = require("../../_lib/buildMatchPatternFn.mjs");
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _buildMatchPatternFnMjs.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"../../_lib/buildMatchFn.mjs":"2mXdQ","../../_lib/buildMatchPatternFn.mjs":"edaXZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2mXdQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchFn", function() {
    return buildMatchFn;
});
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"edaXZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchPatternFn", function() {
    return buildMatchPatternFn;
});
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jOTf6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatters", function() {
    return formatters;
});
var _getDayOfYearMjs = require("../../getDayOfYear.mjs");
var _getISOWeekMjs = require("../../getISOWeek.mjs");
var _getISOWeekYearMjs = require("../../getISOWeekYear.mjs");
var _getWeekMjs = require("../../getWeek.mjs");
var _getWeekYearMjs = require("../../getWeekYear.mjs");
var _addLeadingZerosMjs = require("../addLeadingZeros.mjs");
var _lightFormattersMjs = require("./lightFormatters.mjs");
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _lightFormattersMjs.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _getWeekYearMjs.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _addLeadingZerosMjs.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _addLeadingZerosMjs.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _getISOWeekYearMjs.getISOWeekYear)(date);
        // Padding
        return (0, _addLeadingZerosMjs.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getFullYear();
        return (0, _addLeadingZerosMjs.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _lightFormattersMjs.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _getWeekMjs.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _getISOWeekMjs.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, _lightFormattersMjs.lightFormatters).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _getDayOfYearMjs.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _lightFormattersMjs.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, _lightFormattersMjs.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, _lightFormattersMjs.lightFormatters).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, _lightFormattersMjs.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _lightFormattersMjs.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize) {
        var timestamp = Math.trunc(date.getTime() / 1000);
        return (0, _addLeadingZerosMjs.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize) {
        var timestamp = date.getTime();
        return (0, _addLeadingZerosMjs.addLeadingZeros)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.trunc(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _addLeadingZerosMjs.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _addLeadingZerosMjs.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _addLeadingZerosMjs.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    var minutes = (0, _addLeadingZerosMjs.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"../../getDayOfYear.mjs":"j5Ofr","../../getISOWeek.mjs":"hhzZS","../../getISOWeekYear.mjs":"iN2l0","../../getWeek.mjs":"bYzCC","../../getWeekYear.mjs":"uCMnT","../addLeadingZeros.mjs":"hP5eZ","./lightFormatters.mjs":"fQPPj","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j5Ofr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ parcelHelpers.export(exports, "getDayOfYear", function() {
    return getDayOfYear;
});
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _startOfYearMjs = require("./startOfYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function getDayOfYear(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var diff = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_date, (0, _startOfYearMjs.startOfYear)(_date));
    var dayOfYear = diff + 1;
    return dayOfYear;
}
// Fallback for modularized imports:
exports.default = getDayOfYear;

},{"./differenceInCalendarDays.mjs":"157c4","./startOfYear.mjs":"ceIPy","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hhzZS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ parcelHelpers.export(exports, "getISOWeek", function() {
    return getISOWeek;
});
var _constantsMjs = require("./constants.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _startOfISOWeekYearMjs = require("./startOfISOWeekYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function getISOWeek(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var diff = +(0, _startOfISOWeekMjs.startOfISOWeek)(_date) - +(0, _startOfISOWeekYearMjs.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsMjs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getISOWeek;

},{"./constants.mjs":"dXQPO","./startOfISOWeek.mjs":"9qSeF","./startOfISOWeekYear.mjs":"edLgJ","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bYzCC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ parcelHelpers.export(exports, "getWeek", function() {
    return getWeek;
});
var _constantsMjs = require("./constants.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _startOfWeekYearMjs = require("./startOfWeekYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function getWeek(date, options) {
    var _date = (0, _toDateMjs.toDate)(date);
    var diff = +(0, _startOfWeekMjs.startOfWeek)(_date, options) - +(0, _startOfWeekYearMjs.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsMjs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getWeek;

},{"./constants.mjs":"dXQPO","./startOfWeek.mjs":"kLIcV","./startOfWeekYear.mjs":"2Mh6u","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2Mh6u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfWeekYear", function() {
    return startOfWeekYear;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _getWeekYearMjs = require("./getWeekYear.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function startOfWeekYear(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var year = (0, _getWeekYearMjs.getWeekYear)(date, options);
    var firstWeek = (0, _constructFromMjs.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var _date = (0, _startOfWeekMjs.startOfWeek)(firstWeek, options);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeekYear;

},{"./constructFrom.mjs":"aoN9f","./getWeekYear.mjs":"uCMnT","./startOfWeek.mjs":"kLIcV","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"uCMnT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ parcelHelpers.export(exports, "getWeekYear", function() {
    return getWeekYear;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function getWeekYear(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var firstWeekOfNextYear = (0, _constructFromMjs.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _startOfWeekMjs.startOfWeek)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = (0, _constructFromMjs.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _startOfWeekMjs.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getWeekYear;

},{"./constructFrom.mjs":"aoN9f","./startOfWeek.mjs":"kLIcV","./toDate.mjs":"5c6W0","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hP5eZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLeadingZeros", function() {
    return addLeadingZeros;
});
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fQPPj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightFormatters", function() {
    return lightFormatters;
});
var _addLeadingZerosMjs = require("../addLeadingZeros.mjs");
var lightFormatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _addLeadingZerosMjs.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _addLeadingZerosMjs.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getMilliseconds();
        var fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _addLeadingZerosMjs.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"../addLeadingZeros.mjs":"hP5eZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"k8uXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "longFormatters", function() {
    return longFormatters;
});
var dateLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4OAiy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", function() {
    return isProtectedDayOfYearToken;
});
parcelHelpers.export(exports, "isProtectedWeekYearToken", function() {
    return isProtectedWeekYearToken;
});
parcelHelpers.export(exports, "warnOrThrowProtectedError", function() {
    return warnOrThrowProtectedError;
});
var dayOfYearTokenRE = /^D+$/;
var weekYearTokenRE = /^Y+$/;
var throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    var _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    var subject = token[0] === "Y" ? "years" : "days of the month";
    return "Use `".concat(token.toLowerCase(), "` instead of `").concat(token, "` (in `").concat(format, "`) for formatting ").concat(subject, " to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"i7xvD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ parcelHelpers.export(exports, "formatDistance", function() {
    return formatDistance;
});
var _compareAscMjs = require("./compareAsc.mjs");
var _constantsMjs = require("./constants.mjs");
var _differenceInMonthsMjs = require("./differenceInMonths.mjs");
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function formatDistance(date, baseDate, options) {
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_locale, _ref;
    var locale = (_ref = (_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _defaultLocaleMjs.defaultLocale);
    var minutesInAlmostTwoDays = 2520;
    var comparison = (0, _compareAscMjs.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = Object.assign({}, options, {
        addSuffix: options === null || options === void 0 ? void 0 : options.addSuffix,
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, _toDateMjs.toDate)(baseDate);
        dateRight = (0, _toDateMjs.toDate)(date);
    } else {
        dateLeft = (0, _toDateMjs.toDate)(date);
        dateRight = (0, _toDateMjs.toDate)(baseDate);
    }
    var seconds = (0, _differenceInSecondsMjs.differenceInSeconds)(dateRight, dateLeft);
    var offsetInSeconds = ((0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateRight) - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options === null || options === void 0 ? void 0 : options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, _constantsMjs.minutesInDay)) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, _constantsMjs.minutesInMonth)) {
        var days = Math.round(minutes / (0, _constantsMjs.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, _constantsMjs.minutesInMonth) * 2) {
        months = Math.round(minutes / (0, _constantsMjs.minutesInMonth));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, _differenceInMonthsMjs.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / (0, _constantsMjs.minutesInMonth));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
// Fallback for modularized imports:
exports.default = formatDistance;

},{"./compareAsc.mjs":"99hec","./constants.mjs":"dXQPO","./differenceInMonths.mjs":"hgqlH","./differenceInSeconds.mjs":"7Tn5g","./toDate.mjs":"5c6W0","./_lib/defaultLocale.mjs":"gmHPE","./_lib/defaultOptions.mjs":"fxdBE","./_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9iJxw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceStrict", function() {
    return formatDistanceStrict;
});
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
var _compareAscMjs = require("./compareAsc.mjs");
var _constantsMjs = require("./constants.mjs");
var _toDateMjs = require("./toDate.mjs");
function formatDistanceStrict(date, baseDate, options) {
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_locale, _ref;
    var locale = (_ref = (_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _defaultLocaleMjs.defaultLocale);
    var comparison = (0, _compareAscMjs.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = Object.assign({}, options, {
        addSuffix: options === null || options === void 0 ? void 0 : options.addSuffix,
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, _toDateMjs.toDate)(baseDate);
        dateRight = (0, _toDateMjs.toDate)(date);
    } else {
        dateLeft = (0, _toDateMjs.toDate)(date);
        dateRight = (0, _toDateMjs.toDate)(baseDate);
    }
    var _options_roundingMethod;
    var roundingMethod = (0, _getRoundingMethodMjs.getRoundingMethod)((_options_roundingMethod = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options_roundingMethod !== void 0 ? _options_roundingMethod : "round");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / (0, _constantsMjs.millisecondsInMinute);
    var timezoneOffset = (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateRight) - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / (0, _constantsMjs.millisecondsInMinute);
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < (0, _constantsMjs.minutesInDay)) unit = "hour";
        else if (dstNormalizedMinutes < (0, _constantsMjs.minutesInMonth)) unit = "day";
        else if (dstNormalizedMinutes < (0, _constantsMjs.minutesInYear)) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        var seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        var roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        var hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        var days = roundingMethod(dstNormalizedMinutes / (0, _constantsMjs.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        var months = roundingMethod(dstNormalizedMinutes / (0, _constantsMjs.minutesInMonth));
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        var years = roundingMethod(dstNormalizedMinutes / (0, _constantsMjs.minutesInYear));
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}
// Fallback for modularized imports:
exports.default = formatDistanceStrict;

},{"./_lib/defaultLocale.mjs":"gmHPE","./_lib/defaultOptions.mjs":"fxdBE","./_lib/getRoundingMethod.mjs":"kV6yf","./_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","./compareAsc.mjs":"99hec","./constants.mjs":"dXQPO","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lImTi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceToNow", function() {
    return formatDistanceToNow;
});
var _constructNowMjs = require("./constructNow.mjs");
var _formatDistanceMjs = require("./formatDistance.mjs");
function formatDistanceToNow(date, options) {
    return (0, _formatDistanceMjs.formatDistance)(date, (0, _constructNowMjs.constructNow)(date), options);
}
// Fallback for modularized imports:
exports.default = formatDistanceToNow;

},{"./constructNow.mjs":"8zr8Z","./formatDistance.mjs":"i7xvD","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"0yBPn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceToNowStrict", function() {
    return formatDistanceToNowStrict;
});
var _formatDistanceStrictMjs = require("./formatDistanceStrict.mjs");
var _constructNowMjs = require("./constructNow.mjs");
function formatDistanceToNowStrict(date, options) {
    return (0, _formatDistanceStrictMjs.formatDistanceStrict)(date, (0, _constructNowMjs.constructNow)(date), options);
}
// Fallback for modularized imports:
exports.default = formatDistanceToNowStrict;

},{"./formatDistanceStrict.mjs":"9iJxw","./constructNow.mjs":"8zr8Z","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iOeT5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ parcelHelpers.export(exports, "formatDuration", function() {
    return formatDuration;
});
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
/**
 * The {@link formatDuration} function options.
 */ var defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
function formatDuration(duration, options) {
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_locale, _ref;
    var locale = (_ref = (_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _defaultLocaleMjs.defaultLocale);
    var _options_format;
    var format = (_options_format = options === null || options === void 0 ? void 0 : options.format) !== null && _options_format !== void 0 ? _options_format : defaultFormat;
    var _options_zero;
    var zero = (_options_zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options_zero !== void 0 ? _options_zero : false;
    var _options_delimiter;
    var delimiter = (_options_delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options_delimiter !== void 0 ? _options_delimiter : " ";
    if (!locale.formatDistance) return "";
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}
// Fallback for modularized imports:
exports.default = formatDuration;

},{"./_lib/defaultLocale.mjs":"gmHPE","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7srQr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ parcelHelpers.export(exports, "formatISO", function() {
    return formatISO;
});
var _toDateMjs = require("./toDate.mjs");
var _addLeadingZerosMjs = require("./_lib/addLeadingZeros.mjs");
function formatISO(date, options) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    var _options_format;
    var format = (_options_format = options === null || options === void 0 ? void 0 : options.format) !== null && _options_format !== void 0 ? _options_format : "extended";
    var _options_representation;
    var representation = (_options_representation = options === null || options === void 0 ? void 0 : options.representation) !== null && _options_representation !== void 0 ? _options_representation : "complete";
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getDate(), 2);
        var month = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getMonth() + 1, 2);
        var year = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, _addLeadingZerosMjs.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            var minuteOffset = (0, _addLeadingZerosMjs.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getHours(), 2);
        var minute = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getMinutes(), 2);
        var second = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}
// Fallback for modularized imports:
exports.default = formatISO;

},{"./toDate.mjs":"5c6W0","./_lib/addLeadingZeros.mjs":"hP5eZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1dYHH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ parcelHelpers.export(exports, "formatISO9075", function() {
    return formatISO9075;
});
var _isValidMjs = require("./isValid.mjs");
var _toDateMjs = require("./toDate.mjs");
var _addLeadingZerosMjs = require("./_lib/addLeadingZeros.mjs");
function formatISO9075(date, options) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (!(0, _isValidMjs.isValid)(_date)) throw new RangeError("Invalid time value");
    var _options_format;
    var format = (_options_format = options === null || options === void 0 ? void 0 : options.format) !== null && _options_format !== void 0 ? _options_format : "extended";
    var _options_representation;
    var representation = (_options_representation = options === null || options === void 0 ? void 0 : options.representation) !== null && _options_representation !== void 0 ? _options_representation : "complete";
    var result = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getDate(), 2);
        var month = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getMonth() + 1, 2);
        var year = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        var hour = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getHours(), 2);
        var minute = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getMinutes(), 2);
        var second = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        var separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
    }
    return result;
}
// Fallback for modularized imports:
exports.default = formatISO9075;

},{"./isValid.mjs":"8moLi","./toDate.mjs":"5c6W0","./_lib/addLeadingZeros.mjs":"hP5eZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"359ht":[function(require,module,exports) {
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatISODuration", function() {
    return formatISODuration;
});
function formatISODuration(duration) {
    var _duration_years = duration.years, years = _duration_years === void 0 ? 0 : _duration_years, _duration_months = duration.months, months = _duration_months === void 0 ? 0 : _duration_months, _duration_days = duration.days, days = _duration_days === void 0 ? 0 : _duration_days, _duration_hours = duration.hours, hours = _duration_hours === void 0 ? 0 : _duration_hours, _duration_minutes = duration.minutes, minutes = _duration_minutes === void 0 ? 0 : _duration_minutes, _duration_seconds = duration.seconds, seconds = _duration_seconds === void 0 ? 0 : _duration_seconds;
    return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
}
// Fallback for modularized imports:
exports.default = formatISODuration;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4EA2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ parcelHelpers.export(exports, "formatRFC3339", function() {
    return formatRFC3339;
});
var _isValidMjs = require("./isValid.mjs");
var _toDateMjs = require("./toDate.mjs");
var _addLeadingZerosMjs = require("./_lib/addLeadingZeros.mjs");
function formatRFC3339(date, options) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (!(0, _isValidMjs.isValid)(_date)) throw new RangeError("Invalid time value");
    var _options_fractionDigits;
    var fractionDigits = (_options_fractionDigits = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options_fractionDigits !== void 0 ? _options_fractionDigits : 0;
    var day = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getDate(), 2);
    var month = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getMonth() + 1, 2);
    var year = _date.getFullYear();
    var hour = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getHours(), 2);
    var minute = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getMinutes(), 2);
    var second = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getSeconds(), 2);
    var fractionalSecond = "";
    if (fractionDigits > 0) {
        var milliseconds = _date.getMilliseconds();
        var fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, _addLeadingZerosMjs.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    var offset = "";
    var tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        var absoluteOffset = Math.abs(tzOffset);
        var hourOffset = (0, _addLeadingZerosMjs.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        var minuteOffset = (0, _addLeadingZerosMjs.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        var sign = tzOffset < 0 ? "+" : "-";
        offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else offset = "Z";
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}
// Fallback for modularized imports:
exports.default = formatRFC3339;

},{"./isValid.mjs":"8moLi","./toDate.mjs":"5c6W0","./_lib/addLeadingZeros.mjs":"hP5eZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kQxT1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ parcelHelpers.export(exports, "formatRFC7231", function() {
    return formatRFC7231;
});
var _isValidMjs = require("./isValid.mjs");
var _toDateMjs = require("./toDate.mjs");
var _addLeadingZerosMjs = require("./_lib/addLeadingZeros.mjs");
var days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function formatRFC7231(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (!(0, _isValidMjs.isValid)(_date)) throw new RangeError("Invalid time value");
    var dayName = days[_date.getUTCDay()];
    var dayOfMonth = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getUTCDate(), 2);
    var monthName = months[_date.getUTCMonth()];
    var year = _date.getUTCFullYear();
    var hour = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getUTCHours(), 2);
    var minute = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getUTCMinutes(), 2);
    var second = (0, _addLeadingZerosMjs.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
}
// Fallback for modularized imports:
exports.default = formatRFC7231;

},{"./isValid.mjs":"8moLi","./toDate.mjs":"5c6W0","./_lib/addLeadingZeros.mjs":"hP5eZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7oFgl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ parcelHelpers.export(exports, "formatRelative", function() {
    return formatRelative;
});
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _formatMjs = require("./format.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function formatRelative(date, baseDate, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var _date = (0, _toDateMjs.toDate)(date);
    var _baseDate = (0, _toDateMjs.toDate)(baseDate);
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_locale1, _ref;
    var locale = (_ref = (_options_locale1 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale1 !== void 0 ? _options_locale1 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _defaultLocaleMjs.defaultLocale);
    var _options_weekStartsOn, _ref1, _ref2, _ref3;
    var weekStartsOn = (_ref3 = (_ref2 = (_ref1 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : 0;
    var diff = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    var token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    var formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, _formatMjs.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}
// Fallback for modularized imports:
exports.default = formatRelative;

},{"./differenceInCalendarDays.mjs":"157c4","./format.mjs":"485lL","./toDate.mjs":"5c6W0","./_lib/defaultLocale.mjs":"gmHPE","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7fHhy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ parcelHelpers.export(exports, "fromUnixTime", function() {
    return fromUnixTime;
});
var _toDateMjs = require("./toDate.mjs");
function fromUnixTime(unixTime) {
    return (0, _toDateMjs.toDate)(unixTime * 1000);
}
// Fallback for modularized imports:
exports.default = fromUnixTime;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3iDke":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ parcelHelpers.export(exports, "getDate", function() {
    return getDate;
});
var _toDateMjs = require("./toDate.mjs");
function getDate(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var dayOfMonth = _date.getDate();
    return dayOfMonth;
}
// Fallback for modularized imports:
exports.default = getDate;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"e5GCB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ parcelHelpers.export(exports, "getDay", function() {
    return getDay;
});
var _toDateMjs = require("./toDate.mjs");
function getDay(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var day = _date.getDay();
    return day;
}
// Fallback for modularized imports:
exports.default = getDay;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bXxcX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ parcelHelpers.export(exports, "getDaysInMonth", function() {
    return getDaysInMonth;
});
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function getDaysInMonth(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var monthIndex = _date.getMonth();
    var lastDayOfMonth = (0, _constructFromMjs.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
// Fallback for modularized imports:
exports.default = getDaysInMonth;

},{"./toDate.mjs":"5c6W0","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fPW4c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ parcelHelpers.export(exports, "getDaysInYear", function() {
    return getDaysInYear;
});
var _isLeapYearMjs = require("./isLeapYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function getDaysInYear(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, _isLeapYearMjs.isLeapYear)(_date) ? 366 : 365;
}
// Fallback for modularized imports:
exports.default = getDaysInYear;

},{"./isLeapYear.mjs":"lMNj8","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lMNj8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ parcelHelpers.export(exports, "isLeapYear", function() {
    return isLeapYear;
});
var _toDateMjs = require("./toDate.mjs");
function isLeapYear(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
// Fallback for modularized imports:
exports.default = isLeapYear;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2RfeO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ parcelHelpers.export(exports, "getDecade", function() {
    return getDecade;
});
var _toDateMjs = require("./toDate.mjs");
function getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var decade = Math.floor(year / 10) * 10;
    return decade;
}
// Fallback for modularized imports:
exports.default = getDecade;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cmusC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ parcelHelpers.export(exports, "getDefaultOptions", function() {
    return getDefaultOptions;
});
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function getDefaultOptions() {
    return Object.assign({}, (0, _defaultOptionsMjs.getDefaultOptions)());
}
// Fallback for modularized imports:
exports.default = getDefaultOptions;

},{"./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fxRXK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ parcelHelpers.export(exports, "getHours", function() {
    return getHours;
});
var _toDateMjs = require("./toDate.mjs");
function getHours(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var hours = _date.getHours();
    return hours;
}
// Fallback for modularized imports:
exports.default = getHours;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kPl3b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ parcelHelpers.export(exports, "getISODay", function() {
    return getISODay;
});
var _toDateMjs = require("./toDate.mjs");
function getISODay(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}
// Fallback for modularized imports:
exports.default = getISODay;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1mplI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ parcelHelpers.export(exports, "getISOWeeksInYear", function() {
    return getISOWeeksInYear;
});
var _addWeeksMjs = require("./addWeeks.mjs");
var _constantsMjs = require("./constants.mjs");
var _startOfISOWeekYearMjs = require("./startOfISOWeekYear.mjs");
function getISOWeeksInYear(date) {
    var thisYear = (0, _startOfISOWeekYearMjs.startOfISOWeekYear)(date);
    var nextYear = (0, _startOfISOWeekYearMjs.startOfISOWeekYear)((0, _addWeeksMjs.addWeeks)(thisYear, 60));
    var diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsMjs.millisecondsInWeek));
}
// Fallback for modularized imports:
exports.default = getISOWeeksInYear;

},{"./addWeeks.mjs":"ggWxE","./constants.mjs":"dXQPO","./startOfISOWeekYear.mjs":"edLgJ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4bnhg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ parcelHelpers.export(exports, "getMilliseconds", function() {
    return getMilliseconds;
});
var _toDateMjs = require("./toDate.mjs");
function getMilliseconds(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var milliseconds = _date.getMilliseconds();
    return milliseconds;
}
// Fallback for modularized imports:
exports.default = getMilliseconds;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1sjZu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ parcelHelpers.export(exports, "getMinutes", function() {
    return getMinutes;
});
var _toDateMjs = require("./toDate.mjs");
function getMinutes(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var minutes = _date.getMinutes();
    return minutes;
}
// Fallback for modularized imports:
exports.default = getMinutes;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6r8Xo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ parcelHelpers.export(exports, "getMonth", function() {
    return getMonth;
});
var _toDateMjs = require("./toDate.mjs");
function getMonth(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var month = _date.getMonth();
    return month;
}
// Fallback for modularized imports:
exports.default = getMonth;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4X1Z3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ parcelHelpers.export(exports, "getOverlappingDaysInIntervals", function() {
    return getOverlappingDaysInIntervals;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
var _constantsMjs = require("./constants.mjs");
var _toDateMjs = require("./toDate.mjs");
function getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    var _sort = (0, _slicedToArray._)([
        +(0, _toDateMjs.toDate)(intervalLeft.start),
        +(0, _toDateMjs.toDate)(intervalLeft.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), leftStart = _sort[0], leftEnd = _sort[1];
    var _sort1 = (0, _slicedToArray._)([
        +(0, _toDateMjs.toDate)(intervalRight.start),
        +(0, _toDateMjs.toDate)(intervalRight.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), rightStart = _sort1[0], rightEnd = _sort1[1];
    // Prevent NaN result if intervals don't overlap at all.
    var isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    var overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    var left = overlapLeft - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(overlapLeft);
    var overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    var right = overlapRight - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / (0, _constantsMjs.millisecondsInDay));
}
// Fallback for modularized imports:
exports.default = getOverlappingDaysInIntervals;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","./_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","./constants.mjs":"dXQPO","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"d5oLr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ parcelHelpers.export(exports, "getSeconds", function() {
    return getSeconds;
});
var _toDateMjs = require("./toDate.mjs");
function getSeconds(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var seconds = _date.getSeconds();
    return seconds;
}
// Fallback for modularized imports:
exports.default = getSeconds;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lpflw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ parcelHelpers.export(exports, "getTime", function() {
    return getTime;
});
var _toDateMjs = require("./toDate.mjs");
function getTime(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var timestamp = _date.getTime();
    return timestamp;
}
// Fallback for modularized imports:
exports.default = getTime;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kjgRM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ parcelHelpers.export(exports, "getUnixTime", function() {
    return getUnixTime;
});
var _toDateMjs = require("./toDate.mjs");
function getUnixTime(date) {
    return Math.trunc(+(0, _toDateMjs.toDate)(date) / 1000);
}
// Fallback for modularized imports:
exports.default = getUnixTime;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"48IZO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ parcelHelpers.export(exports, "getWeekOfMonth", function() {
    return getWeekOfMonth;
});
var _getDateMjs = require("./getDate.mjs");
var _getDayMjs = require("./getDay.mjs");
var _startOfMonthMjs = require("./startOfMonth.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function getWeekOfMonth(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var currentDayOfMonth = (0, _getDateMjs.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    var startWeekDay = (0, _getDayMjs.getDay)((0, _startOfMonthMjs.startOfMonth)(date));
    var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}
// Fallback for modularized imports:
exports.default = getWeekOfMonth;

},{"./getDate.mjs":"3iDke","./getDay.mjs":"e5GCB","./startOfMonth.mjs":"9Xfx6","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j6dTC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return getWeeksInMonth;
});
var _differenceInCalendarWeeksMjs = require("./differenceInCalendarWeeks.mjs");
var _lastDayOfMonthMjs = require("./lastDayOfMonth.mjs");
var _startOfMonthMjs = require("./startOfMonth.mjs");
function getWeeksInMonth(date, options) {
    return (0, _differenceInCalendarWeeksMjs.differenceInCalendarWeeks)((0, _lastDayOfMonthMjs.lastDayOfMonth)(date), (0, _startOfMonthMjs.startOfMonth)(date), options) + 1;
}
// Fallback for modularized imports:
exports.default = getWeeksInMonth;

},{"./differenceInCalendarWeeks.mjs":"ceMOy","./lastDayOfMonth.mjs":"5xjKA","./startOfMonth.mjs":"9Xfx6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5xjKA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ parcelHelpers.export(exports, "lastDayOfMonth", function() {
    return lastDayOfMonth;
});
var _toDateMjs = require("./toDate.mjs");
function lastDayOfMonth(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = lastDayOfMonth;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3undW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ parcelHelpers.export(exports, "getYear", function() {
    return getYear;
});
var _toDateMjs = require("./toDate.mjs");
function getYear(date) {
    return (0, _toDateMjs.toDate)(date).getFullYear();
}
// Fallback for modularized imports:
exports.default = getYear;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9OEBd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ parcelHelpers.export(exports, "hoursToMilliseconds", function() {
    return hoursToMilliseconds;
});
var _constantsMjs = require("./constants.mjs");
function hoursToMilliseconds(hours) {
    return Math.trunc(hours * (0, _constantsMjs.millisecondsInHour));
}
// Fallback for modularized imports:
exports.default = hoursToMilliseconds;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cPXIu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ parcelHelpers.export(exports, "hoursToMinutes", function() {
    return hoursToMinutes;
});
var _constantsMjs = require("./constants.mjs");
function hoursToMinutes(hours) {
    return Math.trunc(hours * (0, _constantsMjs.minutesInHour));
}
// Fallback for modularized imports:
exports.default = hoursToMinutes;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"47cro":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ parcelHelpers.export(exports, "hoursToSeconds", function() {
    return hoursToSeconds;
});
var _constantsMjs = require("./constants.mjs");
function hoursToSeconds(hours) {
    return Math.trunc(hours * (0, _constantsMjs.secondsInHour));
}
// Fallback for modularized imports:
exports.default = hoursToSeconds;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8Rnpx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ parcelHelpers.export(exports, "interval", function() {
    return interval;
});
var _toDateMjs = require("./toDate.mjs");
function interval(start, end, options) {
    var _start = (0, _toDateMjs.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    var _end = (0, _toDateMjs.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if ((options === null || options === void 0 ? void 0 : options.assertPositive) && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}
// Fallback for modularized imports:
exports.default = interval;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"l77Rp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ parcelHelpers.export(exports, "intervalToDuration", function() {
    return intervalToDuration;
});
var _addMjs = require("./add.mjs");
var _differenceInDaysMjs = require("./differenceInDays.mjs");
var _differenceInHoursMjs = require("./differenceInHours.mjs");
var _differenceInMinutesMjs = require("./differenceInMinutes.mjs");
var _differenceInMonthsMjs = require("./differenceInMonths.mjs");
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
var _differenceInYearsMjs = require("./differenceInYears.mjs");
var _toDateMjs = require("./toDate.mjs");
function intervalToDuration(interval) {
    var start = (0, _toDateMjs.toDate)(interval.start);
    var end = (0, _toDateMjs.toDate)(interval.end);
    var duration = {};
    var years = (0, _differenceInYearsMjs.differenceInYears)(end, start);
    if (years) duration.years = years;
    var remainingMonths = (0, _addMjs.add)(start, {
        years: duration.years
    });
    var months = (0, _differenceInMonthsMjs.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    var remainingDays = (0, _addMjs.add)(remainingMonths, {
        months: duration.months
    });
    var days = (0, _differenceInDaysMjs.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    var remainingHours = (0, _addMjs.add)(remainingDays, {
        days: duration.days
    });
    var hours = (0, _differenceInHoursMjs.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    var remainingMinutes = (0, _addMjs.add)(remainingHours, {
        hours: duration.hours
    });
    var minutes = (0, _differenceInMinutesMjs.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    var remainingSeconds = (0, _addMjs.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    var seconds = (0, _differenceInSecondsMjs.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}
// Fallback for modularized imports:
exports.default = intervalToDuration;

},{"./add.mjs":"9T8my","./differenceInDays.mjs":"hoq2u","./differenceInHours.mjs":"8WDQc","./differenceInMinutes.mjs":"l5BaQ","./differenceInMonths.mjs":"hgqlH","./differenceInSeconds.mjs":"7Tn5g","./differenceInYears.mjs":"3XWcb","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bI71Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ parcelHelpers.export(exports, "intlFormat", function() {
    return intlFormat;
});
var _toDateMjs = require("./toDate.mjs");
function intlFormat(date, formatOrLocale, localeOptions) {
    var formatOptions;
    if (isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions === null || localeOptions === void 0 ? void 0 : localeOptions.locale, formatOptions).format((0, _toDateMjs.toDate)(date));
}
function isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}
// Fallback for modularized imports:
exports.default = intlFormat;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6h6Jh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ parcelHelpers.export(exports, "intlFormatDistance", function() {
    return intlFormatDistance;
});
var _constantsMjs = require("./constants.mjs");
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _differenceInCalendarMonthsMjs = require("./differenceInCalendarMonths.mjs");
var _differenceInCalendarQuartersMjs = require("./differenceInCalendarQuarters.mjs");
var _differenceInCalendarWeeksMjs = require("./differenceInCalendarWeeks.mjs");
var _differenceInCalendarYearsMjs = require("./differenceInCalendarYears.mjs");
var _differenceInHoursMjs = require("./differenceInHours.mjs");
var _differenceInMinutesMjs = require("./differenceInMinutes.mjs");
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
var _toDateMjs = require("./toDate.mjs");
function intlFormatDistance(date, baseDate, options) {
    var value = 0;
    var unit;
    var dateLeft = (0, _toDateMjs.toDate)(date);
    var dateRight = (0, _toDateMjs.toDate)(baseDate);
    if (!(options === null || options === void 0 ? void 0 : options.unit)) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        var diffInSeconds = (0, _differenceInSecondsMjs.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInMinute)) {
            value = (0, _differenceInSecondsMjs.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInHour)) {
            value = (0, _differenceInMinutesMjs.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInDay) && Math.abs((0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, _differenceInHoursMjs.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInWeek) && (value = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInMonth)) {
            value = (0, _differenceInCalendarWeeksMjs.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInQuarter)) {
            value = (0, _differenceInCalendarMonthsMjs.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInYear)) {
            if ((0, _differenceInCalendarQuartersMjs.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, _differenceInCalendarQuartersMjs.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options === null || options === void 0 ? void 0 : options.unit;
        if (unit === "second") value = (0, _differenceInSecondsMjs.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, _differenceInMinutesMjs.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, _differenceInHoursMjs.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, _differenceInCalendarWeeksMjs.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, _differenceInCalendarMonthsMjs.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, _differenceInCalendarQuartersMjs.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(dateLeft, dateRight);
    }
    var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
        localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
        numeric: (options === null || options === void 0 ? void 0 : options.numeric) || "auto",
        style: options === null || options === void 0 ? void 0 : options.style
    });
    return rtf.format(value, unit);
}
// Fallback for modularized imports:
exports.default = intlFormatDistance;

},{"./constants.mjs":"dXQPO","./differenceInCalendarDays.mjs":"157c4","./differenceInCalendarMonths.mjs":"5o9ya","./differenceInCalendarQuarters.mjs":"UvlTu","./differenceInCalendarWeeks.mjs":"ceMOy","./differenceInCalendarYears.mjs":"ePGcW","./differenceInHours.mjs":"8WDQc","./differenceInMinutes.mjs":"l5BaQ","./differenceInSeconds.mjs":"7Tn5g","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"89XEz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ parcelHelpers.export(exports, "isAfter", function() {
    return isAfter;
});
var _toDateMjs = require("./toDate.mjs");
function isAfter(date, dateToCompare) {
    var _date = (0, _toDateMjs.toDate)(date);
    var _dateToCompare = (0, _toDateMjs.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}
// Fallback for modularized imports:
exports.default = isAfter;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3R0Tu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ parcelHelpers.export(exports, "isBefore", function() {
    return isBefore;
});
var _toDateMjs = require("./toDate.mjs");
function isBefore(date, dateToCompare) {
    var _date = (0, _toDateMjs.toDate)(date);
    var _dateToCompare = (0, _toDateMjs.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}
// Fallback for modularized imports:
exports.default = isBefore;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gHkqW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ parcelHelpers.export(exports, "isEqual", function() {
    return isEqual;
});
var _toDateMjs = require("./toDate.mjs");
function isEqual(leftDate, rightDate) {
    var _dateLeft = (0, _toDateMjs.toDate)(leftDate);
    var _dateRight = (0, _toDateMjs.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}
// Fallback for modularized imports:
exports.default = isEqual;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"36e4b":[function(require,module,exports) {
/**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isExists", function() {
    return isExists;
});
function isExists(year, month, day) {
    var date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}
// Fallback for modularized imports:
exports.default = isExists;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"k00Aa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ parcelHelpers.export(exports, "isFirstDayOfMonth", function() {
    return isFirstDayOfMonth;
});
var _toDateMjs = require("./toDate.mjs");
function isFirstDayOfMonth(date) {
    return (0, _toDateMjs.toDate)(date).getDate() === 1;
}
// Fallback for modularized imports:
exports.default = isFirstDayOfMonth;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eBLgR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ parcelHelpers.export(exports, "isFriday", function() {
    return isFriday;
});
var _toDateMjs = require("./toDate.mjs");
function isFriday(date) {
    return (0, _toDateMjs.toDate)(date).getDay() === 5;
}
// Fallback for modularized imports:
exports.default = isFriday;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9mTQg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ parcelHelpers.export(exports, "isFuture", function() {
    return isFuture;
});
var _toDateMjs = require("./toDate.mjs");
function isFuture(date) {
    return +(0, _toDateMjs.toDate)(date) > Date.now();
}
// Fallback for modularized imports:
exports.default = isFuture;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"wP59U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ parcelHelpers.export(exports, "isMatch", function() {
    return isMatch;
});
var _isValidMjs = require("./isValid.mjs");
var _parseMjs = require("./parse.mjs");
function isMatch(dateStr, formatStr, options) {
    return (0, _isValidMjs.isValid)((0, _parseMjs.parse)(dateStr, formatStr, new Date(), options));
}
// Fallback for modularized imports:
exports.default = isMatch;

},{"./isValid.mjs":"8moLi","./parse.mjs":"2OEEQ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2OEEQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "longFormatters", function() {
    return 0, _longFormattersMjs.longFormatters;
});
parcelHelpers.export(exports, "parsers", function() {
    return 0, _parsersMjs.parsers;
});
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ parcelHelpers.export(exports, "parse", function() {
    return parse;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _constructFromMjs = require("./constructFrom.mjs");
var _getDefaultOptionsMjs = require("./getDefaultOptions.mjs");
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _toDateMjs = require("./toDate.mjs");
var _longFormattersMjs = require("./_lib/format/longFormatters.mjs");
var _protectedTokensMjs = require("./_lib/protectedTokens.mjs");
var _parsersMjs = require("./parse/_lib/parsers.mjs");
var _setterMjs = require("./parse/_lib/Setter.mjs");
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dateStr, formatStr, referenceDate, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var defaultOptions = (0, _getDefaultOptionsMjs.getDefaultOptions)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _defaultLocaleMjs.defaultLocale);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, _toDateMjs.toDate)(referenceDate);
        else return (0, _constructFromMjs.constructFrom)(referenceDate, NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterMjs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _longFormattersMjs.longFormatters)) {
            var longFormatter = (0, _longFormattersMjs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var token = _step.value;
            if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, _protectedTokensMjs.isProtectedWeekYearToken)(token)) (0, _protectedTokensMjs.warnOrThrowProtectedError)(token, formatStr, dateStr);
            if (!(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, _protectedTokensMjs.isProtectedDayOfYearToken)(token)) (0, _protectedTokensMjs.warnOrThrowProtectedError)(token, formatStr, dateStr);
            var firstCharacter = token[0];
            var parser = (0, _parsersMjs.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: (0, _constructFromMjs.constructFrom)(referenceDate, NaN)
                };
                setters.push(parseResult.setter);
                dateStr = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
                else return {
                    v: (0, _constructFromMjs.constructFrom)(referenceDate, NaN)
                };
            }
        };
        for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, _typeOf._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) return (0, _constructFromMjs.constructFrom)(referenceDate, NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _toDateMjs.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, _constructFromMjs.constructFrom)(referenceDate, NaN);
    var flags = {};
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = uniquePrioritySetters[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var setter = _step1.value;
            if (!setter.validate(date, subFnOptions)) return (0, _constructFromMjs.constructFrom)(referenceDate, NaN);
            var result = setter.set(date, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                date = result[0];
                Object.assign(flags, result[1]);
            // Result is date
            } else date = result;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return (0, _constructFromMjs.constructFrom)(referenceDate, date);
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = parse;

},{"@swc/helpers/_/_type_of":"60jEQ","./constructFrom.mjs":"aoN9f","./getDefaultOptions.mjs":"cmusC","./_lib/defaultLocale.mjs":"gmHPE","./toDate.mjs":"5c6W0","./_lib/format/longFormatters.mjs":"k8uXT","./_lib/protectedTokens.mjs":"4OAiy","./parse/_lib/parsers.mjs":"hQTA0","./parse/_lib/Setter.mjs":"3Dz1k","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hQTA0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", function() {
    return parsers;
});
var _eraParserMjs = require("./parsers/EraParser.mjs");
var _yearParserMjs = require("./parsers/YearParser.mjs");
var _localWeekYearParserMjs = require("./parsers/LocalWeekYearParser.mjs");
var _isoweekYearParserMjs = require("./parsers/ISOWeekYearParser.mjs");
var _extendedYearParserMjs = require("./parsers/ExtendedYearParser.mjs");
var _quarterParserMjs = require("./parsers/QuarterParser.mjs");
var _standAloneQuarterParserMjs = require("./parsers/StandAloneQuarterParser.mjs");
var _monthParserMjs = require("./parsers/MonthParser.mjs");
var _standAloneMonthParserMjs = require("./parsers/StandAloneMonthParser.mjs");
var _localWeekParserMjs = require("./parsers/LocalWeekParser.mjs");
var _isoweekParserMjs = require("./parsers/ISOWeekParser.mjs");
var _dateParserMjs = require("./parsers/DateParser.mjs");
var _dayOfYearParserMjs = require("./parsers/DayOfYearParser.mjs");
var _dayParserMjs = require("./parsers/DayParser.mjs");
var _localDayParserMjs = require("./parsers/LocalDayParser.mjs");
var _standAloneLocalDayParserMjs = require("./parsers/StandAloneLocalDayParser.mjs");
var _isodayParserMjs = require("./parsers/ISODayParser.mjs");
var _ampmparserMjs = require("./parsers/AMPMParser.mjs");
var _ampmmidnightParserMjs = require("./parsers/AMPMMidnightParser.mjs");
var _dayPeriodParserMjs = require("./parsers/DayPeriodParser.mjs");
var _hour1To12ParserMjs = require("./parsers/Hour1to12Parser.mjs");
var _hour0To23ParserMjs = require("./parsers/Hour0to23Parser.mjs");
var _hour0To11ParserMjs = require("./parsers/Hour0To11Parser.mjs");
var _hour1To24ParserMjs = require("./parsers/Hour1To24Parser.mjs");
var _minuteParserMjs = require("./parsers/MinuteParser.mjs");
var _secondParserMjs = require("./parsers/SecondParser.mjs");
var _fractionOfSecondParserMjs = require("./parsers/FractionOfSecondParser.mjs");
var _isotimezoneWithZParserMjs = require("./parsers/ISOTimezoneWithZParser.mjs");
var _isotimezoneParserMjs = require("./parsers/ISOTimezoneParser.mjs");
var _timestampSecondsParserMjs = require("./parsers/TimestampSecondsParser.mjs");
var _timestampMillisecondsParserMjs = require("./parsers/TimestampMillisecondsParser.mjs");
var parsers = {
    G: new (0, _eraParserMjs.EraParser)(),
    y: new (0, _yearParserMjs.YearParser)(),
    Y: new (0, _localWeekYearParserMjs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserMjs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserMjs.ExtendedYearParser)(),
    Q: new (0, _quarterParserMjs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserMjs.StandAloneQuarterParser)(),
    M: new (0, _monthParserMjs.MonthParser)(),
    L: new (0, _standAloneMonthParserMjs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserMjs.LocalWeekParser)(),
    I: new (0, _isoweekParserMjs.ISOWeekParser)(),
    d: new (0, _dateParserMjs.DateParser)(),
    D: new (0, _dayOfYearParserMjs.DayOfYearParser)(),
    E: new (0, _dayParserMjs.DayParser)(),
    e: new (0, _localDayParserMjs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserMjs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserMjs.ISODayParser)(),
    a: new (0, _ampmparserMjs.AMPMParser)(),
    b: new (0, _ampmmidnightParserMjs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserMjs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserMjs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserMjs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserMjs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserMjs.Hour1To24Parser)(),
    m: new (0, _minuteParserMjs.MinuteParser)(),
    s: new (0, _secondParserMjs.SecondParser)(),
    S: new (0, _fractionOfSecondParserMjs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserMjs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserMjs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserMjs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserMjs.TimestampMillisecondsParser)()
};

},{"./parsers/EraParser.mjs":"lHHUn","./parsers/YearParser.mjs":"fW3Ok","./parsers/LocalWeekYearParser.mjs":"bRigc","./parsers/ISOWeekYearParser.mjs":"2EEK0","./parsers/ExtendedYearParser.mjs":"aGSsn","./parsers/QuarterParser.mjs":"6XNFH","./parsers/StandAloneQuarterParser.mjs":"2aD3X","./parsers/MonthParser.mjs":"2LOSa","./parsers/StandAloneMonthParser.mjs":"6kuIn","./parsers/LocalWeekParser.mjs":"cESGY","./parsers/ISOWeekParser.mjs":"bEYMn","./parsers/DateParser.mjs":"ag5T4","./parsers/DayOfYearParser.mjs":"lbFm1","./parsers/DayParser.mjs":"5I78m","./parsers/LocalDayParser.mjs":"enq7O","./parsers/StandAloneLocalDayParser.mjs":"2spGe","./parsers/ISODayParser.mjs":"81yrI","./parsers/AMPMParser.mjs":"bTtLG","./parsers/AMPMMidnightParser.mjs":"3MqFT","./parsers/DayPeriodParser.mjs":"jHa9n","./parsers/Hour1to12Parser.mjs":"d195b","./parsers/Hour0to23Parser.mjs":"dVbxB","./parsers/Hour0To11Parser.mjs":"41w4W","./parsers/Hour1To24Parser.mjs":"14OYI","./parsers/MinuteParser.mjs":"02XXg","./parsers/SecondParser.mjs":"6Om20","./parsers/FractionOfSecondParser.mjs":"egXqw","./parsers/ISOTimezoneWithZParser.mjs":"18xjz","./parsers/ISOTimezoneParser.mjs":"kjhLt","./parsers/TimestampSecondsParser.mjs":"8b58e","./parsers/TimestampMillisecondsParser.mjs":"cOfMA","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lHHUn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", function() {
    return EraParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var EraParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(EraParser, Parser);
    var _super = (0, _createSuper._)(EraParser);
    function EraParser() {
        (0, _classCallCheck._)(this, EraParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 140);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setFullYear(value, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5Si0b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", function() {
    return Parser;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _setterMjs = require("./Setter.mjs");
var Parser = /*#__PURE__*/ function() {
    "use strict";
    function Parser() {
        (0, _classCallCheck._)(this, Parser);
    }
    (0, _createClass._)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterMjs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","./Setter.mjs":"3Dz1k","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3Dz1k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", function() {
    return Setter;
});
parcelHelpers.export(exports, "ValueSetter", function() {
    return ValueSetter;
});
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", function() {
    return DateToSystemTimezoneSetter;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _transposeMjs = require("../../transpose.mjs");
var _constructFromMjs = require("../../constructFrom.mjs");
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    "use strict";
    function Setter() {
        (0, _classCallCheck._)(this, Setter);
        (0, _defineProperty._)(this, "subPriority", 0);
    }
    (0, _createClass._)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(Setter) {
    "use strict";
    (0, _inherits._)(ValueSetter, Setter);
    var _super = (0, _createSuper._)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        (0, _classCallCheck._)(this, ValueSetter);
        var _this;
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClass._)(ValueSetter, [
        {
            key: "validate",
            value: function validate(date, options) {
                return this.validateValue(date, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(date, flags, options) {
                return this.setValue(date, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(Setter) {
    "use strict";
    (0, _inherits._)(DateToSystemTimezoneSetter, Setter);
    var _super = (0, _createSuper._)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        (0, _classCallCheck._)(this, DateToSystemTimezoneSetter);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "subPriority", -1);
        return _this;
    }
    (0, _createClass._)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                return (0, _constructFromMjs.constructFrom)(date, (0, _transposeMjs.transpose)(date, Date));
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../transpose.mjs":"1f8Gh","../../constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1f8Gh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ parcelHelpers.export(exports, "transpose", function() {
    return transpose;
});
var _constructFromMjs = require("./constructFrom.mjs");
function transpose(fromDate, constructor) {
    var date = constructor instanceof Date ? (0, _constructFromMjs.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}
// Fallback for modularized imports:
exports.default = transpose;

},{"./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fW3Ok":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", function() {
    return YearParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var YearParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(YearParser, Parser);
    var _super = (0, _createSuper._)(YearParser);
    function YearParser() {
        (0, _classCallCheck._)(this, YearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utilsMjs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsMjs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setFullYear(year, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5ZV9n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", function() {
    return mapValue;
});
parcelHelpers.export(exports, "parseNumericPattern", function() {
    return parseNumericPattern;
});
parcelHelpers.export(exports, "parseTimezonePattern", function() {
    return parseTimezonePattern;
});
parcelHelpers.export(exports, "parseAnyDigitsSigned", function() {
    return parseAnyDigitsSigned;
});
parcelHelpers.export(exports, "parseNDigits", function() {
    return parseNDigits;
});
parcelHelpers.export(exports, "parseNDigitsSigned", function() {
    return parseNDigitsSigned;
});
parcelHelpers.export(exports, "dayPeriodEnumToHours", function() {
    return dayPeriodEnumToHours;
});
parcelHelpers.export(exports, "normalizeTwoDigitYear", function() {
    return normalizeTwoDigitYear;
});
parcelHelpers.export(exports, "isLeapYearIndex", function() {
    return isLeapYearIndex;
});
var _constantsMjs = require("../../constants.mjs");
var _constantsMjs1 = require("./constants.mjs");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _constantsMjs.millisecondsInHour) + minutes * (0, _constantsMjs.millisecondsInMinute) + seconds * (0, _constantsMjs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsMjs1.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsMjs1.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants.mjs":"dXQPO","./constants.mjs":"dWrQP","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dWrQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", function() {
    return numericPatterns;
});
parcelHelpers.export(exports, "timezonePatterns", function() {
    return timezonePatterns;
});
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bRigc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", function() {
    return LocalWeekYearParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _getWeekYearMjs = require("../../../getWeekYear.mjs");
var _startOfWeekMjs = require("../../../startOfWeek.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var LocalWeekYearParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(LocalWeekYearParser, Parser);
    var _super = (0, _createSuper._)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        (0, _classCallCheck._)(this, LocalWeekYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utilsMjs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _getWeekYearMjs.getWeekYear)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsMjs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setHours(0, 0, 0, 0);
                    return (0, _startOfWeekMjs.startOfWeek)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setFullYear(year, 0, options.firstWeekContainsDate);
                date.setHours(0, 0, 0, 0);
                return (0, _startOfWeekMjs.startOfWeek)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../getWeekYear.mjs":"uCMnT","../../../startOfWeek.mjs":"kLIcV","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2EEK0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", function() {
    return ISOWeekYearParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _startOfISOWeekMjs = require("../../../startOfISOWeek.mjs");
var _constructFromMjs = require("../../../constructFrom.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var ISOWeekYearParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(ISOWeekYearParser, Parser);
    var _super = (0, _createSuper._)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        (0, _classCallCheck._)(this, ISOWeekYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utilsMjs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsMjs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var firstWeekOfYear = (0, _constructFromMjs.constructFrom)(date, 0);
                firstWeekOfYear.setFullYear(value, 0, 4);
                firstWeekOfYear.setHours(0, 0, 0, 0);
                return (0, _startOfISOWeekMjs.startOfISOWeek)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../startOfISOWeek.mjs":"9qSeF","../../../constructFrom.mjs":"aoN9f","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aGSsn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", function() {
    return ExtendedYearParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var ExtendedYearParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(ExtendedYearParser, Parser);
    var _super = (0, _createSuper._)(ExtendedYearParser);
    function ExtendedYearParser() {
        (0, _classCallCheck._)(this, ExtendedYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 130);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utilsMjs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsMjs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setFullYear(value, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6XNFH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", function() {
    return QuarterParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var QuarterParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(QuarterParser, Parser);
    var _super = (0, _createSuper._)(QuarterParser);
    function QuarterParser() {
        (0, _classCallCheck._)(this, QuarterParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 120);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth((value - 1) * 3, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2aD3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", function() {
    return StandAloneQuarterParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var StandAloneQuarterParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(StandAloneQuarterParser, Parser);
    var _super = (0, _createSuper._)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        (0, _classCallCheck._)(this, StandAloneQuarterParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 120);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth((value - 1) * 3, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2LOSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", function() {
    return MonthParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var MonthParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(MonthParser, Parser);
    var _super = (0, _createSuper._)(MonthParser);
    function MonthParser() {
        (0, _classCallCheck._)(this, MonthParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 110);
        return _this;
    }
    (0, _createClass._)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utilsMjs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(value, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6kuIn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", function() {
    return StandAloneMonthParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var StandAloneMonthParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(StandAloneMonthParser, Parser);
    var _super = (0, _createSuper._)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        (0, _classCallCheck._)(this, StandAloneMonthParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 110);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utilsMjs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(value, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cESGY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", function() {
    return LocalWeekParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _setWeekMjs = require("../../../setWeek.mjs");
var _startOfWeekMjs = require("../../../startOfWeek.mjs");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var LocalWeekParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(LocalWeekParser, Parser);
    var _super = (0, _createSuper._)(LocalWeekParser);
    function LocalWeekParser() {
        (0, _classCallCheck._)(this, LocalWeekParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 100);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _startOfWeekMjs.startOfWeek)((0, _setWeekMjs.setWeek)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../setWeek.mjs":"bUVq6","../../../startOfWeek.mjs":"kLIcV","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bUVq6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ parcelHelpers.export(exports, "setWeek", function() {
    return setWeek;
});
var _getWeekMjs = require("./getWeek.mjs");
var _toDateMjs = require("./toDate.mjs");
function setWeek(date, week, options) {
    var _date = (0, _toDateMjs.toDate)(date);
    var diff = (0, _getWeekMjs.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
// Fallback for modularized imports:
exports.default = setWeek;

},{"./getWeek.mjs":"bYzCC","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bEYMn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", function() {
    return ISOWeekParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _setISOWeekMjs = require("../../../setISOWeek.mjs");
var _startOfISOWeekMjs = require("../../../startOfISOWeek.mjs");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var ISOWeekParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(ISOWeekParser, Parser);
    var _super = (0, _createSuper._)(ISOWeekParser);
    function ISOWeekParser() {
        (0, _classCallCheck._)(this, ISOWeekParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 100);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _startOfISOWeekMjs.startOfISOWeek)((0, _setISOWeekMjs.setISOWeek)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../setISOWeek.mjs":"gkktW","../../../startOfISOWeek.mjs":"9qSeF","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gkktW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ parcelHelpers.export(exports, "setISOWeek", function() {
    return setISOWeek;
});
var _getISOWeekMjs = require("./getISOWeek.mjs");
var _toDateMjs = require("./toDate.mjs");
function setISOWeek(date, week) {
    var _date = (0, _toDateMjs.toDate)(date);
    var diff = (0, _getISOWeekMjs.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
// Fallback for modularized imports:
exports.default = setISOWeek;

},{"./getISOWeek.mjs":"hhzZS","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ag5T4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", function() {
    return DateParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(DateParser, Parser);
    var _super = (0, _createSuper._)(DateParser);
    function DateParser() {
        (0, _classCallCheck._)(this, DateParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "subPriority", 1);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getFullYear();
                var isLeapYear = (0, _utilsMjs.isLeapYearIndex)(year);
                var month = date.getMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setDate(value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lbFm1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", function() {
    return DayOfYearParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var DayOfYearParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(DayOfYearParser, Parser);
    var _super = (0, _createSuper._)(DayOfYearParser);
    function DayOfYearParser() {
        (0, _classCallCheck._)(this, DayOfYearParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "subpriority", 1);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getFullYear();
                var isLeapYear = (0, _utilsMjs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(0, value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5I78m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", function() {
    return DayParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _setDayMjs = require("../../../setDay.mjs");
var _parserMjs = require("../Parser.mjs");
var DayParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(DayParser, Parser);
    var _super = (0, _createSuper._)(DayParser);
    function DayParser() {
        (0, _classCallCheck._)(this, DayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _setDayMjs.setDay)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../setDay.mjs":"cBlks","../Parser.mjs":"5Si0b","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cBlks":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ parcelHelpers.export(exports, "setDay", function() {
    return setDay;
});
var _addDaysMjs = require("./addDays.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function setDay(date, day, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _toDateMjs.toDate)(date);
    var currentDay = _date.getDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var delta = 7 - weekStartsOn;
    var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, _addDaysMjs.addDays)(_date, diff);
}
// Fallback for modularized imports:
exports.default = setDay;

},{"./addDays.mjs":"6zihD","./toDate.mjs":"5c6W0","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"enq7O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", function() {
    return LocalDayParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _setDayMjs = require("../../../setDay.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var LocalDayParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(LocalDayParser, Parser);
    var _super = (0, _createSuper._)(LocalDayParser);
    function LocalDayParser() {
        (0, _classCallCheck._)(this, LocalDayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function(value) {
                    // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utilsMjs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _setDayMjs.setDay)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../setDay.mjs":"cBlks","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2spGe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", function() {
    return StandAloneLocalDayParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _setDayMjs = require("../../../setDay.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var StandAloneLocalDayParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(StandAloneLocalDayParser, Parser);
    var _super = (0, _createSuper._)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        (0, _classCallCheck._)(this, StandAloneLocalDayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function(value) {
                    // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utilsMjs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _setDayMjs.setDay)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../setDay.mjs":"cBlks","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"81yrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", function() {
    return ISODayParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _setISODayMjs = require("../../../setISODay.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var ISODayParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(ISODayParser, Parser);
    var _super = (0, _createSuper._)(ISODayParser);
    function ISODayParser() {
        (0, _classCallCheck._)(this, ISODayParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 90);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utilsMjs.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utilsMjs.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utilsMjs.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utilsMjs.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _setISODayMjs.setISODay)(date, value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../setISODay.mjs":"ck1p8","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ck1p8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ parcelHelpers.export(exports, "setISODay", function() {
    return setISODay;
});
var _addDaysMjs = require("./addDays.mjs");
var _getISODayMjs = require("./getISODay.mjs");
var _toDateMjs = require("./toDate.mjs");
function setISODay(date, day) {
    var _date = (0, _toDateMjs.toDate)(date);
    var currentDay = (0, _getISODayMjs.getISODay)(_date);
    var diff = day - currentDay;
    return (0, _addDaysMjs.addDays)(_date, diff);
}
// Fallback for modularized imports:
exports.default = setISODay;

},{"./addDays.mjs":"6zihD","./getISODay.mjs":"kPl3b","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bTtLG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", function() {
    return AMPMParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var AMPMParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(AMPMParser, Parser);
    var _super = (0, _createSuper._)(AMPMParser);
    function AMPMParser() {
        (0, _classCallCheck._)(this, AMPMParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 80);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, _utilsMjs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3MqFT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", function() {
    return AMPMMidnightParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var AMPMMidnightParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(AMPMMidnightParser, Parser);
    var _super = (0, _createSuper._)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        (0, _classCallCheck._)(this, AMPMMidnightParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 80);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, _utilsMjs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jHa9n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", function() {
    return DayPeriodParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var DayPeriodParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(DayPeriodParser, Parser);
    var _super = (0, _createSuper._)(DayPeriodParser);
    function DayPeriodParser() {
        (0, _classCallCheck._)(this, DayPeriodParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 80);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, _utilsMjs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"d195b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", function() {
    return Hour1to12Parser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var Hour1to12Parser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(Hour1to12Parser, Parser);
    var _super = (0, _createSuper._)(Hour1to12Parser);
    function Hour1to12Parser() {
        (0, _classCallCheck._)(this, Hour1to12Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getHours() >= 12;
                if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
                else date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dVbxB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", function() {
    return Hour0to23Parser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var Hour0to23Parser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(Hour0to23Parser, Parser);
    var _super = (0, _createSuper._)(Hour0to23Parser);
    function Hour0to23Parser() {
        (0, _classCallCheck._)(this, Hour0to23Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"41w4W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", function() {
    return Hour0To11Parser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var Hour0To11Parser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(Hour0To11Parser, Parser);
    var _super = (0, _createSuper._)(Hour0To11Parser);
    function Hour0To11Parser() {
        (0, _classCallCheck._)(this, Hour0To11Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getHours() >= 12;
                if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
                else date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"14OYI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", function() {
    return Hour1To24Parser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var Hour1To24Parser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(Hour1To24Parser, Parser);
    var _super = (0, _createSuper._)(Hour1To24Parser);
    function Hour1To24Parser() {
        (0, _classCallCheck._)(this, Hour1To24Parser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 70);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"02XXg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", function() {
    return MinuteParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var MinuteParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(MinuteParser, Parser);
    var _super = (0, _createSuper._)(MinuteParser);
    function MinuteParser() {
        (0, _classCallCheck._)(this, MinuteParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 60);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6Om20":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", function() {
    return SecondParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var SecondParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(SecondParser, Parser);
    var _super = (0, _createSuper._)(SecondParser);
    function SecondParser() {
        (0, _classCallCheck._)(this, SecondParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 50);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utilsMjs.parseNumericPattern)((0, _constantsMjs.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utilsMjs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"egXqw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", function() {
    return FractionOfSecondParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var FractionOfSecondParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(FractionOfSecondParser, Parser);
    var _super = (0, _createSuper._)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        (0, _classCallCheck._)(this, FractionOfSecondParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 30);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClass._)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function(value) {
                    return Math.trunc(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsMjs.mapValue)((0, _utilsMjs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"18xjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", function() {
    return ISOTimezoneWithZParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constructFromMjs = require("../../../constructFrom.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("../../../_lib/getTimezoneOffsetInMilliseconds.mjs");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var ISOTimezoneWithZParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(ISOTimezoneWithZParser, Parser);
    var _super = (0, _createSuper._)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        (0, _classCallCheck._)(this, ISOTimezoneWithZParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 10);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return (0, _constructFromMjs.constructFrom)(date, date.getTime() - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(date) - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../constructFrom.mjs":"aoN9f","../../../_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kjhLt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", function() {
    return ISOTimezoneParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constructFromMjs = require("../../../constructFrom.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("../../../_lib/getTimezoneOffsetInMilliseconds.mjs");
var _constantsMjs = require("../constants.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var ISOTimezoneParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(ISOTimezoneParser, Parser);
    var _super = (0, _createSuper._)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        (0, _classCallCheck._)(this, ISOTimezoneParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 10);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, _createClass._)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utilsMjs.parseTimezonePattern)((0, _constantsMjs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return (0, _constructFromMjs.constructFrom)(date, date.getTime() - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(date) - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../constructFrom.mjs":"aoN9f","../../../_lib/getTimezoneOffsetInMilliseconds.mjs":"bZ8h9","../constants.mjs":"dWrQP","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8b58e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", function() {
    return TimestampSecondsParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constructFromMjs = require("../../../constructFrom.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var TimestampSecondsParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(TimestampSecondsParser, Parser);
    var _super = (0, _createSuper._)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        (0, _classCallCheck._)(this, TimestampSecondsParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 40);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClass._)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsMjs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return [
                    (0, _constructFromMjs.constructFrom)(date, value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../constructFrom.mjs":"aoN9f","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cOfMA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", function() {
    return TimestampMillisecondsParser;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _constructFromMjs = require("../../../constructFrom.mjs");
var _parserMjs = require("../Parser.mjs");
var _utilsMjs = require("../utils.mjs");
var TimestampMillisecondsParser = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, _inherits._)(TimestampMillisecondsParser, Parser);
    var _super = (0, _createSuper._)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        (0, _classCallCheck._)(this, TimestampMillisecondsParser);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "priority", 20);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClass._)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsMjs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return [
                    (0, _constructFromMjs.constructFrom)(date, value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserMjs.Parser));

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","../../../constructFrom.mjs":"aoN9f","../Parser.mjs":"5Si0b","../utils.mjs":"5ZV9n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4kjZc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ parcelHelpers.export(exports, "isMonday", function() {
    return isMonday;
});
var _toDateMjs = require("./toDate.mjs");
function isMonday(date) {
    return (0, _toDateMjs.toDate)(date).getDay() === 1;
}
// Fallback for modularized imports:
exports.default = isMonday;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5bhxL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ parcelHelpers.export(exports, "isPast", function() {
    return isPast;
});
var _toDateMjs = require("./toDate.mjs");
function isPast(date) {
    return +(0, _toDateMjs.toDate)(date) < Date.now();
}
// Fallback for modularized imports:
exports.default = isPast;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aBU16":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ parcelHelpers.export(exports, "isSameHour", function() {
    return isSameHour;
});
var _startOfHourMjs = require("./startOfHour.mjs");
function isSameHour(dateLeft, dateRight) {
    var dateLeftStartOfHour = (0, _startOfHourMjs.startOfHour)(dateLeft);
    var dateRightStartOfHour = (0, _startOfHourMjs.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}
// Fallback for modularized imports:
exports.default = isSameHour;

},{"./startOfHour.mjs":"8ME71","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8ME71":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ parcelHelpers.export(exports, "startOfHour", function() {
    return startOfHour;
});
var _toDateMjs = require("./toDate.mjs");
function startOfHour(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfHour;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9p0Pa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ parcelHelpers.export(exports, "isSameISOWeek", function() {
    return isSameISOWeek;
});
var _isSameWeekMjs = require("./isSameWeek.mjs");
function isSameISOWeek(dateLeft, dateRight) {
    return (0, _isSameWeekMjs.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = isSameISOWeek;

},{"./isSameWeek.mjs":"kHX9m","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kHX9m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ parcelHelpers.export(exports, "isSameWeek", function() {
    return isSameWeek;
});
var _startOfWeekMjs = require("./startOfWeek.mjs");
function isSameWeek(dateLeft, dateRight, options) {
    var dateLeftStartOfWeek = (0, _startOfWeekMjs.startOfWeek)(dateLeft, options);
    var dateRightStartOfWeek = (0, _startOfWeekMjs.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}
// Fallback for modularized imports:
exports.default = isSameWeek;

},{"./startOfWeek.mjs":"kLIcV","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iUPI4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ parcelHelpers.export(exports, "isSameISOWeekYear", function() {
    return isSameISOWeekYear;
});
var _startOfISOWeekYearMjs = require("./startOfISOWeekYear.mjs");
function isSameISOWeekYear(dateLeft, dateRight) {
    var dateLeftStartOfYear = (0, _startOfISOWeekYearMjs.startOfISOWeekYear)(dateLeft);
    var dateRightStartOfYear = (0, _startOfISOWeekYearMjs.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}
// Fallback for modularized imports:
exports.default = isSameISOWeekYear;

},{"./startOfISOWeekYear.mjs":"edLgJ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j045I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ parcelHelpers.export(exports, "isSameMinute", function() {
    return isSameMinute;
});
var _startOfMinuteMjs = require("./startOfMinute.mjs");
function isSameMinute(dateLeft, dateRight) {
    var dateLeftStartOfMinute = (0, _startOfMinuteMjs.startOfMinute)(dateLeft);
    var dateRightStartOfMinute = (0, _startOfMinuteMjs.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}
// Fallback for modularized imports:
exports.default = isSameMinute;

},{"./startOfMinute.mjs":"eIDyY","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hV5am":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ parcelHelpers.export(exports, "isSameMonth", function() {
    return isSameMonth;
});
var _toDateMjs = require("./toDate.mjs");
function isSameMonth(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}
// Fallback for modularized imports:
exports.default = isSameMonth;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"d5Afs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ parcelHelpers.export(exports, "isSameQuarter", function() {
    return isSameQuarter;
});
var _startOfQuarterMjs = require("./startOfQuarter.mjs");
function isSameQuarter(dateLeft, dateRight) {
    var dateLeftStartOfQuarter = (0, _startOfQuarterMjs.startOfQuarter)(dateLeft);
    var dateRightStartOfQuarter = (0, _startOfQuarterMjs.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}
// Fallback for modularized imports:
exports.default = isSameQuarter;

},{"./startOfQuarter.mjs":"3MxaQ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"a7O5b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ parcelHelpers.export(exports, "isSameSecond", function() {
    return isSameSecond;
});
var _startOfSecondMjs = require("./startOfSecond.mjs");
function isSameSecond(dateLeft, dateRight) {
    var dateLeftStartOfSecond = (0, _startOfSecondMjs.startOfSecond)(dateLeft);
    var dateRightStartOfSecond = (0, _startOfSecondMjs.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}
// Fallback for modularized imports:
exports.default = isSameSecond;

},{"./startOfSecond.mjs":"9uHeC","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9uHeC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ parcelHelpers.export(exports, "startOfSecond", function() {
    return startOfSecond;
});
var _toDateMjs = require("./toDate.mjs");
function startOfSecond(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfSecond;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kO2r7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ parcelHelpers.export(exports, "isSameYear", function() {
    return isSameYear;
});
var _toDateMjs = require("./toDate.mjs");
function isSameYear(dateLeft, dateRight) {
    var _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    var _dateRight = (0, _toDateMjs.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}
// Fallback for modularized imports:
exports.default = isSameYear;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4IZTu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ parcelHelpers.export(exports, "isThisHour", function() {
    return isThisHour;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameHourMjs = require("./isSameHour.mjs");
function isThisHour(date) {
    return (0, _isSameHourMjs.isSameHour)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isThisHour;

},{"./constructNow.mjs":"8zr8Z","./isSameHour.mjs":"aBU16","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bENnF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ parcelHelpers.export(exports, "isThisISOWeek", function() {
    return isThisISOWeek;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameISOWeekMjs = require("./isSameISOWeek.mjs");
function isThisISOWeek(date) {
    return (0, _isSameISOWeekMjs.isSameISOWeek)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isThisISOWeek;

},{"./constructNow.mjs":"8zr8Z","./isSameISOWeek.mjs":"9p0Pa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"52ftk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ parcelHelpers.export(exports, "isThisMinute", function() {
    return isThisMinute;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameMinuteMjs = require("./isSameMinute.mjs");
function isThisMinute(date) {
    return (0, _isSameMinuteMjs.isSameMinute)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isThisMinute;

},{"./constructNow.mjs":"8zr8Z","./isSameMinute.mjs":"j045I","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eKk8f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ parcelHelpers.export(exports, "isThisMonth", function() {
    return isThisMonth;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameMonthMjs = require("./isSameMonth.mjs");
function isThisMonth(date) {
    return (0, _isSameMonthMjs.isSameMonth)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isThisMonth;

},{"./constructNow.mjs":"8zr8Z","./isSameMonth.mjs":"hV5am","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"flZVP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ parcelHelpers.export(exports, "isThisQuarter", function() {
    return isThisQuarter;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameQuarterMjs = require("./isSameQuarter.mjs");
function isThisQuarter(date) {
    return (0, _isSameQuarterMjs.isSameQuarter)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isThisQuarter;

},{"./constructNow.mjs":"8zr8Z","./isSameQuarter.mjs":"d5Afs","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"djK4R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ parcelHelpers.export(exports, "isThisSecond", function() {
    return isThisSecond;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameSecondMjs = require("./isSameSecond.mjs");
function isThisSecond(date) {
    return (0, _isSameSecondMjs.isSameSecond)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isThisSecond;

},{"./constructNow.mjs":"8zr8Z","./isSameSecond.mjs":"a7O5b","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"N4XJM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ parcelHelpers.export(exports, "isThisWeek", function() {
    return isThisWeek;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameWeekMjs = require("./isSameWeek.mjs");
function isThisWeek(date, options) {
    return (0, _isSameWeekMjs.isSameWeek)(date, (0, _constructNowMjs.constructNow)(date), options);
}
// Fallback for modularized imports:
exports.default = isThisWeek;

},{"./constructNow.mjs":"8zr8Z","./isSameWeek.mjs":"kHX9m","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"coSfR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ parcelHelpers.export(exports, "isThisYear", function() {
    return isThisYear;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameYearMjs = require("./isSameYear.mjs");
function isThisYear(date) {
    return (0, _isSameYearMjs.isSameYear)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isThisYear;

},{"./constructNow.mjs":"8zr8Z","./isSameYear.mjs":"kO2r7","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7sBv4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ parcelHelpers.export(exports, "isThursday", function() {
    return isThursday;
});
var _toDateMjs = require("./toDate.mjs");
function isThursday(date) {
    return (0, _toDateMjs.toDate)(date).getDay() === 4;
}
// Fallback for modularized imports:
exports.default = isThursday;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gcnmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ parcelHelpers.export(exports, "isToday", function() {
    return isToday;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameDayMjs = require("./isSameDay.mjs");
function isToday(date) {
    return (0, _isSameDayMjs.isSameDay)(date, (0, _constructNowMjs.constructNow)(date));
}
// Fallback for modularized imports:
exports.default = isToday;

},{"./constructNow.mjs":"8zr8Z","./isSameDay.mjs":"265Cc","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dLEGn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ parcelHelpers.export(exports, "isTomorrow", function() {
    return isTomorrow;
});
var _addDaysMjs = require("./addDays.mjs");
var _constructNowMjs = require("./constructNow.mjs");
var _isSameDayMjs = require("./isSameDay.mjs");
function isTomorrow(date) {
    return (0, _isSameDayMjs.isSameDay)(date, (0, _addDaysMjs.addDays)((0, _constructNowMjs.constructNow)(date), 1));
}
// Fallback for modularized imports:
exports.default = isTomorrow;

},{"./addDays.mjs":"6zihD","./constructNow.mjs":"8zr8Z","./isSameDay.mjs":"265Cc","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kfkgT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ parcelHelpers.export(exports, "isTuesday", function() {
    return isTuesday;
});
var _toDateMjs = require("./toDate.mjs");
function isTuesday(date) {
    return (0, _toDateMjs.toDate)(date).getDay() === 2;
}
// Fallback for modularized imports:
exports.default = isTuesday;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8FbeG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ parcelHelpers.export(exports, "isWednesday", function() {
    return isWednesday;
});
var _toDateMjs = require("./toDate.mjs");
function isWednesday(date) {
    return (0, _toDateMjs.toDate)(date).getDay() === 3;
}
// Fallback for modularized imports:
exports.default = isWednesday;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5B0CX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ parcelHelpers.export(exports, "isWithinInterval", function() {
    return isWithinInterval;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toDateMjs = require("./toDate.mjs");
function isWithinInterval(date, interval) {
    var time = +(0, _toDateMjs.toDate)(date);
    var _sort = (0, _slicedToArray._)([
        +(0, _toDateMjs.toDate)(interval.start),
        +(0, _toDateMjs.toDate)(interval.end)
    ].sort(function(a, b) {
        return a - b;
    }), 2), startTime = _sort[0], endTime = _sort[1];
    return time >= startTime && time <= endTime;
}
// Fallback for modularized imports:
exports.default = isWithinInterval;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gW0VU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ parcelHelpers.export(exports, "isYesterday", function() {
    return isYesterday;
});
var _constructNowMjs = require("./constructNow.mjs");
var _isSameDayMjs = require("./isSameDay.mjs");
var _subDaysMjs = require("./subDays.mjs");
function isYesterday(date) {
    return (0, _isSameDayMjs.isSameDay)(date, (0, _subDaysMjs.subDays)((0, _constructNowMjs.constructNow)(date), 1));
}
// Fallback for modularized imports:
exports.default = isYesterday;

},{"./constructNow.mjs":"8zr8Z","./isSameDay.mjs":"265Cc","./subDays.mjs":"99ld1","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"99ld1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ parcelHelpers.export(exports, "subDays", function() {
    return subDays;
});
var _addDaysMjs = require("./addDays.mjs");
function subDays(date, amount) {
    return (0, _addDaysMjs.addDays)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subDays;

},{"./addDays.mjs":"6zihD","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"HmZaB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ parcelHelpers.export(exports, "lastDayOfDecade", function() {
    return lastDayOfDecade;
});
var _toDateMjs = require("./toDate.mjs");
function lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = lastDayOfDecade;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fOqx1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ parcelHelpers.export(exports, "lastDayOfISOWeek", function() {
    return lastDayOfISOWeek;
});
var _lastDayOfWeekMjs = require("./lastDayOfWeek.mjs");
function lastDayOfISOWeek(date) {
    return (0, _lastDayOfWeekMjs.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = lastDayOfISOWeek;

},{"./lastDayOfWeek.mjs":"c6NJi","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"c6NJi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ parcelHelpers.export(exports, "lastDayOfWeek", function() {
    return lastDayOfWeek;
});
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function lastDayOfWeek(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, _toDateMjs.toDate)(date);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}
// Fallback for modularized imports:
exports.default = lastDayOfWeek;

},{"./toDate.mjs":"5c6W0","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"boXSf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ parcelHelpers.export(exports, "lastDayOfISOWeekYear", function() {
    return lastDayOfISOWeekYear;
});
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function lastDayOfISOWeekYear(date) {
    var year = (0, _getISOWeekYearMjs.getISOWeekYear)(date);
    var fourthOfJanuary = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var _date = (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}
// Fallback for modularized imports:
exports.default = lastDayOfISOWeekYear;

},{"./getISOWeekYear.mjs":"iN2l0","./startOfISOWeek.mjs":"9qSeF","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6h1A8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ parcelHelpers.export(exports, "lastDayOfQuarter", function() {
    return lastDayOfQuarter;
});
var _toDateMjs = require("./toDate.mjs");
function lastDayOfQuarter(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var currentMonth = _date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = lastDayOfQuarter;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3BZ9B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ parcelHelpers.export(exports, "lastDayOfYear", function() {
    return lastDayOfYear;
});
var _toDateMjs = require("./toDate.mjs");
function lastDayOfYear(date) {
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = lastDayOfYear;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iHfft":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "lightFormatters", function() {
    return 0, _lightFormattersMjs.lightFormatters;
});
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ parcelHelpers.export(exports, "lightFormat", function() {
    return lightFormat;
});
var _isValidMjs = require("./isValid.mjs");
var _toDateMjs = require("./toDate.mjs");
var _lightFormattersMjs = require("./_lib/format/lightFormatters.mjs");
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function lightFormat(date, formatStr) {
    var _date = (0, _toDateMjs.toDate)(date);
    if (!(0, _isValidMjs.isValid)(_date)) throw new RangeError("Invalid time value");
    var tokens = formatStr.match(formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    var result = tokens.map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _lightFormattersMjs.lightFormatters)[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matches = input.match(escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = lightFormat;

},{"./isValid.mjs":"8moLi","./toDate.mjs":"5c6W0","./_lib/format/lightFormatters.mjs":"fQPPj","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"deU9E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ parcelHelpers.export(exports, "milliseconds", function() {
    return milliseconds;
});
var _constantsMjs = require("./constants.mjs");
function milliseconds(param) {
    var years = param.years, months = param.months, weeks = param.weeks, days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds;
    var totalDays = 0;
    if (years) totalDays += years * (0, _constantsMjs.daysInYear);
    if (months) totalDays += months * ((0, _constantsMjs.daysInYear) / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    var totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}
// Fallback for modularized imports:
exports.default = milliseconds;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kynq9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ parcelHelpers.export(exports, "millisecondsToHours", function() {
    return millisecondsToHours;
});
var _constantsMjs = require("./constants.mjs");
function millisecondsToHours(milliseconds) {
    var hours = milliseconds / (0, _constantsMjs.millisecondsInHour);
    return Math.trunc(hours);
}
// Fallback for modularized imports:
exports.default = millisecondsToHours;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gA0wF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ parcelHelpers.export(exports, "millisecondsToMinutes", function() {
    return millisecondsToMinutes;
});
var _constantsMjs = require("./constants.mjs");
function millisecondsToMinutes(milliseconds) {
    var minutes = milliseconds / (0, _constantsMjs.millisecondsInMinute);
    return Math.trunc(minutes);
}
// Fallback for modularized imports:
exports.default = millisecondsToMinutes;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kqBpo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ parcelHelpers.export(exports, "millisecondsToSeconds", function() {
    return millisecondsToSeconds;
});
var _constantsMjs = require("./constants.mjs");
function millisecondsToSeconds(milliseconds) {
    var seconds = milliseconds / (0, _constantsMjs.millisecondsInSecond);
    return Math.trunc(seconds);
}
// Fallback for modularized imports:
exports.default = millisecondsToSeconds;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ktxeo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ parcelHelpers.export(exports, "minutesToHours", function() {
    return minutesToHours;
});
var _constantsMjs = require("./constants.mjs");
function minutesToHours(minutes) {
    var hours = minutes / (0, _constantsMjs.minutesInHour);
    return Math.trunc(hours);
}
// Fallback for modularized imports:
exports.default = minutesToHours;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ldujC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ parcelHelpers.export(exports, "minutesToMilliseconds", function() {
    return minutesToMilliseconds;
});
var _constantsMjs = require("./constants.mjs");
function minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * (0, _constantsMjs.millisecondsInMinute));
}
// Fallback for modularized imports:
exports.default = minutesToMilliseconds;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"xVzzN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ parcelHelpers.export(exports, "minutesToSeconds", function() {
    return minutesToSeconds;
});
var _constantsMjs = require("./constants.mjs");
function minutesToSeconds(minutes) {
    return Math.trunc(minutes * (0, _constantsMjs.secondsInMinute));
}
// Fallback for modularized imports:
exports.default = minutesToSeconds;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gyKDA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ parcelHelpers.export(exports, "monthsToQuarters", function() {
    return monthsToQuarters;
});
var _constantsMjs = require("./constants.mjs");
function monthsToQuarters(months) {
    var quarters = months / (0, _constantsMjs.monthsInQuarter);
    return Math.trunc(quarters);
}
// Fallback for modularized imports:
exports.default = monthsToQuarters;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"80mxc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ parcelHelpers.export(exports, "monthsToYears", function() {
    return monthsToYears;
});
var _constantsMjs = require("./constants.mjs");
function monthsToYears(months) {
    var years = months / (0, _constantsMjs.monthsInYear);
    return Math.trunc(years);
}
// Fallback for modularized imports:
exports.default = monthsToYears;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"it6Fh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ parcelHelpers.export(exports, "nextDay", function() {
    return nextDay;
});
var _addDaysMjs = require("./addDays.mjs");
var _getDayMjs = require("./getDay.mjs");
function nextDay(date, day) {
    var delta = day - (0, _getDayMjs.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, _addDaysMjs.addDays)(date, delta);
}
// Fallback for modularized imports:
exports.default = nextDay;

},{"./addDays.mjs":"6zihD","./getDay.mjs":"e5GCB","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4Li8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ parcelHelpers.export(exports, "nextFriday", function() {
    return nextFriday;
});
var _nextDayMjs = require("./nextDay.mjs");
function nextFriday(date) {
    return (0, _nextDayMjs.nextDay)(date, 5);
}
// Fallback for modularized imports:
exports.default = nextFriday;

},{"./nextDay.mjs":"it6Fh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"32FK2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ parcelHelpers.export(exports, "nextMonday", function() {
    return nextMonday;
});
var _nextDayMjs = require("./nextDay.mjs");
function nextMonday(date) {
    return (0, _nextDayMjs.nextDay)(date, 1);
}
// Fallback for modularized imports:
exports.default = nextMonday;

},{"./nextDay.mjs":"it6Fh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4wpoJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ parcelHelpers.export(exports, "nextSaturday", function() {
    return nextSaturday;
});
var _nextDayMjs = require("./nextDay.mjs");
function nextSaturday(date) {
    return (0, _nextDayMjs.nextDay)(date, 6);
}
// Fallback for modularized imports:
exports.default = nextSaturday;

},{"./nextDay.mjs":"it6Fh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fwB72":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ parcelHelpers.export(exports, "nextSunday", function() {
    return nextSunday;
});
var _nextDayMjs = require("./nextDay.mjs");
function nextSunday(date) {
    return (0, _nextDayMjs.nextDay)(date, 0);
}
// Fallback for modularized imports:
exports.default = nextSunday;

},{"./nextDay.mjs":"it6Fh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7BmNm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ parcelHelpers.export(exports, "nextThursday", function() {
    return nextThursday;
});
var _nextDayMjs = require("./nextDay.mjs");
function nextThursday(date) {
    return (0, _nextDayMjs.nextDay)(date, 4);
}
// Fallback for modularized imports:
exports.default = nextThursday;

},{"./nextDay.mjs":"it6Fh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7jUde":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ parcelHelpers.export(exports, "nextTuesday", function() {
    return nextTuesday;
});
var _nextDayMjs = require("./nextDay.mjs");
function nextTuesday(date) {
    return (0, _nextDayMjs.nextDay)(date, 2);
}
// Fallback for modularized imports:
exports.default = nextTuesday;

},{"./nextDay.mjs":"it6Fh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lctMn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ parcelHelpers.export(exports, "nextWednesday", function() {
    return nextWednesday;
});
var _nextDayMjs = require("./nextDay.mjs");
function nextWednesday(date) {
    return (0, _nextDayMjs.nextDay)(date, 3);
}
// Fallback for modularized imports:
exports.default = nextWednesday;

},{"./nextDay.mjs":"it6Fh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"agu6R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ parcelHelpers.export(exports, "parseISO", function() {
    return parseISO;
});
var _constantsMjs = require("./constants.mjs");
function parseISO(argument, options) {
    var _options_additionalDigits;
    var additionalDigits = (_options_additionalDigits = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options_additionalDigits !== void 0 ? _options_additionalDigits : 2;
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _constantsMjs.millisecondsInHour) + minutes * (0, _constantsMjs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _constantsMjs.millisecondsInHour) + minutes * (0, _constantsMjs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
// Fallback for modularized imports:
exports.default = parseISO;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"as85I":[function(require,module,exports) {
/**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJSON", function() {
    return parseJSON;
});
function parseJSON(dateStr) {
    var parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}
// Fallback for modularized imports:
exports.default = parseJSON;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4rSP6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ parcelHelpers.export(exports, "previousDay", function() {
    return previousDay;
});
var _getDayMjs = require("./getDay.mjs");
var _subDaysMjs = require("./subDays.mjs");
function previousDay(date, day) {
    var delta = (0, _getDayMjs.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, _subDaysMjs.subDays)(date, delta);
}
// Fallback for modularized imports:
exports.default = previousDay;

},{"./getDay.mjs":"e5GCB","./subDays.mjs":"99ld1","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9Nc66":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ parcelHelpers.export(exports, "previousFriday", function() {
    return previousFriday;
});
var _previousDayMjs = require("./previousDay.mjs");
function previousFriday(date) {
    return (0, _previousDayMjs.previousDay)(date, 5);
}
// Fallback for modularized imports:
exports.default = previousFriday;

},{"./previousDay.mjs":"4rSP6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"e5zJz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ parcelHelpers.export(exports, "previousMonday", function() {
    return previousMonday;
});
var _previousDayMjs = require("./previousDay.mjs");
function previousMonday(date) {
    return (0, _previousDayMjs.previousDay)(date, 1);
}
// Fallback for modularized imports:
exports.default = previousMonday;

},{"./previousDay.mjs":"4rSP6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jayle":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ parcelHelpers.export(exports, "previousSaturday", function() {
    return previousSaturday;
});
var _previousDayMjs = require("./previousDay.mjs");
function previousSaturday(date) {
    return (0, _previousDayMjs.previousDay)(date, 6);
}
// Fallback for modularized imports:
exports.default = previousSaturday;

},{"./previousDay.mjs":"4rSP6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gKllv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ parcelHelpers.export(exports, "previousSunday", function() {
    return previousSunday;
});
var _previousDayMjs = require("./previousDay.mjs");
function previousSunday(date) {
    return (0, _previousDayMjs.previousDay)(date, 0);
}
// Fallback for modularized imports:
exports.default = previousSunday;

},{"./previousDay.mjs":"4rSP6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"b0E6W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ parcelHelpers.export(exports, "previousThursday", function() {
    return previousThursday;
});
var _previousDayMjs = require("./previousDay.mjs");
function previousThursday(date) {
    return (0, _previousDayMjs.previousDay)(date, 4);
}
// Fallback for modularized imports:
exports.default = previousThursday;

},{"./previousDay.mjs":"4rSP6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9WWCj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ parcelHelpers.export(exports, "previousTuesday", function() {
    return previousTuesday;
});
var _previousDayMjs = require("./previousDay.mjs");
function previousTuesday(date) {
    return (0, _previousDayMjs.previousDay)(date, 2);
}
// Fallback for modularized imports:
exports.default = previousTuesday;

},{"./previousDay.mjs":"4rSP6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4plUf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ parcelHelpers.export(exports, "previousWednesday", function() {
    return previousWednesday;
});
var _previousDayMjs = require("./previousDay.mjs");
function previousWednesday(date) {
    return (0, _previousDayMjs.previousDay)(date, 3);
}
// Fallback for modularized imports:
exports.default = previousWednesday;

},{"./previousDay.mjs":"4rSP6","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hlJcP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ parcelHelpers.export(exports, "quartersToMonths", function() {
    return quartersToMonths;
});
var _constantsMjs = require("./constants.mjs");
function quartersToMonths(quarters) {
    return Math.trunc(quarters * (0, _constantsMjs.monthsInQuarter));
}
// Fallback for modularized imports:
exports.default = quartersToMonths;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jQmKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ parcelHelpers.export(exports, "quartersToYears", function() {
    return quartersToYears;
});
var _constantsMjs = require("./constants.mjs");
function quartersToYears(quarters) {
    var years = quarters / (0, _constantsMjs.quartersInYear);
    return Math.trunc(years);
}
// Fallback for modularized imports:
exports.default = quartersToYears;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6ETGD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ parcelHelpers.export(exports, "roundToNearestHours", function() {
    return roundToNearestHours;
});
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
var _toDateMjs = require("./toDate.mjs");
function roundToNearestHours(date, options) {
    var _options_nearestTo;
    var nearestTo = (_options_nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options_nearestTo !== void 0 ? _options_nearestTo : 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, _constructFromMjs.constructFrom)(date, NaN);
    var _date = (0, _toDateMjs.toDate)(date);
    var fractionalMinutes = _date.getMinutes() / 60;
    var fractionalSeconds = _date.getSeconds() / 60 / 60;
    var fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    var hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    var _options_roundingMethod;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    var method = (_options_roundingMethod = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options_roundingMethod !== void 0 ? _options_roundingMethod : "round";
    var roundingMethod = (0, _getRoundingMethodMjs.getRoundingMethod)(method);
    // nearestTo option does not care daylight savings time
    var roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    var result = (0, _constructFromMjs.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}
// Fallback for modularized imports:
exports.default = roundToNearestHours;

},{"./_lib/getRoundingMethod.mjs":"kV6yf","./constructFrom.mjs":"aoN9f","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kiDo1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ parcelHelpers.export(exports, "roundToNearestMinutes", function() {
    return roundToNearestMinutes;
});
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
var _toDateMjs = require("./toDate.mjs");
function roundToNearestMinutes(date, options) {
    var _options_nearestTo;
    var nearestTo = (_options_nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options_nearestTo !== void 0 ? _options_nearestTo : 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, _constructFromMjs.constructFrom)(date, NaN);
    var _date = (0, _toDateMjs.toDate)(date);
    var fractionalSeconds = _date.getSeconds() / 60;
    var fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    var minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    var _options_roundingMethod;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    var method = (_options_roundingMethod = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options_roundingMethod !== void 0 ? _options_roundingMethod : "round";
    var roundingMethod = (0, _getRoundingMethodMjs.getRoundingMethod)(method);
    var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    var result = (0, _constructFromMjs.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}
// Fallback for modularized imports:
exports.default = roundToNearestMinutes;

},{"./_lib/getRoundingMethod.mjs":"kV6yf","./constructFrom.mjs":"aoN9f","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j8yPy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ parcelHelpers.export(exports, "secondsToHours", function() {
    return secondsToHours;
});
var _constantsMjs = require("./constants.mjs");
function secondsToHours(seconds) {
    var hours = seconds / (0, _constantsMjs.secondsInHour);
    return Math.trunc(hours);
}
// Fallback for modularized imports:
exports.default = secondsToHours;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5zEHL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ parcelHelpers.export(exports, "secondsToMilliseconds", function() {
    return secondsToMilliseconds;
});
var _constantsMjs = require("./constants.mjs");
function secondsToMilliseconds(seconds) {
    return seconds * (0, _constantsMjs.millisecondsInSecond);
}
// Fallback for modularized imports:
exports.default = secondsToMilliseconds;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9ycfB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ parcelHelpers.export(exports, "secondsToMinutes", function() {
    return secondsToMinutes;
});
var _constantsMjs = require("./constants.mjs");
function secondsToMinutes(seconds) {
    var minutes = seconds / (0, _constantsMjs.secondsInMinute);
    return Math.trunc(minutes);
}
// Fallback for modularized imports:
exports.default = secondsToMinutes;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3vAo0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ parcelHelpers.export(exports, "set", function() {
    return set;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _setMonthMjs = require("./setMonth.mjs");
var _toDateMjs = require("./toDate.mjs");
function set(date, values) {
    var _date = (0, _toDateMjs.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, _constructFromMjs.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, _setMonthMjs.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}
// Fallback for modularized imports:
exports.default = set;

},{"./constructFrom.mjs":"aoN9f","./setMonth.mjs":"kZNby","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kZNby":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ parcelHelpers.export(exports, "setMonth", function() {
    return setMonth;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _getDaysInMonthMjs = require("./getDaysInMonth.mjs");
var _toDateMjs = require("./toDate.mjs");
function setMonth(date, month) {
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var day = _date.getDate();
    var dateWithDesiredMonth = (0, _constructFromMjs.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _getDaysInMonthMjs.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
// Fallback for modularized imports:
exports.default = setMonth;

},{"./constructFrom.mjs":"aoN9f","./getDaysInMonth.mjs":"bXxcX","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gAj5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ parcelHelpers.export(exports, "setDate", function() {
    return setDate;
});
var _toDateMjs = require("./toDate.mjs");
function setDate(date, dayOfMonth) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}
// Fallback for modularized imports:
exports.default = setDate;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"34HbC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ parcelHelpers.export(exports, "setDayOfYear", function() {
    return setDayOfYear;
});
var _toDateMjs = require("./toDate.mjs");
function setDayOfYear(date, dayOfYear) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}
// Fallback for modularized imports:
exports.default = setDayOfYear;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4G8HK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ parcelHelpers.export(exports, "setDefaultOptions", function() {
    return setDefaultOptions;
});
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function setDefaultOptions(options) {
    var result = {};
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    for(var property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(var property1 in options)if (Object.prototype.hasOwnProperty.call(options, property1)) {
        if (options[property1] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property1];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property1] = options[property1];
    }
    (0, _defaultOptionsMjs.setDefaultOptions)(result);
}
// Fallback for modularized imports:
exports.default = setDefaultOptions;

},{"./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2wGfp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ parcelHelpers.export(exports, "setHours", function() {
    return setHours;
});
var _toDateMjs = require("./toDate.mjs");
function setHours(date, hours) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setHours(hours);
    return _date;
}
// Fallback for modularized imports:
exports.default = setHours;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"c4W1y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ parcelHelpers.export(exports, "setMilliseconds", function() {
    return setMilliseconds;
});
var _toDateMjs = require("./toDate.mjs");
function setMilliseconds(date, milliseconds) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}
// Fallback for modularized imports:
exports.default = setMilliseconds;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j0ZBw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ parcelHelpers.export(exports, "setMinutes", function() {
    return setMinutes;
});
var _toDateMjs = require("./toDate.mjs");
function setMinutes(date, minutes) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}
// Fallback for modularized imports:
exports.default = setMinutes;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"D4zeu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ parcelHelpers.export(exports, "setQuarter", function() {
    return setQuarter;
});
var _setMonthMjs = require("./setMonth.mjs");
var _toDateMjs = require("./toDate.mjs");
function setQuarter(date, quarter) {
    var _date = (0, _toDateMjs.toDate)(date);
    var oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, _setMonthMjs.setMonth)(_date, _date.getMonth() + diff * 3);
}
// Fallback for modularized imports:
exports.default = setQuarter;

},{"./setMonth.mjs":"kZNby","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aCwKc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ parcelHelpers.export(exports, "setSeconds", function() {
    return setSeconds;
});
var _toDateMjs = require("./toDate.mjs");
function setSeconds(date, seconds) {
    var _date = (0, _toDateMjs.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}
// Fallback for modularized imports:
exports.default = setSeconds;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2SUSn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ parcelHelpers.export(exports, "setWeekYear", function() {
    return setWeekYear;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _startOfWeekYearMjs = require("./startOfWeekYear.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function setWeekYear(date, weekYear, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var _date = (0, _toDateMjs.toDate)(date);
    var diff = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_date, (0, _startOfWeekYearMjs.startOfWeekYear)(_date, options));
    var firstWeek = (0, _constructFromMjs.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, _startOfWeekYearMjs.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}
// Fallback for modularized imports:
exports.default = setWeekYear;

},{"./constructFrom.mjs":"aoN9f","./differenceInCalendarDays.mjs":"157c4","./startOfWeekYear.mjs":"2Mh6u","./toDate.mjs":"5c6W0","./_lib/defaultOptions.mjs":"fxdBE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ktxZI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ parcelHelpers.export(exports, "setYear", function() {
    return setYear;
});
var _constructFromMjs = require("./constructFrom.mjs");
var _toDateMjs = require("./toDate.mjs");
function setYear(date, year) {
    var _date = (0, _toDateMjs.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, _constructFromMjs.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}
// Fallback for modularized imports:
exports.default = setYear;

},{"./constructFrom.mjs":"aoN9f","./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4R7Sh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ parcelHelpers.export(exports, "startOfDecade", function() {
    return startOfDecade;
});
var _toDateMjs = require("./toDate.mjs");
function startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    var _date = (0, _toDateMjs.toDate)(date);
    var year = _date.getFullYear();
    var decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDecade;

},{"./toDate.mjs":"5c6W0","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dqjKD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfToday", function() {
    return startOfToday;
});
var _startOfDayMjs = require("./startOfDay.mjs");
function startOfToday() {
    return (0, _startOfDayMjs.startOfDay)(Date.now());
}
// Fallback for modularized imports:
exports.default = startOfToday;

},{"./startOfDay.mjs":"dAYr2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hpe9L":[function(require,module,exports) {
/**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startOfTomorrow", function() {
    return startOfTomorrow;
});
function startOfTomorrow() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}
// Fallback for modularized imports:
exports.default = startOfTomorrow;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"a41HB":[function(require,module,exports) {
/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startOfYesterday", function() {
    return startOfYesterday;
});
function startOfYesterday() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}
// Fallback for modularized imports:
exports.default = startOfYesterday;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5L8RT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ parcelHelpers.export(exports, "sub", function() {
    return sub;
});
var _subDaysMjs = require("./subDays.mjs");
var _subMonthsMjs = require("./subMonths.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function sub(date, duration) {
    var _duration_years = duration.years, years = _duration_years === void 0 ? 0 : _duration_years, _duration_months = duration.months, months = _duration_months === void 0 ? 0 : _duration_months, _duration_weeks = duration.weeks, weeks = _duration_weeks === void 0 ? 0 : _duration_weeks, _duration_days = duration.days, days = _duration_days === void 0 ? 0 : _duration_days, _duration_hours = duration.hours, hours = _duration_hours === void 0 ? 0 : _duration_hours, _duration_minutes = duration.minutes, minutes = _duration_minutes === void 0 ? 0 : _duration_minutes, _duration_seconds = duration.seconds, seconds = _duration_seconds === void 0 ? 0 : _duration_seconds;
    // Subtract years and months
    var dateWithoutMonths = (0, _subMonthsMjs.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    var dateWithoutDays = (0, _subDaysMjs.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = (0, _constructFromMjs.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}
// Fallback for modularized imports:
exports.default = sub;

},{"./subDays.mjs":"99ld1","./subMonths.mjs":"luWin","./constructFrom.mjs":"aoN9f","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"luWin":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "subMonths", function() {
    return subMonths;
});
var _addMonthsMjs = require("./addMonths.mjs");
function subMonths(date, amount) {
    return (0, _addMonthsMjs.addMonths)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subMonths;

},{"./addMonths.mjs":"7MGhe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9SMWV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ parcelHelpers.export(exports, "subBusinessDays", function() {
    return subBusinessDays;
});
var _addBusinessDaysMjs = require("./addBusinessDays.mjs");
function subBusinessDays(date, amount) {
    return (0, _addBusinessDaysMjs.addBusinessDays)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subBusinessDays;

},{"./addBusinessDays.mjs":"90wry","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5Ga3q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ parcelHelpers.export(exports, "subHours", function() {
    return subHours;
});
var _addHoursMjs = require("./addHours.mjs");
function subHours(date, amount) {
    return (0, _addHoursMjs.addHours)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subHours;

},{"./addHours.mjs":"3lB5S","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"inVDF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ parcelHelpers.export(exports, "subMilliseconds", function() {
    return subMilliseconds;
});
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
function subMilliseconds(date, amount) {
    return (0, _addMillisecondsMjs.addMilliseconds)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subMilliseconds;

},{"./addMilliseconds.mjs":"jqa9L","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fF89A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ parcelHelpers.export(exports, "subMinutes", function() {
    return subMinutes;
});
var _addMinutesMjs = require("./addMinutes.mjs");
function subMinutes(date, amount) {
    return (0, _addMinutesMjs.addMinutes)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subMinutes;

},{"./addMinutes.mjs":"EoBBG","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4fZO1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ parcelHelpers.export(exports, "subQuarters", function() {
    return subQuarters;
});
var _addQuartersMjs = require("./addQuarters.mjs");
function subQuarters(date, amount) {
    return (0, _addQuartersMjs.addQuarters)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subQuarters;

},{"./addQuarters.mjs":"9dHhj","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"269Fi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ parcelHelpers.export(exports, "subSeconds", function() {
    return subSeconds;
});
var _addSecondsMjs = require("./addSeconds.mjs");
function subSeconds(date, amount) {
    return (0, _addSecondsMjs.addSeconds)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subSeconds;

},{"./addSeconds.mjs":"f072z","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cYQHR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ parcelHelpers.export(exports, "subWeeks", function() {
    return subWeeks;
});
var _addWeeksMjs = require("./addWeeks.mjs");
function subWeeks(date, amount) {
    return (0, _addWeeksMjs.addWeeks)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subWeeks;

},{"./addWeeks.mjs":"ggWxE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iEtOp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ parcelHelpers.export(exports, "subYears", function() {
    return subYears;
});
var _addYearsMjs = require("./addYears.mjs");
function subYears(date, amount) {
    return (0, _addYearsMjs.addYears)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subYears;

},{"./addYears.mjs":"2253z","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"a7XRC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ parcelHelpers.export(exports, "weeksToDays", function() {
    return weeksToDays;
});
var _constantsMjs = require("./constants.mjs");
function weeksToDays(weeks) {
    return Math.trunc(weeks * (0, _constantsMjs.daysInWeek));
}
// Fallback for modularized imports:
exports.default = weeksToDays;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9Sgwk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ parcelHelpers.export(exports, "yearsToDays", function() {
    return yearsToDays;
});
var _constantsMjs = require("./constants.mjs");
function yearsToDays(years) {
    return Math.trunc(years * (0, _constantsMjs.daysInYear));
}
// Fallback for modularized imports:
exports.default = yearsToDays;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iGKI6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ parcelHelpers.export(exports, "yearsToMonths", function() {
    return yearsToMonths;
});
var _constantsMjs = require("./constants.mjs");
function yearsToMonths(years) {
    return Math.trunc(years * (0, _constantsMjs.monthsInYear));
}
// Fallback for modularized imports:
exports.default = yearsToMonths;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7Gp77":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ parcelHelpers.export(exports, "yearsToQuarters", function() {
    return yearsToQuarters;
});
var _constantsMjs = require("./constants.mjs");
function yearsToQuarters(years) {
    return Math.trunc(years * (0, _constantsMjs.quartersInYear));
}
// Fallback for modularized imports:
exports.default = yearsToQuarters;

},{"./constants.mjs":"dXQPO","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6bf5k":[function(require,module,exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var INFINITY = 1 / 0;
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to generate unique IDs. */ var idCounter = 0;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Built-in value references. */ var Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
}
module.exports = uniqueId;

},{"@swc/helpers/_/_type_of":"60jEQ"}],"31J95":[function() {},{}],"7hVKJ":[function() {},{}],"4HPrT":[function(require,module,exports) {
/**
 * Destinations.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _configuration = require("../js/Configuration");
var _actionMessageDisplay = require("./subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _destinationsSearchResults = require("./Destinations/DestinationsSearchResults");
var _destinationsSearchResultsDefault = parcelHelpers.interopDefault(_destinationsSearchResults);
var _destinationsSearch = require("./Destinations/DestinationsSearch");
var _destinationsSearchDefault = parcelHelpers.interopDefault(_destinationsSearch);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _createDestination = require("./Destinations/CreateDestination");
var _createDestinationDefault = parcelHelpers.interopDefault(_createDestination);
var _createVideoSet = require("./Destinations/CreateVideoSet");
var _createVideoSetDefault = parcelHelpers.interopDefault(_createVideoSet);
var _destinationsAddNew = require("./Destinations/DestinationsAddNew");
var _destinationsAddNewDefault = parcelHelpers.interopDefault(_destinationsAddNew);
var _destinationsRenameTrigger = require("./Destinations/DestinationsRenameTrigger");
var _destinationsRenameTriggerDefault = parcelHelpers.interopDefault(_destinationsRenameTrigger);
var _destinationsRename = require("./Destinations/DestinationsRename");
var _destinationsRenameDefault = parcelHelpers.interopDefault(_destinationsRename);
var _utilities = require("../js/Utilities");
var _destinationsUtils = require("../actions/DestinationsUtils");
var _destinationsCss = require("./Destinations/css/Destinations.css");
var Destinations = function(param) {
    var project = param.project, history = param.history;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        loading: false,
        active: false,
        results: [],
        keyword: ""
    }), 2), search = _useState1[0], setSearch = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({
        list: [],
        withinactives: false,
        renaming: {
            destination: "",
            value: ""
        }
    }), 2), destinations = _useState2[0], setDestinations = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(null), 2), create = _useState3[0], setCreate = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)({
        create: null,
        value: "",
        destination: null
    }), 2), createVidset = _useState4[0], setCreateVidSet = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)({
        value: "",
        destination: {
            dID: "",
            dName: ""
        }
    }), 2), videoset = _useState5[0], setVideoset = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({
        mode: "success",
        message: "",
        hidden: true
    }), 2), remove = _useState6[0], setRemove = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)([]), 2), episodes = _useState7[0], setEpisodes = _useState7[1];
    var canAdmin = (0, _utilities.isAdmin)(project);
    var cdRef = (0, _react.useRef)(null);
    var cvsRef = (0, _react.useRef)(null);
    var renameRef = (0, _react.useRef)(null);
    var onPopState = function(domEvent) {
        domEvent.preventDefault();
        var pars = new URLSearchParams(window.locationsearch);
        if (!pars.get("q")) return;
        /*
     * If the length of the q parameter is less than or equal to the length of
     * the current keyword being searched, assume this is a back button operation
     * and replace the last item in the browser history.
     */ if (pars.get("q").length <= search.keyword.length) {
            window.history.replaceState({}, "Destinations", "/destinations");
            // Reset search object.
            onResetSearch();
        }
    };
    (0, _react.useEffect)(function() {
        if (!destinations.list.length) (0, _destinationsUtils.getDestinations)(onDestinationsLoaded);
    }, [
        destinations
    ]);
    var onDestinationsLoaded = function(response) {
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            list: response
        }));
        setLoading(false);
    };
    var onInactivesChange = function(domEvent) {
        var checked = domEvent.target.checked;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            withinactives: +checked,
            list: []
        }));
    };
    var onRestore = function(domEvent) {
        domEvent.preventDefault();
        var setId = domEvent.target.elements.id.value;
        (0, _destinationsUtils.restoreVideoSet)(setId, onRestoreAfter);
    };
    var onRestoreAfter = function(value) {
        if (search.keyword) onSearchDestinations();
        else (0, _destinationsUtils.getDestinations)(onDestinationsLoaded, false, value);
    };
    var showCreate = function() {
        var button = null;
        if (canAdmin) button = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: "btn btn--action",
            onClick: onCreateOpen,
            "data-action": "create",
            children: "Create New Destination"
        });
        return button;
    };
    var showDelete = function(item) {
        var button = null;
        if (canAdmin) button = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "btn btn--destructive",
            "data-destinationid": item.dID,
            onClick: onDelete,
            children: [
                "Delete",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "form__access__label",
                    children: [
                        "to ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                            children: item.dName
                        })
                    ]
                })
            ]
        });
        return button;
    };
    var showRename = function(item) {
        var button = null;
        if (canAdmin) button = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsRenameTriggerDefault.default), (0, _objectSpread._)({
            onClick: onRenameOpen
        }, item));
        return button;
    };
    var buildLinks = function(resp) {
        // If there's something in the search field, assume this is a search and clear
        // links.
        if (search.keyword) return;
        if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: loading
        });
        var dests = destinations.list.map(function(item) {
            var css = item.hasOwnProperty("isNew") ? "destinations__list__new" : "";
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                className: css,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: {
                                pathname: "/destinations/videosets/".concat(item.dID),
                                state: {
                                    destination: item.dName
                                }
                            },
                            children: item.dName
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                        className: "button__group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsAddNewDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                                onClick: onCreateVidsetOpen
                            })),
                            showRename(item),
                            showDelete(item)
                        ]
                    })
                ]
            }, "destination_".concat(item.dID));
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "destinations__list",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: "Actions"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: dests
                })
            ]
        });
    };
    var makeSearchResults = function() {
        var results;
        if (!search.keyword) return;
        if (search.loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: search.loading
        });
        if (!!search.results.length) results = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsSearchResultsDefault.default), {
            keyword: search.keyword,
            results: search.results,
            onRestore: onRestore,
            isAdmin: canAdmin
        });
        else results = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
            children: (0, _configuration.GENERIC_NO_RESULTS)
        });
        return results;
    };
    var handleSearchResponse = function(response) {
        var res = [
            false
        ];
        if (response.length) res = response;
        setSearch((0, _objectSpreadProps._)((0, _objectSpread._)({}, search), {
            loading: false,
            results: res
        }));
    };
    var onResetSearch = function() {
        setSearch({
            loading: false,
            active: false,
            results: [],
            keyword: ""
        });
    };
    var duplicate = function(id) {
        (0, _destinationsUtils.duplicatePlaylist)(id, function(data) {
            props.history.push("/destinations/playlist/".concat(data), {
                is_dupe: true
            });
        });
    };
    var onSearchChange = function(domEvent) {
        var value = domEvent.target.value;
        var history = window.history;
        history.pushState({
            "activeKeyword": value
        }, "search", "?q=".concat(value));
        setSearch((0, _objectSpreadProps._)((0, _objectSpread._)({}, search), {
            loading: true,
            keyword: value
        }));
    };
    var getSearchResults = function() {
        var fd = new FormData();
        fd.set("q", search.keyword.trim());
        fd.set("token", (0, _utilities.getAuthData)("token"));
        if (destinations.withinactives) fd.set("inactives", 1);
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_SEARCH), {
            body: fd
        }, handleSearchResponse);
    };
    var onSearchDestinations = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (domEvent) domEvent.preventDefault();
        window.history.pushState({
            "activeKeyword": search.keyword
        }, "search", "?q=".concat(search.keyword));
        getSearchResults();
    };
    var onSearchFocus = function() {
        window.history.pushState({}, "search", "?q=");
    };
    var onResetEpisodes = function(domEvent) {
        setEpisodes([]);
    };
    var onCreateChange = function(domEvent) {
        var value = domEvent.target.value;
        var form = domEvent.target.form;
        var key;
        var current;
        switch(form){
            case "destination_create_vidset":
                key = "videoset";
                setVideoset((0, _objectSpreadProps._)((0, _objectSpread._)({}, videoset), {
                    value: value
                }));
                break;
            default:
                key = "create";
                setCreate(value);
        }
    };
    var onCreateSave = function(domEvent) {
        domEvent.preventDefault();
        var callback;
        var endpoint;
        switch(domEvent.target.id){
            case "destination_create_vidset":
                callback = function(response) {
                    onCreateVidsetResponse(response);
                };
                endpoint = (0, _configuration.API_VIDEOSET_ADDNEW);
                break;
            default:
                callback = function(response) {
                    onCreateDestinationResponse(response);
                };
                endpoint = (0, _configuration.API_DESTINATIONS_ADDNEW);
        }
        var fd = new FormData(domEvent.target);
        (0, _utilities.apirequest)(endpoint, {
            body: fd
        }, callback);
    };
    var onCreateDestinationSave = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_ADDNEW), {
            body: fd
        }, onCreateDestinationResponse);
    };
    var onCreateDestinationClose = function(domEvent) {
        setCreate("");
        if (cdRef.current) cdRef.current.close();
    };
    var onCreateDestinationResponse = function(response) {
        var new_destination = [
            {
                dID: response.d_id,
                dName: response.d_name,
                isNew: true
            }
        ];
        setCreate("");
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            list: new_destination.concat((0, _toConsumableArray._)(destinations.list))
        }));
        if (cdRef.current) cdRef.current.close();
    };
    var onCreateVidsetResponse = function(response) {
        if (response.result !== "success") {
            setRemove((0, _objectSpreadProps._)((0, _objectSpread._)({}, remove), {
                mode: "failed",
                message: (0, _configuration.MESSAGE_ERROR_GENERAL),
                hidden: false
            }));
            return;
        }
        setVideoset((0, _objectSpreadProps._)((0, _objectSpread._)({}, videoset), {
            value: ""
        }));
        setRemove((0, _objectSpreadProps._)((0, _objectSpread._)({}, remove), {
            mode: "success",
            message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: response.setName
                    }),
                    " was added to ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: response.destination
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: {
                            pathname: "/destinations/rundates/".concat(response.setID),
                            state: {
                                destination: response.setName
                            }
                        },
                        children: "View"
                    })
                ]
            }),
            hidden: false
        }));
    };
    var onCreateVidsetClose = function(dialogRef) {
        setVideoset({
            value: "",
            destination: {
                dID: "",
                dName: ""
            }
        });
        if (cvsRef.current) cvsRef.current.close();
    };
    var onCreateOpen = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (!domEvent) return;
        if (cdRef && cdRef.current) cdRef.current.showModal();
    };
    var onCreateVidsetOpen = function(domEvent) {
        var _domEvent_target_dataset = domEvent.target.dataset, action = _domEvent_target_dataset.action, destinationid = _domEvent_target_dataset.destinationid;
        var destination = null;
        if (destinationid) destination = (0, _destinationsUtils.findDestinationById)(destinations.list, destinationid);
        setVideoset((0, _objectSpreadProps._)((0, _objectSpread._)({}, videoset), {
            destination: destination
        }));
        if (cvsRef && cvsRef.current) cvsRef.current.showModal();
    };
    var onDelete = function(domEvent) {
        var destinationid = domEvent.target.dataset.destinationid;
        var toDelete = (0, _destinationsUtils.findDestinationById)(destinations.list, destinationid);
        var destName = (0, _configuration.MESSAGE_DESTINATION_DELETE_UNNAMED);
        if (toDelete.hasOwnProperty("dName") && (toDelete === null || toDelete === void 0 ? void 0 : toDelete.dName)) destName = toDelete.dName.toUpperCase();
        var confirm = window.confirm((0, _utilities.formatString)((0, _configuration.MESSAGE_DESTINATION_DELETE_CONFIRM), [
            destName
        ]));
        if (!confirm) return;
        setLoading(true);
        onDeleteSubmit(toDelete);
    };
    var onDeleteSubmit = function(destObj) {
        var dID = destObj.dID, dName = destObj.dName;
        (0, _destinationsUtils.deleteDestination)(destObj.dID, function(response) {
            var msg = (0, _configuration.MESSAGE_ERROR_GENERAL);
            if (response.result === "success") msg = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: destObj.dName
                    }),
                    " ",
                    (0, _configuration.MESSAGE_DESTINATION_DELETED).replace(/%s\s/, " ")
                ]
            });
            setLoading(false);
            setRemove((0, _objectSpreadProps._)((0, _objectSpread._)({}, remove), {
                mode: response.result,
                message: msg,
                hidden: false
            }));
            setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
                list: []
            }));
        });
    };
    var onDeleteComplete = function() {
        (0, _destinationsUtils.getDestinations)(onDestinationsLoaded);
    };
    var onCloseMessage = function() {
        setRemove((0, _objectSpreadProps._)((0, _objectSpread._)({}, remove), {
            hidden: true,
            message: "",
            mode: "success"
        }));
    };
    var onRenameOpen = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (!domEvent) return;
        var destinationid = domEvent.target.dataset.destinationid;
        var dest = (0, _destinationsUtils.findDestinationById)(destinations.list, destinationid);
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            renaming: (0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
                destination: dest
            })
        }));
        if (renameRef.current) renameRef.current.showModal();
    };
    var onRenameClose = function() {
        if (renameRef.current) renameRef.current.close();
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            renaming: (0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations.renaming), {
                value: "",
                destination: ""
            })
        }));
    };
    var onRenameChange = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (!domEvent) return;
        var value = domEvent.target.value;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            renaming: (0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations.renaming), {
                value: value
            })
        }));
    };
    var onRenameSave = function(domEvent) {
        var dialogRef = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", destinations.renaming.destination.dID);
        fd.set("name", destinations.renaming.value);
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_RENAME), {
            body: fd
        }, function(response) {
            if (!response.result) return;
            var list = destinations.list;
            dlist = (0, _toConsumableArray._)(list);
            var id = response.id, destination = response.destination;
            var index = dlist.findIndex(function(d) {
                return +d.dID === +id;
            });
            dlist[index]["dName"] = destination;
            setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
                list: dlist
            }));
            onRenameClose();
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        className: "stations__view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                id: "destination__header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Destinations"
                    }),
                    showCreate()
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsSearchDefault.default), {
                isAdmin: canAdmin,
                value: search.keyword,
                onSubmit: onSearchDestinations,
                onChange: onSearchChange,
                onFocus: onSearchFocus,
                onReset: onResetSearch,
                onInactiveChange: onInactivesChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
                hidden: remove.hidden,
                message: remove.message,
                mode: remove.mode,
                onClose: onCloseMessage
            }),
            buildLinks(),
            makeSearchResults(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createDestinationDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
                modalRef: cdRef,
                onSubmit: onCreateSave,
                onChange: onCreateChange,
                onClose: onCreateDestinationClose
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createVideoSetDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, videoset), {
                modalRef: cvsRef,
                onClose: onCreateVidsetClose,
                onSubmit: onCreateSave,
                onChange: onCreateChange
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsRenameDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations.renaming), {
                modalRef: renameRef,
                onClose: onRenameClose,
                onSubmit: onRenameSave,
                onChange: onRenameChange
            }))
        ]
    });
};
exports.default = Destinations;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","../js/Configuration":"k3dur","./subcomponents/ActionMessageDisplay":"bzcdY","./Destinations/DestinationsSearchResults":"3tZ3c","./Destinations/DestinationsSearch":"3zQpu","./subcomponents/LoaderSimple":"1dSHa","./Destinations/CreateDestination":"lNbwg","./Destinations/CreateVideoSet":"d8O2E","./Destinations/DestinationsAddNew":"cxMjh","./Destinations/DestinationsRenameTrigger":"8z10O","./Destinations/DestinationsRename":"gQSMg","../js/Utilities":"euxcI","../actions/DestinationsUtils":"5X8UE","./Destinations/css/Destinations.css":"46DcG","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bzcdY":[function(require,module,exports) {
/**
 * ActionMessageDisplay.js
 * Displays a success or failure message.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _actionMessageDisplayCss = require("./css/ActionMessageDisplay.css");
var ActionMessageDisplay = function(param) {
    var mode = param.mode, _param_hidden = param.hidden, hidden = _param_hidden === void 0 ? true : _param_hidden, _param_message = param.message, message = _param_message === void 0 ? null : _param_message, _param_onClose = param.onClose, onClose = _param_onClose === void 0 ? null : _param_onClose, _param_className = param.className, className = _param_className === void 0 ? null : _param_className;
    var onCloseHandler = function() {
        if (onClose) onClose();
    };
    var htmlOrObject = function() {
        var msg;
        if (typeof message === "string") msg = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: message
            }
        });
        else msg = message;
        return msg;
    };
    var cssClass = (0, _classnamesDefault.default)({
        "action__message": true,
        "action__message--success": mode === "success",
        "action__message--failure": mode === "failed"
    }, className);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: cssClass,
        hidden: hidden,
        children: [
            htmlOrObject(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                onClick: onCloseHandler,
                hidden: !onClose,
                children: "\xd7"
            })
        ]
    });
};
ActionMessageDisplay.propTypes = {
    mode: (0, _propTypesDefault.default).oneOf([
        "success",
        "failed"
    ]),
    hidden: (0, _propTypesDefault.default).bool.isRequired,
    message: (0, _propTypesDefault.default).any,
    onClose: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string
};
exports.default = ActionMessageDisplay;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","./css/ActionMessageDisplay.css":"4S3Ub","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4S3Ub":[function() {},{}],"3tZ3c":[function(require,module,exports) {
/**
 * DestinationsSearchResults
 * Display table data for the stations series.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _destinationsRestoreSet = require("./DestinationsRestoreSet");
var _destinationsSearchResultsCss = require("./css/DestinationsSearchResults.css");
var DestinationsSearchResults = function(param) {
    var keyword = param.keyword, results = param.results, onDuplicate = param.onDuplicate, onRestore = param.onRestore, _param_isAdmin = param.isAdmin, isAdmin = _param_isAdmin === void 0 ? false : _param_isAdmin;
    var makeTitle = function() {
        var tle = null;
        if (keyword) tle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
            children: [
                "Video sets matching ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                    children: keyword
                })
            ]
        });
        return tle;
    };
    var makeLink = function(item) {
        var id = item.id, video_set_name = item.video_set_name;
        var stateobj = {
            title: video_set_name
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: {
                pathname: "/destinations/rundates/".concat(id),
                state: stateobj
            },
            children: video_set_name
        });
    };
    var makeControls = function(item) {
        var id = item.id, video_set_name = item.video_set_name, isActive = item.isActive;
        var stateobj = {
            title: video_set_name
        };
        var link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: {
                pathname: "/destinations/rundates/".concat(item.id),
                state: stateobj
            },
            className: "btn btn-sm btn--action",
            children: "View / Edit"
        });
        if (isActive == false && isAdmin) link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsRestoreSet.DestinationsRestoreSet), {
            id: id,
            onSubmit: onRestore
        });
        return link;
    };
    var makeResultGroup = function() {
        var groups = null;
        if (!results) return [];
        groups = results.map(function(item, index) {
            var body = null;
            if (Object.hasOwn(item, "sets")) {
                var sets = item.sets;
                var rows = sets.map(function(trd, idx) {
                    var id = trd.id, isActive = trd.isActive, video_set_name = trd.video_set_name;
                    var stateobj = {
                        title: video_set_name
                    };
                    var showRestore = isActive == false && isAdmin;
                    var rows = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: {
                                        pathname: "/destinations/rundates/".concat(id),
                                        state: stateobj
                                    },
                                    children: video_set_name
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: {
                                            pathname: "/destinations/rundates/".concat(id),
                                            state: stateobj
                                        },
                                        className: "btn btn-sm btn--action",
                                        children: "View / Edit"
                                    }),
                                    showRestore && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsRestoreSet.DestinationsRestoreSet), {
                                        id: id,
                                        onSubmit: onRestore
                                    })
                                ]
                            })
                        ]
                    });
                    return rows;
                });
                body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: rows
                    })
                });
                // Return the group.
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "destination__search_videosets",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            children: item.title
                        }),
                        body
                    ]
                }, index);
            }
        });
        //console.log(sets)
        return groups;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "DestinationSearchResults",
        children: [
            makeTitle(),
            makeResultGroup()
        ]
    });
};
exports.default = DestinationsSearchResults;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./DestinationsRestoreSet":"2OSxm","./css/DestinationsSearchResults.css":"l4ouf","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2OSxm":[function(require,module,exports) {
/**
 * DestinationsRestoreSet.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DestinationsRestoreSet", function() {
    return DestinationsRestoreSet;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var DestinationsRestoreSet = function(props) {
    var uniq = (0, _lodashUniqueidDefault.default)("DestinationsRestoreSet_");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: props.onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                id: uniq,
                name: "id",
                value: props.id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "btn btn-sm btn--restore",
                children: "Restore"
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","lodash.uniqueid":"6bf5k","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"l4ouf":[function() {},{}],"3zQpu":[function(require,module,exports) {
/**
 * DestinationsSearch
 * Displays playlist URL and comments form fields.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _destinationsSearchCss = require("./css/DestinationsSearch.css");
var _destinationsIncludeInactive = require("./DestinationsIncludeInactive");
var DestinationsSearch = function(param) {
    var value = param.value, onChange = param.onChange, onFocus = param.onFocus, onSubmit = param.onSubmit, onReset = param.onReset, onInactiveChange = param.onInactiveChange, _param_isAdmin = param.isAdmin, isAdmin = _param_isAdmin === void 0 ? false : _param_isAdmin;
    var showIncludeInactive = null;
    if (isAdmin) showIncludeInactive = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsIncludeInactive.DestinationsIncludeInactive), {
        onChange: onInactiveChange
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        method: "dialog",
        id: "DestinationsSearch",
        onSubmit: onSubmit,
        onReset: onReset,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "q",
                children: "Search for a Video Set"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "form__input_button_group",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "search",
                            id: "q",
                            name: "q",
                            value: value,
                            onChange: onChange,
                            "aria-describedby": "DestinationsSearch__hint",
                            autoComplete: "off",
                            onFocus: onFocus
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn--action",
                            children: "Search"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        id: "DestinationsSearch__hint",
                        className: "aria__description",
                        children: [
                            "Add quotes around phrases for better results, (e.g. ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: '"world cup"'
                            }),
                            " instead of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "world cup"
                            }),
                            ".)"
                        ]
                    }),
                    showIncludeInactive
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "reset",
                className: "trigger__fauxlink",
                disabled: !value.length,
                children: "Return to Destinations list"
            })
        ]
    });
};
exports.default = DestinationsSearch;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/DestinationsSearch.css":"dOvMr","./DestinationsIncludeInactive":"wk9pz","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dOvMr":[function() {},{}],"wk9pz":[function(require,module,exports) {
/**
 * DestinationsIncludeInactive.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DestinationsIncludeInactive", function() {
    return DestinationsIncludeInactive;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _destinationsIncludeInactiveCss = require("./css/DestinationsIncludeInactive.css");
var DestinationsIncludeInactive = function(param) {
    var _param_checked = param.checked, checked = _param_checked === void 0 ? false : _param_checked, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? null : _param_onChange;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        id: "DestinationsIncludeInactive",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                defaultChecked: checked,
                name: "DestinationsIncludeInactive__toggle",
                id: "DestinationsIncludeInactive__toggle",
                value: "1",
                onChange: onChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "DestinationsIncludeInactive__toggle",
                children: "Include deleted video sets?"
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./css/DestinationsIncludeInactive.css":"1PbQF","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1PbQF":[function() {},{}],"lNbwg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeButton = require("../subcomponents/CloseButton");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _textInputControlled = require("../subcomponents/TextInputControlled");
var _textInputControlledDefault = parcelHelpers.interopDefault(_textInputControlled);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var CreateDestination = function(param) {
    var modalRef = param.modalRef, create = param.create, destination = param.destination, onChange = param.onChange, onClose = param.onClose, onSubmit = param.onSubmit, value = param.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "DestinationsCreateNew",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Create a New Destination"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: onSubmit,
                id: "destination_create_new",
                action: (0, _configuration.API_DESTINATIONS_ADDNEW),
                method: "POST",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "token",
                        value: (0, _utilities.getAuthData)("token"),
                        onChange: function() {}
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputControlledDefault.default), {
                        cssClass: "destinations__create-new",
                        labelText: "Enter the name for this destination",
                        name: "name",
                        maxLength: "50",
                        isRequired: true,
                        onInputHandler: onChange,
                        value: value
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        children: "Save"
                    })
                ]
            })
        ]
    });
};
exports.default = CreateDestination;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/CloseButton":"3MmmO","prop-types":"fUIWk","../subcomponents/TextInputControlled":"l2yII","../subcomponents/ModalDialog":"72kji","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"l2yII":[function(require,module,exports) {
/**
 * TextInput.jsx
 * A no-framework text input 
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var TextInput = function(param) {
    var onInputHandler = param.onInputHandler, value = param.value, name = param.name, id = param.id, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_datalist = param.datalist, datalist = _param_datalist === void 0 ? [] : _param_datalist, _param_isRequired = param.isRequired, isRequired = _param_isRequired === void 0 ? false : _param_isRequired, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "Add label text" : _param_labelText, _param_ariaDescribedBy = param.ariaDescribedBy, ariaDescribedBy = _param_ariaDescribedBy === void 0 ? "" : _param_ariaDescribedBy;
    var cssClasses = (0, _classnamesDefault.default)("input-text", cssClass);
    var fieldId = id || name;
    var dataList = null, dataListAttr = null;
    var makeDataList = function(arrayOfOptions) {
        return arrayOfOptions.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: item.title
            }, index.toString());
        });
    };
    if (datalist === null || datalist === void 0 ? void 0 : datalist.length) {
        dataListAttr = "".concat(id, "_dl");
        dataList = /*#__PURE__*/ (0, _jsxRuntime.jsx)("datalist", {
            id: dataListAttr,
            children: makeDataList(datalist)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: labelText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "text",
                name: name,
                id: fieldId,
                list: dataListAttr,
                onChange: onInputHandler,
                value: value,
                required: isRequired,
                "aria-describedby": ariaDescribedBy
            }),
            dataList
        ]
    });
};
exports.default = TextInput;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"d8O2E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _closeButton = require("../subcomponents/CloseButton");
var _textInput = require("../subcomponents/TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var CreateVideoSet = function(param) {
    var destination = param.destination, value = param.value, modalRef = param.modalRef, onClose = param.onClose, onChange = param.onChange, onSubmit = param.onSubmit;
    var dName = destination.dName, dID = destination.dID;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "DestinationsCreateNewVidset",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                children: [
                    "Create a new videoset in ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: dName
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: onSubmit,
                id: "destination_create_vidset",
                action: (0, _configuration.API_VIDEOSET_ADDNEW),
                method: "POST",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "token",
                        value: (0, _utilities.getAuthData)("token")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "destination",
                        value: dID
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form__label_btn_group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                                cssClass: "destinations__create-new",
                                labelText: "Enter the name for this video set",
                                name: "name",
                                id: "create",
                                maxLength: "50",
                                isRequired: true,
                                onInputHandler: onChange,
                                value: value
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "btn btn--action",
                                children: "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = CreateVideoSet;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/CloseButton":"3MmmO","../subcomponents/TextInput":"327SP","../subcomponents/ModalDialog":"72kji","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cxMjh":[function(require,module,exports) {
/**
 * DestinationsAddNew.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DestinationsAddNew = function(param) {
    var dID = param.dID, dName = param.dName, onClick = param.onClick;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        type: "button",
        className: "btn btn--action",
        "data-action": "videoset",
        "data-destinationid": dID,
        onClick: onClick,
        children: [
            "Add New Video Set",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "form__access__label",
                children: [
                    "to ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: dName
                    })
                ]
            })
        ]
    });
};
exports.default = DestinationsAddNew;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8z10O":[function(require,module,exports) {
/**
 * DestinationsRenameTrigger.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DestinationsRenameTrigger = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        type: "button",
        className: "btn btn--action",
        "data-action": "videoset",
        "data-destinationid": props.dID,
        onClick: props.onClick,
        children: [
            "Rename ",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "form__access__label",
                children: [
                    "to ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: props.dName
                    })
                ]
            })
        ]
    });
};
exports.default = DestinationsRenameTrigger;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gQSMg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _closeButton = require("../subcomponents/CloseButton");
var _textInputControlled = require("../subcomponents/TextInputControlled");
var _textInputControlledDefault = parcelHelpers.interopDefault(_textInputControlled);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var DestinationsRename = function(param) {
    var modalRef = param.modalRef, destination = param.destination, value = param.value, onChange = param.onChange, onSubmit = param.onSubmit, onClose = param.onClose;
    var dID = destination.dID, dName = destination.dName;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "DestinationsRename",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                children: [
                    "Rename ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: dName
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: onSubmit,
                id: "destination_create_vidset",
                action: (0, _configuration.API_VIDEOSET_ADDNEW),
                method: "POST",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "token",
                        value: (0, _utilities.getAuthData)("token")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "destination",
                        value: dID || "",
                        onChange: function() {}
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form__label_btn_group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputControlledDefault.default), {
                                cssClass: "destinations__create-new",
                                labelText: "Enter the new name for this destination",
                                name: "name",
                                id: "create",
                                maxLength: "50",
                                onInputHandler: onChange,
                                value: value || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "btn btn--action",
                                children: "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = DestinationsRename;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/CloseButton":"3MmmO","../subcomponents/TextInputControlled":"l2yII","../subcomponents/ModalDialog":"72kji","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"46DcG":[function() {},{}],"1MWQ0":[function(require,module,exports) {
/**
 * DestinationVideoSets.js
 * View of videosets for an individual destination
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dateFns = require("date-fns");
var _reactRouterDom = require("react-router-dom");
var _actionMessageDisplay = require("../subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _breadcrumb = require("../subcomponents/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _createVideoSet = require("./CreateVideoSet");
var _createVideoSetDefault = parcelHelpers.interopDefault(_createVideoSet);
var _editVideoSet = require("./EditVideoSet");
var _editVideoSetDefault = parcelHelpers.interopDefault(_editVideoSet);
var _paginationBar = require("../subcomponents/PaginationBar");
var _paginationBarDefault = parcelHelpers.interopDefault(_paginationBar);
var _selectPerPage = require("../subcomponents/SelectPerPage");
var _selectPerPageDefault = parcelHelpers.interopDefault(_selectPerPage);
var _destinationsVideoSetsToggleSort = require("./DestinationsVideoSetsToggleSort");
var _destinationsIncludeInactive = require("./DestinationsIncludeInactive");
var _destinationsRestoreSet = require("./DestinationsRestoreSet");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _destinationsUtils = require("../../actions/DestinationsUtils");
var _destinationVideoSetsUtils = require("../../actions/DestinationVideoSetsUtils");
var _paginationBarUtils = require("../../actions/PaginationBarUtils");
var _destinationVideoSetsCss = require("./css/DestinationVideoSets.css");
var DestinationVideoSets = function(param) {
    var params = param.params, history = param.history;
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _destinationVideoSetsUtils.initPaginationState)), 2), pagination = _useState[0], setPagination = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), breadcrumbs = _useState1[0], setBreadcrumbs = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)({
        open: false,
        value: "",
        destination: {
            dName: "",
            dID: ""
        }
    }), 2), create = _useState3[0], setCreate = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)({
        hidden: true,
        message: "",
        mode: "failed"
    }), 2), postCreate = _useState4[0], setPostCreate = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)({
        setList: [],
        withinactives: false
    }), 2), destinations = _useState5[0], setDestinations = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({
        item: "",
        value: ""
    }), 2), edit = _useState6[0], setEdit = _useState6[1];
    var fetchcancelqueue = [];
    var createVSRef = (0, _react.useRef)(null);
    var editModalRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        if (!destinations.setList.length) getDestinationInfo();
        return function() {
            fetchcancelqueue.forEach(function(ac) {
                ac.abort();
            });
        };
    }, [
        destinations
    ]);
    var findCurrent = function(id) {
        return destinations.setList.findIndex(function(item) {
            return item.setID == id;
        });
    };
    var getDestinationInfo = function() {
        var fd = new FormData();
        fd.set("id", params.id);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        if (pagination.perPage) fd.set("perPage", pagination.perPage);
        if (pagination.page) fd.set("page", pagination.page);
        fd.set("inactives", +destinations.withinactives);
        fd.set("sort", _getSortValue(+pagination.sort));
        fd.set("ascending", pagination.ascending);
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_INFO), {
            body: fd
        }, function(response) {
            setDestinations((0, _objectSpread._)({}, destinations, response));
            setLoading(false);
            setPagination((0, _objectSpread._)({}, pagination, response.sets));
        });
    };
    var getRunDateForSet = function(videosetID) {
        var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!videosetID) throw new Error("No video set ID was passed.");
        // Check if we've already fetched a list of blocks. If so, just show what we have.
        var videoSet = (0, _objectSpread._)({}, destinations).setList.find(function(vs) {
            return vs.setID == videosetID;
        });
        if (videoSet.hasOwnProperty("blockList")) {
            callback((0, _toConsumableArray._)(videoSet.blockList));
            return;
        }
        fetchcancelqueue[videosetID] = new AbortController();
        var signal = fetchcancelqueue[videosetID].signal;
        var fd = new FormData();
        fd.set("id", videosetID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ASSIGNMENTS), {
            body: fd,
            signal: signal
        }, callback);
    };
    var onCloseMessage = function(domEvent) {
        setPostCreate({
            hidden: true,
            message: "",
            mode: "failed"
        });
    };
    var onTogglePanel = function(domEvent) {
        var id = domEvent.currentTarget.dataset.id;
        // Finds the index of the toggled-open panel.
        var index = findCurrent(id);
        var setList = destinations.setList;
        var sl = (0, _toConsumableArray._)(setList);
        getRunDateForSet(id, function(response) {
            // console.log(response)
            sl[index] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, sl[index]), {
                loading: false,
                blockList: response
            });
            setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
                setList: sl
            }));
        });
    };
    var onInactivesChange = function(domEvent) {
        var checked = domEvent.target.checked;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            withinactives: +checked,
            setList: []
        }));
    };
    var makeASet = function(videoset) {
        var plural = videoset.count > 1 ? "s" : "";
        var body = null;
        var action;
        if (videoset.hasOwnProperty("blockList") && !videoset.loading) {
            var dates = videoset.blockList.map(makeASetDates);
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "videosets__list",
                children: dates
            });
        } else body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true,
            className: "videoset__rundates__loader"
        });
        var vs;
        // videoset.activecomes in as a string. Use + to convert it to an integer.
        if (videoset.hasOwnProperty("active") && +videoset.active) vs = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
            className: "videoset__rundates",
            onClick: onTogglePanel,
            "data-id": videoset.setID,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                        className: "videoset__rundates__title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                children: [
                                    "".concat(videoset.setName, " "),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "videoset__rundates__count",
                                        children: [
                                            "(",
                                            videoset.count,
                                            " playlist",
                                            plural,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "videoset__edittitle trigger__fauxlink",
                                "data-videoset": videoset.setID,
                                onClick: onEditVidsetOpen,
                                children: "Edit title"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn btn-sm btn--destructive",
                                "data-videoset": videoset.setID,
                                onClick: onDeleteSet,
                                children: "Delete video set"
                            })
                        ]
                    })
                }),
                body
            ]
        }, "vs_".concat(videoset.setID));
        else vs = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "videoset__rundates",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        className: "videoset__rundates__title",
                        children: videoset.setName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsRestoreSet.DestinationsRestoreSet), {
                        id: videoset.setID,
                        onSubmit: onRestore
                    })
                ]
            })
        }, "vs_".concat(videoset.setID));
        return vs;
    };
    var makeASetDates = function(item) {
        var datetxt = !item.vsb_datetimetorun || item.vsb_datetimetorun === "0000-00-00" ? (0, _configuration.NULL_DATE_TEXT_STATIONS) : (0, _dateFns.format)(new Date("".concat(item.vsb_datetimetorun, "T00:00:00")), "PP");
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/destinations/playlist/".concat(item.vsb_id),
                    children: datetxt
                }),
                " ",
                (0, _utilities.getDuration)(item.duration)
            ]
        }, item.vsb_id);
    };
    var makeSets = function() {
        var vsets = Object.values(destinations.setList);
        var rundates;
        if (loading === false && !vsets.length) rundates = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
            children: (0, _configuration.MESSAGE_DESTINATION_NOVIDEOSETS)
        });
        else rundates = vsets.map(makeASet);
        return rundates;
    };
    var makeBreadcrumbs = function() {
        var crumbs = [
            {
                path: "/destinations",
                label: "Destinations",
                state: {}
            }
        ];
        var lastCrumb = [
            {
                label: ""
            }
        ];
        if (destinations.hasOwnProperty("dName")) lastCrumb = [
            {
                label: destinations.dName,
                state: {}
            }
        ];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbDefault.default), {
            items: crumbs.concat(lastCrumb),
            ariaLabel: "Destinations navigation"
        });
    };
    var makePagination = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "videosets__pagination",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPerPageDefault.default), {
                    id: "VideoSetsPerPage",
                    value: pagination.perPage,
                    onChangeHandler: onPerPageSelect,
                    options: [
                        "View All|-1",
                        15,
                        30,
                        50,
                        75,
                        100
                    ],
                    replace: true,
                    cssClass: "VideoSetsPerPage__select"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationBarDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
                    onClickHandler: getPage
                }))
            ]
        });
    };
    var onPerPageSelect = function(domEvent) {
        var value = domEvent.target.value;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            setList: []
        }));
        setPagination((0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
            perPage: +value
        }));
    };
    var getPage = function(domEvent) {
        var value = domEvent.target.value;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            setList: []
        }));
        setPagination((0, _paginationBarUtils.setPageState)(pagination, value));
    };
    var onCreateVidsetClose = function() {
        if (createVSRef.current) createVSRef.current.close();
        setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
            destination: {
                dID: "",
                dName: ""
            },
            value: ""
        }));
    };
    var onCreateVidsetOpen = function() {
        setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
            destination: (0, _objectSpreadProps._)((0, _objectSpread._)({}, create.destination), {
                dID: params.id,
                dName: destinations.dName
            })
        }));
        if (createVSRef.current) createVSRef.current.showModal();
    };
    var onCreateChange = function(domEvent) {
        var _domEvent_target = domEvent.target, id = _domEvent_target.id, value = _domEvent_target.value;
        setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
            value: value
        }));
    };
    var onCreateSave = function(domEvent) {
        domEvent.preventDefault();
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            setList: []
        }));
        var fd = new FormData(domEvent.target);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ADDNEW), {
            body: fd
        }, function(response) {
            setPostCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, postCreate), {
                hidden: false,
                message: response.message,
                mode: response.result
            }));
            if (createVSRef.current) createVSRef.current.close();
        });
    };
    var onEditVidsetOpen = function(domEvent) {
        var setList = destinations.setList;
        var videoset = domEvent.target.dataset.videoset;
        var which = setList.find(function(vs) {
            return videoset == vs.setID;
        });
        setEdit((0, _objectSpreadProps._)((0, _objectSpread._)({}, edit), {
            item: videoset,
            value: which.setName
        }));
        if (editModalRef.current) editModalRef.current.showModal();
    };
    var onEditChange = function(domEvent) {
        var value = domEvent.target.value;
        setEdit((0, _objectSpreadProps._)((0, _objectSpread._)({}, edit), {
            value: value
        }));
    };
    var onEditVidsetClose = function() {
        var dialogRef = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        setEdit({
            item: "",
            value: ""
        });
        if (editModalRef.current) editModalRef.current.showModal();
    };
    var onEditVidsetSave = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("title", edit.value);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_RENAME), {
            body: fd
        }, function(response) {
            setPostCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, postCreate), {
                hidden: false,
                message: response.message,
                mode: response.result === "fail" ? "failed" : response.result
            }));
            setEdit({
                item: "",
                value: ""
            });
            setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
                setList: []
            }));
            if (editModalRef.current) editModalRef.current.close();
        });
    };
    var _updateTitle = function(id) {
        var changed = findCurrent(id);
        var setlist = (0, _toConsumableArray._)(destinations.setList);
        setlist[changed].setName = edit.value;
        return setlist;
    };
    var duplicate = function(id) {
        (0, _destinationsUtils.duplicatePlaylist)(id, function(data) {
            history.push("/destinations/playlist/".concat(data), {
                is_dupe: true
            });
        });
    };
    var onSortChange = function(domEvent) {
        var value = domEvent.target.value;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            setList: []
        }));
        setPagination((0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
            sort: +value,
            // Value == 0 will be true/false. + converts it to a boolean
            ascending: +(value == 0)
        }));
    };
    var _getSortValue = function(index) {
        var options = [
            "alpha",
            "alpha",
            "newest"
        ];
        return options[index];
    };
    var onDeleteSet = function(domEvent) {
        domEvent.preventDefault();
        var setId = domEvent.target.dataset.videoset;
        var title = destinations.setList[findCurrent(setId)].setName;
        var confirm = window.confirm("Are you sure that you want to delete \u201C".concat(title, "\u201D?"));
        if (confirm) (0, _destinationsUtils.deleteVideoSet)(setId, getDestinationInfo);
    };
    var onRestore = function(domEvent) {
        domEvent.preventDefault();
        var setId = domEvent.target.elements.id.value;
        (0, _destinationsUtils.restoreVideoSet)(setId, getDestinationInfo);
    };
    var body;
    if (loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: loading
    });
    else body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        className: "stations__view",
        children: [
            makeBreadcrumbs(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                id: "destination__header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        children: [
                            "Video Sets for ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                                children: destinations.dName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--action",
                        onClick: onCreateVidsetOpen,
                        children: "Create New Video Set"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "destinations__component__note",
                children: (0, _configuration.INTERSTITIAL_NOTE)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, postCreate), {
                onClose: onCloseMessage,
                className: "destinations__videosets__msg"
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "l-shelf-flex50",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsVideoSetsToggleSort.DestinationsVideoSetsToggleSort), {
                        onChange: onSortChange,
                        selectedIndex: pagination.sort,
                        disabled: !destinations.setList.length
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsIncludeInactive.DestinationsIncludeInactive), {
                        onChange: onInactivesChange
                    })
                ]
            }),
            makePagination(),
            makeSets(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createVideoSetDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
                modalRef: createVSRef,
                onClose: onCreateVidsetClose,
                onSubmit: onCreateSave,
                onChange: onCreateChange
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editVideoSetDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, edit), {
                modalRef: editModalRef,
                onClose: onEditVidsetClose,
                onSubmit: onEditVidsetSave,
                onChange: onEditChange
            })),
            makePagination()
        ]
    });
    return body;
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DestinationVideoSets, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","react-router-dom":"gMZz4","../subcomponents/ActionMessageDisplay":"bzcdY","../subcomponents/Breadcrumb":"e7Haa","../subcomponents/LoaderSimple":"1dSHa","./CreateVideoSet":"d8O2E","./EditVideoSet":"35A3R","../subcomponents/PaginationBar":"03zHm","../subcomponents/SelectPerPage":"anMUV","./DestinationsVideoSetsToggleSort":"ko5CJ","./DestinationsIncludeInactive":"wk9pz","./DestinationsRestoreSet":"2OSxm","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/DestinationsUtils":"5X8UE","../../actions/DestinationVideoSetsUtils":"kXJJz","../../actions/PaginationBarUtils":"hC8I0","./css/DestinationVideoSets.css":"87C45","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"e7Haa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _breadcrumbCss = require("./css/Breadcrumb.css");
var Breadcrumb = function(param) {
    var _param_items = param.items, items = _param_items === void 0 ? [] : _param_items, _param_id = param.id, id = _param_id === void 0 ? "breadcrumb-navigation" : _param_id, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_ariaLabel = param.ariaLabel, ariaLabel = _param_ariaLabel === void 0 ? "Breadcrumb" : _param_ariaLabel;
    var makeCrumb = function(item, index) {
        var link;
        var linkState = {};
        var defaultObj = {
            pathname: null,
            state: {}
        };
        if (!item.hasOwnProperty("path") || !item.path) link = /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
            children: item.label
        });
        else {
            if (item.hasOwnProperty("state")) linkState = {
                state: item.state
            };
            link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                to: item.path,
                state: linkState,
                className: function(param) {
                    var isActive = param.isActive;
                    return isActive ? "active" : "";
                },
                end: true,
                children: item.label
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
            children: link
        }, index.toString());
    };
    var links = items.map(makeCrumb);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
        id: id,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ol", {
            className: "breadcrumb__menu ".concat(cssClass),
            children: links
        })
    });
};
Breadcrumb.propTypes = {
    items: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        path: (0, _propTypesDefault.default).string,
        label: (0, _propTypesDefault.default).string.isRequired,
        state: (0, _propTypesDefault.default).object
    })).isRequired,
    cssClass: (0, _propTypesDefault.default).string,
    id: (0, _propTypesDefault.default).string,
    ariaLabel: (0, _propTypesDefault.default).string.isRequired
};
exports.default = Breadcrumb;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","react-router-dom":"gMZz4","./css/Breadcrumb.css":"jMoSX","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jMoSX":[function() {},{}],"35A3R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeButton = require("../subcomponents/CloseButton");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _textInput = require("../subcomponents/TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var EditVideoSet = function(props) {
    var onClose = function() {
        if (props.modalRef.current) props.modalRef.current.close();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: props.modalRef,
        id: "DestinationsEditVidset",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Rename this video set"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: props.onSubmit,
                id: "destination_create_vidset",
                action: (0, _configuration.API_VIDEOSET_RENAME),
                method: "POST",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "token",
                        value: (0, _utilities.getAuthData)("token")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "id",
                        value: props.item,
                        onChange: function() {}
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form__label_btn_group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                                cssClass: "destinations__create-new",
                                labelText: "Enter a new name for this video set",
                                name: "title",
                                id: "edit",
                                maxLength: "50",
                                onInputHandler: props.onChange,
                                value: props.value
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "btn btn--action",
                                children: "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = EditVideoSet;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/CloseButton":"3MmmO","prop-types":"fUIWk","../subcomponents/TextInput":"327SP","../subcomponents/ModalDialog":"72kji","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"03zHm":[function(require,module,exports) {
/**
 * PaginationBar.js
 * A no-framework pagination component
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utilities = require("../../js/Utilities");
var _paginationCss = require("../../css/pagination.css");
var PaginationBar = function(param) {
    var data = param.data, _param_navSize = param.navSize, navSize = _param_navSize === void 0 ? 10 : _param_navSize, onClickHandler = param.onClickHandler, page = param.page, pages = param.pages;
    var onClick = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        domEvent.persist();
        if (onClickHandler) onClickHandler(domEvent);
    };
    var batches = function() {
        var max = 1;
        if (pages) max = pages;
        var pgs = (0, _utilities.range)(1, max);
        var batches = (0, _utilities.arraychunk)(pgs, navSize);
        return batches;
    };
    var makeButton = function(pg) {
        var cssClass = (0, _classnamesDefault.default)({
            "pagination__pg": true,
            "pagination__pg__current": pg === page
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            className: cssClass,
            type: "button",
            value: pg,
            onClick: onClick,
            "data-data": data,
            children: pg
        }, "pagination__pg--".concat(pg));
    };
    var makeFirstLast = function() {
        var last = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, disabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (pages <= navSize) return null;
        var text = "first";
        if (last) text = "last";
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            className: "pagination__".concat(text, " pagination__pg"),
            type: "button",
            onClick: onClick,
            "data-data": data,
            value: text,
            disabled: disabled,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "form__access__label",
                children: [
                    text.charAt(0).toUpperCase(),
                    " Page"
                ]
            })
        });
    };
    var makeNav = function() {
        // Break the number of pages into chunks of 10.
        var btches = batches();
        // Finds the index of the batch that contains the currently-requested page
        var batch = btches.findIndex(function(b) {
            return b.indexOf(page) > -1;
        });
        /*
     If we change the number of pages available and our new requested page is no
     longer in range, reset the page batch to 0
    */ var index = batch > -1 ? batch : 0;
        // Return a set of buttons for the current chunk
        return btches[index].map(makeButton);
    };
    var isFirstPage = pages === 1 || page === 1;
    var isLastPage = false;
    if (page >= pages) isLastPage = true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "pagination__component--bar",
        children: [
            makeFirstLast(false, isFirstPage),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                "data-data": data,
                className: "pagination__previous pagination__pg",
                type: "button",
                onClick: onClick,
                value: "previous",
                disabled: isFirstPage,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "form__access__label",
                    children: "Previous"
                })
            }),
            makeNav(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                "data-data": data,
                className: "pagination__next pagination__pg",
                type: "button",
                onClick: onClick,
                value: "next",
                disabled: isLastPage,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "form__access__label",
                    children: "Next"
                })
            }),
            makeFirstLast(true, isLastPage)
        ]
    });
};
exports.default = PaginationBar;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","../../js/Utilities":"euxcI","../../css/pagination.css":"cjyAX","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cjyAX":[function() {},{}],"ko5CJ":[function(require,module,exports) {
/**
 * DestinationsVideoSetsToggleSort.jsx
 * Toggles between list and grid views on Destinations, Stations
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DestinationsVideoSetsToggleSort", function() {
    return DestinationsVideoSetsToggleSort;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggleSwitch = require("../subcomponents/ToggleSwitch");
var _toggleSwitchDefault = parcelHelpers.interopDefault(_toggleSwitch);
var DestinationsVideoSetsToggleSort = function(param) {
    var selectedIndex = param.selectedIndex, disabled = param.disabled, onChange = param.onChange;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
        label: "Sort video sets: ",
        selectedIndex: selectedIndex,
        options: [
            "A - Z",
            "Z - A",
            "Newest first"
        ],
        disabled: disabled,
        onChange: onChange,
        name: "DestinationsVideoSetsToggleSort"
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/ToggleSwitch":"k29YD","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"k29YD":[function(require,module,exports) {
/**
 * ToggleSwitch.js
 * Toggles between two options
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _toggleSwitchCss = require("./css/ToggleSwitch.css");
var ToggleSwitch = function(param) {
    var className = param.className, data = param.data, _param_label = param.label, label = _param_label === void 0 ? "NEEDS LABEL TEXT" : _param_label, _param_options = param.options, options = _param_options === void 0 ? [] : _param_options, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_name = param.name, name = _param_name === void 0 ? "" : _param_name, _param_selectedIndex = param.selectedIndex, selectedIndex = _param_selectedIndex === void 0 ? 0 : _param_selectedIndex, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function() {} : _param_onChange;
    // eslint-disable-next-line react/destructuring-assignment
    /* eslint-disable */ var cssClass = (0, _classnamesDefault.default)({
        "toggle__switch": true
    }, className);
    /* eslint-enable */ var opts = options.map(function(opt, index) {
        var fieldId = (0, _react.useId)();
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "radio",
                    disabled: disabled,
                    value: +index,
                    name: name || (0, _lodashUniqueidDefault.default)("ToggleSwitchInput__"),
                    onChange: onChange,
                    checked: +index == +selectedIndex,
                    id: fieldId
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: fieldId,
                    children: opt
                })
            ]
        }, (0, _lodashUniqueidDefault.default)());
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "".concat(name, "Control"),
        className: cssClass,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
            id: "".concat(name, "Form"),
            className: "toggle__switch__form",
            "data-data": data,
            onChange: onChange,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("fieldset", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toggle__switch__group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                            children: label
                        }),
                        opts
                    ]
                })
            })
        })
    });
};
ToggleSwitch.propTypes = {
    options: (0, _propTypesDefault.default).array.isRequired,
    disabled: (0, _propTypesDefault.default).bool,
    name: (0, _propTypesDefault.default).string.isRequired,
    selectedIndex: (0, _propTypesDefault.default).number,
    onChange: (0, _propTypesDefault.default).func.isRequired
};
exports.default = ToggleSwitch;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","lodash.uniqueid":"6bf5k","./css/ToggleSwitch.css":"eKmjS","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eKmjS":[function() {},{}],"kXJJz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initPaginationState", function() {
    return initPaginationState;
});
var initPaginationState = {
    perPage: 15,
    page: 1,
    total: 1,
    sort: 0,
    ascending: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hC8I0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setPageState", function() {
    return setPageState;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var setPageState = function(pagination, value) {
    var process;
    switch(value){
        case "first":
            process = (0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
                page: 1
            });
            break;
        case "previous":
            process = (0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
                page: +pagination.page - 1
            });
            break;
        case "next":
            process = (0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
                page: pagination.page + 1
            });
            break;
        case "last":
            process = (0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
                page: pagination.pages
            });
            break;
        default:
            process = (0, _objectSpreadProps._)((0, _objectSpread._)({}, pagination), {
                page: +value
            });
    }
    return process;
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"87C45":[function() {},{}],"6detW":[function(require,module,exports) {
/*
 eslint "react/react/destructuring-assignment": 0
*/ /**
 * DestinationPlaylist
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _dateFns = require("date-fns");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _closeButton = require("../subcomponents/CloseButton");
var _destinationsToggleView = require("./DestinationsToggleView");
var _dragSortList = require("../DragSortList");
var _dragSortListDefault = parcelHelpers.interopDefault(_dragSortList);
var _breadcrumb = require("../subcomponents/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _videosList = require("../VideosList");
var _videosListDefault = parcelHelpers.interopDefault(_videosList);
var _videoModal = require("../subcomponents/Videos/VideoModal");
var _videoModalDefault = parcelHelpers.interopDefault(_videoModal);
var _addVideosByURL = require("./AddVideosByURL");
var _addVideosByURLDefault = parcelHelpers.interopDefault(_addVideosByURL);
var _checkForUpdates = require("./CheckForUpdates");
var _checkForUpdatesDefault = parcelHelpers.interopDefault(_checkForUpdates);
var _checkForUpdatesProgress = require("./CheckForUpdatesProgress");
var _checkForUpdatesProgressDefault = parcelHelpers.interopDefault(_checkForUpdatesProgress);
var _checkForDuplicatesModal = require("./CheckForDuplicatesModal");
var _checkForDuplicatesModalDefault = parcelHelpers.interopDefault(_checkForDuplicatesModal);
var _deleteSetModal = require("./DeleteSetModal");
var _deleteSetModalDefault = parcelHelpers.interopDefault(_deleteSetModal);
var _videoDragItem = require("../subcomponents/VideoDragItem");
var _videoDragItemDefault = parcelHelpers.interopDefault(_videoDragItem);
var _reviewed = require("./Reviewed");
var _reviewedDefault = parcelHelpers.interopDefault(_reviewed);
var _playlistMeta = require("./PlaylistMeta");
var _playlistMetaDefault = parcelHelpers.interopDefault(_playlistMeta);
var _crtstatus = require("./CRTStatus");
var _crtstatusDefault = parcelHelpers.interopDefault(_crtstatus);
var _destinationsPlaylistTitle = require("./DestinationsPlaylistTitle");
var _destinationsPlaylistTitleDefault = parcelHelpers.interopDefault(_destinationsPlaylistTitle);
var _destinationsPlaylistRunDateModal = require("./DestinationsPlaylistRunDateModal");
var _destinationsPlaylistRunDateModalDefault = parcelHelpers.interopDefault(_destinationsPlaylistRunDateModal);
var _destinationsPlaylistHeader = require("./DestinationsPlaylistHeader");
var _destinationsPlaylistHeaderDefault = parcelHelpers.interopDefault(_destinationsPlaylistHeader);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _runDate = require("../Stations/RunDate");
var _runDateDefault = parcelHelpers.interopDefault(_runDate);
var _importSpreadsheetToPlaylist = require("../Import/ImportSpreadsheetToPlaylist");
var _importSpreadsheetToPlaylistDefault = parcelHelpers.interopDefault(_importSpreadsheetToPlaylist);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _destinationsUtils = require("../../actions/DestinationsUtils");
var _destinationsPlaylistUtils = require("../../actions/DestinationsPlaylistUtils");
var _stationsUtils = require("../../actions/StationsUtils");
var _destinationsPageCss = require("../../css/destinationsPage.css");
var _videoDisplayCss = require("./css/VideoDisplay.css");
var DestinationPlaylist = function(props) {
    var project = props.project, params = props.params;
    var vsbID = params.vsbID;
    var canAdmin = (0, _utilities.isAdmin)(project);
    var fetchCancel = new AbortController();
    var duplicateRunDate = (0, _react.useRef)(null);
    var importModal = (0, _react.useRef)(null);
    var addByUrlModal = (0, _react.useRef)(null);
    var addBySearchModal = (0, _react.useRef)(null);
    var checkForDupesModal = (0, _react.useRef)(null);
    var checkForUpdatesModal = (0, _react.useRef)(null);
    var videoModal = (0, _react.useRef)(null);
    var deleteSetRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), breadcrumbs = _useState[0], setBreadcrumbs = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), list = _useState1[0], setList = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)("00:00:00"), 2), runTime = _useState3[0], setRunTime = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(true), 2), useGrid = _useState4[0], setUseGrid = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)([]), 2), ratings = _useState5[0], setRatings = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)("\u2014"), 2), playlistRating = _useState6[0], setPlaylistRating = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)({
        Station: "",
        Video_Set: "",
        vsb_datetimetorun: "",
        vsb_tags: "",
        vsb_proofCopy: "",
        vsb_playlistURL: "",
        title: "",
        vsb_id: 0
    }), 2), currentVideoBlock = _useState7[0], setCurrentVideoBlock = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(false), 2), duplicated = _useState8[0], setDuplicated = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)({
        id: null,
        rundate: ""
    }), 2), duplicatePL = _useState9[0], setDuplicatePL = _useState9[1];
    var _useState10 = (0, _slicedToArray._)((0, _react.useState)({
        approved: false,
        loading: false,
        status: "Not Submitted"
    }), 2), crtstatus = _useState10[0], setCrtStatus = _useState10[1];
    var _useState11 = (0, _slicedToArray._)((0, _react.useState)((0, _destinationsPlaylistUtils.initAddByUrlState)), 2), addByURL = _useState11[0], setAddByURL = _useState11[1];
    var _useState12 = (0, _slicedToArray._)((0, _react.useState)((0, _destinationsPlaylistUtils.initAddBySearchState)), 2), addBySearch = _useState12[0], setAddBySearch = _useState12[1];
    var _useState13 = (0, _slicedToArray._)((0, _react.useState)((0, _destinationsPlaylistUtils.initCheckForUpdatesState)), 2), checkForUpdates = _useState13[0], setCheckForUpdates = _useState13[1];
    var _useState14 = (0, _slicedToArray._)((0, _react.useState)(""), 2), videoToPlay = _useState14[0], setVideoToPlay = _useState14[1];
    var _useState15 = (0, _slicedToArray._)((0, _react.useState)([]), 2), checkForDupes = _useState15[0], setCheckForDupes = _useState15[1];
    var _useState16 = (0, _slicedToArray._)((0, _react.useState)([]), 2), submissions = _useState16[0], setSubmissions = _useState16[1];
    /* If we haven't yet retrieved the block info, do so now. */ (0, _react.useEffect)(function() {
        if (!list.length) getVideosForBlock();
        if (!ratings.length) getRatings();
        if (!playlistRating) getVideoSetRating();
        return function() {
            return fetchCancel.abort();
        };
    }, [
        currentVideoBlock,
        list,
        ratings,
        playlistRating
    ]);
    var getVideosForBlock = function() {
        var fd = new FormData();
        fd.set("id", vsbID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        var signal = fetchCancel.signal;
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_INFO), {
            body: fd,
            signal: signal
        }, function(response) {
            var returnData = response.videoList.returnData;
            if (returnData.length) setList((0, _destinationsPlaylistUtils.normalizeVids)(returnData));
            else setList([
                false
            ]);
            setCurrentVideoBlock((0, _objectSpread._)({}, currentVideoBlock, response));
        });
    };
    var getRatings = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_RATINGS_ALL), {
            body: fd
        }, function(data) {
            setRatings((0, _destinationsPlaylistUtils.makeRatingsObjects)(data));
        });
    };
    var getVideoSetRating = function() {
        var fd = new FormData();
        fd.set("videosetblockid", +currentVideoBlock.vsb_id);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        // Make the network request here.
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_RATING), {
            body: fd
        }, function(data) {
            if (data.message === "success") setPlaylistRating(data.rating);
        });
    };
    var toNextPage = function(blockID) {
        window.location = "/destinations/playlist/".concat(blockID);
    };
    var onShuffle = function() {
        var shuffled = (0, _utilities.shuffle)(list);
        var ordered = shuffled.map(function(vid) {
            return vid.ytID;
        });
        saveNewOrder(ordered);
    };
    var onRunDateChange = function(domEvent) {
        var value = domEvent.target.value;
        setCurrentVideoBlock((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentVideoBlock), {
            vsb_datetimetorun: value
        }));
        var fd = new FormData();
        fd.set("id", currentVideoBlock.vsb_id);
        fd.set("rundate", value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_UPDATE), {
            body: fd
        }, function(response) {});
    };
    var onCloseRunDateModal = function() {
        if (duplicateRunDate.current) duplicateRunDate.current.close();
    };
    var onDuplicate = function() {
        (0, _destinationsUtils.duplicatePlaylist)(vsbID, function(data) {
            setDuplicatePL((0, _objectSpreadProps._)((0, _objectSpread._)({}, duplicatePL), {
                id: data
            }));
            if (duplicateRunDate.current) duplicateRunDate.current.showModal();
        });
    };
    var onDuplicateSubmit = function(domEvent) {
        domEvent.preventDefault();
        var id = duplicatePL.id, rundate = duplicatePL.rundate;
        var fd = new FormData();
        fd.set("id", id);
        fd.set("rundate", rundate);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_UPDATE), {
            body: fd
        }, function(response) {
            if (response.result === "success") onDuplicateSkip();
        });
    };
    var onDuplicateSkip = function() {
        var id = duplicatePL.id;
        toNextPage(id);
    };
    var onDuplicateRunDateChange = function(domEvent) {
        var value = domEvent.target.value;
        setDuplicatePL((0, _objectSpreadProps._)((0, _objectSpread._)({}, duplicatePL), {
            rundate: value
        }));
    };
    var getVideoSetCRTStatus = function() {
        setCrtStatus((0, _objectSpreadProps._)((0, _objectSpread._)({}, crtstatus), {
            loading: true
        }));
        var fd = new FormData();
        fd.set("videoset", currentVideoBlock.vsb_id || 0);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CRTAPPROVALS_GETVIDSETSTATUS), {
            body: fd
        }, function(data) {
            setCrtStatus({
                approved: data.approved,
                status: data.status,
                loading: false
            });
        });
    };
    var playVideo = function(youtubeId) {
        setVideoToPlay(youtubeId);
        videoModal.current.showModal();
    };
    var onPlayVideoClose = function() {
        if (videoModal.current) videoModal.current.close();
    };
    var deleteVideo = function(data) {
        var id = data.id, position = data.position;
        var params = props.params;
        var yes = window.confirm("Are you sure that you want to delete this video?");
        if (yes) {
            var fd = new FormData();
            fd.set("playlist", vsbID);
            fd.set("video", id);
            fd.set("order", position);
            fd.set("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_VIDEO_REMOVEFROMSET), {
                body: fd
            }, function(response) {
                setList([]);
            });
        }
    };
    var makeBreadcrumbs = function() {
        var crumbs = [];
        var loaf = [
            {
                label: "Destinations",
                path: "/destinations"
            }
        ];
        var Station = currentVideoBlock.Station, station_id = currentVideoBlock.station_id, vsb_setID = currentVideoBlock.vsb_setID, Video_Set = currentVideoBlock.Video_Set, vsb_datetimetorun = currentVideoBlock.vsb_datetimetorun;
        var lastCrumb = (0, _configuration.NULL_DATE_TEXT_STATIONS);
        if (vsb_datetimetorun && (0, _dateFns.isValid)(new Date(vsb_datetimetorun))) lastCrumb = (0, _dateFns.format)(new Date(vsb_datetimetorun), "PP", {
            timeZone: "Etc/UTC"
        });
        if (Station) crumbs = [
            {
                path: "/destinations/videosets/".concat(station_id),
                label: Station
            },
            {
                path: "/destinations/rundates/".concat(vsb_setID),
                label: Video_Set
            },
            {
                label: lastCrumb
            }
        ];
        return loaf.concat(crumbs);
    };
    var makeVideos = function() {
        var body;
        if (!list.length || list[0] === false) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            style: {
                "fontSize": "3rem",
                "marginBlock": "2rem 30rem"
            },
            children: "This playlist does not contain any videos."
        });
        body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true,
            className: "playlist__global"
        });
        if (currentVideoBlock.Approved === "y") body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "List destinations__disabled__list",
            children: list.map(function(i) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoDragItemDefault.default), {
                    interstitial: i.is_interstitial,
                    data: i,
                    playVideo: playVideo,
                    disabled: true,
                    deleteVideo: function() {},
                    position: i.position,
                    ordinal: i.ordinal
                }, (0, _lodashUniqueidDefault.default)("".concat(i.ytID, "_")));
            })
        });
        else body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dragSortListDefault.default), {
            items: list,
            onReSort: function(newOrder) {
                setList(newOrder);
            },
            onPlayVideo: playVideo,
            onDeleteVideo: deleteVideo
        });
        return body;
    };
    var onPlaylistSave = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("id", currentVideoBlock.vsb_id);
        fd.set("playlisturl", currentVideoBlock.vsb_playlistURL);
        fd.set("proofcopy", currentVideoBlock.vsb_proofCopy);
        fd.set("tags", currentVideoBlock.vsb_tags);
        fd.set("title", currentVideoBlock.title);
        fd.set("rundate", currentVideoBlock.vsb_datetimetorun);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_UPDATE), {
            body: fd
        }, function(data) {
            alert(data.message);
        });
    };
    var onPlaylistMetaChange = function(domEvent) {
        var _domEvent_target = domEvent.target, name = _domEvent_target.name, value = _domEvent_target.value;
        setCurrentVideoBlock((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentVideoBlock), (0, _defineProperty._)({}, name, value)));
    };
    var onApprovedProofedCuratedChange = function(domEvent) {
        var fd = new FormData();
        fd.set("field", domEvent.target.name);
        fd.set("by", (0, _utilities.getAuthData)("uuid"));
        fd.set("id", currentVideoBlock.vsb_id);
        fd.set("isOkayed", +domEvent.target.checked); // The + converts the true/false to an integer
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_REVIEWED), {
            body: fd
        }, function(data) {
            switch(data.field){
                case "proofed":
                    setCurrentVideoBlock((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentVideoBlock), {
                        Proofed_By: data.by,
                        Proofed_Date: data.date,
                        Proofed: data.okayed
                    }));
                    break;
                case "curated":
                    setCurrentVideoBlock((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentVideoBlock), {
                        Curated_By: data.by,
                        Curated_Date: data.date,
                        Curated: data.okayed
                    }));
                    break;
                default:
                    setCurrentVideoBlock((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentVideoBlock), {
                        Approved_By: data.by,
                        Approved_Date: data.date,
                        Approved: data.okayed
                    }));
            }
        });
    };
    var onCommentsChange = function(domEvent) {
        setCurrentVideoBlock((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentVideoBlock), {
            vsb_tags: domEvent.target.value
        }));
    };
    var onShowImport = function() {
        if (importModal === null || importModal === void 0 ? void 0 : importModal.current) importModal.current.showModal();
    };
    var onCloseImport = function() {
        if (importModal === null || importModal === void 0 ? void 0 : importModal.current) importModal.current.close();
    };
    var onShowVideos = function() {
        if (addBySearchModal.current) addBySearchModal.current.showModal();
    };
    var onCheckForDuplicates = function() {
        setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
            dupes: (0, _destinationsPlaylistUtils.checkDupes)((0, _toConsumableArray._)(list))
        }));
        if (checkForDupesModal.current) checkForDupesModal.current.showModal();
    };
    var onShowAddByUrlModal = function() {
        if (addByUrlModal.current) addByUrlModal.current.showModal();
    };
    var onCloseAddByUrlModal = function() {
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            value: ""
        }));
        if (addByUrlModal === null || addByUrlModal === void 0 ? void 0 : addByUrlModal.current) addByUrlModal.current.close();
    };
    var onAddVideoByUrlSubmit = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        domEvent.preventDefault();
        var postdupecheck = false;
        // Videos from the first submission.
        var add_videos_by_url_urls = domEvent.target.add_videos_by_url_urls;
        if (add_videos_by_url_urls) setSubmissions((0, _destinationsPlaylistUtils.splitURLs)(add_videos_by_url_urls.value));
        if (domEvent) postdupecheck = Object.hasOwn(domEvent.target.elements, "PostDupeCheck");
        // Find duplicates, then get unique values.
        var dupes = (0, _destinationsPlaylistUtils.checkUrlsForDupes)(addByURL.value, list);
        dupes = Array.from(new Set(dupes));
        /*
      If we have duplicates, and this form isn't being submitted after the duplicate
      checked display the 'Duplicates Found' modal.
    */ if (dupes.length && !postdupecheck) setTimeout(function() {
            addByUrlModal.current.close();
            checkForDupesModal.current.showModal();
            setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                dupes: dupes,
                loading: false
            }));
        }, 100);
        else {
            setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                loading: true
            }));
            onSubmitUrlPostConfirmation(domEvent.target);
        }
    };
    var onSubmitUrlPostConfirmation = function(formElement) {
        var duplicates = formElement.elements.duplicates;
        // Returned the YouTube IDs for checked boxes only.
        var exclude = [];
        if (duplicates.length) exclude = Array.from(duplicates).filter(function(d) {
            return !d.checked;
        }).map(function(d) {
            return d.value;
        });
        /*
     Filter the excluded values from the submitted ones.
    */ var submits = submissions.map((0, _utilities.expandShortYouTubeUrl)).map((0, _utilities.extractYouTubeIdFromUrl)).filter(function(s) {
            return exclude.indexOf(s) == -1;
        });
        if (submits.length) {
            var fd = new FormData();
            fd.set("blockid", currentVideoBlock.vsb_id);
            fd.set("userID", (0, _utilities.getAuthData)("uuid"));
            fd.set("token", (0, _utilities.getAuthData)("token"));
            fd.set("videoids", submits.join(","));
            fd.set("prepend", +!addByURL.toggle.selected);
            (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDBATCH), {
                body: fd
            }, function(response) {
                if (!response || Object.hasOwn(response, "error") && response.error) window.alert("ERROR: ".concat(response.message));
                else {
                    setCheckForDupes((0, _destinationsPlaylistUtils.initCheckForDupesState));
                    setAddByURL((0, _destinationsPlaylistUtils.initAddByUrlState));
                    setList([]);
                    if (checkForDupesModal.current) checkForDupesModal.current.close();
                    if (addByUrlModal.current) addByUrlModal.current.close();
                }
            });
        } else setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            maxIds: true
        }));
    };
    var onAddByUrlChange = function(domEvent) {
        var value = domEvent.target.value;
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            value: value,
            maxIds: (0, _utilities.stringToArray)(value).filter(function(l) {
                return l != "";
            }).length > 50
        }));
    };
    var onPrependChange = function(domEvent) {
        var value = domEvent.target.value;
        var toggle = addByURL.toggle;
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            "toggle": (0, _objectSpreadProps._)((0, _objectSpread._)({}, toggle), {
                selected: +value
            })
        }));
    };
    var onVideoSelected = function(domEvent) {
        alert("update state with the video!");
    };
    var onCheckDupesClose = function() {
        setCheckForDupes((0, _destinationsPlaylistUtils.initCheckForDupesState));
        if (checkForDupesModal.current) checkForDupesModal.current.close();
    };
    var onAddBySearchClose = function() {
        if (addBySearchModal.current) addBySearchModal.current.close();
        setAddBySearch((0, _destinationsPlaylistUtils.initAddBySearchState));
    };
    var onCheckForUpdates = function() {
        if (checkForUpdatesModal.current) checkForUpdatesModal.current.showModal();
        var fd = new FormData();
        fd.set("id", vsbID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_CHECKFORUPDATES), {
            body: fd
        }, function(response) {
            // Passes response back up to the parent for processing.
            onCheckForUpdatesResponse(response);
        });
    };
    var onCheckForUpdatesResponse = function(response) {
        if (!response) return;
        var changed = response.changed, videoList = response.videoList;
        if (!changed.length) setCheckForUpdates((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForUpdates), {
            loading: false
        }));
        else {
            var updates = (0, _toConsumableArray._)(list);
            changed.forEach(function(vid) {
                var idx = updates.findIndex(function(t) {
                    return t.ytID === vid.YouTube_ID;
                });
                var upv;
                if (vid.Current_Title) upv = (0, _objectSpreadProps._)((0, _objectSpread._)({}, updates[idx]), {
                    name: vid.Current_Title
                });
                updates[idx] = upv;
            });
            setCheckForUpdates((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForUpdates), {
                loading: false,
                updates: changed
            }));
            setList((0, _destinationsPlaylistUtils.normalizeVids)(videoList.returnData));
        }
    };
    var onCheckForUpdatesClose = function() {
        if (checkForUpdatesModal.current) checkForUpdatesModal.current.close();
        setCheckForUpdates((0, _destinationsPlaylistUtils.initCheckForUpdatesState));
    };
    var onCheckDupesErrorClose = function() {
        setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
            mode: "checking",
            message: ""
        }));
    };
    var saveNewOrder = function(ordered) {
        var fd = new FormData();
        var vsb_id = currentVideoBlock.vsb_id;
        fd.set("id", vsb_id);
        fd.set("videos", ordered.join(","));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("prepend", +!addByURL.toggle.selected);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_REORDERED), {
            body: fd
        }, function(response) {
            var returnData = response.returnData;
            setList((0, _destinationsPlaylistUtils.normalizeVids)(returnData));
        });
    };
    var onRemoveInstance = function(domEvent) {
        domEvent.preventDefault();
        var confirm = false;
        var vid = false;
        var video = domEvent.target.elements.video;
        if (video) vid = list.find(function(item) {
            return item.ytID === video.value;
        });
        if (!vid) return;
        // eslint-disable-next-line no-alert
        confirm = window.confirm('Are you sure you want to delete this instance of "'.concat(vid.name, '"?'));
        if (confirm) {
            var fd = new FormData(domEvent.target);
            fd.set("token", (0, _utilities.getAuthData)("token"));
            var signal = fetchCancel.signal;
            (0, _utilities.apirequest)((0, _configuration.API_VIDEO_REMOVEFROMSET), {
                body: fd,
                signal: signal
            }, function(response) {
                var returnData = response.videoList.returnData;
                setList((0, _destinationsPlaylistUtils.normalizeVids)(returnData));
            });
        }
    };
    var onCRTSubmitted = function(response) {
        var youtubeid = response.youtubeid, crt = response.crt;
        var index = list.findIndex(function(f) {
            return f.ytID == youtubeid;
        });
        var changedList = (0, _toConsumableArray._)(list);
        var update = (0, _objectSpread._)({}, changedList[index]);
        update.crt = crt;
        changedList[index] = update;
        setList(changedList);
    };
    var onRatingSubmitted = function(response) {
        var youtubeid = response.youtubeid, rating = response.rating;
        var index = list.findIndex(function(f) {
            return f.ytID == youtubeid;
        });
        var changedList = (0, _toConsumableArray._)(list);
        var update = (0, _objectSpread._)({}, changedList[index]);
        update.rating = rating;
        changedList[index] = update;
        setList(changedList);
    };
    var onMeowSubmitted = function(response) {
        var youtubeid = response.youtubeid, meow = response.meow;
        var index = list.findIndex(function(f) {
            return f.ytID == youtubeid;
        });
        var changedList = (0, _toConsumableArray._)(list);
        var update = (0, _objectSpread._)({}, changedList[index]);
        update.meow = meow;
        changedList[index] = update;
        setList(changedList);
    };
    var onSetDelete = function() {
        if (deleteSetRef.current) deleteSetRef.current.showModal();
    };
    var onSetDeleteClose = function() {
        if (deleteSetRef.current) deleteSetRef.current.close();
    };
    var cssClass = (0, _classnamesDefault.default)({
        video__display: true,
        "video__display--grid": useGrid,
        "video__display--listview": !useGrid
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "destinations__view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbDefault.default), {
                ariaLabel: "Destinations navigation",
                items: makeBreadcrumbs()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsPlaylistTitleDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, currentVideoBlock), {
                duplicated: duplicated,
                isAdmin: canAdmin,
                onDuplicate: onDuplicate,
                onSetDelete: onSetDelete
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runDateDefault.default), {
                date: currentVideoBlock.vsb_datetimetorun,
                onInputChange: onRunDateChange,
                className: "playlist__rundate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsPlaylistHeaderDefault.default), {
                runtime: runTime,
                rating: playlistRating,
                count: list.length,
                crtstatus: crtstatus,
                videosetid: currentVideoBlock.vsb_id,
                onSubmit: onPlaylistSave,
                onPlaylistMetaChange: onPlaylistMetaChange,
                onApprovedProofedCuratedChange: onApprovedProofedCuratedChange,
                playlist: currentVideoBlock,
                onCommentsChange: onCommentsChange,
                onCheckForDuplicates: onCheckForDuplicates,
                onCheckForUpdates: onCheckForUpdates,
                onAddBySearch: onShowVideos,
                onAddByUrl: onShowAddByUrlModal,
                onExport: function() {
                    (0, _destinationsUtils.exportVideoData)(list);
                },
                onPlay: function() {
                    (0, _destinationsUtils.playAllVideos)(list);
                },
                onImport: onShowImport,
                onShuffle: onShuffle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: cssClass,
                style: {
                    "marginBlock": "2rem"
                },
                children: makeVideos()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videosListDefault.default), {
                modalRef: addBySearchModal,
                currentSet: list,
                blockId: vsbID,
                onSubmit: function() {
                    return setList([]);
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addVideosByURLDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
                modalRef: addByUrlModal,
                block: currentVideoBlock,
                onClose: onCloseAddByUrlModal,
                onSubmit: onAddVideoByUrlSubmit,
                onChange: onAddByUrlChange,
                onPrependChange: onPrependChange
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsPlaylistRunDateModalDefault.default), {
                rundate: duplicatePL.rundate,
                modalRef: duplicateRunDate,
                onClose: onCloseRunDateModal,
                onSubmit: onDuplicateSubmit,
                onChange: onDuplicateRunDateChange,
                onDuplicateSkip: onDuplicateSkip
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importSpreadsheetToPlaylistDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                modalRef: importModal,
                onSubmit: function() {
                    return setList([]);
                }
            }, currentVideoBlock), {
                onClose: onCloseImport
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForUpdatesProgressDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForUpdates), {
                modalRef: checkForUpdatesModal,
                videoset: vsbID,
                onClose: onCheckForUpdatesClose,
                onServerResponse: onCheckForUpdatesResponse
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForDuplicatesModalDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                modalRef: checkForDupesModal,
                onClose: onCheckDupesClose,
                inSet: list,
                playlist: vsbID,
                onRemove: onRemoveInstance,
                onSubmit: onAddVideoByUrlSubmit,
                onErrorClose: onCheckDupesErrorClose
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoModalDefault.default), {
                modalRef: videoModal,
                isAdmin: canAdmin,
                id: "DestinationPlaylistVideoModal",
                mode: "videos_in_system",
                youtubeId: videoToPlay,
                onClose: onPlayVideoClose,
                onCRTSave: onCRTSubmitted,
                onRatingSave: onRatingSubmitted,
                onMeowSave: onMeowSubmitted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteSetModalDefault.default), {
                modalRef: deleteSetRef,
                blockId: vsbID,
                title: currentVideoBlock.Video_Set,
                stationId: currentVideoBlock.station_id,
                setId: currentVideoBlock.vsb_setID
            })
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DestinationPlaylist, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","date-fns":"1h4Hj","classnames":"8N3a2","lodash.uniqueid":"6bf5k","../subcomponents/CloseButton":"3MmmO","./DestinationsToggleView":"ilkFj","../DragSortList":"tQbiV","../subcomponents/Breadcrumb":"e7Haa","../VideosList":"h4I1m","../subcomponents/Videos/VideoModal":"aQAN2","./AddVideosByURL":"5T0Rm","./CheckForUpdates":"gvTXy","./CheckForUpdatesProgress":"9F7am","./CheckForDuplicatesModal":"4ZmTu","./DeleteSetModal":"6GKoY","../subcomponents/VideoDragItem":"4r79B","./Reviewed":"710TT","./PlaylistMeta":"f33rk","./CRTStatus":"2l3mr","./DestinationsPlaylistTitle":"fEKsS","./DestinationsPlaylistRunDateModal":"gJNah","./DestinationsPlaylistHeader":"54o4P","../subcomponents/LoaderSimple":"1dSHa","../Stations/RunDate":"2wBau","../Import/ImportSpreadsheetToPlaylist":"4HG0O","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/DestinationsUtils":"5X8UE","../../actions/DestinationsPlaylistUtils":"73dnb","../../actions/StationsUtils":"Ja4lj","../../css/destinationsPage.css":"kWrfi","./css/VideoDisplay.css":"jiXKe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ilkFj":[function(require,module,exports) {
/**
 * DestinationsToggleView.js
 * Toggles between list and grid views on Destinations, Stations
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DestinationsToggleView", function() {
    return DestinationsToggleView;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _destinationsToggleViewCss = require("./css/DestinationsToggleView.css");
var DestinationsToggleView = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "DestinationsToggleView",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                children: "View:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                id: "DestinationsToggleViewForm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                disabled: props.disabled,
                                type: "radio",
                                value: "1",
                                name: "DestinationsToggleViewInput",
                                checked: props.useGrid === true,
                                onChange: props.onChange,
                                id: "DestinationsToggleViewInput__grid"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "DestinationsToggleViewInput__grid",
                                children: "Grid"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                disabled: props.disabled,
                                type: "radio",
                                value: "0",
                                name: "DestinationsToggleViewInput",
                                checked: props.useGrid === false,
                                onChange: props.onChange,
                                id: "DestinationsToggleViewInput__list"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "DestinationsToggleViewInput__list",
                                children: "List"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./css/DestinationsToggleView.css":"jbpB9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jbpB9":[function() {},{}],"tQbiV":[function(require,module,exports) {
/**
 * DragSortList.js
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _videoDragItem = require("./subcomponents/VideoDragItem");
var _videoDragItemDefault = parcelHelpers.interopDefault(_videoDragItem);
var _dragSortListCss = require("../css/DragSortList.css");
var DragSortList = function(props) {
    var dragged = null;
    var wrapper = (0, _react.useRef)();
    var dragStart = function(domEvent) {
        domEvent.stopPropagation();
        dragged = domEvent.currentTarget;
        if (dragged.parentElement) dragged.parentElement.classList.add("dragsortlist__is_dragging");
        dragged.classList.add("dragsortlist__dragged_item");
        domEvent.dataTransfer.effectAllowed = "move";
        domEvent.dataTransfer.setData("text/html", dragged.cloneNode(true));
    };
    var dropped = function(domEvent) {
        if (dragged != domEvent.currentTarget) {
            var wrapper = domEvent.currentTarget.parentElement;
            domEvent.dataTransfer.dropEffect = "move";
            var before = null;
            if (domEvent.target.previousElementSibling) before = domEvent.currentTarget.nextSibling;
            else before = wrapper.firstElementChild;
            wrapper.insertBefore(dragged, before);
        }
        dragged.classList.remove("dragsortlist__dragged_item");
        return false;
    };
    var dragOverEnter = function(domEvent) {
        if (domEvent.preventDefault) domEvent.preventDefault();
        domEvent.dataTransfer.dropEffect = "move";
        return false;
    };
    var dragEndLeave = function(domEvent) {
        if (dragged === null || dragged === void 0 ? void 0 : dragged.parentElement) dragged.parentElement.classList.remove("dragsortlist__is_dragging");
    };
    var reSort = function(domEvent) {
        /**
     * Not sure this is the best way to get the new order, but
     * it's what we're doing.
     */ var newOrder = [];
        var origOrder = (0, _toConsumableArray._)(props.items);
        var reOrdered = Array.from(wrapper.current.children).forEach(function(item, index) {
            var ordinal = origOrder.filter(function(oo) {
                return item.dataset.dragid == oo.ytID;
            })[0];
            ordinal = (0, _objectSpread._)({}, ordinal);
            ordinal.ordinal = index;
            newOrder[index] = ordinal;
        });
        // Pass it back up to the parent
        if (Object.hasOwn(props, "onReSort")) props.onReSort(newOrder);
    };
    var classes = (0, _classnamesDefault.default)((0, _objectSpread._)({
        "DragSortList": true
    }, props.classNames));
    var draggables = props.items.map(function(d, index) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
            "data-dragid": d.ytID,
            onDragStart: dragStart,
            onDragEnd: dragEndLeave,
            onDrop: dropped,
            onDragOver: dragOverEnter,
            onDragEnter: dragOverEnter,
            onDragLeave: dragEndLeave,
            draggable: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoDragItemDefault.default), {
                interstitial: d.is_interstitial,
                data: d,
                playVideo: props.onPlayVideo,
                deleteVideo: props.onDeleteVideo,
                position: d.position,
                ordinal: d.ordinal
            }, (0, _lodashUniqueidDefault.default)("".concat(d.ytID, "_")))
        }, (0, _lodashUniqueidDefault.default)());
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        className: classes,
        onDrop: reSort,
        ref: wrapper,
        children: draggables
    });
};
exports.default = DragSortList;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","lodash.uniqueid":"6bf5k","prop-types":"fUIWk","classnames":"8N3a2","./subcomponents/VideoDragItem":"4r79B","../css/DragSortList.css":"3yHLn","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4r79B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ytplayIcon = require("./YTPlayIcon");
var _ytplayIconDefault = parcelHelpers.interopDefault(_ytplayIcon);
var _videoItemCss = require("../../css/VideoItem.css");
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var VideoDragItem = function(param) {
    var deleteVideo = param.deleteVideo, playVideo = param.playVideo, _param_data = param.data, data = _param_data === void 0 ? {} : _param_data, _param_ordinal = param.ordinal, ordinal = _param_ordinal === void 0 ? 0 : _param_ordinal, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_deleteText = param.deleteText, deleteText = _param_deleteText === void 0 ? "Delete video" : _param_deleteText;
    var active = data.active, is_interstitial = data.is_interstitial, duration = data.duration, ytID = data.ytID, thumb = data.thumb, name = data.name, position = data.position, meow = data.meow, crt = data.crt;
    var playHandler = function(data) {
        if (playVideo) playVideo(data);
    };
    var deleteHandler = function(data) {
        if (deleteVideo) deleteVideo(data);
    };
    var makeBadge = function() {
        var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isMeow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var label = obj.label || (0, _configuration.MESSAGE_NOT_SUBMITTED);
        var css;
        if (isMeow) css = (0, _classnamesDefault.default)({
            "video__meow--okay": meowOK() === true,
            "video__meow--notok": meowOK() === false,
            "video__meow--escalate": meowOK() === "escalate"
        });
        else css = (0, _classnamesDefault.default)({
            "video__crt--okay": crtOK(),
            "video__crt--notok": crtOK() === false,
            "video__crt--escalate": crtOK() === "escalate"
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
            className: "video__badge itemsBadge ".concat(css),
            children: label
        });
    };
    var meowOK = function() {
        // Return this if it's not submitted.
        var okay;
        if (meow && (0, _utilities.isNumeric)(meow === null || meow === void 0 ? void 0 : meow.id)) switch(+meow.id){
            case 0:
                okay = true;
                break;
            case 16:
                okay = "escalate";
                break;
            default:
                okay = false;
        }
        else okay = null;
        return okay;
    };
    var crtOK = function() {
        if (!crt) return;
        var id = crt.id;
        var approved = false;
        if (id === 0) approved = null;
        if (id === 1) approved = true;
        if (id >= 10) approved = "escalate";
        return approved;
    };
    var cssClasses = (0, _classnamesDefault.default)({
        "video__draggable": true,
        "results__list__item--interstitial": is_interstitial,
        "video__inactive": active === "n"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "video__draggable__ordinal",
                children: ordinal + 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                "data-video": ytID,
                onClick: playVideo.bind(null, ytID),
                className: "resultItemLink videoResultItemHeader results__list__item__title divTransition",
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                "data-video": ytID,
                onClick: playVideo.bind(null, ytID),
                className: "video__item__thumb videoThumb",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: thumb,
                        alt: "Watch ".concat(name)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ytplayIconDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "video__drag__item__duration",
                children: [
                    "Duration: ",
                    (0, _utilities.formatTime)(duration)
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                className: "video__drag__item__data",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                        children: "MEOW"
                                    }),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: makeBadge(meow, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                        title: "Content Review Team",
                                        children: "CRT"
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: makeBadge(crt)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "video__item__delete",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    "data-video": ytID,
                    type: "button",
                    disabled: disabled,
                    className: "btn btn-sm btn--action",
                    onClick: deleteVideo.bind(null, {
                        id: ytID,
                        position: position
                    }),
                    children: deleteText
                })
            })
        ]
    });
};
exports.default = VideoDragItem;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","./YTPlayIcon":"5wQr0","../../css/VideoItem.css":"011DU","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5wQr0":[function(require,module,exports) {
/**
 * YTPlayIcon.js
 * YouTube's Play Icon in SVG for crispness.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var YTPlayIcon = function(param) {
    var cssClass = param.cssClass, _param_title = param.title, title = _param_title === void 0 ? "Click to Play this video" : _param_title, _param_height = param.height, height = _param_height === void 0 ? 121.599 : _param_height, _param_width = param.width, width = _param_width === void 0 ? 172.592 : _param_width;
    var style = {
        isolation: "isolate",
        aspectRatio: "${width / height}"
    };
    var cssClasses = (0, _classnamesDefault.default)("youtube__play__icon", cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        focusable: "false",
        width: width,
        height: height,
        style: style,
        viewBox: "0 0 172.592 121.599",
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "_clipPath_rlc6PkcFvDQwJZ96IQjYNr05YeqrKMg5",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: "172.592",
                        height: "121.599"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#_clipPath_rlc6PkcFvDQwJZ96IQjYNr05YeqrKMg5)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "_clipPath_eEVTedFdv6HDi8Yy2TvjhUY1hq7FWVgj",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: " M 0 0 L 0 121.599 L 172.592 121.599 L 172.592 0 L 0 0 Z ",
                            fill: "rgb(255,255,255)"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        clipPath: "url(#_clipPath_eEVTedFdv6HDi8Yy2TvjhUY1hq7FWVgj)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: " M 168.985 18.988 C 167.001 11.514 161.153 5.628 153.727 3.63 C 140.267 0 86.296 0 86.296 0 C 86.296 0 32.325 0 18.865 3.63 C 11.44 5.628 5.591 11.514 3.607 18.988 C 0 32.535 0 60.8 0 60.8 C 0 60.8 0 89.064 3.607 102.612 C 5.591 110.085 11.44 115.971 18.865 117.97 C 32.325 121.599 86.296 121.599 86.296 121.599 C 86.296 121.599 140.267 121.599 153.727 117.97 C 161.153 115.971 167.001 110.085 168.985 102.612 C 172.592 89.064 172.592 60.8 172.592 60.8 C 172.592 60.8 172.592 32.535 168.985 18.988 Z ",
                            fill: "rgb(236,54,56)"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "_clipPath_FGVafdfWIM4x72ePH055Y1i4054mmNEi",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: " M 0 0 L 0 121.599 L 172.592 121.599 L 172.592 0 L 0 0 Z ",
                            fill: "rgb(255,255,255)"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        clipPath: "url(#_clipPath_FGVafdfWIM4x72ePH055Y1i4054mmNEi)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: " M 68.645 86.462 L 113.754 60.8 L 68.645 35.137 L 68.645 86.462 Z ",
                            fill: "rgb(254,254,254)"
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = YTPlayIcon;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"011DU":[function() {},{}],"3yHLn":[function() {},{}],"h4I1m":[function(require,module,exports) {
/**
 * VideoList
 * Displays a list of available videos to add.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeButton = require("./subcomponents/CloseButton");
var _videoListTable = require("./subcomponents/VideoListTable");
var _videoListTableDefault = parcelHelpers.interopDefault(_videoListTable);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _pagination = require("./subcomponents/Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _selectPerPage = require("./subcomponents/SelectPerPage");
var _selectPerPageDefault = parcelHelpers.interopDefault(_selectPerPage);
var _filterComponent = require("./Videos/FilterComponent");
var _filterComponentDefault = parcelHelpers.interopDefault(_filterComponent);
var _modalDialog = require("./subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var _destinationsPlaylistUtils = require("../actions/DestinationsPlaylistUtils");
var VideosList = function(param) {
    var blockId = param.blockId, currentSet = param.currentSet, modalRef = param.modalRef, selected = param.selected, onSubmit = param.onSubmit;
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _configuration.DESTINATIONS_VIDEOS_PER_PAGE)), 2), perPage = _useState[0], setPerPage = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(1), 2), currentPage = _useState1[0], setCurrentPage = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(1), 2), totalPages = _useState2[0], setTotalPages = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)("video_addeddate"), 2), sortBy = _useState3[0], setSortBy = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(""), 2), keyword = _useState4[0], setKeyword = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(""), 2), filterOn = _useState5[0], setFilterOn = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(true), 2), ascending = _useState6[0], setAscending = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)([]), 2), list = _useState7[0], setList = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(0), 2), numResults = _useState8[0], setNumResults = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState9[0], setLoading = _useState9[1];
    var _useState10 = (0, _slicedToArray._)((0, _react.useState)([]), 2), selectedVideos = _useState10[0], setSelectedVideos = _useState10[1];
    var _useState11 = (0, _slicedToArray._)((0, _react.useState)(false), 2), selectAll = _useState11[0], setSelectAll = _useState11[1];
    var _useState12 = (0, _slicedToArray._)((0, _react.useState)(false), 2), prepend = _useState12[0], setPrepend = _useState12[1];
    var _useState13 = (0, _slicedToArray._)((0, _react.useState)([
        {
            name: "",
            sortable: false
        },
        {
            name: "Occurrences",
            sortable: false
        },
        {
            name: "Video Name",
            sortable: false
        },
        {
            name: "Channel Name",
            sortable: false
        },
        {
            name: "Duration",
            sortable: false
        },
        {
            name: "Video Date",
            sortable: false
        }
    ]), 2), tableHeaders = _useState13[0], setTableHeaders = _useState13[1];
    var getVideoListBatchSortDir = function() {
        var direction = [
            "descending",
            "ascending"
        ];
        var dirKey = +ascending;
        return direction[dirKey];
    };
    (0, _react.useEffect)(function() {
        if (!list.length) requestVideoListBatch();
    }, [
        list
    ]);
    var requestVideoListBatch = function() {
        var fd = new FormData();
        fd.set("perpage", perPage);
        fd.set("page", currentPage);
        fd.set("sort_by", sortBy);
        fd.set("filter_by", keyword);
        fd.set("filter_on", filterOn);
        fd.set("order", getVideoListBatchSortDir());
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_GETBATCH), {
            body: fd
        }, function(response) {
            var videos = response.videos, current_page = response.current_page, pages = response.pages, num_results = response.num_results;
            if (videos.length) {
                setList(videos.map(function(v) {
                    v.checked = false;
                    return v;
                }));
                setCurrentPage(current_page);
                setTotalPages(pages);
                setNumResults(num_results);
                setLoading(false);
            }
        });
    };
    var onPaginationClick = function(domEvent) {
        var value = domEvent.target.value;
        setCurrentPage(currentPage + +value);
        setLoading(true);
        setList([]);
    };
    var onPerPageChange = function(domEvent) {
        domEvent.persist();
        var value = domEvent.target.value;
        setPerPage(+value);
        setList([]);
    };
    var onSearchFilterChange = function(domEvent) {
        var form = domEvent.target.form;
        setList([]);
        setKeyword(form.searchValue.value);
        setFilterOn(form.filterOn.value.split("|")[0]);
        setCurrentPage(1);
        setTotalPages(1);
    };
    var onCheckBoxChange = function(domEvent) {
        var target = domEvent.target;
        var checked = target.checked, value = target.value;
        setList(function(prev) {
            var updates = (0, _toConsumableArray._)(prev);
            var index = updates.findIndex(function(video) {
                return video.video_youtubeID === value;
            });
            updates[index].checked = checked;
            return updates;
        });
        if (checked) setSelectedVideos(function(prev) {
            return (0, _toConsumableArray._)(prev).concat([
                value
            ]);
        });
        else setSelectedVideos(function(prev) {
            return (0, _toConsumableArray._)(prev).filter(function(f) {
                return f !== value;
            });
        });
    };
    var oOnSubmit = function(domEvent) {
        domEvent.preventDefault();
        if (!selectedVideos.length) {
            alert("Nothing to submit!");
            return;
        }
        var fd = new FormData();
        fd.set("blockid", blockId);
        fd.set("userID", (0, _utilities.getAuthData)("uuid"));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("prepend", 0);
        fd.set("videoids", selectedVideos.join(","));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDBATCH), {
            body: fd
        }, function(response) {
            if (response.error) {
                alert(response.message);
                return;
            }
            var returnData = response.videoList.returnData;
            if (modalRef.current) modalRef.current.close();
            setSelectedVideos([]);
            setList([]);
            /* Resets the parent component's video list. */ if (onSubmit) onSubmit();
        });
    };
    var isSelected = function(id) {
        var videos = Array.isArray(selected) ? selected : [];
        var selectedVideo = videos.find(function(sv) {
            return sv.video_youtubeID === id;
        });
        return !!selectedVideo;
    };
    var makeTableData = function() {
        var data = [];
        if (list.length) data = list.map(function(item, index) {
            return {
                video_id: item.video_id,
                video_title: item.video_title,
                video_channel: item.channel_title,
                video_duration: +item.videoext_duration,
                video_pubdate: item.videoext_publishdatetime,
                video_youtubeID: item.video_youtubeID,
                occurrences: currentSet.filter(function(v) {
                    return item.video_youtubeID === v.ytID;
                }).length,
                checked: item.checked
            };
        });
        return data;
    };
    var getModalBody = function() {
        var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true,
            cssClass: "destinations__video__list__loader"
        });
        if (!loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoListTableDefault.default), {
            headers: tableHeaders,
            rows: makeTableData(),
            currentSet: currentSet,
            cssClass: "video__list__table",
            onCheckBoxChange: onCheckBoxChange
        });
        return body;
    };
    var makeVideoSearch = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterComponentDefault.default), {
            ascending: ascending,
            cssClass: "reports__vidset__search",
            itemsName: "Videos",
            filterOn: "video_title",
            filterData: [
                {
                    value: "video_title",
                    name: "Video Title",
                    type: "string"
                },
                {
                    value: "video_channel_title",
                    name: "Channel Name",
                    type: "string"
                },
                {
                    value: "video_addedbyname",
                    name: "User name",
                    type: "string"
                }
            ],
            sortData: [
                {
                    value: "video_title",
                    name: "Video Title",
                    type: "string"
                },
                {
                    value: "video_updateddate",
                    name: "Video Last Updated",
                    type: "num"
                },
                {
                    value: "video_addeddate",
                    name: "Date Video Added to System",
                    type: "num"
                },
                {
                    value: "video_channel_title",
                    name: "Channel Name",
                    type: "string"
                },
                {
                    value: "video_duration_seconds",
                    name: "Video Duration",
                    type: "num"
                },
                {
                    value: "video_viewcount",
                    name: "Video View Count",
                    type: "num"
                },
                {
                    value: "video_likecount",
                    name: "Video Likes Count",
                    type: "string"
                },
                {
                    value: "video_setscount",
                    name: "Number of Video Sets",
                    type: "num"
                },
                {
                    value: "video_publishdate",
                    name: "Publish Date",
                    type: "num"
                },
                {
                    value: "video_channel_publishdate",
                    name: "Channel Date",
                    type: "date"
                },
                {
                    value: "video_rating",
                    name: "Rating",
                    type: "string"
                },
                {
                    value: "meow",
                    name: "MEOW Status"
                }
            ],
            onSortChange: onSortChange,
            onFilterChange: onSearchFilterChange,
            onFilterClear: onFilterClear,
            onDirectionChange: onDirectionChange,
            hideCategories: true
        });
    };
    var onDirectionChange = function(domEvent) {
        setAscending(!ascending);
        setList([]);
    };
    var onSortChange = function(domEvent) {
        var value = domEvent.target.value;
        setSortBy(value);
        setList([]);
    };
    var onFilterClear = function(domEvent) {
        setPerPage((0, _configuration.DESTINATIONS_VIDEOS_PER_PAGE));
        setCurrentPage(1);
        setTotalPages(1);
        setSortBy("video_addeddate");
        setKeyword("");
        setFilterOn("");
        setAscending(true);
        setList([]);
        setNumResults(0);
        setLoading(true);
        setSelectedVideos([]);
        setSelectAll(false);
    };
    var onClose = function() {
        if (modalRef.current) modalRef.current.close();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "VideosListModal",
        className: "video__list__modal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Select Videos"
            }),
            makeVideoSearch(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                action: (0, _configuration.API_VIDEOSET_REINIT),
                method: "post",
                onSubmit: oOnSubmit,
                id: "add_to_videoset",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "table__list__controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPerPageDefault.default), {
                                name: "video_list_pages",
                                cssClass: "table__list__perpage",
                                value: perPage,
                                onChangeHandler: onPerPageChange
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                                currentPage: currentPage,
                                totalPages: totalPages,
                                onClickHandler: onPaginationClick,
                                disablePrevious: currentPage <= 1,
                                disableNext: currentPage >= totalPages
                            })
                        ]
                    }),
                    getModalBody(),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "table__list__controls",
                        children: [
                            "  ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                                currentPage: currentPage,
                                totalPages: totalPages,
                                onClickHandler: onPaginationClick,
                                disablePrevious: currentPage <= 1,
                                disableNext: currentPage >= totalPages
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "vlm__controls",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    form: "add_to_videoset",
                    className: "btn btn--action",
                    children: "Submit"
                })
            })
        ]
    });
};
exports.default = VideosList;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","./subcomponents/CloseButton":"3MmmO","./subcomponents/VideoListTable":"eQohY","./subcomponents/LoaderSimple":"1dSHa","./subcomponents/Pagination":"kHqdc","./subcomponents/SelectPerPage":"anMUV","./Videos/FilterComponent":"jxYDN","./subcomponents/ModalDialog":"72kji","../js/Utilities":"euxcI","../js/Configuration":"k3dur","../actions/DestinationsPlaylistUtils":"73dnb","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eQohY":[function(require,module,exports) {
/**
 * VideoListTable.js
 * A no-framework table component, specifically for the VideoListComponent
 * display. Used on the DestinationsPage.
 * See PropTypes definitions at the end of this file for parameters
 * TODO: See if can consolidate this with ChannelListTable.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dateFns = require("date-fns");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _utilitiesJs = require("../../js/Utilities.js");
var _videoListTableCss = require("../../css/VideoListTable.css");
var VideoListTable = function(props) {
    var makeHeaders = function makeHeaders() {
        var retval;
        if (headers) {
            var hdrs = [];
            hdrs = headers.map(function(h, idx) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                    children: h.name
                }, idx.toString());
            });
            retval = /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                    children: hdrs
                })
            });
        } else retval = null;
        return retval;
    };
    var makeRows = function makeRows() {
        var retval;
        if (rows) {
            var rws = [];
            rws = rows.map(makeOneRow);
            retval = /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                children: rws
            });
        } else retval = null;
        return retval;
    };
    var makeOneRow = function makeOneRow(obj) {
        var tds = [];
        var video_youtubeID = obj.video_youtubeID, video_pubdate = obj.video_pubdate, video_title = obj.video_title, video_channel = obj.video_channel, occurrences = obj.occurrences, video_duration = obj.video_duration, checked = obj.checked;
        var pubDate = "";
        if ((0, _dateFns.isValid)(video_pubdate)) pubDate = (0, _dateFns.format)(video_pubdate * 1000, "d MMM yyyy");
        tds[0] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                name: "videos_to_add",
                type: "checkbox",
                id: video_youtubeID,
                value: video_youtubeID,
                onChange: onCheckBoxChange,
                checked: checked
            })
        }, video_youtubeID);
        tds[1] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            className: "video__list__table_occurr",
            children: occurrences > 0 ? occurrences : ""
        }, (0, _lodashUniqueidDefault.default)());
        tds[2] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: video_youtubeID,
                children: video_title
            })
        }, (0, _lodashUniqueidDefault.default)());
        tds[3] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: video_channel
        }, (0, _lodashUniqueidDefault.default)());
        tds[4] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: (0, _utilitiesJs.getDuration)(video_duration)
        }, (0, _lodashUniqueidDefault.default)());
        tds[5] = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            children: pubDate
        }, (0, _lodashUniqueidDefault.default)());
        var tr = /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
            children: tds
        }, (0, _lodashUniqueidDefault.default)());
        return tr;
    };
    var cssClass = props.cssClass, headers = props.headers, id = props.id, rows = props.rows, currentSet = props.currentSet, onCheckBoxChange = props.onCheckBoxChange;
    var cssClasses = (0, _classnamesDefault.default)("table-list", cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
        className: cssClasses,
        id: id,
        children: [
            makeHeaders(),
            makeRows()
        ]
    });
};
exports.default = VideoListTable;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","date-fns":"1h4Hj","lodash.uniqueid":"6bf5k","../../js/Utilities.js":"euxcI","../../css/VideoListTable.css":"5PTib","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5PTib":[function() {},{}],"jxYDN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _selectMenuControlled = require("../subcomponents/SelectMenuControlled");
var _selectMenuControlledDefault = parcelHelpers.interopDefault(_selectMenuControlled);
var _filterComponentCss = require("./css/FilterComponent.css");
var FilterComponent = function(param) {
    var onFilterChange = param.onFilterChange, onFilterClear = param.onFilterClear, onSortChange = param.onSortChange, onDirectionChange = param.onDirectionChange, cssClass = param.cssClass, sortData = param.sortData, _param_sortDefault = param.sortDefault, sortDefault = _param_sortDefault === void 0 ? "video_setscount" : _param_sortDefault, filterData = param.filterData, showHint = param.showHint, itemsName = param.itemsName, searchValue = param.searchValue, hideCategories = param.hideCategories, filterOn = param.filterOn, category = param.category, _param_ascending = param.ascending, ascending = _param_ascending === void 0 ? true : _param_ascending, _param_categories = param.categories, categories = _param_categories === void 0 ? [] : _param_categories;
    var sortFields = [
        {
            value: "none",
            name: "Select property to sort by",
            type: "none"
        }
    ].concat(sortData);
    var filterFields = [
        {
            isDisabled: false,
            value: "none",
            name: "Select property to filter by",
            type: "none"
        }
    ].concat(filterData);
    var makeMenuItems = function() {
        var arrayOfItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var menu = null;
        if (arrayOfItems.length) menu = arrayOfItems.map(function(item, index) {
            var disabledOpt;
            disabledOpt = item.hasOwnProperty("isDisabled") ? item.isDisabled : false;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: "".concat(item.value),
                disabled: disabledOpt,
                children: item.name
            }, index.toString());
        });
        return menu;
    };
    var makeSortIndicator = function() {
        var arrow = ascending ? "\u2191" : "\u2193";
        var label = ascending ? "Ascending" : "Descending";
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
            className: "sort__order__icon",
            "aria-label": label,
            children: arrow
        });
    };
    var css = (0, _classnamesDefault.default)(cssClass, {
        "filter__component": true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: css,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                id: "filter_videos",
                method: "dialog",
                onChange: onFilterChange,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filter__vid",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "searchValue",
                                children: "Filter ".concat(itemsName, ":")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                autoFocus: true,
                                className: "form-control",
                                type: "text",
                                name: "searchValue",
                                id: "searchValue",
                                disabled: !hideCategories
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        hidden: !showHint,
                        id: "filter__component__hint",
                        children: [
                            "For best results, use quotes for filters containing multiple words. ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                title: "example",
                                children: "ex:"
                            }),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                                    children: "room makeover"
                                })
                            }),
                            " instead of ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "room makeover"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "ava-input-select",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                            name: "filterOn",
                            id: "filterOn",
                            value: filterOn,
                            onChange: function() {},
                            children: makeMenuItems(filterFields)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "filter__categories",
                        hidden: hideCategories,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuControlledDefault.default), {
                            options: categories,
                            labelText: "Category",
                            firstEmpty: false,
                            name: "category",
                            value: category,
                            disabled: !categories.length
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "reset",
                            className: "btn btn-sm btn--action filterBtn",
                            children: "Clear Filter"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                id: "sort_videos",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filter__sort",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "sortBy",
                                children: "Sort ".concat(itemsName, " by Property:")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "ava-input-select",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                    name: "sortBy",
                                    id: "sortBy",
                                    onChange: onSortChange,
                                    children: makeMenuItems(sortFields)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            "display": "flex",
                            "alignItems": "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn btn-sm btn--action filterBtn",
                                onClick: onDirectionChange,
                                children: "Change Direction"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "sort__order",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "form__access__label",
                                        children: "Sort Direction is now:"
                                    }),
                                    "  ",
                                    makeSortIndicator()
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = FilterComponent;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../subcomponents/SelectMenuControlled":"6qOrd","./css/FilterComponent.css":"9WkZS","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6qOrd":[function(require,module,exports) {
/**
 * SelectMenuControlled.jsx
 * A no-framework dropdown menu. This sends the entire DOMEvent to the onChange
 * instead of just the value. It's also a CONTROLLED rather than an UNCONTROLLED
 * component.
 *
 * Second version is due to some legacy code. Easier to add this component than
 * to rewrite SelectMenu and everywhere it's used to make it controlled.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _selectOption = require("./SelectOption");
var _selectOptionDefault = parcelHelpers.interopDefault(_selectOption);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _selectMenuCss = require("../../css/SelectMenu.css");
var SelectMenuControlled = function(param) {
    var onChange = param.onChange, _param_name = param.name, name = _param_name === void 0 ? "" : _param_name, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_hidden = param.hidden, hidden = _param_hidden === void 0 ? false : _param_hidden, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "NEEDS LABEL TEXT" : _param_labelText, _param_id = param.id, id = _param_id === void 0 ? null : _param_id, _param_options = param.options, options = _param_options === void 0 ? [] : _param_options, _param_firstEmpty = param.firstEmpty, firstEmpty = _param_firstEmpty === void 0 ? true : _param_firstEmpty, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_isRequired = param.isRequired, isRequired = _param_isRequired === void 0 ? false : _param_isRequired, _param_size = param.size, size = _param_size === void 0 ? "1" : _param_size, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? false : _param_multiple, _param_labelledby = param.labelledby, labelledby = _param_labelledby === void 0 ? null : _param_labelledby, _param_describedBy = param.describedBy, describedBy = _param_describedBy === void 0 ? null : _param_describedBy;
    var makeOptions = function(arrayOfObjects) {
        return arrayOfObjects.map(function(o, x) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectOptionDefault.default), {
                value: o.value,
                label: o.label
            }, x.toString());
        });
    };
    var cssClasses = (0, _classnamesDefault.default)("ava-input-select", cssClass);
    var opts = makeOptions(options);
    if (firstEmpty) opts.unshift(/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {}, "selectmenufirstempty"));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id || name,
                children: labelText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                disabled: disabled,
                hidden: hidden,
                required: isRequired,
                defaultValue: value,
                id: id || name,
                name: name,
                onChange: onChange,
                size: size,
                multiple: multiple,
                "aria-labelledby": labelledby,
                "aria-describedby": describedBy,
                children: opts
            })
        ]
    });
};
SelectMenuControlled.propTypes = {
    id: (0, _propTypesDefault.default).string,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    name: (0, _propTypesDefault.default).string.isRequired,
    cssClass: (0, _propTypesDefault.default).string,
    onChange: (0, _propTypesDefault.default).func,
    options: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string,
        value: (0, _propTypesDefault.default).string
    })).isRequired,
    value: (0, _propTypesDefault.default).string.isRequired,
    isRequired: (0, _propTypesDefault.default).bool,
    firstEmpty: (0, _propTypesDefault.default).bool.isRequired,
    size: (0, _propTypesDefault.default).string,
    multiple: (0, _propTypesDefault.default).bool
};
exports.default = SelectMenuControlled;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./SelectOption":"lqdWV","classnames":"8N3a2","../../css/SelectMenu.css":"cUBB3","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lqdWV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SelectOption = function(param) {
    var _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_label = param.label, label = _param_label === void 0 ? "" : _param_label;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
        value: value,
        children: label
    });
};
exports.default = SelectOption;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cUBB3":[function() {},{}],"9WkZS":[function() {},{}],"73dnb":[function(require,module,exports) {
/*
DestinationsPlaylistUtils.js

Functions that are used in DestinationsPlaylist/Stations component.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStateOnShuffle", function() {
    return setStateOnShuffle;
});
parcelHelpers.export(exports, "setStateGroups", function() {
    return setStateGroups;
});
parcelHelpers.export(exports, "setStateOnPreGetVideoListBatch", function() {
    return setStateOnPreGetVideoListBatch;
});
parcelHelpers.export(exports, "normalizeVids", function() {
    return normalizeVids;
});
parcelHelpers.export(exports, "setStatePostVideoListBatch", function() {
    return setStatePostVideoListBatch;
});
parcelHelpers.export(exports, "makeRatingsObjects", function() {
    return makeRatingsObjects;
});
parcelHelpers.export(exports, "setStatePostRatingsSubmit", function() {
    return setStatePostRatingsSubmit;
});
parcelHelpers.export(exports, "setStateOnRatingsChange", function() {
    return setStateOnRatingsChange;
});
parcelHelpers.export(exports, "setStateIsDupe", function() {
    return setStateIsDupe;
});
parcelHelpers.export(exports, "setStateCloseVideoList", function() {
    return setStateCloseVideoList;
});
parcelHelpers.export(exports, "setStateCloseCheckDupes", function() {
    return setStateCloseCheckDupes;
});
parcelHelpers.export(exports, "setStateShowAddByURLModal", function() {
    return setStateShowAddByURLModal;
});
parcelHelpers.export(exports, "setStateOnShowVids", function() {
    return setStateOnShowVids;
});
parcelHelpers.export(exports, "setStateOnSearchDirectionChange", function() {
    return setStateOnSearchDirectionChange;
});
parcelHelpers.export(exports, "setStateOnSearchFilterClear", function() {
    return setStateOnSearchFilterClear;
});
parcelHelpers.export(exports, "findDupes", function() {
    return findDupes;
});
parcelHelpers.export(exports, "checkDupes", function() {
    return checkDupes;
});
parcelHelpers.export(exports, "checkUrlsForDupes", function() {
    return checkUrlsForDupes;
});
parcelHelpers.export(exports, "splitURLs", function() {
    return splitURLs;
});
parcelHelpers.export(exports, "indicesOfDupes", function() {
    return indicesOfDupes;
});
parcelHelpers.export(exports, "excludeUrlFromValue", function() {
    return excludeUrlFromValue;
});
parcelHelpers.export(exports, "setStateResetModal", function() {
    return setStateResetModal;
});
parcelHelpers.export(exports, "setStateAfterGrid", function() {
    return setStateAfterGrid;
});
parcelHelpers.export(exports, "setStateOnVideoSelect", function() {
    return setStateOnVideoSelect;
});
parcelHelpers.export(exports, "initAddByUrlState", function() {
    return initAddByUrlState;
});
parcelHelpers.export(exports, "initAddBySearchState", function() {
    return initAddBySearchState;
});
parcelHelpers.export(exports, "initCheckForUpdatesState", function() {
    return initCheckForUpdatesState;
});
parcelHelpers.export(exports, "initCheckForDupesState", function() {
    return initCheckForDupesState;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _destinationsUtils = require("./DestinationsUtils");
var setStateOnShuffle = function(state) {
    var toshuffle = (0, _toConsumableArray._)(state.list);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        list: (0, _utilities.shuffle)(toshuffle)
    });
};
var setStateGroups = function(state, data) {
    return {
        videoGroups: data
    };
};
var setStateOnPreGetVideoListBatch = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addBySearch: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
            loading: true
        })
    });
};
var normalizeVids = function(videolist) {
    var callback = function(item, index) {
        return {
            name: item.Video_Name,
            ordinal: index,
            id: item.video_id,
            ytID: item.Video_ID,
            thumb: item.videoext_thumbnail,
            duration: +item.Duration,
            is_interstitial: item.is_interstitial,
            crt: item.crt,
            meow: item.meow,
            active: item.active,
            position: +item.order
        };
    };
    return videolist.map(callback);
};
var setStatePostVideoListBatch = function(state, data) {
    // add a checked property so we don't get undefined errors
    var videos = data.videos;
    videos.map(function(v) {
        v.checked = false;
        return v;
    });
    var newState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
        list: videos,
        currentPage: data.current_page,
        totalPages: data.pages,
        numResults: data.num_results,
        loading: false
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addBySearch: newState
    });
};
var makeRatingsObjects = function(data) {
    return data.map(function(item, index) {
        return {
            value: index,
            label: item.label
        };
    });
};
var setStatePostRatingsSubmit = function(state, data) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        showVideo: false,
        selectedRating: "",
        currentVideoData: {}
    });
};
var setStateOnRatingsChange = function(state, value) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        selectedRating: value,
        ratingsSubmitHandler: ""
    });
};
var setStateIsDupe = function(state, data) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        duplicated: data.is_dupe
    });
};
var setStateCloseVideoList = function(state) {
    var newState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
        open: false,
        currentPage: 1,
        totalPages: 0,
        numResults: 0,
        sortBy: "video_addeddate",
        ascending: false,
        filterKeyword: "",
        filterOn: "",
        loading: true
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addBySearch: newState
    });
};
var setStateCloseCheckDupes = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        checkForDupes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.checkForDupes), {
            open: false,
            loading: true
        })
    });
};
var setStateShowAddByURLModal = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addByURL: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addByURL), {
            open: true,
            value: "",
            working: false
        })
    });
};
var setStateOnShowVids = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addBySearch: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
            open: true
        })
    });
};
var setStateOnSearchDirectionChange = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addBySearch: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
            ascending: !state.addBySearch.ascending
        })
    });
};
var setStateOnSearchFilterClear = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state, state.addBySearch), {
        filterOn: "",
        filterKeyword: ""
    });
};
// Technique for finding duplicates in an array. See: https://stackoverflow.com/a/24968449
var count = function(list) {
    return list.reduce(function(accumulator, currentvalue) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, accumulator), (0, _defineProperty._)({}, currentvalue, (accumulator[currentvalue] || 0) + 1));
    }, {});
};
var findDupes = function(arry) {
    var counts = count(arry);
    return Object.keys(counts).filter(function(a) {
        return counts[a] > 1;
    });
};
var checkDupes = function() {
    var videolist = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var vidIds = videolist.map(function(video) {
        if (video.hasOwnProperty("ytID")) return video.ytID;
    });
    return findDupes(vidIds);
};
var checkUrlsForDupes = function(submitted, existing) {
    var subs = splitURLs(submitted);
    var exist = existing.map(function(e) {
        return (0, _utilities.makeYouTubeUrl)(e.ytID);
    });
    return exist.filter(function(f) {
        return subs.indexOf(f) > -1;
    });
};
var splitURLs = function() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return input.split(/[,\s]/).filter(function(f) {
        return f !== "";
    }).map(function(i) {
        return i.replace("https://youtu.be/", "https://www.youtube.com/watch?v=");
    }).map(function(i) {
        return i.replace("https://www.youtube.com/shorts/", "https://www.youtube.com/watch?v=");
    });
};
var indicesOfDupes = function(array, value) {
    var reducer = function(acc, current, index) {
        if (current.ytID === value) acc.push(index);
        return acc;
    };
    // Find the indices of the video in the video list array.
    var indices = array.reduce(reducer, []);
    return {
        id: value,
        indexes: indices,
        checked: true
    };
};
var excludeUrlFromValue = function() {
    var urls = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", video = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", checked = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    // Splits by commas, or whitespace. filters empties.
    var list = urls.split(/[,\s]/).filter(function(line) {
        return line !== "";
    });
    if (!list.length) return;
    if (!checked) include = list.filter(function(line) {
        return line.indexOf(video) === -1;
    });
    else include = list;
    return include.join("\n");
};
var setStateResetModal = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        loading: false,
        addBySearch: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
            open: false
        }),
        addByURL: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addByURL), {
            open: false,
            value: "",
            working: false
        }),
        checkForDupes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.checkForDupes), {
            open: false,
            working: false
        })
    });
};
var setStateAfterGrid = function(state) {
    var response = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, closeAfter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!response.hasOwnProperty("videoList")) return state;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        loading: false,
        list: normalizeVids(response.videoList.returnData),
        addBySearch: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
            open: false
        }),
        currentVideoBlock: response,
        curated: {
            by: response.Curated_By || "",
            date: response.Curated_Date || false,
            isOkayed: response.Curated === "y"
        },
        approved: {
            by: response.Approved_By || "",
            date: response.Approved_Date || false,
            isOkayed: response.Approved === "y"
        },
        proofed: {
            by: response.Proofed_By || "",
            date: response.Proofed_Date || false,
            isOkayed: response.Proofed === "y"
        },
        addByURL: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addByURL), {
            open: false,
            value: "",
            working: false
        }),
        checkForDupes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.checkForDupes), {
            open: !closeAfter,
            working: false
        })
    });
};
var updateSelectedInList = function(list, target) {
    var loadedRows = (0, _toConsumableArray._)(list);
    var update = loadedRows.findIndex(function(item) {
        return target.value === item.video_youtubeID;
    });
    loadedRows[update] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, loadedRows[update]), {
        checked: !loadedRows[update].checked
    });
    return loadedRows;
};
var setStateOnVideoSelect = function(state, target) {
    var updatedSet = new Set((0, _toConsumableArray._)(state.addBySearch.selected));
    if (!target.checked) updatedSet.delete(target.value);
    else updatedSet.add(target.value);
    var boo = {
        addBySearch: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addBySearch), {
            selected: updatedSet,
            list: (0, _toConsumableArray._)(updateSelectedInList(state.addBySearch.list, target))
        }),
        addByURL: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addByURL), {
            value: (0, _toConsumableArray._)(updatedSet).join("\n")
        })
    };
    return boo;
};
var initAddByUrlState = {
    value: "",
    maxIds: false,
    working: false,
    toggle: {
        options: [
            "Yes",
            "No"
        ],
        selected: 1
    }
};
var initAddBySearchState = {
    loading: true,
    currentPage: 1,
    perPage: (0, _configuration.DESTINATIONS_VIDEOS_PER_PAGE),
    totalPages: 0,
    numResults: 0,
    sortBy: "video_addeddate",
    ascending: false,
    filterKeyword: "",
    filterOn: "",
    list: [],
    selected: [],
    maxIds: false
};
var initCheckForUpdatesState = {
    open: false,
    updates: [],
    loading: true,
    dupes: []
};
var initCheckForDupesState = {
    dupes: [],
    mode: "adding",
    working: false,
    response: {},
    message: ""
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_to_consumable_array":"fRXIP","../js/Configuration":"k3dur","../js/Utilities":"euxcI","./DestinationsUtils":"5X8UE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aQAN2":[function(require,module,exports) {
/**
 * VideoModal.js
 * Shows data in a modal when requested.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactYoutube = require("react-youtube");
var _reactYoutubeDefault = parcelHelpers.interopDefault(_reactYoutube);
var _dateFns = require("date-fns");
var _utilities = require("../../../js/Utilities");
var _searchUtils = require("../../../actions/SearchUtils");
var _destinationsSelect = require("../../Destinations/DestinationsSelect");
var _destinationsSelectDefault = parcelHelpers.interopDefault(_destinationsSelect);
var _modalDialog = require("../ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _ratingsMenu = require("../RatingsMenu");
var _ratingsMenuDefault = parcelHelpers.interopDefault(_ratingsMenu);
var _crtapprovalsMenu = require("./CRTApprovalsMenu");
var _crtapprovalsMenuDefault = parcelHelpers.interopDefault(_crtapprovalsMenu);
var _meowMenu = require("./MeowMenu");
var _meowMenuDefault = parcelHelpers.interopDefault(_meowMenu);
var _videoNote = require("./VideoNote");
var _badgeMEOWCRT = require("../../Videos/BadgeMEOWCRT");
var _pleaseAddToAva = require("../../Videos/PleaseAddToAva");
var _closeButton = require("../CloseButton");
var _configuration = require("../../../js/Configuration");
var _videoModalCss = require("./css/VideoModal.css");
var _this = undefined;
var VideoModal = function(param) {
    var _param_isAdmin = param.isAdmin, isAdmin = _param_isAdmin === void 0 ? false : _param_isAdmin, modalRef = param.modalRef, youtubeId = param.youtubeId, id = param.id, params = param.params, onClose = param.onClose, onCRTSave = param.onCRTSave, onRatingSave = param.onRatingSave, onMeowSave = param.onMeowSave;
    var initInfoState = {
        video_yt_id: "",
        video_alreadyprocessed: "",
        video_channel_title: "No title found",
        video_channel_yt_id: ""
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(youtubeId), 2), ytid = _useState[0], setYtid = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(initInfoState), 2), info = _useState1[0], setInfo = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(""), 2), note = _useState2[0], setNote = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), channelAdded = _useState3[0], setChannelAdded = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), videoAdded = _useState4[0], setVideoAdded = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(false), 2), addVideoButtonDisabled = _useState5[0], setAddVideoButtonDisabled = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({
        options: [],
        selected: null
    }), 2), chanGroups = _useState6[0], setChanGroups = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)({
        options: [],
        selected: null
    }), 2), ratingsMenu = _useState7[0], setRatingsMenu = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)({
        options: [],
        selected: null
    }), 2), meowMenu = _useState8[0], setMeowMenu = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)({
        options: [],
        selected: null
    }), 2), crtMenu = _useState9[0], setCrtMenu = _useState9[1];
    (0, _react.useEffect)(function() {
        if (youtubeId && ytid != youtubeId) {
            setInfo(initInfoState);
            setYtid(youtubeId);
        }
        if (info.video_yt_id == "" && youtubeId) getVideo(youtubeId);
        if (!crtMenu.options.length) getCrtOptions();
        if (!meowMenu.options.length) getMeowOptions();
        if (!ratingsMenu.options.length) getRatings();
        if (!chanGroups.options.length) getGroupOptions();
    }, [
        info,
        ratingsMenu,
        crtMenu,
        meowMenu,
        youtubeId,
        ytid
    ]);
    var oOnClose = function() {
        setInfo(initInfoState);
        if (onClose) onClose(youtubeId);
    };
    var getVideo = function(id) {
        var fd = new FormData();
        fd.set("id", id);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_INFO), {
            body: fd
        }, function(data) {
            setInfo(data);
        });
    };
    var getCrtOptions = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CRTAPPROVALS_OPTIONS), {
            body: fd
        }, function(data) {
            var crtData = data.map(function(item, index) {
                return {
                    value: index,
                    label: item
                };
            });
            setCrtMenu((0, _objectSpreadProps._)((0, _objectSpread._)({}, crtMenu), {
                options: crtData
            }));
        });
    };
    var getMeowOptions = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_MEOW_OPTIONS), {
            body: fd
        }, function(data) {
            setMeowMenu((0, _objectSpreadProps._)((0, _objectSpread._)({}, meowMenu), {
                options: data
            }));
        });
    };
    var getGroupOptions = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ALLGROUPS), {
            body: fd
        }, function(data) {
            setChanGroups((0, _objectSpreadProps._)((0, _objectSpread._)({}, chanGroups), {
                options: data
            }));
        });
    };
    var onCRTSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("ytid", ytid);
        fd.set("status", crtMenu.selected);
        fd.set("user_id", (0, _utilities.getAuthData)("uuid"));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CRTAPPROVALS_SETSTATUS), {
            body: fd
        }, function(data) {
            window.alert(data.message);
            if (data.status === "success" && onCRTSave) onCRTSave(data);
        });
    };
    var onCRTChange = function(domEvent) {
        var value = domEvent.target.value;
        if (value) setCrtMenu((0, _objectSpreadProps._)((0, _objectSpread._)({}, crtMenu), {
            selected: value
        }));
    };
    var getCrtMenu = function() {
        var val = "";
        if (info.hasOwnProperty("crt") && !crtMenu.selected) val = info.crt.id;
        else if (crtMenu.selected) val = crtMenu.selected;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crtapprovalsMenuDefault.default), {
            onSubmit: onCRTSubmit,
            onChange: onCRTChange,
            options: crtMenu.options,
            value: val,
            disabled: info.video_alreadyprocessed === "n"
        });
    };
    var getMeowMenu = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _meowMenuDefault.default), {
            onSubmit: onMeowSubmit,
            onChange: onMeowChange,
            options: meowMenu.options,
            value: meowMenu.selected,
            disabled: info.video_alreadyprocessed === "n"
        });
    };
    var onMeowChange = function(domEvent) {
        if (domEvent.target) {
            var value = domEvent.target.value;
            setMeowMenu((0, _objectSpreadProps._)((0, _objectSpread._)({}, meowMenu), {
                selected: value
            }));
        }
    };
    var onMeowSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("ytid", info.video_yt_id);
        fd.set("status", meowMenu.selected);
        fd.set("user_id", (0, _utilities.getAuthData)("uuid"));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_MEOW_SETSTATUS), {
            body: fd
        }, function(data) {
            window.alert(data.message);
            if (data.status === "success" && onMeowSave) onMeowSave(data);
        });
    };
    var getRatings = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_RATINGS_ALL), {
            body: fd
        }, function(data) {
            var ratingsData = data.map(function(item, index) {
                return {
                    value: index,
                    label: item.label
                };
            });
            setRatingsMenu((0, _objectSpreadProps._)((0, _objectSpread._)({}, ratingsMenu), {
                options: ratingsData
            }));
        });
    };
    var onAddVideo = function(domEvent) {
        (0, _searchUtils.addVideo)(ytid, function(response) {
            var success = response.success, addedVideos = response.addedVideos;
            if (success) {
                setInfo(initInfoState);
                setYtid(addedVideos[0]);
            }
        });
    };
    var getAddBtn = function() {
        var action;
        if (info.video_alreadyprocessed === "y" || info.video_alreadyprocessed === true || videoAdded) action = /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
            children: "Video Added to System"
        });
        else action = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: "video__info__in btn btn--action",
            onClick: onAddVideo,
            children: "Add to System"
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "video__info__in_sys",
            children: action
        });
    };
    var getDeleteVideo = function() {
        if (!isAdmin) return;
        var setblocklist = function() {
            var response = [];
            if (Object.hasOwn(info, "dest_set_block_assignments") && (info === null || info === void 0 ? void 0 : info.dest_set_block_assignments.length)) response = info.dest_set_block_assignments.filter(function(vset) {
                return vset !== null;
            }).map(function(st, index) {
                var rundate = st.episode_run_date ? (0, _dateFns.format)(new Date(st.episode_run_date), "yyyy-MM-dd") : (0, _configuration.NULL_DATE_TEXT);
                var isStation = st.isStation ? "(station)" : "";
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                    value: st.block_id,
                    children: [
                        st.destination_name,
                        " ",
                        st.vs_name,
                        " ",
                        rundate,
                        " ",
                        isStation
                    ]
                }, index.toString());
            });
            return response;
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "video__info_field video__info__field",
            onSubmit: deleteVideo,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: "video_delete_value",
                    children: "Delete Video from Block or System:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "form__input_button_group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            name: "video_delete_value",
                            id: "video_delete_value",
                            disabled: info.video_alreadyprocessed === "n",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "all",
                                    children: "Delete Video From System"
                                }),
                                setblocklist()
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "btn btn--action",
                            children: "Delete Video"
                        })
                    ]
                })
            ]
        });
    };
    var makeVideoSets = function() {
        var video_sets = null;
        if (Object.hasOwn(info, "dest_set_block_assignments")) {
            var dest_set_block_assignments = info.dest_set_block_assignments;
            video_sets = dest_set_block_assignments.filter(function(vset) {
                return vset !== null;
            }).map(function(vset, index) {
                if (!vset) return;
                var rundate = vset.episode_run_date ? (0, _dateFns.format)(new Date(vset.episode_run_date), "yyyy-MM-dd") : (0, _configuration.NULL_DATE_TEXT);
                var eptitle = vset.episode_title ? ": ".concat(vset.episode_title) : "";
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    "data-videosetblock": vset.video_set_block_id,
                    className: "video__info__setname",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "video__info__vs_badge",
                        href: "/destinations/playlist/".concat(vset.block_id),
                        rel: "nofollow noreferrer",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                            children: [
                                vset.destination_name,
                                ":",
                                " ",
                                vset.vs_name,
                                eptitle,
                                " ",
                                "(",
                                rundate,
                                ")"
                            ]
                        })
                    })
                }, index.toString());
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            className: "video__stats__list_vs",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    children: "Video Sets:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "resizable--vert",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        className: "video__info__eplist",
                        children: video_sets
                    })
                })
            ]
        });
    };
    var onRatingsChange = function(domEvent) {
        var rating = ratingsMenu.options.find(function(rating) {
            return domEvent.target.value == rating.value;
        });
        setRatingsMenu((0, _objectSpreadProps._)((0, _objectSpread._)({}, ratingsMenu), {
            selected: rating
        }));
    };
    var onRatingsSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("userid", (0, _utilities.getAuthData)("uuid"));
        fd.set("videoid", info.video_yt_id);
        fd.set("rating", ratingsMenu.selected.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_RATINGS_VIDEOUPDATE), {
            body: fd
        }, function(data) {
            window.alert(data.message);
            if (data.error === false && onRatingSave) onRatingSave(data);
        });
    };
    var getRatingsMenu = function() {
        var val = "";
        if (ratingsMenu.selected) val = ratingsMenu.selected.value;
        else if (info.rating) val = ratingsMenu.options.findIndex(function(opt) {
            return info.rating.value === opt.value;
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ratingsMenuDefault.default), {
            actionURL: "api/ratings",
            options: ratingsMenu.options,
            onChangeHandler: onRatingsChange,
            onSubmitHandler: onRatingsSubmit,
            value: val,
            disabled: info.video_alreadyprocessed === "n"
        });
    };
    var deleteVideo = function(domEvent) {
        domEvent.preventDefault();
        var blockid = domEvent.target.video_delete_value.value;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        /**
     * Until we can standardize the API end points to spit out the same property names.
     */ var vid;
        if (Object.hasOwn(info, "video_yt_id")) vid = info.video_yt_id;
        if (Object.hasOwn(info, "video_youtubeID")) vid = info.video_youtubeID;
        if (blockid === "all") {
            var yes = window.confirm("Are you sure you want to delete this video from AVA?");
            if (yes) {
                fd.set("videoid", vid);
                (0, _utilities.apirequest)((0, _configuration.API_VIDEO_DELETE), {
                    body: fd
                }, function(response) {
                    if (response.videosDeleted.length) alert("Video deleted.");
                });
            } else alert("Video not deleted.");
        } else {
            var yes1 = window.confirm("Are you sure you want to remove this video from the selected playlist?");
            fd.set("video", vid);
            fd.set("playlist", blockid);
            (0, _utilities.apirequest)((0, _configuration.API_VIDEO_REMOVEFROMSET), {
                body: fd
            }, function(response) {
                if (_this.props.hasOwnProperty("onDeleteFromBlock")) _this.props.onDeleteFromBlock(response);
            });
        }
    };
    var addTagsToVideo = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_UPDATETAGS), {
            body: fd
        }, function(data) {
            if (data.message === "success") window.alert("Custom tags saved!");
        });
    };
    var onChannelGroupChange = function(domEvent) {
        setChanGroups((0, _objectSpreadProps._)((0, _objectSpread._)({}, chanGroups), {
            selected: domEvent.target.value
        }));
    };
    var addChannelToGroup = function(domEvent) {
        domEvent.preventDefault();
        var channel = info.video_channel_yt_id;
        var fd = new FormData();
        fd.set("group", chanGroups.selected);
        fd.set("channels", channel);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ADD_CHANNEL_TO_GROUP), {
            body: fd
        }, addedToGroup);
    };
    var addedToGroup = function(data) {
        var sel = chanGroups.selected;
        var grp = chanGroups.options.find(function(g) {
            return +g.group_id === +sel;
        });
        if (data.success) alert('Added "'.concat(info.video_channel_title, '" to "').concat(grp.group_name, '."'));
        else alert('"'.concat(info.video_channel_title, '" is already in "').concat(grp.group_name, '."'));
    };
    var getAddChannel = function() {
        if (!chanGroups.options) return;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "video__info__field video__info_changroup",
            onSubmit: function() {},
            onChange: onChannelGroupChange,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: "modal_group_select",
                    children: "Add Channel to Group:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pleaseAddToAva.PleaseAddToAva), {
                    hidden: info.video_alreadyprocessed !== "n"
                }),
                !video_channel_yt_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "itemsBadge",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        children: "\u205F\u205FCan't Modify Channel Group. Missing Channel ID."
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "form__input_button_group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            name: "modal_group_select",
                            id: "modal_group_select",
                            disabled: !info.video_alreadyprocessed || !video_channel_yt_id,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "",
                                    children: "Select Group"
                                }),
                                chanGroups.options.map(function(st, k) {
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: st.group_id,
                                        children: st.group_name
                                    }, st.group_id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn--action",
                            onClick: addChannelToGroup,
                            disabled: !video_channel_yt_id,
                            children: "Add Channel"
                        })
                    ]
                })
            ]
        });
    };
    var onNoteChange = function(domEvent) {
        var value = domEvent.target.value;
        setNote(value);
    };
    var onNoteSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("ytid", info.video_yt_id);
        fd.set("note", note);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDNOTE), {
            body: fd
        }, function(data) {
            if (data.error === false) alert((0, _configuration.MESSAGE_VIDEO_NOTE_SAVED));
        });
    };
    var video_channel_title = info.video_channel_title, video_channel_yt_id = info.video_channel_yt_id, video_yt_id = info.video_yt_id, video_duration = info.video_duration, video_viewcount = info.video_viewcount, video_likecount = info.video_likecount, video_dislikecount = info.video_dislikecount, video_description = info.video_description, video_favoriteCount = info.video_favoriteCount, meow = info.meow, crt = info.crt, pubdate = info.pubdate, avadate = info.avadate, videoTags = info.videoTags, video_rating = info.video_rating;
    var pDate = "";
    if ((0, _dateFns.isValid)(pubdate)) pDate = (0, _dateFns.format)(pubdate, "PP");
    var aDate = "";
    if ((0, _dateFns.isValid)(avadate)) pDate = (0, _dateFns.format)(avadate, "PP");
    var duration = "";
    if ((0, _dateFns.isValid)(video_duration)) duration = (0, _utilities.formatTime)(video_duration);
    var getSysContent = function() {
        var vid = info;
        var tags = vid.hasOwnProperty("video_customtags") ? vid.video_customtags.replace(/,/, "") : "";
        var vid_id = vid.video_yt_id || "";
        var pubDate;
        // Comes in as a PHP timestamp.
        if (info.hasOwnProperty("video_publishdate")) pubDate = (0, _dateFns.isValid)(info.video_publishdate) ? (0, _dateFns.format)(new Date(info.video_publishdate * 1000), "PP") : null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsSelectDefault.default), {
                    mode: "video_info",
                    disabled: vid.video_alreadyprocessed === "n",
                    showEdit: false,
                    videoId: ytid
                }),
                getRatingsMenu(),
                getMeowMenu(),
                getCrtMenu(),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    className: "video__info__custom_tags video__info__field",
                    onSubmit: addTagsToVideo,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "videoid",
                            value: vid_id,
                            onChange: function() {}
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "tags",
                            children: "Add/Edit Custom Video Tags:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pleaseAddToAva.PleaseAddToAva), {
                            hidden: info.video_alreadyprocessed !== "n"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "form__input_button_group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    id: "tags",
                                    name: "tags",
                                    defaultValue: tags,
                                    placeholder: "Add Comma Separated Tags",
                                    disabled: info.video_alreadyprocessed === "n"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn btn--action",
                                    type: "submit",
                                    children: "Update Video Tags"
                                })
                            ]
                        })
                    ]
                }),
                getDeleteVideo(),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "video__info__field",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            children: "Channel Info:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                            className: "video__info__channel",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            className: "listText",
                                            children: "Name:"
                                        }),
                                        video_channel_title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            rel: "noopener noreferrer",
                                            target: "_blank",
                                            href: "https://www.youtube.com/channel/".concat(video_channel_yt_id, "/videos"),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "itemsBadge textLink divTransition",
                                                children: video_channel_title
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "itemsBadge",
                                            children: "Missing Channel Title"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            className: "listText",
                                            children: "Date:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "itemsBadge",
                                            children: pubDate
                                        })
                                    ]
                                })
                            ]
                        }),
                        getAddChannel(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoNote.VideoNote), {
                            onChange: onNoteChange,
                            onSubmit: onNoteSubmit,
                            value: info.video_note,
                            disabled: info.video_alreadyprocessed === "n"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
        ref: modalRef,
        onClose: oOnClose,
        id: id,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "video__info__container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactYoutubeDefault.default), {
                    id: ytid,
                    videoId: ytid,
                    opts: (0, _configuration.VIDEO_OPTIONS),
                    className: "video__info__vid"
                }),
                getAddBtn(),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "video__stats video__info__field",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            children: "Video Stats:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                            className: "list__meta__data video__stats__list",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Channel Name:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: video_channel_title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Publish Date:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: pDate
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Added to AVA:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: aDate
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Duration:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: duration
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Views:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: (0, _utilities.numberFormat)(video_viewcount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Likes:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: (0, _utilities.numberFormat)(video_likecount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Dislikes:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: (0, _utilities.numberFormat)(video_dislikecount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Favorites:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: (0, _utilities.numberFormat)(video_favoriteCount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    className: "video__stats__list_vt",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Video Tags:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "resizable--vert",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: videoTags
                                            })
                                        })
                                    ]
                                }),
                                makeVideoSets(),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Video Rating:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: video_rating
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                            children: "MEOW:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeMEOWCRT.BadgeMEOWCRT), (0, _objectSpreadProps._)((0, _objectSpread._)({
                                                mode: "meow"
                                            }, meowMenu), {
                                                fullSize: true
                                            }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                            title: "Content Review Team",
                                            children: "CRT:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeMEOWCRT.BadgeMEOWCRT), (0, _objectSpreadProps._)((0, _objectSpread._)({
                                                mode: "crt"
                                            }, crtMenu), {
                                                fullSize: true
                                            }))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "video__info__description video__info__field",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            children: "Video Description:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "description",
                            contentEditable: "true",
                            dangerouslySetInnerHTML: {
                                __html: video_description
                            }
                        })
                    ]
                }),
                getSysContent()
            ]
        })
    });
};
exports.default = VideoModal;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","prop-types":"fUIWk","react-youtube":"2vzH8","date-fns":"1h4Hj","../../../js/Utilities":"euxcI","../../../actions/SearchUtils":"hf48D","../../Destinations/DestinationsSelect":"9htHZ","../ModalDialog":"72kji","../RatingsMenu":"6sVW2","./CRTApprovalsMenu":"lPyZn","./MeowMenu":"3Oaad","./VideoNote":"gOZZg","../../Videos/BadgeMEOWCRT":"jWFU9","../../Videos/PleaseAddToAva":"6CriY","../CloseButton":"3MmmO","../../../js/Configuration":"k3dur","./css/VideoModal.css":"ktXP4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2vzH8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return YouTube_default;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
// src/YouTube.tsx
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fastDeepEqual = require("fast-deep-equal");
var _fastDeepEqualDefault = parcelHelpers.interopDefault(_fastDeepEqual);
var _youtubePlayer = require("youtube-player");
var _youtubePlayerDefault = parcelHelpers.interopDefault(_youtubePlayer);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var __spreadProps = function(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
};
var __async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
function shouldUpdateVideo(prevProps, props) {
    var _a, _b;
    if (prevProps.videoId !== props.videoId) return true;
    var prevVars = ((_a = prevProps.opts) == null ? void 0 : _a.playerVars) || {};
    var vars = ((_b = props.opts) == null ? void 0 : _b.playerVars) || {};
    return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
function filterResetOptions() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return __spreadProps(__spreadValues({}, opts), {
        height: 0,
        width: 0,
        playerVars: __spreadProps(__spreadValues({}, opts.playerVars), {
            autoplay: 0,
            start: 0,
            end: 0
        })
    });
}
function shouldResetPlayer(prevProps, props) {
    return prevProps.videoId !== props.videoId || !(0, _fastDeepEqualDefault.default)(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}
function shouldUpdatePlayer(prevProps, props) {
    var _a, _b, _c, _d;
    return prevProps.id !== props.id || prevProps.className !== props.className || ((_a = prevProps.opts) == null ? void 0 : _a.width) !== ((_b = props.opts) == null ? void 0 : _b.width) || ((_c = prevProps.opts) == null ? void 0 : _c.height) !== ((_d = props.opts) == null ? void 0 : _d.height) || prevProps.iframeClassName !== props.iframeClassName || prevProps.title !== props.title;
}
var defaultProps = {
    videoId: "",
    id: "",
    className: "",
    iframeClassName: "",
    style: {},
    title: "",
    loading: void 0,
    opts: {},
    onReady: function() {},
    onError: function() {},
    onPlay: function() {},
    onPause: function() {},
    onEnd: function() {},
    onStateChange: function() {},
    onPlaybackRateChange: function() {},
    onPlaybackQualityChange: function() {}
};
var propTypes = {
    videoId: (0, _propTypesDefault.default).string,
    id: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    iframeClassName: (0, _propTypesDefault.default).string,
    style: (0, _propTypesDefault.default).object,
    title: (0, _propTypesDefault.default).string,
    loading: (0, _propTypesDefault.default).oneOf([
        "lazy",
        "eager"
    ]),
    opts: (0, _propTypesDefault.default).objectOf((0, _propTypesDefault.default).any),
    onReady: (0, _propTypesDefault.default).func,
    onError: (0, _propTypesDefault.default).func,
    onPlay: (0, _propTypesDefault.default).func,
    onPause: (0, _propTypesDefault.default).func,
    onEnd: (0, _propTypesDefault.default).func,
    onStateChange: (0, _propTypesDefault.default).func,
    onPlaybackRateChange: (0, _propTypesDefault.default).func,
    onPlaybackQualityChange: (0, _propTypesDefault.default).func
};
var _YouTube = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(_YouTube1, _React_Component);
    var _super = (0, _createSuper._)(_YouTube1);
    function _YouTube1(props) {
        (0, _classCallCheck._)(this, _YouTube1);
        var _this;
        _this = _super.call(this, props);
        _this.destroyPlayerPromise = void 0;
        _this.onPlayerReady = function(event) {
            var _a, _b;
            return (_b = (_a = _this.props).onReady) == null ? void 0 : _b.call(_a, event);
        };
        _this.onPlayerError = function(event) {
            var _a, _b;
            return (_b = (_a = _this.props).onError) == null ? void 0 : _b.call(_a, event);
        };
        _this.onPlayerStateChange = function(event) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            (_b = (_a = _this.props).onStateChange) == null || _b.call(_a, event);
            switch(event.data){
                case _YouTube.PlayerState.ENDED:
                    (_d = (_c = _this.props).onEnd) == null || _d.call(_c, event);
                    break;
                case _YouTube.PlayerState.PLAYING:
                    (_f = (_e = _this.props).onPlay) == null || _f.call(_e, event);
                    break;
                case _YouTube.PlayerState.PAUSED:
                    (_h = (_g = _this.props).onPause) == null || _h.call(_g, event);
                    break;
                default:
            }
        };
        _this.onPlayerPlaybackRateChange = function(event) {
            var _a, _b;
            return (_b = (_a = _this.props).onPlaybackRateChange) == null ? void 0 : _b.call(_a, event);
        };
        _this.onPlayerPlaybackQualityChange = function(event) {
            var _a, _b;
            return (_b = (_a = _this.props).onPlaybackQualityChange) == null ? void 0 : _b.call(_a, event);
        };
        _this.destroyPlayer = function() {
            if (_this.internalPlayer) {
                _this.destroyPlayerPromise = _this.internalPlayer.destroy().then(function() {
                    return _this.destroyPlayerPromise = void 0;
                });
                return _this.destroyPlayerPromise;
            }
            return Promise.resolve();
        };
        _this.createPlayer = function() {
            if (typeof document === "undefined") return;
            if (_this.destroyPlayerPromise) {
                _this.destroyPlayerPromise.then(_this.createPlayer);
                return;
            }
            var playerOpts = __spreadProps(__spreadValues({}, _this.props.opts), {
                videoId: _this.props.videoId
            });
            _this.internalPlayer = (0, _youtubePlayerDefault.default)(_this.container, playerOpts);
            _this.internalPlayer.on("ready", _this.onPlayerReady);
            _this.internalPlayer.on("error", _this.onPlayerError);
            _this.internalPlayer.on("stateChange", _this.onPlayerStateChange);
            _this.internalPlayer.on("playbackRateChange", _this.onPlayerPlaybackRateChange);
            _this.internalPlayer.on("playbackQualityChange", _this.onPlayerPlaybackQualityChange);
            if (_this.props.title || _this.props.loading) _this.internalPlayer.getIframe().then(function(iframe) {
                if (_this.props.title) iframe.setAttribute("title", _this.props.title);
                if (_this.props.loading) iframe.setAttribute("loading", _this.props.loading);
            });
        };
        _this.resetPlayer = function() {
            return _this.destroyPlayer().then(_this.createPlayer);
        };
        _this.updatePlayer = function() {
            var _a;
            (_a = _this.internalPlayer) == null || _a.getIframe().then(function(iframe) {
                if (_this.props.id) iframe.setAttribute("id", _this.props.id);
                else iframe.removeAttribute("id");
                if (_this.props.iframeClassName) iframe.setAttribute("class", _this.props.iframeClassName);
                else iframe.removeAttribute("class");
                if (_this.props.opts && _this.props.opts.width) iframe.setAttribute("width", _this.props.opts.width.toString());
                else iframe.removeAttribute("width");
                if (_this.props.opts && _this.props.opts.height) iframe.setAttribute("height", _this.props.opts.height.toString());
                else iframe.removeAttribute("height");
                if (_this.props.title) iframe.setAttribute("title", _this.props.title);
                else iframe.setAttribute("title", "YouTube video player");
                if (_this.props.loading) iframe.setAttribute("loading", _this.props.loading);
                else iframe.removeAttribute("loading");
            });
        };
        _this.getInternalPlayer = function() {
            return _this.internalPlayer;
        };
        _this.updateVideo = function() {
            var _a, _b, _c, _d;
            if (typeof _this.props.videoId === "undefined" || _this.props.videoId === null) {
                (_a = _this.internalPlayer) == null || _a.stopVideo();
                return;
            }
            var autoplay = false;
            var opts = {
                videoId: _this.props.videoId
            };
            if ((_b = _this.props.opts) == null ? void 0 : _b.playerVars) {
                autoplay = _this.props.opts.playerVars.autoplay === 1;
                if ("start" in _this.props.opts.playerVars) opts.startSeconds = _this.props.opts.playerVars.start;
                if ("end" in _this.props.opts.playerVars) opts.endSeconds = _this.props.opts.playerVars.end;
            }
            if (autoplay) {
                (_c = _this.internalPlayer) == null || _c.loadVideoById(opts);
                return;
            }
            (_d = _this.internalPlayer) == null || _d.cueVideoById(opts);
        };
        _this.refContainer = function(container) {
            _this.container = container;
        };
        _this.container = null;
        _this.internalPlayer = null;
        return _this;
    }
    (0, _createClass._)(_YouTube1, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.createPlayer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                return __async(this, null, function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (shouldUpdatePlayer(prevProps, this.props)) this.updatePlayer();
                                if (!shouldResetPlayer(prevProps, this.props)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.resetPlayer()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (shouldUpdateVideo(prevProps, this.props)) this.updateVideo();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyPlayer();
            }
        },
        {
            key: "render",
            value: function render() {
                return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
                    className: this.props.className,
                    style: this.props.style
                }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
                    id: this.props.id,
                    className: this.props.iframeClassName,
                    ref: this.refContainer
                }));
            }
        }
    ]);
    return _YouTube1;
}((0, _reactDefault.default).Component);
var YouTube = _YouTube;
YouTube.propTypes = propTypes;
YouTube.defaultProps = defaultProps;
YouTube.PlayerState = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
};
var YouTube_default = YouTube;

},{"@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","@swc/helpers/_/_ts_generator":"7uYyU","prop-types":"fUIWk","react":"l5IPE","fast-deep-equal":"19brG","youtube-player":"umNiB","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"19brG":[function(require,module,exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"umNiB":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _typeof = typeof Symbol === "function" && (0, _typeOf._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
};
var _sister = require("b57d8c412065127f");
var _sister2 = _interopRequireDefault(_sister);
var _loadYouTubeIframeApi = require("c5742c4f1dbc1159");
var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
var _YouTubePlayer = require("e7235fa0d15c4f0b");
var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */ /**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */ var youtubeIframeAPI = void 0;
/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */ exports.default = function(maybeElementId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var emitter = (0, _sister2.default)();
    if (!youtubeIframeAPI) youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
    if (options.events) throw new Error("Event handlers cannot be overwritten.");
    if (typeof maybeElementId === "string" && !document.getElementById(maybeElementId)) throw new Error('Element "' + maybeElementId + '" does not exist.');
    options.events = _YouTubePlayer2.default.proxyEvents(emitter);
    var playerAPIReady = new Promise(function(resolve) {
        if ((typeof maybeElementId === "undefined" ? "undefined" : _typeof(maybeElementId)) === "object" && maybeElementId.playVideo instanceof Function) {
            var player = maybeElementId;
            resolve(player);
        } else // asume maybeElementId can be rendered inside
        // eslint-disable-next-line promise/catch-or-return
        youtubeIframeAPI.then(function(YT) {
            // eslint-disable-line promise/prefer-await-to-then
            var player = new YT.Player(maybeElementId, options);
            emitter.on("ready", function() {
                resolve(player);
            });
            return null;
        });
    });
    var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
    playerApi.on = emitter.on;
    playerApi.off = emitter.off;
    return playerApi;
};
module.exports = exports["default"];

},{"@swc/helpers/_/_type_of":"60jEQ","b57d8c412065127f":"5PPMp","c5742c4f1dbc1159":"8Phdb","e7235fa0d15c4f0b":"dzB9K"}],"5PPMp":[function(require,module,exports) {
"use strict";
var Sister;
/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/ Sister = function Sister() {
    var sister = {}, events = {};
    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */ /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */ sister.on = function(name, handler) {
        var listener = {
            name: name,
            handler: handler
        };
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };
    /**
     * @param {listener}
     */ sister.off = function(listener) {
        var index = events[listener.name].indexOf(listener);
        if (index !== -1) events[listener.name].splice(index, 1);
    };
    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */ sister.trigger = function(name, data) {
        var listeners = events[name], i;
        if (listeners) {
            i = listeners.length;
            while(i--)listeners[i].handler(data);
        }
    };
    return sister;
};
module.exports = Sister;

},{}],"8Phdb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _loadScript = require("38b3238846c649bc");
var _loadScript2 = _interopRequireDefault(_loadScript);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(emitter) {
    /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */ var iframeAPIReady = new Promise(function(resolve) {
        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
            resolve(window.YT);
            return;
        } else {
            var protocol = window.location.protocol === "http:" ? "http:" : "https:";
            (0, _loadScript2.default)(protocol + "//www.youtube.com/iframe_api", function(error) {
                if (error) emitter.trigger("error", error);
            });
        }
        var previous = window.onYouTubeIframeAPIReady;
        // The API will call this function when page has finished downloading
        // the JavaScript for the player API.
        window.onYouTubeIframeAPIReady = function() {
            if (previous) previous();
            resolve(window.YT);
        };
    });
    return iframeAPIReady;
};
module.exports = exports["default"];

},{"38b3238846c649bc":"4H5Nh"}],"4H5Nh":[function(require,module,exports) {
module.exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName("head")[0];
    var script = document.createElement("script");
    if (typeof opts === "function") {
        cb = opts;
        opts = {};
    }
    opts = opts || {};
    cb = cb || function() {};
    script.type = opts.type || "text/javascript";
    script.charset = opts.charset || "utf8";
    script.async = "async" in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) setAttributes(script, opts.attrs);
    if (opts.text) script.text = "" + opts.text;
    var onend = "onload" in script ? stdOnEnd : ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) stdOnEnd(script, cb);
    head.appendChild(script);
};
function setAttributes(script, attrs) {
    for(var attr in attrs)script.setAttribute(attr, attrs[attr]);
}
function stdOnEnd(script, cb) {
    script.onload = function() {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function() {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null;
        cb(new Error("Failed to load " + this.src), script);
    };
}
function ieOnEnd(script, cb) {
    script.onreadystatechange = function() {
        if (this.readyState != "complete" && this.readyState != "loaded") return;
        this.onreadystatechange = null;
        cb(null, script) // there is no way to catch loading errors in IE8
        ;
    };
}

},{}],"dzB9K":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _debug = require("d666b3669dc861db");
var _debug2 = _interopRequireDefault(_debug);
var _functionNames = require("2c53efa60e6c47a5");
var _functionNames2 = _interopRequireDefault(_functionNames);
var _eventNames = require("9d738db9b6ef0302");
var _eventNames2 = _interopRequireDefault(_eventNames);
var _FunctionStateMap = require("76c2169923072471");
var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable promise/prefer-await-to-then */ var debug = (0, _debug2.default)("youtube-player");
var YouTubePlayer = {};
/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */ YouTubePlayer.proxyEvents = function(emitter) {
    var events = {};
    var _loop = function _loop(eventName) {
        var onEventName = "on" + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
        events[onEventName] = function(event) {
            debug('event "%s"', onEventName, event);
            emitter.trigger(eventName, event);
        };
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventName = _step.value;
            _loop(eventName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return events;
};
/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */ YouTubePlayer.promisifyPlayer = function(playerAPIReady) {
    var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var functions = {};
    var _loop2 = function _loop2(functionName) {
        if (strictState && _FunctionStateMap2.default[functionName]) functions[functionName] = function() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return playerAPIReady.then(function(player) {
                var stateInfo = _FunctionStateMap2.default[functionName];
                var playerState = player.getPlayerState();
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                var value = player[functionName].apply(player, args);
                // TRICKY: For functions like `seekTo`, a change in state must be
                // triggered given that the resulting state could match the initial
                // state.
                if (stateInfo.stateChangeRequired || // eslint-disable-next-line no-extra-parens
                Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) return new Promise(function(resolve) {
                    var onPlayerStateChange = function onPlayerStateChange() {
                        var playerStateAfterChange = player.getPlayerState();
                        var timeout = void 0;
                        if (typeof stateInfo.timeout === "number") timeout = setTimeout(function() {
                            player.removeEventListener("onStateChange", onPlayerStateChange);
                            resolve();
                        }, stateInfo.timeout);
                        if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                            player.removeEventListener("onStateChange", onPlayerStateChange);
                            clearTimeout(timeout);
                            resolve();
                        }
                    };
                    player.addEventListener("onStateChange", onPlayerStateChange);
                }).then(function() {
                    return value;
                });
                return value;
            });
        };
        else functions[functionName] = function() {
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return playerAPIReady.then(function(player) {
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                return player[functionName].apply(player, args);
            });
        };
    };
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var functionName = _step2.value;
            _loop2(functionName);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
    return functions;
};
exports.default = YouTubePlayer;
module.exports = exports["default"];

},{"d666b3669dc861db":"bgp1I","2c53efa60e6c47a5":"40tjS","9d738db9b6ef0302":"dHaw8","76c2169923072471":"g0q0v"}],"bgp1I":[function(require,module,exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ var process = require("d29fc060f251f498");
exports = module.exports = require("76f79387d50f5378");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    "lightseagreen",
    "forestgreen",
    "goldenrod",
    "dodgerblue",
    "darkorchid",
    "crimson"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && window.process.type === "renderer") return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return "[UnexpectedJSONParseError]: " + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var _$useColors = this.useColors;
    args[0] = (_$useColors ? "%c" : "") + this.namespace + (_$useColors ? " %c" : " ") + args[0] + (_$useColors ? "%c " : " ") + "+" + exports.humanize(this.diff);
    if (!_$useColors) return;
    var c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ("%%" === match) return;
        index++;
        if ("%c" === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem("debug");
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof process !== "undefined" && "env" in process) r = undefined;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

},{"d29fc060f251f498":"3vU20","76f79387d50f5378":"jYgmm"}],"3vU20":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"jYgmm":[function(require,module,exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug["default"] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = require("a2f5baaa230fafe4");
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ("string" !== typeof args[0]) // anything else let's inspect with %O
        args.unshift("%O");
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === "%%") return match;
            index++;
            var formatter = exports.formatters[format];
            if ("function" === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ("function" === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, ".*?");
        if (namespaces[0] === "-") exports.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
        else exports.names.push(new RegExp("^" + namespaces + "$"));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable("");
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

},{"a2f5baaa230fafe4":"LFSGU"}],"LFSGU":[function(require,module,exports) {
/**
 * Helpers.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val);
    if (type === "string" && val.length > 0) return parse(val);
    else if (type === "number" && isNaN(val) === false) return options.long ? fmtLong(val) : fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * y;
        case "days":
        case "day":
        case "d":
            return n * d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtShort(ms) {
    if (ms >= d) return Math.round(ms / d) + "d";
    if (ms >= h) return Math.round(ms / h) + "h";
    if (ms >= m) return Math.round(ms / m) + "m";
    if (ms >= s) return Math.round(ms / s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtLong(ms) {
    return plural(ms, d, "day") || plural(ms, h, "hour") || plural(ms, m, "minute") || plural(ms, s, "second") || ms + " ms";
}
/**
 * Pluralization helper.
 */ function plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + " " + name;
    return Math.ceil(ms / n) + " " + name + "s";
}

},{"@swc/helpers/_/_type_of":"60jEQ"}],"40tjS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */ exports.default = [
    "cueVideoById",
    "loadVideoById",
    "cueVideoByUrl",
    "loadVideoByUrl",
    "playVideo",
    "pauseVideo",
    "stopVideo",
    "getVideoLoadedFraction",
    "cuePlaylist",
    "loadPlaylist",
    "nextVideo",
    "previousVideo",
    "playVideoAt",
    "setShuffle",
    "setLoop",
    "getPlaylist",
    "getPlaylistIndex",
    "setOption",
    "mute",
    "unMute",
    "isMuted",
    "setVolume",
    "getVolume",
    "seekTo",
    "getPlayerState",
    "getPlaybackRate",
    "setPlaybackRate",
    "getAvailablePlaybackRates",
    "getPlaybackQuality",
    "setPlaybackQuality",
    "getAvailableQualityLevels",
    "getCurrentTime",
    "getDuration",
    "removeEventListener",
    "getVideoUrl",
    "getVideoEmbedCode",
    "getOptions",
    "getOption",
    "addEventListener",
    "destroy",
    "setSize",
    "getIframe"
];
module.exports = exports["default"];

},{}],"dHaw8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */ exports.default = [
    "ready",
    "stateChange",
    "playbackQualityChange",
    "playbackRateChange",
    "error",
    "apiChange",
    "volumeChange"
];
module.exports = exports["default"];

},{}],"g0q0v":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _PlayerStates = require("ee14195859f97da8");
var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = {
    pauseVideo: {
        acceptableStates: [
            _PlayerStates2.default.ENDED,
            _PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: false
    },
    playVideo: {
        acceptableStates: [
            _PlayerStates2.default.ENDED,
            _PlayerStates2.default.PLAYING
        ],
        stateChangeRequired: false
    },
    seekTo: {
        acceptableStates: [
            _PlayerStates2.default.ENDED,
            _PlayerStates2.default.PLAYING,
            _PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: true,
        // TRICKY: `seekTo` may not cause a state change if no buffering is
        // required.
        timeout: 3000
    }
};
module.exports = exports["default"];

},{"ee14195859f97da8":"02cXG"}],"02cXG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
};
module.exports = exports["default"];

},{}],"hf48D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initLanguage", function() {
    return initLanguage;
});
parcelHelpers.export(exports, "initCriteria", function() {
    return initCriteria;
});
parcelHelpers.export(exports, "initGroups", function() {
    return initGroups;
});
parcelHelpers.export(exports, "initChannelsList", function() {
    return initChannelsList;
});
parcelHelpers.export(exports, "getRegions", function() {
    return getRegions;
});
parcelHelpers.export(exports, "getLanguages", function() {
    return getLanguages;
});
parcelHelpers.export(exports, "getGroups", function() {
    return getGroups;
});
parcelHelpers.export(exports, "setStateAfterGetRegions", function() {
    return setStateAfterGetRegions;
});
parcelHelpers.export(exports, "setStateAfterGetLangs", function() {
    return setStateAfterGetLangs;
});
parcelHelpers.export(exports, "search", function() {
    return search;
});
parcelHelpers.export(exports, "getChannels", function() {
    return getChannels;
});
parcelHelpers.export(exports, "addVideo", function() {
    return addVideo;
});
parcelHelpers.export(exports, "setStateOnGetGroups", function() {
    return setStateOnGetGroups;
});
parcelHelpers.export(exports, "setStateGetChannelBatch", function() {
    return setStateGetChannelBatch;
});
parcelHelpers.export(exports, "setStateAfterChannelBatch", function() {
    return setStateAfterChannelBatch;
});
parcelHelpers.export(exports, "setStateOnChannelList", function() {
    return setStateOnChannelList;
});
parcelHelpers.export(exports, "setStateOnChannelSearchSubmit", function() {
    return setStateOnChannelSearchSubmit;
});
parcelHelpers.export(exports, "setStateOnPerPageChange", function() {
    return setStateOnPerPageChange;
});
parcelHelpers.export(exports, "setStateOnChanFilterChange", function() {
    return setStateOnChanFilterChange;
});
parcelHelpers.export(exports, "setStateOnPanelToggle", function() {
    return setStateOnPanelToggle;
});
parcelHelpers.export(exports, "setStateOnHideChannels", function() {
    return setStateOnHideChannels;
});
parcelHelpers.export(exports, "setStateOnReset", function() {
    return setStateOnReset;
});
parcelHelpers.export(exports, "setStateOnCloseVideo", function() {
    return setStateOnCloseVideo;
});
parcelHelpers.export(exports, "setStateOnSetChannelGroup", function() {
    return setStateOnSetChannelGroup;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var _regionFlagsConfiguration = require("../js/RegionFlagsConfiguration");
var initLanguage = {
    code: "YTE",
    name: "All Languages"
};
var initCriteria = {
    order: "viewCount",
    channelsearch: [],
    search_group: 0
};
var initGroups = [
    {
        label: "Select Group",
        value: "0"
    }
];
var initChannelsList = {
    channels: [],
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    sortBy: "channel_title",
    ascending: true,
    filterKeyword: "",
    filterOn: "",
    loading: false
};
var getRegions = function() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    var fd = new FormData();
    fd.set("token", (0, _utilities.getAuthData)("token"));
    return (0, _utilities.apirequest)((0, _configuration.API_REGIONS), {
        body: fd
    }, callback);
};
var getLanguages = function(callback) {
    var fd = new FormData();
    fd.set("token", (0, _utilities.getAuthData)("token"));
    return (0, _utilities.apirequest)((0, _configuration.API_LANGUAGES), {
        body: fd
    }, callback);
};
var getGroups = function(callback) {
    var fd = new FormData();
    fd.set("token", (0, _utilities.getAuthData)("token"));
    return (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ALLGROUPS), {
        body: fd
    }, callback);
};
var setStateAfterGetRegions = function(state, response) {
    var regionShapes = response.map(function(region) {
        return {
            label: region.name,
            value: region.code
        };
    });
    return {
        regions: regionShapes
    };
};
var setStateAfterGetLangs = function(state, response) {
    var langShapes = response.map(function(language) {
        return {
            label: language.name,
            value: language.code
        };
    });
    return {
        languages: langShapes
    };
};
var search = function(options, callback) {
    return (0, _utilities.apirequest)((0, _configuration.API_SEARCH), options, callback);
};
var getChannels = function(options, callback) {
    return (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_BATCH), options, callback);
};
var addVideo = function(youtubeID, callback) {
    var ac = new AbortController();
    var signal = ac.signal;
    var fd = new FormData();
    fd.set("videoids", youtubeID);
    fd.set("setID", "-1");
    fd.set("blockID", "-1");
    fd.set("uuid", (0, _utilities.getAuthData)("uuid"));
    fd.set("userName", (0, _utilities.getAuthData)("user"));
    fd.set("token", (0, _utilities.getAuthData)("token"));
    var options = {
        method: "POST",
        body: fd,
        signal: signal
    };
    (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDNEW), options, callback);
};
var setStateOnGetGroups = function(state, groups) {
    return {
        groups: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.groups), {
            data: groups
        })
    };
};
var setStateGetChannelBatch = function(state) {
    var loading = (0, _utilities.showLoader)();
    return {
        channelslist: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelslist, loading), {
            open: true
        })
    };
};
var setStateAfterChannelBatch = function(state, data) {
    var notloading = (0, _utilities.hideLoader)();
    return {
        channelslist: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelslist, notloading), {
            channels: data.channels,
            currentPage: data.current_page,
            totalPages: data.pages
        })
    };
};
var setStateOnChannelList = function(state, value) {
    return {
        channelslist: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelslist), {
            currentPage: +state.channelslist.currentPage + +value
        })
    };
};
var setStateOnChannelSearchSubmit = function(state, value) {
    return {
        channelslist: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelslist), {
            open: false,
            filterKeyword: ""
        })
    };
};
var setStateOnPerPageChange = function(state, value) {
    return {
        channelslist: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelslist), {
            perPage: value
        })
    };
};
var setStateOnChanFilterChange = function(state, value) {
    return {
        channelslist: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelslist), {
            filterKeyword: value.toString(),
            filterOn: "channel_title"
        })
    };
};
var setStateOnPanelToggle = function(state, channel) {
    return {
        results: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.results), (0, _defineProperty._)({}, channel, (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.results[channel]), {
            open: !state.results[channel].open
        })))
    };
};
var setStateOnHideChannels = function(state) {
    var notloading = (0, _utilities.hideLoader)();
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, notloading), {
        channelslist: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.channelslist), {
            channels: [],
            currentPage: 1,
            perPage: 10,
            totalPages: 0,
            sortBy: "channel_title",
            ascending: true,
            filterKeyword: "",
            filterOn: "",
            open: false,
            loading: false
        })
    });
};
var setStateOnReset = function(state) {
    return {
        channelslist: {
            channels: [],
            currentPage: 1,
            perPage: (0, _configuration.VIDEOS_PER_PAGE),
            totalPages: 0,
            sortBy: "channel_title",
            ascending: true,
            filterKeyword: "",
            filterOn: ""
        },
        results: {},
        channelsearch: [],
        criteria: {
            order: "viewCount"
        }
    };
};
var setStateOnCloseVideo = function(state) {
    return {
        videoinfo: {
            open: false,
            videoData: {}
        }
    };
};
var setStateOnSetChannelGroup = function(state, value) {
    var notloading = (0, _utilities.hideLoader)();
    // Returns the group whose channels we want to search.
    var group = state.groups.data.find(function(item) {
        return item.group_id == value;
    });
    var channels = [];
    if (group && Object.hasOwn(group, "channelList")) channels = group.channelList;
    return (0, _objectSpread._)({
        channelsearch: channels
    }, notloading);
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","../js/Utilities":"euxcI","../js/Configuration":"k3dur","../js/RegionFlagsConfiguration":"auhPa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"auhPa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_FLAGS", function() {
    return REGION_FLAGS;
});
var REGION_FLAGS = [
    {
        flag: "\uD83C\uDF10",
        region: "All Regions"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDE8",
        region: "Ascension Island"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDE9",
        region: "Andorra"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDEA",
        region: "United Arab Emirates"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDEB",
        region: "Afghanistan"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDEC",
        region: "Antigua & Barbuda"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDEE",
        region: "Anguilla"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDF1",
        region: "Albania"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDF2",
        region: "Armenia"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDF4",
        region: "Angola"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDF6",
        region: "Antarctica"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDF7",
        region: "Argentina"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDF8",
        region: "American Samoa"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDF9",
        region: "Austria"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDFA",
        region: "Australia"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDFC",
        region: "Aruba"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDFD",
        region: "\xc5land Islands"
    },
    {
        flag: "\uD83C\uDDE6\uD83C\uDDFF",
        region: "Azerbaijan"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDE6",
        region: "Bosnia & Herzegovina"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDE7",
        region: "Barbados"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDE9",
        region: "Bangladesh"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDEA",
        region: "Belgium"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDEB",
        region: "Burkina Faso"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDEC",
        region: "Bulgaria"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDED",
        region: "Bahrain"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDEE",
        region: "Burundi"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDEF",
        region: "Benin"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF1",
        region: "St. Barth\xe9lemy"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF2",
        region: "Bermuda"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF3",
        region: "Brunei"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF4",
        region: "Bolivia"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF6",
        region: "Caribbean Netherlands"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF7",
        region: "Brazil"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF8",
        region: "Bahamas"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDF9",
        region: "Bhutan"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDFB",
        region: "Bouvet Island"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDFC",
        region: "Botswana"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDFE",
        region: "Belarus"
    },
    {
        flag: "\uD83C\uDDE7\uD83C\uDDFF",
        region: "Belize"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDE6",
        region: "Canada"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDE8",
        region: "Cocos (Keeling) Islands"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDE9",
        region: "Congo - Kinshasa"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDEB",
        region: "Central African Republic"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDEC",
        region: "Congo - Brazzaville"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDED",
        region: "Switzerland"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDEE",
        region: "C\xf4te d'Ivoire"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDF0",
        region: "Cook Islands"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDF1",
        region: "Chile"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDF2",
        region: "Cameroon"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDF3",
        region: "China"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDF4",
        region: "Colombia"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDF5",
        region: "Clipperton Island"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDF7",
        region: "Costa Rica"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDFA",
        region: "Cuba"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDFB",
        region: "Cape Verde"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDFC",
        region: "Cura\xe7ao"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDFD",
        region: "Christmas Island"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDFE",
        region: "Cyprus"
    },
    {
        flag: "\uD83C\uDDE8\uD83C\uDDFF",
        region: "Czechia"
    },
    {
        flag: "\uD83C\uDDE9\uD83C\uDDEA",
        region: "Germany"
    },
    {
        flag: "\uD83C\uDDE9\uD83C\uDDEC",
        region: "Diego Garcia"
    },
    {
        flag: "\uD83C\uDDE9\uD83C\uDDEF",
        region: "Djibouti"
    },
    {
        flag: "\uD83C\uDDE9\uD83C\uDDF0",
        region: "Denmark"
    },
    {
        flag: "\uD83C\uDDE9\uD83C\uDDF2",
        region: "Dominica"
    },
    {
        flag: "\uD83C\uDDE9\uD83C\uDDF4",
        region: "Dominican Republic"
    },
    {
        flag: "\uD83C\uDDE9\uD83C\uDDFF",
        region: "Algeria"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDE6",
        region: "Ceuta & Melilla"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDE8",
        region: "Ecuador"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDEA",
        region: "Estonia"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDEC",
        region: "Egypt"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDED",
        region: "Western Sahara"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDF7",
        region: "Eritrea"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDF8",
        region: "Spain"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDF9",
        region: "Ethiopia"
    },
    {
        flag: "\uD83C\uDDEA\uD83C\uDDFA",
        region: "European Union"
    },
    {
        flag: "\uD83C\uDDEB\uD83C\uDDEE",
        region: "Finland"
    },
    {
        flag: "\uD83C\uDDEB\uD83C\uDDEF",
        region: "Fiji"
    },
    {
        flag: "\uD83C\uDDEB\uD83C\uDDF0",
        region: "Falkland Islands"
    },
    {
        flag: "\uD83C\uDDEB\uD83C\uDDF2",
        region: "Micronesia"
    },
    {
        flag: "\uD83C\uDDEB\uD83C\uDDF4",
        region: "Faroe Islands"
    },
    {
        flag: "\uD83C\uDDEB\uD83C\uDDF7",
        region: "France"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDE6",
        region: "Gabon"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDE7",
        region: "United Kingdom"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDE9",
        region: "Grenada"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDEA",
        region: "Georgia"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDEB",
        region: "French Guiana"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDEC",
        region: "Guernsey"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDED",
        region: "Ghana"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDEE",
        region: "Gibraltar"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF1",
        region: "Greenland"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF2",
        region: "Gambia"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF3",
        region: "Guinea"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF5",
        region: "Guadeloupe"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF6",
        region: "Equatorial Guinea"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF7",
        region: "Greece"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF8",
        region: "South Georgia & South Sandwich Islands"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDF9",
        region: "Guatemala"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDFA",
        region: "Guam"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDFC",
        region: "Guinea-Bissau"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDFE",
        region: "Guyana"
    },
    {
        flag: "\uD83C\uDDED\uD83C\uDDF0",
        region: "Hong Kong SAR China"
    },
    {
        flag: "\uD83C\uDDED\uD83C\uDDF2",
        region: "Heard & McDonald Islands"
    },
    {
        flag: "\uD83C\uDDED\uD83C\uDDF3",
        region: "Honduras"
    },
    {
        flag: "\uD83C\uDDED\uD83C\uDDF7",
        region: "Croatia"
    },
    {
        flag: "\uD83C\uDDED\uD83C\uDDF9",
        region: "Haiti"
    },
    {
        flag: "\uD83C\uDDED\uD83C\uDDFA",
        region: "Hungary"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDE8",
        region: "Canary Islands"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDE9",
        region: "Indonesia"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDEA",
        region: "Ireland"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF1",
        region: "Israel"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF2",
        region: "Isle of Man"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF3",
        region: "India"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF4",
        region: "British Indian Ocean Territory"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF6",
        region: "Iraq"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF7",
        region: "Iran"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF8",
        region: "Iceland"
    },
    {
        flag: "\uD83C\uDDEE\uD83C\uDDF9",
        region: "Italy"
    },
    {
        flag: "\uD83C\uDDEF\uD83C\uDDEA",
        region: "Jersey"
    },
    {
        flag: "\uD83C\uDDEF\uD83C\uDDF2",
        region: "Jamaica"
    },
    {
        flag: "\uD83C\uDDEF\uD83C\uDDF4",
        region: "Jordan"
    },
    {
        flag: "\uD83C\uDDEF\uD83C\uDDF5",
        region: "Japan"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDEA",
        region: "Kenya"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDEC",
        region: "Kyrgyzstan"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDED",
        region: "Cambodia"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDEE",
        region: "Kiribati"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDF2",
        region: "Comoros"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDF3",
        region: "St. Kitts & Nevis"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDF5",
        region: "North Korea"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDF7",
        region: "South Korea"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDFC",
        region: "Kuwait"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDFE",
        region: "Cayman Islands"
    },
    {
        flag: "\uD83C\uDDF0\uD83C\uDDFF",
        region: "Kazakhstan"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDE6",
        region: "Laos"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDE7",
        region: "Lebanon"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDE8",
        region: "St. Lucia"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDEE",
        region: "Liechtenstein"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDF0",
        region: "Sri Lanka"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDF7",
        region: "Liberia"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDF8",
        region: "Lesotho"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDF9",
        region: "Lithuania"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDFA",
        region: "Luxembourg"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDFB",
        region: "Latvia"
    },
    {
        flag: "\uD83C\uDDF1\uD83C\uDDFE",
        region: "Libya"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDE6",
        region: "Morocco"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDE8",
        region: "Monaco"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDE9",
        region: "Moldova"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDEA",
        region: "Montenegro"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDEB",
        region: "St. Martin"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDEC",
        region: "Madagascar"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDED",
        region: "Marshall Islands"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF0",
        region: "North Macedonia"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF1",
        region: "Mali"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF2",
        region: "Myanmar (Burma)"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF3",
        region: "Mongolia"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF4",
        region: "Macao Sar China"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF5",
        region: "Northern Mariana Islands"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF6",
        region: "Martinique"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF7",
        region: "Mauritania"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF8",
        region: "Montserrat"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDF9",
        region: "Malta"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDFA",
        region: "Mauritius"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDFB",
        region: "Maldives"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDFC",
        region: "Malawi"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDFD",
        region: "Mexico"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDFE",
        region: "Malaysia"
    },
    {
        flag: "\uD83C\uDDF2\uD83C\uDDFF",
        region: "Mozambique"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDE6",
        region: "Namibia"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDE8",
        region: "New Caledonia"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDEA",
        region: "Niger"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDEB",
        region: "Norfolk Island"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDEC",
        region: "Nigeria"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDEE",
        region: "Nicaragua"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDF1",
        region: "Netherlands"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDF4",
        region: "Norway"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDF5",
        region: "Nepal"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDF7",
        region: "Nauru"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDFA",
        region: "Niue"
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDFF",
        region: "New Zealand"
    },
    {
        flag: "\uD83C\uDDF4\uD83C\uDDF2",
        region: "Oman"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDE6",
        region: "Panama"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDEA",
        region: "Peru"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDEB",
        region: "French Polynesia"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDEC",
        region: "Papua New Guinea"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDED",
        region: "Philippines"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF0",
        region: "Pakistan"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF1",
        region: "Poland"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF2",
        region: "St. Pierre & Miquelon"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF3",
        region: "Pitcairn Islands"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF7",
        region: "Puerto Rico"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF8",
        region: "Palestinian Territories"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF9",
        region: "Portugal"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDFC",
        region: "Palau"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDFE",
        region: "Paraguay"
    },
    {
        flag: "\uD83C\uDDF6\uD83C\uDDE6",
        region: "Qatar"
    },
    {
        flag: "\uD83C\uDDF7\uD83C\uDDEA",
        region: "R\xe9union"
    },
    {
        flag: "\uD83C\uDDF7\uD83C\uDDF4",
        region: "Romania"
    },
    {
        flag: "\uD83C\uDDF7\uD83C\uDDF8",
        region: "Serbia"
    },
    {
        flag: "\uD83C\uDDF7\uD83C\uDDFA",
        region: "Russia"
    },
    {
        flag: "\uD83C\uDDF7\uD83C\uDDFC",
        region: "Rwanda"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDE6",
        region: "Saudi Arabia"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDE7",
        region: "Solomon Islands"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDE8",
        region: "Seychelles"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDE9",
        region: "Sudan"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDEA",
        region: "Sweden"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDEC",
        region: "Singapore"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDED",
        region: "St. Helena"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDEE",
        region: "Slovenia"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDEF",
        region: "Svalbard & Jan Mayen"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF0",
        region: "Slovakia"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF1",
        region: "Sierra Leone"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF2",
        region: "San Marino"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF3",
        region: "Senegal"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF4",
        region: "Somalia"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF7",
        region: "Suriname"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF8",
        region: "South Sudan"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF9",
        region: "S\xe3o Tom\xe9 & Pr\xedncipe"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDFB",
        region: "El Salvador"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDFD",
        region: "Sint Maarten"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDFE",
        region: "Syria"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDFF",
        region: "Eswatini"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDE6",
        region: "Tristan Da Cunha"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDE8",
        region: "Turks & Caicos Islands"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDE9",
        region: "Chad"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDEB",
        region: "French Southern Territories"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDEC",
        region: "Togo"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDED",
        region: "Thailand"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDEF",
        region: "Tajikistan"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDF0",
        region: "Tokelau"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDF1",
        region: "Timor-Leste"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDF2",
        region: "Turkmenistan"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDF3",
        region: "Tunisia"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDF4",
        region: "Tonga"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDF7",
        region: "Turkey"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDF9",
        region: "Trinidad & Tobago"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDFB",
        region: "Tuvalu"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDFC",
        region: "Taiwan"
    },
    {
        flag: "\uD83C\uDDF9\uD83C\uDDFF",
        region: "Tanzania"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDE6",
        region: "Ukraine"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDEC",
        region: "Uganda"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDF2",
        region: "U.S. Outlying Islands"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDF3",
        region: "United Nations"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDF8",
        region: "United States"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDFE",
        region: "Uruguay"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDFF",
        region: "Uzbekistan"
    },
    {
        flag: "\uD83C\uDDFB\uD83C\uDDE6",
        region: "Vatican City"
    },
    {
        flag: "\uD83C\uDDFB\uD83C\uDDE8",
        region: "St. Vincent & Grenadines"
    },
    {
        flag: "\uD83C\uDDFB\uD83C\uDDEA",
        region: "Venezuela"
    },
    {
        flag: "\uD83C\uDDFB\uD83C\uDDEC",
        region: "British Virgin Islands"
    },
    {
        flag: "\uD83C\uDDFB\uD83C\uDDEE",
        region: "U.S. Virgin Islands"
    },
    {
        flag: "\uD83C\uDDFB\uD83C\uDDF3",
        region: "Vietnam"
    },
    {
        flag: "\uD83C\uDDFB\uD83C\uDDFA",
        region: "Vanuatu"
    },
    {
        flag: "\uD83C\uDDFC\uD83C\uDDEB",
        region: "Wallis & Futuna"
    },
    {
        flag: "\uD83C\uDDFC\uD83C\uDDF8",
        region: "Samoa"
    },
    {
        flag: "\uD83C\uDDFD\uD83C\uDDF0",
        region: "Kosovo"
    },
    {
        flag: "\uD83C\uDDFE\uD83C\uDDEA",
        region: "Yemen"
    },
    {
        flag: "\uD83C\uDDFE\uD83C\uDDF9",
        region: "Mayotte"
    },
    {
        flag: "\uD83C\uDDFF\uD83C\uDDE6",
        region: "South Africa"
    },
    {
        flag: "\uD83C\uDDFF\uD83C\uDDF2",
        region: "Zambia"
    },
    {
        flag: "\uD83C\uDDFF\uD83C\uDDFC",
        region: "Zimbabwe"
    },
    {
        flag: "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
        region: "England"
    },
    {
        flag: "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
        region: "Scotland"
    },
    {
        flag: "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
        region: "Wales"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9htHZ":[function(require,module,exports) {
/**
 * DestinationsSelect
 * Used on VideoInfo only to select a destination
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectMenu = require("../subcomponents/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _dateFns = require("date-fns");
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var _destinationsSelectCss = require("../Destinations/css/DestinationsSelect.css");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var DestinationsSelect = function(param) {
    var disabled = param.disabled, mode = param.mode, videoId = param.videoId, onSubmit = param.onSubmit, onVideosLoad = param.onVideosLoad;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        disabled: false,
        options: [],
        mode: "select",
        value: null,
        name: null
    }), 2), destinations = _useState[0], setDestinations = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        options: [],
        mode: "select",
        value: null,
        disabled: true,
        deleteDisabled: true,
        editDisabled: true,
        name: null
    }), 2), videosets = _useState1[0], setVideoSets = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({
        options: [],
        mode: "select",
        value: null,
        newDate: null,
        datePickerDisabled: false,
        disabled: true
    }), 2), videosetblocks = _useState2[0], setVideoSetBlocks = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(true), 2), disableAddVideoToDestination = _useState3[0], setDisableAddVideoToDestination = _useState3[1];
    var newBlockRef = (0, _react.useRef)(null);
    var newDestinationRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        if (!destinations.options.length) getDestinations();
    }, [
        destinations
    ]);
    var getDestinations = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_LIST), {
            body: fd
        }, onDestinationsLoaded);
    };
    var getVideoSets = function(id) {
        var fd = new FormData();
        fd.set("id", id);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_ASSIGNMENTS), {
            body: fd
        }, function(data) {
            onVideoSetsLoaded(data);
        });
    };
    var getBlockList = function(value) {
        if (!value) return;
        if (videosetblocks.mode === "create") return;
        /* Only make this request if the mode is 'select' */ var fd = new FormData();
        fd.set("id", value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ASSIGNMENTS), {
            body: fd
        }, function(response) {
            onBlockListLoaded(response);
        });
    };
    var getVideosForBlock = function() {
        var fd = new FormData();
        fd.set("id", videosetblocks.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_INFO), {
            body: fd
        }, function(response) {
            setDisableAddVideoToDestination(false);
        });
    };
    var onDestinationsLoaded = function() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var dl = [
            {
                value: "",
                label: " "
            },
            {
                value: "create",
                label: "Create Destination"
            }
        ];
        var list = data.map(function(item) {
            return {
                value: item.dID,
                label: item.dName
            };
        });
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            disabled: false,
            options: dl.concat(list)
        }));
    };
    var onVideoSetsLoaded = function() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var vsl = [
            {
                value: "",
                label: " "
            },
            {
                value: "create",
                label: "Create Video Set"
            }
        ];
        var videoSetList = [];
        if (data.length) videoSetList = data.map(function(item) {
            return {
                value: item.setID,
                label: item.setName
            };
        });
        setVideoSets((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosets), {
            options: vsl.concat(videoSetList),
            disabled: false
        }));
    };
    var onCreateDestinationCancel = function(event) {
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            mode: "select",
            value: null,
            name: null
        }));
    };
    var onDestinationSelect = function(domEvent) {
        var value = domEvent.target.value;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            value: value,
            mode: value === "create" ? "create" : "select"
        }));
        if (value === "create") setVideoSets((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosets), {
            disabled: true
        }));
        else getVideoSets(value);
    };
    var onCreateDestinationChange = function(domEvent) {
        var value = domEvent.target.value;
        setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
            name: value
        }));
    };
    var onCreateDestinationSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("name", destinations.name);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_ADDNEW), {
            body: fd
        }, function(response) {
            if (response.result === "success") {
                var newDestination = {
                    value: response.d_id,
                    label: response.d_name
                };
                setDestinations((0, _objectSpreadProps._)((0, _objectSpread._)({}, destinations), {
                    value: response.d_id,
                    mode: "select",
                    options: (0, _toConsumableArray._)(destinations.options).concat(newDestination)
                }));
                getVideoSets(response.d_id);
            } else alert(response.message);
        });
    };
    var onCreateVideoSetCancel = function() {
        setVideoSets((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosets), {
            mode: "select",
            value: null,
            name: null
        }));
    };
    var onVideoSetSelect = function(domEvent) {
        var value = domEvent.target.value;
        setVideoSets((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosets), {
            value: value,
            deleteDisabled: value ? false : true,
            mode: value === "create" ? "create" : "select"
        }));
        if (value === "create") setVideoSetBlocks((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosetblocks), {
            disabled: true
        }));
        else getBlockList(value);
    };
    var onCreateVideoSetChange = function(domEvent) {
        var value = domEvent.target.value;
        setVideoSets((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosets), {
            name: value
        }));
    };
    var onCreateVideoSetSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("name", videosets.name);
        fd.set("destination", destinations.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ADDNEW), {
            body: fd
        }, function(response) {
            if (response.result !== "success") {
                alert(response.message);
                return false;
            }
            setVideoSets((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosets), {
                mode: "select",
                value: response.setID,
                options: (0, _toConsumableArray._)(videosets.options).concat([
                    {
                        value: "".concat(response.setID),
                        label: response.setName
                    }
                ]),
                disabled: false
            }));
            getBlockList(response.setID);
        });
    };
    var onVideoBlockSelect = function(domEvent) {
        var value = domEvent.target.value;
        setVideoSetBlocks((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosetblocks), {
            value: value,
            mode: value === "create" ? "create" : "select"
        }));
        getVideosForBlock(value);
    };
    var onBlockListLoaded = function() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var bl = [
            {
                value: "",
                label: " "
            },
            {
                value: "create",
                label: "Create Instance/Episode"
            }
        ];
        var blocks = data.map(function(item) {
            var vsb_datetimetorun = item.vsb_datetimetorun, vsb_id = item.vsb_id, contains_interstitial = item.contains_interstitial;
            var rundate = "";
            var interstitial = "";
            if (vsb_datetimetorun === null || vsb_datetimetorun === "0000-00-00") rundate = (0, _configuration.NULL_DATE_TEXT);
            else {
                var date = new Date(vsb_datetimetorun);
                rundate = (0, _dateFns.format)(date, "PP", {
                    timeZone: "Etc/UTC"
                });
            }
            if (contains_interstitial) interstitial = " ".concat((0, _configuration.INTERSTITIAL_INDICATOR), " ");
            return {
                value: vsb_id,
                label: "".concat(rundate, " ").concat(interstitial)
            };
        });
        setVideoSetBlocks((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosetblocks), {
            options: bl.concat(blocks),
            deleteDisabled: false,
            disabled: false
        }));
    };
    var onCreateBlockSubmit = function(domEvent) {
        domEvent.preventDefault();
        var newDate = videosetblocks.newDate;
        var yyyymmdd = "0000-00-00";
        var dateTxt = (0, _configuration.NULL_DATE_TEXT);
        if ((0, _dateFns.isValid)(newDate)) {
            yyyymmdd = (0, _dateFns.format)(newDate, "yyyy-MM-dd", {
                timeZone: "Etc/UTC"
            });
            dateText = (0, _dateFns.format)(newDate, "PP", {
                timeZone: "Etc/UTC"
            });
        }
        var fd = new FormData();
        fd.set("date", yyyymmdd);
        fd.set("setID", videosets.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_ADDNEW), {
            body: fd
        }, function(response) {
            if (response.result === "success") {
                var newblock = [
                    {
                        value: response.blockID,
                        label: dateText
                    }
                ];
                setVideoSetBlocks((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosetblocks), {
                    options: (0, _toConsumableArray._)(videosetblocks.options).concat(newblock),
                    mode: "select",
                    value: response.blockID,
                    datePickerDisabled: false
                }));
            } else alert(response.message);
        });
    };
    var onCreateBlockDateSelect = function(value) {
        setVideoSetBlocks((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosetblocks), {
            newDate: value
        }));
    };
    var blockNoDateSelected = function(domEvent) {
        var checked = domEvent.target.checked;
        setVideoSetBlocks((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosetblocks), {
            datePickerDisabled: checked,
            newDate: ""
        }));
    };
    var onCreateBlockDateReset = function() {
        setVideoSetBlocks((0, _objectSpreadProps._)((0, _objectSpread._)({}, videosetblocks), {
            mode: "select",
            value: "",
            newDate: null
        }));
    };
    var onCloneVideo = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("ytid", videoId);
        fd.set("setid", videosets.value);
        fd.set("blockid", videosetblocks.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDTOSET), {
            body: fd
        }, function(response) {
            if (response.success) alert("Video added to destination.");
        });
    };
    var makeDestinations = function() {
        if (destinations.mode === "create") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
            id: "destinations__new_dest",
            className: "destinations__create__new",
            onReset: onCreateDestinationCancel,
            onSubmit: onCreateDestinationSubmit,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form__label_btn_group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "destination_name form__access__label",
                        children: "Enter a name for this destination"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        className: "form-control",
                        onChange: onCreateDestinationChange,
                        id: "destination_name",
                        name: "destination_name",
                        maxLength: "50"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        disabled: !destinations.name,
                        className: "btn btn--action",
                        children: "Create"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "reset",
                        className: "btn btn-light",
                        children: "Cancel"
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                cssClass: "video__modal__destinations__select",
                name: "DestinationsSelect__destination",
                id: "DestinationsSelect__destination",
                options: destinations.options,
                labelText: "Select Destination",
                value: destinations.value,
                disabled: destinations.disabled || disabled,
                onChangeHandler: onDestinationSelect
            })
        });
    };
    var makeVideoSets = function() {
        if (videosets.mode === "create") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
            id: "destinations__new_videoset",
            className: "destinations__create__new",
            onReset: onCreateVideoSetCancel,
            onSubmit: onCreateVideoSetSubmit,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form__label_btn_group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "list_name",
                        children: "Enter a name for this video set"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        className: "form-control",
                        id: "list_name",
                        name: "list_name",
                        maxLength: "100",
                        onChange: onCreateVideoSetChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "reset",
                        className: "btn btn-default",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        disabled: !videosets.name,
                        className: "btn btn-default",
                        children: "Create"
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                cssClass: "video__modal__destinations__select",
                name: "DestinationsSelect__videoset",
                id: "DestinationsSelect__videoset",
                options: videosets.options,
                labelText: "Select Video Set",
                value: videosets.value,
                disabled: videosets.disabled,
                onChangeHandler: onVideoSetSelect
            })
        });
    };
    var makeVideoBlocks = function() {
        if (videosetblocks.mode === "create") {
            var newDate = videosetblocks.newDate, datePickerDisabled = videosetblocks.datePickerDisabled;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                method: "dialog",
                className: "dateCreateContainer destinations__date_select",
                onSubmit: onCreateBlockSubmit,
                onReset: onCreateBlockDateReset,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                        disabled: datePickerDisabled,
                        id: "create_date",
                        selected: newDate,
                        onChange: onCreateBlockDateSelect,
                        dateFormat: "PP"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "fancy__chex",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                id: "no_date",
                                name: "create_date_none",
                                onChange: blockNoDateSelected
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "no_date",
                                children: "Unscheduled (No date)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "button__group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "btn btn-sm",
                                children: "Create"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "reset",
                                className: "btn btn-sm",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), (0, _defineProperty._)({
                cssClass: "video__modal__destinations__select",
                name: "DestinationsSelect__rundate",
                id: "DestinationsSelect__rundate",
                options: videosetblocks.options,
                labelText: "Select Video Set Run Date",
                value: videosetblocks.value,
                disabled: !videosets.value || !destinations.value,
                onChangeHandler: onVideoBlockSelect
            }, "disabled", videosetblocks.disabled))
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: "destinations__component destinations__component--videos",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                children: "Add Video to Destination:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                hidden: !disabled,
                className: "form__instructions",
                children: (0, _configuration.MESSAGE_ADD_TO_AVA)
            }),
            makeDestinations(),
            makeVideoSets(),
            makeVideoBlocks(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                id: "DestinationsSelect",
                action: "/",
                method: "post",
                onSubmit: onCloneVideo,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    id: "DestinationsSelect",
                    type: "submit",
                    className: "btn btn--action",
                    disabled: disableAddVideoToDestination,
                    children: "Add Video To Destination"
                })
            })
        ]
    });
};
exports.default = DestinationsSelect;

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/SelectMenu":"da8gs","date-fns":"1h4Hj","react-datepicker":"2SKYH","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","../Destinations/css/DestinationsSelect.css":"7RJ0l","react-datepicker/dist/react-datepicker.css":"4U9hY","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"da8gs":[function(require,module,exports) {
/**
 * SelectMenu.js
 * A no-framework dropdown menu. This functions as an UNCONTROLLED component and
 * returns the selected VALUE to the onChangeHandler, property rather than the 
 * entire DOMEvent.
 *
 * To return the entire DOMEvent and have a CONTROLLED component, use the
 * SelectMenuControlled component.
 * 
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _selectOption = require("./SelectOption");
var _selectOptionDefault = parcelHelpers.interopDefault(_selectOption);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _selectMenuCss = require("../../css/SelectMenu.css");
var SelectMenu = function(param) {
    var onChangeHandler = param.onChangeHandler, cssClass = param.cssClass, id = param.id, name = param.name, size = param.size, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? false : _param_multiple, _param_isRequired = param.isRequired, isRequired = _param_isRequired === void 0 ? false : _param_isRequired, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_firstEmpty = param.firstEmpty, firstEmpty = _param_firstEmpty === void 0 ? false : _param_firstEmpty, _param_labelledby = param.labelledby, labelledby = _param_labelledby === void 0 ? null : _param_labelledby, _param_describedBy = param.describedBy, describedBy = _param_describedBy === void 0 ? null : _param_describedBy, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "NEEDS A LABEL" : _param_labelText, _param_options = param.options, options = _param_options === void 0 ? [
        {
            label: "Empty Menu",
            value: ""
        }
    ] : _param_options, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? null : _param_disabled;
    var makeOptions = function(arrayOfObjects) {
        return arrayOfObjects.map(function(o, x) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectOptionDefault.default), {
                value: o.value,
                label: o.label
            }, x.toString());
        });
    };
    var cssClasses = (0, _classnamesDefault.default)("ava-input-select", cssClass);
    var opts = makeOptions(options);
    if (firstEmpty) opts.unshift(/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {}, "selectmenufirstempty"));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: labelText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                required: isRequired,
                defaultValue: value,
                id: id || name,
                name: name,
                onChange: onChangeHandler,
                size: size,
                multiple: multiple,
                "aria-labelledby": labelledby,
                "aria-describedby": describedBy,
                disabled: disabled,
                children: opts
            })
        ]
    });
};
exports.default = SelectMenu;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./SelectOption":"lqdWV","classnames":"8N3a2","../../css/SelectMenu.css":"cUBB3","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cUBB3":[function() {},{}],"2SKYH":[function(require,module,exports) {
/*!
  react-datepicker v7.3.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ !function(e, t) {
    t(exports, require("328b40e48ebebf49"), require("55b400dfb9477df9"), require("11a993db5effee60"), require("5fc940b8b11b2f30"), require("4f1b37d05fed00b3"), require("786b9925c1b6b5ed"), require("baecc74d7df402ea"), require("13428a01c277b105"), require("11178028a6b82c2f"), require("b78d0278e54da1b4"), require("7360dafd9cf06bde"), require("1a7d4440a348b466"), require("50dce9ec585a5332"), require("1282d380e0614c2b"), require("cdc90b6df52760f"), require("5c05196fbf6d6b4d"), require("23c6d2169b7feabe"), require("9a6937c0aa7a418e"), require("7ec00ac1947d54ca"), require("d7b993ace1eca80"), require("5592c752ef1290f4"), require("42e3036b4499153e"), require("72fc20cc52029f11"), require("8406427195a66845"), require("12eec1f6d562e008"), require("fa470ac376b26caf"), require("bf3222da2f520817"), require("e8ff49b0d1cab426"), require("d6dea87c85b53e02"), require("685dda4962dc82e1"), require("c3348d940b830a7f"), require("53a4aaeeb87e1c51"), require("13c776570732a9da"), require("fda4089c257f1876"), require("b5061c3c95f48e73"), require("f57afb99b9b06613"), require("6663b9b2b265a941"), require("496ef8c8ed2b34d6"), require("6553b0b4b603e1c3"), require("45f66dd8a17e85aa"), require("9818583261d8a102"), require("47020b485e994171"), require("201a807b2e6adc5e"), require("a89a534c753bb4c3"), require("80c2a8fbe4339722"), require("8ac41f1b252a0973"), require("e1fbbdf633f9e5ae"), require("156a522b3b8fd124"), require("f2620442a53b80d6"), require("b9a1398c1c94250d"), require("1b94d4eb34edeca3"), require("2fdd28e51cf3c8b2"), require("964e71bf85841794"), require("38468de993ee0549"), require("72fb68fdc0d9bca3"), require("ec1866b328e982ea"), require("aa659b497503e983"), require("f501b8cd52ae4ff"), require("d616e9f0b9bc7b7a"), require("7b7bf8fb2c20e0c7"), require("9e212fc4b323ed41"), require("a3a5398768dc185f"), require("c3c8699f35b37adb"), require("96de361de41dc920"));
}(this, function(e, t, r, n, a, o, s, i, l, c, p, d, u, f, h, m, v, g, D, y, k, w, S, b, M, C, _, E, P, Y, x, N, O, I, T, R, L, A, F, H, W, Q, q, K, B, V, j, U, $, z, X, G, J, Z, ee, te, re, ne, ae, oe, se, ie, le, ce, pe) {
    "use strict";
    function de(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var ue = de(r), fe = de(n), he = de(pe), me = function me1(e, t) {
        return me = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var _$r in t)Object.prototype.hasOwnProperty.call(t, _$r) && (e[_$r] = t[_$r]);
        }, me(e, t);
    };
    function ve(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function r() {
            this.constructor = e;
        }
        me(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
    }
    var ge = function ge1() {
        return ge = Object.assign || function(e) {
            for(var t, _$r = 1, _$n = arguments.length; _$r < _$n; _$r++)for(var a in t = arguments[_$r])Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
        }, ge.apply(this, arguments);
    };
    function De(e, t, r) {
        if (r || 2 === arguments.length) for(var _$n, a = 0, o = t.length; a < o; a++)!_$n && a in t || (_$n || (_$n = Array.prototype.slice.call(t, 0, a)), _$n[a] = t[a]);
        return e.concat(_$n || Array.prototype.slice.call(t));
    }
    "function" == typeof SuppressedError && SuppressedError;
    var ye, ke = function ke(e) {
        var t = e.showTimeSelectOnly, _$r = void 0 !== t && t, _$n = e.showTime, a = void 0 !== _$n && _$n, o = e.className, s = e.children, i = _$r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
        return ue.default.createElement("div", {
            className: o,
            role: "dialog",
            "aria-label": i,
            "aria-modal": "true"
        }, s);
    };
    function we() {
        return "undefined" != typeof window ? window : globalThis;
    }
    !function(e) {
        e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
    }(ye || (ye = {}));
    var Se = 12, be = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Me(e) {
        if (null == e) return new Date;
        var t = "string" == typeof e ? B.parseISO(e) : le.toDate(e);
        return Ce(t) ? t : new Date;
    }
    function Ce(e, t) {
        return H.isValid(e) && !O.isBefore(e, null != t ? t : new Date("1/1/1800"));
    }
    function _e(e, t, r) {
        if ("en" === r) return k.format(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var _$n = r ? Ke(r) : void 0;
        return r && !_$n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !_$n && qe() && Ke(qe()) && (_$n = Ke(qe())), k.format(e, t, {
            locale: _$n,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Ee(e, t) {
        var _$r = t.dateFormat, _$n = t.locale, a = Array.isArray(_$r) && _$r.length > 0 ? _$r[0] : _$r;
        return e && _e(e, a, _$n) || "";
    }
    function Pe(e, t) {
        var _$r = t.hour, _$n = void 0 === _$r ? 0 : _$r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second, i = void 0 === s ? 0 : s;
        return j.setHours(U.setMinutes(X.setSeconds(e, i), o), _$n);
    }
    function Ye(e) {
        return J.startOfDay(e);
    }
    function xe(e, t, r) {
        var _$n = Ke(t || qe());
        return te.startOfWeek(e, {
            locale: _$n,
            weekStartsOn: r
        });
    }
    function Ne(e) {
        return Z.startOfMonth(e);
    }
    function Oe(e) {
        return re.startOfYear(e);
    }
    function Ie(e) {
        return ee.startOfQuarter(e);
    }
    function Te() {
        return J.startOfDay(Me());
    }
    function Re(e) {
        return v.endOfDay(e);
    }
    function Le(e, t) {
        return e && t ? F.isSameYear(e, t) : !e && !t;
    }
    function Ae(e, t) {
        return e && t ? L.isSameMonth(e, t) : !e && !t;
    }
    function Fe(e, t) {
        return e && t ? A.isSameQuarter(e, t) : !e && !t;
    }
    function He(e, t) {
        return e && t ? R.isSameDay(e, t) : !e && !t;
    }
    function We(e, t) {
        return e && t ? T.isEqual(e, t) : !e && !t;
    }
    function Qe(e, t, r) {
        var _$n, a = J.startOfDay(t), o = v.endOfDay(r);
        try {
            _$n = W.isWithinInterval(e, {
                start: a,
                end: o
            });
        } catch (e) {
            _$n = !1;
        }
        return _$n;
    }
    function qe() {
        return we().__localeId__;
    }
    function Ke(e) {
        if ("string" == typeof e) {
            var t = we();
            return t.__localeData__ ? t.__localeData__[e] : void 0;
        }
        return e;
    }
    function Be(e, t) {
        return _e($.setMonth(Me(), e), "LLLL", t);
    }
    function Ve(e, t) {
        return _e($.setMonth(Me(), e), "LLL", t);
    }
    function je(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.maxDate, o = _$r.excludeDates, s = _$r.excludeDateIntervals, i = _$r.includeDates, l = _$r.includeDateIntervals, c = _$r.filterDate;
        return tt(e, {
            minDate: _$n,
            maxDate: a
        }) || o && o.some(function(t) {
            var _$r;
            return t instanceof Date ? He(e, t) : He(e, null !== (_$r = t.date) && void 0 !== _$r ? _$r : new Date);
        }) || s && s.some(function(t) {
            var _$r = t.start, _$n = t.end;
            return W.isWithinInterval(e, {
                start: _$r,
                end: _$n
            });
        }) || i && !i.some(function(t) {
            return He(e, t);
        }) || l && !l.some(function(t) {
            var _$r = t.start, _$n = t.end;
            return W.isWithinInterval(e, {
                start: _$r,
                end: _$n
            });
        }) || c && !c(Me(e)) || !1;
    }
    function Ue(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.excludeDates, a = _$r.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var _$r = t.start, _$n = t.end;
            return W.isWithinInterval(e, {
                start: _$r,
                end: _$n
            });
        }) : _$n && _$n.some(function(t) {
            var _$r;
            return t instanceof Date ? He(e, t) : He(e, null !== (_$r = t.date) && void 0 !== _$r ? _$r : new Date);
        }) || !1;
    }
    function $e(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.maxDate, o = _$r.excludeDates, s = _$r.includeDates, i = _$r.filterDate;
        return tt(e, {
            minDate: _$n ? Z.startOfMonth(_$n) : void 0,
            maxDate: a ? g.endOfMonth(a) : void 0
        }) || (null == o ? void 0 : o.some(function(t) {
            return Ae(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return Ae(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function ze(e, t, r, n) {
        var a = x.getYear(e), o = _.getMonth(e), s = x.getYear(t), i = _.getMonth(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function Xe(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.maxDate, o = _$r.excludeDates, s = _$r.includeDates;
        return tt(e, {
            minDate: _$n,
            maxDate: a
        }) || o && o.some(function(t) {
            return Ae(t instanceof Date ? t : t.date, e);
        }) || s && !s.some(function(t) {
            return Ae(t, e);
        }) || !1;
    }
    function Ge(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.maxDate, o = _$r.excludeDates, s = _$r.includeDates, i = _$r.filterDate;
        return tt(e, {
            minDate: _$n,
            maxDate: a
        }) || (null == o ? void 0 : o.some(function(t) {
            return Fe(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return Fe(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function Je(e, t, r) {
        if (!t || !r) return !1;
        if (!H.isValid(t) || !H.isValid(r)) return !1;
        var _$n = x.getYear(t), a = x.getYear(r);
        return _$n <= e && a >= e;
    }
    function Ze(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.maxDate, o = _$r.excludeDates, s = _$r.includeDates, i = _$r.filterDate, l = new Date(e, 0, 1);
        return tt(l, {
            minDate: _$n ? re.startOfYear(_$n) : void 0,
            maxDate: a ? y.endOfYear(a) : void 0
        }) || (null == o ? void 0 : o.some(function(e) {
            return Le(l, e instanceof Date ? e : e.date);
        })) || s && !s.some(function(e) {
            return Le(l, e);
        }) || i && !i(Me(l)) || !1;
    }
    function et(e, t, r, n) {
        var a = x.getYear(e), o = E.getQuarter(e), s = x.getYear(t), i = E.getQuarter(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function tt(e, t) {
        var _$r, _$n = void 0 === t ? {} : t, a = _$n.minDate, o = _$n.maxDate;
        return null !== (_$r = a && u.differenceInCalendarDays(e, a) < 0 || o && u.differenceInCalendarDays(e, o) > 0) && void 0 !== _$r && _$r;
    }
    function rt(e, t) {
        return t.some(function(t) {
            return b.getHours(t) === b.getHours(e) && C.getMinutes(t) === C.getMinutes(e) && P.getSeconds(t) === P.getSeconds(e);
        });
    }
    function nt(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.excludeTimes, a = _$r.includeTimes, o = _$r.filterTime;
        return _$n && rt(e, _$n) || a && !rt(e, a) || o && !o(e) || !1;
    }
    function at(e, t) {
        var _$r = t.minTime, _$n = t.maxTime;
        if (!_$r || !_$n) throw new Error("Both minTime and maxTime props required");
        var a = Me();
        a = j.setHours(a, b.getHours(e)), a = U.setMinutes(a, C.getMinutes(e)), a = X.setSeconds(a, P.getSeconds(e));
        var o = Me();
        o = j.setHours(o, b.getHours(_$r)), o = U.setMinutes(o, C.getMinutes(_$r)), o = X.setSeconds(o, P.getSeconds(_$r));
        var s, i = Me();
        i = j.setHours(i, b.getHours(_$n)), i = U.setMinutes(i, C.getMinutes(_$n)), i = X.setSeconds(i, P.getSeconds(_$n));
        try {
            s = !W.isWithinInterval(a, {
                start: o,
                end: i
            });
        } catch (e) {
            s = !1;
        }
        return s;
    }
    function ot(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.includeDates, o = ae.subMonths(e, 1);
        return _$n && f.differenceInCalendarMonths(_$n, o) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(e, o) > 0;
        }) || !1;
    }
    function st(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.maxDate, a = _$r.includeDates, o = i.addMonths(e, 1);
        return _$n && f.differenceInCalendarMonths(o, _$n) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(o, e) > 0;
        }) || !1;
    }
    function it(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.includeDates, o = ie.subYears(e, 1);
        return _$n && m.differenceInCalendarYears(_$n, o) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(e, o) > 0;
        }) || !1;
    }
    function lt(e, t) {
        var _$r = void 0 === t ? {} : t, _$n = _$r.maxDate, a = _$r.includeDates, o = d.addYears(e, 1);
        return _$n && m.differenceInCalendarYears(o, _$n) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(o, e) > 0;
        }) || !1;
    }
    function ct(e) {
        var t = e.minDate, _$r = e.includeDates;
        if (_$r && t) {
            var _$n = _$r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) >= 0;
            });
            return q.min(_$n);
        }
        return _$r ? q.min(_$r) : t;
    }
    function pt(e) {
        var t = e.maxDate, _$r = e.includeDates;
        if (_$r && t) {
            var _$n = _$r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) <= 0;
            });
            return Q.max(_$n);
        }
        return _$r ? Q.max(_$r) : t;
    }
    function dt(e, t) {
        var _$r;
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--highlighted");
        for(var _$n = new Map, a = 0, o = e.length; a < o; a++){
            var s = e[a];
            if (I.isDate(s)) {
                var i = _e(s, "MM.dd.yyyy");
                (f = _$n.get(i) || []).includes(t) || (f.push(t), _$n.set(i, f));
            } else if ("object" == typeof s) {
                var l = null !== (_$r = Object.keys(s)[0]) && void 0 !== _$r ? _$r : "", c = s[l];
                if ("string" == typeof l && Array.isArray(c)) for(var p = 0, d = c.length; p < d; p++){
                    var u = c[p];
                    if (u) {
                        var f;
                        i = _e(u, "MM.dd.yyyy");
                        (f = _$n.get(i) || []).includes(l) || (f.push(l), _$n.set(i, f));
                    }
                }
            }
        }
        return _$n;
    }
    function ut(e, t) {
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--holidays");
        var _$r = new Map;
        return e.forEach(function(e) {
            var _$n = e.date, a = e.holidayName;
            if (I.isDate(_$n)) {
                var o = _e(_$n, "MM.dd.yyyy"), s = _$r.get(o) || {
                    className: "",
                    holidayNames: []
                };
                if (!("className" in s) || s.className !== t || (i = s.holidayNames, l = [
                    a
                ], i.length !== l.length || !i.every(function(e, t) {
                    return e === l[t];
                }))) {
                    var i, l;
                    s.className = t;
                    var c = s.holidayNames;
                    s.holidayNames = c ? De(De([], c, !0), [
                        a
                    ], !1) : [
                        a
                    ], _$r.set(o, s);
                }
            }
        }), _$r;
    }
    function ft(e, t, r, n, a) {
        for(var i = a.length, l = [], p = 0; p < i; p++){
            var d = e, u = a[p];
            u && (d = o.addHours(d, b.getHours(u)), d = s.addMinutes(d, C.getMinutes(u)), d = c.addSeconds(d, P.getSeconds(u)));
            var f = s.addMinutes(e, (r + 1) * n);
            N.isAfter(d, t) && O.isBefore(d, f) && null != u && l.push(u);
        }
        return l;
    }
    function ht(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function mt(e, t) {
        void 0 === t && (t = Se);
        var _$r = Math.ceil(x.getYear(e) / t) * t;
        return {
            startPeriod: _$r - (t - 1),
            endPeriod: _$r
        };
    }
    function vt(e) {
        var t = e.getSeconds(), _$r = e.getMilliseconds();
        return le.toDate(e.getTime() - 1e3 * t - _$r);
    }
    function gt(e) {
        if (!I.isDate(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function Dt(e, t) {
        if (!I.isDate(e) || !I.isDate(t)) throw new Error("Invalid date received");
        var _$r = gt(e), _$n = gt(t);
        return O.isBefore(_$r, _$n);
    }
    function yt(e) {
        return e.key === ye.Space;
    }
    var kt, wt = function(e) {
        function t(t) {
            var _$n = e.call(this, t) || this;
            return _$n.onTimeChange = function(e) {
                var _$t, _$r;
                _$n.setState({
                    time: e
                });
                var a = _$n.props.date, o = a instanceof Date && !isNaN(+a) ? a : new Date;
                if (null == e ? void 0 : e.includes(":")) {
                    var s = e.split(":"), i = s[0], l = s[1];
                    o.setHours(Number(i)), o.setMinutes(Number(l));
                }
                null === (_$r = (_$t = _$n.props).onChange) || void 0 === _$r || _$r.call(_$t, o);
            }, _$n.renderTimeInput = function() {
                var _$e = _$n.state.time, _$t = _$n.props, a = _$t.date, o = _$t.timeString, s = _$t.customTimeInput;
                return s ? r.cloneElement(s, {
                    date: a,
                    value: _$e,
                    onChange: _$n.onTimeChange
                }) : ue.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: _$e,
                    onChange: function onChange(e) {
                        _$n.onTimeChange(e.target.value || o);
                    }
                });
            }, _$n.state = {
                time: _$n.props.timeString
            }, _$n;
        }
        return ve(t, e), t.getDerivedStateFromProps = function(e, t) {
            return e.timeString !== t.time ? {
                time: e.timeString
            } : null;
        }, t.prototype.render = function() {
            return ue.default.createElement("div", {
                className: "react-datepicker__input-time-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__caption"
            }, this.props.timeInputLabel), ue.default.createElement("div", {
                className: "react-datepicker-time__input-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__input"
            }, this.renderTimeInput())));
        }, t;
    }(r.Component), St = function(e) {
        function n() {
            var _$n = null !== e && e.apply(this, arguments) || this;
            return _$n.dayEl = r.createRef(), _$n.handleClick = function(e) {
                !_$n.isDisabled() && _$n.props.onClick && _$n.props.onClick(e);
            }, _$n.handleMouseEnter = function(e) {
                !_$n.isDisabled() && _$n.props.onMouseEnter && _$n.props.onMouseEnter(e);
            }, _$n.handleOnKeyDown = function(e) {
                var t, _$r;
                e.key === ye.Space && (e.preventDefault(), e.key = ye.Enter), null === (_$r = (t = _$n.props).handleOnKeyDown) || void 0 === _$r || _$r.call(t, e);
            }, _$n.isSameDay = function(e) {
                return He(_$n.props.day, e);
            }, _$n.isKeyboardSelected = function() {
                var _$e;
                if (_$n.props.disabledKeyboardNavigation) return !1;
                var t = _$n.props.selectsMultiple ? null === (_$e = _$n.props.selectedDates) || void 0 === _$e ? void 0 : _$e.some(function(e) {
                    return _$n.isSameDayOrWeek(e);
                }) : _$n.isSameDayOrWeek(_$n.props.selected), _$r = _$n.props.preSelection && _$n.isDisabled(_$n.props.preSelection);
                return !t && _$n.isSameDayOrWeek(_$n.props.preSelection) && !_$r;
            }, _$n.isDisabled = function(e) {
                return void 0 === e && (e = _$n.props.day), je(e, {
                    minDate: _$n.props.minDate,
                    maxDate: _$n.props.maxDate,
                    excludeDates: _$n.props.excludeDates,
                    excludeDateIntervals: _$n.props.excludeDateIntervals,
                    includeDateIntervals: _$n.props.includeDateIntervals,
                    includeDates: _$n.props.includeDates,
                    filterDate: _$n.props.filterDate
                });
            }, _$n.isExcluded = function() {
                return Ue(_$n.props.day, {
                    excludeDates: _$n.props.excludeDates,
                    excludeDateIntervals: _$n.props.excludeDateIntervals
                });
            }, _$n.isStartOfWeek = function() {
                return He(_$n.props.day, xe(_$n.props.day, _$n.props.locale, _$n.props.calendarStartDay));
            }, _$n.isSameWeek = function(e) {
                return _$n.props.showWeekPicker && He(e, xe(_$n.props.day, _$n.props.locale, _$n.props.calendarStartDay));
            }, _$n.isSameDayOrWeek = function(e) {
                return _$n.isSameDay(e) || _$n.isSameWeek(e);
            }, _$n.getHighLightedClass = function() {
                var _$e = _$n.props, t = _$e.day, _$r = _$e.highlightDates;
                if (!_$r) return !1;
                var a = _e(t, "MM.dd.yyyy");
                return _$r.get(a);
            }, _$n.getHolidaysClass = function() {
                var _$e, t = _$n.props, _$r = t.day, a = t.holidays;
                if (!a) return [
                    void 0
                ];
                var o = _e(_$r, "MM.dd.yyyy");
                return a.has(o) ? [
                    null === (_$e = a.get(o)) || void 0 === _$e ? void 0 : _$e.className
                ] : [
                    void 0
                ];
            }, _$n.isInRange = function() {
                var _$e = _$n.props, t = _$e.day, _$r = _$e.startDate, a = _$e.endDate;
                return !(!_$r || !a) && Qe(t, _$r, a);
            }, _$n.isInSelectingRange = function() {
                var _$e, t = _$n.props, _$r = t.day, a = t.selectsStart, o = t.selectsEnd, s = t.selectsRange, i = t.selectsDisabledDaysInRange, l = t.startDate, c = t.endDate, p = null !== (_$e = _$n.props.selectingDate) && void 0 !== _$e ? _$e : _$n.props.preSelection;
                return !(!(a || o || s) || !p || !i && _$n.isDisabled()) && (a && c && (O.isBefore(p, c) || We(p, c)) ? Qe(_$r, p, c) : (o && l && (N.isAfter(p, l) || We(p, l)) || !(!s || !l || c || !N.isAfter(p, l) && !We(p, l))) && Qe(_$r, l, p));
            }, _$n.isSelectingRangeStart = function() {
                var _$e;
                if (!_$n.isInSelectingRange()) return !1;
                var t = _$n.props, _$r = t.day, a = t.startDate, o = t.selectsStart, s = null !== (_$e = _$n.props.selectingDate) && void 0 !== _$e ? _$e : _$n.props.preSelection;
                return He(_$r, o ? s : a);
            }, _$n.isSelectingRangeEnd = function() {
                var _$e;
                if (!_$n.isInSelectingRange()) return !1;
                var t = _$n.props, _$r = t.day, a = t.endDate, o = t.selectsEnd, s = t.selectsRange, i = null !== (_$e = _$n.props.selectingDate) && void 0 !== _$e ? _$e : _$n.props.preSelection;
                return He(_$r, o || s ? i : a);
            }, _$n.isRangeStart = function() {
                var _$e = _$n.props, t = _$e.day, _$r = _$e.startDate, a = _$e.endDate;
                return !(!_$r || !a) && He(_$r, t);
            }, _$n.isRangeEnd = function() {
                var _$e = _$n.props, t = _$e.day, _$r = _$e.startDate, a = _$e.endDate;
                return !(!_$r || !a) && He(a, t);
            }, _$n.isWeekend = function() {
                var _$e = S.getDay(_$n.props.day);
                return 0 === _$e || 6 === _$e;
            }, _$n.isAfterMonth = function() {
                return void 0 !== _$n.props.month && (_$n.props.month + 1) % 12 === _.getMonth(_$n.props.day);
            }, _$n.isBeforeMonth = function() {
                return void 0 !== _$n.props.month && (_.getMonth(_$n.props.day) + 1) % 12 === _$n.props.month;
            }, _$n.isCurrentDay = function() {
                return _$n.isSameDay(Me());
            }, _$n.isSelected = function() {
                var _$e;
                return _$n.props.selectsMultiple ? null === (_$e = _$n.props.selectedDates) || void 0 === _$e ? void 0 : _$e.some(function(e) {
                    return _$n.isSameDayOrWeek(e);
                }) : _$n.isSameDayOrWeek(_$n.props.selected);
            }, _$n.getClassNames = function(e) {
                var _$r, a = _$n.props.dayClassName ? _$n.props.dayClassName(e) : void 0;
                return t.clsx("react-datepicker__day", a, "react-datepicker__day--" + _e(_$n.props.day, "ddd", _$r), {
                    "react-datepicker__day--disabled": _$n.isDisabled(),
                    "react-datepicker__day--excluded": _$n.isExcluded(),
                    "react-datepicker__day--selected": _$n.isSelected(),
                    "react-datepicker__day--keyboard-selected": _$n.isKeyboardSelected(),
                    "react-datepicker__day--range-start": _$n.isRangeStart(),
                    "react-datepicker__day--range-end": _$n.isRangeEnd(),
                    "react-datepicker__day--in-range": _$n.isInRange(),
                    "react-datepicker__day--in-selecting-range": _$n.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": _$n.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": _$n.isSelectingRangeEnd(),
                    "react-datepicker__day--today": _$n.isCurrentDay(),
                    "react-datepicker__day--weekend": _$n.isWeekend(),
                    "react-datepicker__day--outside-month": _$n.isAfterMonth() || _$n.isBeforeMonth()
                }, _$n.getHighLightedClass(), _$n.getHolidaysClass());
            }, _$n.getAriaLabel = function() {
                var _$e = _$n.props, t = _$e.day, _$r = _$e.ariaLabelPrefixWhenEnabled, a = void 0 === _$r ? "Choose" : _$r, o = _$e.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = _$n.isDisabled() || _$n.isExcluded() ? s : a;
                return "".concat(i, " ").concat(_e(t, "PPPP", _$n.props.locale));
            }, _$n.getTitle = function() {
                var _$e = _$n.props, t = _$e.day, _$r = _$e.holidays, a = void 0 === _$r ? new Map : _$r, o = _$e.excludeDates, s = _e(t, "MM.dd.yyyy"), i = [];
                return a.has(s) && i.push.apply(i, a.get(s).holidayNames), _$n.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return e instanceof Date ? He(e, t) : He(null == e ? void 0 : e.date, t);
                }).map(function(e) {
                    if (!(e instanceof Date)) return null == e ? void 0 : e.message;
                })), i.join(", ");
            }, _$n.getTabIndex = function() {
                var _$e = _$n.props.selected, t = _$n.props.preSelection;
                return (!_$n.props.showWeekPicker || !_$n.props.showWeekNumber && _$n.isStartOfWeek()) && (_$n.isKeyboardSelected() || _$n.isSameDay(_$e) && He(t, _$e)) ? 0 : -1;
            }, _$n.handleFocusDay = function() {
                var _$e;
                _$n.shouldFocusDay() && (null === (_$e = _$n.dayEl.current) || void 0 === _$e || _$e.focus({
                    preventScroll: !0
                }));
            }, _$n.renderDayContents = function() {
                return _$n.props.monthShowsDuplicateDaysEnd && _$n.isAfterMonth() || _$n.props.monthShowsDuplicateDaysStart && _$n.isBeforeMonth() ? null : _$n.props.renderDayContents ? _$n.props.renderDayContents(w.getDate(_$n.props.day), _$n.props.day) : w.getDate(_$n.props.day);
            }, _$n.render = function() {
                return ue.default.createElement("div", {
                    ref: _$n.dayEl,
                    className: _$n.getClassNames(_$n.props.day),
                    onKeyDown: _$n.handleOnKeyDown,
                    onClick: _$n.handleClick,
                    onMouseEnter: _$n.props.usePointerEvent ? void 0 : _$n.handleMouseEnter,
                    onPointerEnter: _$n.props.usePointerEvent ? _$n.handleMouseEnter : void 0,
                    tabIndex: _$n.getTabIndex(),
                    "aria-label": _$n.getAriaLabel(),
                    role: "option",
                    title: _$n.getTitle(),
                    "aria-disabled": _$n.isDisabled(),
                    "aria-current": _$n.isCurrentDay() ? "date" : void 0,
                    "aria-selected": _$n.isSelected() || _$n.isInRange()
                }, _$n.renderDayContents(), "" !== _$n.getTitle() && ue.default.createElement("span", {
                    className: "overlay"
                }, _$n.getTitle()));
            }, _$n;
        }
        return ve(n, e), n.prototype.componentDidMount = function() {
            this.handleFocusDay();
        }, n.prototype.componentDidUpdate = function() {
            this.handleFocusDay();
        }, n.prototype.shouldFocusDay = function() {
            var _$e = !1;
            return 0 === this.getTabIndex() && this.isSameDay(this.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (_$e = !0), this.props.inline && !this.props.shouldFocusDayInline && (_$e = !1), this.isDayActiveElement() && (_$e = !0), this.isDuplicateDay() && (_$e = !1)), _$e;
        }, n.prototype.isDayActiveElement = function() {
            var _$e, t, _$r;
            return (null === (t = null === (_$e = this.props.containerRef) || void 0 === _$e ? void 0 : _$e.current) || void 0 === t ? void 0 : t.contains(document.activeElement)) && (null === (_$r = document.activeElement) || void 0 === _$r ? void 0 : _$r.classList.contains("react-datepicker__day"));
        }, n.prototype.isDuplicateDay = function() {
            return this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth();
        }, n;
    }(r.Component), bt = function(e) {
        function n() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.weekNumberEl = r.createRef(), t.handleClick = function(e) {
                t.props.onClick && t.props.onClick(e);
            }, t.handleOnKeyDown = function(e) {
                var _$r, _$n;
                e.key === ye.Space && (e.preventDefault(), e.key = ye.Enter), null === (_$n = (_$r = t.props).handleOnKeyDown) || void 0 === _$n || _$n.call(_$r, e);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !He(t.props.date, t.props.selected) && He(t.props.date, t.props.preSelection);
            }, t.getTabIndex = function() {
                return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || He(t.props.date, t.props.selected) && He(t.props.preSelection, t.props.selected)) ? 0 : -1;
            }, t.handleFocusWeekNumber = function(e) {
                var _$r = !1;
                0 === t.getTabIndex() && !(null == e ? void 0 : e.isInputFocused) && He(t.props.date, t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (_$r = !0), t.props.inline && !t.props.shouldFocusDayInline && (_$r = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (_$r = !0)), _$r && t.weekNumberEl.current && t.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }, t;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function get() {
                return {
                    ariaLabelPrefix: "week "
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            this.handleFocusWeekNumber();
        }, n.prototype.componentDidUpdate = function(e) {
            this.handleFocusWeekNumber(e);
        }, n.prototype.render = function() {
            var _$e = this.props, _$r = _$e.weekNumber, a = _$e.ariaLabelPrefix, o = void 0 === a ? n.defaultProps.ariaLabelPrefix : a, s = _$e.onClick, i = {
                "react-datepicker__week-number": !0,
                "react-datepicker__week-number--clickable": !!s,
                "react-datepicker__week-number--selected": !!s && He(this.props.date, this.props.selected),
                "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
            };
            return ue.default.createElement("div", {
                ref: this.weekNumberEl,
                className: t.clsx(i),
                "aria-label": "".concat(o, " ").concat(this.props.weekNumber),
                onClick: this.handleClick,
                onKeyDown: this.handleOnKeyDown,
                tabIndex: this.getTabIndex()
            }, _$r);
        }, n;
    }(r.Component), Mt = function(e) {
        function r() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.isDisabled = function(e) {
                return je(e, {
                    minDate: t.props.minDate,
                    maxDate: t.props.maxDate,
                    excludeDates: t.props.excludeDates,
                    excludeDateIntervals: t.props.excludeDateIntervals,
                    includeDateIntervals: t.props.includeDateIntervals,
                    includeDates: t.props.includeDates,
                    filterDate: t.props.filterDate
                });
            }, t.handleDayClick = function(e, r) {
                t.props.onDayClick && t.props.onDayClick(e, r);
            }, t.handleDayMouseEnter = function(e) {
                t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
            }, t.handleWeekClick = function(e, n, a) {
                for(var o, s, i, l = new Date(e), c = 0; c < 7; c++){
                    var p = new Date(e);
                    if (p.setDate(p.getDate() + c), !t.isDisabled(p)) {
                        l = p;
                        break;
                    }
                }
                "function" == typeof t.props.onWeekSelect && t.props.onWeekSelect(l, n, a), t.props.showWeekPicker && t.handleDayClick(l, a), (null !== (o = t.props.shouldCloseOnSelect) && void 0 !== o ? o : r.defaultProps.shouldCloseOnSelect) && (null === (i = (s = t.props).setOpen) || void 0 === i || i.call(s, !1));
            }, t.formatWeekNumber = function(e) {
                return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : function(e) {
                    return M.getISOWeek(e);
                }(e);
            }, t.renderDays = function() {
                var _$e = t.startOfWeek(), _$n = [], o = t.formatWeekNumber(_$e);
                if (t.props.showWeekNumber) {
                    var s = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, _$e, o) : void 0;
                    _$n.push(ue.default.createElement(bt, ge({
                        key: "W"
                    }, r.defaultProps, t.props, {
                        weekNumber: o,
                        date: _$e,
                        onClick: s
                    })));
                }
                return _$n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(n) {
                    var o = a.addDays(_$e, n);
                    return ue.default.createElement(St, ge({}, r.defaultProps, t.props, {
                        ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
                        key: o.valueOf(),
                        day: o,
                        onClick: t.handleDayClick.bind(t, o),
                        onMouseEnter: t.handleDayMouseEnter.bind(t, o)
                    }));
                }));
            }, t.startOfWeek = function() {
                return xe(t.props.day, t.props.locale, t.props.calendarStartDay);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !He(t.startOfWeek(), t.props.selected) && He(t.startOfWeek(), t.props.preSelection);
            }, t;
        }
        return ve(r, e), Object.defineProperty(r, "defaultProps", {
            get: function get() {
                return {
                    shouldCloseOnSelect: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), r.prototype.render = function() {
            var _$e = {
                "react-datepicker__week": !0,
                "react-datepicker__week--selected": He(this.startOfWeek(), this.props.selected),
                "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
            };
            return ue.default.createElement("div", {
                className: t.clsx(_$e)
            }, this.renderDays());
        }, r;
    }(r.Component), Ct = "two_columns", _t = "three_columns", Et = "four_columns", Pt = ((kt = {})[Ct] = {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }, kt[_t] = {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }, kt[Et] = {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    }, kt);
    function Yt(e, t) {
        return e ? Et : t ? Ct : _t;
    }
    var xt = function(e) {
        function n() {
            var _$n = null !== e && e.apply(this, arguments) || this;
            return _$n.MONTH_REFS = De([], Array(12), !0).map(function() {
                return r.createRef();
            }), _$n.QUARTER_REFS = De([], Array(4), !0).map(function() {
                return r.createRef();
            }), _$n.isDisabled = function(e) {
                return je(e, {
                    minDate: _$n.props.minDate,
                    maxDate: _$n.props.maxDate,
                    excludeDates: _$n.props.excludeDates,
                    excludeDateIntervals: _$n.props.excludeDateIntervals,
                    includeDateIntervals: _$n.props.includeDateIntervals,
                    includeDates: _$n.props.includeDates,
                    filterDate: _$n.props.filterDate
                });
            }, _$n.isExcluded = function(e) {
                return Ue(e, {
                    excludeDates: _$n.props.excludeDates,
                    excludeDateIntervals: _$n.props.excludeDateIntervals
                });
            }, _$n.handleDayClick = function(e, t) {
                var _$r, a;
                null === (a = (_$r = _$n.props).onDayClick) || void 0 === a || a.call(_$r, e, t, _$n.props.orderInDisplay);
            }, _$n.handleDayMouseEnter = function(e) {
                var t, _$r;
                null === (_$r = (t = _$n.props).onDayMouseEnter) || void 0 === _$r || _$r.call(t, e);
            }, _$n.handleMouseLeave = function() {
                var _$e, t;
                null === (t = (_$e = _$n.props).onMouseLeave) || void 0 === t || t.call(_$e);
            }, _$n.isRangeStartMonth = function(e) {
                var t = _$n.props, _$r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Ae($.setMonth(_$r, e), a);
            }, _$n.isRangeStartQuarter = function(e) {
                var t = _$n.props, _$r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Fe(z.setQuarter(_$r, e), a);
            }, _$n.isRangeEndMonth = function(e) {
                var t = _$n.props, _$r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Ae($.setMonth(_$r, e), o);
            }, _$n.isRangeEndQuarter = function(e) {
                var t = _$n.props, _$r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Fe(z.setQuarter(_$r, e), o);
            }, _$n.isInSelectingRangeMonth = function(e) {
                var t, _$r = _$n.props, a = _$r.day, o = _$r.selectsStart, s = _$r.selectsEnd, i = _$r.selectsRange, l = _$r.startDate, c = _$r.endDate, p = null !== (t = _$n.props.selectingDate) && void 0 !== t ? t : _$n.props.preSelection;
                return !(!(o || s || i) || !p) && (o && c ? ze(p, c, e, a) : (s && l || !(!i || !l || c)) && ze(l, p, e, a));
            }, _$n.isSelectingMonthRangeStart = function(e) {
                var t;
                if (!_$n.isInSelectingRangeMonth(e)) return !1;
                var _$r = _$n.props, a = _$r.day, o = _$r.startDate, s = _$r.selectsStart, i = $.setMonth(a, e), l = null !== (t = _$n.props.selectingDate) && void 0 !== t ? t : _$n.props.preSelection;
                return Ae(i, s ? l : o);
            }, _$n.isSelectingMonthRangeEnd = function(e) {
                var t;
                if (!_$n.isInSelectingRangeMonth(e)) return !1;
                var _$r = _$n.props, a = _$r.day, o = _$r.endDate, s = _$r.selectsEnd, i = _$r.selectsRange, l = $.setMonth(a, e), c = null !== (t = _$n.props.selectingDate) && void 0 !== t ? t : _$n.props.preSelection;
                return Ae(l, s || i ? c : o);
            }, _$n.isInSelectingRangeQuarter = function(e) {
                var t, _$r = _$n.props, a = _$r.day, o = _$r.selectsStart, s = _$r.selectsEnd, i = _$r.selectsRange, l = _$r.startDate, c = _$r.endDate, p = null !== (t = _$n.props.selectingDate) && void 0 !== t ? t : _$n.props.preSelection;
                return !(!(o || s || i) || !p) && (o && c ? et(p, c, e, a) : (s && l || !(!i || !l || c)) && et(l, p, e, a));
            }, _$n.isWeekInMonth = function(e) {
                var t = _$n.props.day, _$r = a.addDays(e, 6);
                return Ae(e, t) || Ae(_$r, t);
            }, _$n.isCurrentMonth = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === _.getMonth(Me());
            }, _$n.isCurrentQuarter = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === E.getQuarter(Me());
            }, _$n.isSelectedMonth = function(e, t, r) {
                return _.getMonth(r) === t && x.getYear(e) === x.getYear(r);
            }, _$n.isSelectMonthInList = function(e, t, r) {
                return r.some(function(r) {
                    return _$n.isSelectedMonth(e, t, r);
                });
            }, _$n.isSelectedQuarter = function(e, t, r) {
                return E.getQuarter(e) === t && x.getYear(e) === x.getYear(r);
            }, _$n.renderWeeks = function() {
                for(var _$e = [], t = _$n.props.fixedHeight, _$r = 0, a = !1, o = xe(Ne(_$n.props.day), _$n.props.locale, _$n.props.calendarStartDay), s = _$n.props.selected ? function(e) {
                    return _$n.props.showWeekPicker ? xe(e, _$n.props.locale, _$n.props.calendarStartDay) : _$n.props.selected;
                }(_$n.props.selected) : void 0, i = _$n.props.preSelection ? function(e) {
                    return _$n.props.showWeekPicker ? xe(e, _$n.props.locale, _$n.props.calendarStartDay) : _$n.props.preSelection;
                }(_$n.props.preSelection) : void 0; _$e.push(ue.default.createElement(Mt, ge({}, _$n.props, {
                    ariaLabelPrefix: _$n.props.weekAriaLabelPrefix,
                    key: _$r,
                    day: o,
                    month: _.getMonth(_$n.props.day),
                    onDayClick: _$n.handleDayClick,
                    onDayMouseEnter: _$n.handleDayMouseEnter,
                    selected: s,
                    preSelection: i,
                    showWeekNumber: _$n.props.showWeekNumbers
                }))), !a;){
                    _$r++, o = p.addWeeks(o, 1);
                    var l = t && _$r >= 6, c = !t && !_$n.isWeekInMonth(o);
                    if (l || c) {
                        if (!_$n.props.peekNextMonth) break;
                        a = !0;
                    }
                }
                return _$e;
            }, _$n.onMonthClick = function(e, t) {
                var _$r = _$n.isMonthDisabledForLabelDate(t), a = _$r.isDisabled, o = _$r.labelDate;
                a || _$n.handleDayClick(Ne(o), e);
            }, _$n.onMonthMouseEnter = function(e) {
                var t = _$n.isMonthDisabledForLabelDate(e), _$r = t.isDisabled, a = t.labelDate;
                _$r || _$n.handleDayMouseEnter(Ne(a));
            }, _$n.handleMonthNavigation = function(e, t) {
                var _$r, a, o, s;
                null === (a = (_$r = _$n.props).setPreSelection) || void 0 === a || a.call(_$r, t), null === (s = null === (o = _$n.MONTH_REFS[e]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus();
            }, _$n.handleKeyboardNavigation = function(e, t, r) {
                var a, o = _$n.props, s = o.selected, l = o.preSelection, c = o.setPreSelection, p = o.minDate, d = o.maxDate, u = o.showFourColumnMonthYearPicker, f = o.showTwoColumnMonthYearPicker;
                if (l) {
                    var h = Yt(u, f), m = _$n.getVerticalOffset(h), v = null === (a = Pt[h]) || void 0 === a ? void 0 : a.grid, g = function g(e, t, r) {
                        var _$n, a, o = t, s = r;
                        switch(e){
                            case ye.ArrowRight:
                                o = i.addMonths(t, 1), s = 11 === r ? 0 : r + 1;
                                break;
                            case ye.ArrowLeft:
                                o = ae.subMonths(t, 1), s = 0 === r ? 11 : r - 1;
                                break;
                            case ye.ArrowUp:
                                o = ae.subMonths(t, m), s = (null === (_$n = null == v ? void 0 : v[0]) || void 0 === _$n ? void 0 : _$n.includes(r)) ? r + 12 - m : r - m;
                                break;
                            case ye.ArrowDown:
                                o = i.addMonths(t, m), s = (null === (a = null == v ? void 0 : v[v.length - 1]) || void 0 === a ? void 0 : a.includes(r)) ? r - 12 + m : r + m;
                        }
                        return {
                            newCalculatedDate: o,
                            newCalculatedMonth: s
                        };
                    };
                    if (t !== ye.Enter) {
                        var D = function(e, t, r) {
                            for(var a = e, o = !1, s = 0, i = g(a, t, r), l = i.newCalculatedDate, c = i.newCalculatedMonth; !o;){
                                if (s >= 40) {
                                    l = t, c = r;
                                    break;
                                }
                                var u;
                                if (p && l < p) a = ye.ArrowRight, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (d && l > d) a = ye.ArrowLeft, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (Xe(l, _$n.props)) l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                else o = !0;
                                s++;
                            }
                            return {
                                newCalculatedDate: l,
                                newCalculatedMonth: c
                            };
                        }(t, l, r), y = D.newCalculatedDate, k = D.newCalculatedMonth;
                        switch(t){
                            case ye.ArrowRight:
                            case ye.ArrowLeft:
                            case ye.ArrowUp:
                            case ye.ArrowDown:
                                _$n.handleMonthNavigation(k, y);
                        }
                    } else _$n.isMonthDisabled(r) || (_$n.onMonthClick(e, r), null == c || c(s));
                }
            }, _$n.getVerticalOffset = function(e) {
                var t, _$r;
                return null !== (_$r = null === (t = Pt[e]) || void 0 === t ? void 0 : t.verticalNavigationOffset) && void 0 !== _$r ? _$r : 0;
            }, _$n.onMonthKeyDown = function(e, t) {
                var _$r = _$n.props, a = _$r.disabledKeyboardNavigation, o = _$r.handleOnMonthKeyDown, s = e.key;
                s !== ye.Tab && e.preventDefault(), a || _$n.handleKeyboardNavigation(e, s, t), o && o(e);
            }, _$n.onQuarterClick = function(e, t) {
                var _$r = z.setQuarter(_$n.props.day, t);
                Ge(_$r, _$n.props) || _$n.handleDayClick(Ie(_$r), e);
            }, _$n.onQuarterMouseEnter = function(e) {
                var t = z.setQuarter(_$n.props.day, e);
                Ge(t, _$n.props) || _$n.handleDayMouseEnter(Ie(t));
            }, _$n.handleQuarterNavigation = function(e, t) {
                var _$r, a, o, s;
                _$n.isDisabled(t) || _$n.isExcluded(t) || (null === (a = (_$r = _$n.props).setPreSelection) || void 0 === a || a.call(_$r, t), null === (s = null === (o = _$n.QUARTER_REFS[e - 1]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
            }, _$n.onQuarterKeyDown = function(e, t) {
                var _$r, a, o = e.key;
                if (!_$n.props.disabledKeyboardNavigation) switch(o){
                    case ye.Enter:
                        _$n.onQuarterClick(e, t), null === (a = (_$r = _$n.props).setPreSelection) || void 0 === a || a.call(_$r, _$n.props.selected);
                        break;
                    case ye.ArrowRight:
                        if (!_$n.props.preSelection) break;
                        _$n.handleQuarterNavigation(4 === t ? 1 : t + 1, l.addQuarters(_$n.props.preSelection, 1));
                        break;
                    case ye.ArrowLeft:
                        if (!_$n.props.preSelection) break;
                        _$n.handleQuarterNavigation(1 === t ? 4 : t - 1, oe.subQuarters(_$n.props.preSelection, 1));
                }
            }, _$n.isMonthDisabledForLabelDate = function(e) {
                var t, _$r = _$n.props, a = _$r.day, o = _$r.minDate, s = _$r.maxDate, i = _$r.excludeDates, l = _$r.includeDates, c = $.setMonth(a, e);
                return {
                    isDisabled: null !== (t = (o || s || i || l) && $e(c, _$n.props)) && void 0 !== t && t,
                    labelDate: c
                };
            }, _$n.isMonthDisabled = function(e) {
                return _$n.isMonthDisabledForLabelDate(e).isDisabled;
            }, _$n.getMonthClassNames = function(e) {
                var _$r = _$n.props, a = _$r.day, o = _$r.startDate, s = _$r.endDate, i = _$r.preSelection, l = _$r.monthClassName, c = l ? l($.setMonth(a, e)) : void 0, p = _$n.getSelection();
                return t.clsx("react-datepicker__month-text", "react-datepicker__month-".concat(e), c, {
                    "react-datepicker__month-text--disabled": _$n.isMonthDisabled(e),
                    "react-datepicker__month-text--selected": p ? _$n.isSelectMonthInList(a, e, p) : void 0,
                    "react-datepicker__month-text--keyboard-selected": !_$n.props.disabledKeyboardNavigation && i && _$n.isSelectedMonth(a, e, i) && !_$n.isMonthDisabled(e),
                    "react-datepicker__month-text--in-selecting-range": _$n.isInSelectingRangeMonth(e),
                    "react-datepicker__month-text--in-range": o && s ? ze(o, s, e, a) : void 0,
                    "react-datepicker__month-text--range-start": _$n.isRangeStartMonth(e),
                    "react-datepicker__month-text--range-end": _$n.isRangeEndMonth(e),
                    "react-datepicker__month-text--selecting-range-start": _$n.isSelectingMonthRangeStart(e),
                    "react-datepicker__month-text--selecting-range-end": _$n.isSelectingMonthRangeEnd(e),
                    "react-datepicker__month-text--today": _$n.isCurrentMonth(a, e)
                });
            }, _$n.getTabIndex = function(e) {
                if (null == _$n.props.preSelection) return "-1";
                var t = _.getMonth(_$n.props.preSelection);
                return _$n.props.disabledKeyboardNavigation || e !== t ? "-1" : "0";
            }, _$n.getQuarterTabIndex = function(e) {
                if (null == _$n.props.preSelection) return "-1";
                var t = E.getQuarter(_$n.props.preSelection);
                return _$n.props.disabledKeyboardNavigation || e !== t ? "-1" : "0";
            }, _$n.getAriaLabel = function(e) {
                var t = _$n.props, _$r = t.chooseDayAriaLabelPrefix, a = void 0 === _$r ? "Choose" : _$r, o = t.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = t.day, l = t.locale, c = $.setMonth(i, e), p = _$n.isDisabled(c) || _$n.isExcluded(c) ? s : a;
                return "".concat(p, " ").concat(_e(c, "MMMM yyyy", l));
            }, _$n.getQuarterClassNames = function(e) {
                var _$r = _$n.props, a = _$r.day, o = _$r.startDate, s = _$r.endDate, i = _$r.selected, l = _$r.minDate, c = _$r.maxDate, p = _$r.excludeDates, d = _$r.includeDates, u = _$r.filterDate, f = _$r.preSelection, h = _$r.disabledKeyboardNavigation, m = (l || c || p || d || u) && Ge(z.setQuarter(a, e), _$n.props);
                return t.clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
                    "react-datepicker__quarter-text--disabled": m,
                    "react-datepicker__quarter-text--selected": i ? _$n.isSelectedQuarter(a, e, i) : void 0,
                    "react-datepicker__quarter-text--keyboard-selected": !h && f && _$n.isSelectedQuarter(a, e, f) && !m,
                    "react-datepicker__quarter-text--in-selecting-range": _$n.isInSelectingRangeQuarter(e),
                    "react-datepicker__quarter-text--in-range": o && s ? et(o, s, e, a) : void 0,
                    "react-datepicker__quarter-text--range-start": _$n.isRangeStartQuarter(e),
                    "react-datepicker__quarter-text--range-end": _$n.isRangeEndQuarter(e)
                });
            }, _$n.getMonthContent = function(e) {
                var t = _$n.props, _$r = t.showFullMonthYearPicker, a = t.renderMonthContent, o = t.locale, s = t.day, i = Ve(e, o), l = Be(e, o);
                return a ? a(e, i, l, s) : _$r ? l : i;
            }, _$n.getQuarterContent = function(e) {
                var t, _$r = _$n.props, a = _$r.renderQuarterContent, o = function(e, t) {
                    return _e(z.setQuarter(Me(), e), "QQQ", t);
                }(e, _$r.locale);
                return null !== (t = null == a ? void 0 : a(e, o)) && void 0 !== t ? t : o;
            }, _$n.renderMonths = function() {
                var _$e, t = _$n.props, _$r = t.showTwoColumnMonthYearPicker, a = t.showFourColumnMonthYearPicker, o = t.day, s = t.selected, i = null === (_$e = Pt[Yt(a, _$r)]) || void 0 === _$e ? void 0 : _$e.grid;
                return null == i ? void 0 : i.map(function(e, t) {
                    return ue.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: t
                    }, e.map(function(e, t) {
                        return ue.default.createElement("div", {
                            ref: _$n.MONTH_REFS[e],
                            key: t,
                            onClick: function onClick(t) {
                                _$n.onMonthClick(t, e);
                            },
                            onKeyDown: function onKeyDown(t) {
                                yt(t) && (t.preventDefault(), t.key = ye.Enter), _$n.onMonthKeyDown(t, e);
                            },
                            onMouseEnter: _$n.props.usePointerEvent ? void 0 : function() {
                                return _$n.onMonthMouseEnter(e);
                            },
                            onPointerEnter: _$n.props.usePointerEvent ? function() {
                                return _$n.onMonthMouseEnter(e);
                            } : void 0,
                            tabIndex: Number(_$n.getTabIndex(e)),
                            className: _$n.getMonthClassNames(e),
                            "aria-disabled": _$n.isMonthDisabled(e),
                            role: "option",
                            "aria-label": _$n.getAriaLabel(e),
                            "aria-current": _$n.isCurrentMonth(o, e) ? "date" : void 0,
                            "aria-selected": s ? _$n.isSelectedMonth(o, e, s) : void 0
                        }, _$n.getMonthContent(e));
                    }));
                });
            }, _$n.renderQuarters = function() {
                var _$e = _$n.props, t = _$e.day, _$r = _$e.selected;
                return ue.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(e, a) {
                    return ue.default.createElement("div", {
                        key: a,
                        ref: _$n.QUARTER_REFS[a],
                        role: "option",
                        onClick: function onClick(t) {
                            _$n.onQuarterClick(t, e);
                        },
                        onKeyDown: function onKeyDown(t) {
                            _$n.onQuarterKeyDown(t, e);
                        },
                        onMouseEnter: _$n.props.usePointerEvent ? void 0 : function() {
                            return _$n.onQuarterMouseEnter(e);
                        },
                        onPointerEnter: _$n.props.usePointerEvent ? function() {
                            return _$n.onQuarterMouseEnter(e);
                        } : void 0,
                        className: _$n.getQuarterClassNames(e),
                        "aria-selected": _$r ? _$n.isSelectedQuarter(t, e, _$r) : void 0,
                        tabIndex: Number(_$n.getQuarterTabIndex(e)),
                        "aria-current": _$n.isCurrentQuarter(t, e) ? "date" : void 0
                    }, _$n.getQuarterContent(e));
                }));
            }, _$n.getClassNames = function() {
                var _$e = _$n.props, _$r = _$e.selectingDate, a = _$e.selectsStart, o = _$e.selectsEnd, s = _$e.showMonthYearPicker, i = _$e.showQuarterYearPicker, l = _$e.showWeekPicker;
                return t.clsx("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": _$r && (a || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": i
                }, {
                    "react-datepicker__weekPicker": l
                });
            }, _$n;
        }
        return ve(n, e), n.prototype.getSelection = function() {
            var _$e = this.props, t = _$e.selected, _$r = _$e.selectedDates;
            return _$e.selectsMultiple ? _$r : t ? [
                t
            ] : void 0;
        }, n.prototype.render = function() {
            var _$e = this.props, t = _$e.showMonthYearPicker, _$r = _$e.showQuarterYearPicker, _$n = _$e.day, a = _$e.ariaLabelPrefix, o = void 0 === a ? "Month " : a, s = o ? o.trim() + " " : "";
            return ue.default.createElement("div", {
                className: this.getClassNames(),
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
                onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
                "aria-label": "".concat(s).concat(_e(_$n, "MMMM, yyyy", this.props.locale)),
                role: "listbox"
            }, t ? this.renderMonths() : _$r ? this.renderQuarters() : this.renderWeeks());
        }, n;
    }(r.Component), Nt = function(e) {
        function t() {
            var _$t = null !== e && e.apply(this, arguments) || this;
            return _$t.isSelectedMonth = function(e) {
                return _$t.props.month === e;
            }, _$t.renderOptions = function() {
                return _$t.props.monthNames.map(function(e, r) {
                    return ue.default.createElement("div", {
                        className: _$t.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: e,
                        onClick: _$t.onChange.bind(_$t, r),
                        "aria-selected": _$t.isSelectedMonth(r) ? "true" : void 0
                    }, _$t.isSelectedMonth(r) ? ue.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", e);
                });
            }, _$t.onChange = function(e) {
                return _$t.props.onChange(e);
            }, _$t.handleClickOutside = function() {
                return _$t.props.onCancel();
            }, _$t;
        }
        return ve(t, e), t.prototype.render = function() {
            return ue.default.createElement("div", {
                className: "react-datepicker__month-dropdown"
            }, this.renderOptions());
        }, t;
    }(r.Component), Ot = fe.default(Nt), It = function(e) {
        function t() {
            var _$t = null !== e && e.apply(this, arguments) || this;
            return _$t.state = {
                dropdownVisible: !1
            }, _$t.renderSelectOptions = function(e) {
                return e.map(function(e, t) {
                    return ue.default.createElement("option", {
                        key: e,
                        value: t
                    }, e);
                });
            }, _$t.renderSelectMode = function(e) {
                return ue.default.createElement("select", {
                    value: _$t.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function onChange(e) {
                        return _$t.onChange(parseInt(e.target.value));
                    }
                }, _$t.renderSelectOptions(e));
            }, _$t.renderReadView = function(e, r) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: _$t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[_$t.props.month]));
            }, _$t.renderDropdown = function(e) {
                return ue.default.createElement(Ot, ge({
                    key: "dropdown"
                }, _$t.props, {
                    monthNames: e,
                    onChange: _$t.onChange,
                    onCancel: _$t.toggleDropdown
                }));
            }, _$t.renderScrollMode = function(e) {
                var _$r = _$t.state.dropdownVisible, _$n = [
                    _$t.renderReadView(!_$r, e)
                ];
                return _$r && _$n.unshift(_$t.renderDropdown(e)), _$n;
            }, _$t.onChange = function(e) {
                _$t.toggleDropdown(), e !== _$t.props.month && _$t.props.onChange(e);
            }, _$t.toggleDropdown = function() {
                return _$t.setState({
                    dropdownVisible: !_$t.state.dropdownVisible
                });
            }, _$t;
        }
        return ve(t, e), t.prototype.render = function() {
            var _$e, _$t = this, _$r = [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map(this.props.useShortMonthInDropdown ? function(e) {
                return Ve(e, _$t.props.locale);
            } : function(e) {
                return Be(e, _$t.props.locale);
            });
            switch(this.props.dropdownMode){
                case "scroll":
                    _$e = this.renderScrollMode(_$r);
                    break;
                case "select":
                    _$e = this.renderSelectMode(_$r);
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
            }, _$e);
        }, t;
    }(r.Component);
    function Tt(e, t) {
        for(var _$r = [], _$n = Ne(e), a = Ne(t); !N.isAfter(_$n, a);)_$r.push(Me(_$n)), _$n = i.addMonths(_$n, 1);
        return _$r;
    }
    var Rt = function(e) {
        function r(t) {
            var _$r = e.call(this, t) || this;
            return _$r.renderOptions = function() {
                return _$r.state.monthYearsList.map(function(e) {
                    var _$t = Y.getTime(e), _$n = Le(_$r.props.date, e) && Ae(_$r.props.date, e);
                    return ue.default.createElement("div", {
                        className: _$n ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: _$t,
                        onClick: _$r.onChange.bind(_$r, _$t),
                        "aria-selected": _$n ? "true" : void 0
                    }, _$n ? ue.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", _e(e, _$r.props.dateFormat, _$r.props.locale));
                });
            }, _$r.onChange = function(e) {
                return _$r.props.onChange(e);
            }, _$r.handleClickOutside = function() {
                _$r.props.onCancel();
            }, _$r.state = {
                monthYearsList: Tt(_$r.props.minDate, _$r.props.maxDate)
            }, _$r;
        }
        return ve(r, e), r.prototype.render = function() {
            var _$e = t.clsx({
                "react-datepicker__month-year-dropdown": !0,
                "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
            });
            return ue.default.createElement("div", {
                className: _$e
            }, this.renderOptions());
        }, r;
    }(r.Component), Lt = fe.default(Rt), At = function(e) {
        function t() {
            var _$t = null !== e && e.apply(this, arguments) || this;
            return _$t.state = {
                dropdownVisible: !1
            }, _$t.renderSelectOptions = function() {
                for(var _$e = Ne(_$t.props.minDate), _$r = Ne(_$t.props.maxDate), _$n = []; !N.isAfter(_$e, _$r);){
                    var a = Y.getTime(_$e);
                    _$n.push(ue.default.createElement("option", {
                        key: a,
                        value: a
                    }, _e(_$e, _$t.props.dateFormat, _$t.props.locale))), _$e = i.addMonths(_$e, 1);
                }
                return _$n;
            }, _$t.onSelectChange = function(e) {
                _$t.onChange(parseInt(e.target.value));
            }, _$t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: Y.getTime(Ne(_$t.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: _$t.onSelectChange
                }, _$t.renderSelectOptions());
            }, _$t.renderReadView = function(e) {
                var _$r = _e(_$t.props.date, _$t.props.dateFormat, _$t.props.locale);
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: _$t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, _$r));
            }, _$t.renderDropdown = function() {
                return ue.default.createElement(Lt, ge({
                    key: "dropdown"
                }, _$t.props, {
                    onChange: _$t.onChange,
                    onCancel: _$t.toggleDropdown
                }));
            }, _$t.renderScrollMode = function() {
                var _$e = _$t.state.dropdownVisible, _$r = [
                    _$t.renderReadView(!_$e)
                ];
                return _$e && _$r.unshift(_$t.renderDropdown()), _$r;
            }, _$t.onChange = function(e) {
                _$t.toggleDropdown();
                var _$r = Me(e);
                Le(_$t.props.date, _$r) && Ae(_$t.props.date, _$r) || _$t.props.onChange(_$r);
            }, _$t.toggleDropdown = function() {
                return _$t.setState({
                    dropdownVisible: !_$t.state.dropdownVisible
                });
            }, _$t;
        }
        return ve(t, e), t.prototype.render = function() {
            var _$e;
            switch(this.props.dropdownMode){
                case "scroll":
                    _$e = this.renderScrollMode();
                    break;
                case "select":
                    _$e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
            }, _$e);
        }, t;
    }(r.Component), Ft = function(e) {
        function t() {
            var _$r = null !== e && e.apply(this, arguments) || this;
            return _$r.state = {
                height: null
            }, _$r.scrollToTheSelectedTime = function() {
                requestAnimationFrame(function() {
                    var _$e, _$n, a;
                    _$r.list && (_$r.list.scrollTop = null !== (a = _$r.centerLi && t.calcCenterPosition(_$r.props.monthRef ? _$r.props.monthRef.clientHeight - (null !== (_$n = null === (_$e = _$r.header) || void 0 === _$e ? void 0 : _$e.clientHeight) && void 0 !== _$n ? _$n : 0) : _$r.list.clientHeight, _$r.centerLi)) && void 0 !== a ? a : 0);
                });
            }, _$r.handleClick = function(e) {
                var _$t, _$n;
                (_$r.props.minTime || _$r.props.maxTime) && at(e, _$r.props) || (_$r.props.excludeTimes || _$r.props.includeTimes || _$r.props.filterTime) && nt(e, _$r.props) || null === (_$n = (_$t = _$r.props).onChange) || void 0 === _$n || _$n.call(_$t, e);
            }, _$r.isSelectedTime = function(e) {
                var _$t, _$n;
                return _$r.props.selected && (_$t = _$r.props.selected, _$n = e, vt(_$t).getTime() === vt(_$n).getTime());
            }, _$r.isDisabledTime = function(e) {
                return (_$r.props.minTime || _$r.props.maxTime) && at(e, _$r.props) || (_$r.props.excludeTimes || _$r.props.includeTimes || _$r.props.filterTime) && nt(e, _$r.props);
            }, _$r.liClasses = function(e) {
                var _$n, a = [
                    "react-datepicker__time-list-item",
                    _$r.props.timeClassName ? _$r.props.timeClassName(e) : void 0
                ];
                return _$r.isSelectedTime(e) && a.push("react-datepicker__time-list-item--selected"), _$r.isDisabledTime(e) && a.push("react-datepicker__time-list-item--disabled"), _$r.props.injectTimes && (3600 * b.getHours(e) + 60 * C.getMinutes(e) + P.getSeconds(e)) % (60 * (null !== (_$n = _$r.props.intervals) && void 0 !== _$n ? _$n : t.defaultProps.intervals)) != 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
            }, _$r.handleOnKeyDown = function(e, t) {
                var _$n, a;
                e.key === ye.Space && (e.preventDefault(), e.key = ye.Enter), (e.key === ye.ArrowUp || e.key === ye.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === ye.ArrowDown || e.key === ye.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === ye.Enter && _$r.handleClick(t), null === (a = (_$n = _$r.props).handleOnKeyDown) || void 0 === a || a.call(_$n, e);
            }, _$r.renderTimes = function() {
                for(var _$e, _$n = [], a = _$r.props.format ? _$r.props.format : "p", o = null !== (_$e = _$r.props.intervals) && void 0 !== _$e ? _$e : t.defaultProps.intervals, i = _$r.props.selected || _$r.props.openToDate || Me(), l = Ye(i), c = _$r.props.injectTimes && _$r.props.injectTimes.sort(function(e, t) {
                    return e.getTime() - t.getTime();
                }), p = 60 * function(e) {
                    var _$t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), _$r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+_$r - +_$t) / 36e5);
                }(i), d = p / o, u = 0; u < d; u++){
                    var f = s.addMinutes(l, u * o);
                    if (_$n.push(f), c) {
                        var h = ft(l, f, u, o, c);
                        _$n = _$n.concat(h);
                    }
                }
                var m = _$n.reduce(function(e, t) {
                    return t.getTime() <= i.getTime() ? t : e;
                }, _$n[0]);
                return _$n.map(function(e) {
                    return ue.default.createElement("li", {
                        key: e.valueOf(),
                        onClick: _$r.handleClick.bind(_$r, e),
                        className: _$r.liClasses(e),
                        ref: function ref(t) {
                            e === m && (_$r.centerLi = t);
                        },
                        onKeyDown: function onKeyDown(t) {
                            _$r.handleOnKeyDown(t, e);
                        },
                        tabIndex: e === m ? 0 : -1,
                        role: "option",
                        "aria-selected": _$r.isSelectedTime(e) ? "true" : void 0,
                        "aria-disabled": _$r.isDisabledTime(e) ? "true" : void 0
                    }, _e(e, a, _$r.props.locale));
                });
            }, _$r;
        }
        return ve(t, e), Object.defineProperty(t, "defaultProps", {
            get: function get() {
                return {
                    intervals: 30,
                    todayButton: null,
                    timeCaption: "Time"
                };
            },
            enumerable: !1,
            configurable: !0
        }), t.prototype.componentDidMount = function() {
            this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                height: this.props.monthRef.clientHeight - this.header.clientHeight
            });
        }, t.prototype.render = function() {
            var _$e, _$r = this, _$n = this.state.height;
            return ue.default.createElement("div", {
                className: "react-datepicker__time-container ".concat((null !== (_$e = this.props.todayButton) && void 0 !== _$e ? _$e : t.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
            }, ue.default.createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function ref(e) {
                    _$r.header = e;
                }
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__header"
            }, this.props.timeCaption)), ue.default.createElement("div", {
                className: "react-datepicker__time"
            }, ue.default.createElement("div", {
                className: "react-datepicker__time-box"
            }, ue.default.createElement("ul", {
                className: "react-datepicker__time-list",
                ref: function ref(e) {
                    _$r.list = e;
                },
                style: _$n ? {
                    height: _$n
                } : {},
                role: "listbox",
                "aria-label": this.props.timeCaption
            }, this.renderTimes()))));
        }, t.calcCenterPosition = function(e, t) {
            return t.offsetTop - (e / 2 - t.clientHeight / 2);
        }, t;
    }(r.Component), Ht = function(e) {
        function n(n) {
            var a = e.call(this, n) || this;
            return a.YEAR_REFS = De([], Array(a.props.yearItemNumber), !0).map(function() {
                return r.createRef();
            }), a.isDisabled = function(e) {
                return je(e, {
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    excludeDates: a.props.excludeDates,
                    includeDates: a.props.includeDates,
                    filterDate: a.props.filterDate
                });
            }, a.isExcluded = function(e) {
                return Ue(e, {
                    excludeDates: a.props.excludeDates
                });
            }, a.selectingDate = function() {
                var _$e;
                return null !== (_$e = a.props.selectingDate) && void 0 !== _$e ? _$e : a.props.preSelection;
            }, a.updateFocusOnPaginate = function(e) {
                window.requestAnimationFrame(function() {
                    var t, _$r;
                    null === (_$r = null === (t = a.YEAR_REFS[e]) || void 0 === t ? void 0 : t.current) || void 0 === _$r || _$r.focus();
                });
            }, a.handleYearClick = function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }, a.handleYearNavigation = function(e, t) {
                var _$r, _$n, o, s, i = a.props, l = i.date, c = i.yearItemNumber;
                if (void 0 !== l && void 0 !== c) {
                    var p = mt(l, c).startPeriod;
                    a.isDisabled(t) || a.isExcluded(t) || (null === (_$n = (_$r = a.props).setPreSelection) || void 0 === _$n || _$n.call(_$r, t), e - p < 0 ? a.updateFocusOnPaginate(c - (p - e)) : e - p >= c ? a.updateFocusOnPaginate(Math.abs(c - (e - p))) : null === (s = null === (o = a.YEAR_REFS[e - p]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
                }
            }, a.isSameDay = function(e, t) {
                return He(e, t);
            }, a.isCurrentYear = function(e) {
                return e === x.getYear(Me());
            }, a.isRangeStart = function(e) {
                return a.props.startDate && a.props.endDate && Le(G.setYear(Me(), e), a.props.startDate);
            }, a.isRangeEnd = function(e) {
                return a.props.startDate && a.props.endDate && Le(G.setYear(Me(), e), a.props.endDate);
            }, a.isInRange = function(e) {
                return Je(e, a.props.startDate, a.props.endDate);
            }, a.isInSelectingRange = function(e) {
                var t = a.props, _$r = t.selectsStart, _$n = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(_$r || _$n || o) || !a.selectingDate()) && (_$r && i ? Je(e, a.selectingDate(), i) : (_$n && s || !(!o || !s || i)) && Je(e, s, a.selectingDate()));
            }, a.isSelectingRangeStart = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var _$r = a.props, _$n = _$r.startDate, o = _$r.selectsStart, s = G.setYear(Me(), e);
                return Le(s, o ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != _$n ? _$n : null);
            }, a.isSelectingRangeEnd = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var _$r = a.props, _$n = _$r.endDate, o = _$r.selectsEnd, s = _$r.selectsRange, i = G.setYear(Me(), e);
                return Le(i, o || s ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != _$n ? _$n : null);
            }, a.isKeyboardSelected = function(e) {
                if (void 0 !== a.props.date && null != a.props.selected && null != a.props.preSelection) {
                    var t = a.props, _$r = t.minDate, _$n = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate, l = Oe(G.setYear(a.props.date, e)), c = (_$r || _$n || o || s || i) && Ze(e, a.props);
                    return !a.props.disabledKeyboardNavigation && !a.props.inline && !He(l, Oe(a.props.selected)) && He(l, Oe(a.props.preSelection)) && !c;
                }
            }, a.onYearClick = function(e, t) {
                var _$r = a.props.date;
                void 0 !== _$r && a.handleYearClick(Oe(G.setYear(_$r, t)), e);
            }, a.onYearKeyDown = function(e, t) {
                var _$r, _$n, o = e.key, s = a.props, i = s.date, l = s.yearItemNumber, c = s.handleOnKeyDown;
                if (o !== ye.Tab && e.preventDefault(), !a.props.disabledKeyboardNavigation) switch(o){
                    case ye.Enter:
                        if (null == a.props.selected) break;
                        a.onYearClick(e, t), null === (_$n = (_$r = a.props).setPreSelection) || void 0 === _$n || _$n.call(_$r, a.props.selected);
                        break;
                    case ye.ArrowRight:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t + 1, d.addYears(a.props.preSelection, 1));
                        break;
                    case ye.ArrowLeft:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t - 1, ie.subYears(a.props.preSelection, 1));
                        break;
                    case ye.ArrowUp:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var p = mt(i, l).startPeriod;
                        if ((h = t - (f = 3)) < p) {
                            var u = l % f;
                            t >= p && t < p + u ? f = u : f += u, h = t - f;
                        }
                        a.handleYearNavigation(h, ie.subYears(a.props.preSelection, f));
                        break;
                    case ye.ArrowDown:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var f, h, m = mt(i, l).endPeriod;
                        if ((h = t + (f = 3)) > m) {
                            u = l % f;
                            t <= m && t > m - u ? f = u : f += u, h = t + f;
                        }
                        a.handleYearNavigation(h, d.addYears(a.props.preSelection, f));
                }
                c && c(e);
            }, a.getYearClassNames = function(e) {
                var _$r = a.props, _$n = _$r.date, o = _$r.minDate, s = _$r.maxDate, i = _$r.selected, l = _$r.excludeDates, c = _$r.includeDates, p = _$r.filterDate, d = _$r.yearClassName;
                return t.clsx("react-datepicker__year-text", "react-datepicker__year-".concat(e), _$n ? null == d ? void 0 : d(G.setYear(_$n, e)) : void 0, {
                    "react-datepicker__year-text--selected": i ? e === x.getYear(i) : void 0,
                    "react-datepicker__year-text--disabled": (o || s || l || c || p) && Ze(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": a.isRangeStart(e),
                    "react-datepicker__year-text--range-end": a.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": a.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }, a.getYearTabIndex = function(e) {
                return a.props.disabledKeyboardNavigation || null == a.props.preSelection ? "-1" : e === x.getYear(a.props.preSelection) ? "0" : "-1";
            }, a.getYearContainerClassNames = function() {
                var _$e = a.props, _$r = _$e.selectingDate, _$n = _$e.selectsStart, o = _$e.selectsEnd, s = _$e.selectsRange;
                return t.clsx("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": _$r && (_$n || o || s)
                });
            }, a.getYearContent = function(e) {
                return a.props.renderYearContent ? a.props.renderYearContent(e) : e;
            }, a;
        }
        return ve(n, e), n.prototype.render = function() {
            var _$e = this, t = [], _$r = this.props, _$n = _$r.date, a = _$r.yearItemNumber, o = _$r.onYearMouseEnter, s = _$r.onYearMouseLeave;
            if (void 0 === _$n) return null;
            for(var i = mt(_$n, a), l = i.startPeriod, c = i.endPeriod, p = function p(r) {
                t.push(ue.default.createElement("div", {
                    ref: d.YEAR_REFS[r - l],
                    onClick: function onClick(t) {
                        _$e.onYearClick(t, r);
                    },
                    onKeyDown: function onKeyDown(t) {
                        yt(t) && (t.preventDefault(), t.key = ye.Enter), _$e.onYearKeyDown(t, r);
                    },
                    tabIndex: Number(d.getYearTabIndex(r)),
                    className: d.getYearClassNames(r),
                    onMouseEnter: d.props.usePointerEvent ? void 0 : function(e) {
                        return o(e, r);
                    },
                    onPointerEnter: d.props.usePointerEvent ? function(e) {
                        return o(e, r);
                    } : void 0,
                    onMouseLeave: d.props.usePointerEvent ? void 0 : function(e) {
                        return s(e, r);
                    },
                    onPointerLeave: d.props.usePointerEvent ? function(e) {
                        return s(e, r);
                    } : void 0,
                    key: r,
                    "aria-current": d.isCurrentYear(r) ? "date" : void 0
                }, d.getYearContent(r)));
            }, d = this, u = l; u <= c; u++)p(u);
            return ue.default.createElement("div", {
                className: this.getYearContainerClassNames()
            }, ue.default.createElement("div", {
                className: "react-datepicker__year-wrapper",
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
                onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
            }, t));
        }, n;
    }(r.Component);
    function Wt(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = x.getYear(r) <= s), n && i && (i = x.getYear(n) >= s), i && a.push(s);
        }
        return a;
    }
    var Qt = function(e) {
        function n(t) {
            var _$n = e.call(this, t) || this;
            _$n.renderOptions = function() {
                var _$e = _$n.props.year, _$t = _$n.state.yearsList.map(function(t) {
                    return ue.default.createElement("div", {
                        className: _$e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: _$n.onChange.bind(_$n, t),
                        "aria-selected": _$e === t ? "true" : void 0
                    }, _$e === t ? ue.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), _$r = _$n.props.minDate ? x.getYear(_$n.props.minDate) : null, a = _$n.props.maxDate ? x.getYear(_$n.props.maxDate) : null;
                return a && _$n.state.yearsList.find(function(e) {
                    return e === a;
                }) || _$t.unshift(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: _$n.incrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), _$r && _$n.state.yearsList.find(function(e) {
                    return e === _$r;
                }) || _$t.push(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: _$n.decrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), _$t;
            }, _$n.onChange = function(e) {
                _$n.props.onChange(e);
            }, _$n.handleClickOutside = function() {
                _$n.props.onCancel();
            }, _$n.shiftYears = function(e) {
                var _$t = _$n.state.yearsList.map(function(t) {
                    return t + e;
                });
                _$n.setState({
                    yearsList: _$t
                });
            }, _$n.incrementYears = function() {
                return _$n.shiftYears(1);
            }, _$n.decrementYears = function() {
                return _$n.shiftYears(-1);
            };
            var a = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return _$n.state = {
                yearsList: Wt(_$n.props.year, s, _$n.props.minDate, _$n.props.maxDate)
            }, _$n.dropdownRef = r.createRef(), _$n;
        }
        return ve(n, e), n.prototype.componentDidMount = function() {
            var _$e = this.dropdownRef.current;
            if (_$e) {
                var t = _$e.children ? Array.from(_$e.children) : null, _$r = t ? t.find(function(e) {
                    return e.ariaSelected;
                }) : null;
                _$e.scrollTop = _$r && _$r instanceof HTMLElement ? _$r.offsetTop + (_$r.clientHeight - _$e.clientHeight) / 2 : (_$e.scrollHeight - _$e.clientHeight) / 2;
            }
        }, n.prototype.render = function() {
            var _$e = t.clsx({
                "react-datepicker__year-dropdown": !0,
                "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
            });
            return ue.default.createElement("div", {
                className: _$e,
                ref: this.dropdownRef
            }, this.renderOptions());
        }, n;
    }(r.Component), qt = fe.default(Qt), Kt = function(e) {
        function t() {
            var _$t = null !== e && e.apply(this, arguments) || this;
            return _$t.state = {
                dropdownVisible: !1
            }, _$t.renderSelectOptions = function() {
                for(var _$e = _$t.props.minDate ? x.getYear(_$t.props.minDate) : 1900, _$r = _$t.props.maxDate ? x.getYear(_$t.props.maxDate) : 2100, _$n = [], a = _$e; a <= _$r; a++)_$n.push(ue.default.createElement("option", {
                    key: a,
                    value: a
                }, a));
                return _$n;
            }, _$t.onSelectChange = function(e) {
                _$t.onChange(parseInt(e.target.value));
            }, _$t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: _$t.props.year,
                    className: "react-datepicker__year-select",
                    onChange: _$t.onSelectChange
                }, _$t.renderSelectOptions());
            }, _$t.renderReadView = function(e) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function onClick(e) {
                        return _$t.toggleDropdown(e);
                    }
                }, ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, _$t.props.year));
            }, _$t.renderDropdown = function() {
                return ue.default.createElement(qt, ge({
                    key: "dropdown"
                }, _$t.props, {
                    onChange: _$t.onChange,
                    onCancel: _$t.toggleDropdown
                }));
            }, _$t.renderScrollMode = function() {
                var _$e = _$t.state.dropdownVisible, _$r = [
                    _$t.renderReadView(!_$e)
                ];
                return _$e && _$r.unshift(_$t.renderDropdown()), _$r;
            }, _$t.onChange = function(e) {
                _$t.toggleDropdown(), e !== _$t.props.year && _$t.props.onChange(e);
            }, _$t.toggleDropdown = function(e) {
                _$t.setState({
                    dropdownVisible: !_$t.state.dropdownVisible
                }, function() {
                    _$t.props.adjustDateOnChange && _$t.handleYearChange(_$t.props.date, e);
                });
            }, _$t.handleYearChange = function(e, r) {
                _$t.onSelect(e, r), _$t.setOpen();
            }, _$t.onSelect = function(e, r) {
                _$t.props.onSelect && _$t.props.onSelect(e, r);
            }, _$t.setOpen = function() {
                _$t.props.setOpen && _$t.props.setOpen(!0);
            }, _$t;
        }
        return ve(t, e), t.prototype.render = function() {
            var _$e;
            switch(this.props.dropdownMode){
                case "scroll":
                    _$e = this.renderScrollMode();
                    break;
                case "select":
                    _$e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
            }, _$e);
        }, t;
    }(r.Component), Bt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Vt = function(e) {
        function n(o) {
            var s = e.call(this, o) || this;
            return s.monthContainer = void 0, s.handleClickOutside = function(e) {
                s.props.onClickOutside(e);
            }, s.setClickOutsideRef = function() {
                return s.containerRef.current;
            }, s.handleDropdownFocus = function(e) {
                var t, _$r, _$n, a;
                _$n = e.target, a = (_$n.className || "").split(/\s+/), Bt.some(function(e) {
                    return a.indexOf(e) >= 0;
                }) && (null === (_$r = (t = s.props).onDropdownFocus) || void 0 === _$r || _$r.call(t, e));
            }, s.getDateInView = function() {
                var _$e = s.props, t = _$e.preSelection, _$r = _$e.selected, _$n = _$e.openToDate, a = ct(s.props), _$o = pt(s.props), i = Me(), l = _$n || _$r || t;
                return l || (a && O.isBefore(i, a) ? a : _$o && N.isAfter(i, _$o) ? _$o : i);
            }, s.increaseMonth = function() {
                s.setState(function(e) {
                    var t = e.date;
                    return {
                        date: i.addMonths(t, 1)
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.decreaseMonth = function() {
                s.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ae.subMonths(t, 1)
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.handleDayClick = function(e, t, r) {
                s.props.onSelect(e, t, r), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleDayMouseEnter = function(e) {
                s.setState({
                    selectingDate: e
                }), s.props.onDayMouseEnter && s.props.onDayMouseEnter(e);
            }, s.handleMonthMouseLeave = function() {
                s.setState({
                    selectingDate: void 0
                }), s.props.onMonthMouseLeave && s.props.onMonthMouseLeave();
            }, s.handleYearMouseEnter = function(e, t) {
                s.setState({
                    selectingDate: G.setYear(Me(), t)
                }), s.props.onYearMouseEnter && s.props.onYearMouseEnter(e, t);
            }, s.handleYearMouseLeave = function(e, t) {
                s.props.onYearMouseLeave && s.props.onYearMouseLeave(e, t);
            }, s.handleYearChange = function(e) {
                s.props.onYearChange && (s.props.onYearChange(e), s.setState({
                    isRenderAriaLiveMessage: !0
                })), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(e), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleMonthChange = function(e) {
                s.handleCustomMonthChange(e), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(e), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleCustomMonthChange = function(e) {
                s.props.onMonthChange && (s.props.onMonthChange(e), s.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }, s.handleMonthYearChange = function(e) {
                s.handleYearChange(e), s.handleMonthChange(e);
            }, s.changeYear = function(e) {
                s.setState(function(t) {
                    var _$r = t.date;
                    return {
                        date: G.setYear(_$r, Number(e))
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.changeMonth = function(e) {
                s.setState(function(t) {
                    var _$r = t.date;
                    return {
                        date: $.setMonth(_$r, Number(e))
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.changeMonthYear = function(e) {
                s.setState(function(t) {
                    var _$r = t.date;
                    return {
                        date: G.setYear($.setMonth(_$r, _.getMonth(e)), x.getYear(e))
                    };
                }, function() {
                    return s.handleMonthYearChange(s.state.date);
                });
            }, s.header = function(e) {
                void 0 === e && (e = s.state.date);
                var _$r = xe(e, s.props.locale, s.props.calendarStartDay), _$n = [];
                return s.props.showWeekNumbers && _$n.push(ue.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, s.props.weekLabel || "#")), _$n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var _$n = a.addDays(_$r, e), _$o = s.formatWeekday(_$n, s.props.locale), i = s.props.weekDayClassName ? s.props.weekDayClassName(_$n) : void 0;
                    return ue.default.createElement("div", {
                        key: e,
                        "aria-label": _e(_$n, "EEEE", s.props.locale),
                        className: t.clsx("react-datepicker__day-name", i)
                    }, _$o);
                }));
            }, s.formatWeekday = function(e, t) {
                return s.props.formatWeekDay ? function(e, t, r) {
                    return t(_e(e, "EEEE", r));
                }(e, s.props.formatWeekDay, t) : s.props.useWeekdaysShort ? function(e, t) {
                    return _e(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return _e(e, "EEEEEE", t);
                }(e, t);
            }, s.decreaseYear = function() {
                s.setState(function(e) {
                    var t, _$r = e.date;
                    return {
                        date: ie.subYears(_$r, s.props.showYearPicker ? null !== (t = s.props.yearItemNumber) && void 0 !== t ? t : n.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.clearSelectingDate = function() {
                s.setState({
                    selectingDate: void 0
                });
            }, s.renderPreviousButton = function() {
                var _$e;
                if (!s.props.renderCustomHeader) {
                    var t;
                    switch(!0){
                        case s.props.showMonthYearPicker:
                            t = it(s.state.date, s.props);
                            break;
                        case s.props.showYearPicker:
                            t = function(e, t) {
                                var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.yearItemNumber, _$o = void 0 === a ? Se : a, s = mt(Oe(ie.subYears(e, _$o)), _$o).endPeriod, i = _$n && x.getYear(_$n);
                                return i && i > s || !1;
                            }(s.state.date, s.props);
                            break;
                        case s.props.showQuarterYearPicker:
                            t = function(e, t) {
                                var _$r = void 0 === t ? {} : t, _$n = _$r.minDate, a = _$r.includeDates, _$o = re.startOfYear(e), s = oe.subQuarters(_$o, 1);
                                return _$n && h.differenceInCalendarQuarters(_$n, s) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(e, s) > 0;
                                }) || !1;
                            }(s.state.date, s.props);
                            break;
                        default:
                            t = ot(s.state.date, s.props);
                    }
                    if (((null !== (_$e = s.props.forceShowMonthNavigation) && void 0 !== _$e ? _$e : n.defaultProps.forceShowMonthNavigation) || s.props.showDisabledMonthNavigation || !t) && !s.props.showTimeSelectOnly) {
                        var _$r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], a = s.decreaseMonth;
                        (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (a = s.decreaseYear), t && s.props.showDisabledMonthNavigation && (_$r.push("react-datepicker__navigation--previous--disabled"), a = void 0);
                        var _$o = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, i = s.props, l = i.previousMonthButtonLabel, c = void 0 === l ? n.defaultProps.previousMonthButtonLabel : l, p = i.previousYearButtonLabel, d = void 0 === p ? n.defaultProps.previousYearButtonLabel : p, u = s.props, f = u.previousMonthAriaLabel, m = void 0 === f ? "string" == typeof c ? c : "Previous Month" : f, v = u.previousYearAriaLabel, g = void 0 === v ? "string" == typeof d ? d : "Previous Year" : v;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: _$r.join(" "),
                            onClick: a,
                            onKeyDown: s.props.handleOnKeyDown,
                            "aria-label": _$o ? g : m
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, _$o ? d : c));
                    }
                }
            }, s.increaseYear = function() {
                s.setState(function(e) {
                    var t, _$r = e.date;
                    return {
                        date: d.addYears(_$r, s.props.showYearPicker ? null !== (t = s.props.yearItemNumber) && void 0 !== t ? t : n.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.renderNextButton = function() {
                var _$e;
                if (!s.props.renderCustomHeader) {
                    var t;
                    switch(!0){
                        case s.props.showMonthYearPicker:
                            t = lt(s.state.date, s.props);
                            break;
                        case s.props.showYearPicker:
                            t = function(e, t) {
                                var _$r = void 0 === t ? {} : t, _$n = _$r.maxDate, a = _$r.yearItemNumber, _$o = void 0 === a ? Se : a, s = mt(d.addYears(e, _$o), _$o).startPeriod, i = _$n && x.getYear(_$n);
                                return i && i < s || !1;
                            }(s.state.date, s.props);
                            break;
                        case s.props.showQuarterYearPicker:
                            t = function(e, t) {
                                var _$r = void 0 === t ? {} : t, _$n = _$r.maxDate, a = _$r.includeDates, _$o = y.endOfYear(e), s = l.addQuarters(_$o, 1);
                                return _$n && h.differenceInCalendarQuarters(s, _$n) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(s, e) > 0;
                                }) || !1;
                            }(s.state.date, s.props);
                            break;
                        default:
                            t = st(s.state.date, s.props);
                    }
                    if (((null !== (_$e = s.props.forceShowMonthNavigation) && void 0 !== _$e ? _$e : n.defaultProps.forceShowMonthNavigation) || s.props.showDisabledMonthNavigation || !t) && !s.props.showTimeSelectOnly) {
                        var _$r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        s.props.showTimeSelect && _$r.push("react-datepicker__navigation--next--with-time"), s.props.todayButton && _$r.push("react-datepicker__navigation--next--with-today-button");
                        var a = s.increaseMonth;
                        (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (a = s.increaseYear), t && s.props.showDisabledMonthNavigation && (_$r.push("react-datepicker__navigation--next--disabled"), a = void 0);
                        var _$o = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, i = s.props, c = i.nextMonthButtonLabel, p = void 0 === c ? n.defaultProps.nextMonthButtonLabel : c, u = i.nextYearButtonLabel, f = void 0 === u ? n.defaultProps.nextYearButtonLabel : u, m = s.props, v = m.nextMonthAriaLabel, g = void 0 === v ? "string" == typeof p ? p : "Next Month" : v, D = m.nextYearAriaLabel, k = void 0 === D ? "string" == typeof f ? f : "Next Year" : D;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: _$r.join(" "),
                            onClick: a,
                            onKeyDown: s.props.handleOnKeyDown,
                            "aria-label": _$o ? k : g
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, _$o ? f : p));
                    }
                }
            }, s.renderCurrentMonth = function(e) {
                void 0 === e && (e = s.state.date);
                var t = [
                    "react-datepicker__current-month"
                ];
                return s.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), s.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), s.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), ue.default.createElement("h2", {
                    className: t.join(" ")
                }, _e(e, s.props.dateFormat, s.props.locale));
            }, s.renderYearDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showYearDropdown && !e) return ue.default.createElement(Kt, ge({}, n.defaultProps, s.props, {
                    date: s.state.date,
                    onChange: s.changeYear,
                    year: x.getYear(s.state.date)
                }));
            }, s.renderMonthDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showMonthDropdown && !e) return ue.default.createElement(It, ge({}, n.defaultProps, s.props, {
                    month: _.getMonth(s.state.date),
                    onChange: s.changeMonth
                }));
            }, s.renderMonthYearDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showMonthYearDropdown && !e) return ue.default.createElement(At, ge({}, n.defaultProps, s.props, {
                    date: s.state.date,
                    onChange: s.changeMonthYear
                }));
            }, s.handleTodayButtonClick = function(e) {
                s.props.onSelect(Te(), e), s.props.setPreSelection && s.props.setPreSelection(Te());
            }, s.renderTodayButton = function() {
                if (s.props.todayButton && !s.props.showTimeSelectOnly) return ue.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: s.handleTodayButtonClick
                }, s.props.todayButton);
            }, s.renderDefaultHeader = function(e) {
                var t = e.monthDate, _$r = e.i;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header ".concat(s.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, s.renderCurrentMonth(t), ue.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(s.props.dropdownMode),
                    onFocus: s.handleDropdownFocus
                }, s.renderMonthDropdown(0 !== _$r), s.renderMonthYearDropdown(0 !== _$r), s.renderYearDropdown(0 !== _$r)), ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, s.header(t)));
            }, s.renderCustomHeader = function(e) {
                var t, _$r, _$n = e.monthDate, a = e.i;
                if (s.props.showTimeSelect && !s.state.monthContainer || s.props.showTimeSelectOnly) return null;
                var _$o = ot(s.state.date, s.props), i = st(s.state.date, s.props), l = it(s.state.date, s.props), c = lt(s.state.date, s.props), p = !s.props.showMonthYearPicker && !s.props.showQuarterYearPicker && !s.props.showYearPicker;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: s.props.onDropdownFocus
                }, null === (_$r = (t = s.props).renderCustomHeader) || void 0 === _$r ? void 0 : _$r.call(t, ge(ge({}, s.state), {
                    customHeaderCount: a,
                    monthDate: _$n,
                    changeMonth: s.changeMonth,
                    changeYear: s.changeYear,
                    decreaseMonth: s.decreaseMonth,
                    increaseMonth: s.increaseMonth,
                    decreaseYear: s.decreaseYear,
                    increaseYear: s.increaseYear,
                    prevMonthButtonDisabled: _$o,
                    nextMonthButtonDisabled: i,
                    prevYearButtonDisabled: l,
                    nextYearButtonDisabled: c
                })), p && ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, s.header(_$n)));
            }, s.renderYearHeader = function(e) {
                var t = e.monthDate, _$r = s.props, a = _$r.showYearPicker, _$o = _$r.yearItemNumber, i = mt(t, void 0 === _$o ? n.defaultProps.yearItemNumber : _$o), l = i.startPeriod, c = i.endPeriod;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, a ? "".concat(l, " - ").concat(c) : x.getYear(t));
            }, s.renderHeader = function(e) {
                var t = e.monthDate, _$r = e.i, _$n = {
                    monthDate: t,
                    i: void 0 === _$r ? 0 : _$r
                };
                switch(!0){
                    case void 0 !== s.props.renderCustomHeader:
                        return s.renderCustomHeader(_$n);
                    case s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker:
                        return s.renderYearHeader(_$n);
                    default:
                        return s.renderDefaultHeader(_$n);
                }
            }, s.renderMonths = function() {
                var _$e, t;
                if (!s.props.showTimeSelectOnly && !s.props.showYearPicker) {
                    for(var _$r = [], a = null !== (_$e = s.props.monthsShown) && void 0 !== _$e ? _$e : n.defaultProps.monthsShown, _$o = s.props.showPreviousMonths ? a - 1 : 0, l = s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? d.addYears(s.state.date, _$o) : ae.subMonths(s.state.date, _$o), c = null !== (t = s.props.monthSelectedIn) && void 0 !== t ? t : _$o, p = 0; p < a; ++p){
                        var u = p - c + _$o, f = s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? d.addYears(l, u) : i.addMonths(l, u), h = "month-".concat(p), m = p < a - 1, v = p > 0;
                        _$r.push(ue.default.createElement("div", {
                            key: h,
                            ref: function ref(e) {
                                s.monthContainer = null != e ? e : void 0;
                            },
                            className: "react-datepicker__month-container"
                        }, s.renderHeader({
                            monthDate: f,
                            i: p
                        }), ue.default.createElement(xt, ge({}, n.defaultProps, s.props, {
                            ariaLabelPrefix: s.props.monthAriaLabelPrefix,
                            day: f,
                            onDayClick: s.handleDayClick,
                            handleOnKeyDown: s.props.handleOnDayKeyDown,
                            handleOnMonthKeyDown: s.props.handleOnKeyDown,
                            onDayMouseEnter: s.handleDayMouseEnter,
                            onMouseLeave: s.handleMonthMouseLeave,
                            orderInDisplay: p,
                            selectingDate: s.state.selectingDate,
                            monthShowsDuplicateDaysEnd: m,
                            monthShowsDuplicateDaysStart: v
                        }))));
                    }
                    return _$r;
                }
            }, s.renderYears = function() {
                if (!s.props.showTimeSelectOnly) return s.props.showYearPicker ? ue.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, s.renderHeader({
                    monthDate: s.state.date
                }), ue.default.createElement(Ht, ge({}, n.defaultProps, s.props, {
                    selectingDate: s.state.selectingDate,
                    date: s.state.date,
                    onDayClick: s.handleDayClick,
                    clearSelectingDate: s.clearSelectingDate,
                    onYearMouseEnter: s.handleYearMouseEnter,
                    onYearMouseLeave: s.handleYearMouseLeave
                }))) : void 0;
            }, s.renderTimeSection = function() {
                if (s.props.showTimeSelect && (s.state.monthContainer || s.props.showTimeSelectOnly)) return ue.default.createElement(Ft, ge({}, n.defaultProps, s.props, {
                    onChange: s.props.onTimeChange,
                    format: s.props.timeFormat,
                    intervals: s.props.timeIntervals,
                    monthRef: s.state.monthContainer
                }));
            }, s.renderInputTimeSection = function() {
                var _$e = s.props.selected ? new Date(s.props.selected) : void 0, t = _$e && Ce(_$e) && Boolean(s.props.selected) ? "".concat(ht(_$e.getHours()), ":").concat(ht(_$e.getMinutes())) : "";
                if (s.props.showTimeInput) return ue.default.createElement(wt, ge({}, n.defaultProps, s.props, {
                    date: _$e,
                    timeString: t,
                    onChange: s.props.onTimeChange
                }));
            }, s.renderAriaLiveRegion = function() {
                var _$e, t, _$r = mt(s.state.date, null !== (_$e = s.props.yearItemNumber) && void 0 !== _$e ? _$e : n.defaultProps.yearItemNumber), a = _$r.startPeriod, _$o = _$r.endPeriod;
                return t = s.props.showYearPicker ? "".concat(a, " - ").concat(_$o) : s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? x.getYear(s.state.date) : "".concat(Be(_.getMonth(s.state.date), s.props.locale), " ").concat(x.getYear(s.state.date)), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, s.state.isRenderAriaLiveMessage && t);
            }, s.renderChildren = function() {
                if (s.props.children) return ue.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, s.props.children);
            }, s.containerRef = r.createRef(), s.state = {
                date: s.getDateInView(),
                selectingDate: void 0,
                monthContainer: void 0,
                isRenderAriaLiveMessage: !1
            }, s;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function get() {
                return {
                    monthsShown: 1,
                    forceShowMonthNavigation: !1,
                    timeCaption: "Time",
                    previousYearButtonLabel: "Previous Year",
                    nextYearButtonLabel: "Next Year",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthButtonLabel: "Next Month",
                    yearItemNumber: Se
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            var _$e = this;
            this.props.showTimeSelect && (this.assignMonthContainer = void _$e.setState({
                monthContainer: _$e.monthContainer
            }));
        }, n.prototype.componentDidUpdate = function(e) {
            var t = this;
            if (!this.props.preSelection || He(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !He(this.props.openToDate, e.openToDate) && this.setState({
                date: this.props.openToDate
            });
            else {
                var _$r = !Ae(this.state.date, this.props.preSelection);
                this.setState({
                    date: this.props.preSelection
                }, function() {
                    return _$r && t.handleCustomMonthChange(t.state.date);
                });
            }
        }, n.prototype.render = function() {
            var _$e = this.props.container || ke;
            return ue.default.createElement("div", {
                style: {
                    display: "contents"
                },
                ref: this.containerRef
            }, ue.default.createElement(_$e, {
                className: t.clsx("react-datepicker", this.props.className, {
                    "react-datepicker--time-only": this.props.showTimeSelectOnly
                }),
                showTime: this.props.showTimeSelect || this.props.showTimeInput,
                showTimeSelectOnly: this.props.showTimeSelectOnly
            }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
        }, n;
    }(r.Component), jt = function jt(e) {
        var t = e.icon, _$r = e.className, _$n = void 0 === _$r ? "" : _$r, a = e.onClick, o = "react-datepicker__calendar-icon";
        return "string" == typeof t ? ue.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(_$n),
            "aria-hidden": "true",
            onClick: a
        }) : ue.default.isValidElement(t) ? ue.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(_$n),
            onClick: function onClick(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof a && a(e);
            }
        }) : ue.default.createElement("svg", {
            className: "".concat(o, " ").concat(_$n),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: a
        }, ue.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, Ut = function(e) {
        function t(t) {
            var _$r = e.call(this, t) || this;
            return _$r.portalRoot = null, _$r.el = document.createElement("div"), _$r;
        }
        return ve(t, e), t.prototype.componentDidMount = function() {
            this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
        }, t.prototype.componentWillUnmount = function() {
            this.portalRoot && this.portalRoot.removeChild(this.el);
        }, t.prototype.render = function() {
            return he.default.createPortal(this.props.children, this.el);
        }, t;
    }(r.Component), $t = function $t(e) {
        return (e instanceof HTMLAnchorElement || !e.disabled) && -1 !== e.tabIndex;
    }, zt = function(e) {
        function t(t) {
            var _$n = e.call(this, t) || this;
            return _$n.getTabChildren = function() {
                var _$e;
                return Array.prototype.slice.call(null === (_$e = _$n.tabLoopRef.current) || void 0 === _$e ? void 0 : _$e.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter($t);
            }, _$n.handleFocusStart = function() {
                var _$e = _$n.getTabChildren();
                _$e && _$e.length > 1 && _$e[_$e.length - 1].focus();
            }, _$n.handleFocusEnd = function() {
                var _$e = _$n.getTabChildren();
                _$e && _$e.length > 1 && _$e[0].focus();
            }, _$n.tabLoopRef = r.createRef(), _$n;
        }
        return ve(t, e), t.prototype.render = function() {
            var _$e;
            return (null !== (_$e = this.props.enableTabLoop) && void 0 !== _$e ? _$e : t.defaultProps.enableTabLoop) ? ue.default.createElement("div", {
                className: "react-datepicker__tab-loop",
                ref: this.tabLoopRef
            }, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__start",
                tabIndex: 0,
                onFocus: this.handleFocusStart
            }), this.props.children, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__end",
                tabIndex: 0,
                onFocus: this.handleFocusEnd
            })) : this.props.children;
        }, t.defaultProps = {
            enableTabLoop: !0
        }, t;
    }(r.Component);
    var Xt, Gt = function(e) {
        function n() {
            return null !== e && e.apply(this, arguments) || this;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function get() {
                return {
                    hidePopper: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.render = function() {
            var _$e = this.props, a = _$e.className, o = _$e.wrapperClassName, s = _$e.hidePopper, i = void 0 === s ? n.defaultProps.hidePopper : s, l = _$e.popperComponent, c = _$e.targetComponent, p = _$e.enableTabLoop, d = _$e.popperOnKeyDown, u = _$e.portalId, f = _$e.portalHost, h = _$e.popperProps, m = _$e.showArrow, v = void 0;
            if (!i) {
                var g = t.clsx("react-datepicker-popper", a);
                v = ue.default.createElement(zt, {
                    enableTabLoop: p
                }, ue.default.createElement("div", {
                    ref: h.refs.setFloating,
                    style: h.floatingStyles,
                    className: g,
                    "data-placement": h.placement,
                    onKeyDown: d
                }, l, m && ue.default.createElement(ce.FloatingArrow, {
                    ref: h.arrowRef,
                    context: h.context,
                    fill: "currentColor",
                    strokeWidth: 1,
                    height: 8,
                    width: 16,
                    style: {
                        transform: "translateY(-1px)"
                    },
                    className: "react-datepicker__triangle"
                })));
            }
            this.props.popperContainer && (v = r.createElement(this.props.popperContainer, {}, v)), u && !i && (v = ue.default.createElement(Ut, {
                portalId: u,
                portalHost: f
            }, v));
            var D = t.clsx("react-datepicker-wrapper", o);
            return ue.default.createElement(ue.default.Fragment, null, ue.default.createElement("div", {
                ref: h.refs.setReference,
                className: D
            }, c), v);
        }, n;
    }(r.Component), Jt = (Xt = Gt, function Jt(e) {
        var t, _$n = "boolean" != typeof e.hidePopper || e.hidePopper, a = r.useRef(null), o = ce.useFloating(ge({
            open: !_$n,
            whileElementsMounted: ce.autoUpdate,
            placement: e.popperPlacement,
            middleware: De([
                ce.flip({
                    padding: 15
                }),
                ce.offset(10),
                ce.arrow({
                    element: a
                })
            ], null !== (t = e.popperModifiers) && void 0 !== t ? t : [], !0)
        }, e.popperProps)), s = ge(ge({}, e), {
            hidePopper: _$n,
            popperProps: ge(ge({}, o), {
                arrowRef: a
            })
        });
        return ue.default.createElement(Xt, ge({}, s));
    }), Zt = "react-datepicker-ignore-onclickoutside", er = fe.default(Vt);
    var tr = "Date input not valid.", rr = function(e) {
        function n(o) {
            var s = e.call(this, o) || this;
            return s.calendar = null, s.input = null, s.getPreSelection = function() {
                return s.props.openToDate ? s.props.openToDate : s.props.selectsEnd && s.props.startDate ? s.props.startDate : s.props.selectsStart && s.props.endDate ? s.props.endDate : Me();
            }, s.modifyHolidays = function() {
                var _$e;
                return null === (_$e = s.props.holidays) || void 0 === _$e ? void 0 : _$e.reduce(function(e, t) {
                    var _$r = new Date(t.date);
                    return Ce(_$r) ? De(De([], e, !0), [
                        ge(ge({}, t), {
                            date: _$r
                        })
                    ], !1) : e;
                }, []);
            }, s.calcInitialState = function() {
                var _$e, t = s.getPreSelection(), _$r = ct(s.props), _$n = pt(s.props), a = _$r && O.isBefore(t, Ye(_$r)) ? _$r : _$n && N.isAfter(t, Re(_$n)) ? _$n : t;
                return {
                    open: s.props.startOpen || !1,
                    preventFocus: !1,
                    inputValue: null,
                    preSelection: null !== (_$e = s.props.selectsRange ? s.props.startDate : s.props.selected) && void 0 !== _$e ? _$e : a,
                    highlightDates: dt(s.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1,
                    wasHidden: !1
                };
            }, s.resetHiddenStatus = function() {
                s.setState(ge(ge({}, s.state), {
                    wasHidden: !1
                }));
            }, s.setHiddenStatus = function() {
                s.setState(ge(ge({}, s.state), {
                    wasHidden: !0
                }));
            }, s.setHiddenStateOnVisibilityHidden = function() {
                "hidden" === document.visibilityState && s.setHiddenStatus();
            }, s.clearPreventFocusTimeout = function() {
                s.preventFocusTimeout && clearTimeout(s.preventFocusTimeout);
            }, s.setFocus = function() {
                s.input && s.input.focus && s.input.focus({
                    preventScroll: !0
                });
            }, s.setBlur = function() {
                s.input && s.input.blur && s.input.blur(), s.cancelFocusInput();
            }, s.setOpen = function(e, t) {
                void 0 === t && (t = !1), s.setState({
                    open: e,
                    preSelection: e && s.state.open ? s.state.preSelection : s.calcInitialState().preSelection,
                    lastPreSelectChange: ar
                }, function() {
                    e || s.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && s.setBlur(), s.setState({
                            inputValue: null
                        });
                    });
                });
            }, s.inputOk = function() {
                return I.isDate(s.state.preSelection);
            }, s.isCalendarOpen = function() {
                return void 0 === s.props.open ? s.state.open && !s.props.disabled && !s.props.readOnly : s.props.open;
            }, s.handleFocus = function(e) {
                var t, _$r, _$n = s.state.wasHidden, a = !_$n || s.state.open;
                _$n && s.resetHiddenStatus(), !s.state.preventFocus && a && (null === (_$r = (t = s.props).onFocus) || void 0 === _$r || _$r.call(t, e), s.props.preventOpenOnFocus || s.props.readOnly || s.setOpen(!0)), s.setState({
                    focused: !0
                });
            }, s.sendFocusBackToInput = function() {
                s.preventFocusTimeout && s.clearPreventFocusTimeout(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.preventFocusTimeout = setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                });
            }, s.cancelFocusInput = function() {
                clearTimeout(s.inputFocusTimeout), s.inputFocusTimeout = void 0;
            }, s.deferFocusInput = function() {
                s.cancelFocusInput(), s.inputFocusTimeout = setTimeout(function() {
                    return s.setFocus();
                }, 1);
            }, s.handleDropdownFocus = function() {
                s.cancelFocusInput();
            }, s.handleBlur = function(e) {
                var t, _$r;
                (!s.state.open || s.props.withPortal || s.props.showTimeInput) && (null === (_$r = (t = s.props).onBlur) || void 0 === _$r || _$r.call(t, e)), s.setState({
                    focused: !1
                });
            }, s.handleCalendarClickOutside = function(e) {
                var t, _$r;
                s.props.inline || s.setOpen(!1), null === (_$r = (t = s.props).onClickOutside) || void 0 === _$r || _$r.call(t, e), s.props.withPortal && e.preventDefault();
            }, s.handleChange = function() {
                for(var _$e = [], t = 0; t < arguments.length; t++)_$e[t] = arguments[t];
                var _$r = _$e[0];
                if (!s.props.onChangeRaw || (s.props.onChangeRaw.apply(s, _$e), _$r && "function" == typeof _$r.isDefaultPrevented && !_$r.isDefaultPrevented())) {
                    s.setState({
                        inputValue: (null == _$r ? void 0 : _$r.target) instanceof HTMLInputElement ? _$r.target.value : null,
                        lastPreSelectChange: nr
                    });
                    var a = s.props, _$o = a.dateFormat, i = void 0 === _$o ? n.defaultProps.dateFormat : _$o, l = a.strictParsing, c = void 0 === l ? n.defaultProps.strictParsing : l, p = function(e, t, r, n, a) {
                        var _$o, s = null, i = Ke(r) || Ke(qe()), l = !0;
                        if (Array.isArray(t)) return t.forEach(function(t) {
                            var _$o = K.parse(e, t, new Date, {
                                locale: i,
                                useAdditionalWeekYearTokens: !0,
                                useAdditionalDayOfYearTokens: !0
                            });
                            n && (l = Ce(_$o, a) && e === _e(_$o, t, r)), Ce(_$o, a) && l && (s = _$o);
                        }), s;
                        if (s = K.parse(e, t, new Date, {
                            locale: i,
                            useAdditionalWeekYearTokens: !0,
                            useAdditionalDayOfYearTokens: !0
                        }), n) l = Ce(s) && e === _e(s, t, r);
                        else if (!Ce(s)) {
                            var c = (null !== (_$o = t.match(be)) && void 0 !== _$o ? _$o : []).map(function(e) {
                                var _$t = e[0];
                                if ("p" === _$t || "P" === _$t) {
                                    var _$r = k.longFormatters[_$t];
                                    return i ? _$r(e, i.formatLong) : _$t;
                                }
                                return e;
                            }).join("");
                            e.length > 0 && (s = K.parse(e, c.slice(0, e.length), new Date, {
                                useAdditionalWeekYearTokens: !0,
                                useAdditionalDayOfYearTokens: !0
                            })), Ce(s) || (s = new Date(e));
                        }
                        return Ce(s) && l ? s : null;
                    }((null == _$r ? void 0 : _$r.target) instanceof HTMLInputElement ? _$r.target.value : "", i, s.props.locale, c, s.props.minDate);
                    s.props.showTimeSelectOnly && s.props.selected && p && !He(p, s.props.selected) && (p = V.set(s.props.selected, {
                        hours: b.getHours(p),
                        minutes: C.getMinutes(p),
                        seconds: P.getSeconds(p)
                    })), !p && (null == _$r ? void 0 : _$r.target) instanceof HTMLInputElement && (null == _$r ? void 0 : _$r.target.value) || s.setSelected(p, _$r, !0);
                }
            }, s.handleSelect = function(e, t, r) {
                if (s.props.shouldCloseOnSelect && !s.props.showTimeSelect && s.sendFocusBackToInput(), s.props.onChangeRaw && s.props.onChangeRaw(t), s.setSelected(e, t, !1, r), s.props.showDateSelect && s.setState({
                    isRenderAriaLiveMessage: !0
                }), !s.props.shouldCloseOnSelect || s.props.showTimeSelect) s.setPreSelection(e);
                else if (!s.props.inline) {
                    s.props.selectsRange || s.setOpen(!1);
                    var _$n = s.props, a = _$n.startDate, _$o = _$n.endDate;
                    !a || _$o || !s.props.swapRange && Dt(e, a) || s.setOpen(!1);
                }
            }, s.setSelected = function(e, t, r, a) {
                var _$o, i = e;
                if (s.props.showYearPicker) {
                    if (null !== i && Ze(x.getYear(i), s.props)) return;
                } else if (s.props.showMonthYearPicker) {
                    if (null !== i && $e(i, s.props)) return;
                } else if (null !== i && je(i, s.props)) return;
                var l = s.props, c = l.onChange, p = l.selectsRange, d = l.startDate, u = l.endDate, f = l.selectsMultiple, h = l.selectedDates, m = l.minTime, v = l.swapRange;
                if (!We(s.props.selected, i) || s.props.allowSameDay || p || f) {
                    if (null !== i && (!s.props.selected || r && (s.props.showTimeSelect || s.props.showTimeSelectOnly || s.props.showTimeInput) || (i = Pe(i, {
                        hour: b.getHours(s.props.selected),
                        minute: C.getMinutes(s.props.selected),
                        second: P.getSeconds(s.props.selected)
                    })), r || !s.props.showTimeSelect && !s.props.showTimeSelectOnly || m && (i = Pe(i, {
                        hour: m.getHours(),
                        minute: m.getMinutes(),
                        second: m.getSeconds()
                    })), s.props.inline || s.setState({
                        preSelection: i
                    }), s.props.focusSelectedMonth || s.setState({
                        monthSelectedIn: a
                    })), p) {
                        var g = d && !u, D = d && u;
                        !d && !u ? c ? c([
                            i,
                            null
                        ], t) : n.defaultProps.onChange : g && (null === i ? c ? c([
                            null,
                            null
                        ], t) : n.defaultProps.onChange : Dt(i, d) ? v ? c ? c([
                            i,
                            d
                        ], t) : n.defaultProps.onChange : c ? c([
                            i,
                            null
                        ], t) : n.defaultProps.onChange : c ? c([
                            d,
                            i
                        ], t) : n.defaultProps.onChange), D && (c ? c([
                            i,
                            null
                        ], t) : n.defaultProps.onChange);
                    } else if (f) {
                        if (null !== i) {
                            if (null == h ? void 0 : h.length) {
                                if (h.some(function(e) {
                                    return He(e, i);
                                })) {
                                    var y = h.filter(function(e) {
                                        return !He(e, i);
                                    });
                                    c ? c(y, t) : n.defaultProps.onChange;
                                } else c ? c(De(De([], h, !0), [
                                    i
                                ], !1), t) : n.defaultProps.onChange;
                            } else c ? c([
                                i
                            ], t) : n.defaultProps.onChange;
                        }
                    } else c ? c(i, t) : n.defaultProps.onChange;
                }
                r || ((null !== (_$o = s.props.onSelect) && void 0 !== _$o ? _$o : n.defaultProps.onSelect)(i, t), s.setState({
                    inputValue: null
                }));
            }, s.setPreSelection = function(e) {
                var t = I.isDate(s.props.minDate), _$r = I.isDate(s.props.maxDate), _$n = !0;
                if (e) {
                    var a = Ye(e);
                    if (t && _$r) _$n = Qe(e, s.props.minDate, s.props.maxDate);
                    else if (t) {
                        var _$o = Ye(s.props.minDate);
                        _$n = N.isAfter(e, _$o) || We(a, _$o);
                    } else if (_$r) {
                        var i = Re(s.props.maxDate);
                        _$n = O.isBefore(e, i) || We(a, i);
                    }
                }
                _$n && s.setState({
                    preSelection: e
                });
            }, s.toggleCalendar = function() {
                s.setOpen(!s.state.open);
            }, s.handleTimeChange = function(e) {
                var t;
                if (!s.props.selectsRange && !s.props.selectsMultiple) {
                    var _$r = s.props.selected ? s.props.selected : s.getPreSelection(), a = s.props.selected ? e : Pe(_$r, {
                        hour: b.getHours(e),
                        minute: C.getMinutes(e)
                    });
                    s.setState({
                        preSelection: a
                    }), (null !== (t = s.props.onChange) && void 0 !== t ? t : n.defaultProps.onChange)(a), s.props.shouldCloseOnSelect && !s.props.showTimeInput && (s.sendFocusBackToInput(), s.setOpen(!1)), s.props.showTimeInput && s.setOpen(!0), (s.props.showTimeSelectOnly || s.props.showTimeSelect) && s.setState({
                        isRenderAriaLiveMessage: !0
                    }), s.setState({
                        inputValue: null
                    });
                }
            }, s.onInputClick = function() {
                var _$e, t;
                s.props.disabled || s.props.readOnly || s.setOpen(!0), null === (t = (_$e = s.props).onInputClick) || void 0 === t || t.call(_$e);
            }, s.onInputKeyDown = function(e) {
                var t, _$r, _$n, a, _$o;
                null === (_$r = (t = s.props).onKeyDown) || void 0 === _$r || _$r.call(t, e);
                var i = e.key;
                if (s.state.open || s.props.inline || s.props.preventOpenOnFocus) {
                    if (s.state.open) {
                        if (i === ye.ArrowDown || i === ye.ArrowUp) {
                            e.preventDefault();
                            var l = s.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : s.props.showWeekPicker && s.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : s.props.showFullMonthYearPicker || s.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', c = (null === (_$n = s.calendar) || void 0 === _$n ? void 0 : _$n.componentNode) instanceof Element && s.calendar.componentNode.querySelector(l);
                            return void (c instanceof HTMLElement && c.focus({
                                preventScroll: !0
                            }));
                        }
                        var p = Me(s.state.preSelection);
                        i === ye.Enter ? (e.preventDefault(), s.inputOk() && s.state.lastPreSelectChange === ar ? (s.handleSelect(p, e), !s.props.shouldCloseOnSelect && s.setPreSelection(p)) : s.setOpen(!1)) : i === ye.Escape ? (e.preventDefault(), s.sendFocusBackToInput(), s.setOpen(!1)) : i === ye.Tab && s.setOpen(!1), s.inputOk() || null === (_$o = (a = s.props).onInputError) || void 0 === _$o || _$o.call(a, {
                            code: 1,
                            msg: tr
                        });
                    }
                } else i !== ye.ArrowDown && i !== ye.ArrowUp && i !== ye.Enter || s.onInputClick();
            }, s.onPortalKeyDown = function(e) {
                e.key === ye.Escape && (e.preventDefault(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.setOpen(!1), setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }, s.onDayKeyDown = function(e) {
                var t, _$r, _$n, _$o, l = s.props, c = l.minDate, u = l.maxDate, f = l.disabledKeyboardNavigation, h = l.showWeekPicker, m = l.shouldCloseOnSelect, v = l.locale, g = l.calendarStartDay, y = l.adjustDateOnChange, k = l.inline;
                if (null === (_$r = (t = s.props).onKeyDown) || void 0 === _$r || _$r.call(t, e), !f) {
                    var w = e.key, S = e.shiftKey, b = Me(s.state.preSelection), M = function M(e, t) {
                        var _$r = t;
                        switch(e){
                            case ye.ArrowRight:
                                _$r = h ? p.addWeeks(t, 1) : a.addDays(t, 1);
                                break;
                            case ye.ArrowLeft:
                                _$r = h ? se.subWeeks(t, 1) : ne.subDays(t, 1);
                                break;
                            case ye.ArrowUp:
                                _$r = se.subWeeks(t, 1);
                                break;
                            case ye.ArrowDown:
                                _$r = p.addWeeks(t, 1);
                                break;
                            case ye.PageUp:
                                _$r = S ? ie.subYears(t, 1) : ae.subMonths(t, 1);
                                break;
                            case ye.PageDown:
                                _$r = S ? d.addYears(t, 1) : i.addMonths(t, 1);
                                break;
                            case ye.Home:
                                _$r = xe(t, v, g);
                                break;
                            case ye.End:
                                _$r = function(e) {
                                    return D.endOfWeek(e);
                                }(t);
                        }
                        return _$r;
                    };
                    if (w === ye.Enter) return e.preventDefault(), s.handleSelect(b, e), void (!m && s.setPreSelection(b));
                    if (w === ye.Escape) return e.preventDefault(), s.setOpen(!1), void (s.inputOk() || null === (_$o = (_$n = s.props).onInputError) || void 0 === _$o || _$o.call(_$n, {
                        code: 1,
                        msg: tr
                    }));
                    var C = null;
                    switch(w){
                        case ye.ArrowLeft:
                        case ye.ArrowRight:
                        case ye.ArrowUp:
                        case ye.ArrowDown:
                        case ye.PageUp:
                        case ye.PageDown:
                        case ye.Home:
                        case ye.End:
                            C = function(e, t) {
                                for(var _$r = e, _$n = !1, a = 0, _$o = M(e, t); !_$n;){
                                    if (a >= 40) {
                                        _$o = t;
                                        break;
                                    }
                                    c && _$o < c && (_$r = ye.ArrowRight, _$o = je(c, s.props) ? M(_$r, _$o) : c), u && _$o > u && (_$r = ye.ArrowLeft, _$o = je(u, s.props) ? M(_$r, _$o) : u), je(_$o, s.props) ? (_$r !== ye.PageUp && _$r !== ye.Home || (_$r = ye.ArrowRight), _$r !== ye.PageDown && _$r !== ye.End || (_$r = ye.ArrowLeft), _$o = M(_$r, _$o)) : _$n = !0, a++;
                                }
                                return _$o;
                            }(w, b);
                    }
                    if (C) {
                        if (e.preventDefault(), s.setState({
                            lastPreSelectChange: ar
                        }), y && s.setSelected(C), s.setPreSelection(C), k) {
                            var E = _.getMonth(b), P = _.getMonth(C), Y = x.getYear(b), N = x.getYear(C);
                            E !== P || Y !== N ? s.setState({
                                shouldFocusDayInline: !0
                            }) : s.setState({
                                shouldFocusDayInline: !1
                            });
                        }
                    } else s.props.onInputError && s.props.onInputError({
                        code: 1,
                        msg: tr
                    });
                }
            }, s.onPopperKeyDown = function(e) {
                e.key === ye.Escape && (e.preventDefault(), s.sendFocusBackToInput());
            }, s.onClearClick = function(e) {
                e && e.preventDefault && e.preventDefault(), s.sendFocusBackToInput();
                var t = s.props, _$r = t.selectsRange, a = t.onChange;
                _$r ? a ? a([
                    null,
                    null
                ], e) : n.defaultProps.onChange() : a ? a(null, e) : n.defaultProps.onChange(), s.setState({
                    inputValue: null
                });
            }, s.clear = function() {
                s.onClearClick();
            }, s.onScroll = function(e) {
                "boolean" == typeof s.props.closeOnScroll && s.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || s.setOpen(!1) : "function" == typeof s.props.closeOnScroll && s.props.closeOnScroll(e) && s.setOpen(!1);
            }, s.renderCalendar = function() {
                var _$e, t;
                return s.props.inline || s.isCalendarOpen() ? ue.default.createElement(er, ge({
                    ref: function ref(e) {
                        s.calendar = e;
                    }
                }, s.props, s.state, {
                    setOpen: s.setOpen,
                    dateFormat: null !== (_$e = s.props.dateFormatCalendar) && void 0 !== _$e ? _$e : n.defaultProps.dateFormatCalendar,
                    onSelect: s.handleSelect,
                    onClickOutside: s.handleCalendarClickOutside,
                    holidays: ut(s.modifyHolidays()),
                    outsideClickIgnoreClass: Zt,
                    onDropdownFocus: s.handleDropdownFocus,
                    onTimeChange: s.handleTimeChange,
                    className: s.props.calendarClassName,
                    container: s.props.calendarContainer,
                    handleOnKeyDown: s.props.onKeyDown,
                    handleOnDayKeyDown: s.onDayKeyDown,
                    setPreSelection: s.setPreSelection,
                    dropdownMode: null !== (t = s.props.dropdownMode) && void 0 !== t ? t : n.defaultProps.dropdownMode
                }), s.props.children) : null;
            }, s.renderAriaLiveRegion = function() {
                var _$e, t = s.props, _$r = t.dateFormat, a = void 0 === _$r ? n.defaultProps.dateFormat : _$r, _$o = t.locale, i = s.props.showTimeInput || s.props.showTimeSelect ? "PPPPp" : "PPPP";
                return _$e = s.props.selectsRange ? "Selected start date: ".concat(Ee(s.props.startDate, {
                    dateFormat: i,
                    locale: _$o
                }), ". ").concat(s.props.endDate ? "End date: " + Ee(s.props.endDate, {
                    dateFormat: i,
                    locale: _$o
                }) : "") : s.props.showTimeSelectOnly ? "Selected time: ".concat(Ee(s.props.selected, {
                    dateFormat: a,
                    locale: _$o
                })) : s.props.showYearPicker ? "Selected year: ".concat(Ee(s.props.selected, {
                    dateFormat: "yyyy",
                    locale: _$o
                })) : s.props.showMonthYearPicker ? "Selected month: ".concat(Ee(s.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: _$o
                })) : s.props.showQuarterYearPicker ? "Selected quarter: ".concat(Ee(s.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: _$o
                })) : "Selected date: ".concat(Ee(s.props.selected, {
                    dateFormat: i,
                    locale: _$o
                })), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, _$e);
            }, s.renderDateInput = function() {
                var _$e, a, _$o, i = t.clsx(s.props.className, ((_$e = {})[Zt] = s.state.open, _$e)), l = s.props.customInput || ue.default.createElement("input", {
                    type: "text"
                }), c = s.props.customInputRef || "ref", p = s.props, d = p.dateFormat, u = void 0 === d ? n.defaultProps.dateFormat : d, f = p.locale, h = "string" == typeof s.props.value ? s.props.value : "string" == typeof s.state.inputValue ? s.state.inputValue : s.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var _$n = Ee(e, r), a = t ? Ee(t, r) : "";
                    return "".concat(_$n, " - ").concat(a);
                }(s.props.startDate, s.props.endDate, {
                    dateFormat: u,
                    locale: f
                }) : s.props.selectsMultiple ? function(e, t) {
                    if (!(null == e ? void 0 : e.length)) return "";
                    var _$r = e[0] ? Ee(e[0], t) : "";
                    if (1 === e.length) return _$r;
                    if (2 === e.length && e[1]) {
                        var _$n = Ee(e[1], t);
                        return "".concat(_$r, ", ").concat(_$n);
                    }
                    var a = e.length - 1;
                    return "".concat(_$r, " (+").concat(a, ")");
                }(null !== (_$o = s.props.selectedDates) && void 0 !== _$o ? _$o : [], {
                    dateFormat: u,
                    locale: f
                }) : Ee(s.props.selected, {
                    dateFormat: u,
                    locale: f
                });
                return r.cloneElement(l, ((a = {})[c] = function(e) {
                    s.input = e;
                }, a.value = h, a.onBlur = s.handleBlur, a.onChange = s.handleChange, a.onClick = s.onInputClick, a.onFocus = s.handleFocus, a.onKeyDown = s.onInputKeyDown, a.id = s.props.id, a.name = s.props.name, a.form = s.props.form, a.autoFocus = s.props.autoFocus, a.placeholder = s.props.placeholderText, a.disabled = s.props.disabled, a.autoComplete = s.props.autoComplete, a.className = t.clsx(l.props.className, i), a.title = s.props.title, a.readOnly = s.props.readOnly, a.required = s.props.required, a.tabIndex = s.props.tabIndex, a["aria-describedby"] = s.props.ariaDescribedBy, a["aria-invalid"] = s.props.ariaInvalid, a["aria-labelledby"] = s.props.ariaLabelledBy, a["aria-required"] = s.props.ariaRequired, a));
            }, s.renderClearButton = function() {
                var _$e = s.props, _$r = _$e.isClearable, _$n = _$e.disabled, a = _$e.selected, _$o = _$e.startDate, i = _$e.endDate, l = _$e.clearButtonTitle, c = _$e.clearButtonClassName, p = void 0 === c ? "" : c, d = _$e.ariaLabelClose, u = void 0 === d ? "Close" : d, f = _$e.selectedDates;
                return _$r && (null != a || null != _$o || null != i || (null == f ? void 0 : f.length)) ? ue.default.createElement("button", {
                    type: "button",
                    className: t.clsx("react-datepicker__close-icon", p, {
                        "react-datepicker__close-icon--disabled": _$n
                    }),
                    disabled: _$n,
                    "aria-label": u,
                    onClick: s.onClearClick,
                    title: l,
                    tabIndex: -1
                }) : null;
            }, s.state = s.calcInitialState(), s.preventFocusTimeout = void 0, s;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function get() {
                return {
                    allowSameDay: !1,
                    dateFormat: "MM/dd/yyyy",
                    dateFormatCalendar: "LLLL yyyy",
                    onChange: function onChange() {},
                    disabled: !1,
                    disabledKeyboardNavigation: !1,
                    dropdownMode: "scroll",
                    onFocus: function onFocus() {},
                    onBlur: function onBlur() {},
                    onKeyDown: function onKeyDown() {},
                    onInputClick: function onInputClick() {},
                    onSelect: function onSelect() {},
                    onClickOutside: function onClickOutside() {},
                    onMonthChange: function onMonthChange() {},
                    onCalendarOpen: function onCalendarOpen() {},
                    onCalendarClose: function onCalendarClose() {},
                    preventOpenOnFocus: !1,
                    onYearChange: function onYearChange() {},
                    onInputError: function onInputError() {},
                    monthsShown: 1,
                    readOnly: !1,
                    withPortal: !1,
                    selectsDisabledDaysInRange: !1,
                    shouldCloseOnSelect: !0,
                    showTimeSelect: !1,
                    showTimeInput: !1,
                    showPreviousMonths: !1,
                    showMonthYearPicker: !1,
                    showFullMonthYearPicker: !1,
                    showTwoColumnMonthYearPicker: !1,
                    showFourColumnMonthYearPicker: !1,
                    showYearPicker: !1,
                    showQuarterYearPicker: !1,
                    showWeekPicker: !1,
                    strictParsing: !1,
                    swapRange: !1,
                    timeIntervals: 30,
                    timeCaption: "Time",
                    previousMonthAriaLabel: "Previous Month",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthAriaLabel: "Next Month",
                    nextMonthButtonLabel: "Next Month",
                    previousYearAriaLabel: "Previous Year",
                    previousYearButtonLabel: "Previous Year",
                    nextYearAriaLabel: "Next Year",
                    nextYearButtonLabel: "Next Year",
                    timeInputLabel: "Time",
                    enableTabLoop: !0,
                    yearItemNumber: Se,
                    focusSelectedMonth: !1,
                    showPopperArrow: !0,
                    excludeScrollbar: !0,
                    customTimeInput: null,
                    calendarStartDay: void 0,
                    toggleCalendarOnIconClick: !1,
                    usePointerEvent: !1
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.componentDidUpdate = function(e, t) {
            var _$r, _$n, a, o, s, i;
            e.inline && (s = e.selected, i = this.props.selected, s && i ? _.getMonth(s) !== _.getMonth(i) || x.getYear(s) !== x.getYear(i) : s !== i) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                monthSelectedIn: 0
            }), e.highlightDates !== this.props.highlightDates && this.setState({
                highlightDates: dt(this.props.highlightDates)
            }), t.focused || We(e.selected, this.props.selected) || this.setState({
                inputValue: null
            }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && (null === (_$n = (_$r = this.props).onCalendarOpen) || void 0 === _$n || _$n.call(_$r)), !0 === t.open && !1 === this.state.open && (null === (o = (a = this.props).onCalendarClose) || void 0 === o || o.call(a)));
        }, n.prototype.componentWillUnmount = function() {
            this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.renderInputContainer = function() {
            var _$e = this.props, _$r = _$e.showIcon, _$n = _$e.icon, a = _$e.calendarIconClassname, o = _$e.calendarIconClassName, s = _$e.toggleCalendarOnIconClick, i = this.state.open;
            return a && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), ue.default.createElement("div", {
                className: "react-datepicker__input-container".concat(_$r ? " react-datepicker__view-calendar-icon" : "")
            }, _$r && ue.default.createElement(jt, ge({
                icon: _$n,
                className: t.clsx(o, !o && a, i && "react-datepicker-ignore-onclickoutside")
            }, s ? {
                onClick: this.toggleCalendar
            } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
        }, n.prototype.render = function() {
            var _$e = this.renderCalendar();
            if (this.props.inline) return _$e;
            if (this.props.withPortal) {
                var t = this.state.open ? ue.default.createElement(zt, {
                    enableTabLoop: this.props.enableTabLoop
                }, ue.default.createElement("div", {
                    className: "react-datepicker__portal",
                    tabIndex: -1,
                    onKeyDown: this.onPortalKeyDown
                }, _$e)) : null;
                return this.state.open && this.props.portalId && (t = ue.default.createElement(Ut, ge({
                    portalId: this.props.portalId
                }, this.props), t)), ue.default.createElement("div", null, this.renderInputContainer(), t);
            }
            return ue.default.createElement(Jt, ge({}, this.props, {
                className: this.props.popperClassName,
                hidePopper: !this.isCalendarOpen(),
                targetComponent: this.renderInputContainer(),
                popperComponent: _$e,
                popperOnKeyDown: this.onPopperKeyDown,
                showArrow: this.props.showPopperArrow
            }));
        }, n;
    }(r.Component), nr = "input", ar = "navigate";
    e.CalendarContainer = ke, e.default = rr, e.getDefaultLocale = qe, e.registerLocale = function(e, t) {
        var _$r = we();
        _$r.__localeData__ || (_$r.__localeData__ = {}), _$r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        we().__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{"328b40e48ebebf49":"1N65K","55b400dfb9477df9":"l5IPE","11a993db5effee60":"6kmQP","5fc940b8b11b2f30":"4rfUY","4f1b37d05fed00b3":"4nx75","786b9925c1b6b5ed":"cxnKG","baecc74d7df402ea":"6cECY","13428a01c277b105":"8P1Ro","11178028a6b82c2f":"qV0t6","b78d0278e54da1b4":"jPvAg","7360dafd9cf06bde":"fDVF0","1a7d4440a348b466":"6OksG","50dce9ec585a5332":"aM2iH","1282d380e0614c2b":"4hKRZ","cdc90b6df52760f":"96JRi","5c05196fbf6d6b4d":"hrufR","23c6d2169b7feabe":"hMsPJ","9a6937c0aa7a418e":"9aLDB","7ec00ac1947d54ca":"gNh98","d7b993ace1eca80":"jA8qR","5592c752ef1290f4":"g0pDX","42e3036b4499153e":"fhUMA","72fc20cc52029f11":"4Aywj","8406427195a66845":"9UpoQ","12eec1f6d562e008":"bcMd7","fa470ac376b26caf":"8yLyg","bf3222da2f520817":"dEUoh","e8ff49b0d1cab426":"kpBnX","d6dea87c85b53e02":"cHOKA","685dda4962dc82e1":"8xoTX","c3348d940b830a7f":"fzng2","53a4aaeeb87e1c51":"a5u0o","13c776570732a9da":"byTCo","fda4089c257f1876":"22cZO","b5061c3c95f48e73":"hYihA","f57afb99b9b06613":"6jB9O","6663b9b2b265a941":"4MJIk","496ef8c8ed2b34d6":"eU6Ej","6553b0b4b603e1c3":"6Uhv0","45f66dd8a17e85aa":"eHJvF","9818583261d8a102":"adXYY","47020b485e994171":"1K8Pj","201a807b2e6adc5e":"9HIBF","a89a534c753bb4c3":"iAstl","80c2a8fbe4339722":"pVQn8","8ac41f1b252a0973":"3JkVP","e1fbbdf633f9e5ae":"kPhzA","156a522b3b8fd124":"bbmV7","f2620442a53b80d6":"ciD3Y","b9a1398c1c94250d":"kIitV","1b94d4eb34edeca3":"jwmnN","2fdd28e51cf3c8b2":"5punH","964e71bf85841794":"mXmxs","38468de993ee0549":"auSUw","72fb68fdc0d9bca3":"1RQd2","ec1866b328e982ea":"kIE5G","aa659b497503e983":"cvXrD","f501b8cd52ae4ff":"lGAwE","d616e9f0b9bc7b7a":"ez0sQ","7b7bf8fb2c20e0c7":"gxXpH","9e212fc4b323ed41":"91P4k","a3a5398768dc185f":"eYsCJ","c3c8699f35b37adb":"9bqSj","96de361de41dc920":"lkfQ7"}],"1N65K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", function() {
    return clsx;
});
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6kmQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IGNORE_CLASS_NAME", function() {
    return IGNORE_CLASS_NAME;
});
var _react = require("react");
var _reactDom = require("react-dom");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    var passive = false;
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener("testPassiveEventSupport", noop, options);
    window.removeEventListener("testPassiveEventSupport", noop, options);
    return passive;
};
function autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = [
    "touchstart",
    "touchmove"
];
var IGNORE_CLASS_NAME = "ignore-react-onclickoutside";
/**
 * Options for addEventHandler and removeEventHandler
 */ function getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        _inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === "function") {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === "function") {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === "function") {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === "function") return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === "function") return instance.setClickOutsideRef();
                return (0, _reactDom.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === "undefined" || enabledInstances[_this._uid]) return;
                if (typeof passiveEventSupport === "undefined") passiveEventSupport = testPassiveEventSupport();
                enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete enabledInstances[_this._uid];
                var fn = handlersMap[_this._uid];
                if (fn && typeof document !== "undefined") {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                    });
                    delete handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === "undefined" || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === "function") {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== "function") throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = _objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, _react.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, _react.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: IGNORE_CLASS_NAME,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
exports.default = onClickOutsideHOC;

},{"react":"l5IPE","react-dom":"lkfQ7","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9bqSj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrow", function() {
    return 0, _reactDom1.arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return 0, _reactDom1.autoPlacement;
});
parcelHelpers.export(exports, "autoUpdate", function() {
    return 0, _reactDom1.autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return 0, _reactDom1.computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _reactDom1.detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return 0, _reactDom1.flip;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _reactDom1.getOverflowAncestors;
});
parcelHelpers.export(exports, "hide", function() {
    return 0, _reactDom1.hide;
});
parcelHelpers.export(exports, "inline", function() {
    return 0, _reactDom1.inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return 0, _reactDom1.limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return 0, _reactDom1.offset;
});
parcelHelpers.export(exports, "platform", function() {
    return 0, _reactDom1.platform;
});
parcelHelpers.export(exports, "shift", function() {
    return 0, _reactDom1.shift;
});
parcelHelpers.export(exports, "size", function() {
    return 0, _reactDom1.size;
});
parcelHelpers.export(exports, "Composite", function() {
    return Composite;
});
parcelHelpers.export(exports, "CompositeItem", function() {
    return CompositeItem;
});
parcelHelpers.export(exports, "FloatingArrow", function() {
    return FloatingArrow;
});
parcelHelpers.export(exports, "FloatingDelayGroup", function() {
    return FloatingDelayGroup;
});
parcelHelpers.export(exports, "FloatingFocusManager", function() {
    return FloatingFocusManager;
});
parcelHelpers.export(exports, "FloatingList", function() {
    return FloatingList;
});
parcelHelpers.export(exports, "FloatingNode", function() {
    return FloatingNode;
});
parcelHelpers.export(exports, "FloatingOverlay", function() {
    return FloatingOverlay;
});
parcelHelpers.export(exports, "FloatingPortal", function() {
    return FloatingPortal;
});
parcelHelpers.export(exports, "FloatingTree", function() {
    return FloatingTree;
});
parcelHelpers.export(exports, "inner", function() {
    return inner;
});
parcelHelpers.export(exports, "safePolygon", function() {
    return safePolygon;
});
parcelHelpers.export(exports, "useClick", function() {
    return useClick;
});
parcelHelpers.export(exports, "useClientPoint", function() {
    return useClientPoint;
});
parcelHelpers.export(exports, "useDelayGroup", function() {
    return useDelayGroup;
});
parcelHelpers.export(exports, "useDelayGroupContext", function() {
    return useDelayGroupContext;
});
parcelHelpers.export(exports, "useDismiss", function() {
    return useDismiss;
});
parcelHelpers.export(exports, "useFloating", function() {
    return useFloating;
});
parcelHelpers.export(exports, "useFloatingNodeId", function() {
    return useFloatingNodeId;
});
parcelHelpers.export(exports, "useFloatingParentNodeId", function() {
    return useFloatingParentNodeId;
});
parcelHelpers.export(exports, "useFloatingPortalNode", function() {
    return useFloatingPortalNode;
});
parcelHelpers.export(exports, "useFloatingRootContext", function() {
    return useFloatingRootContext;
});
parcelHelpers.export(exports, "useFloatingTree", function() {
    return useFloatingTree;
});
parcelHelpers.export(exports, "useFocus", function() {
    return useFocus;
});
parcelHelpers.export(exports, "useHover", function() {
    return useHover;
});
parcelHelpers.export(exports, "useId", function() {
    return useId;
});
parcelHelpers.export(exports, "useInnerOffset", function() {
    return useInnerOffset;
});
parcelHelpers.export(exports, "useInteractions", function() {
    return useInteractions;
});
parcelHelpers.export(exports, "useListItem", function() {
    return useListItem;
});
parcelHelpers.export(exports, "useListNavigation", function() {
    return useListNavigation;
});
parcelHelpers.export(exports, "useMergeRefs", function() {
    return useMergeRefs;
});
parcelHelpers.export(exports, "useRole", function() {
    return useRole;
});
parcelHelpers.export(exports, "useTransitionStatus", function() {
    return useTransitionStatus;
});
parcelHelpers.export(exports, "useTransitionStyles", function() {
    return useTransitionStyles;
});
parcelHelpers.export(exports, "useTypeahead", function() {
    return useTypeahead;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _toPropertyKey = require("@swc/helpers/_/_to_property_key");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _react = require("react");
var _utils = require("@floating-ui/react/utils");
var _utils1 = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
var _tabbable = require("tabbable");
var _reactDom = require("react-dom");
var _reactDom1 = require("@floating-ui/react-dom");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function useMergeRefs(refs) {
    return _react.useMemo(function() {
        if (refs.every(function(ref) {
            return ref == null;
        })) return null;
        return function(value) {
            refs.forEach(function(ref) {
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
var SafeReact = (0, _objectSpread._)({}, _react);
var useInsertionEffect = SafeReact.useInsertionEffect;
var useSafeInsertionEffect = useInsertionEffect || function(fn) {
    return fn();
};
function useEffectEvent(callback) {
    var ref = _react.useRef(function() {});
    useSafeInsertionEffect(function() {
        ref.current = callback;
    });
    return _react.useCallback(function() {
        var _ref;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : (_ref = ref).current.apply(_ref, (0, _toConsumableArray._)(args));
    }, []);
}
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
function isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
    return findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function getMaxIndex(listRef, disabledIndices) {
    return findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function findNonDisabledIndex(listRef, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_startingIndex = _ref.startingIndex, startingIndex = _ref_startingIndex === void 0 ? -1 : _ref_startingIndex, _ref_decrement = _ref.decrement, decrement = _ref_decrement === void 0 ? false : _ref_decrement, disabledIndices = _ref.disabledIndices, _ref_amount = _ref.amount, amount = _ref_amount === void 0 ? 1 : _ref_amount;
    var list = listRef.current;
    var index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && isDisabled(list, index, disabledIndices));
    return index;
}
function getGridNavigatedIndex(elementsRef, _ref) {
    var event = _ref.event, orientation = _ref.orientation, loop = _ref.loop, cols = _ref.cols, disabledIndices = _ref.disabledIndices, minIndex = _ref.minIndex, maxIndex = _ref.maxIndex, prevIndex = _ref.prevIndex, tmp = _ref.stopEvent, stop = tmp === void 0 ? false : tmp;
    var nextIndex = prevIndex;
    if (event.key === ARROW_UP) {
        stop && (0, _utils.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                var col = prevIndex % cols;
                var maxCol = maxIndex % cols;
                var offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if (isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === ARROW_DOWN) {
        stop && (0, _utils.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if (isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        var prevRow = (0, _utils1.floor)(prevIndex / cols);
        if (event.key === ARROW_RIGHT) {
            stop && (0, _utils.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && isDifferentRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if (isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === ARROW_LEFT) {
            stop && (0, _utils.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && isDifferentRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        var lastRow = (0, _utils1.floor)(maxIndex / cols) === prevRow;
        if (isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === ARROW_LEFT ? maxIndex : findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function buildCellMap(sizes, cols, dense) {
    var cellMap = [];
    var startIndex = 0;
    sizes.forEach(function(_ref2, index) {
        var _loop = function() {
            var targetCells = [];
            for(var i = 0; i < width; i++)for(var j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every(function(cell) {
                return cellMap[cell] == null;
            })) {
                targetCells.forEach(function(cell) {
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        };
        var width = _ref2.width, height = _ref2.height;
        var itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced)_loop();
    });
    // convert into a non-sparse array
    return (0, _toConsumableArray._)(cellMap);
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    var firstCellIndex = cellMap.indexOf(index);
    var sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function getCellIndices(indices, cellMap) {
    return cellMap.flatMap(function(index, cellIndex) {
        return indices.includes(index) ? [
            cellIndex
        ] : [];
    });
}
function isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    var element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
var rafId = 0;
function enqueueFocus(el, options) {
    if (options === void 0) options = {};
    var _options_preventScroll = options.preventScroll, preventScroll = _options_preventScroll === void 0 ? false : _options_preventScroll, _options_cancelPrevious = options.cancelPrevious, cancelPrevious = _options_cancelPrevious === void 0 ? true : _options_cancelPrevious, _options_sync = options.sync, sync = _options_sync === void 0 ? false : _options_sync;
    cancelPrevious && cancelAnimationFrame(rafId);
    var exec = function() {
        return el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    };
    if (sync) exec();
    else rafId = requestAnimationFrame(exec);
}
var index = typeof document !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function sortByDocumentPosition(a, b) {
    var position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = map1.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value !== map2.get(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
var FloatingListContext = /*#__PURE__*/ _react.createContext({
    register: function() {},
    unregister: function() {},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function FloatingList(props) {
    var children = props.children, elementsRef = props.elementsRef, labelsRef = props.labelsRef;
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return new Map();
    }), 2), map = _React_useState[0], setMap = _React_useState[1];
    var register = _react.useCallback(function(node) {
        setMap(function(prevMap) {
            return new Map(prevMap).set(node, null);
        });
    }, []);
    var unregister = _react.useCallback(function(node) {
        setMap(function(prevMap) {
            var map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    index(function() {
        var newMap = new Map(map);
        var nodes = Array.from(newMap.keys()).sort(sortByDocumentPosition);
        nodes.forEach(function(node, index) {
            newMap.set(node, index);
        });
        if (!areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ _react.createElement(FloatingListContext.Provider, {
        value: _react.useMemo(function() {
            return {
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            };
        }, [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function useListItem(props) {
    if (props === void 0) props = {};
    var label = props.label;
    var _React_useContext = _react.useContext(FloatingListContext), register = _React_useContext.register, unregister = _React_useContext.unregister, map = _React_useContext.map, elementsRef = _React_useContext.elementsRef, labelsRef = _React_useContext.labelsRef;
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), index$1 = _React_useState[0], setIndex = _React_useState[1];
    var componentRef = _react.useRef(null);
    var ref = _react.useCallback(function(node) {
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                var isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    index(function() {
        var node = componentRef.current;
        if (node) {
            register(node);
            return function() {
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    index(function() {
        var index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return _react.useMemo(function() {
        return {
            ref: ref,
            index: index$1 == null ? -1 : index$1
        };
    }, [
        index$1,
        ref
    ]);
}
function renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ _react.cloneElement(render, computedProps);
    return /*#__PURE__*/ _react.createElement("div", computedProps);
}
var CompositeContext = /*#__PURE__*/ _react.createContext({
    activeIndex: 0,
    onNavigate: function() {}
});
var horizontalKeys = [
    ARROW_LEFT,
    ARROW_RIGHT
];
var verticalKeys = [
    ARROW_UP,
    ARROW_DOWN
];
var allKeys = (0, _toConsumableArray._)(horizontalKeys).concat((0, _toConsumableArray._)(verticalKeys));
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ var Composite = /*#__PURE__*/ _react.forwardRef(function Composite(props, forwardedRef) {
    var render = props.render, _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? "both" : _props_orientation, _props_loop = props.loop, loop = _props_loop === void 0 ? true : _props_loop, _props_cols = props.cols, cols = _props_cols === void 0 ? 1 : _props_cols, disabledIndices = props.disabledIndices, externalActiveIndex = props.activeIndex, externalSetActiveIndex = props.onNavigate, itemSizes = props.itemSizes, _props_dense = props.dense, dense = _props_dense === void 0 ? false : _props_dense, domProps = (0, _objectWithoutProperties._)(props, [
        "render",
        "orientation",
        "loop",
        "cols",
        "disabledIndices",
        "activeIndex",
        "onNavigate",
        "itemSizes",
        "dense"
    ]);
    var _React_useState = (0, _slicedToArray._)(_react.useState(0), 2), internalActiveIndex = _React_useState[0], internalSetActiveIndex = _React_useState[1];
    var activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    var onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    var elementsRef = _react.useRef([]);
    var renderElementProps = render && typeof render !== "function" ? render.props : {};
    var contextValue = _react.useMemo(function() {
        return {
            activeIndex: activeIndex,
            onNavigate: onNavigate
        };
    }, [
        activeIndex,
        onNavigate
    ]);
    var isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!allKeys.includes(event.key)) return;
        var nextIndex = activeIndex;
        var minIndex = getMinIndex(elementsRef, disabledIndices);
        var maxIndex = getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            var sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, function() {
                return {
                    width: 1,
                    height: 1
                };
            });
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            var cellMap = buildCellMap(sizes, cols, dense);
            var minGridIndex = cellMap.findIndex(function(index) {
                return index != null && !isDisabled(elementsRef.current, index, disabledIndices);
            });
            // last enabled index
            var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                return index != null && !isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex;
            }, -1);
            var maybeNextIndex = cellMap[getGridNavigatedIndex({
                current: cellMap.map(function(itemIndex) {
                    return itemIndex ? elementsRef.current[itemIndex] : null;
                })
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: getCellIndices((0, _toConsumableArray._)(disabledIndices || elementsRef.current.map(function(_, index) {
                    return isDisabled(elementsRef.current, index) ? index : undefined;
                })).concat([
                    undefined
                ]), cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === ARROW_DOWN ? "bl" : event.key === ARROW_RIGHT ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        var toEndKeys = {
            horizontal: [
                ARROW_RIGHT
            ],
            vertical: [
                ARROW_DOWN
            ],
            both: [
                ARROW_RIGHT,
                ARROW_DOWN
            ]
        }[orientation];
        var toStartKeys = {
            horizontal: [
                ARROW_LEFT
            ],
            vertical: [
                ARROW_UP
            ],
            both: [
                ARROW_LEFT,
                ARROW_UP
            ]
        }[orientation];
        var preventedKeys = isGrid ? allKeys : ({
            horizontal: horizontalKeys,
            vertical: verticalKeys,
            both: allKeys
        })[orientation];
        if (nextIndex === activeIndex && (0, _toConsumableArray._)(toEndKeys).concat((0, _toConsumableArray._)(toStartKeys)).includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(function() {
                enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    var computedProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, domProps, renderElementProps), {
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown: function(e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    });
    return /*#__PURE__*/ _react.createElement(CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ _react.createElement(FloatingList, {
        elementsRef: elementsRef
    }, renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ var CompositeItem = /*#__PURE__*/ _react.forwardRef(function CompositeItem(props, forwardedRef) {
    var render = props.render, domProps = (0, _objectWithoutProperties._)(props, [
        "render"
    ]);
    var renderElementProps = render && typeof render !== "function" ? render.props : {};
    var _React_useContext = _react.useContext(CompositeContext), activeIndex = _React_useContext.activeIndex, onNavigate = _React_useContext.onNavigate;
    var _useListItem = useListItem(), ref = _useListItem.ref, index = _useListItem.index;
    var mergedRef = useMergeRefs([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    var isActive = activeIndex === index;
    var computedProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, domProps, renderElementProps), {
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus: function(e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    });
    return renderJsx(render, computedProps);
});
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var serverHandoffComplete = false;
var count = 0;
var genId = function() {
    return(// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++);
};
function useFloatingId() {
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return serverHandoffComplete ? genId() : undefined;
    }), 2), id = _React_useState[0], setId = _React_useState[1];
    index(function() {
        if (id == null) setId(genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    _react.useEffect(function() {
        serverHandoffComplete = true;
    }, []);
    return id;
}
var useReactId = SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ var useId = useReactId || useFloatingId;
var devMessageSet;
function warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    var message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    var message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ var FloatingArrow = /*#__PURE__*/ _react.forwardRef(function FloatingArrow(props, ref) {
    var _props_context = props.context, placement = _props_context.placement, floating = _props_context.elements.floating, _props_context_middlewareData = _props_context.middlewareData, arrow = _props_context_middlewareData.arrow, shift = _props_context_middlewareData.shift, _props_width = props.width, width = _props_width === void 0 ? 14 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 7 : _props_height, _props_tipRadius = props.tipRadius, tipRadius = _props_tipRadius === void 0 ? 0 : _props_tipRadius, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 0 : _props_strokeWidth, staticOffset = props.staticOffset, stroke = props.stroke, d = props.d, tmp = props.style, transform = (tmp === void 0 ? {} : tmp).transform, restStyle = (0, _objectWithoutProperties._)(props.style, [
        "transform"
    ]), rest = (0, _objectWithoutProperties._)(props, [
        "context",
        "width",
        "height",
        "tipRadius",
        "strokeWidth",
        "staticOffset",
        "stroke",
        "d",
        "style"
    ]);
    var clipPathId = useId();
    var _React_useState = (0, _slicedToArray._)(_react.useState(false), 2), isRTL = _React_useState[0], setIsRTL = _React_useState[1];
    // https://github.com/floating-ui/floating-ui/issues/2932
    index(function() {
        if (!floating) return;
        var isRTL = (0, _dom.getComputedStyle)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    var _placement_split = (0, _slicedToArray._)(placement.split("-"), 2), side = _placement_split[0], alignment = _placement_split[1];
    var isVerticalSide = side === "top" || side === "bottom";
    var computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    var computedStrokeWidth = strokeWidth * 2;
    var halfStrokeWidth = computedStrokeWidth / 2;
    var svgX = width / 2 * (tipRadius / -8 + 1);
    var svgY = height / 2 * tipRadius / 4;
    var isCustomShape = !!d;
    var yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    var xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    var arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    var arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    var dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    var rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    var _obj;
    return /*#__PURE__*/ _react.createElement("svg", _extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: (0, _objectSpread._)((_obj = {
            position: "absolute",
            pointerEvents: "none"
        }, (0, _defineProperty._)(_obj, xOffsetProp, arrowX), (0, _defineProperty._)(_obj, yOffsetProp, arrowY), (0, _defineProperty._)(_obj, side, isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)"), (0, _defineProperty._)(_obj, "transform", "" + rotation + (transform != null ? transform : "")), _obj), restStyle)
    }), computedStrokeWidth > 0 && /*#__PURE__*/ _react.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ _react.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ _react.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ _react.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function createPubSub() {
    var map = new Map();
    return {
        emit: function(event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach(function(handler) {
                return handler(data);
            });
        },
        on: function(event, listener) {
            map.set(event, (0, _toConsumableArray._)(map.get(event) || []).concat([
                listener
            ]));
        },
        off: function(event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(function(l) {
                return l !== listener;
            })) || []);
        }
    };
}
var FloatingNodeContext = /*#__PURE__*/ _react.createContext(null);
var FloatingTreeContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ var useFloatingParentNodeId = function() {
    var _React$useContext;
    return ((_React$useContext = _react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ var useFloatingTree = function() {
    return _react.useContext(FloatingTreeContext);
};
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function useFloatingNodeId(customParentId) {
    var id = useId();
    var tree = useFloatingTree();
    var reactParentId = useFloatingParentNodeId();
    var parentId = customParentId || reactParentId;
    index(function() {
        var node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return function() {
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function FloatingNode(props) {
    var children = props.children, id = props.id;
    var parentId = useFloatingParentNodeId();
    return /*#__PURE__*/ _react.createElement(FloatingNodeContext.Provider, {
        value: _react.useMemo(function() {
            return {
                id: id,
                parentId: parentId
            };
        }, [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function FloatingTree(props) {
    var children = props.children;
    var nodesRef = _react.useRef([]);
    var addNode = _react.useCallback(function(node) {
        nodesRef.current = (0, _toConsumableArray._)(nodesRef.current).concat([
            node
        ]);
    }, []);
    var removeNode = _react.useCallback(function(node) {
        nodesRef.current = nodesRef.current.filter(function(n) {
            return n !== node;
        });
    }, []);
    var events = _react.useState(function() {
        return createPubSub();
    })[0];
    return /*#__PURE__*/ _react.createElement(FloatingTreeContext.Provider, {
        value: _react.useMemo(function() {
            return {
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            };
        }, [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function createAttribute(name) {
    return "data-floating-ui-" + name;
}
function useLatestRef(value) {
    var ref = (0, _react.useRef)(value);
    index(function() {
        ref.current = value;
    });
    return ref;
}
var safePolygonIdentifier = /*#__PURE__*/ createAttribute("safe-polygon");
function getDelay(value, prop, pointerType) {
    if (pointerType && !(0, _utils.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function useHover(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, dataRef = context.dataRef, events = context.events, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_delay = props.delay, delay = _props_delay === void 0 ? 0 : _props_delay, _props_handleClose = props.handleClose, handleClose = _props_handleClose === void 0 ? null : _props_handleClose, _props_mouseOnly = props.mouseOnly, mouseOnly = _props_mouseOnly === void 0 ? false : _props_mouseOnly, _props_restMs = props.restMs, restMs = _props_restMs === void 0 ? 0 : _props_restMs, _props_move = props.move, move = _props_move === void 0 ? true : _props_move;
    var tree = useFloatingTree();
    var parentId = useFloatingParentNodeId();
    var handleCloseRef = useLatestRef(handleClose);
    var delayRef = useLatestRef(delay);
    var openRef = useLatestRef(open);
    var pointerTypeRef = _react.useRef();
    var timeoutRef = _react.useRef(-1);
    var handlerRef = _react.useRef();
    var restTimeoutRef = _react.useRef(-1);
    var blockMouseMoveRef = _react.useRef(true);
    var performedPointerEventsMutationRef = _react.useRef(false);
    var unbindMouseMoveRef = _react.useRef(function() {});
    var isHoverOpen = _react.useCallback(function() {
        var _dataRef$current$open;
        var type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    _react.useEffect(function() {
        var onOpenChange = function onOpenChange(_ref) {
            var open = _ref.open;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
            }
        };
        if (!enabled) return;
        events.on("openchange", onOpenChange);
        return function() {
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    _react.useEffect(function() {
        var onLeave = function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        };
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        var html = (0, _utils.getDocument)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return function() {
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    var closeWithDelay = _react.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        var closeDelay = getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(function() {
                return onOpenChange(false, event, reason);
            }, closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    var cleanupMouseMoveHandler = useEffectEvent(function() {
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    var clearPointerEvents = useEffectEvent(function() {
        if (performedPointerEventsMutationRef.current) {
            var body = (0, _utils.getDocument)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute(safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    _react.useEffect(function() {
        var isClickLikeOpenEvent = function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        };
        var onMouseEnter = function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, _utils.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !getDelay(delayRef.current, "open")) return;
            var openDelay = getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(function() {
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else onOpenChange(true, event, "hover");
        };
        var onMouseLeave = function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            var doc = (0, _utils.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current((0, _objectSpreadProps._)((0, _objectSpread._)({}, dataRef.current.floatingContext), {
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose: function() {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, "safe-polygon");
                    }
                }));
                var handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = function() {
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            var shouldClose = pointerTypeRef.current === "touch" ? !(0, _utils.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        };
        var onScrollMouseLeave = // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current((0, _objectSpreadProps._)((0, _objectSpread._)({}, dataRef.current.floatingContext), {
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose: function() {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            }))(event);
        };
        if (!enabled) return;
        if ((0, _dom.isElement)(elements.domReference)) {
            var _elements$floating;
            var ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return function() {
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    index(function() {
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            var floatingEl = elements.floating;
            if ((0, _dom.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                var body = (0, _utils.getDocument)(elements.floating).body;
                body.setAttribute(safePolygonIdentifier, "");
                var ref = elements.domReference;
                var parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(function(node) {
                    return node.id === parentId;
                })) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return function() {
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    index(function() {
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    _react.useEffect(function() {
        return function() {
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    var reference = _react.useMemo(function() {
        var setPointerRef = function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        };
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove: function(event) {
                var nativeEvent = event.nativeEvent;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, _utils.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    var floating = _react.useMemo(function() {
        return {
            onMouseEnter: function() {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave: function(event) {
                closeWithDelay(event.nativeEvent, false);
            }
        };
    }, [
        closeWithDelay
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
var NOOP = function() {};
var FloatingDelayGroupContext = /*#__PURE__*/ _react.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: NOOP,
    setState: NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ var useDelayGroupContext = function() {
    return _react.useContext(FloatingDelayGroupContext);
};
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function FloatingDelayGroup(props) {
    var children = props.children, delay = props.delay, _props_timeoutMs = props.timeoutMs, timeoutMs = _props_timeoutMs === void 0 ? 0 : _props_timeoutMs;
    var _React_useReducer = (0, _slicedToArray._)(_react.useReducer(function(prev, next) {
        return (0, _objectSpread._)({}, prev, next);
    }, {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    }), 2), state = _React_useReducer[0], setState = _React_useReducer[1];
    var initialCurrentIdRef = _react.useRef(null);
    var setCurrentId = _react.useCallback(function(currentId) {
        setState({
            currentId: currentId
        });
    }, []);
    index(function() {
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ _react.createElement(FloatingDelayGroupContext.Provider, {
        value: _react.useMemo(function() {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                setState: setState,
                setCurrentId: setCurrentId
            });
        }, [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function useDelayGroup(context, options) {
    if (options === void 0) options = {};
    var open = context.open, onOpenChange = context.onOpenChange, floatingId = context.floatingId;
    var optionId = options.id;
    var id = optionId != null ? optionId : floatingId;
    var groupContext = useDelayGroupContext();
    var currentId = groupContext.currentId, setCurrentId = groupContext.setCurrentId, initialDelay = groupContext.initialDelay, setState = groupContext.setState, timeoutMs = groupContext.timeoutMs;
    index(function() {
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    index(function() {
        var unset = function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        };
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                var timeout = window.setTimeout(unset, timeoutMs);
                return function() {
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    index(function() {
        if (setCurrentId === NOOP || !open) return;
        setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function getAncestors(nodes, id) {
    var _nodes$find;
    var allAncestors = [];
    var currentParentId = (_nodes$find = nodes.find(function(node) {
        return node.id === id;
    })) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        var currentNode = nodes.find(function(node) {
            return node.id === currentParentId;
        });
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function getChildren(nodes, id) {
    var allChildren = nodes.filter(function(node) {
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    var currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter(function(node) {
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(function(n) {
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function getDeepestNode(nodes, id) {
    var deepestNodeId;
    var maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        var children = getChildren(nodes, nodeId);
        children.forEach(function(child) {
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find(function(node) {
        return node.id === deepestNodeId;
    });
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
var counterMap = /*#__PURE__*/ new WeakMap();
var uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
var markerMap = {};
var lockCount = 0;
var supportsInert = function() {
    return typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
};
var unwrapHost = function(node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctElements = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter(function(x) {
        return x != null;
    });
};
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    var markerName = "data-floating-ui-inert";
    var controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    var avoidElements = correctElements(body, uncorrectedAvoidElements);
    var elementsToKeep = new Set();
    var elementsToStop = new Set(avoidElements);
    var hiddenElements = [];
    if (!markerMap[markerName]) markerMap[markerName] = new WeakMap();
    var markerCounter = markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, function(node) {
            if ((0, _dom.getNodeName)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    lockCount++;
    return function() {
        hiddenElements.forEach(function(element) {
            var counterValue = (counterMap.get(element) || 0) - 1;
            var markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        lockCount--;
        if (!lockCount) {
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledElementsSet = new WeakSet();
            markerMap = {};
        }
    };
}
function markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    var body = (0, _utils.getDocument)(avoidElements[0]).body;
    return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
var getTabbableOptions = function() {
    return {
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    };
};
function getTabbableIn(container, direction) {
    var allTabbable = (0, _tabbable.tabbable)(container, getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    var activeIndex = allTabbable.indexOf((0, _utils.activeElement)((0, _utils.getDocument)(container)));
    var nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function getNextTabbable() {
    return getTabbableIn(document.body, "next");
}
function getPreviousTabbable() {
    return getTabbableIn(document.body, "prev");
}
function isOutsideEvent(event, container) {
    var containerElement = container || event.currentTarget;
    var relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, _utils.contains)(containerElement, relatedTarget);
}
function disableFocusInside(container) {
    var tabbableElements = (0, _tabbable.tabbable)(container, getTabbableOptions());
    tabbableElements.forEach(function(element) {
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function enableFocusInside(container) {
    var elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach(function(element) {
        var tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
function getClosestTabbableElement(tabbableElements, element, floating) {
    var elementIndex = tabbableElements.indexOf(element);
    function traverseTabbableElements(next) {
        var attr = createAttribute("focus-guard");
        var index = elementIndex + (next ? 1 : 0);
        var currentElement = tabbableElements[index];
        while(currentElement && (!currentElement.isConnected || currentElement.hasAttribute(attr) || (0, _utils.contains)(floating, currentElement))){
            if (next) index++;
            else index--;
            currentElement = tabbableElements[index];
        }
        return currentElement;
    }
    // First, try to find the next tabbable element
    var next = traverseTabbableElements(true);
    if (next) return next;
    // If we can't find a next tabbable element, try to find the previous one
    return traverseTabbableElements(false);
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
var HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
var timeoutId;
function setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout(timeoutId);
    }
}
var FocusGuard = /*#__PURE__*/ _react.forwardRef(function FocusGuard(props, ref) {
    var _React_useState = (0, _slicedToArray._)(_react.useState(), 2), role = _React_useState[0], setRole = _React_useState[1];
    index(function() {
        if ((0, _utils.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", setActiveElementOnTab);
        return function() {
            document.removeEventListener("keydown", setActiveElementOnTab);
        };
    }, []);
    var _obj;
    var restProps = (_obj = {
        ref: ref,
        tabIndex: 0,
        // Role is only for VoiceOver
        role: role,
        "aria-hidden": role ? undefined : true
    }, (0, _defineProperty._)(_obj, createAttribute("focus-guard"), ""), (0, _defineProperty._)(_obj, "style", HIDDEN_STYLES), _obj);
    return /*#__PURE__*/ _react.createElement("span", _extends({}, props, restProps));
});
var PortalContext = /*#__PURE__*/ _react.createContext(null);
var attr = /*#__PURE__*/ createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function useFloatingPortalNode(props) {
    if (props === void 0) props = {};
    var id = props.id, root = props.root;
    var uniqueId = useId();
    var portalContext = usePortalContext();
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), portalNode = _React_useState[0], setPortalNode = _React_useState[1];
    var portalNodeRef = _react.useRef(null);
    index(function() {
        return function() {
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(function() {
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    index(function() {
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        var existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        var subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute(attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    index(function() {
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        var container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, _dom.isElement)(container)) container = container.current;
        container = container || document.body;
        var idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        var subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute(attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function FloatingPortal(props) {
    var children = props.children, id = props.id, _props_root = props.root, root = _props_root === void 0 ? null : _props_root, _props_preserveTabOrder = props.preserveTabOrder, preserveTabOrder = _props_preserveTabOrder === void 0 ? true : _props_preserveTabOrder;
    var portalNode = useFloatingPortalNode({
        id: id,
        root: root
    });
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), focusManagerState = _React_useState[0], setFocusManagerState = _React_useState[1];
    var beforeOutsideRef = _react.useRef(null);
    var afterOutsideRef = _react.useRef(null);
    var beforeInsideRef = _react.useRef(null);
    var afterInsideRef = _react.useRef(null);
    var modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    var open = focusManagerState == null ? void 0 : focusManagerState.open;
    var shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    _react.useEffect(function() {
        var onFocus = // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && isOutsideEvent(event)) {
                var focusing = event.type === "focusin";
                var manageFocus = focusing ? enableFocusInside : disableFocusInside;
                manageFocus(portalNode);
            }
        };
        if (!portalNode || !preserveTabOrder || modal) return;
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return function() {
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    _react.useEffect(function() {
        if (!portalNode) return;
        if (open) return;
        enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ _react.createElement(PortalContext.Provider, {
        value: _react.useMemo(function() {
            return {
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            };
        }, [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: function(event) {
            if (isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                var prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ _react.createElement("span", {
        "aria-owns": portalNode.id,
        style: HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ _reactDom.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: function(event) {
            if (isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                var nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
            }
        }
    }));
}
var usePortalContext = function() {
    return _react.useContext(PortalContext);
};
var FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
var LIST_LIMIT = 20;
var previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
    previouslyFocusedElements = previouslyFocusedElements.filter(function(el) {
        return el.isConnected;
    });
    var tabbableEl = element;
    if (!tabbableEl || (0, _dom.getNodeName)(tabbableEl) === "body") return;
    if (!(0, _tabbable.isTabbable)(tabbableEl, getTabbableOptions())) {
        var tabbableChild = (0, _tabbable.tabbable)(tabbableEl, getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    previouslyFocusedElements.push(tabbableEl);
    if (previouslyFocusedElements.length > LIST_LIMIT) previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
}
function getPreviouslyFocusedElement() {
    return previouslyFocusedElements.slice().reverse().find(function(el) {
        return el.isConnected;
    });
}
var VisuallyHiddenDismiss = /*#__PURE__*/ _react.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ _react.createElement("button", _extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function FloatingFocusManager(props) {
    var context = props.context, children = props.children, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_order = props.order, order = _props_order === void 0 ? [
        "content"
    ] : _props_order, tmp = props.guards, _guards = tmp === void 0 ? true : tmp, _props_initialFocus = props.initialFocus, initialFocus = _props_initialFocus === void 0 ? 0 : _props_initialFocus, _props_returnFocus = props.returnFocus, returnFocus = _props_returnFocus === void 0 ? true : _props_returnFocus, _props_restoreFocus = props.restoreFocus, restoreFocus = _props_restoreFocus === void 0 ? false : _props_restoreFocus, _props_modal = props.modal, modal = _props_modal === void 0 ? true : _props_modal, _props_visuallyHiddenDismiss = props.visuallyHiddenDismiss, visuallyHiddenDismiss = _props_visuallyHiddenDismiss === void 0 ? false : _props_visuallyHiddenDismiss, _props_closeOnFocusOut = props.closeOnFocusOut, closeOnFocusOut = _props_closeOnFocusOut === void 0 ? true : _props_closeOnFocusOut;
    var open = context.open, refs = context.refs, nodeId = context.nodeId, onOpenChange = context.onOpenChange, events = context.events, dataRef = context.dataRef, floatingId = context.floatingId, _context_elements = context.elements, domReference = _context_elements.domReference, floating = _context_elements.floating;
    var ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    var isUntrappedTypeableCombobox = (0, _utils.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    var guards = supportsInert() ? _guards : true;
    var orderRef = useLatestRef(order);
    var initialFocusRef = useLatestRef(initialFocus);
    var returnFocusRef = useLatestRef(returnFocus);
    var tree = useFloatingTree();
    var portalContext = usePortalContext();
    var startDismissButtonRef = _react.useRef(null);
    var endDismissButtonRef = _react.useRef(null);
    var preventReturnFocusRef = _react.useRef(false);
    var isPointerDownRef = _react.useRef(false);
    var tabbableIndexRef = _react.useRef(-1);
    var isInsidePortal = portalContext != null;
    var floatingFocusElement = getFloatingFocusElement(floating);
    var getTabbableContent = useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, _tabbable.tabbable)(container, getTabbableOptions()) : [];
    });
    var getTabbableElements = useEffectEvent(function(container) {
        var content = getTabbableContent(container);
        return orderRef.current.map(function(type) {
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    _react.useEffect(function() {
        preventReturnFocusRef.current = false;
    }, [
        disabled
    ]);
    _react.useEffect(function() {
        var onKeyDown = function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, _utils.contains)(floatingFocusElement, (0, _utils.activeElement)((0, _utils.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, _utils.stopEvent)(event);
                var els = getTabbableElements();
                var target = (0, _utils.getTarget)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, _utils.stopEvent)(event);
                    if (event.shiftKey) enqueueFocus(els[els.length - 1]);
                    else enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, _utils.stopEvent)(event);
                    enqueueFocus(els[0]);
                }
            }
        };
        if (disabled) return;
        if (!modal) return;
        var doc = (0, _utils.getDocument)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return function() {
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    _react.useEffect(function() {
        var handleFocusIn = function handleFocusIn(event) {
            var target = (0, _utils.getTarget)(event);
            var tabbableContent = getTabbableContent();
            var tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        };
        if (disabled) return;
        if (!floating) return;
        floating.addEventListener("focusin", handleFocusIn);
        return function() {
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    _react.useEffect(function() {
        var handlePointerDown = // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(function() {
                isPointerDownRef.current = false;
            });
        };
        var handleFocusOutside = function handleFocusOutside(event) {
            var relatedTarget = event.relatedTarget;
            queueMicrotask(function() {
                var movedToUnrelatedNode = !((0, _utils.contains)(domReference, relatedTarget) || (0, _utils.contains)(floating, relatedTarget) || (0, _utils.contains)(relatedTarget, floating) || (0, _utils.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute("focus-guard")) || tree && (getChildren(tree.nodesRef.current, nodeId).find(function(node) {
                    var _node$context, _node$context2;
                    return (0, _utils.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, _utils.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || getAncestors(tree.nodesRef.current, nodeId).find(function(node) {
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, _utils.activeElement)((0, _utils.getDocument)(floatingFocusElement)) === (0, _utils.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, _dom.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    var prevTabbableIndex = tabbableIndexRef.current;
                    var tabbableContent = getTabbableContent();
                    var nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, _dom.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        };
        if (disabled) return;
        if (!closeOnFocusOut) return;
        if (floating && (0, _dom.isHTMLElement)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return function() {
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    _react.useEffect(function() {
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        var portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute("portal") + "]")) || []);
        if (floating) {
            var insideElements = [
                floating
            ].concat((0, _toConsumableArray._)(portalNodes), [
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ]).filter(function(x) {
                return x != null;
            });
            var cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
            return function() {
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    index(function() {
        if (disabled || !(0, _dom.isHTMLElement)(floatingFocusElement)) return;
        var doc = (0, _utils.getDocument)(floatingFocusElement);
        var previouslyFocusedElement = (0, _utils.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(function() {
            var focusableElements = getTabbableElements(floatingFocusElement);
            var initialFocusValue = initialFocusRef.current;
            var elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            var focusAlreadyInsideFloatingEl = (0, _utils.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    index(function() {
        var onOpenChange = // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            var open = _ref.open, reason = _ref.reason, event = _ref.event, nested = _ref.nested;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, _utils.isVirtualClick)(event) || (0, _utils.isVirtualPointerEvent)(event));
        };
        if (disabled || !floatingFocusElement) return;
        var preventReturnFocusScroll = false;
        var doc = (0, _utils.getDocument)(floatingFocusElement);
        var previouslyFocusedElement = (0, _utils.activeElement)(doc);
        var contextData = dataRef.current;
        var openEvent = contextData.openEvent;
        var domReference = refs.domReference.current;
        addPreviouslyFocusedElement(previouslyFocusedElement);
        events.on("openchange", onOpenChange);
        return function() {
            events.off("openchange", onOpenChange);
            var activeEl = (0, _utils.activeElement)(doc);
            var isFocusInsideFloatingTree = (0, _utils.contains)(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(function(node) {
                var _node$context5;
                return (0, _utils.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            var shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) addPreviouslyFocusedElement(refs.domReference.current);
            var returnContextElement = domReference || previouslyFocusedElement;
            var tabbableElements = (0, _tabbable.tabbable)((0, _utils.getDocument)(returnContextElement).body, getTabbableOptions());
            // Wait for the return element to get potentially disconnected before
            // checking.
            queueMicrotask(function() {
                var returnElement = getPreviouslyFocusedElement();
                if (!returnElement && (0, _dom.isHTMLElement)(returnContextElement) && floating) returnElement = getClosestTabbableElement(tabbableElements, returnContextElement, floating);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, _dom.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    index(function() {
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return function() {
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    index(function() {
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        var handleMutation = function() {
            var tabIndex = floatingFocusElement.getAttribute("tabindex");
            var tabbableContent = getTabbableContent();
            var activeEl = (0, _utils.activeElement)((0, _utils.getDocument)(floating));
            var tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        var observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return function() {
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ _react.createElement(VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: function(event) {
                return onOpenChange(false, event.nativeEvent);
            }
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    var shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, shouldRenderGuards && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: function(event) {
            if (modal) {
                var els = getTabbableElements();
                enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if (isOutsideEvent(event, portalContext.portalNode)) {
                    var nextTabbable = getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: function(event) {
            if (modal) enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if (isOutsideEvent(event, portalContext.portalNode)) {
                    var prevTabbable = getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
var activeLocks = /*#__PURE__*/ new Set();
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ var FloatingOverlay = /*#__PURE__*/ _react.forwardRef(function FloatingOverlay(props, ref) {
    var _props_lockScroll = props.lockScroll, lockScroll = _props_lockScroll === void 0 ? false : _props_lockScroll, rest = (0, _objectWithoutProperties._)(props, [
        "lockScroll"
    ]);
    var lockId = useId();
    index(function() {
        if (!lockScroll) return;
        activeLocks.add(lockId);
        var isIOS = /iP(hone|ad|od)|iOS/.test((0, _utils.getPlatform)());
        var bodyStyle = document.body.style;
        // RTL <body> scrollbar
        var scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        var paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        var scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
        var scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
        bodyStyle.overflow = "hidden";
        if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
        // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (isIOS) {
            var _window$visualViewpor, _window$visualViewpor2;
            // iOS 12 does not support `visualViewport`.
            var offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
            var offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
            Object.assign(bodyStyle, {
                position: "fixed",
                top: -(scrollY - Math.floor(offsetTop)) + "px",
                left: -(scrollX - Math.floor(offsetLeft)) + "px",
                right: "0"
            });
        }
        return function() {
            activeLocks.delete(lockId);
            if (activeLocks.size === 0) {
                Object.assign(bodyStyle, (0, _defineProperty._)({
                    overflow: ""
                }, paddingProp, ""));
                if (isIOS) {
                    Object.assign(bodyStyle, {
                        position: "",
                        top: "",
                        left: "",
                        right: ""
                    });
                    window.scrollTo(scrollX, scrollY);
                }
            }
        };
    }, [
        lockId,
        lockScroll
    ]);
    return /*#__PURE__*/ _react.createElement("div", _extends({
        ref: ref
    }, rest, {
        style: (0, _objectSpread._)({
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, rest.style)
    }));
});
function isButtonTarget(event) {
    return (0, _dom.isHTMLElement)(event.target) && event.target.tagName === "BUTTON";
}
function isSpaceIgnored(element) {
    return (0, _utils.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function useClick(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, dataRef = context.dataRef, domReference = context.elements.domReference;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, tmp = props.event, eventOption = tmp === void 0 ? "click" : tmp, _props_toggle = props.toggle, toggle = _props_toggle === void 0 ? true : _props_toggle, _props_ignoreMouse = props.ignoreMouse, ignoreMouse = _props_ignoreMouse === void 0 ? false : _props_ignoreMouse, _props_keyboardHandlers = props.keyboardHandlers, keyboardHandlers = _props_keyboardHandlers === void 0 ? true : _props_keyboardHandlers;
    var pointerTypeRef = _react.useRef();
    var didKeyDownRef = _react.useRef(false);
    var reference = _react.useMemo(function() {
        return {
            onPointerDown: function(event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown: function(event) {
                var pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, _utils.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick: function(event) {
                var pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, _utils.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown: function(event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) return;
                if (event.key === " " && !isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp: function(event) {
                if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        };
    }, [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
function createVirtualElement(domElement, data) {
    var offsetX = null;
    var offsetY = null;
    var isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect: function() {
            var _data$dataRef$current;
            var domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            var isXAxis = data.axis === "x" || data.axis === "both";
            var isYAxis = data.axis === "y" || data.axis === "both";
            var canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            var width = domRect.width;
            var height = domRect.height;
            var x = domRect.x;
            var y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function useClientPoint(context, props) {
    if (props === void 0) props = {};
    var open = context.open, dataRef = context.dataRef, _context_elements = context.elements, floating = _context_elements.floating, domReference = _context_elements.domReference, refs = context.refs;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_axis = props.axis, axis = _props_axis === void 0 ? "both" : _props_axis, _props_x = props.x, x = _props_x === void 0 ? null : _props_x, _props_y = props.y, y = _props_y === void 0 ? null : _props_y;
    var initialRef = _react.useRef(false);
    var cleanupListenerRef = _react.useRef(null);
    var _React_useState = (0, _slicedToArray._)(_react.useState(), 2), pointerType = _React_useState[0], setPointerType = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState([]), 2), reactive = _React_useState1[0], setReactive = _React_useState1[1];
    var setReference = useEffectEvent(function(x, y) {
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference(createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    var handleReferenceEnterOrMove = useEffectEvent(function(event) {
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    var openCheck = (0, _utils.isMouseLikePointerType)(pointerType) ? floating : open;
    var addListener = _react.useCallback(function() {
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        var win = (0, _dom.getWindow)(floating);
        function handleMouseMove(event) {
            var target = (0, _utils.getTarget)(event);
            if (!(0, _utils.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            var cleanup = function() {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    _react.useEffect(function() {
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    _react.useEffect(function() {
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    _react.useEffect(function() {
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    index(function() {
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    var reference = _react.useMemo(function() {
        var setPointerTypeRef = function setPointerTypeRef(_ref) {
            var pointerType = _ref.pointerType;
            setPointerType(pointerType);
        };
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
var bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
var captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
var normalizeProp = function(normalizable) {
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function useDismiss(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, elements = context.elements, dataRef = context.dataRef;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_escapeKey = props.escapeKey, escapeKey = _props_escapeKey === void 0 ? true : _props_escapeKey, tmp = props.outsidePress, unstable_outsidePress = tmp === void 0 ? true : tmp, _props_outsidePressEvent = props.outsidePressEvent, outsidePressEvent = _props_outsidePressEvent === void 0 ? "pointerdown" : _props_outsidePressEvent, _props_referencePress = props.referencePress, referencePress = _props_referencePress === void 0 ? false : _props_referencePress, _props_referencePressEvent = props.referencePressEvent, referencePressEvent = _props_referencePressEvent === void 0 ? "pointerdown" : _props_referencePressEvent, _props_ancestorScroll = props.ancestorScroll, ancestorScroll = _props_ancestorScroll === void 0 ? false : _props_ancestorScroll, bubbles = props.bubbles, capture = props.capture;
    var tree = useFloatingTree();
    var outsidePressFn = useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : function() {
        return false;
    });
    var outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    var insideReactTreeRef = _react.useRef(false);
    var endedOrStartedInsideRef = _react.useRef(false);
    var _normalizeProp = normalizeProp(bubbles), escapeKeyBubbles = _normalizeProp.escapeKey, outsidePressBubbles = _normalizeProp.outsidePress;
    var _normalizeProp1 = normalizeProp(capture), escapeKeyCapture = _normalizeProp1.escapeKey, outsidePressCapture = _normalizeProp1.outsidePress;
    var closeOnEscapeKeyDown = useEffectEvent(function(event) {
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        var nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        var children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                var shouldDismiss = true;
                children.forEach(function(child) {
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, _utils.isReactEvent)(event) ? event.nativeEvent : event, "escape-key");
    });
    var closeOnEscapeKeyDownCapture = useEffectEvent(function(event) {
        var _getTarget2;
        var callback = function() {
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, _utils.getTarget)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, _utils.getTarget)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    var closeOnPressOutside = useEffectEvent(function(event) {
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        var endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        var target = (0, _utils.getTarget)(event);
        var inertSelector = "[" + createAttribute("inert") + "]";
        var markers = (0, _utils.getDocument)(elements.floating).querySelectorAll(inertSelector);
        var targetRootAncestor = (0, _dom.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, _dom.isLastTraversableNode)(targetRootAncestor)){
            var nextParent = (0, _dom.getParentNode)(targetRootAncestor);
            if ((0, _dom.isLastTraversableNode)(nextParent) || !(0, _dom.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, _dom.isElement)(target) && !(0, _utils.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, _utils.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every(function(marker) {
            return !(0, _utils.contains)(targetRootAncestor, marker);
        })) return;
        // Check if the click occurred on the scrollbar
        if ((0, _dom.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            var canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            var canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            var xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                var isRTL = (0, _dom.getComputedStyle)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        var nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        var targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(function(node) {
            var _node$context;
            return (0, _utils.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, _utils.isEventTargetWithin)(event, elements.floating) || (0, _utils.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        var children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            var shouldDismiss = true;
            children.forEach(function(child) {
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    var closeOnPressOutsideCapture = useEffectEvent(function(event) {
        var _getTarget4;
        var callback = function() {
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, _utils.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, _utils.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    _react.useEffect(function() {
        var onScroll = function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        };
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        var doc = (0, _utils.getDocument)(elements.floating);
        escapeKey && doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        var ancestors = [];
        if (ancestorScroll) {
            if ((0, _dom.isElement)(elements.domReference)) ancestors = (0, _reactDom1.getOverflowAncestors)(elements.domReference);
            if ((0, _dom.isElement)(elements.floating)) ancestors = ancestors.concat((0, _reactDom1.getOverflowAncestors)(elements.floating));
            if (!(0, _dom.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, _reactDom1.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter(function(ancestor) {
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach(function(ancestor) {
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return function() {
            escapeKey && doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach(function(ancestor) {
                ancestor.removeEventListener("scroll", onScroll);
            });
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    _react.useEffect(function() {
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    var reference = _react.useMemo(function() {
        return (0, _defineProperty._)({
            onKeyDown: closeOnEscapeKeyDown
        }, bubbleHandlerKeys[referencePressEvent], function(event) {
            if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
        });
    }, [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    var floating = _react.useMemo(function() {
        return (0, _defineProperty._)({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: function() {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp: function() {
                endedOrStartedInsideRef.current = true;
            }
        }, captureHandlerKeys[outsidePressEvent], function() {
            insideReactTreeRef.current = true;
        });
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
function useFloatingRootContext(options) {
    var _options_open = options.open, open = _options_open === void 0 ? false : _options_open, onOpenChangeProp = options.onOpenChange, elementsProp = options.elements;
    var floatingId = useId();
    var dataRef = _react.useRef({});
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return createPubSub();
    }), 1), events = _React_useState[0];
    var nested = useFloatingParentNodeId() != null;
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(elementsProp.reference), 2), positionReference = _React_useState1[0], setPositionReference = _React_useState1[1];
    var onOpenChange = useEffectEvent(function(open, event, reason) {
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    var refs = _react.useMemo(function() {
        return {
            setPositionReference: setPositionReference
        };
    }, []);
    var elements = _react.useMemo(function() {
        return {
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        };
    }, [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return _react.useMemo(function() {
        return {
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        };
    }, [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    var nodeId = options.nodeId;
    var internalRootContext = useFloatingRootContext((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        elements: (0, _objectSpread._)({
            reference: null,
            floating: null
        }, options.elements)
    }));
    var rootContext = options.rootContext || internalRootContext;
    var computedElements = rootContext.elements;
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), _domReference = _React_useState[0], setDomReference = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(null), 2), positionReference = _React_useState1[0], _setPositionReference = _React_useState1[1];
    var optionDomReference = computedElements == null ? void 0 : computedElements.reference;
    var domReference = optionDomReference || _domReference;
    var domReferenceRef = _react.useRef(null);
    var tree = useFloatingTree();
    index(function() {
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    var position = (0, _reactDom1.useFloating)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        elements: (0, _objectSpread._)({}, computedElements, positionReference && {
            reference: positionReference
        })
    }));
    var setPositionReference = _react.useCallback(function(node) {
        var computedPositionReference = (0, _dom.isElement)(node) ? {
            getBoundingClientRect: function() {
                return node.getBoundingClientRect();
            },
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    var setReference = _react.useCallback(function(node) {
        if ((0, _dom.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, _dom.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, _dom.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    var refs = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position.refs), {
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        });
    }, [
        position.refs,
        setReference,
        setPositionReference
    ]);
    var elements = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position.elements), {
            domReference: domReference
        });
    }, [
        position.elements,
        domReference
    ]);
    var context = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position, rootContext), {
            refs: refs,
            elements: elements,
            nodeId: nodeId
        });
    }, [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    index(function() {
        rootContext.dataRef.current.floatingContext = context;
        var node = tree == null ? void 0 : tree.nodesRef.current.find(function(node) {
            return node.id === nodeId;
        });
        if (node) node.context = context;
    });
    return _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
            context: context,
            refs: refs,
            elements: elements
        });
    }, [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function useFocus(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, events = context.events, dataRef = context.dataRef, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_visibleOnly = props.visibleOnly, visibleOnly = _props_visibleOnly === void 0 ? true : _props_visibleOnly;
    var blockFocusRef = _react.useRef(false);
    var timeoutRef = _react.useRef();
    var keyboardModalityRef = _react.useRef(true);
    _react.useEffect(function() {
        var onBlur = // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, _dom.isHTMLElement)(elements.domReference) && elements.domReference === (0, _utils.activeElement)((0, _utils.getDocument)(elements.domReference))) blockFocusRef.current = true;
        };
        var onKeyDown = function onKeyDown() {
            keyboardModalityRef.current = true;
        };
        if (!enabled) return;
        var win = (0, _dom.getWindow)(elements.domReference);
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return function() {
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    _react.useEffect(function() {
        var onOpenChange = function onOpenChange(_ref) {
            var reason = _ref.reason;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        };
        if (!enabled) return;
        events.on("openchange", onOpenChange);
        return function() {
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    _react.useEffect(function() {
        return function() {
            clearTimeout(timeoutRef.current);
        };
    }, []);
    var reference = _react.useMemo(function() {
        return {
            onPointerDown: function(event) {
                if ((0, _utils.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave: function() {
                blockFocusRef.current = false;
            },
            onFocus: function(event) {
                if (blockFocusRef.current) return;
                var target = (0, _utils.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, _dom.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, _utils.isSafari)() && (0, _utils.isMac)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, _utils.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur: function(event) {
                blockFocusRef.current = false;
                var relatedTarget = event.relatedTarget;
                var nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                var movedToFocusGuard = (0, _dom.isElement)(relatedTarget) && relatedTarget.hasAttribute(createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(function() {
                    var _dataRef$current$floa;
                    var activeEl = (0, _utils.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, _utils.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, _utils.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        };
    }, [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
var ACTIVE_KEY = "active";
var SELECTED_KEY = "selected";
function mergeProps(userProps, propsList, elementKey) {
    var map = new Map();
    var isItem = elementKey === "item";
    var domUserProps = userProps;
    if (isItem && userProps) {
        var _ = userProps[ACTIVE_KEY], __ = userProps[SELECTED_KEY], validProps = (0, _objectWithoutProperties._)(userProps, [
            ACTIVE_KEY,
            SELECTED_KEY
        ].map((0, _toPropertyKey._)));
        domUserProps = validProps;
    }
    return (0, _objectSpread._)({}, elementKey === "floating" && (0, _defineProperty._)({
        tabIndex: -1
    }, FOCUSABLE_ATTRIBUTE, ""), domUserProps, propsList.map(function(value) {
        var propsOrGetProps = value ? value[elementKey] : null;
        if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
        return propsOrGetProps;
    }).concat(userProps).reduce(function(acc, props) {
        if (!props) return acc;
        Object.entries(props).forEach(function(_ref) {
            var _$_ref = (0, _slicedToArray._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            if (isItem && [
                ACTIVE_KEY,
                SELECTED_KEY
            ].includes(key)) return;
            if (key.indexOf("on") === 0) {
                if (!map.has(key)) map.set(key, []);
                if (typeof value === "function") {
                    var _map$get;
                    (_map$get = map.get(key)) == null || _map$get.push(value);
                    acc[key] = function() {
                        var _map$get2;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(function(fn) {
                            return fn.apply(void 0, (0, _toConsumableArray._)(args));
                        }).find(function(val) {
                            return val !== undefined;
                        });
                    };
                }
            } else acc[key] = value;
        });
        return acc;
    }, {}));
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function useInteractions(propsList) {
    if (propsList === void 0) propsList = [];
    var referenceDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.reference;
    });
    var floatingDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.floating;
    });
    var itemDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.item;
    });
    var getReferenceProps = _react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "reference");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    var getFloatingProps = _react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "floating");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    var getItemProps = _react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "item");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return _react.useMemo(function() {
        return {
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        };
    }, [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
var isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function isMainOrientationKey(key, orientation) {
    var vertical = key === ARROW_UP || key === ARROW_DOWN;
    var horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
    var vertical = key === ARROW_DOWN;
    var horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
    var vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    var horizontal = key === ARROW_DOWN;
    return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
    var vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
    var horizontal = key === ARROW_UP;
    return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function useListNavigation(context, props) {
    var open = context.open, onOpenChange = context.onOpenChange, elements = context.elements;
    var listRef = props.listRef, activeIndex = props.activeIndex, tmp = props.onNavigate, unstable_onNavigate = tmp === void 0 ? function() {} : tmp, _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_selectedIndex = props.selectedIndex, selectedIndex = _props_selectedIndex === void 0 ? null : _props_selectedIndex, _props_allowEscape = props.allowEscape, allowEscape = _props_allowEscape === void 0 ? false : _props_allowEscape, _props_loop = props.loop, loop = _props_loop === void 0 ? false : _props_loop, _props_nested = props.nested, nested = _props_nested === void 0 ? false : _props_nested, _props_rtl = props.rtl, rtl = _props_rtl === void 0 ? false : _props_rtl, _props_virtual = props.virtual, virtual = _props_virtual === void 0 ? false : _props_virtual, _props_focusItemOnOpen = props.focusItemOnOpen, focusItemOnOpen = _props_focusItemOnOpen === void 0 ? "auto" : _props_focusItemOnOpen, _props_focusItemOnHover = props.focusItemOnHover, focusItemOnHover = _props_focusItemOnHover === void 0 ? true : _props_focusItemOnHover, _props_openOnArrowKeyDown = props.openOnArrowKeyDown, openOnArrowKeyDown = _props_openOnArrowKeyDown === void 0 ? true : _props_openOnArrowKeyDown, disabledIndices = props.disabledIndices, _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? "vertical" : _props_orientation, _props_cols = props.cols, cols = _props_cols === void 0 ? 1 : _props_cols, _props_scrollItemIntoView = props.scrollItemIntoView, scrollItemIntoView = _props_scrollItemIntoView === void 0 ? true : _props_scrollItemIntoView, virtualItemRef = props.virtualItemRef, itemSizes = props.itemSizes, _props_dense = props.dense, dense = _props_dense === void 0 ? false : _props_dense;
    var floatingFocusElement = getFloatingFocusElement(elements.floating);
    var floatingFocusElementRef = useLatestRef(floatingFocusElement);
    var parentId = useFloatingParentNodeId();
    var tree = useFloatingTree();
    var onNavigate = useEffectEvent(unstable_onNavigate);
    var focusItemOnOpenRef = _react.useRef(focusItemOnOpen);
    var indexRef = _react.useRef(selectedIndex != null ? selectedIndex : -1);
    var keyRef = _react.useRef(null);
    var isPointerModalityRef = _react.useRef(true);
    var previousOnNavigateRef = _react.useRef(onNavigate);
    var previousMountedRef = _react.useRef(!!elements.floating);
    var previousOpenRef = _react.useRef(open);
    var forceSyncFocus = _react.useRef(false);
    var forceScrollIntoViewRef = _react.useRef(false);
    var disabledIndicesRef = useLatestRef(disabledIndices);
    var latestOpenRef = useLatestRef(open);
    var scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
    var selectedIndexRef = useLatestRef(selectedIndex);
    var _React_useState = (0, _slicedToArray._)(_react.useState(), 2), activeId = _React_useState[0], setActiveId = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(), 2), virtualId = _React_useState1[0], setVirtualId = _React_useState1[1];
    var focusItem = useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, _utils.isMac)() && (0, _utils.isSafari)() ? isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        var initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(function() {
            var waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            var scrollIntoViewOptions = scrollItemIntoViewRef.current;
            var shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    index(function() {
        document.createElement("div").focus({
            get preventScroll () {
                isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    index(function() {
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    index(function() {
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    var runs = 0;
                    var waitForListPopulated = function() {
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                var scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    index(function() {
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        var nodes = tree.nodesRef.current;
        var parent = (_nodes$find = nodes.find(function(node) {
            return node.id === parentId;
        })) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        var activeEl = (0, _utils.activeElement)((0, _utils.getDocument)(elements.floating));
        var treeContainsActiveEl = nodes.some(function(node) {
            return node.context && (0, _utils.contains)(node.context.elements.floating, activeEl);
        });
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    index(function() {
        var handleVirtualFocus = function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        };
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        tree.events.on("virtualfocus", handleVirtualFocus);
        return function() {
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    index(function() {
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    index(function() {
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    index(function() {
        previousOpenRef.current = open;
    }, [
        open
    ]);
    var hasActiveIndex = activeIndex != null;
    var item = _react.useMemo(function() {
        var syncCurrentTarget = function syncCurrentTarget(currentTarget) {
            if (!open) return;
            var index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        };
        var _$props = (0, _objectSpread._)({
            onFocus: function(_ref) {
                var currentTarget = _ref.currentTarget;
                syncCurrentTarget(currentTarget);
            },
            onClick: function(_ref2) {
                var currentTarget = _ref2.currentTarget;
                return currentTarget.focus({
                    preventScroll: true
                });
            }
        }, focusItemOnHover && {
            onMouseMove: function(_ref3) {
                var currentTarget = _ref3.currentTarget;
                syncCurrentTarget(currentTarget);
            },
            onPointerLeave: function(_ref4) {
                var pointerType = _ref4.pointerType;
                if (!isPointerModalityRef.current || pointerType === "touch") return;
                indexRef.current = -1;
                focusItem(listRef, indexRef);
                onNavigate(null);
                if (!virtual) enqueueFocus(floatingFocusElementRef.current, {
                    preventScroll: true
                });
            }
        });
        return _$props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    var commonOnKeyDown = useEffectEvent(function(event) {
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, _utils.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, _dom.isHTMLElement)(elements.domReference) && !virtual) elements.domReference.focus();
            return;
        }
        var currentIndex = indexRef.current;
        var minIndex = getMinIndex(listRef, disabledIndices);
        var maxIndex = getMaxIndex(listRef, disabledIndices);
        if (event.key === "Home") {
            (0, _utils.stopEvent)(event);
            indexRef.current = minIndex;
            onNavigate(indexRef.current);
        }
        if (event.key === "End") {
            (0, _utils.stopEvent)(event);
            indexRef.current = maxIndex;
            onNavigate(indexRef.current);
        }
        // Grid navigation.
        if (cols > 1) {
            var sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, function() {
                return {
                    width: 1,
                    height: 1
                };
            });
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            var cellMap = buildCellMap(sizes, cols, dense);
            var minGridIndex = cellMap.findIndex(function(index) {
                return index != null && !isDisabled(listRef.current, index, disabledIndices);
            });
            // last enabled index
            var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                return index != null && !isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex;
            }, -1);
            var index = cellMap[getGridNavigatedIndex({
                current: cellMap.map(function(itemIndex) {
                    return itemIndex != null ? listRef.current[itemIndex] : null;
                })
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: getCellIndices((0, _toConsumableArray._)(disabledIndices || listRef.current.map(function(_, index) {
                    return isDisabled(listRef.current, index) ? index : undefined;
                })).concat([
                    undefined
                ]), cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === ARROW_DOWN ? "bl" : event.key === ARROW_RIGHT ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === "both") return;
        }
        if (isMainOrientationKey(event.key, orientation)) {
            (0, _utils.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, _utils.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if (isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    var ariaActiveDescendantProp = _react.useMemo(function() {
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    var floating = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            "aria-orientation": orientation === "both" ? undefined : orientation
        }, !(0, _utils.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp), {
            onKeyDown: commonOnKeyDown,
            onPointerMove: function() {
                isPointerModalityRef.current = true;
            }
        });
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    var reference = _react.useMemo(function() {
        var checkVirtualMouse = function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, _utils.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        };
        var checkVirtualPointer = function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, _utils.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        };
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaActiveDescendantProp), {
            onKeyDown: function(event) {
                isPointerModalityRef.current = false;
                var isArrowKey = event.key.indexOf("Arrow") === 0;
                var isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
                var isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
                var isMainKey = isMainOrientationKey(event.key, orientation);
                var isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    var rootNode = tree == null ? void 0 : tree.nodesRef.current.find(function(node) {
                        return node.parentId == null;
                    });
                    var deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isArrowKey && deepestNode && virtualItemRef) {
                        var eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            var isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            var dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find(function(item) {
                                return (item == null ? void 0 : item.id) === activeId;
                            }) : null;
                            if (dispatchItem) {
                                (0, _utils.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if (isMainKey && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, _utils.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, _utils.stopEvent)(event);
                        if (open) {
                            indexRef.current = getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, _utils.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus: function() {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        });
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {};
    }, [
        enabled,
        reference,
        floating,
        item
    ]);
}
var componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function useRole(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    var open = context.open, floatingId = context.floatingId;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_role = props.role, role = _props_role === void 0 ? "dialog" : _props_role;
    var ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    var referenceId = useId();
    var parentId = useFloatingParentNodeId();
    var isNested = parentId != null;
    var reference = _react.useMemo(function() {
        if (ariaRole === "tooltip" || role === "label") return (0, _defineProperty._)({}, "aria-" + (role === "label" ? "labelledby" : "describedby"), open ? floatingId : undefined);
        return (0, _objectSpread._)({
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined
        }, ariaRole === "listbox" && {
            role: "combobox"
        }, ariaRole === "menu" && {
            id: referenceId
        }, ariaRole === "menu" && isNested && {
            role: "menuitem"
        }, role === "select" && {
            "aria-autocomplete": "none"
        }, role === "combobox" && {
            "aria-autocomplete": "list"
        });
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    var floating = _react.useMemo(function() {
        var floatingProps = (0, _objectSpread._)({
            id: floatingId
        }, ariaRole && {
            role: ariaRole
        });
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return (0, _objectSpread._)({}, floatingProps, ariaRole === "menu" && {
            "aria-labelledby": referenceId
        });
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    var item = _react.useCallback(function(_ref) {
        var active = _ref.active, selected = _ref.selected;
        var commonProps = (0, _objectSpread._)({
            role: "option"
        }, active && {
            id: floatingId + "-option"
        });
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    "aria-selected": active && selected
                });
            case "combobox":
                return (0, _objectSpread._)({}, commonProps, active && {
                    "aria-selected": true
                });
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {};
    }, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
var camelCaseToKebabCase = function(str) {
    return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function($, ofs) {
        return (ofs ? "-" : "") + $.toLowerCase();
    });
};
function execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
    var _React_useState = (0, _slicedToArray._)(_react.useState(open), 2), isMounted = _React_useState[0], setIsMounted = _React_useState[1];
    if (open && !isMounted) setIsMounted(true);
    _react.useEffect(function() {
        if (!open && isMounted) {
            var timeout = setTimeout(function() {
                return setIsMounted(false);
            }, durationMs);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function useTransitionStatus(context, props) {
    if (props === void 0) props = {};
    var open = context.open, floating = context.elements.floating;
    var _props_duration = props.duration, duration = _props_duration === void 0 ? 250 : _props_duration;
    var isNumberDuration = typeof duration === "number";
    var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    var _React_useState = (0, _slicedToArray._)(_react.useState("unmounted"), 2), status = _React_useState[0], setStatus = _React_useState[1];
    var isMounted = useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    index(function() {
        if (!floating) return;
        if (open) {
            setStatus("initial");
            var frame = requestAnimationFrame(function() {
                setStatus("open");
            });
            return function() {
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function useTransitionStyles(context, props) {
    if (props === void 0) props = {};
    var tmp = props.initial, unstable_initial = tmp === void 0 ? {
        opacity: 0
    } : tmp, unstable_open = props.open, unstable_close = props.close, unstable_common = props.common, _props_duration = props.duration, duration = _props_duration === void 0 ? 250 : _props_duration;
    var placement = context.placement;
    var side = placement.split("-")[0];
    var fnArgs = _react.useMemo(function() {
        return {
            side: side,
            placement: placement
        };
    }, [
        side,
        placement
    ]);
    var isNumberDuration = typeof duration === "number";
    var openDuration = (isNumberDuration ? duration : duration.open) || 0;
    var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return (0, _objectSpread._)({}, execWithArgsOrReturn(unstable_common, fnArgs), execWithArgsOrReturn(unstable_initial, fnArgs));
    }), 2), styles = _React_useState[0], setStyles = _React_useState[1];
    var _useTransitionStatus = useTransitionStatus(context, {
        duration: duration
    }), isMounted = _useTransitionStatus.isMounted, status = _useTransitionStatus.status;
    var initialRef = useLatestRef(unstable_initial);
    var openRef = useLatestRef(unstable_open);
    var closeRef = useLatestRef(unstable_close);
    var commonRef = useLatestRef(unstable_common);
    index(function() {
        var initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
        var closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
        var commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
        var openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce(function(acc, key) {
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles(function(styles) {
            return (0, _objectSpread._)({
                transitionProperty: styles.transitionProperty
            }, commonStyles, initialStyles);
        });
        if (status === "open") setStyles((0, _objectSpread._)({
            transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms"
        }, commonStyles, openStyles));
        if (status === "close") {
            var styles = closeStyles || initialStyles;
            setStyles((0, _objectSpread._)({
                transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms"
            }, commonStyles, styles));
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function useTypeahead(context, props) {
    var _ref;
    var open = context.open, dataRef = context.dataRef;
    var listRef = props.listRef, activeIndex = props.activeIndex, unstable_onMatch = props.onMatch, unstable_onTypingChange = props.onTypingChange, _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_findMatch = props.findMatch, findMatch = _props_findMatch === void 0 ? null : _props_findMatch, _props_resetMs = props.resetMs, resetMs = _props_resetMs === void 0 ? 750 : _props_resetMs, _props_ignoreKeys = props.ignoreKeys, ignoreKeys = _props_ignoreKeys === void 0 ? [] : _props_ignoreKeys, _props_selectedIndex = props.selectedIndex, selectedIndex = _props_selectedIndex === void 0 ? null : _props_selectedIndex;
    var timeoutIdRef = _react.useRef();
    var stringRef = _react.useRef("");
    var prevIndexRef = _react.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    var matchIndexRef = _react.useRef(null);
    var onMatch = useEffectEvent(unstable_onMatch);
    var onTypingChange = useEffectEvent(unstable_onTypingChange);
    var findMatchRef = useLatestRef(findMatch);
    var ignoreKeysRef = useLatestRef(ignoreKeys);
    index(function() {
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    index(function() {
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    var setTypingChange = useEffectEvent(function(value) {
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    var onKeyDown = useEffectEvent(function(event) {
        var getMatchingIndex = function getMatchingIndex(list, orderedList, string) {
            var str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(function(text) {
                return (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0;
            });
            return str ? list.indexOf(str) : -1;
        };
        var listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, _utils.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, _utils.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        var allowRapidSuccessionOfFirstLetter = listContent.every(function(text) {
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(function() {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        var prevIndex = prevIndexRef.current;
        var index = getMatchingIndex(listContent, (0, _toConsumableArray._)(listContent.slice((prevIndex || 0) + 1)).concat((0, _toConsumableArray._)(listContent.slice(0, (prevIndex || 0) + 1))), stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    var reference = _react.useMemo(function() {
        return {
            onKeyDown: onKeyDown
        };
    }, [
        onKeyDown
    ]);
    var floating = _react.useMemo(function() {
        return {
            onKeyDown: onKeyDown,
            onKeyUp: function(event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
function getArgsWithCustomFloatingHeight(state, height) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        rects: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.rects), {
            floating: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.rects.floating), {
                height: height
            })
        })
    });
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ var inner = function(props) {
    return {
        name: "inner",
        options: props,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var _evaluate, listRef, overflowRef, onFallbackChange, tmp, innerOffset, _evaluate_index, index, _evaluate_minItemsVisible, minItemsVisible, _evaluate_referenceOverflowThreshold, referenceOverflowThreshold, scrollRef, detectOverflowOptions, rects, floating, item, scrollEl, clientTop, floatingIsBordered, scrollElIsBordered, floatingIsScrollEl, nextArgs, _tmp, overflow, refOverflow, diffY, nextY, maxHeight;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _evaluate = (0, _utils1.evaluate)(props, state), listRef = _evaluate.listRef, overflowRef = _evaluate.overflowRef, onFallbackChange = _evaluate.onFallbackChange, tmp = _evaluate.offset, innerOffset = tmp === void 0 ? 0 : tmp, _evaluate_index = _evaluate.index, index = _evaluate_index === void 0 ? 0 : _evaluate_index, _evaluate_minItemsVisible = _evaluate.minItemsVisible, minItemsVisible = _evaluate_minItemsVisible === void 0 ? 4 : _evaluate_minItemsVisible, _evaluate_referenceOverflowThreshold = _evaluate.referenceOverflowThreshold, referenceOverflowThreshold = _evaluate_referenceOverflowThreshold === void 0 ? 0 : _evaluate_referenceOverflowThreshold, scrollRef = _evaluate.scrollRef, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "listRef",
                                "overflowRef",
                                "onFallbackChange",
                                "offset",
                                "index",
                                "minItemsVisible",
                                "referenceOverflowThreshold",
                                "scrollRef"
                            ]);
                            rects = state.rects, floating = state.elements.floating;
                            item = listRef.current[index];
                            scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
                            // Valid combinations:
                            // 1. Floating element is the scrollRef and has a border (default)
                            // 2. Floating element is not the scrollRef, floating element has a border
                            // 3. Floating element is not the scrollRef, scrollRef has a border
                            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
                            // allowed as VoiceOver doesn't work.
                            clientTop = floating.clientTop || scrollEl.clientTop;
                            floatingIsBordered = floating.clientTop !== 0;
                            scrollElIsBordered = scrollEl.clientTop !== 0;
                            floatingIsScrollEl = floating === scrollEl;
                            if (!item) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                {},
                                state
                            ];
                            return [
                                4,
                                (0, _reactDom1.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
                            ];
                        case 1:
                            nextArgs = (0, _objectSpread._).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            return [
                                4,
                                (0, _reactDom1.detectOverflow)(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            return [
                                4,
                                (0, _reactDom1.detectOverflow)(nextArgs, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 3:
                            refOverflow = _state.sent();
                            diffY = Math.max(0, overflow.top);
                            nextY = nextArgs.y + diffY;
                            maxHeight = Math.max(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - Math.max(0, overflow.bottom));
                            scrollEl.style.maxHeight = maxHeight + "px";
                            scrollEl.scrollTop = diffY;
                            // There is not enough space, fallback to standard anchored positioning
                            if (onFallbackChange) {
                                if (scrollEl.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) _reactDom.flushSync(function() {
                                    return onFallbackChange(true);
                                });
                                else _reactDom.flushSync(function() {
                                    return onFallbackChange(false);
                                });
                            }
                            if (!overflowRef) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                (0, _reactDom1.detectOverflow)(getArgsWithCustomFloatingHeight((0, _objectSpreadProps._)((0, _objectSpread._)({}, nextArgs), {
                                    y: nextY
                                }), scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions)
                            ];
                        case 4:
                            overflowRef.current = _state.sent();
                            _state.label = 5;
                        case 5:
                            return [
                                2,
                                {
                                    y: nextY
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function useInnerOffset(context, props) {
    var open = context.open, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, overflowRef = props.overflowRef, scrollRef = props.scrollRef, unstable_onChange = props.onChange;
    var onChange = useEffectEvent(unstable_onChange);
    var controlledScrollingRef = _react.useRef(false);
    var prevScrollTopRef = _react.useRef(null);
    var initialOverflowRef = _react.useRef(null);
    _react.useEffect(function() {
        var onWheel = function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            var dY = e.deltaY;
            var isAtTop = overflowRef.current.top >= -0.5;
            var isAtBottom = overflowRef.current.bottom >= -0.5;
            var remainingScroll = el.scrollHeight - el.clientHeight;
            var sign = dY < 0 ? -1 : 1;
            var method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                _reactDom.flushSync(function() {
                    onChange(function(d) {
                        return d + Math[method](dY, remainingScroll * sign);
                    });
                });
            } else if (/firefox/i.test((0, _utils.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        };
        if (!enabled) return;
        var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(function() {
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = (0, _objectSpread._)({}, overflowRef.current);
            });
            return function() {
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    var floating = _react.useMemo(function() {
        return {
            onKeyDown: function() {
                controlledScrollingRef.current = true;
            },
            onWheel: function() {
                controlledScrollingRef.current = false;
            },
            onPointerMove: function() {
                controlledScrollingRef.current = false;
            },
            onScroll: function() {
                var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    var scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) _reactDom.flushSync(function() {
                        return onChange(function(d) {
                            return d + scrollDiff;
                        });
                    });
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(function() {
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        };
    }, [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            floating: floating
        } : {};
    }, [
        enabled,
        floating
    ]);
}
function isPointInPolygon(point, polygon) {
    var _point = (0, _slicedToArray._)(point, 2), x = _point[0], y = _point[1];
    var isInside = false;
    var length = polygon.length;
    for(var i = 0, j = length - 1; i < length; j = i++){
        var _ref = (0, _slicedToArray._)(polygon[i] || [
            0,
            0
        ], 2), xi = _ref[0], yi = _ref[1];
        var _ref1 = (0, _slicedToArray._)(polygon[j] || [
            0,
            0
        ], 2), xj = _ref1[0], yj = _ref1[1];
        var intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function safePolygon(options) {
    if (options === void 0) options = {};
    var _options_buffer = options.buffer, buffer = _options_buffer === void 0 ? 0.5 : _options_buffer, _options_blockPointerEvents = options.blockPointerEvents, blockPointerEvents = _options_blockPointerEvents === void 0 ? false : _options_blockPointerEvents, _options_requireIntent = options.requireIntent, requireIntent = _options_requireIntent === void 0 ? true : _options_requireIntent;
    var timeoutId;
    var hasLanded = false;
    var lastX = null;
    var lastY = null;
    var lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        var currentTime = performance.now();
        var elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        var deltaX = x - lastX;
        var deltaY = y - lastY;
        var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        var speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    var fn = function(_ref) {
        var x = _ref.x, y = _ref.y, placement = _ref.placement, elements = _ref.elements, onClose = _ref.onClose, nodeId = _ref.nodeId, tree = _ref.tree;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            var clientX = event.clientX, clientY = event.clientY;
            var clientPoint = [
                clientX,
                clientY
            ];
            var target = (0, _utils.getTarget)(event);
            var isLeave = event.type === "mouseleave";
            var isOverFloatingEl = (0, _utils.contains)(elements.floating, target);
            var isOverReferenceEl = (0, _utils.contains)(elements.domReference, target);
            var refRect = elements.domReference.getBoundingClientRect();
            var rect = elements.floating.getBoundingClientRect();
            var side = placement.split("-")[0];
            var cursorLeaveFromRight = x > rect.right - rect.width / 2;
            var cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            var isOverReferenceRect = isInside(clientPoint, refRect);
            var isFloatingWider = rect.width > refRect.width;
            var isFloatingTaller = rect.height > refRect.height;
            var left = (isFloatingWider ? refRect : rect).left;
            var right = (isFloatingWider ? refRect : rect).right;
            var top = (isFloatingTaller ? refRect : rect).top;
            var bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, _dom.isElement)(event.relatedTarget) && (0, _utils.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && getChildren(tree.nodesRef.current, nodeId).some(function(_ref2) {
                var context = _ref2.context;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            var rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                var _$_ref3 = (0, _slicedToArray._)(_ref3, 2), x = _$_ref3[0], y = _$_ref3[1];
                switch(side){
                    case "top":
                        {
                            var cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            var cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            var commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo
                            ].concat((0, _toConsumableArray._)(commonPoints));
                        }
                    case "bottom":
                        {
                            var cursorPointOne1 = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            var cursorPointTwo1 = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            var commonPoints1 = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne1,
                                cursorPointTwo1
                            ].concat((0, _toConsumableArray._)(commonPoints1));
                        }
                    case "left":
                        {
                            var cursorPointOne2 = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var cursorPointTwo2 = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var commonPoints2 = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return (0, _toConsumableArray._)(commonPoints2).concat([
                                cursorPointOne2,
                                cursorPointTwo2
                            ]);
                        }
                    case "right":
                        {
                            var cursorPointOne3 = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var cursorPointTwo3 = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var commonPoints3 = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne3,
                                cursorPointTwo3
                            ].concat((0, _toConsumableArray._)(commonPoints3));
                        }
                }
            }
            if (isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                var cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                var cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

},{"@swc/helpers/_/_async_to_generator":"2CamX","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_object_without_properties":"2L3ov","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","@swc/helpers/_/_to_property_key":"8H1ts","@swc/helpers/_/_ts_generator":"7uYyU","react":"l5IPE","@floating-ui/react/utils":"7sCqH","@floating-ui/utils":"7BZLa","@floating-ui/utils/dom":"bZryT","tabbable":"gbeaN","react-dom":"lkfQ7","@floating-ui/react-dom":"etHv9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2L3ov":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties;
});
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"fhOjo","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fhOjo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties_loose;
});
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8H1ts":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_property_key;
});
var _toPrimitiveJs = require("./_to_primitive.js");
var _typeOfJs = require("./_type_of.js");
function _to_property_key(arg) {
    var key = (0, _toPrimitiveJs._)(arg, "string");
    return (0, _typeOfJs._)(key) === "symbol" ? key : String(key);
}

},{"./_to_primitive.js":"94xJk","./_type_of.js":"60jEQ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"94xJk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_primitive;
});
var _typeOfJs = require("./_type_of.js");
function _to_primitive(input, hint) {
    if ((0, _typeOfJs._)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeOfJs._)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

},{"./_type_of.js":"60jEQ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7sCqH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPEABLE_SELECTOR", function() {
    return TYPEABLE_SELECTOR;
});
parcelHelpers.export(exports, "activeElement", function() {
    return activeElement;
});
parcelHelpers.export(exports, "contains", function() {
    return contains;
});
parcelHelpers.export(exports, "getDocument", function() {
    return getDocument;
});
parcelHelpers.export(exports, "getPlatform", function() {
    return getPlatform;
});
parcelHelpers.export(exports, "getTarget", function() {
    return getTarget;
});
parcelHelpers.export(exports, "getUserAgent", function() {
    return getUserAgent;
});
parcelHelpers.export(exports, "isAndroid", function() {
    return isAndroid;
});
parcelHelpers.export(exports, "isEventTargetWithin", function() {
    return isEventTargetWithin;
});
parcelHelpers.export(exports, "isJSDOM", function() {
    return isJSDOM;
});
parcelHelpers.export(exports, "isMac", function() {
    return isMac;
});
parcelHelpers.export(exports, "isMouseLikePointerType", function() {
    return isMouseLikePointerType;
});
parcelHelpers.export(exports, "isReactEvent", function() {
    return isReactEvent;
});
parcelHelpers.export(exports, "isRootElement", function() {
    return isRootElement;
});
parcelHelpers.export(exports, "isSafari", function() {
    return isSafari;
});
parcelHelpers.export(exports, "isTypeableCombobox", function() {
    return isTypeableCombobox;
});
parcelHelpers.export(exports, "isTypeableElement", function() {
    return isTypeableElement;
});
parcelHelpers.export(exports, "isVirtualClick", function() {
    return isVirtualClick;
});
parcelHelpers.export(exports, "isVirtualPointerEvent", function() {
    return isVirtualPointerEvent;
});
parcelHelpers.export(exports, "stopEvent", function() {
    return stopEvent;
});
var _dom = require("@floating-ui/utils/dom");
function activeElement(doc) {
    var activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function contains(parent, child) {
    if (!parent || !child) return false;
    var rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, _dom.isShadowRoot)(rootNode)) {
        var next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function getPlatform() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function getUserAgent() {
    var uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map(function(_ref) {
        var brand = _ref.brand, version = _ref.version;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if (isAndroid() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
    if (isJSDOM()) return false;
    return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function isSafari() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function isAndroid() {
    var re = /android/i;
    return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
    return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
    return getUserAgent().includes("jsdom/");
}
function isMouseLikePointerType(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    var values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function isReactEvent(event) {
    return "nativeEvent" in event;
}
function isRootElement(element) {
    return element.matches("html,body");
}
function getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    var e = event;
    return e.target != null && node.contains(e.target);
}
function getTarget(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
var TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
    return (0, _dom.isHTMLElement)(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
function isTypeableCombobox(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && isTypeableElement(element);
}

},{"@floating-ui/utils/dom":"bZryT","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bZryT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", function() {
    return getComputedStyle;
});
parcelHelpers.export(exports, "getContainingBlock", function() {
    return getContainingBlock;
});
parcelHelpers.export(exports, "getDocumentElement", function() {
    return getDocumentElement;
});
parcelHelpers.export(exports, "getFrameElement", function() {
    return getFrameElement;
});
parcelHelpers.export(exports, "getNearestOverflowAncestor", function() {
    return getNearestOverflowAncestor;
});
parcelHelpers.export(exports, "getNodeName", function() {
    return getNodeName;
});
parcelHelpers.export(exports, "getNodeScroll", function() {
    return getNodeScroll;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return getOverflowAncestors;
});
parcelHelpers.export(exports, "getParentNode", function() {
    return getParentNode;
});
parcelHelpers.export(exports, "getWindow", function() {
    return getWindow;
});
parcelHelpers.export(exports, "isContainingBlock", function() {
    return isContainingBlock;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
parcelHelpers.export(exports, "isLastTraversableNode", function() {
    return isLastTraversableNode;
});
parcelHelpers.export(exports, "isNode", function() {
    return isNode;
});
parcelHelpers.export(exports, "isOverflowElement", function() {
    return isOverflowElement;
});
parcelHelpers.export(exports, "isShadowRoot", function() {
    return isShadowRoot;
});
parcelHelpers.export(exports, "isTableElement", function() {
    return isTableElement;
});
parcelHelpers.export(exports, "isTopLayer", function() {
    return isTopLayer;
});
parcelHelpers.export(exports, "isWebKit", function() {
    return isWebKit;
});
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY, display = _getComputedStyle.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes(getNodeName(element));
}
function isTopLayer(element) {
    return [
        ":popover-open",
        ":modal"
    ].some(function(selector) {
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function isContainingBlock(elementOrCss) {
    var webkit = isWebKit();
    var css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some(function(value) {
        return (css.willChange || "").includes(value);
    }) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some(function(value) {
        return (css.contain || "").includes(value);
    });
}
function getContainingBlock(element) {
    var currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    var parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = getNearestOverflowAncestor(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = getWindow(scrollableAncestor);
    if (isBody) {
        var frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7BZLa":[function(require,module,exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", function() {
    return alignments;
});
parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
parcelHelpers.export(exports, "createCoords", function() {
    return createCoords;
});
parcelHelpers.export(exports, "evaluate", function() {
    return evaluate;
});
parcelHelpers.export(exports, "expandPaddingObject", function() {
    return expandPaddingObject;
});
parcelHelpers.export(exports, "floor", function() {
    return floor;
});
parcelHelpers.export(exports, "getAlignment", function() {
    return getAlignment;
});
parcelHelpers.export(exports, "getAlignmentAxis", function() {
    return getAlignmentAxis;
});
parcelHelpers.export(exports, "getAlignmentSides", function() {
    return getAlignmentSides;
});
parcelHelpers.export(exports, "getAxisLength", function() {
    return getAxisLength;
});
parcelHelpers.export(exports, "getExpandedPlacements", function() {
    return getExpandedPlacements;
});
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", function() {
    return getOppositeAlignmentPlacement;
});
parcelHelpers.export(exports, "getOppositeAxis", function() {
    return getOppositeAxis;
});
parcelHelpers.export(exports, "getOppositeAxisPlacements", function() {
    return getOppositeAxisPlacements;
});
parcelHelpers.export(exports, "getOppositePlacement", function() {
    return getOppositePlacement;
});
parcelHelpers.export(exports, "getPaddingObject", function() {
    return getPaddingObject;
});
parcelHelpers.export(exports, "getSide", function() {
    return getSide;
});
parcelHelpers.export(exports, "getSideAxis", function() {
    return getSideAxis;
});
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "rectToClientRect", function() {
    return rectToClientRect;
});
parcelHelpers.export(exports, "round", function() {
    return round;
});
parcelHelpers.export(exports, "sides", function() {
    return sides;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var sides = [
    "top",
    "right",
    "bottom",
    "left"
];
var alignments = [
    "start",
    "end"
];
var placements = /*#__PURE__*/ sides.reduce(function(acc, side) {
    return acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]);
}, []);
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = function(v) {
    return {
        x: v,
        y: v
    };
};
var oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
var oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = getAlignment(placement);
    var alignmentAxis = getAlignmentAxis(placement);
    var length = getAxisLength(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    var oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, function(alignment) {
        return oppositeAlignmentMap[alignment];
    });
}
function getSideList(side, isStart, rtl) {
    var lr = [
        "left",
        "right"
    ];
    var rl = [
        "right",
        "left"
    ];
    var tb = [
        "top",
        "bottom"
    ];
    var bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    var alignment = getAlignment(placement);
    var list = getSideList(getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(side) {
        return oppositeSideMap[side];
    });
}
function expandPaddingObject(padding) {
    return (0, _objectSpread._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

},{"@swc/helpers/_/_object_spread":"95yNt","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gbeaN":[function(require,module,exports) {
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusable", function() {
    return focusable;
});
parcelHelpers.export(exports, "getTabIndex", function() {
    return getTabIndex;
});
parcelHelpers.export(exports, "isFocusable", function() {
    return isFocusable;
});
parcelHelpers.export(exports, "isTabbable", function() {
    return isTabbable;
});
parcelHelpers.export(exports, "tabbable", function() {
    return tabbable;
});
var candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var candidateSelector = /* #__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if (isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var getTabIndex = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) return 0;
    return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"etHv9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoUpdate", function() {
    return 0, _dom.autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return 0, _dom.computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _dom.detectOverflow;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _dom.getOverflowAncestors;
});
parcelHelpers.export(exports, "platform", function() {
    return 0, _dom.platform;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
parcelHelpers.export(exports, "useFloating", function() {
    return useFloating;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _dom = require("@floating-ui/dom");
var _react = require("react");
var _reactDom = require("react-dom");
var index = typeof document !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
    if (a === b) return true;
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b))) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    var length;
    var i;
    var keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function getDPR(element) {
    if (typeof window === "undefined") return 1;
    var win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    var dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    var ref = _react.useRef(value);
    index(function() {
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    var _options_placement = options.placement, placement = _options_placement === void 0 ? "bottom" : _options_placement, _options_strategy = options.strategy, strategy = _options_strategy === void 0 ? "absolute" : _options_strategy, _options_middleware = options.middleware, middleware = _options_middleware === void 0 ? [] : _options_middleware, platform = options.platform, tmp = options.elements, _ref = tmp === void 0 ? {} : tmp, externalReference = _ref.reference, externalFloating = _ref.floating, _options_transform = options.transform, transform = _options_transform === void 0 ? true : _options_transform, whileElementsMounted = options.whileElementsMounted, open = options.open;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    }), 2), data = _React_useState[0], setData = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(middleware), 2), latestMiddleware = _React_useState1[0], setLatestMiddleware = _React_useState1[1];
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    var _React_useState2 = (0, _slicedToArray._)(_react.useState(null), 2), _reference = _React_useState2[0], _setReference = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)(_react.useState(null), 2), _floating = _React_useState3[0], _setFloating = _React_useState3[1];
    var setReference = _react.useCallback(function(node) {
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    var setFloating = _react.useCallback(function(node) {
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    var referenceEl = externalReference || _reference;
    var floatingEl = externalFloating || _floating;
    var referenceRef = _react.useRef(null);
    var floatingRef = _react.useRef(null);
    var dataRef = _react.useRef(data);
    var hasWhileElementsMounted = whileElementsMounted != null;
    var whileElementsMountedRef = useLatestRef(whileElementsMounted);
    var platformRef = useLatestRef(platform);
    var update = _react.useCallback(function() {
        if (!referenceRef.current || !floatingRef.current) return;
        var config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, _dom.computePosition)(referenceRef.current, floatingRef.current, config).then(function(data) {
            var fullData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                isPositioned: true
            });
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                _reactDom.flushSync(function() {
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    index(function() {
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData(function(data) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                    isPositioned: false
                });
            });
        }
    }, [
        open
    ]);
    var isMountedRef = _react.useRef(false);
    index(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    index(function() {
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    var refs = _react.useMemo(function() {
        return {
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        };
    }, [
        setReference,
        setFloating
    ]);
    var elements = _react.useMemo(function() {
        return {
            reference: referenceEl,
            floating: floatingEl
        };
    }, [
        referenceEl,
        floatingEl
    ]);
    var floatingStyles = _react.useMemo(function() {
        var initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        var x = roundByDPR(elements.floating, data.x);
        var y = roundByDPR(elements.floating, data.y);
        if (transform) return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, initialStyles), {
            transform: "translate(" + x + "px, " + y + "px)"
        }), getDPR(elements.floating) >= 1.5 && {
            willChange: "transform"
        });
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        });
    }, [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow$1 = function(options) {
    var isRef = function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    };
    return {
        name: "arrow",
        options: options,
        fn: function(state) {
            var _ref = typeof options === "function" ? options(state) : options, element = _ref.element, padding = _ref.padding;
            if (element && isRef(element)) {
                if (element.current != null) return (0, _dom.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, _dom.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.offset)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.shift)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.limitShift)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.flip)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.size)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.autoPlacement)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.hide)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.inline)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, arrow$1(options)), {
        options: [
            options,
            deps
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_type_of":"60jEQ","@floating-ui/dom":"9KCWF","react":"l5IPE","react-dom":"lkfQ7","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9KCWF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _dom.getOverflowAncestors;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "autoUpdate", function() {
    return autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "platform", function() {
    return platform;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    var css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = (0, _dom.isHTMLElement)(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    var domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    var y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    var win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = unwrapElement(element);
    var scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    var visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement) {
        var win = (0, _dom.getWindow)(domElement);
        var offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        var currentWin = win;
        var currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            var iframeScale = getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = (0, _dom.getComputedStyle)(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var elements = _ref.elements, rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isFixed = strategy === "fixed";
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = (0, _utils.createCoords)(1);
    var offsets = (0, _utils.createCoords)(0);
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            var offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + (0, _dom.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    var html = (0, _dom.getDocumentElement)(element);
    var scroll = (0, _dom.getNodeScroll)(element);
    var body = element.ownerDocument.body;
    var width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + getWindowScrollBarX(element);
    var y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === "rtl") x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getViewportRect(element, strategy) {
    var win = (0, _dom.getWindow)(element);
    var html = (0, _dom.getDocumentElement)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    var clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = getVisualOffsets(element);
        rect = (0, _objectSpreadProps._)((0, _objectSpread._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    var parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = (0, _dom.getOverflowAncestors)(element, [], false).filter(function(el) {
        return (0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== "body";
    });
    var currentContainingBlockComputedStyle = null;
    var elementIsFixed = (0, _dom.getComputedStyle)(element).position === "fixed";
    var currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        var computedStyle = (0, _dom.getComputedStyle)(currentNode);
        var currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        var shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === "clippingAncestors" ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, _toConsumableArray._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstClippingAncestor = clippingAncestors[0];
    var clippingRect = clippingAncestors.reduce(function(accRect, clippingAncestor) {
        var rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    var _getCssDimensions = getCssDimensions(element), width = _getCssDimensions.width, height = _getCssDimensions.height;
    return {
        width: width,
        height: height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var isFixed = strategy === "fixed";
    var rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
    }
    var x = rect.left + scroll.scrollLeft - offsets.x;
    var y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    var win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        var svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    var offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
var getElementRects = function() {
    var _ref = (0, _asyncToGenerator._)(function(data) {
        var getOffsetParentFn, getDimensionsFn, floatingDimensions, _tmp, _tmp1;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getOffsetParentFn = this.getOffsetParent || getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    return [
                        4,
                        getDimensionsFn(data.floating)
                    ];
                case 1:
                    floatingDimensions = _state.sent();
                    _tmp = {};
                    _tmp1 = [
                        data.reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(data.floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.reference = getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                            _state.sent(),
                            data.strategy
                        ])), _tmp.floating = {
                            x: 0,
                            y: 0,
                            width: floatingDimensions.width,
                            height: floatingDimensions.height
                        }, _tmp)
                    ];
            }
        });
    });
    return function getElementRects(data) {
        return _ref.apply(this, arguments);
    };
}();
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === "rtl";
}
var platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect: getClippingRect,
    getOffsetParent: getOffsetParent,
    getElementRects: getElementRects,
    getClientRects: getClientRects,
    getDimensions: getDimensions,
    getScale: getScale,
    isElement: (0, _dom.isElement),
    isRTL: isRTL
};
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    var io = null;
    var timeoutId;
    var root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var _element_getBoundingClientRect = element.getBoundingClientRect(), left = _element_getBoundingClientRect.left, top = _element_getBoundingClientRect.top, width = _element_getBoundingClientRect.width, height = _element_getBoundingClientRect.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = (0, _utils.floor)(top);
        var insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        var insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        var insetLeft = (0, _utils.floor)(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin: rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === "function" : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === "function" : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, _toConsumableArray._)(referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : []).concat((0, _toConsumableArray._)((0, _dom.getOverflowAncestors)(floating))) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    var cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, _slicedToArray._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        var _resizeObserver2;
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ var detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ var computePosition = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = (0, _objectSpread._)({
        platform: platform
    }, options);
    var platformWithCache = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, _core.computePosition)(reference, floating, (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

},{"@swc/helpers/_/_async_to_generator":"2CamX","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","@swc/helpers/_/_ts_generator":"7uYyU","@floating-ui/core":"hdGAa","@floating-ui/utils":"7BZLa","@floating-ui/utils/dom":"bZryT","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hdGAa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", function() {
    return 0, _utils.rectToClientRect;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = (0, _utils.getSideAxis)(placement);
    var alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    var alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    var side = (0, _utils.getSide)(placement);
    var isVertical = sideAxis === "y";
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var computePosition = function() {
    var _ref = (0, _asyncToGenerator._)(function(reference, floating, config) {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware_i, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? "bottom" : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? "absolute" : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    validMiddleware = middleware.filter(Boolean);
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    middlewareData = {};
                    resetCount = 0;
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < validMiddleware.length)) return [
                        3,
                        11
                    ];
                    _validMiddleware_i = validMiddleware[i], name = _validMiddleware_i.name, fn = _validMiddleware_i.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platform,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, middlewareData), (0, _defineProperty._)({}, name, (0, _objectSpread._)({}, middlewareData[name], data)));
                    if (!(reset && resetCount <= 50)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!(typeof reset === "object")) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    _state.label = 10;
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    });
    return function computePosition(reference, floating, config) {
        return _ref.apply(this, arguments);
    };
}();
function detectOverflow(state, options) {
    return _detectOverflow.apply(this, arguments);
}
function _detectOverflow() {
    _detectOverflow = /**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ (0, _asyncToGenerator._)(function(state, options) {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = (0, _utils.evaluate)(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? "clippingAncestors" : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? "viewport" : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? "floating" : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = (0, _utils.getPaddingObject)(padding);
                    altContext = elementContext === "floating" ? "reference" : "floating";
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === "floating" ? {
                        x: x,
                        y: y,
                        width: rects.floating.width,
                        height: rects.floating.height
                    } : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    if (!_state.sent()) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent() || {
                        x: 1,
                        y: 1
                    };
                    return [
                        3,
                        11
                    ];
                case 10:
                    _tmp3 = {
                        x: 1,
                        y: 1
                    };
                    _state.label = 11;
                case 11:
                    offsetScale = _tmp3;
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            elements: elements,
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 12:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        14
                    ];
                case 13:
                    _tmp4 = rect;
                    _state.label = 14;
                case 14:
                    elementClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    });
    return _detectOverflow.apply(this, arguments);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = function(options) {
    return {
        name: "arrow",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, rects, platform, elements, middlewareData, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, min$1, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            // Since `element` is required, we don't Partial<> the type.
                            _ref = (0, _utils.evaluate)(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = (0, _utils.getAlignmentAxis)(placement);
                            length = (0, _utils.getAxisLength)(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === "y";
                            minProp = isYAxis ? "top" : "left";
                            maxProp = isYAxis ? "bottom" : "right";
                            clientProp = isYAxis ? "clientHeight" : "clientWidth";
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            // If the padding is large enough that it causes the arrow to no longer be
                            // centered, modify the padding so that it is centered.
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
                            // Make sure the arrow doesn't overflow the floating element if the center
                            // point is outside the floating element's bounds.
                            min$1 = minPadding;
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = (0, _utils.clamp)(min$1, center, max);
                            // If the reference is small enough that the arrow's padding causes it to
                            // to point to nothing for an aligned placement, adjust the offset of the
                            // floating element itself. To ensure `shift()` continues to take action,
                            // a single reset is performed when this is true.
                            shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                            return [
                                2,
                                (_obj1 = {}, (0, _defineProperty._)(_obj1, axis, coords[axis] + alignmentOffset), (0, _defineProperty._)(_obj1, "data", (0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, axis, offset), (0, _defineProperty._)(_obj, "centerOffset", center - offset - alignmentOffset), _obj), shouldAddOffset && {
                                    alignmentOffset: alignmentOffset
                                })), (0, _defineProperty._)(_obj1, "reset", shouldAddOffset), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) === alignment;
    })).concat((0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return (0, _utils.getSide)(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements$1, overflow, currentIndex, currentPlacement, alignmentSides, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? (0, _utils.placements) : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements$1[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            alignmentSides = (0, _utils.getAlignmentSides).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements$1[0]
                                    }
                                }
                            ];
                            currentOverflows = [
                                overflow[(0, _utils.getSide)(currentPlacement)],
                                overflow[alignmentSides[0]],
                                overflow[alignmentSides[1]]
                            ];
                            allOverflows = (0, _toConsumableArray._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements$1[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = (0, _utils.getAlignment)(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, initialSideAxis, isBasePlacement, rtl, fallbackPlacements, hasFallbackAxisSideDirection, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$filter2, placement1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? "bestFit" : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? "none" : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            // If a reset by the arrow was caused due to an alignment offset being
                            // added, we should skip any logic now since `flip()` has already done its
                            // work.
                            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = (0, _utils.getSide)(placement);
                            initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
                            isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                (0, _utils.getOppositePlacement)(initialPlacement)
                            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
                            hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
                            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, _toConsumableArray._)((0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, _toConsumableArray._)(fallbackPlacements));
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0, _toConsumableArray._)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) // Try next placement and re-run the lifecycle.
                                return [
                                    2,
                                    {
                                        data: {
                                            index: nextIndex,
                                            overflows: overflowsData
                                        },
                                        reset: {
                                            placement: nextPlacement
                                        }
                                    }
                                ];
                                // First, find the candidates that fit on the mainAxis side of overflow,
                                // then find the placement that fits the best on the main crossAxis side.
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case "bestFit":
                                        {
                                            ;
                                            placement1 = (_overflowsData$filter2 = overflowsData.filter(function(d) {
                                                if (hasFallbackAxisSideDirection) {
                                                    var currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                                    // reading directions favoring greater width.
                                                    currentSideAxis === "y";
                                                }
                                                return true;
                                            }).map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$filter2[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case "initialPlacement":
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var rects, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? "referenceHidden" : _evaluate_strategy, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case "referenceHidden":
                                    return [
                                        3,
                                        1
                                    ];
                                case "escaped":
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function getBoundingRect(rects) {
    var minX = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return (0, _utils.rectToClientRect)(getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ((0, _utils.getSideAxis)(placement) === "y") {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = (0, _utils.getSide)(placement) === "top";
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            var width = right - left;
                            var height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        var isLeftSide = (0, _utils.getSide)(placement) === "left";
                        var maxRight = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        var left1 = minLeft;
                        var right1 = maxRight;
                        var width1 = right1 - left1;
                        var height1 = bottom1 - top1;
                        return {
                            top: top1,
                            bottom: bottom1,
                            left: left1,
                            right: right1,
                            width: width1,
                            height: height1,
                            x: left1,
                            y: top1
                        };
                    }
                    return fallback;
                }
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                            // ClientRect's bounds, despite the event listener being triggered. A
                            // padding of 2 seems to handle this issue.
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            clientRects = getRectsByLine(nativeClientRects);
                            fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect: getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy: strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function convertValueToCoords(state, options) {
    return _convertValueToCoords.apply(this, arguments);
}
function _convertValueToCoords() {
    _convertValueToCoords = // For type backwards-compatibility, the `OffsetOptions` type was also
    // Derivable.
    (0, _asyncToGenerator._)(function(state, options) {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = (0, _utils.getSide)(placement);
                    alignment = (0, _utils.getAlignment)(placement);
                    isVertical = (0, _utils.getSideAxis)(placement) === "y";
                    mainAxisMulti = [
                        "left",
                        "top"
                    ].includes(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = (0, _utils.evaluate)(options, state);
                    // eslint-disable-next-line prefer-const
                    _ref = typeof rawValue === "number" ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : (0, _objectSpread._)({
                        mainAxis: 0,
                        crossAxis: 0,
                        alignmentAxis: null
                    }, rawValue), mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    });
    return _convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
                            return [
                                4,
                                convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            // If the placement is the same and the arrow caused an alignment offset
                            // then we don't need to change the positioning coordinates.
                            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, diffCoords), {
                                        placement: placement
                                    })
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, min, max, minSide1, maxSide1, min1, max1, _obj, limitedCoords;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
                            mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            if (checkMainAxis) {
                                minSide = mainAxis === "y" ? "top" : "left";
                                maxSide = mainAxis === "y" ? "bottom" : "right";
                                min = mainAxisCoord + overflow[minSide];
                                max = mainAxisCoord - overflow[maxSide];
                                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
                            }
                            if (checkCrossAxis) {
                                minSide1 = crossAxis === "y" ? "top" : "left";
                                maxSide1 = crossAxis === "y" ? "bottom" : "right";
                                min1 = crossAxisCoord + overflow[minSide1];
                                max1 = crossAxisCoord - overflow[maxSide1];
                                crossAxisCoord = (0, _utils.clamp)(min1, crossAxisCoord, max1);
                            }
                            limitedCoords = limiter.fn((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), (_obj = {}, (0, _defineProperty._)(_obj, mainAxis, mainAxisCoord), (0, _defineProperty._)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function(state) {
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = (0, _utils.evaluate)(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var crossAxis = (0, _utils.getSideAxis)(placement);
            var mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = (0, _utils.evaluate)(offset, state);
            var computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, _objectSpread._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                var len = mainAxis === "y" ? "height" : "width";
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === "y" ? "width" : "height";
                var isOriginSide = [
                    "top",
                    "left"
                ].includes((0, _utils.getSide)(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return _obj = {}, (0, _defineProperty._)(_obj, mainAxis, mainAxisCoord), (0, _defineProperty._)(_obj, crossAxis, crossAxisCoord), _obj;
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = function size(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects_floating, width, height, heightSide, widthSide, maximumClippingHeight, maximumClippingWidth, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, xMin, xMax, yMin, yMax, nextDimensions;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = (0, _utils.getSide)(placement);
                            alignment = (0, _utils.getAlignment)(placement);
                            isYAxis = (0, _utils.getSideAxis)(placement) === "y";
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === "top" || side === "bottom")) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? "start" : "end") ? "left" : "right";
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === "end" ? "top" : "bottom";
                            _state.label = 4;
                        case 4:
                            maximumClippingHeight = height - overflow.top - overflow.bottom;
                            maximumClippingWidth = width - overflow.left - overflow.right;
                            overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
                            overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
                            noShift = !state.middlewareData.shift;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if (isYAxis) availableWidth = alignment || noShift ? (0, _utils.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
                            else availableHeight = alignment || noShift ? (0, _utils.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
                            if (noShift && !alignment) {
                                xMin = (0, _utils.max)(overflow.left, 0);
                                xMax = (0, _utils.max)(overflow.right, 0);
                                yMin = (0, _utils.max)(overflow.top, 0);
                                yMax = (0, _utils.max)(overflow.bottom, 0);
                                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
                            }
                            return [
                                4,
                                apply((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};

},{"@swc/helpers/_/_async_to_generator":"2CamX","@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_object_without_properties":"2L3ov","@swc/helpers/_/_to_consumable_array":"fRXIP","@swc/helpers/_/_ts_generator":"7uYyU","@floating-ui/utils":"7BZLa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7RJ0l":[function() {},{}],"4U9hY":[function() {},{}],"6sVW2":[function(require,module,exports) {
/**
 * RatingsMenu.jsx
 * Displays individual channels. Used on Videos page for individual video items.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _pleaseAddToAva = require("../Videos/PleaseAddToAva");
var RatingsMenu = function(param) {
    var _param_onChangeHandler = param.onChangeHandler, onChangeHandler = _param_onChangeHandler === void 0 ? function() {} : _param_onChangeHandler, _param_onSubmitHandler = param.onSubmitHandler, onSubmitHandler = _param_onSubmitHandler === void 0 ? function() {} : _param_onSubmitHandler, _param_actionURL = param.actionURL, actionURL = _param_actionURL === void 0 ? "api/ratings" : _param_actionURL, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_method = param.method, method = _param_method === void 0 ? "POST" : _param_method, _param_options = param.options, options = _param_options === void 0 ? [] : _param_options, _param_value = param.value, value = _param_value === void 0 ? null : _param_value, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var makeMenuItems = function() {
        var arrayOfItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var defaultSelect = [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: "",
                children: "Select Rating"
            }, "selectrating_rating-1")
        ];
        var menu = null;
        if (arrayOfItems.length) menu = arrayOfItems.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: index,
                children: item.label
            }, "selectrating_".concat(index.toString()));
        });
        menu = defaultSelect.concat(menu);
        return menu;
    };
    var cssClasses = (0, _classnamesDefault.default)(cssClass, {
        "video__form__ratings": true,
        "video__info__field": true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        action: actionURL,
        method: method,
        className: cssClasses,
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "video_rating",
                children: "Assign a rating to this video:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pleaseAddToAva.PleaseAddToAva), {
                hidden: !disabled
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "form__input_button_group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        name: "video_rating",
                        id: "video_rating",
                        onChange: onChangeHandler,
                        value: value,
                        disabled: disabled,
                        children: makeMenuItems(options)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        disabled: disabled,
                        className: "btn btn--action",
                        children: "Save"
                    })
                ]
            })
        ]
    });
};
RatingsMenu.propTypes = {
    actionURL: (0, _propTypesDefault.default).string,
    method: (0, _propTypesDefault.default).string,
    cssClass: (0, _propTypesDefault.default).string,
    options: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string,
        value: (0, _propTypesDefault.default).number
    })).isRequired,
    onChangeHandler: (0, _propTypesDefault.default).func.isRequired,
    onSubmitHandler: (0, _propTypesDefault.default).func.isRequired,
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
exports.default = RatingsMenu;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../Videos/PleaseAddToAva":"6CriY","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6CriY":[function(require,module,exports) {
/**
 * PleaseAddToAva.jsx
 * A no-framework meter input
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PleaseAddToAva", function() {
    return PleaseAddToAva;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../../js/Configuration");
var PleaseAddToAva = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "form__instructions",
        hidden: props.hidden,
        children: (0, _configuration.MESSAGE_ADD_TO_AVA)
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lPyZn":[function(require,module,exports) {
/**
 * CRTApprovalsMenu.js
 * Used on the VideosPage modal to set whether a video has been approved,
 * rejected, etc.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _pleaseAddToAva = require("../../Videos/PleaseAddToAva");
var CRTApprovalsMenu = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(CRTApprovalsMenu, _React_Component);
    var _super = (0, _createSuper._)(CRTApprovalsMenu);
    function CRTApprovalsMenu(props) {
        (0, _classCallCheck._)(this, CRTApprovalsMenu);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            options: []
        };
        _this.makeMenuItems = _this.makeMenuItems.bind((0, _assertThisInitialized._)(_this));
        return _this;
    }
    (0, _createClass._)(CRTApprovalsMenu, [
        {
            key: "makeMenuItems",
            value: function makeMenuItems() {
                var arrayOfItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var menu = null;
                if (arrayOfItems.length) menu = arrayOfItems.map(function(item) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                        value: item.value,
                        children: item.label
                    }, "selectrating_".concat(item.value.toString()));
                });
                return menu;
            }
        },
        {
            key: "render",
            value: function render() {
                var cssClasses = (0, _classnamesDefault.default)(this.props.cssClass, {
                    "video__info__crt": true,
                    "video__info__field": true
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    action: this.props.apiurl,
                    method: this.props.method,
                    className: cssClasses,
                    onChange: this.props.onChange,
                    onSubmit: this.props.onSubmit,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "review_status",
                            children: "Content Review Team:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pleaseAddToAva.PleaseAddToAva), {
                            hidden: !this.props.disabled
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "form__input_button_group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                    name: "review_status",
                                    id: "review_status",
                                    onChange: function() {},
                                    disabled: this.props.disabled,
                                    value: this.props.value,
                                    children: this.makeMenuItems(this.props.options)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "submit",
                                    disabled: this.props.disabled,
                                    className: "btn btn--action",
                                    children: "Save"
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return CRTApprovalsMenu;
}((0, _reactDefault.default).Component);
CRTApprovalsMenu.propTypes = {
    apiurl: (0, _propTypesDefault.default).string,
    onChange: (0, _propTypesDefault.default).func,
    onSubmit: (0, _propTypesDefault.default).func,
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
exports.default = CRTApprovalsMenu;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_create_super":"4WNpt","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../../Videos/PleaseAddToAva":"6CriY","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3Oaad":[function(require,module,exports) {
/**
 * MeowMenu.jsx
 * Used on the VideosPage modal to set whether a video's MEOW status
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _pleaseAddToAva = require("../../Videos/PleaseAddToAva");
var MeowMenu = function(param) {
    var _param_actionURL = param.actionURL, actionURL = _param_actionURL === void 0 ? "api/ratings" : _param_actionURL, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? null : _param_cssClass, _param_method = param.method, method = _param_method === void 0 ? "POST" : _param_method, _param_options = param.options, options = _param_options === void 0 ? [] : _param_options, disabled = param.disabled, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? null : _param_onChange, _param_onSubmit = param.onSubmit, onSubmit = _param_onSubmit === void 0 ? null : _param_onSubmit, _param_value = param.value, value = _param_value === void 0 ? null : _param_value;
    var makeMenuItems = function() {
        var arrayOfItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var defaultSelect = [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: "",
                children: "Select a MEOW Status"
            }, "selectrating_rating-1")
        ];
        var menu = null;
        if (arrayOfItems.length) menu = arrayOfItems.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: index,
                children: item
            }, "selectrating_".concat(index.toString()));
        });
        menu = defaultSelect.concat(menu);
        return menu;
    };
    var cssClasses = (0, _classnamesDefault.default)(cssClass, {
        "video__info__meow__select": true,
        "video__info__field": true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        action: actionURL,
        method: method,
        className: cssClasses,
        onChange: onChange,
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "video_rating",
                children: "MEOW Status:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pleaseAddToAva.PleaseAddToAva), {
                hidden: !disabled
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "form__input_button_group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        name: "meow_status",
                        id: "meow_status",
                        onChange: function() {},
                        value: value,
                        disabled: disabled,
                        children: makeMenuItems(options)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        disabled: disabled,
                        className: "btn btn--action",
                        children: "Save"
                    })
                ]
            })
        ]
    });
};
MeowMenu.propTypes = {
    actionURL: (0, _propTypesDefault.default).string,
    method: (0, _propTypesDefault.default).string,
    cssClass: (0, _propTypesDefault.default).string,
    options: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    onChange: (0, _propTypesDefault.default).func.isRequired,
    onSubmit: (0, _propTypesDefault.default).func.isRequired,
    value: (0, _propTypesDefault.default).string
};
exports.default = MeowMenu;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../../Videos/PleaseAddToAva":"6CriY","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gOZZg":[function(require,module,exports) {
/**
 * VideoNote.js
 * Add notes for a particular video.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VideoNote", function() {
    return VideoNote;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pleaseAddToAva = require("../../Videos/PleaseAddToAva");
var _videoNoteCss = require("./css/VideoNote.css");
var VideoNote = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "video__info__note video__info__field",
        onSubmit: props.onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: "video_note",
                    children: "Notes"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pleaseAddToAva.PleaseAddToAva), {
                hidden: !props.disabled
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                    id: "video_note",
                    name: "video_note",
                    disabled: props.disabled,
                    defaultValue: props.value,
                    className: "form-control",
                    rows: "5",
                    onChange: props.onChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    disabled: props.disabled,
                    className: "btn btn--action",
                    children: "Save Note"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../Videos/PleaseAddToAva":"6CriY","./css/VideoNote.css":"hUdGW","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hUdGW":[function() {},{}],"jWFU9":[function(require,module,exports) {
/**
 * BadgeMEOWCRT.js
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeMEOWCRT", function() {
    return BadgeMEOWCRT;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var _badgeMEOWCRTCss = require("./css/BadgeMEOWCRT.css");
var BadgeMEOWCRT = function(param) {
    var _param_mode = param.mode, mode = _param_mode === void 0 ? "meow" : _param_mode, _param_id = param.id, id = _param_id === void 0 ? false : _param_id, _param_label = param.label, label = _param_label === void 0 ? (0, _configuration.MESSAGE_NOT_SUBMITTED) : _param_label, _param_fullSize = param.fullSize, fullSize = _param_fullSize === void 0 ? false : _param_fullSize;
    var css = {
        "video__badge": true,
        "video__badge--large": fullSize
    };
    if (mode === "meow") css = (0, _classnamesDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, css), {
        "video__meow--okay": meowOK(id) === true,
        "video__meow--notok": meowOK(id) === false,
        "video__meow--escalate": meowOK(id) === "escalate" // Yellow badge
    }));
    else css = (0, _classnamesDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, css), {
        "video__crt--okay": crtOK(id),
        "video__crt--notok": crtOK(id) === false,
        "video__crt--escalate": crtOK(id) === "escalate"
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
        className: css,
        children: label
    });
};
var meowOK = function(id) {
    // Return this if it's not submitted.
    var okay = null;
    if ((0, _utilities.isNumeric)(id)) switch(id){
        case 0:
            okay = true;
            break;
        case 16:
            okay = "escalate";
            break;
        default:
            okay = false;
    }
    return okay;
};
var crtOK = function(id) {
    var approved = false;
    var crtId = +id;
    if (crtId === 0) approved = null;
    if (crtId === 1) approved = true;
    if (crtId >= 10) approved = "escalate";
    return approved;
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","./css/BadgeMEOWCRT.css":"j6SAE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j6SAE":[function() {},{}],"ktXP4":[function() {},{}],"5T0Rm":[function(require,module,exports) {
/**
 * AddVideosByURL.jsx
 * Displays playlist URL and comments form fields.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _closeButton = require("../subcomponents/CloseButton");
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _toggleSwitch = require("../subcomponents/ToggleSwitch");
var _toggleSwitchDefault = parcelHelpers.interopDefault(_toggleSwitch);
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var _addVideosByURLCss = require("./css/AddVideosByURL.css");
var AddVideosByURL = function(param) {
    var onChange = param.onChange, onClose = param.onClose, onSubmit = param.onSubmit, toggle = param.toggle, modalRef = param.modalRef, working = param.working, block = param.block, value = param.value, maxIds = param.maxIds, onPrependChange = param.onPrependChange, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass;
    var makeToggle = function() {
        var toggleSwitch = null;
        if (toggle) toggleSwitch = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
            onChange: onPrependChange,
            label: "Add to beginning?",
            className: "addvideos__toggle",
            options: toggle.options,
            name: "prepend",
            selectedIndex: +toggle.selected
        });
        return toggleSwitch;
    };
    var makeDialogBody = function() {
        var blockid = block && Object.hasOwn(block, "vsb_id") ? block.vsb_id : "";
        var setid = block && Object.hasOwn("block", "vsb_setID") ? block.vsb_setID : "";
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            id: "add_videos_by_url",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    method: "dialog",
                    id: "add_videos_by_url_form",
                    onSubmit: onSubmit,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                            cssClass: "add__by__url__loading",
                            open: working
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "setid",
                            id: "add_videos_by_url_videoset",
                            value: setid,
                            onChange: function() {}
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "blockid",
                            id: "add_videos_by_url_blockid",
                            value: blockid,
                            onChange: function() {}
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "userID",
                            id: "add_videos_by_url_userid",
                            value: (0, _utilities.getAuthData)("uid"),
                            onChange: function() {}
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "userUID",
                            id: "add_videos_by_url_uid",
                            value: (0, _utilities.getAuthData)("uuid"),
                            onChange: function() {}
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "userName",
                            id: "add_videos_by_url_username",
                            value: (0, _utilities.getAuthData)("user"),
                            onChange: function() {}
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "add_videos_by_url_urls",
                                    children: "Enter URLs"
                                }),
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "form__instructions",
                                    id: "add_videos_by_url_note",
                                    children: "(Maximum 50 URLs or YouTube identifiers.)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    autoFocus: true,
                                    className: "form-control",
                                    id: "add_videos_by_url_urls",
                                    "aria-describedby": "add_videos_by_url_note",
                                    name: "videoids",
                                    onChange: onChange,
                                    rows: "20",
                                    required: true,
                                    disabled: working,
                                    value: value
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "form__instructions aria__description",
                                    children: [
                                        "Use valid YouTube URLs or video IDs. URLs or IDs should be separated either by a comma (,) or new line. If using URLs, include the protocol for each, e.g.: ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                            children: "http://"
                                        }),
                                        " or ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                            children: "https://"
                                        }),
                                        ". Limit 50."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                hidden: !maxIds,
                                className: "form__instructions form__error",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: (0, _configuration.MESSAGE_ERROR_TOO_MANY_URLS)[0]
                                    }),
                                    " ",
                                    (0, _configuration.MESSAGE_ERROR_TOO_MANY_URLS)[1]
                                ]
                            })
                        }),
                        makeToggle(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            form: "add_videos_by_url_form",
                            disabled: maxIds,
                            className: "btn btn--action",
                            children: "Add Videos"
                        })
                    ]
                })
            ]
        });
    };
    var cssClasses = (0, _classnamesDefault.default)({
        "add__videos__by__url": true
    }, cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "AddVideoByURL",
        onClose: onClose,
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Add Videos By URL"
            }),
            makeDialogBody()
        ]
    });
};
exports.default = AddVideosByURL;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../subcomponents/CloseButton":"3MmmO","../subcomponents/ModalDialog":"72kji","../subcomponents/LoaderSimple":"1dSHa","../subcomponents/ToggleSwitch":"k29YD","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","./css/AddVideosByURL.css":"8lUhq","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8lUhq":[function() {},{}],"gvTXy":[function(require,module,exports) {
/**
 * CheckForUpdates.jsx
 * Check for updates button.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var CheckForUpdates = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
        type: "submit"
    }, props), {
        onClick: props.onClick,
        className: "btn btn--action btn-sm destinations__check_for_updates",
        children: "Check for Updates"
    }));
};
CheckForUpdates.propTypes = {
    onClick: (0, _propTypesDefault.default).func.isRequired
};
exports.default = CheckForUpdates;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9F7am":[function(require,module,exports) {
/**
 * CheckForUpdatesProgress.js
 * Modal called when there's a request to check for video updates.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _checkForUpdatesProgressCss = require("./css/CheckForUpdatesProgress.css");
var CheckForUpdatesProgress = function(props) {
    var loading = props.loading, onClose = props.onClose, updates = props.updates, videoset = props.videoset, modalRef = props.modalRef, onServerResponse = props.onServerResponse;
    var getUpdatesCSV = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        var vidIds = updates.map(function(vid) {
            return vid.YouTube_ID;
        }).join("|");
        fd.set("videoset_id", videoset);
        fd.set("ids", vidIds);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.csvrequest)((0, _configuration.API_DESTINATIONS_CHECKFORUPDATES_CSV), {
            body: fd
        }, function(response) {
            (0, _utilities.forceDownload)(response);
        });
    };
    var makeList = function() {
        if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        if (updates === null || updates === void 0 ? void 0 : updates.length) {
            var items = updates.map(function(item) {
                var url;
                if (!item.URL) url = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "text__center",
                    children: "\u2013"
                });
                else url = /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "text__nowrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: item.URL,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: item.URL
                    })
                });
                var deleted = item.deleted ? "Yes" : "";
                var title = item.Current_Title === item.Previous_Title ? "\u2013" : item.Current_Title;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        item.Previous_Title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: item.Previous_Title
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: "\u2013"
                        }),
                        item.Current_Title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: title
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: "\u2013"
                        }),
                        url,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: deleted
                        })
                    ]
                }, item.YouTube_ID);
            });
            var ids = updates.map(function(item) {
                return item.history_id;
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "destinations__checkupdated__results",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Results"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Previous Title"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Current Title"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Video URL"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Deleted from YouTube"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                children: items
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        action: (0, _configuration.API_DESTINATIONS_CHECKFORUPDATES_CSV),
                        method: "POST",
                        target: "_blank",
                        onSubmit: getUpdatesCSV,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                name: "videoset_id",
                                id: "videoset_id",
                                value: videoset,
                                onChange: function() {}
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                name: "ids",
                                id: "ids",
                                value: ids.join("|"),
                                onChange: function() {}
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "btn btn--action",
                                children: "Export updates as CSV"
                            })
                        ]
                    })
                ]
            });
        } else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "destinations__checkupdated__noupdates",
            children: "No updates"
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        onClose: onClose,
        className: "CheckForUpdatesProgress",
        id: "CheckForUpdatesProgress",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Checking for Title Updates"
            }),
            makeList()
        ]
    });
};
exports.default = CheckForUpdatesProgress;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/LoaderSimple":"1dSHa","../subcomponents/ModalDialog":"72kji","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","./css/CheckForUpdatesProgress.css":"cpgxa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cpgxa":[function() {},{}],"4ZmTu":[function(require,module,exports) {
/**
 * CheckForDuplicatesModal.js
 * Displays a list of available videos to add. 
 * Used in DestinationsPlaylist.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _checkForDuplicatesRemove = require("./CheckForDuplicatesRemove");
var _checkForDuplicatesExclude = require("./CheckForDuplicatesExclude");
var _actionMessageDisplay = require("../subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _destinationsPlaylistUtils = require("../../actions/DestinationsPlaylistUtils");
var _utilities = require("../../js/Utilities");
var _checkForDuplicatesModalCss = require("./css/CheckForDuplicatesModal.css");
var CheckForDuplicatesModal = function(param) {
    var _param_dupes = param.dupes, dupes = _param_dupes === void 0 ? [] : _param_dupes, inSet = param.inSet, message = param.message, modalRef = param.modalRef, mode = param.mode, loading = param.loading, onChange = param.onChange, onClose = param.onClose, onErrorClose = param.onErrorClose, onRemove = param.onRemove, onSubmit = param.onSubmit, playlist = param.playlist, response = param.response, working = param.working;
    /*
    Finds the indices of the original and the duplicate.
    returns an object in the form {youtubeid: [array,of,indices]}
  */ var findDupesIndices = function() {
        if (!dupes.length) return;
        var callback = function(item) {
            return (0, _destinationsPlaylistUtils.indicesOfDupes)(inSet, item);
        };
        return dupes.map(callback);
    };
    var makeBody = function() {
        var body = null;
        switch(mode){
            case "checking":
            case "checked":
                body = checkingModeDisplay();
                break;
            default:
                body = addingModeDisplay();
        }
        return body;
    };
    var sortByVideoName = function(a, b) {
        var c = a.name.toLowerCase();
        var d = b.name.toLowerCase();
        if (c < d) return -1;
        if (c > d) return 1;
        // names must be equal
        return 0;
    };
    var checkingModeDisplay = function() {
        var dupes = findDupesIndices() || [];
        var table = null;
        if (!dupes.length) table = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Check for Duplicates"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "No duplicates found."
                })
            ]
        });
        else {
            /* For each array of indices in each row return a row...*/ var rows = dupes.map(function(r) {
                return r.indexes.map(function(index) {
                    return inSet[index];
                });
            }).reduce(function(accumulator, value) {
                return accumulator.concat(value);
            }, []) // flattens the array
            .sort(sortByVideoName) // alphabetize
            .map(function(instance, index) {
                var ky = (0, _lodashUniqueidDefault.default)("".concat(instance.ytID, "__"));
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: instance.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: +instance.ordinal + 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForDuplicatesRemove.CheckForDuplicatesRemove), {
                                id: instance.ytID,
                                playlist: playlist,
                                order: instance.position,
                                onSubmit: onRemove
                            })
                        })
                    ]
                }, ky);
            });
            table = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Found duplicates"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
                        mode: response.itemsDeleted ? "success" : "failed",
                        message: response.itemsDeleted ? message : "Error: Something went wrong. Please tell an administrator.",
                        hidden: mode !== "checked",
                        onClose: onErrorClose
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                        open: working
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The following videos appear more than once in this play list. Please select which instance(s) you'd like to remove."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                        className: "CheckForDuplicatesModal__table__checking",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Video Name"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Order"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Remove"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                children: rows
                            })
                        ]
                    })
                ]
            });
        }
        return table;
    };
    var addingModeDisplay = function() {
        if (!dupes.length) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
            children: "No duplicates found."
        });
        var du = dupes.map((0, _utilities.extractYouTubeIdFromUrl)).map(function(d) {
            return inSet.find(function(i) {
                return i.ytID == d;
            });
        }).flat();
        // Filter undefined.
        var rows = du.filter(function(r) {
            return r;
        }).map(function(r) {
            var ky = (0, _lodashUniqueidDefault.default)("".concat(r.ytID, "__"));
            var formId = (0, _lodashUniqueidDefault.default)("".concat(r.ytID, "--"));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: formId,
                            children: r.name
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForDuplicatesExclude.CheckForDuplicatesExclude), {
                            onChange: onChange,
                            youtubeid: r.ytID,
                            id: formId,
                            name: "duplicates"
                        })
                    })
                ]
            }, ky);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Found duplicates"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "The following videos are already part of this list. Do you still want to add them?"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: "PostDupeCheck",
                    name: "PostDupeCheck",
                    value: "1",
                    type: "hidden"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    className: "CheckForDuplicatesModal__table__adding",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Video Name"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                        children: [
                                            "Yes",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "note",
                                                children: "(uncheck to exclude)"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            children: rows
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "button__group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn--action",
                            children: "Save"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn",
                            onClick: onClose,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        });
    };
    var body;
    if (loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Check for Duplicates"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                open: true
            })
        ]
    });
    else body = makeBody();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
        onClose: onClose,
        ref: modalRef,
        id: "CheckForDuplicatesModal",
        className: "check_dupes__modal",
        children: body
    });
};
exports.default = CheckForDuplicatesModal;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/LoaderSimple":"1dSHa","lodash.uniqueid":"6bf5k","./CheckForDuplicatesRemove":"eCYXW","./CheckForDuplicatesExclude":"iC0ZX","../subcomponents/ActionMessageDisplay":"bzcdY","../subcomponents/ModalDialog":"72kji","../../actions/DestinationsPlaylistUtils":"73dnb","../../js/Utilities":"euxcI","./css/CheckForDuplicatesModal.css":"jqAsa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eCYXW":[function(require,module,exports) {
/**
 * CheckForDuplicatesRemove.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckForDuplicatesRemove", function() {
    return CheckForDuplicatesRemove;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var CheckForDuplicatesRemove = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
        onSubmit: props.onSubmit,
        id: "CheckForDuplicatesRemove",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "hidden",
                    name: "video",
                    value: props.id,
                    onChange: function() {}
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "hidden",
                    name: "order",
                    value: props.order,
                    onChange: function() {}
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "hidden",
                    name: "playlist",
                    value: props.playlist,
                    onChange: function() {}
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    className: "btn btn--action",
                    children: "Remove this instance"
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iC0ZX":[function(require,module,exports) {
/**
 * CheckForDuplicatesExclude.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckForDuplicatesExclude", function() {
    return CheckForDuplicatesExclude;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var CheckForDuplicatesExclude = function(param) {
    var checked = param.checked, name = param.name, id = param.id, youtubeid = param.youtubeid, onChange = param.onChange;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        type: "checkbox",
        defaultChecked: !checked,
        name: name,
        id: id,
        value: youtubeid,
        onChange: onChange
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jqAsa":[function() {},{}],"6GKoY":[function(require,module,exports) {
/**
 * DeleteSetModal
 * Modal called when there's a request to check for video updates.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
// import './css/CheckForUpdatesProgress.css';
/* {
  "result": "success",
  "message": "Episode 13833 was updated",
  "series": null
} */ var DeleteSetModal = function(param) {
    var modalRef = param.modalRef, blockId = param.blockId, setId = param.setId, stationId = param.stationId, title = param.title;
    var onClose = function(domEvent) {
        var returnValue = domEvent.target.returnValue;
        returnValue = !!+returnValue; // Convert to boolean true/false.
        if (returnValue) {
            var fd = new FormData();
            fd.set("id", blockId);
            fd.set("series", -1);
            fd.set("token", (0, _utilities.getAuthData)("token"));
            var callback = function(response) {
                if (response.result === "success") window.location = "/destinations/rundates/".concat(setId);
            };
            (0, _utilities.apirequest)((0, _configuration.API_STATIONS_EPISODE_EDIT), {
                body: fd
            }, callback);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
        ref: modalRef,
        onClose: onClose,
        className: "DeleteSetModal",
        id: "DeleteSetModal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            method: "dialog",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                    children: [
                        "Are you sure you want to delete ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                            children: title
                        }),
                        "?"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    style: {
                        "display": "flex",
                        gap: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn-sm btn--action",
                            name: "delete_playlist",
                            value: "1",
                            children: "Yes"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn-sm btn--action",
                            name: "delete_playlist",
                            value: "0",
                            children: "No"
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = DeleteSetModal;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/ModalDialog":"72kji","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"710TT":[function(require,module,exports) {
/**
 * Reviewed.jsx
 * Component used for Proofed, Curated, and Approved features.
 * Author: Webinista, Inc.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reviewedCss = require("./css/Reviewed.css");
var Reviewed = function(param) {
    var _param_date = param.date, date = _param_date === void 0 ? null : _param_date, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_name = param.name, name = _param_name === void 0 ? null : _param_name, _param_id = param.id, id = _param_id === void 0 ? null : _param_id, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "YOU FORGOT YOUR LABEL!" : _param_labelText, _param_by = param.by, by = _param_by === void 0 ? " " : _param_by, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function(domEvent) {} : _param_onChange;
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), checked = _React_useState[0], setChecked = _React_useState[1];
    var cssClasses = (0, _classnamesDefault.default)(cssClass, {
        "destinations__reviewed": true
    });
    var fieldName = name || id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        htmlFor: id,
                        children: [
                            labelText,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        onChange: onChange,
                        name: fieldName,
                        id: id
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        children: "by:"
                    }),
                    " ",
                    by
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        children: "date:"
                    }),
                    " ",
                    date
                ]
            })
        ]
    });
};
Reviewed.propTypes = {
    cssClass: (0, _propTypesDefault.default).string,
    onChange: (0, _propTypesDefault.default).func.isRequired,
    checked: (0, _propTypesDefault.default).bool,
    name: (0, _propTypesDefault.default).string,
    id: (0, _propTypesDefault.default).string.isRequired,
    by: (0, _propTypesDefault.default).string,
    date: (0, _propTypesDefault.default).string,
    labelText: (0, _propTypesDefault.default).string.isRequired
};
exports.default = Reviewed;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","./css/Reviewed.css":"6uOHn","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6uOHn":[function() {},{}],"f33rk":[function(require,module,exports) {
/**
 * PlaylistMeta.jsx
 * Displays playlist URL and comments form fields.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PlaylistMeta = function(param) {
    var url = param.url, copy = param.copy, onChange = param.onChange, form = param.form, playlist = param.playlist, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "destinations__playlist_copy",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "playlist_url",
                className: "form__access__label",
                children: "Enter Playlist URL:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                form: form,
                onChange: onChange,
                className: "blockInfoTxt form-control",
                type: "text",
                id: "playlist_url",
                name: "vsb_playlistURL",
                defaultValue: url,
                placeholder: "Enter Playlist URL",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "playlist_comments",
                className: "form__access__label",
                children: "Enter comments for this play list:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                form: form,
                className: "blockInfoTxt copy-txt form-control",
                name: "vsb_proofCopy",
                id: "playlist_comments",
                defaultValue: copy,
                onChange: onChange,
                placeholder: "Playlist Copy",
                disabled: disabled
            })
        ]
    });
};
exports.default = PlaylistMeta;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2l3mr":[function(require,module,exports) {
/**
 * CRTStatus.js
 * Check for updates button.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _crtstatusCss = require("./css/CRTStatus.css");
var CRTStatus = function(param) {
    var _param_approved = param.approved, approved = _param_approved === void 0 ? false : _param_approved, _param_status = param.status, status = _param_status === void 0 ? "Not Submitted" : _param_status, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading;
    var cssClass = (0, _classnamesDefault.default)({
        "destinations__crt_status": true
    }, {
        "destinations__crt_status--approved": approved
    }, {
        "destinations__crt_status--unsubmitted": /Not Submitted/.test(status)
    }, {
        "destinations__crt_status--rejected": /Rejected/.test(status)
    });
    var showLoader = loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true,
        cssClass: "destinations__crt_status__loader"
    }) : status;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                        title: "Content Review Team",
                        children: "CRT"
                    }),
                    " Status:"
                ]
            }),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "destinations__crt_status__message",
                children: showLoader
            })
        ]
    });
};
CRTStatus.propTypes = {
    approved: (0, _propTypesDefault.default).bool,
    status: (0, _propTypesDefault.default).string
};
exports.default = CRTStatus;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../subcomponents/LoaderSimple":"1dSHa","./css/CRTStatus.css":"flhfS","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"flhfS":[function() {},{}],"fEKsS":[function(require,module,exports) {
/**
 * DestinationsPlaylistTitle.js
 * Display title, duplicate, and delete controls for a Destination playlist.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _configuration = require("../../js/Configuration");
var DestinationsPlaylistTitle = function(props) {
    var contains_interstitial = props.contains_interstitial, vsb_datetimetorun = props.vsb_datetimetorun, Video_Set = props.Video_Set, duplicated = props.duplicated, onDuplicate = props.onDuplicate, onSetDelete = props.onSetDelete, isAdmin = props.isAdmin;
    var interstit = null;
    if (contains_interstitial) interstit = /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
        className: "icon",
        title: "",
        children: (0, _configuration.INTERSTITIAL_INDICATOR)
    });
    var dte = (0, _configuration.NULL_DATE_TEXT_STATIONS);
    if (vsb_datetimetorun && (0, _dateFns.isValid)(new Date(vsb_datetimetorun))) dte = (0, _dateFns.format)(new Date(vsb_datetimetorun), "PP");
    var deletebutton = null;
    if (isAdmin) deletebutton = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: "btn btn--action",
            onClick: onSetDelete,
            children: "Delete this playlist"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "playlist__title__bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                className: "playlist__title",
                children: [
                    Video_Set,
                    " ",
                    "(",
                    dte.replace(/[[|\]]/g, ""),
                    ")",
                    interstit,
                    duplicated ? " [copy] " : ""
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: "inline-flex",
                    gap: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn btn--action",
                                onClick: onDuplicate,
                                children: "Duplicate this playlist"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                hidden: !duplicated,
                                className: "action--alert",
                                children: "Playlist duplicated"
                            })
                        ]
                    }),
                    deletebutton
                ]
            })
        ]
    });
};
exports.default = DestinationsPlaylistTitle;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gJNah":[function(require,module,exports) {
/**
 * DestinationsPlaylistRunDateModal.jsx
 * Modal for adding a run date after duplicating a playlist
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _configuration = require("../../js/Configuration");
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var DestinationsPlaylistRunDateModal = function(props) {
    var open = props.open, modalRef = props.modalRef, rundate = props.rundate, onClose = props.onClose, onSubmit = props.onSubmit, onChange = props.onChange, onDuplicateSkip = props.onDuplicateSkip;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "DestinationsPlaylistRunDateModal",
        onClose: onClose,
        open: open,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Duplicate this list"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                action: "api/videosetblockupdate",
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Add a run date?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "destination_rundate",
                                children: "Set run date: "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "playlist__dupemod_btns",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "date",
                                        id: "destination_rundate",
                                        name: "destination_rundate",
                                        value: rundate,
                                        onChange: onChange
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn--action",
                                        disabled: !rundate,
                                        children: "Save"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn btn-light",
                            onClick: onDuplicateSkip,
                            children: "Skip"
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = DestinationsPlaylistRunDateModal;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","../../js/Configuration":"k3dur","../subcomponents/ModalDialog":"72kji","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"54o4P":[function(require,module,exports) {
/**
 * DestinationsPlaylistHeader
 * 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _configuration = require("../../js/Configuration");
var _reviewed = require("./Reviewed");
var _reviewedDefault = parcelHelpers.interopDefault(_reviewed);
var _playlistMeta = require("./PlaylistMeta");
var _playlistMetaDefault = parcelHelpers.interopDefault(_playlistMeta);
var _crtstatus = require("./CRTStatus");
var _crtstatusDefault = parcelHelpers.interopDefault(_crtstatus);
var _runtimeRatings = require("./RuntimeRatings");
var _runtimeRatingsDefault = parcelHelpers.interopDefault(_runtimeRatings);
var _exportCSV = require("./ExportCSV");
var _exportCSVDefault = parcelHelpers.interopDefault(_exportCSV);
var _checkForUpdates = require("./CheckForUpdates");
var _checkForUpdatesDefault = parcelHelpers.interopDefault(_checkForUpdates);
var _shuffleVideos = require("./ShuffleVideos");
var _shuffleVideosDefault = parcelHelpers.interopDefault(_shuffleVideos);
var DestinationsPlaylistHeader = function(props) {
    var runtime = props.runtime, rating = props.rating, count = props.count, crtstatus = props.crtstatus, _props_videosetid = props.videosetid, videosetid = _props_videosetid === void 0 ? -1 : _props_videosetid, playlist = props.playlist, onSubmit = props.onSubmit, onExport = props.onExport, onCheckForUpdates = props.onCheckForUpdates, onPlay = props.onPlay, onShuffle = props.onShuffle, onPlaylistMetaChange = props.onPlaylistMetaChange, onApprovedProofedCuratedChange = props.onApprovedProofedCuratedChange, onCommentsChange = props.onCommentsChange, onImport = props.onImport, onAddBySearch = props.onAddBySearch, onAddByUrl = props.onAddByUrl, onCheckForDuplicates = props.onCheckForDuplicates;
    var vsb_playlistURL = playlist.vsb_playlistURL, vsb_proofCopy = playlist.vsb_proofCopy;
    var proofedDate = null;
    var curatedDate = null;
    var approveDate = null;
    if (playlist.Proofed_Date && (0, _dateFns.isValid)(new Date(playlist.Proofed_Date))) proofedDate = (0, _dateFns.format)(new Date(playlist.Proofed_Date), "PP");
    if (playlist.Curated_Date && (0, _dateFns.isValid)(new Date(playlist.Curated_Date))) curatedDate = (0, _dateFns.format)(new Date(playlist.Curated_Date), "PP");
    if (playlist.Approved_Date && (0, _dateFns.isValid)(new Date(playlist.Approved_Date))) approveDate = (0, _dateFns.format)(new Date(playlist.Approved_Date), "PP");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "blockInfo",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "destinations__metadata_and_status",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "destinations__meta_controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeRatingsDefault.default), {
                                runtime: runtime,
                                rating: rating,
                                videos: count
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crtstatusDefault.default), {
                                approved: crtstatus.approved,
                                status: crtstatus.status,
                                loading: crtstatus.loading
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "destinations__meta_controls__controls",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        disabled: !count,
                                        type: "button",
                                        className: "btn btn-sm btn--action playAllBtn playListBtn",
                                        onClick: onPlay,
                                        children: "Play All Videos"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        disabled: !count,
                                        type: "button",
                                        className: "btn btn-sm btn--action exportDataBtn playListBtn",
                                        onClick: onExport,
                                        children: "Export IDs"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exportCSVDefault.default), {
                                        actionURL: (0, _configuration.API_VIDEOSETBLOCK_INFO_CSV),
                                        videosetID: videosetid,
                                        disabled: false
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                                        className: "destinations__save",
                                        id: "destinations_save_playlist",
                                        name: "destinations_save_playlist",
                                        method: "POST",
                                        action: (0, _configuration.API_VIDEOSETBLOCK_UPDATE),
                                        onSubmit: onSubmit,
                                        onChange: function() {},
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            disabled: false,
                                            type: "submit",
                                            className: "btn btn-sm btn--action saveChangesBtn playListBtn",
                                            children: "Save Playlist Changes"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForUpdatesDefault.default), {
                                        onClick: onCheckForUpdates,
                                        disabled: !count
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shuffleVideosDefault.default), {
                                        onClick: onShuffle,
                                        disabled: !count
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playlistMetaDefault.default), {
                        url: vsb_playlistURL,
                        copy: vsb_proofCopy,
                        onChange: onPlaylistMetaChange,
                        disabled: playlist.Proofed === "y",
                        form: "destinations_save_playlist"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewedDefault.default), {
                        checked: playlist.Proofed === "y",
                        cssClass: "destinations__proofed",
                        labelText: "PROOFED: ",
                        id: "proofed",
                        by: playlist.Proofed_By || " ",
                        date: proofedDate,
                        onChange: onApprovedProofedCuratedChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "destinations__comments_reviewed",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewedDefault.default), {
                        checked: playlist.Curated === "y",
                        cssClass: "destinations__curated",
                        labelText: "CURATED: ",
                        id: "curated",
                        by: playlist.Curated_By || " ",
                        date: curatedDate,
                        onChange: onApprovedProofedCuratedChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "destinations__comments",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "playlist_comments",
                                children: "Enter Playlist Comments"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                className: "commentsTxt form-control",
                                type: "textarea",
                                name: "playlist_comments",
                                id: "playlist_comments",
                                value: playlist.vsb_tags,
                                onChange: onCommentsChange
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "destinations__add__video__controls",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--action",
                                        onClick: onImport,
                                        disabled: playlist.Approved === "y",
                                        children: "Import Videos from Google Sheet"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--action",
                                        onClick: onAddBySearch,
                                        disabled: playlist.Approved === "y",
                                        children: "Add Videos by Search"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--action",
                                        onClick: onAddByUrl,
                                        disabled: playlist.Approved === "y",
                                        children: "Add Videos by URL"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--action",
                                        onClick: onCheckForDuplicates,
                                        children: "Check for Duplicate Videos"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewedDefault.default), {
                        checked: playlist.Approved === "y",
                        cssClass: "destinations__approved",
                        labelText: "APPROVED: ",
                        id: "approved",
                        by: playlist.Approved_By,
                        date: approveDate,
                        onChange: onApprovedProofedCuratedChange
                    })
                ]
            })
        ]
    });
};
exports.default = DestinationsPlaylistHeader;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","../../js/Configuration":"k3dur","./Reviewed":"710TT","./PlaylistMeta":"f33rk","./CRTStatus":"2l3mr","./RuntimeRatings":"cfBio","./ExportCSV":"gnFlW","./CheckForUpdates":"gvTXy","./ShuffleVideos":"a5rri","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cfBio":[function(require,module,exports) {
/**
 * RuntimeRatings.jsx
 * Display runtime and video set ratings on the Destinations page.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _runtimeRatingsCss = require("./css/RuntimeRatings.css");
var RuntimeRatings = function(param) {
    var _param_runtime = param.runtime, runtime = _param_runtime === void 0 ? 0 : _param_runtime, _param_rating = param.rating, rating = _param_rating === void 0 ? "\u2014" : _param_rating, _param_videos = param.videos, videos = _param_videos === void 0 ? 0 : _param_videos, _param_isRequired = param.isRequired, isRequired = _param_isRequired === void 0 ? false : _param_isRequired;
    var showOptionalMessage = function() {
        var msg = "(Optional)";
        if (isRequired) msg = "(Required)";
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ratings__runtime",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "ratings__runtime_rt",
                children: [
                    "Runtime ",
                    runtime,
                    " "
                ]
            }),
            "| ",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "ratings__runtime_vc",
                children: [
                    videos,
                    " videos "
                ]
            }),
            "| ",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "ratings__runtime_r",
                children: [
                    "Rating: ",
                    rating
                ]
            })
        ]
    });
};
exports.default = RuntimeRatings;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./css/RuntimeRatings.css":"kZfp2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kZfp2":[function() {},{}],"gnFlW":[function(require,module,exports) {
/**
 * ExportCSV.js
 * Check for updates button.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _exportCSVCss = require("./css/ExportCSV.css");
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var ExportCSV = function(param) {
    var _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_actionURL = param.actionURL, actionURL = _param_actionURL === void 0 ? (0, _configuration.API_VIDEOSETBLOCK_INFO_CSV) : _param_actionURL, _param_videosetID = param.videosetID, videosetID = _param_videosetID === void 0 ? 0 : _param_videosetID;
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), working = _React_useState[0], setWorking = _React_useState[1];
    var onSubmit = function(domEvent) {
        domEvent.preventDefault();
        setWorking(true);
        if (!videosetID) return;
        var fd = new FormData();
        fd.set("id", videosetID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.csvrequest)((0, _configuration.API_VIDEOSETBLOCK_INFO_CSV), {
            body: fd
        }, function(response) {
            (0, _utilities.forceDownload)(response);
            setWorking(false);
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        action: actionURL,
        method: "POST",
        target: "_blank",
        className: "export__csv",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                id: "id",
                name: "id",
                value: "".concat(videosetID),
                onChange: function() {}
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                id: "token",
                name: "token",
                value: (0, _utilities.getAuthData)("token"),
                onChange: function() {}
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                disabled: disabled || working,
                type: "submit",
                className: "btn btn-sm btn--action saveChangesBtn playListBtn",
                children: [
                    "Export CSV",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                        cssClass: "export__csv__loader",
                        open: working
                    })
                ]
            })
        ]
    });
};
ExportCSV.propTypes = {
    actionURL: (0, _propTypesDefault.default).string.isRequired,
    videosetID: (0, _propTypesDefault.default).number.isRequired,
    disabled: (0, _propTypesDefault.default).bool.isRequired
};
exports.default = ExportCSV;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/ExportCSV.css":"3Bf4Q","../subcomponents/LoaderSimple":"1dSHa","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3Bf4Q":[function() {},{}],"a5rri":[function(require,module,exports) {
/**
 * ShuffleVideos.jsx
 * Shuffle videos in a playlist
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var ShuffleVideos = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
        type: "button"
    }, props), {
        onClick: props.onClick,
        className: "btn btn--action btn-sm",
        children: "Shuffle Videos"
    }));
};
ShuffleVideos.propTypes = {
    onClick: (0, _propTypesDefault.default).func.isRequired
};
exports.default = ShuffleVideos;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2wBau":[function(require,module,exports) {
/**
 * RunDate.jsx
 * Display the RunDate on the the Destinations/edit page
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dateFns = require("date-fns");
var _configuration = require("../../js/Configuration");
var _runDateCss = require("./css/RunDate.css");
var RunDate = function(param) {
    var _param_date = param.date, date = _param_date === void 0 ? null : _param_date, className = param.className, onInputChange = param.onInputChange;
    var cssClass = (0, _classnamesDefault.default)({
        "destinations__run__date": true
    }, className);
    var runDateFull = (0, _configuration.NULL_DATE_TEXT);
    if (date) {
        var input = new Date(date); // Convert the input date to a Date object.
        // Create a new date object
        var d = new Date(input.getUTCFullYear(), input.getUTCMonth(), input.getUTCDate());
        if ((0, _dateFns.isValid)(d)) runDateFull = (0, _dateFns.format)(d, "PP");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "destination_rundate",
                        children: "Set or Change Run Date: "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "date",
                        id: "destination_rundate",
                        name: "destination_rundate",
                        defaultValue: date,
                        onChange: onInputChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "destinations__run__date__full",
                children: runDateFull
            })
        ]
    });
};
RunDate.propTypes = {
    date: (0, _propTypesDefault.default).string,
    onInputChange: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string
};
exports.default = RunDate;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","date-fns":"1h4Hj","../../js/Configuration":"k3dur","./css/RunDate.css":"8WkPm","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8WkPm":[function() {},{}],"4HG0O":[function(require,module,exports) {
/**
 * ImportSpreadsheetToPlaylist
 * Enables users to import data into an AVA playlist from Google Sheet.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _closeButton = require("../subcomponents/CloseButton");
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _importSpreadsheetFields = require("./ImportSpreadsheetFields");
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _toggleSwitch = require("../subcomponents/ToggleSwitch");
var _toggleSwitchDefault = parcelHelpers.interopDefault(_toggleSwitch);
var _dateFns = require("date-fns");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _importUtils = require("../../actions/ImportUtils");
var ImportSpreadsheetToPlaylist = function(props) {
    var onSubmit = props.onSubmit, className = props.className, prepend = props.prepend, Video_Set = props.Video_Set, vsb_datetimetorun = props.vsb_datetimetorun, sheet = props.sheet, vsb_id = props.vsb_id, modalRef = props.modalRef;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _importUtils.initGState)), 2), gSheet = _useState1[0], setGSheet = _useState1[1];
    (0, _react.useEffect)(function() {
        if (email == "") {
            var fd = new FormData();
            fd.append("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_IMPORT_EMAIL), {
                body: fd
            }, function(response) {
                setEmail(response.email);
            });
        }
    }, [
        email
    ]);
    var makeTitle = function() {
        var dte = "(".concat((0, _configuration.NULL_DATE_TEXT_STATIONS), ")");
        if (vsb_datetimetorun && (0, _dateFns.isValid)(new Date(vsb_datetimetorun))) dte = (0, _dateFns.format)(new Date(vsb_datetimetorun), "PP");
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                "Importing videos to ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                    children: Video_Set
                }),
                " ",
                dte.replace(/[[|\]]/g, "")
            ]
        });
    };
    var body;
    var cssClasses = (0, _classnamesDefault.default)({
        "spreadsheet__destinations": true,
        "spreadsheet__import__disabled": !email
    }, className);
    var onChange = function(domEvent) {
        var _domEvent_target = domEvent.target, name = _domEvent_target.name, value = _domEvent_target.value;
        var field = name;
        if (name.indexOf("prepend") === 0) field = "prepend";
        setGSheet((0, _objectSpreadProps._)((0, _objectSpread._)({}, gSheet), (0, _defineProperty._)({}, field, value)));
    };
    var oOnSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("url", gSheet.url);
        fd.set("sheet", gSheet.sheet);
        fd.set("playlist", vsb_id);
        fd.set("prepend", gSheet.prepend);
        fd.set("userUID", (0, _utilities.getAuthData)("uuid"));
        fd.set("userID", (0, _utilities.getAuthData)("uid"));
        fd.set("userName", (0, _utilities.getAuthData)("user"));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_IMPORT_GSHEET_TO_PLAYLIST), {
            body: fd
        }, function(response) {
            if (response.success && onSubmit) {
                onSubmit();
                if (modalRef.current) modalRef.current.close();
                setGSheet((0, _importUtils.initGState));
            }
        });
    };
    var onClose = function(domEvent) {
        if (modalRef.current) modalRef.current.close();
        setGSheet((0, _importUtils.initGState));
    };
    if (gSheet.loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else /*
    This markup is weird because ToggleSwitch is also a form and you can't nest forms.
    You can, however, associate a form control such as a button with a form by setting
    the `form` attribute as we've done here.
    */ body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                id: "tools_import_sheet",
                onSubmit: oOnSubmit,
                className: cssClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "playlist",
                        id: "playlist",
                        value: vsb_id,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importSpreadsheetFields.ImportSpreadsheetFields), (0, _objectSpreadProps._)((0, _objectSpread._)({
                        email: email
                    }, gSheet), {
                        onChange: onChange
                    }))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                disabled: !email || !gSheet.url,
                onChange: onChange,
                label: "Add to beginning?",
                options: [
                    "Yes",
                    "No"
                ],
                name: "prepend",
                selectedIndex: +gSheet.prepend
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "text__right button__group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: !email || !gSheet.url,
                        type: "submit",
                        className: "btn btn--action",
                        form: "tools_import_sheet",
                        children: "Import"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        className: "btn btn-light",
                        form: "tools_import_sheet",
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "ImportSpreadsheetToPlaylist",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: makeTitle()
            }),
            body
        ]
    });
};
exports.default = ImportSpreadsheetToPlaylist;

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","../subcomponents/CloseButton":"3MmmO","../subcomponents/LoaderSimple":"1dSHa","./ImportSpreadsheetFields":"fi3zf","../subcomponents/ModalDialog":"72kji","../subcomponents/ToggleSwitch":"k29YD","date-fns":"1h4Hj","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/ImportUtils":"9MRIx","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fi3zf":[function(require,module,exports) {
/**
 * ImportSpreadsheetFields
 * Enables users to import data into AVA from GoogleSheet.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImportSpreadsheetFields", function() {
    return ImportSpreadsheetFields;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ImportSpreadsheetFields = function(param) {
    var email = param.email, url = param.url, sheet = param.sheet, onChange = param.onChange;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "alert alert-warning",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: "Important!"
                    }),
                    " ",
                    " ",
                    "Make sure that the page you're importing contains ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: "5000"
                    }),
                    " ",
                    " ",
                    "or fewer YouTube ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                        title: "identifiers",
                        children: "IDs"
                    }),
                    ". "
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        className: "form__access__label",
                        children: "Google Sheet Information"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "url",
                                children: "Google Sheet URL"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                disabled: !email,
                                type: "url",
                                id: "url",
                                name: "url",
                                "aria-describedby": "url_note",
                                onChange: onChange,
                                defaultValue: url,
                                required: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                id: "url_note",
                                children: [
                                    "Make sure that you've shared this spreadsheet with the email address ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: email
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "sheet",
                                children: "Sheet name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                disabled: !email,
                                type: "sheet",
                                id: "sheet",
                                name: "sheet",
                                "aria-describedby": "sheet_hint",
                                onChange: onChange,
                                defaultValue: sheet,
                                required: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "sheet_hint",
                                children: "You'll find this at the bottom of the Google Sheets screen. It's the text that indicates which tab or page of the spreadsheet you're currently on."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9MRIx":[function(require,module,exports) {
/*
ImportUtils.js
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initGState", function() {
    return initGState;
});
parcelHelpers.export(exports, "setStateImportOnOpen", function() {
    return setStateImportOnOpen;
});
parcelHelpers.export(exports, "setStateImportOnClose", function() {
    return setStateImportOnClose;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var initGState = {
    url: "",
    sheet: "Sheet1",
    loading: false,
    prepend: 1
};
var setStateImportOnOpen = function(state) {
    return {
        importGSheet: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.importGSheet), {
            open: true
        })
    };
};
var setStateImportOnClose = function(state) {
    var showloader = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        importGSheet: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.importGSheet), {
            loading: false,
            open: false,
            url: "",
            sheet: "Sheet1"
        }),
        loading: showloader
    });
};
var setStateImportOnError = function(state) {
    return {
        importGSheet: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.importGSheet), {
            loading: false
        })
    };
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","../js/Utilities":"euxcI","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"Ja4lj":[function(require,module,exports) {
/*
StationsUtils.js

Functions that are shared between multiple views in stations
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveSeasonEp", function() {
    return saveSeasonEp;
});
parcelHelpers.export(exports, "formatVideoList", function() {
    return formatVideoList;
});
parcelHelpers.export(exports, "setStateOnPerPage", function() {
    return setStateOnPerPage;
});
parcelHelpers.export(exports, "setStateOnCrtChange", function() {
    return setStateOnCrtChange;
});
parcelHelpers.export(exports, "setStateOnPaginationClick", function() {
    return setStateOnPaginationClick;
});
parcelHelpers.export(exports, "setStateAfterVidBatch", function() {
    return setStateAfterVidBatch;
});
parcelHelpers.export(exports, "setStateOnFilterChange", function() {
    return setStateOnFilterChange;
});
parcelHelpers.export(exports, "setStateOnSortChange", function() {
    return setStateOnSortChange;
});
parcelHelpers.export(exports, "setStateOnDirectionChange", function() {
    return setStateOnDirectionChange;
});
parcelHelpers.export(exports, "setStateOnFilterClear", function() {
    return setStateOnFilterClear;
});
parcelHelpers.export(exports, "setStateOnInfoClose", function() {
    return setStateOnInfoClose;
});
parcelHelpers.export(exports, "setStateOnDeleteFromSystem", function() {
    return setStateOnDeleteFromSystem;
});
parcelHelpers.export(exports, "setStateAddByURLWorking", function() {
    return setStateAddByURLWorking;
});
parcelHelpers.export(exports, "setStateOnRatingChange", function() {
    return setStateOnRatingChange;
});
parcelHelpers.export(exports, "setStateAfterRating", function() {
    return setStateAfterRating;
});
parcelHelpers.export(exports, "setStateHideSaved", function() {
    return setStateHideSaved;
});
parcelHelpers.export(exports, "setStateGridToggle", function() {
    return setStateGridToggle;
});
parcelHelpers.export(exports, "setStateOnVideoBlockSelect", function() {
    return setStateOnVideoBlockSelect;
});
parcelHelpers.export(exports, "setStateCloseVideo", function() {
    return setStateCloseVideo;
});
parcelHelpers.export(exports, "setStateAddByURL", function() {
    return setStateAddByURL;
});
parcelHelpers.export(exports, "setStateOnCloseCheckForDupes", function() {
    return setStateOnCloseCheckForDupes;
});
parcelHelpers.export(exports, "setStateOnReOrder", function() {
    return setStateOnReOrder;
});
parcelHelpers.export(exports, "setStateOnRunDateChange", function() {
    return setStateOnRunDateChange;
});
parcelHelpers.export(exports, "setStateIndicateSaved", function() {
    return setStateIndicateSaved;
});
parcelHelpers.export(exports, "initEditSeries", function() {
    return initEditSeries;
});
parcelHelpers.export(exports, "initAddNewSeries", function() {
    return initAddNewSeries;
});
parcelHelpers.export(exports, "initAddNewEp", function() {
    return initAddNewEp;
});
parcelHelpers.export(exports, "initEpisodes", function() {
    return initEpisodes;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var saveSeasonEp = function(blockid, season, episode) {
    var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!season && !episode) return;
    var fd = new FormData();
    fd.set("blockid", blockid);
    fd.set("season", season);
    fd.set("episode", episode);
    fd.set("userid", (0, _utilities.getAuthData)("uid"));
    fd.set("uuid", (0, _utilities.getAuthData)("uuid"));
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_SAVE_SEASONEPS), {
        body: fd
    }, callback);
};
var formatVideoList = function(videos) {
    var list = videos.length ? videos : [];
    var items = list.map(function(item, index) {
        return {
            name: item.Video_Name,
            ordinal: index,
            id: item.video_id,
            ytID: item.Video_ID,
            thumb: item.videoext_thumbnail,
            duration: item.Duration,
            is_interstitial: item.is_interstitial,
            crt: item.crt,
            meow: item.meow,
            position: +item.order
        };
    });
    return items;
};
var setStateOnPerPage = function(state, value) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            perPage: +value
        })
    };
};
var setStateOnCrtChange = function(state, data) {
    return {
        crtstatus: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.crt), {
            approved: data.approved,
            status: data.status,
            loading: false
        })
    };
};
var setStateOnPaginationClick = function(prevState, value) {
    var curPage = prevState.videostoadd.page + +value;
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState.videostoadd), {
            page: curPage
        })
    };
};
var setStateAfterVidBatch = function(state, response) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            available: response.videos,
            page: response.current_page,
            pageCount: response.pages,
            results: response.num_results,
            isloading: false,
            open: true
        })
    };
};
var setStateOnFilterChange = function(state, keyword, criterion) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            filterKeyword: keyword,
            filterOn: criterion,
            page: 1,
            pageCount: 1
        })
    };
};
var setStateOnSortChange = function(state, criterion) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            sortBy: criterion
        })
    };
};
var setStateOnDirectionChange = function(state) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            ascending: !state.videostoadd.ascending
        })
    };
};
var setStateOnFilterClear = function(state) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            filterOn: "",
            filterKeyword: "",
            ascending: false
        })
    };
};
var setStateOnInfoClose = function(state) {
    return {
        videopreview: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videopreview), {
            open: false
        })
    };
};
var setStateOnDeleteFromSystem = function(state, response) {
    var vlist = (0, _toConsumableArray._)(state.list);
    // Removes deleted videos from the list.
    var removevid = function(id) {
        var remove = vlist.findIndex(function(item) {
            return +id === +item.id;
        });
        vlist.splice(remove, 1);
    };
    response.videosDeleted.forEach(removevid);
    return {
        list: vlist,
        videopreview: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videopreview), {
            open: false
        })
    };
};
var setStateAddByURLWorking = function(state) {
    return {
        addByURL: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addByURL), {
            working: true
        })
    };
};
var setStateOnRatingChange = function(state, value) {
    return {
        videopreview: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videopreview), {
            currentrating: value
        })
    };
};
var setStateAfterRating = function(state, value) {
    return {
        videopreview: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videopreview), {
            open: false,
            currentrating: null,
            current: {}
        })
    };
};
var setStateHideSaved = function(state) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            savestatus: {
                hidden: true
            }
        })
    };
};
var setStateGridToggle = function(state, value) {
    return {
        useGrid: value
    };
};
var setStateOnVideoBlockSelect = function(state, data) {
    return {
        videopreview: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videopreview), {
            selectedSet: {
                videosetid: data.videosets.value,
                videoblockid: data.videosetblocks.value
            }
        })
    };
};
var setStateCloseVideo = function(state) {
    return {
        videopreview: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videopreview), {
            open: false,
            currentrating: null,
            selectedSet: {}
        })
    };
};
var setStateAddByURL = function(state, value) {
    return {
        addByURL: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addByURL), {
            open: true
        }),
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            open: false
        })
    };
};
var setStateOnCloseCheckForDupes = function(state) {
    return {
        checkForDupes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.checkForDupes), {
            open: false,
            loading: true,
            dupes: [],
            mode: "adding",
            working: false,
            message: ""
        }),
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            open: false,
            selected: []
        }),
        addByURL: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addByURL), {
            open: false,
            value: "",
            maxIds: false,
            working: false
        })
    };
};
var setStateOnReOrder = function(state, data) {
    if (!data.returnData.length) return state;
    return {
        list: formatVideoList(data.returnData),
        runtime: (0, _utilities.totalRunTime)(data.returnData)
    };
};
var setStateOnRunDateChange = function(state, newdate) {
    return {
        meta: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.meta), {
            vsb_datetimetorun: newdate
        })
    };
};
var setStateIndicateSaved = function(state) {
    return {
        videostoadd: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videostoadd), {
            savestatus: {
                hidden: false
            }
        })
    };
};
var initEditSeries = {
    open: false,
    error: null,
    value: "",
    mode: "series_title",
    series_id: null
};
var initAddNewSeries = {
    setId: null,
    blockId: null,
    error: null,
    mode: "series",
    title: "Add a New Series",
    labelText: "Enter a name for this series"
};
var _obj;
var initAddNewEp = (_obj = {
    setId: null,
    blockId: null,
    title: "",
    open: false,
    error: null,
    mode: "episode"
}, (0, _defineProperty._)(_obj, "title", ""), (0, _defineProperty._)(_obj, "labelText", "Enter a name for this episode"), (0, _defineProperty._)(_obj, "modalTitle", "Add an Episode to This Series"), _obj);
var initEpisodes = {
    open: false,
    list: [],
    meta: {
        id: 0,
        title: null
    },
    mode: "view"
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_to_consumable_array":"fRXIP","lodash.uniqueid":"6bf5k","../js/Utilities":"euxcI","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kWrfi":[function() {},{}],"jiXKe":[function() {},{}],"bUMo2":[function(require,module,exports) {
/**
 * VideoSetRundates
 * View run dates or playlists for a particular video set
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _breadcrumb = require("../subcomponents/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _destinationsPlaylistTable = require("./DestinationsPlaylistTable");
var _destinationsPlaylistTableDefault = parcelHelpers.interopDefault(_destinationsPlaylistTable);
var _createRunDate = require("./CreateRunDate");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _destinationsUtils = require("../../actions/DestinationsUtils");
var _destinationVideoSetsCss = require("./css/DestinationVideoSets.css");
var VideoSetRundates = function(param) {
    var params = param.params;
    var initCreateState = {
        open: false,
        date: "",
        mode: "add",
        playlistID: null,
        title: ""
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), episodes = _useState[0], setEpisodes = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), crumbTrail = _useState2[0], setCrumbTrail = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(initCreateState), 2), create = _useState3[0], setCreate = _useState3[1];
    var createRunDateRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        if (!episodes.length) getTheRunDates();
        if (!crumbTrail.length) (0, _destinationsUtils.getVideoSetBreadcrumbs)(params.id, setBreadcrumbs);
    }, [
        create,
        params,
        episodes
    ]);
    var getTheRunDates = function() {
        var id = params.id;
        (0, _destinationsUtils.getRunDates)(id, function(response) {
            setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
                title: create.title
            }));
            setEpisodes(response);
            setLoading(false);
        });
    };
    var duplicate = function(id) {
        (0, _destinationsUtils.duplicatePlaylist)(id, function(data) {
            window.location = "/destinations/playlist/".concat(data);
        });
    };
    var onCreateSave = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (domEvent) domEvent.preventDefault();
        var fd = new FormData();
        fd.set("setID", params.id);
        fd.set("date", create.date);
        fd.set("title", "");
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_ADDNEW), {
            body: fd
        }, onCreateRundateResponse);
    };
    var onCreateRundateResponse = function(response) {
        var result = response.result, blockID = response.blockID, set_title = response.set_title;
        setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
            mode: result,
            playlistID: blockID,
            title: set_title
        }));
    };
    var onCreateChange = function(domEvent) {
        var value = domEvent.target.value;
        setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
            date: value
        }));
        if (value == "") onCreateSave();
    };
    var onCreateOpen = function() {
        if (createRunDateRef.current) createRunDateRef.current.showModal();
    };
    var onCreateRundateClose = function() {
        setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
            mode: "add",
            playlistID: null,
            date: ""
        }));
        if (createRunDateRef.current) createRunDateRef.current.close();
    };
    var setBreadcrumbs = function(response) {
        var station_id = response.station_id, Station = response.Station, Video_Set = response.Video_Set;
        var items = [
            {
                path: "/destinations",
                label: "Destinations"
            },
            {
                path: "/destinations/videosets/".concat(station_id),
                label: Station,
                state: {
                    destination: Station
                }
            },
            {
                label: Video_Set
            }
        ];
        setCrumbTrail(items);
        setCreate((0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
            title: Video_Set
        }));
    };
    var makeBreadcrumbs = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbDefault.default), {
            items: crumbTrail
        });
    };
    var body;
    if (loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsPlaylistTableDefault.default), {
        header: [
            "Run Dates",
            "Duration",
            "Actions"
        ],
        rows: episodes,
        onDuplicate: duplicate
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            makeBreadcrumbs(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                id: "destination__header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        children: [
                            "Run dates for ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                                children: create.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--action",
                        onClick: onCreateOpen,
                        children: "Create New Playlist"
                    })
                ]
            }),
            body,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createRunDate.CreateRunDate), (0, _objectSpreadProps._)((0, _objectSpread._)({}, create), {
                modalRef: createRunDateRef,
                videoset: params.id,
                onClose: onCreateRundateClose,
                onSubmit: onCreateSave,
                onChange: onCreateChange
            }))
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VideoSetRundates, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","../subcomponents/Breadcrumb":"e7Haa","../subcomponents/LoaderSimple":"1dSHa","./DestinationsPlaylistTable":"dD2E7","./CreateRunDate":"jHn7P","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/DestinationsUtils":"5X8UE","./css/DestinationVideoSets.css":"87C45","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dD2E7":[function(require,module,exports) {
/**
 * DestinationsPlaylistTable
 * Display table data for the stations series.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _reactRouterDom = require("react-router-dom");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _stationsSeriesTableCss = require("../Stations/css/StationsSeriesTable.css");
var _destinationsPlaylistTableCss = require("./css/DestinationsPlaylistTable.css");
var DestinationsPlaylistTable = function(param) {
    var header = param.header, rows = param.rows, onDuplicate = param.onDuplicate;
    var makeHeader = function() {
        var ths = header.map(function(thd, idx) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                children: thd
            }, idx);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: ths
            })
        });
    };
    var makeLink = function(item) {
        var vsb_datetimetorun = item.vsb_datetimetorun, vsb_id = item.vsb_id, contains_interstitial = item.contains_interstitial;
        var datelabel = (0, _configuration.NULL_DATE_TEXT_STATIONS);
        if (vsb_datetimetorun && vsb_datetimetorun !== "0000-00-00") datelabel = (0, _dateFns.format)(new Date(vsb_datetimetorun), "PP");
        var interstit = null;
        if (contains_interstitial) interstit = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
            className: "icon",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    "aria-hidden": "true",
                    children: (0, _configuration.INTERSTITIAL_INDICATOR)
                }),
                " ",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "form__access__label",
                    children: "Contains Interstitial"
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                interstit,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/destinations/playlist/".concat(vsb_id),
                    children: datelabel
                })
            ]
        });
    };
    var makeControls = function(item) {
        var vsb_id = item.vsb_id;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/destinations/playlist/".concat(vsb_id),
                    className: "btn btn-sm btn--action",
                    children: "View / Edit"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    action: "/",
                    onSubmit: oOnDuplicate,
                    className: "playlist__edit",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "block",
                            id: "block_id",
                            value: vsb_id
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn-sm btn--action",
                            children: "Duplicate"
                        })
                    ]
                })
            ]
        });
    };
    var makeRows = function() {
        var trs = rows.map(function(trd, idx) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: makeLink(trd)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "duration",
                        children: (0, _utilities.formatTime)(trd.duration)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: makeControls(trd)
                    })
                ]
            }, "set_".concat(trd.vsb_id));
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
            children: trs
        });
    };
    var oOnDuplicate = function(domEvent) {
        domEvent.preventDefault();
        var block = domEvent.target.block;
        if (onDuplicate) onDuplicate(block.value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "destinations__playlist",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "destinations__component__note",
                children: (0, _configuration.INTERSTITIAL_NOTE)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "stations__series__table destinations__playlist__table",
                children: [
                    makeHeader(),
                    makeRows()
                ]
            })
        ]
    });
};
exports.default = DestinationsPlaylistTable;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","react-router-dom":"gMZz4","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../Stations/css/StationsSeriesTable.css":"3eGr4","./css/DestinationsPlaylistTable.css":"78FNe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3eGr4":[function() {},{}],"78FNe":[function() {},{}],"jHn7P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateRunDate", function() {
    return CreateRunDate;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _reactRouterDom = require("react-router-dom");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var CreateRunDate = function(param) {
    var mode = param.mode, date = param.date, title = param.title, videoset = param.videoset, playlistID = param.playlistID, modalRef = param.modalRef, onSubmit = param.onSubmit, onChange = param.onChange, onClose = param.onClose;
    var body;
    if (mode === "add") body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        id: "DestinationsCreateNewRunDate__add",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                children: [
                    "Create a new playlist in ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: onSubmit,
                id: "destination_create_rundate",
                className: "destination_create_rundate--modal",
                action: (0, _configuration.API_VIDEOSET_ADDNEW),
                method: "POST",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "token",
                        value: (0, _utilities.getAuthData)("token")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "videoset",
                        value: videoset
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "destination_rundate",
                                children: "Set run date:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "playlist__dupemod_btns",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "date",
                                        id: "destination_rundate",
                                        name: "destination_rundate",
                                        value: date,
                                        onChange: onChange
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn--action",
                                        disabled: !date,
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-light",
                                        onClick: onChange,
                                        value: "",
                                        children: "I'll set one later"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    else if (mode === "success") body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        id: "DestinationsCreateNewRunDate__success",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Success!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "I've added a new playlist to the videoset, ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: title
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/destinations/playlist/".concat(playlistID),
                    className: "btn btn--action",
                    children: "Edit this playlist"
                })
            })
        ]
    });
    else body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        id: "DestinationsCreateNewRunDate__error",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Error! Something went wrong"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Sorry. I could not add a new play list to the videoset,",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: title
                    }),
                    ". This is probably a bug. Please report it to an administrator."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "DestinationsCreateNewRunDate",
        onClose: onClose,
        children: body
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/ModalDialog":"72kji","react-router-dom":"gMZz4","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"87C45":[function() {},{}],"cbBP2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _lodashUniqueId = require("lodash.uniqueId");
var _lodashUniqueIdDefault = parcelHelpers.interopDefault(_lodashUniqueId);
var _searchForm = require("./Search/SearchForm");
var _searchFormDefault = parcelHelpers.interopDefault(_searchForm);
var _searchResultsPanel = require("./Search/SearchResultsPanel");
var _searchResultsPanelDefault = parcelHelpers.interopDefault(_searchResultsPanel);
var _channelsList = require("./ChannelsList");
var _channelsListDefault = parcelHelpers.interopDefault(_channelsList);
var _videoModal = require("./subcomponents/Videos/VideoModal");
var _videoModalDefault = parcelHelpers.interopDefault(_videoModal);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _searchUtils = require("../actions/SearchUtils");
var _searchMultiChannelCss = require("../css/SearchMultiChannel.css");
var SearchMultiChannel = function(param) {
    var project = param.project;
    // Prevents API requests from clogging up and blocking the UI.
    var fetchcancelqueue = new Map();
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _searchUtils.initLanguage)), 2), language = _useState[0], setLanguage = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({}), 2), results = _useState1[0], setResults = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({
        "All Channels": false
    }), 2), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(""), 2), video = _useState3[0], setVideo = _useState3[1];
    /*
   Even though the ChannelsList form is a subcomponent to SearchForm,
   it's a separate form element.

   Since ChannelsList can be submitted separately from SearchForm, we'll pass its
   submit value (an array of channel IDs) up to this component and make the search
   request from here instead of handling it all in SearchForm.

   The results will be displayed here, so I ~think~ this makes sense.
   */ var _useState4 = (0, _slicedToArray._)((0, _react.useState)([]), 2), channels = _useState4[0], setChannels = _useState4[1];
    var modalRef = (0, _react.useRef)(null);
    var panels = [];
    var canAdmin = (0, _utilities.isAdmin)(project);
    var makeFormData = function(formObject) {
        var fd = new FormData(formObject);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.delete("searchGroup");
        /* If the region code value is all, then unset it. */ if (fd.get("regionCode") === "all" || fd.get("regionCode") === "YTE") fd.delete("regionCode");
        if (fd.get("relevanceLanguage") === "all" || fd.get("relevanceLanguage") === "YTE") fd.delete("relevanceLanguage");
        return fd;
    };
    var onServerResponse = function(channel, response) {
        setResults(function(prev) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), (0, _defineProperty._)({}, channel, (0, _objectSpread._)({}, prev[channel], response)));
        });
        setLoading(function(prev) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), (0, _defineProperty._)({}, channel, false));
        });
    };
    var onRequestPage = function(domEvent) {
        domEvent.preventDefault();
        var form = domEvent.target.form;
        var _domEvent_target_dataset = domEvent.target.dataset, page = _domEvent_target_dataset.page, channel = _domEvent_target_dataset.channel;
        setLoading(function(prev) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), (0, _defineProperty._)({}, channel, true));
        });
        var fd = makeFormData(form);
        fd.set("pageToken", page);
        if (channel === "All Channels") fd.set("maxResults", (0, _configuration.VIDEOS_PER_PAGE) * 2);
        else {
            fd.set("channelId", channel);
            fd.set("maxResults", (0, _configuration.VIDEOS_PER_PAGE));
        }
        var ac = new AbortController();
        var signal = ac.signal;
        (0, _searchUtils.search)({
            body: fd,
            signal: signal
        }, function(response) {
            onServerResponse(channel, response);
        });
    };
    var onCloseVideo = function() {
        if (modalRef.current) modalRef.current.close();
        setVideo(null);
    };
    var onPlayVideo = function(videodata) {
        var video_yt_id = videodata.video_yt_id;
        setVideo(video_yt_id);
        if (modalRef.current) modalRef.current.showModal();
    };
    var onSubmit = function(domEvent) {
        setLoading(true);
        setResults({});
        domEvent.preventDefault();
        var fd = makeFormData(domEvent.target);
        if (channels.length) channels.forEach(function(c) {
            var ac = new AbortController();
            var signal = ac.signal;
            fd.set("channelId", c);
            fd.set("maxResults", (0, _configuration.VIDEOS_PER_PAGE));
            (0, _searchUtils.search)({
                body: fd,
                signal: signal
            }, function(response) {
                var channel_ytid = response.channel_ytid;
                setResults(function(prev) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), (0, _defineProperty._)({}, channel_ytid, response));
                });
                setLoading(function() {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, loading), (0, _defineProperty._)({}, channel_ytid, false));
                });
            });
        });
        else {
            var ac = new AbortController();
            var signal = ac.signal;
            fd.set("maxResults", (0, _configuration.VIDEOS_PER_PAGE) * 2);
            (0, _searchUtils.search)({
                body: fd,
                signal: signal
            }, function(response) {
                setLoading(false);
                setResults(function(prev) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), (0, _defineProperty._)({}, "All Channels", response));
                });
            });
        }
    };
    var onChannelSearchSubmit = function(channelList) {
        setChannels(channelList);
    };
    var channelIds = Object.keys(results);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            minHeight: "70rem"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchFormDefault.default), {
                onSubmit: onSubmit,
                onChannelSubmit: onChannelSearchSubmit,
                onReset: function() {
                    return setResults({});
                }
            }),
            channelIds.length > 0 && channelIds.map(function(c) {
                return /*#__PURE__*/ (0, _react.createElement)((0, _searchResultsPanelDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                    id: c
                }, results[c]), {
                    key: (0, _lodashUniqueIdDefault.default)(),
                    onRequestPage: onRequestPage,
                    onPlayVideo: onPlayVideo,
                    loading: loading[c]
                }));
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoModalDefault.default), {
                modalRef: modalRef,
                isAdmin: canAdmin,
                id: "SearchResultsModal",
                youtubeId: video,
                onClose: onCloseVideo
            })
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchMultiChannel, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","lodash.uniqueId":"1DF8m","./Search/SearchForm":"lLpWP","./Search/SearchResultsPanel":"2VQdt","./ChannelsList":"cn7Fd","./subcomponents/Videos/VideoModal":"aQAN2","./subcomponents/LoaderSimple":"1dSHa","../js/Configuration":"k3dur","../js/Utilities":"euxcI","../actions/SearchUtils":"hf48D","../css/SearchMultiChannel.css":"4lUZe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1DF8m":[function(require,module,exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var INFINITY = 1 / 0;
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to generate unique IDs. */ var idCounter = 0;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Built-in value references. */ var Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
}
module.exports = uniqueId;

},{"@swc/helpers/_/_type_of":"60jEQ"}],"lLpWP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _channelsList = require("../ChannelsList");
var _channelsListDefault = parcelHelpers.interopDefault(_channelsList);
var _searchDropDown = require("./SearchDropDown");
var _searchDropDownDefault = parcelHelpers.interopDefault(_searchDropDown);
var _searchInChannels = require("./SearchInChannels");
var _searchInChannelsDefault = parcelHelpers.interopDefault(_searchInChannels);
var _searchMoreOptions = require("./SearchMoreOptions");
var _searchMoreOptionsDefault = parcelHelpers.interopDefault(_searchMoreOptions);
var _searchDateRange = require("./SearchDateRange");
var _searchDateRangeDefault = parcelHelpers.interopDefault(_searchDateRange);
var _regionLangDisplay = require("../subcomponents/RegionLangDisplay");
var _regionLangDisplayDefault = parcelHelpers.interopDefault(_regionLangDisplay);
var _dateFns = require("date-fns");
var _searchFormCss = require("./css/SearchForm.css");
var _configuration = require("../../js/Configuration");
var _searchConfiguration = require("../../js/SearchConfiguration");
var _utilities = require("../../js/Utilities");
var _searchUtils = require("../../actions/SearchUtils");
var SearchForm = function(param) {
    var onSubmit = param.onSubmit, onChannelSubmit = param.onChannelSubmit, onReset = param.onReset;
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState((0, _searchUtils.initGroups)), 2), groups = _React_useState[0], setGroups = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), advancedOpen = _React_useState1[0], setAdvancedOpen = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)((0, _reactDefault.default).useState((0, _searchUtils.initCriteria)), 2), criteria = _React_useState2[0], setCriteria = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)((0, _reactDefault.default).useState((0, _searchUtils.initLanguage)), 2), language = _React_useState3[0], setLanguage = _React_useState3[1];
    var _React_useState4 = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), languages = _React_useState4[0], setLanguages = _React_useState4[1];
    var _React_useState5 = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), regions = _React_useState5[0], setRegions = _React_useState5[1];
    var _React_useState6 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        code: "YTE",
        name: "All Regions",
        flag: {
            flag: "\uD83C\uDF10",
            region: ""
        }
    }), 2), international = _React_useState6[0], setInternational = _React_useState6[1];
    var _React_useState7 = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), channelpicks = _React_useState7[0], setChannelPicks = _React_useState7[1];
    var modalRef = (0, _reactDefault.default).useRef(null);
    (0, _reactDefault.default).useEffect(function() {
        if (!(groups.length > 1)) (0, _searchUtils.getGroups)(function(response) {
            var grps = response.map(function(g) {
                return {
                    label: g.group_name,
                    value: g.group_id,
                    channelList: g.channelList
                };
            });
            setGroups((0, _toConsumableArray._)((0, _searchUtils.initGroups)).concat(grps));
        });
        if (!regions.length) (0, _searchUtils.getRegions)(function(response) {
            var reg = response.map(function(r) {
                return {
                    label: r.name,
                    value: r.code
                };
            });
            setRegions(reg);
        });
        if (!languages.length) (0, _searchUtils.getLanguages)(function(response) {
            var langs = response.map(function(l) {
                return {
                    label: l.name,
                    value: l.code
                };
            });
            setLanguages(langs);
        });
    }, [
        groups
    ]);
    var advanced = (0, _classnamesDefault.default)({
        "search__form__advanced": true,
        "search__form__advanced--open": advancedOpen
    });
    var publishedBefore = criteria.publishedBefore, publishedAfter = criteria.publishedAfter, regionCode = criteria.regionCode, relevanceLanguage = criteria.relevanceLanguage, videoCategoryId = criteria.videoCategoryId, _criteria_channelSearchGroup = criteria.channelSearchGroup, channelSearchGroup = _criteria_channelSearchGroup === void 0 ? "" : _criteria_channelSearchGroup, _criteria_channelsearch = criteria.channelsearch, channelsearch = _criteria_channelsearch === void 0 ? [] : _criteria_channelsearch, _criteria_order = criteria.order, order = _criteria_order === void 0 ? "" : _criteria_order, _criteria_topicId = criteria.topicId, topicId = _criteria_topicId === void 0 ? "" : _criteria_topicId, _criteria_videoDefinition = criteria.videoDefinition, videoDefinition = _criteria_videoDefinition === void 0 ? "" : _criteria_videoDefinition, _criteria_videoDimension = criteria.videoDimension, videoDimension = _criteria_videoDimension === void 0 ? "" : _criteria_videoDimension, _criteria_videoDuration = criteria.videoDuration, videoDuration = _criteria_videoDuration === void 0 ? "" : _criteria_videoDuration, _criteria_videoType = criteria.videoType, videoType = _criteria_videoType === void 0 ? "" : _criteria_videoType, _criteria_videoEmbeddable = criteria.videoEmbeddable, videoEmbeddable = _criteria_videoEmbeddable === void 0 ? "" : _criteria_videoEmbeddable, _criteria_videoLicense = criteria.videoLicense, videoLicense = _criteria_videoLicense === void 0 ? "" : _criteria_videoLicense, _criteria_eventType = criteria.eventType, eventType = _criteria_eventType === void 0 ? "" : _criteria_eventType, _criteria_safeSearch = criteria.safeSearch, safeSearch = _criteria_safeSearch === void 0 ? "" : _criteria_safeSearch;
    // FIX THESE
    var before = new Date(publishedBefore);
    var after = new Date(publishedAfter);
    var onShowOptions = function() {
        setAdvancedOpen(true);
    };
    var onToggleOptions = function() {
        setAdvancedOpen(!advancedOpen);
    };
    var onChange = function(domEvent) {
        var target = domEvent.target;
        var name = target.name, value = target.value;
        setCriteria((0, _objectSpreadProps._)((0, _objectSpread._)({}, criteria), (0, _defineProperty._)({}, name, value)));
        if (name === "searchGroup") {
            var channelGroup = groups.find(function(g) {
                return +g.value === +value;
            });
            if (Object.hasOwn(channelGroup, "channelList")) {
                var channels = channelGroup.channelList.map(function(c) {
                    return c.youtubeid;
                });
                setChannelPicks(channels);
                onChannelSubmit(channels);
            } else {
                setChannelPicks([]);
                onChannelSubmit([]);
            }
        }
    };
    var onResetter = function(domEvent) {
        (0, _utilities.removeAuthData)("userSearch");
        setLanguage((0, _searchUtils.initLanguage));
        setCriteria((0, _searchUtils.initCriteria));
        setChannelPicks([]);
        onChannelSubmit([]);
        if (onReset) onReset();
    };
    var onShowChannels = function() {
        if (modalRef.current) modalRef.current.showModal();
    };
    var onHideChannels = function() {
        if (modalRef.current) modalRef.current.close();
    };
    var onChannelSearchSubmit = function(domEvent) {
        domEvent.preventDefault();
        var elements = domEvent.target.elements;
        var picks = Array.from(elements).filter(function(p) {
            return p.type === "checkbox";
        }).filter(function(p) {
            return p.checked;
        }).map(function(p) {
            return p.value;
        });
        setChannelPicks(picks);
        onChannelSubmit(picks);
        onHideChannels();
    };
    var rangeStart = "";
    if (!isNaN(after.getTime())) rangeStart = (0, _dateFns.format)(after.getTime(), "yyyy-MM-dd");
    var rangeEnd = "";
    if (!isNaN(before.getTime())) rangeEnd = (0, _dateFns.format)(before.getTime(), "yyyy-MM-dd");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _regionLangDisplayDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, international), {
                language: language,
                onClick: onShowOptions
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                action: (0, _configuration.API_SEARCH),
                method: "POST",
                id: "search_form",
                onSubmit: onSubmit,
                onReset: onResetter,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group form__input_button_group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "q",
                                children: "Enter Search Keywords"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "search",
                                    className: "bigSearchInputBox",
                                    name: "q",
                                    id: "q",
                                    defaultValue: criteria.q,
                                    onChange: onChange
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "search__form__shelf",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Search in Group",
                                options: groups,
                                onChange: onChange,
                                id: "searchGroup",
                                value: criteria.searchGroup
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchInChannelsDefault.default), {
                                onShowChannels: onShowChannels
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Order By",
                                options: (0, _searchConfiguration.ORDER_BY),
                                onChange: onChange,
                                id: "order",
                                value: order || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDateRangeDefault.default), {
                                onChange: onChange,
                                afterDate: rangeStart,
                                beforeDate: rangeEnd
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Topic ID",
                                options: (0, _searchConfiguration.TOPIC_ID),
                                onChange: onChange,
                                id: "topicId",
                                value: topicId || ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "search__form__chancount",
                        children: [
                            "Searching in ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: channelpicks.length
                            }),
                            " channels"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "search__form__shelf show__more",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchMoreOptionsDefault.default), {
                            open: advancedOpen,
                            onClick: onToggleOptions
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: advanced,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Category Search",
                                options: (0, _searchConfiguration.VIDEO_CAT),
                                onChange: onChange,
                                id: "videoCategoryId",
                                value: videoCategoryId || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Video Definition",
                                options: (0, _searchConfiguration.VIDEO_DEF),
                                onChange: onChange,
                                id: "videoDefinition",
                                value: videoDefinition || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Video Dimensions",
                                options: (0, _searchConfiguration.VIDEO_DIM),
                                onChange: onChange,
                                id: "videoDimension",
                                value: videoDimension || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Video Duration",
                                options: (0, _searchConfiguration.VIDEO_DUR),
                                onChange: onChange,
                                id: "videoDuration",
                                value: videoDuration || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Video Type",
                                options: (0, _searchConfiguration.VIDEO_TYPE),
                                onChange: onChange,
                                id: "videoType",
                                value: videoType || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Video Embeddable",
                                options: (0, _searchConfiguration.VIDEO_EMBEDDABLE),
                                onChange: onChange,
                                id: "videoEmbeddable",
                                value: videoEmbeddable || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Video License",
                                options: (0, _searchConfiguration.VIDEO_LIC),
                                onChange: onChange,
                                id: "videoLicense",
                                value: videoLicense || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Live Event Type",
                                options: (0, _searchConfiguration.EVENT_TYPE),
                                onChange: onChange,
                                id: "eventType",
                                value: eventType || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Regions",
                                options: regions,
                                onChange: onChange,
                                id: "regionCode",
                                value: regionCode
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Language",
                                options: languages,
                                onChange: onChange,
                                id: "relevanceLanguage",
                                value: relevanceLanguage
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDropDownDefault.default), {
                                label: "Safe Search",
                                options: (0, _searchConfiguration.SAFE_SEARCH),
                                onChange: onChange,
                                id: "safeSearch",
                                value: safeSearch || ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "search__form__shelf search__form__controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "reset",
                                className: "btn",
                                children: "Reset search"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                id: "search_btn",
                                className: "btn btn--action",
                                children: "Search"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelsListDefault.default), {
                modalRef: modalRef,
                onClose: onHideChannels,
                onSubmit: onChannelSearchSubmit
            })
        ]
    });
};
exports.default = SearchForm;

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","../ChannelsList":"cn7Fd","./SearchDropDown":"GEGKu","./SearchInChannels":"bhpWD","./SearchMoreOptions":"44RCO","./SearchDateRange":"jyxdN","../subcomponents/RegionLangDisplay":"3TObo","date-fns":"1h4Hj","./css/SearchForm.css":"36s2k","../../js/Configuration":"k3dur","../../js/SearchConfiguration":"9UCv3","../../js/Utilities":"euxcI","../../actions/SearchUtils":"hf48D","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"GEGKu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchDropDown", function() {
    return SearchDropDown;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _selectMenuCss = require("../../css/SelectMenu.css");
var SearchDropDown = function(param) {
    var value = param.value, _param_label = param.label, label = _param_label === void 0 ? "NEEDS A LABEL" : _param_label, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? "" : _param_onChange, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id, _param_options = param.options, options = _param_options === void 0 ? [] : _param_options, _param_note = param.note, note = _param_note === void 0 ? "" : _param_note, _param_defaultValue = param.defaultValue, defaultValue = _param_defaultValue === void 0 ? "" : _param_defaultValue;
    var makeMenuItems = function() {
        var arrayOfItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var menu;
        if (arrayOfItems.length) menu = arrayOfItems.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: item.value,
                children: item.label
            }, index.toString());
        });
        else menu = null;
        return menu;
    };
    var theNote = null;
    if (note) theNote = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: note
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "search__form__item ava-input-select",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                id: id,
                name: id,
                onChange: onChange,
                defaultValue: defaultValue,
                children: makeMenuItems(options)
            }),
            note
        ]
    });
};
SearchDropDown.propTypes = {
    label: (0, _propTypesDefault.default).string.isRequired,
    onChange: (0, _propTypesDefault.default).func.isRequired,
    id: (0, _propTypesDefault.default).string.isRequired,
    options: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string.isRequired,
        value: (0, _propTypesDefault.default).any
    })),
    note: (0, _propTypesDefault.default).string,
    defaultValue: (0, _propTypesDefault.default).string,
    value: (0, _propTypesDefault.default).any
};
exports.default = SearchDropDown;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../../css/SelectMenu.css":"cUBB3","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cUBB3":[function() {},{}],"bhpWD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _searchInChannelsCss = require("./css/SearchInChannels.css");
var SearchInChannels = function(param) {
    var onShowChannels = param.onShowChannels;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "search__form__item form-group search__inchannels",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                children: "Search in Channels:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn btn-sm btn--action",
                onClick: onShowChannels,
                children: "Show Channel List"
            })
        ]
    });
};
SearchInChannels.propTypes = {
    onShowChannels: (0, _propTypesDefault.default).func.isRequired
};
exports.default = SearchInChannels;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/SearchInChannels.css":"iyU4b","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iyU4b":[function() {},{}],"44RCO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var SearchMoreOptions = function(param) {
    var open = param.open, onClick = param.onClick;
    var txt = open ? "Hide advanced options" : "Show advanced options";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        onClick: onClick,
        type: "button",
        className: "trigger__fauxlink",
        children: txt
    });
};
SearchMoreOptions.propTypes = {
    open: (0, _propTypesDefault.default).bool,
    onClick: (0, _propTypesDefault.default).func.isRequired
};
exports.default = SearchMoreOptions;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jyxdN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _dateInput = require("../subcomponents/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
var _searchDateRangeCss = require("./css/SearchDateRange.css");
var SearchDateInput = function(param) {
    var onChange = param.onChange, afterDate = param.afterDate, beforeDate = param.beforeDate;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("fieldset", {
        className: "search__form__daterange",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                    children: "Published Between:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                            cssClass: "search__form__date__label",
                            name: "publishedAfter",
                            isRequired: false,
                            value: afterDate,
                            onChangeHandler: onChange
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "and"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                            cssClass: "search__form__date__label",
                            name: "publishedBefore",
                            isRequired: false,
                            labelText: "End of range",
                            value: beforeDate,
                            onChangeHandler: onChange
                        })
                    ]
                })
            ]
        })
    });
};
SearchDateInput.propTypes = {
    date: (0, _propTypesDefault.default).string
};
exports.default = SearchDateInput;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/DateInput":"90qRl","./css/SearchDateRange.css":"7bORP","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"90qRl":[function(require,module,exports) {
/**
 * DateInput.jsx
 * A no-framework date input 
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var DateInput = function(param) {
    var onChangeHandler = param.onChangeHandler, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? null : _param_cssClass, _param_id = param.id, id = _param_id === void 0 ? null : _param_id, _param_name = param.name, name = _param_name === void 0 ? null : _param_name, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "Add label text" : _param_labelText, _param_isRequired = param.isRequired, isRequired = _param_isRequired === void 0 ? true : _param_isRequired;
    var showOptionalMessage = function() {
        var msg = "";
        msg = isRequired ? "(Required)" : "(Optional)";
        return msg;
    };
    var cssClasses = (0, _classnamesDefault.default)("input-date destination-date", cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: labelText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "date",
                defaultValue: value,
                name: name,
                id: id,
                required: isRequired,
                onChange: onChangeHandler
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: showOptionalMessage()
            })
        ]
    });
};
DateInput.propTypes = {
    id: (0, _propTypesDefault.default).string,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    name: (0, _propTypesDefault.default).string.isRequired,
    onChange: (0, _propTypesDefault.default).func,
    cssClass: (0, _propTypesDefault.default).string,
    value: (0, _propTypesDefault.default).string,
    isRequired: (0, _propTypesDefault.default).bool,
    onChangeHandler: (0, _propTypesDefault.default).func
};
exports.default = DateInput;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7bORP":[function() {},{}],"3TObo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _regionLangDisplayCss = require("./css/RegionLangDisplay.css");
var RegionLangDisplay = function(param) {
    var name = param.name, flag = param.flag, language = param.language, onClick = param.onClick;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "RegionLangDisplay",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                children: "Region:\xa0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                children: flag.flag
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                children: "Language:\xa0\xa0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                children: language.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "btn__link",
                onClick: onClick,
                children: "Change"
            })
        ]
    });
};
exports.default = RegionLangDisplay;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./css/RegionLangDisplay.css":"dltB5","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dltB5":[function() {},{}],"36s2k":[function() {},{}],"9UCv3":[function(require,module,exports) {
/*
Search Field Options used on SearchPage.js

*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ORDER_BY", function() {
    return ORDER_BY;
});
parcelHelpers.export(exports, "TOPIC_ID", function() {
    return TOPIC_ID;
});
parcelHelpers.export(exports, "VIDEO_CAT", function() {
    return VIDEO_CAT;
});
parcelHelpers.export(exports, "EVENT_TYPE", function() {
    return EVENT_TYPE;
});
parcelHelpers.export(exports, "VIDEO_DEF", function() {
    return VIDEO_DEF;
});
parcelHelpers.export(exports, "VIDEO_DIM", function() {
    return VIDEO_DIM;
});
parcelHelpers.export(exports, "VIDEO_DUR", function() {
    return VIDEO_DUR;
});
parcelHelpers.export(exports, "VIDEO_TYPE", function() {
    return VIDEO_TYPE;
});
parcelHelpers.export(exports, "ANY_TRUE", function() {
    return ANY_TRUE;
});
parcelHelpers.export(exports, "VIDEO_EMBEDDABLE", function() {
    return VIDEO_EMBEDDABLE;
});
parcelHelpers.export(exports, "SAFE_SEARCH", function() {
    return SAFE_SEARCH;
});
parcelHelpers.export(exports, "VIDEO_LIC", function() {
    return VIDEO_LIC;
});
parcelHelpers.export(exports, "VIDEO_SYNDICATED", function() {
    return VIDEO_SYNDICATED;
});
var ORDER_BY = [
    {
        value: "",
        label: "Choose one"
    },
    {
        value: "date",
        label: "Date"
    },
    {
        value: "rating",
        label: "Rating"
    },
    {
        value: "relevance",
        label: "Relevance"
    },
    {
        value: "title",
        label: "Title"
    },
    {
        value: "viewCount",
        label: "View Count"
    }
];
var TOPIC_ID = [
    {
        value: "",
        label: "Choose one"
    },
    {
        value: "/m/025zzc",
        label: "Action game"
    },
    {
        value: "/m/02ntfj",
        label: "Action-adventure game"
    },
    {
        value: "/m/0jm_",
        label: "American football"
    },
    {
        value: "/m/095bb",
        label: "Animated cartoon"
    },
    {
        value: "/m/018jz",
        label: "Baseball"
    },
    {
        value: "/m/018w8",
        label: "Basketball"
    },
    {
        value: "/m/01cgz",
        label: "Boxing"
    },
    {
        value: "/m/0b1vjn",
        label: "Casual game"
    },
    {
        value: "/m/05fw6t",
        label: "Children's music"
    },
    {
        value: "/m/02mscn",
        label: "Christian music"
    },
    {
        value: "/m/0ggq0m",
        label: "Classical music"
    },
    {
        value: "/m/01lyv",
        label: "Country music"
    },
    {
        value: "/m/09xp_",
        label: "Cricket"
    },
    {
        value: "/m/02lkt",
        label: "Electronic music"
    },
    {
        value: "/m/02jjt",
        label: "Entertainment"
    },
    {
        value: "/m/032tl",
        label: "Fashion"
    },
    {
        value: "/m/027x7n",
        label: "Fitness"
    },
    {
        value: "/m/02wbm",
        label: "Food"
    },
    {
        value: "/m/02vx4",
        label: "Football"
    },
    {
        value: "/m/0bzvm2",
        label: "Gaming"
    },
    {
        value: "/m/037hz",
        label: "Golf"
    },
    {
        value: "/m/0glt670",
        label: "Hip hop music"
    },
    {
        value: "/m/03glg",
        label: "Hobby"
    },
    {
        value: "/m/09kqc",
        label: "Humor"
    },
    {
        value: "/m/03tmr",
        label: "Ice hockey"
    },
    {
        value: "/m/05rwpb",
        label: "Independent music"
    },
    {
        value: "/m/03_d0",
        label: "Jazz music"
    },
    {
        value: "/m/01k8wb",
        label: "Knowledge"
    },
    {
        value: "/m/019_rr",
        label: "Lifestyle"
    },
    {
        value: "/m/01h7lh",
        label: "Mixed martial arts"
    },
    {
        value: "/m/0410tth",
        label: "Motorsport"
    },
    {
        value: "/m/02vxn",
        label: "Movies"
    },
    {
        value: "/m/04rlf",
        label: "Music"
    },
    {
        value: "/m/028sqc",
        label: "Music of Asia"
    },
    {
        value: "/m/0g293",
        label: "Music of Latin America"
    },
    {
        value: "/m/02hygl",
        label: "Music video game"
    },
    {
        value: "/m/05qjc",
        label: "Performing arts"
    },
    {
        value: "/m/068hy",
        label: "Pets"
    },
    {
        value: "/m/041xxh",
        label: "Physical attractiveness (Beauty)"
    },
    {
        value: "/m/064t9",
        label: "Pop music"
    },
    {
        value: "/m/066wd",
        label: "Professional wrestling"
    },
    {
        value: "/m/04q1x3q",
        label: "Puzzle video game"
    },
    {
        value: "/m/01sjng",
        label: "Racing video game"
    },
    {
        value: "/m/06cqb",
        label: "Reggae music"
    },
    {
        value: "/m/06j6l",
        label: "Rhythm and blues music"
    },
    {
        value: "/m/06by7",
        label: "Rock music"
    },
    {
        value: "/m/0403l3g",
        label: "Role-playing video game"
    },
    {
        value: "/m/021bp2",
        label: "Simulation video game"
    },
    {
        value: "/m/098wr",
        label: "Society"
    },
    {
        value: "/m/0gywn",
        label: "Soul music"
    },
    {
        value: "/m/06ntj",
        label: "Sports"
    },
    {
        value: "/m/022dc6",
        label: "Sports game"
    },
    {
        value: "/m/03hf_rm",
        label: "Strategy video game"
    },
    {
        value: "/m/07c1v",
        label: "Technology"
    },
    {
        value: "/m/07bs0",
        label: "Tennis"
    },
    {
        value: "/m/07bxq",
        label: "Tourism"
    },
    {
        value: "/m/0f2f9",
        label: "TV shows"
    },
    {
        value: "/m/07yv9",
        label: "Vehicles"
    },
    {
        value: "/m/07_53",
        label: "Volleyball"
    }
];
var VIDEO_CAT = [
    {
        value: "",
        label: "Choose one"
    },
    {
        value: "1",
        label: "Film & Animation"
    },
    {
        value: "2",
        label: "Autos & Vehicles"
    },
    {
        value: "10",
        label: "Music"
    },
    {
        value: "15",
        label: "Pets & Animals"
    },
    {
        value: "17",
        label: "Sports"
    },
    {
        value: "19",
        label: "Travel & Events"
    },
    {
        value: "20",
        label: "Gaming"
    },
    {
        value: "22",
        label: "People & Blogs"
    },
    {
        value: "23",
        label: "Comedy"
    },
    {
        value: "24",
        label: "Entertainment"
    },
    {
        value: "25",
        label: "News & Politics"
    },
    {
        value: "26",
        label: "How to & Style"
    },
    {
        value: "27",
        label: "Education"
    },
    {
        value: "28",
        label: "Science & Technology"
    },
    {
        value: "29",
        label: "Nonprofits & Activism"
    }
];
var EVENT_TYPE = [
    {
        value: "",
        label: "Choose one"
    },
    {
        value: "completed",
        label: "Completed"
    },
    {
        value: "live",
        label: "Live"
    },
    {
        value: "upcoming",
        label: "Upcoming"
    }
];
var VIDEO_DEF = [
    {
        value: "any",
        label: "Any"
    },
    {
        value: "standard",
        label: "SD"
    },
    {
        value: "high",
        label: "HD"
    }
];
var VIDEO_DIM = [
    {
        value: "any",
        label: "Any"
    },
    {
        value: "2d",
        label: "2D"
    },
    {
        value: "3d",
        label: "3D"
    }
];
var VIDEO_DUR = [
    {
        value: "any",
        label: "Any"
    },
    {
        value: "short",
        label: "Short ( 0min - 4min )"
    },
    {
        value: "medium",
        label: "Medium ( 4min - 20min )"
    },
    {
        value: "long",
        label: "Long( 20min+ )"
    }
];
var VIDEO_TYPE = [
    {
        value: "any",
        label: "Any"
    },
    {
        value: "episode",
        label: "Episode"
    },
    {
        value: "movie",
        label: "Movie"
    }
];
var ANY_TRUE = [
    {
        value: "any",
        label: "Any"
    },
    {
        value: "true",
        label: "True"
    }
];
var VIDEO_EMBEDDABLE = [
    {
        value: "any",
        label: "All videos"
    },
    {
        value: "true",
        label: "Embeddable only"
    }
];
var SAFE_SEARCH = [
    {
        value: "none",
        label: "None"
    },
    {
        value: "moderate",
        label: "Moderate"
    },
    {
        value: "strict",
        label: "Strict"
    }
];
var VIDEO_LIC = [
    {
        value: "any",
        label: "Any"
    },
    {
        value: "creativeCommon",
        label: "Creative Common"
    },
    {
        value: "youtube",
        label: "YouTube"
    }
];
var VIDEO_SYNDICATED = [
    {
        value: "any",
        label: "All"
    },
    {
        value: "true",
        label: "Syndicated only"
    }
] // Moved REGIONS and LANGUAGES constants to the API codebase.
;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2VQdt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _nextPrevious = require("./NextPrevious");
var _nextPreviousDefault = parcelHelpers.interopDefault(_nextPrevious);
var _searchResultItem = require("./SearchResultItem");
var _searchResultItemDefault = parcelHelpers.interopDefault(_searchResultItem);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _searchResultsPanelCss = require("./css/SearchResultsPanel.css");
var _configuration = require("../../js/Configuration");
var SearchResultsPanel = function(props) {
    var channel_ytid = props.channel_ytid, channel_title = props.channel_title, results = props.results, onPlayVideo = props.onPlayVideo, onRequestPage = props.onRequestPage, loading = props.loading, _props_next_page = props.next_page, next_page = _props_next_page === void 0 ? null : _props_next_page, _props_prev_page = props.prev_page, prev_page = _props_prev_page === void 0 ? null : _props_prev_page;
    var makeResultItems = function() {
        if (results.length) videos = results.map(function(r) {
            var video_yt_id = r.video_yt_id;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultItemDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                id: video_yt_id
            }, r), {
                onPlay: onPlayVideo
            }), (0, _lodashUniqueidDefault.default)(video_yt_id));
        });
        else videos = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
            style: {
                fontStyle: "italic",
                fontWeight: 400
            },
            children: "No results in this channel."
        });
        return videos;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
        className: "search__results__panel",
        id: channel_ytid,
        open: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: channel_title || "All Channels"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextPreviousDefault.default), {
                next: onRequestPage,
                prev: onRequestPage,
                nextpage: next_page,
                prevpage: prev_page,
                className: "search__channel__pagination",
                form: "search_form",
                channel: channel_ytid
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "video__display video__display--grid search__results__results",
                children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                    open: true
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "List",
                    children: makeResultItems()
                })
            })
        ]
    });
};
exports.default = SearchResultsPanel;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","lodash.uniqueid":"6bf5k","./NextPrevious":"2aqoJ","./SearchResultItem":"7Q00K","../subcomponents/LoaderSimple":"1dSHa","./css/SearchResultsPanel.css":"bNnX2","../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2aqoJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _nextPreviousCss = require("./css/NextPrevious.css");
var NextPrevious = function(param) {
    var className = param.className, next = param.next, prev = param.prev, _param_prevpage = param.prevpage, prevpage = _param_prevpage === void 0 ? null : _param_prevpage, _param_nextpage = param.nextpage, nextpage = _param_nextpage === void 0 ? null : _param_nextpage, per_page = param.per_page, result_count = param.result_count, form = param.form, _param_channel = param.channel, channel = _param_channel === void 0 ? "All Channels" : _param_channel;
    var cssClass = (0, _classnamesDefault.default)(className, {
        "pagination__component": true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !prevpage,
                type: "button",
                className: "pagination__btn btn btn-light pagination__previous",
                onClick: prev,
                form: form,
                "data-page": prevpage,
                "data-channel": channel,
                children: "Previous"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: result_count < per_page || !nextpage,
                type: "button",
                className: "pagination__btn btn btn-light pagination__next",
                onClick: next,
                form: form,
                "data-page": nextpage,
                "data-channel": channel,
                children: "Next"
            })
        ]
    });
};
exports.default = NextPrevious;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","./css/NextPrevious.css":"8KwIL","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8KwIL":[function() {},{}],"7Q00K":[function(require,module,exports) {
/**
 * SearchResultItem.js
 * An item in the search page results.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _dateFns = require("date-fns");
var _logo1021 = require("../subcomponents/Logo1021");
var _logo1021Default = parcelHelpers.interopDefault(_logo1021);
var _ytplayIcon = require("../subcomponents/YTPlayIcon");
var _ytplayIconDefault = parcelHelpers.interopDefault(_ytplayIcon);
var _searchResultItemCss = require("./css/SearchResultItem.css");
var _utilities = require("../../js/Utilities");
var _searchUtils = require("../../actions/SearchUtils");
var SearchResultItem = function(props) {
    var id = props.id, video_title = props.video_title, video_channel_title = props.video_channel_title, video_thumb = props.video_thumb, video_alreadyprocessed = props.video_alreadyprocessed, onPlay = props.onPlay, video_viewcount = props.video_viewcount, video_publishdate = props.video_publishdate, video_duration = props.video_duration, video_likecount = props.video_likecount, video_dislikecount = props.video_dislikecount;
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(video_alreadyprocessed), 2), inSystem = _React_useState[0], setInSystem = _React_useState[1];
    var onAdd = function(domEvent) {
        var target = domEvent.target;
        var videoid = target.dataset.videoid;
        (0, _searchUtils.addVideo)(videoid, function(response) {
            var success = response.success;
            if (success) setInSystem(true);
        });
    };
    /*
  * Displays 'Add Video To System' if it's not already there, or
  * 'Video Added to System' if it is
  */ var makeInSystemIndicator = function() {
        var status;
        var id = props.id, video_alreadyprocessed = props.video_alreadyprocessed;
        if (inSystem === true) status = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "result__item__is-in-system",
            children: "Video Added to System"
        });
        else status = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: "result__item__add_to_system btn",
            "data-videoid": id,
            onClick: onAdd,
            children: "Add to System"
        });
        return status;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "results__list__item",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "searchListItem",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "show__video__title results__list__item__title",
                    onClick: onPlay.bind(null, props),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        className: "videoResultItemHeader divTransition",
                        children: video_title
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    type: "button",
                    className: "show__video__trigger videoThumb",
                    onClick: onPlay.bind(null, props),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: video_thumb,
                            alt: "Watch ".concat(video_title)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ytplayIconDefault.default), {})
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "centerTxt",
                    children: makeInSystemIndicator()
                }),
                video_alreadyprocessed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logo1021Default.default), {
                    className: "video__in__system__icon"
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "listText",
                                    children: "Channel Title:"
                                }),
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "itemsBadge",
                                    children: (0, _utilities.truncateString)(video_channel_title, 25)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "listText",
                                    children: "Views:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "itemsBadge",
                                    children: (0, _utilities.numberFormat)(video_viewcount)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "listText",
                                    children: "Video Date:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "itemsBadge",
                                    children: (0, _dateFns.format)(video_publishdate * 1000, "PP")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "listText",
                                    children: "Duration:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "itemsBadge",
                                    children: (0, _utilities.formatTime)(video_duration)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "listText",
                                    children: "Likes:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "itemsBadge",
                                    children: (0, _utilities.numberFormat)(video_likecount)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "listText",
                                    children: "Dislikes:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "itemsBadge",
                                    children: (0, _utilities.numberFormat)(video_dislikecount)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = SearchResultItem;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","date-fns":"1h4Hj","../subcomponents/Logo1021":"1OCHu","../subcomponents/YTPlayIcon":"5wQr0","./css/SearchResultItem.css":"8wVJi","../../js/Utilities":"euxcI","../../actions/SearchUtils":"hf48D","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1OCHu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var Logo1021 = function(props) {
    var className = props.className, _props_width = props.width, width = _props_width === void 0 ? 257 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 155 : _props_height;
    var cssClass = (0, _classnamesDefault.default)("logo__1021", className);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        focusable: "false",
        width: width,
        height: height,
        viewBox: "0 0 257 155",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: cssClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "1021 Creative"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                    id: "path-1",
                    points: "0.303 0.741 117.826 0.741 117.826 132.94 0.303 132.94"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(37.000000, 22.000000)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M46.198,86.002 C46.219,85.566 46.195,85.136 46.101,84.714 C45.769,82.485 45.933,80.84 46.56,80.076 C46.69,79.918 47.086,79.437 48.372,79.384 C48.372,79.384 48.373,79.384 48.374,79.384 C48.83,79.384 49.38,79.473 49.719,79.899 C50.005,80.256 50.082,80.794 49.941,81.416 C49.786,82.182 49.535,82.658 49.091,83.062 L46.198,86.002 Z M3.059,121.288 L29.196,87.885 C30.519,91.831 33.503,94.31 37.246,94.31 C37.52,94.31 37.794,94.296 38.067,94.269 L27.984,104.52 C27.49,105.013 27.035,105.616 26.643,106.303 C25.137,108.795 24.82,111.436 25.771,113.699 C26.667,115.836 28.568,117.347 31.126,117.953 C31.887,118.124 32.73,118.215 33.522,118.215 L59.481,118.215 C63.861,118.215 67.092,115.57 68.146,111.134 C68.318,110.651 68.417,110.11 68.43,109.586 L69.127,103.274 C69.339,101.177 68.715,99.209 67.368,97.719 C65.921,96.116 63.797,95.232 61.388,95.232 C61.214,95.232 61.038,95.237 60.859,95.246 C60.305,95.246 59.738,95.312 59.159,95.441 L62.523,91.805 C62.801,91.529 63.126,91.198 63.453,90.791 C66.195,87.534 67.553,85.009 68.116,82.109 C69.133,77.247 68.079,72.565 65.142,68.95 C61.815,64.856 56.49,62.602 50.145,62.602 C49.53,62.61 49.241,62.621 48.954,62.637 L95.194,3.543 C108.614,17.649 115.978,36.046 115.978,55.587 C115.978,72.691 110.139,89.335 99.497,102.678 C98.672,102.1 97.724,101.691 96.679,101.474 L99.73,72.497 C99.73,72.256 99.716,72.079 99.747,71.928 L99.8,71.518 C99.843,68.954 99.281,67.167 98.029,65.892 C96.672,64.513 94.591,63.87 91.481,63.87 L83.46,63.87 C79.816,63.87 76.531,65.687 74.886,68.611 C73.589,70.98 73.392,73.645 74.336,75.937 C75.169,77.965 76.817,79.474 78.854,80.08 C79.613,80.298 80.374,80.445 81.13,80.52 L78.893,101.509 C74.856,102.324 71.838,105.503 71.421,109.492 C71.161,111.812 71.834,114.014 73.321,115.679 C74.781,117.314 76.834,118.215 79.099,118.215 L82.683,118.215 C70.187,126.697 55.685,131.152 40.413,131.152 C27.271,131.152 14.401,127.749 3.059,121.288 Z",
                                id: "Fill-1",
                                fill: "#E2642C",
                                mask: "url(#mask-2)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M95.041,0.741 L44.668,65.115 C46.292,64.721 48.019,64.49 49.842,64.452 C49.942,64.45 50.044,64.45 50.145,64.45 C61.637,64.449 68.256,72.411 66.302,81.757 C65.811,84.289 64.616,86.542 62.011,89.636 C61.73,89.987 61.449,90.269 61.167,90.55 L49,103.705 L54.134,103.705 L54.204,102.509 C54.344,100.608 55.751,98.709 58.284,97.655 C59.127,97.303 60.042,97.093 60.956,97.093 C61.102,97.085 61.246,97.081 61.388,97.081 C65.157,97.081 67.627,99.749 67.288,103.072 L66.584,109.473 C66.584,109.823 66.514,110.247 66.373,110.599 C65.529,114.325 62.927,116.366 59.481,116.366 L33.522,116.366 C32.889,116.366 32.186,116.296 31.551,116.154 C27.402,115.171 25.784,111.302 28.246,107.221 C28.527,106.729 28.88,106.236 29.301,105.815 L50.334,84.43 C51.109,83.726 51.53,82.883 51.742,81.826 C52.295,79.41 50.812,77.535 48.427,77.535 C48.383,77.535 48.338,77.536 48.294,77.537 C44.987,77.677 43.512,80 44.285,85.064 C44.425,85.626 44.355,86.329 44.144,87.314 C43.652,89.354 42.244,90.973 39.995,91.887 C39.064,92.272 38.136,92.462 37.246,92.462 C33.753,92.462 30.805,89.57 30.356,84.358 C30.33,84.064 30.322,83.761 30.313,83.457 L0.303,121.812 C12.001,128.911 25.729,133 40.413,133 C58.513,133 75.146,126.773 88.329,116.366 L79.099,116.366 C75.513,116.366 72.839,113.411 73.26,109.684 C73.612,106.308 76.286,103.633 79.944,103.211 L80.576,103.142 L83.179,78.731 L82.336,78.731 C81.351,78.731 80.367,78.592 79.381,78.311 C76.075,77.325 74.457,73.244 76.497,69.518 C77.763,67.266 80.367,65.718 83.46,65.718 L91.481,65.718 C96.334,65.718 98.023,67.338 97.952,71.486 C97.881,71.768 97.881,72.119 97.881,72.401 L94.646,103.142 L95.138,103.142 C97.107,103.217 98.686,104.064 99.66,105.396 C110.99,91.933 117.826,74.562 117.826,55.587 C117.826,34.154 109.114,14.758 95.041,0.741 Z M28.814,91.371 C30.047,93.345 31.802,94.917 34.094,95.67 L26.688,103.201 C26.078,103.813 25.529,104.534 25.061,105.348 C23.24,108.386 22.886,111.604 24.066,114.414 C25.181,117.07 27.599,119.015 30.745,119.761 C31.625,119.958 32.585,120.062 33.522,120.062 L59.481,120.062 C64.408,120.062 68.247,117.163 69.709,112.422 C70.039,114.091 70.795,115.625 71.942,116.91 C73.2,118.318 74.864,119.305 76.699,119.766 C65.693,126.034 53.336,129.305 40.413,129.305 C28.312,129.305 16.449,126.346 5.853,120.715 L28.814,91.371 Z M48.079,81.27 C48.007,81.541 47.929,81.62 47.858,81.686 C47.896,81.484 47.941,81.361 47.968,81.296 C47.995,81.288 48.031,81.278 48.079,81.27 Z M95.312,6.392 C107.478,19.932 114.13,37.244 114.13,55.587 C114.13,71.754 108.784,87.497 99.008,100.301 C98.899,100.252 98.789,100.206 98.676,100.16 L101.555,72.788 L101.578,72.595 L101.578,72.401 C101.578,72.347 101.577,72.287 101.578,72.228 L101.64,71.977 L101.647,71.549 C101.7,68.499 100.948,66.225 99.347,64.598 C97.078,62.289 93.772,62.021 91.481,62.021 L83.46,62.021 C79.149,62.021 75.247,64.2 73.255,67.742 C71.699,70.585 71.47,73.829 72.627,76.641 C73.674,79.187 75.752,81.085 78.366,81.863 C78.612,81.934 78.859,81.998 79.108,82.054 L77.19,100.047 C74.363,100.97 72.066,102.911 70.747,105.424 L70.965,103.446 C71.231,100.837 70.441,98.362 68.74,96.48 C67.363,94.956 65.516,93.955 63.411,93.566 L63.831,93.112 C64.129,92.814 64.49,92.45 64.865,91.984 C67.836,88.447 69.305,85.686 69.92,82.515 C71.058,77.069 69.87,71.838 66.575,67.783 C63.351,63.816 58.481,61.409 52.682,60.869 L95.312,6.392 Z",
                                id: "Fill-3",
                                fill: "#1A1919",
                                mask: "url(#mask-2)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M60.213,62.502 C59.522,62.502 58.999,62.291 58.612,61.856 C57.961,61.122 57.71,59.791 57.908,58.106 L59.323,44.573 C59.718,41.011 61.015,40.369 62.2,40.049 L62.348,40.002 C62.59,39.914 62.831,39.875 63.126,39.875 C63.27,39.875 63.414,39.884 63.555,39.896 C64.574,40.072 66.042,40.404 65.594,44.164 L64.182,57.698 C63.881,60.609 62.771,62.205 60.884,62.441 C60.609,62.483 60.408,62.502 60.213,62.502",
                        id: "Fill-5",
                        fill: "#96C3DD"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M63.126,38.027 C62.673,38.027 62.209,38.087 61.718,38.266 C59.231,38.937 57.887,40.753 57.486,44.382 L56.072,57.891 C55.587,62.029 57.416,64.35 60.213,64.35 C60.503,64.35 60.804,64.324 61.113,64.273 C63.8,63.938 65.616,61.789 66.019,57.891 L67.43,44.382 C67.901,40.416 66.557,38.534 63.8,38.065 C63.577,38.041 63.353,38.027 63.126,38.027 Z M63.126,41.723 C63.182,41.723 63.24,41.725 63.297,41.73 C63.525,41.776 63.646,41.83 63.663,41.83 C63.665,41.83 63.665,41.829 63.665,41.829 C63.667,41.832 63.954,42.324 63.754,43.998 L62.344,57.509 C62.142,59.449 61.574,60.492 60.656,60.607 L60.586,60.615 L60.519,60.626 C60.408,60.644 60.303,60.654 60.213,60.654 C60.07,60.654 60.003,60.631 59.997,60.631 C59.896,60.537 59.561,59.878 59.749,58.274 L61.158,44.789 C61.449,42.167 62.133,41.981 62.683,41.832 L62.832,41.792 L62.978,41.739 C62.997,41.732 63.024,41.723 63.126,41.723 Z",
                        id: "Fill-6",
                        fill: "#1A1919"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: "Group-10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M22.897,129.899 C9.306,115.76 1.849,97.265 1.849,77.587 C1.849,63.762 5.585,50.352 12.683,38.598 C13.526,39.622 14.651,40.386 15.962,40.776 C16.665,40.976 17.37,41.115 18.068,41.189 L15.945,61.1 C12.084,61.902 9.201,64.957 8.802,68.787 C8.548,71.024 9.198,73.152 10.633,74.759 C12.046,76.341 14.028,77.21 16.218,77.21 L29.794,77.21 C31.025,77.21 32.213,76.949 33.324,76.436 C36.146,75.274 38.201,72.521 38.615,69.28 C38.945,67.103 38.419,65.019 37.124,63.456 C36.12,62.241 34.724,61.42 33.104,61.069 L36.01,33.457 L36.01,33.36 C36.01,33.226 35.999,33.061 36.026,32.919 L36.053,32.769 L36.076,32.517 C36.103,30.96 35.954,28.705 34.361,27.084 C33.048,25.749 31.042,25.127 28.047,25.127 L23.055,25.127 C37.276,10.391 56.848,2.022 77.413,2.022 C90.683,2.022 103.663,5.493 115.092,12.081 L81.668,54.794 L82.843,43.772 C83.021,42.005 83.042,40.648 82.912,39.358 C82.41,30.737 74.286,23.925 64.421,23.925 C62.373,23.925 60.299,24.217 58.257,24.793 C56.713,25.178 55.273,25.812 54.074,26.38 C47.006,30.021 43.165,35.568 42.276,43.365 L40.527,58.484 C40.377,59.762 40.377,61.058 40.528,62.337 C41.509,71.711 49.269,78.532 58.98,78.532 C60.48,78.532 61.98,78.37 63.469,78.05 L22.897,129.899",
                                id: "Fill-7",
                                fill: "#96C3DD"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M77.413,0.175 C53.931,0.175 32.906,10.645 18.709,27.155 C19.248,27.047 19.804,26.975 20.386,26.975 L28.047,26.975 C32.684,26.975 34.296,28.521 34.23,32.485 C34.161,32.754 34.161,33.092 34.161,33.36 L31.07,62.729 L31.541,62.729 C35.035,62.862 37.321,65.484 36.784,69.045 C36.447,71.666 34.834,73.817 32.549,74.758 C31.676,75.162 30.736,75.363 29.794,75.363 L16.218,75.363 C12.791,75.363 10.236,72.54 10.641,68.978 C10.977,65.753 13.531,63.198 17.024,62.796 L17.63,62.729 L20.116,39.408 L19.311,39.408 C18.369,39.408 17.428,39.273 16.487,39.005 C14.564,38.433 13.245,36.761 12.944,34.74 C4.772,47.01 0,61.74 0,77.587 C0,99.155 8.828,118.656 23.058,132.691 L68.957,74.036 C68.847,74.095 68.752,74.164 68.64,74.222 C65.355,75.917 62.066,76.683 58.98,76.683 C50.319,76.683 43.255,70.645 42.362,62.123 C42.229,60.981 42.229,59.839 42.362,58.696 L44.111,43.576 C44.918,36.518 48.344,31.411 54.863,28.051 C56.14,27.447 57.417,26.908 58.76,26.572 C60.692,26.027 62.594,25.773 64.421,25.773 C73.405,25.773 80.627,31.891 81.073,39.543 C81.208,40.886 81.14,42.231 81.005,43.576 L79.394,58.696 C79.311,59.555 79.182,60.384 79.01,61.189 L117.841,11.566 C106.074,4.345 92.232,0.175 77.413,0.175 Z M13.145,41.474 C13.849,41.94 14.631,42.309 15.475,42.559 C15.665,42.614 15.856,42.664 16.048,42.71 L14.24,59.65 C10.273,60.983 7.402,64.4 6.968,68.561 C6.653,71.347 7.464,73.985 9.254,75.991 C10.997,77.941 13.535,79.059 16.218,79.059 L29.794,79.059 C31.269,79.059 32.693,78.752 34.031,78.144 C37.484,76.69 39.936,73.409 40.443,69.556 C40.469,69.386 40.489,69.217 40.506,69.048 C43.743,75.88 50.72,80.379 58.98,80.379 C59.088,80.379 59.194,80.379 59.301,80.378 L22.773,127.06 C10.44,113.478 3.696,96.068 3.696,77.587 C3.696,64.847 6.948,52.469 13.145,41.474 Z M77.413,3.871 C89.641,3.871 101.619,6.893 112.305,12.643 L84.189,48.572 L84.683,43.944 C84.868,42.096 84.892,40.643 84.758,39.25 C84.15,29.614 75.234,22.077 64.421,22.077 C62.22,22.077 59.996,22.388 57.809,23.001 C56.078,23.439 54.55,24.109 53.282,24.709 L53.226,24.736 L53.171,24.765 C45.675,28.628 41.392,34.816 40.44,43.151 L38.692,58.267 C38.529,59.667 38.525,61.085 38.68,62.441 C38.637,62.385 38.592,62.331 38.548,62.277 C37.624,61.161 36.449,60.308 35.1,59.757 L37.838,33.747 L37.857,33.554 L37.857,33.36 C37.857,33.314 37.856,33.262 37.857,33.211 L37.917,32.971 L37.924,32.547 C37.975,29.587 37.241,27.377 35.679,25.788 C33.468,23.539 30.264,23.279 28.047,23.279 L27.597,23.279 C41.13,10.855 58.858,3.871 77.413,3.871 Z",
                                id: "Fill-9",
                                fill: "#1A1919"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: "creative",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M154.057,132.361 C154.183,131.887 154.214,131.476 154.214,131.065 C154.214,129.106 153.077,126.735 147.356,126.735 C143.557,126.735 140.912,128.25 139.341,130.041 C138.169,131.379 137.593,132.869 137.593,134.004 C137.593,134.554 137.67,135.045 137.805,135.484 C138.785,138.658 142.925,139.123 144.923,139.123 C149.474,139.123 152.286,136.405 153.489,133.847 L147.706,133.847 C147.706,133.847 147.61,134.321 147.484,134.636 C146.82,136.374 145.018,136.312 145.018,136.312 C143.597,136.247 143.344,135.268 143.407,134.51 C143.407,134.51 143.503,134.035 144.007,132.171 C144.704,129.484 146.757,129.549 146.757,129.549 C148.115,129.611 148.463,130.307 148.431,131.001 C148.431,131.255 148.304,131.792 148.146,132.361 L154.057,132.361",
                                id: "Fill-11",
                                fill: "#1A1919"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M154.214,126.989 L157.44,129.138 L154.057,138.808 L159.65,138.808 L161.989,132.044 C162.211,131.413 163.696,130.053 164.643,130.053 C164.643,130.053 165.717,130.053 164.643,132.361 L168.973,132.361 C169.731,130.527 171.216,126.925 168.182,126.925 C166.319,126.925 164.232,127.843 163.285,128.475 L163.631,126.989 L154.214,126.989",
                                id: "Fill-12",
                                fill: "#1A1919"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M181.291,132.203 L177.246,132.203 C177.783,129.454 179.868,129.454 179.868,129.454 C179.868,129.454 182.649,129.454 181.291,132.203 Z M180.247,126.704 C173.612,126.704 170.482,131.317 170.482,133.972 C170.482,138.491 175.539,139.092 177.814,139.092 C177.814,139.092 183.691,139.092 186,134.51 L180.847,134.51 C180.247,136.28 178.446,136.28 178.446,136.28 C178.446,136.28 176.076,136.28 176.897,133.655 L186.473,133.655 C190.075,126.704 180.247,126.704 180.247,126.704 Z",
                                id: "Fill-13",
                                fill: "#1A1919"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M196.901,135.299 C196.648,135.521 195.479,136.09 194.563,136.09 C194.184,136.09 192.825,136.185 192.825,135.142 C192.825,135.142 192.825,133.688 197.313,133.751 C197.313,134.321 197.154,135.109 196.901,135.299 Z M197.628,126.989 C195.227,126.989 192.036,127.305 190.549,129.833 C190.424,130.053 190.044,130.749 189.886,131.128 L194.911,131.128 C195.321,129.454 197.09,129.454 197.09,129.454 C197.818,129.454 198.608,129.928 198.608,130.749 C198.608,132.076 197.09,132.013 196.586,132.108 C195.763,132.266 194.753,132.361 194.279,132.361 C190.456,132.361 187.421,132.835 187.421,135.963 C187.421,138.144 188.844,138.871 191.308,138.871 C193.836,138.871 195.574,137.891 195.985,137.637 L195.891,138.808 L201.168,138.808 C203.823,130.623 203.854,129.959 203.854,129.959 C203.854,126.641 198.735,126.989 197.628,126.989 Z",
                                id: "Fill-14",
                                fill: "#1A1919"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M208.184,138.808 L211.629,138.808 L212.387,136.437 C211.534,136.247 211.217,135.838 211.251,135.362 C211.312,134.73 213.272,129.169 213.272,129.169 L214.82,129.169 L215.578,126.989 L214.125,126.989 L215.8,122.091 L213.682,122.091 C213.555,122.091 212.703,123.006 211.786,123.606 C210.838,124.177 209.069,124.682 209.005,124.776 C208.943,124.966 208.531,126.262 208.311,126.989 L206.667,126.989 L205.94,129.169 L207.362,129.169 L205.182,136.058 C204.771,137.954 206.477,138.808 208.184,138.808",
                                id: "Fill-15",
                                fill: "#1A1919"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                id: "Fill-16",
                                fill: "#1A1919",
                                points: "220.854 138.808 225.057 126.989 215.99 126.989 218.421 128.79 214.851 138.839 220.854 138.808"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M223.163,121.27 C221.266,121.27 219.654,122.248 219.559,123.449 C219.433,124.618 220.886,125.598 222.783,125.598 C224.678,125.598 226.291,124.618 226.386,123.449 C226.479,122.248 225.057,121.27 223.163,121.27",
                                id: "Fill-17",
                                fill: "#1A1919"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                id: "Group-21",
                                transform: "translate(226.000000, 126.000000)",
                                fill: "#1A1919",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        id: "Fill-18",
                                        points: "6.675 12.808 15.492 0.989 9.644 0.989 6.36 5.413 5.852 0.989 0.545 0.989 1.427 12.808 6.675 12.808"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M23.449,3.454 C23.449,3.454 26.228,3.454 24.871,6.203 L20.826,6.203 C21.364,3.454 23.449,3.454 23.449,3.454 Z M21.394,13.092 C21.394,13.092 27.272,13.092 29.577,8.51 L24.429,8.51 C23.827,10.28 22.027,10.28 22.027,10.28 C22.027,10.28 19.657,10.28 20.478,7.655 L30.051,7.655 C33.656,0.704 23.827,0.704 23.827,0.704 C17.19,0.704 14.062,5.317 14.062,7.972 C14.062,12.491 19.12,13.092 21.394,13.092 Z",
                                        id: "Fill-20"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Logo1021.propTypes = {
    width: (0, _propTypesDefault.default).number,
    height: (0, _propTypesDefault.default).number
};
exports.default = Logo1021;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8wVJi":[function() {},{}],"bNnX2":[function() {},{}],"4lUZe":[function() {},{}],"50JzI":[function(require,module,exports) {
/**
 * Videos
 * Top-level component that displays the
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _videoModal = require("./subcomponents/Videos/VideoModal");
var _videoModalDefault = parcelHelpers.interopDefault(_videoModal);
var _filterComponent = require("./Videos/FilterComponent");
var _filterComponentDefault = parcelHelpers.interopDefault(_filterComponent);
var _nextPrevious = require("./Search/NextPrevious");
var _nextPreviousDefault = parcelHelpers.interopDefault(_nextPrevious);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _addVideosField = require("./Videos/AddVideosField");
var _addVideosFieldDefault = parcelHelpers.interopDefault(_addVideosField);
var _videoItem = require("./subcomponents/VideoItem");
var _videoItemDefault = parcelHelpers.interopDefault(_videoItem);
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var _videosPageCss = require("../css/videosPage.css");
var _videoDisplayCss = require("./Destinations/css/VideoDisplay.css");
var Videos = function(props) {
    var initFilterState = {
        searchValue: "",
        filterOn: "video_title",
        categories: [],
        hideCategories: true,
        category: "",
        showHint: false
    };
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), videoList = _React_useState[0], setVideoList = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)((0, _reactDefault.default).useState(true), 2), loading = _React_useState1[0], setLoading = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)((0, _reactDefault.default).useState(""), 2), videoToPlay = _React_useState2[0], setVideoToPlay = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)((0, _reactDefault.default).useState(1), 2), page = _React_useState3[0], setPage = _React_useState3[1];
    var _React_useState4 = (0, _slicedToArray._)((0, _reactDefault.default).useState((0, _configuration.VIDEOS_PER_PAGE)), 2), perPage = _React_useState4[0], setPerPage = _React_useState4[1];
    var _React_useState5 = (0, _slicedToArray._)((0, _reactDefault.default).useState(1), 2), pageCount = _React_useState5[0], setPageCount = _React_useState5[1];
    var _React_useState6 = (0, _slicedToArray._)((0, _reactDefault.default).useState(0), 2), numResults = _React_useState6[0], setNumResults = _React_useState6[1];
    var _React_useState7 = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), ratings = _React_useState7[0], setRatings = _React_useState7[1];
    var _React_useState8 = (0, _slicedToArray._)((0, _reactDefault.default).useState(""), 2), selectedRating = _React_useState8[0], setSelectedRating = _React_useState8[1];
    var _React_useState9 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        open: false,
        videoData: {},
        rating: "",
        selectedSet: {
            videosetid: "-1",
            videoblockid: "-1"
        },
        groups: []
    }), 2), videoinfo = _React_useState9[0], setVideoInfo = _React_useState9[1];
    var _React_useState10 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        categories: [],
        category: null,
        filterOn: "video_title",
        hideCategories: true,
        itemsName: "Videos",
        searchValue: "",
        showHint: false
    }), 2), filter = _React_useState10[0], setFilter = _React_useState10[1];
    var _React_useState11 = (0, _slicedToArray._)((0, _reactDefault.default).useState("video_setscount"), 2), sortBy = _React_useState11[0], setSortBy = _React_useState11[1];
    var _React_useState12 = (0, _slicedToArray._)((0, _reactDefault.default).useState(""), 2), ascending = _React_useState12[0], setAscending = _React_useState12[1];
    var fetchcancelqueue = new Map();
    var videoModalRef = (0, _reactDefault.default).useRef(null);
    var canAdmin = (0, _utilities.isAdmin)(props.project);
    (0, _reactDefault.default).useEffect(function() {
        if (!videoList.length) getPage();
        return function() {
            fetchcancelqueue.forEach(function(value, key) {
                value.abort();
            });
        };
    }, [
        videoList
    ]);
    var addVideoToSet = function(domEvent) {
        domEvent.preventDefault();
        domEvent.persist();
        var fd = new FormData();
        fd.set("videoid", videoinfo.videoData.video_ava_id);
        fd.set("ytid", videoinfo.videoData.video_yt_id);
        fd.set("setid", videoinfo.selectedSet.videosetid);
        fd.set("blockid", videoinfo.selectedSet.videoblockid);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        var ac = new AbortController();
        var signal = ac.signal;
        fetchcancelqueue["addVideoToSet"] = ac;
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDTOSET), {
            body: fd,
            signal: signal
        }, function(data) {
            // TODO: Should probably handle errors too.
            window.alert("Video added to set.");
        });
    };
    var getPage = function() {
        setLoading(true);
        var fd = new FormData();
        fd.set("perpage", perPage);
        fd.set("page", page);
        fd.set("sort_by", sortBy);
        fd.set("filter_by", filter.searchValue);
        fd.set("filter_on", filter.filterOn);
        fd.set("order", (0, _utilities.getSortDirection)(ascending));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("category", filter.category);
        var ac = new AbortController();
        var signal = ac.signal;
        fetchcancelqueue.set("getPage", ac);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_GETBATCH), {
            body: fd,
            signal: signal
        }, function(response) {
            var list = [
                false
            ];
            if (response.videos.length) list = response.videos;
            setFilter((0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                hideCategories: filter.filterOn !== "video_category"
            }));
            var num_results = response.num_results;
            if (!num_results) num_results = response.videos.length;
            setVideoList(list);
            setPageCount(response.pages);
            setNumResults(+num_results);
            setLoading(false);
        });
    };
    var getNextPage = function() {
        setPage(function(prev) {
            var nextPage;
            if (prev > pageCount) nextPage = pageCount;
            else nextPage = ++prev;
            return nextPage;
        });
        setVideoList([]);
    };
    var getPrevPage = function() {
        setPage(function(prev) {
            var prevPage;
            if (prev <= 0) prevPage = 1;
            else prevPage = prev - 1;
            return prevPage;
        });
        setVideoList([]);
    };
    var onFilterChangeHandler = function(domEvent) {
        var _domEvent_target = domEvent.target, id = _domEvent_target.id, value = _domEvent_target.value;
        setFilter((0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), (0, _defineProperty._)({}, id, value)));
        setVideoList([]);
    };
    var onSortChangeHandler = function(domEvent) {
        var value = domEvent.target.value;
        setSortBy(value);
        setVideoList([]);
    };
    var onDirectionChangeHandler = function(domEvent) {
        setLoading(true);
        setAscending(!ascending);
        setVideoList([]);
    };
    var onFilterClearHandler = function(domEvent) {
        setVideoList([]);
        domEvent.preventDefault();
        setFilter(initFilterState);
    };
    var getContent = function() {
        var videos;
        var pagingComponent;
        var list;
        if (loading) {
            videos = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "search__results__results",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                    open: true
                })
            });
            pagingComponent = null;
        } else {
            var list1 = "";
            if (videoList[0] === false) list1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "No videos match your criteria"
            });
            else {
                var lst = videoList.map(function(_video, index) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoItemDefault.default), {
                        videoData: _video,
                        id: _video.video_youtubeID,
                        onPlayVideo: playVideo
                    }, index.toString());
                });
                list1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "List",
                    children: lst
                });
            }
            videos = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "search__results__results video__display video__display--grid",
                children: list1
            });
            /*
        NextPrevious activates the previous button based on the PRESENCE of a
        prev_page prop, NOT its value. So we're going to conditionally add
        that prop based on the value of page.
      */ var pgeprops = {
                next: getNextPage,
                prev: getPrevPage,
                result_count: videoList.length,
                per_page: perPage
            };
            if (page > 1) pgeprops.prev_page = true;
            pagingComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextPreviousDefault.default), (0, _objectSpread._)({}, pgeprops));
        }
        var pgCount;
        if (pageCount) {
            if (videoList.length) pgCount = "Page ".concat(page, " of ").concat(pageCount, " (").concat(numResults, " results)");
            else pgCount = "Page \u2013 of \u2013 (0 results)";
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "VideoListGroup search__results__panel--open",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "videos__pagination",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "videos__pgcount",
                            children: pgCount
                        }),
                        pagingComponent
                    ]
                }),
                videos,
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "videos__pagination",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "videos__pgcount",
                            children: pgCount
                        }),
                        pagingComponent
                    ]
                })
            ]
        });
    };
    var playVideo = function(id) {
        setVideoToPlay(id);
        if (videoModalRef.current) videoModalRef.current.showModal();
    };
    var onPlayVideoClose = function() {
        if (videoModalRef.current) videoModalRef.current.close();
    };
    var addVideo = function(domEvent) {
        domEvent.preventDefault();
        var elements = domEvent.target.elements;
        var fd = new FormData();
        fd.set("videoids", elements.video_ids.value);
        fd.set("setID", "-1");
        fd.set("blockID", "-1");
        fd.set("uuid", (0, _utilities.getAuthData)("uuid"));
        fd.set("userName", (0, _utilities.getAuthData)("user"));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        var ac = new AbortController();
        var signal = ac.signal;
        fetchcancelqueue.set("addVideo", ac);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDNEW), {
            body: fd,
            signal: signal
        }, function(data) {
            if (data.success) {
                setSortBy("video_addeddate");
                setLoading(false);
                setAscending(false);
                setVideoList([]);
                domEvent.target.reset();
            } else alert("Something went wrong while adding the video. Please tell an administrator.");
        });
    };
    var videoSetSelected = function(_data) {
        var value = _data ? _data.value : null;
        setState(function(state) {
            return {
                videoinfo: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videoinfo), {
                    selectedSet: value
                })
            };
        });
    };
    var importGoogleSheets = function() {
        importModal.open(0);
    };
    // After the user changes the CRT value, we should update it in state with
    // method.
    var postCRTHandler = function(data) {
        if (data.status !== "success") return;
        var vl = (0, _toConsumableArray._)(videoList);
        var whichVideo = vl.findIndex(function(item) {
            return item.video_youtubeID === data.video_ytid;
        });
        vl[whichVideo].video_crt = data.video_crt;
        setVideoList(vl);
    };
    var postMeowHandler = function(data) {
        if (data.status !== "success") return;
        var vl = (0, _toConsumableArray._)(videoList);
        var whichVideo = vl.findIndex(function(item) {
            return item.video_youtubeID === data.video_ytid;
        });
        vl[whichVideo].meow = data.meow;
        setVideoList(vl);
    };
    var postRatingHandler = function(data) {
        if (data.error === true) return;
        var vl = (0, _toConsumableArray._)(videoList);
        var whichVideo = vl.findIndex(function(item) {
            return item.video_youtubeID === data.youtubeid;
        });
        vl[whichVideo].rating = data.rating;
        setVideoList(vl);
    };
    var postTagsHandler = function(data) {
        var result;
        if (data.error) result = data.message;
        else setState(function(state) {
            return {
                videoinfo: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videoinfo), {
                    videoData: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videoinfo.videoData), {
                        video_customtags: data.customTags
                    })
                })
            };
        }, function(data) {
            result = 'Updated tags for "'.concat(videoinfo.videoData.video_title, '" (YouTube ID: ').concat(videoinfo.videoData.video_yt_id, ").");
        });
        window.alert(result);
    };
    var onDeleteVideo = function(data) {
        var modalRef = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!data.videosDeleted.length) return;
        var list = (0, _toConsumableArray._)(videoList);
        // Removes deleted videos from the displayed list.
        var removevid = function(id) {
            var remove = list.findIndex(function(item) {
                return id == item.video_youtubeID;
            });
            list.splice(remove, 1);
        };
        data.videosDeleted.forEach(removevid);
        setState(function(state) {
            return {
                videoList: list,
                videoinfo: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.videoinfo), {
                    open: false
                })
            };
        }, function() {
            if (modalRef && Object.hasOwn(modalRef, "current")) modalRef.current.close();
        });
    };
    var onDeleteFromBlock = function(data) {
        if (!data.videosDeleted.length) {
            window.alert("I could not remove the video from the set. may be a bug. Please tell an administrator.");
            return;
        }
        var remove;
        if (videoinfo.videoData.hasOwnProperty("dest_set_block_assignments")) {
            var blocks = (0, _toConsumableArray._)(videoinfo.videoData.dest_set_block_assignments);
            remove = blocks.findIndex(function(block) {
                return block.block_id === data.deletedFrom;
            });
            var block_title = blocks[remove].vs_name;
            blocks.slice(remove, 1); // Remove that block from the list.
            setState({
                videoinfo: (0, _objectSpreadProps._)((0, _objectSpread._)({}, videoinfo), {
                    videoData: (0, _objectSpreadProps._)((0, _objectSpread._)({}, videoinfo.videoData), {
                        dest_set_block_assignments: blocks
                    })
                })
            }, function() {
                return window.alert('I removed "'.concat(videoinfo.videoData.video_title, '" from "').concat(block_title, '"'));
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "videoListHolder",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "videoHeaderParent",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    id: "videoHeader",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addVideosFieldDefault.default), {
                            action: (0, _configuration.API_VIDEO_ADDNEW),
                            onSubmit: addVideo
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterComponentDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                            filterData: [
                                {
                                    value: "video_title",
                                    name: "Video Title"
                                },
                                {
                                    value: "video_title_tags",
                                    name: "Video Tags & Title"
                                },
                                {
                                    value: "video_description",
                                    name: "Video Description"
                                },
                                {
                                    value: "video_channel_title",
                                    name: "Channel Title"
                                },
                                {
                                    value: "video_addedbyname",
                                    name: "User Name"
                                },
                                {
                                    value: "video_category",
                                    name: "Category"
                                }
                            ],
                            sortDefault: sortBy,
                            sortData: [
                                {
                                    value: "video_title",
                                    name: "Video Title"
                                },
                                {
                                    value: "video_updateddate",
                                    name: "Video Last Updated"
                                },
                                {
                                    value: "video_addeddate",
                                    name: "Date Video Added to System"
                                },
                                {
                                    value: "video_channel_title",
                                    name: "Channel Title"
                                },
                                {
                                    value: "video_category",
                                    name: "Category"
                                },
                                {
                                    value: "video_duration_seconds",
                                    name: "Video Duration"
                                },
                                {
                                    value: "video_viewcount",
                                    name: "Video View Count"
                                },
                                {
                                    value: "video_likecount",
                                    name: "Video Likes Count"
                                },
                                {
                                    value: "video_setscount",
                                    name: "Number of Video Sets"
                                },
                                {
                                    value: "video_publishdate",
                                    name: "Publish Date"
                                },
                                {
                                    value: "video_channel_publishdate",
                                    name: "Channel Date"
                                },
                                {
                                    value: "video_rating",
                                    name: "Rating"
                                },
                                {
                                    value: "meow",
                                    name: "MEOW Status"
                                }
                            ],
                            ascending: ascending,
                            onSortChange: onSortChangeHandler,
                            onFilterChange: onFilterChangeHandler,
                            onFilterClear: onFilterClearHandler,
                            onDirectionChange: onDirectionChangeHandler
                        }))
                    ]
                })
            }),
            getContent(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoModalDefault.default), {
                modalRef: videoModalRef,
                isAdmin: canAdmin,
                id: "VideoInfo",
                mode: "videos_in_system",
                youtubeId: videoToPlay,
                onClose: onPlayVideoClose,
                onTagsSave: function() {
                    return alert("NEED A TAG SAVE HANDLER! GET FROM DESTINATIONPLAYLIST");
                },
                onCRTSave: postCRTHandler,
                onRatingSave: postRatingHandler,
                onMeowSave: postMeowHandler
            })
        ]
    });
};
exports.default = Videos;

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","./subcomponents/Videos/VideoModal":"aQAN2","./Videos/FilterComponent":"jxYDN","./Search/NextPrevious":"2aqoJ","./subcomponents/LoaderSimple":"1dSHa","./Videos/AddVideosField":"4z0Dq","./subcomponents/VideoItem":"1aNu6","../js/Utilities":"euxcI","../js/Configuration":"k3dur","../css/videosPage.css":"hxw3o","./Destinations/css/VideoDisplay.css":"jiXKe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4z0Dq":[function(require,module,exports) {
/**
 * AddVideosField.js
 * Add videos to AVA. Used on the Videos page
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addVideosFieldCss = require("./css/AddVideosField.css");
var AddVideosField = function(param) {
    var action = param.action, onSubmit = param.onSubmit;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
        method: "post",
        action: action,
        id: "video_add_form",
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "form__input_button_group",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: "video_ids",
                    children: "Add Videos:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "bigSearchInputBox",
                            type: "text",
                            name: "video_ids",
                            id: "video_ids",
                            autoComplete: "off",
                            required: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn-sm btn--action videosPageAddVideosBtn",
                            children: "Add Videos"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "form__instructions",
                    children: "Use valid YouTube URLs or video IDs."
                })
            ]
        })
    });
};
AddVideosField.propTypes = {
    action: (0, _propTypesDefault.default).string.isRequired,
    onSubmit: (0, _propTypesDefault.default).func.isRequired
};
exports.default = AddVideosField;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/AddVideosField.css":"1iIub","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1iIub":[function() {},{}],"1aNu6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ytplayIcon = require("./YTPlayIcon");
var _ytplayIconDefault = parcelHelpers.interopDefault(_ytplayIcon);
var _badgeMEOWCRT = require("../Videos/BadgeMEOWCRT");
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var _videoItemCss = require("../../css/VideoItem.css");
var VideoItem = function(param) {
    var _param_videoData = param.videoData, videoData = _param_videoData === void 0 ? {} : _param_videoData, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_onPlayVideo = param.onPlayVideo, onPlayVideo = _param_onPlayVideo === void 0 ? null : _param_onPlayVideo;
    if (!videoData) return null;
    var category = videoData.category, channel_title = videoData.channel_title, is_interstitial = videoData.is_interstitial, meow = videoData.meow, rating = videoData.rating, video_crt = videoData.video_crt, video_dateadded = videoData.video_dateadded, videoext_duration = videoData.videoext_duration, videoext_publishdatetime = videoData.videoext_publishdatetime, video_setcount = videoData.video_setcount, videoext_thumbnail = videoData.videoext_thumbnail, video_title = videoData.video_title, videoext_viewcount = videoData.videoext_viewcount, video_youtubeID = videoData.video_youtubeID;
    var playVideo = function() {
        if (onPlayVideo) onPlayVideo(video_youtubeID);
    };
    var makeBadge = function() {
        var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isMeow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeMEOWCRT.BadgeMEOWCRT), (0, _objectSpreadProps._)((0, _objectSpread._)({}, obj), {
            mode: isMeow ? "meow" : "crt"
        }));
    };
    var cssClasses = (0, _classnamesDefault.default)({
        "videoListItem": true,
        "results__list__item": true,
        "results__list__item--interstitial": is_interstitial
    }, cssClass);
    var channelTitle = channel_title ? (0, _utilities.truncateString)(channel_title, 20) : "No Channel Info";
    var videoRating = rating ? rating.label : "\u2E3B";
    var ratingCSS = rating ? "" : "__unrated";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                onClick: playVideo,
                className: "results__list__item__title videoResultItemHeader divTransition",
                children: video_title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                onClick: playVideo,
                className: "videoThumb video__item__thumb",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        lazy: "true",
                        width: "480",
                        height: "360",
                        src: videoext_thumbnail,
                        alt: "Watch ".concat(video_title)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ytplayIconDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                className: "video__item__metadata",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "listText",
                                children: "Channel Title:"
                            }),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: channelTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "listText",
                                children: "Video Publish Date:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _dateFns.format)(videoext_publishdatetime * 1000, "PP")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "listText",
                                children: "Added to AVA:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _dateFns.format)(video_dateadded * 1000, "PP")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "listText",
                                children: "Duration:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.formatTime)(videoext_duration)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "listText",
                                children: "Views:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.numberFormat)(videoext_viewcount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                className: "listText",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                        title: "number",
                                        children: "No."
                                    }),
                                    " of Video Sets:"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: video_setcount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "listText",
                                children: "Video Rating:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge video__item__rating".concat(ratingCSS),
                                children: videoRating
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                className: "listText",
                                children: "MEOW:"
                            }),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: makeBadge(meow, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("abbr", {
                                title: "Content Review Team",
                                className: "listText",
                                children: "CRT:"
                            }),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: makeBadge(video_crt)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "listText",
                                children: "Category:"
                            }),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: category
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = VideoItem;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","classnames":"8N3a2","./YTPlayIcon":"5wQr0","../Videos/BadgeMEOWCRT":"jWFU9","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","../../css/VideoItem.css":"011DU","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"011DU":[function() {},{}],"hxw3o":[function() {},{}],"jiXKe":[function() {},{}],"8V1UL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _filterComponent = require("./Videos/FilterComponent");
var _filterComponentDefault = parcelHelpers.interopDefault(_filterComponent);
var _nextPrevious = require("./Search/NextPrevious");
var _nextPreviousDefault = parcelHelpers.interopDefault(_nextPrevious);
var _channelItem = require("./Channels/ChannelItem");
var _channelItemDefault = parcelHelpers.interopDefault(_channelItem);
var _addChannelsByURL = require("./Channels/AddChannelsByURL");
var _addChannelsByURLDefault = parcelHelpers.interopDefault(_addChannelsByURL);
var _channelsCss = require("../css/Channels.css");
var _utilities = require("../js/Utilities");
var _channelsUtils = require("../actions/ChannelsUtils");
var _configuration = require("../js/Configuration");
var Channels = function() {
    var fetchCancel = new AbortController();
    var modalRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), channelList = _useState[0], setChannelList = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(0), 2), channelCount = _useState1[0], setChannelCount = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), groupsOptions = _useState2[0], setGroupsOptions = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState3[0], setLoading = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(1), 2), page = _useState4[0], setPage = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)((0, _configuration.CHANNELS_PER_PAGE)), 2), perPage = _useState5[0], setPerPage = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(1), 2), pageCount = _useState6[0], setPageCount = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(0), 2), numResults = _useState7[0], setNumResults = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)("channel_title"), 2), sortBy = _useState8[0], setSortBy = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)(true), 2), ascending = _useState9[0], setAscending = _useState9[1];
    var _useState10 = (0, _slicedToArray._)((0, _react.useState)((0, _channelsUtils.filterCriteria)), 2), filter = _useState10[0], setFilter = _useState10[1];
    var _useState11 = (0, _slicedToArray._)((0, _react.useState)((0, _channelsUtils.addChannelState)), 2), addChannels = _useState11[0], setAddChannels = _useState11[1];
    var getChannelBatch = function(abortControllerSignal) {
        var fd = new FormData();
        fd.set("perpage", perPage);
        fd.set("page", page);
        fd.set("sort_by", sortBy);
        fd.set("filter_by", filter.searchValue);
        fd.set("filter_on", filter.filterOn);
        fd.set("order", (0, _utilities.getSortDirection)(ascending));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_BATCH), {
            body: fd,
            abortControllerSignal: abortControllerSignal
        }, function(data) {
            if (!data) return;
            if (!data.channels.length) setChannelList([
                false
            ]);
            else setChannelList(data.channels);
            setChannelCount(data.channel_count);
            setPage(data.current_page);
            setPageCount(data.pages);
            setNumResults(data.num_results);
            setLoading(false);
        });
    };
    (0, _react.useEffect)(function() {
        var signal = fetchCancel.signal;
        if (!channelList.length) getChannelBatch(signal);
        return function() {
            return fetchCancel.abort();
        };
    }, [
        channelList,
        fetchCancel,
        ascending,
        addChannels
    ]);
    var getGroups = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ALLGROUPS), {
            body: fd
        }, onGroupsResponse);
    };
    var onGroupsResponse = function(data) {
        if (!data.length) return;
        var groups = data.map(function(x) {
            return {
                value: x.group_id,
                label: x.group_name
            };
        });
        setGroupsOptions(groups);
        var ac = (0, _channelsUtils.setStateOnShowAddChannel)(addChannels);
        setAddChannels(ac);
        if (Object.hasOwn(modalRef, "current") && !!modalRef.current) modalRef.current.showModal();
    };
    var onFilterChangeHandler = function(domEvent) {
        var value = domEvent.target.value;
        setPage(1);
        setFilter((0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
            searchValue: value
        }));
        setLoading(!loading);
        setChannelList([]);
    };
    var onSortChangeHandler = function(domEvent) {
        var sort_criteria = domEvent.target.value.split("|")[0];
        setSortBy(sort_criteria);
        setPage(1);
        setLoading(true);
        setChannelList([]);
    };
    var onDirectionChangeHandler = function() {
        setAscending(!ascending);
        setChannelList([]);
        setLoading(!loading);
    };
    var onFilterClearHandler = function() {
        setFilter((0, _objectSpread._)({}, filter, (0, _channelsUtils.filterCriteria)));
        setAscending(true);
        setPage(1);
        setPageCount(1);
        setLoading(true);
        setChannelList([]);
    };
    var onShowAddChannel = function() {
        getGroups();
    };
    var onCloseAddChannel = function() {
        if (Object.hasOwn(modalRef, "current") && !!modalRef.current) modalRef.current.close();
        var acs = (0, _channelsUtils.setStateOnCloseAddChannel)(addChannels);
        setAddChannels(acs);
    };
    var onSubmitAddChannel = function(domEvent) {
        domEvent.preventDefault();
        var _domEvent_target = domEvent.target, group = _domEvent_target.group, channels = _domEvent_target.channels;
        var fd = new FormData();
        fd.set("groupid", group.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        var chnls = (0, _channelsUtils.stringToArray)(channels.value).filter(function(ch) {
            return ch !== "";
        });
        chnls.forEach(function(ch) {
            fd.set("id", ch); // onSubmitAddChannelResponse
            (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_ADD_TO_SYSTEM), {
                body: fd
            }, onSubmitAddChannelResponse);
        });
    };
    var onSubmitAddChannelResponse = function(response) {
        var ac = (0, _channelsUtils.setStateOnAddChannelResponse)(addChannels, response);
        setAddChannels(ac);
    };
    var onAddChannelErrorClose = function() {
        setAddChannels((0, _objectSpreadProps._)((0, _objectSpread._)({}, addChannels), {
            error: ""
        }));
    };
    var getPagingComp = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextPreviousDefault.default), {
            prev_page: +page > 1,
            next: getNextPage,
            prev: getPrevPage,
            per_page: +perPage,
            result_count: numResults,
            className: "channels__pagination"
        });
    };
    var getNextPage = function() {
        // If page is greater than count, clamp to the value of count.
        // Otherwise increment.
        var nextPage = page > pageCount ? pageCount : page + 1;
        setLoading(true);
        setChannelList([]);
        setPage(+nextPage);
    };
    var getPrevPage = function() {
        // If page is greater than count, clamp to the value of count.
        // Otherwise increment.
        var prevPage = page <= 0 ? 1 : page - 1;
        setLoading(true);
        setChannelList([]);
        setPage(+prevPage);
    };
    var getCurrentGroupFromId = function(id) {
        return groupsOptions.find(function(item) {
            return item.value == id;
        });
    };
    /* When coming from SelectMenu, may be a numeric value, not an Event object */ var onAddChannelsChange = function(domEvent) {
        var _domEvent_target = domEvent.target, name = _domEvent_target.name, value = _domEvent_target.value;
        var acc = (0, _channelsUtils.setStateOnAddChannelChange)(addChannels, name, value);
        setAddChannels(acc);
    };
    var makePageCount = function() {
        var pgCount;
        if (channelList.length) pgCount = "Page ".concat(page, " of ").concat(pageCount, " (").concat(numResults, " results)");
        else pgCount = "Page \u2013 of \u2013 (0 results)";
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "channels__pgcount",
            children: pgCount
        });
    };
    var channels = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: loading
    });
    if (channelList.length) {
        var items = channelList.map(function(item, i) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelItemDefault.default), {
                channelData: item,
                groupsList: groupsOptions
            }, i);
        });
        channels = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "video__display video__display--grid channels__list",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "List",
                children: items
            })
        });
    } else channels = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
        children: "No channels found."
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ava__view__wrap",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterComponentDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                itemsName: "Channels",
                sortDefault: sortBy,
                ascending: ascending,
                sortData: [
                    {
                        value: "channel_title",
                        name: "Sort by Name",
                        type: "string"
                    },
                    {
                        value: "channel_videocount",
                        name: "Sort by Number of Videos",
                        type: "num"
                    },
                    {
                        value: "channel_dateadded",
                        name: "Sort by Date Published",
                        type: "num"
                    },
                    {
                        value: "channel_datelastupdated",
                        name: "Sort by Last Updated",
                        type: "num"
                    },
                    {
                        value: "curated_video_count",
                        name: "Number of Curated Videos",
                        type: "num"
                    },
                    {
                        value: "channel_subscribercount",
                        name: "Number of Subscribers",
                        type: "num"
                    },
                    {
                        value: "channel_category",
                        name: "Sort by Category/Topic",
                        type: "string"
                    }
                ],
                filterData: [
                    {
                        value: "channel_title",
                        name: "Channel Title",
                        type: "string"
                    },
                    {
                        value: "channel_category",
                        name: "Category/Topic",
                        type: "string"
                    },
                    {
                        value: "channel_keywords",
                        name: "Keywords",
                        type: "string"
                    },
                    {
                        value: "channel_customtags",
                        name: "Tags",
                        type: "string"
                    }
                ],
                onSortChange: onSortChangeHandler,
                onFilterChange: onFilterChangeHandler,
                onFilterClear: onFilterClearHandler,
                onDirectionChange: onDirectionChangeHandler
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn btn--action",
                onClick: onShowAddChannel,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    children: "Add Channels"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "channels__pagination_bar",
                children: [
                    makePageCount(),
                    getPagingComp()
                ]
            }),
            channels,
            getPagingComp(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addChannelsByURLDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                modalRef: modalRef
            }, addChannels), {
                options: groupsOptions,
                onChange: onAddChannelsChange,
                onClose: onCloseAddChannel,
                onSubmit: onSubmitAddChannel,
                onErrorClose: onAddChannelErrorClose
            }))
        ]
    });
};
exports.default = Channels;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","./subcomponents/LoaderSimple":"1dSHa","./Videos/FilterComponent":"jxYDN","./Search/NextPrevious":"2aqoJ","./Channels/ChannelItem":"2tBxG","./Channels/AddChannelsByURL":"kmyU5","../css/Channels.css":"7jSBw","../js/Utilities":"euxcI","../actions/ChannelsUtils":"5iVEd","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2tBxG":[function(require,module,exports) {
/**
 * ChannelItem.js
 * Displays individual channels. Used on Channels page.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _reactRouterDom = require("react-router-dom");
var _utilities = require("../../js/Utilities");
var _channelsUtils = require("../../actions/ChannelsUtils");
var _channelItemCss = require("./css/ChannelItem.css");
var ChannelItem = function(param) {
    var channelData = param.channelData;
    var channel_title = channelData.channel_title, channel_youtubechannelid = channelData.channel_youtubechannelid, channel_thumbnail = channelData.channel_thumbnail, channel_dateaddedtosystem = channelData.channel_dateaddedtosystem, channel_datelastupdated = channelData.channel_datelastupdated, channel_dateadded = channelData.channel_dateadded, videos_in_ava = channelData.videos_in_ava, channel_subscribercount = channelData.channel_subscribercount, channel_videocount = channelData.channel_videocount, channel_customtags = channelData.channel_customtags;
    var title = (0, _utilities.truncateString)(channel_title);
    var group_select_id = "".concat(channel_youtubechannelid, "_group_select");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
        to: {
            pathname: "/channels/".concat(channel_youtubechannelid)
        },
        className: "channel__list__item results__list__item",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                className: "results__list__item__title videoResultItemHeader divTransition",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: channel_thumbnail,
                alt: "View ".concat(channel_title),
                className: "channel__thumb"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Added to System:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.formatDate)(channel_dateaddedtosystem, "PP")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Date Updated in System:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.formatDate)(channel_datelastupdated, "PP")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Publication Date:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.formatDate)(channel_dateadded, "PP")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Videos In AVA:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.numberFormat)(videos_in_ava)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Subscriber Count:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.numberFormat)(channel_subscribercount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Video Count:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge",
                                children: (0, _utilities.numberFormat)(channel_videocount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        className: "nogrid",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Groups:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge textNormal listItemScrollingTextBox",
                                children: (0, _channelsUtils.getGroupNamesFromData)(channelData)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        className: "nogrid",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "listText",
                                children: "Tags:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "itemsBadge textNormal listItemScrollingTextBox",
                                children: channel_customtags
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = ChannelItem;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","react-router-dom":"gMZz4","../../js/Utilities":"euxcI","../../actions/ChannelsUtils":"5iVEd","./css/ChannelItem.css":"ejxGl","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ejxGl":[function() {},{}],"kmyU5":[function(require,module,exports) {
/**
 * AddChannelsByURL.js
 * Used to add channels by URL. In terms of layout, it's the same as AddVideosByURL.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _selectMenuControlled = require("../subcomponents/SelectMenuControlled");
var _selectMenuControlledDefault = parcelHelpers.interopDefault(_selectMenuControlled);
var _iconApprovedRejected = require("../subcomponents/IconApprovedRejected");
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _configuration = require("../../js/Configuration");
var _addVideosByURLCss = require("../Destinations/css/AddVideosByURL.css");
var AddChannelsByURL = function(param) {
    var channels = param.channels, group = param.group, open = param.open, options = param.options, modalRef = param.modalRef, response = param.response, working = param.working, max = param.max, onClose = param.onClose, onChange = param.onChange, onSubmit = param.onSubmit;
    var urlField = (0, _reactDefault.default).useRef(null);
    if (Object.hasOwn(urlField, "current") && urlField.current && open) urlField.current.focus();
    var makeListItem = function() {
        var info = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var title;
        switch(info[1].message){
            case "exists":
                title = "Already in AVA";
                break;
            default:
                title = "Added successfully";
        }
        /*
      In makeDialogBody, we convert response to an array from a Map.
      Each item that we receive here is an array in the form [channelid, statusobject]
     */ return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                info[1].title,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "add_channels_message__".concat(info[1].message),
                    children: title
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    className: "add_channels_indicator__".concat(info[1].message),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconApprovedRejected.IconApprovedRejected), {
                        approved: info[1].message === "success",
                        title: ""
                    })
                })
            ]
        }, (0, _lodashUniqueidDefault.default)());
    };
    var makeAddForm = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    method: "dialog",
                    id: "add_channels_by_url_form",
                    onSubmit: onSubmit,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "add_channels_by_url_urls",
                                    children: "Enter URLs"
                                }),
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "form__instructions",
                                    id: "add_channels_by_url_note",
                                    children: "(Maximum 50 URLs or YouTube identifiers.)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    className: "form-control",
                                    id: "add_channels_by_url_urls",
                                    "aria-describedby": "add_channels_by_url_note",
                                    name: "channels",
                                    value: channels,
                                    onChange: onChange,
                                    rows: "15",
                                    ref: urlField,
                                    required: true,
                                    disabled: working
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "form__instructions aria__description",
                                    children: [
                                        "Use valid YouTube URLs or channel IDs. URLs or IDs should be separated either by a comma (,) or new line. If using URLs, include the protocol for each, e.g.: ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                            children: "http://"
                                        }),
                                        " or ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                            children: "https://"
                                        }),
                                        ". Limit 50."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuControlledDefault.default), {
                                    options: options,
                                    labelText: "Select a group",
                                    firstEmpty: true,
                                    name: "group",
                                    cssClass: "channels__group_menu",
                                    value: group,
                                    onChange: onChange
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    id: "group__labelled",
                                    className: "form__instructions",
                                    children: "(Optional)"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                hidden: !max,
                                className: "form__instructions form__error",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: (0, _configuration.MESSAGE_ERROR_TOO_MANY_URLS)[0]
                                    }),
                                    " ",
                                    (0, _configuration.MESSAGE_ERROR_TOO_MANY_URLS)[1]
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            form: "add_channels_by_url_form",
                            disabled: max,
                            className: "btn btn--action",
                            children: "Add Channels"
                        })
                    ]
                })
            ]
        });
    };
    var makeDialogBody = function() {
        var display = makeAddForm();
        /* Convert the map to an array */ /*if( [...response].length ) {
      display = <ul className="multi_success multi_success--alt">{ Array.from( response ).map( makeListItem ) }</ul>;
    } */ return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            id: "add_channels_by_url",
            children: display
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "AddChannelsByURL",
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Add Channels By URL"
            }),
            makeDialogBody()
        ]
    });
};
AddChannelsByURL.propTypes = {
    open: (0, _propTypesDefault.default).bool.isRequired,
    cssClass: (0, _propTypesDefault.default).string,
    channels: (0, _propTypesDefault.default).string,
    group: (0, _propTypesDefault.default).string,
    options: (0, _propTypesDefault.default).array,
    max: (0, _propTypesDefault.default).bool,
    onClose: (0, _propTypesDefault.default).func,
    onChange: (0, _propTypesDefault.default).func,
    onSubmit: (0, _propTypesDefault.default).func,
    response: (0, _propTypesDefault.default).object,
    working: (0, _propTypesDefault.default).bool
};
exports.default = AddChannelsByURL;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/SelectMenuControlled":"6qOrd","../subcomponents/IconApprovedRejected":"x7bFl","../subcomponents/ModalDialog":"72kji","lodash.uniqueid":"6bf5k","../../js/Configuration":"k3dur","../Destinations/css/AddVideosByURL.css":"8lUhq","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"x7bFl":[function(require,module,exports) {
/**
 * IconApprovedRejected.js
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconApprovedRejected", function() {
    return IconApprovedRejected;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var IconApprovedRejected = function(props) {
    var title = props.title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
        children: props.title
    }) : null;
    var icon;
    var clsname = props.approved ? "icon__approved" : "icon__rejected";
    if (props.approved) icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        stroke: "none",
        strokeWidth: "1",
        id: "checkmark",
        fill: "#009900",
        fillRule: "nonzero",
        d: "M15.4285714,31.8571429 C18.2276786,31.8571429 20.8091518,31.1674107 23.1729911,29.7879464 C25.5368304,28.4084821 27.4084821,26.5368304 28.7879464,24.1729911 C30.1674107,21.8091518 30.8571429,19.2276786 30.8571429,16.4285714 C30.8571429,13.6294643 30.1674107,11.0513393 28.7879464,8.69419643 C27.4084821,6.32366071 25.5368304,4.44866071 23.1729911,3.06919643 C20.8091518,1.68973214 18.2276786,1 15.4285714,1 C12.6294643,1 10.0479911,1.68973214 7.68415179,3.06919643 C5.3203125,4.44866071 3.44866071,6.3203125 2.06919643,8.68415179 C0.689732143,11.0479911 0,13.6294643 0,16.4285714 C0,19.2276786 0.689732143,21.8091518 2.06919643,24.1729911 C3.44866071,26.5368304 5.3203125,28.4084821 7.68415179,29.7879464 C10.0479911,31.1674107 12.6294643,31.8571429 15.4285714,31.8571429 Z M13.6004464,25.3683036 C13.2522321,25.3683036 12.9508929,25.2410714 12.6964286,24.9866071 L12.6964286,24.9866071 L5.42410714,17.7142857 C5.18303571,17.4732143 5.0625,17.171875 5.0625,16.8102679 C5.0625,16.4352679 5.18303571,16.1272321 5.42410714,15.8861607 L5.42410714,15.8861607 L7.25223214,14.078125 C7.50669643,13.8236607 7.80803571,13.6964286 8.15625,13.6964286 C8.50446429,13.6964286 8.80580357,13.8236607 9.06026786,14.078125 L9.06026786,14.078125 L13.6004464,18.6183036 L21.796875,10.4419643 C22.0513393,10.1875 22.3526786,10.0602679 22.7008929,10.0602679 C23.0491071,10.0602679 23.3504464,10.1875 23.6049107,10.4419643 L23.6049107,10.4419643 L25.4330357,12.25 C25.6741071,12.4910714 25.7946429,12.7991071 25.7946429,13.1741071 C25.7946429,13.5357143 25.6741071,13.8370536 25.4330357,14.078125 L25.4330357,14.078125 L14.5245536,24.9866071 C14.2700893,25.2410714 13.9620536,25.3683036 13.6004464,25.3683036 Z"
    });
    else icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        stroke: "none",
        strokeWidth: "1",
        id: "xmark",
        fill: "#CC0000",
        fillRule: "nonzero",
        d: "M15.4285714,31.8571429 C18.2276786,31.8571429 20.8091518,31.1674107 23.1729911,29.7879464 C25.5368304,28.4084821 27.4084821,26.5368304 28.7879464,24.1729911 C30.1674107,21.8091518 30.8571429,19.2276786 30.8571429,16.4285714 C30.8571429,13.6294643 30.1674107,11.0513393 28.7879464,8.69419643 C27.4084821,6.32366071 25.5368304,4.44866071 23.1729911,3.06919643 C20.8091518,1.68973214 18.2276786,1 15.4285714,1 C12.6294643,1 10.0479911,1.68973214 7.68415179,3.06919643 C5.3203125,4.44866071 3.44866071,6.3203125 2.06919643,8.68415179 C0.689732143,11.0479911 0,13.6294643 0,16.4285714 C0,19.2276786 0.689732143,21.8091518 2.06919643,24.1729911 C3.44866071,26.5368304 5.3203125,28.4084821 7.68415179,29.7879464 C10.0479911,31.1674107 12.6294643,31.8571429 15.4285714,31.8571429 Z M19.96875,24.0825893 C19.6205357,24.0825893 19.3191964,23.9553571 19.0647321,23.7008929 L19.0647321,23.7008929 L15.4285714,20.0647321 L11.7924107,23.7008929 C11.5379464,23.9553571 11.2366071,24.0825893 10.8883929,24.0825893 C10.5267857,24.0825893 10.21875,23.9553571 9.96428571,23.7008929 L9.96428571,23.7008929 L8.15625,21.8928571 C7.90178571,21.6383929 7.77455357,21.3303571 7.77455357,20.96875 C7.77455357,20.6205357 7.90178571,20.3191964 8.15625,20.0647321 L8.15625,20.0647321 L11.7924107,16.4285714 L8.15625,12.7924107 C7.90178571,12.5379464 7.77455357,12.2366071 7.77455357,11.8883929 C7.77455357,11.5267857 7.90178571,11.21875 8.15625,10.9642857 L8.15625,10.9642857 L9.96428571,9.15625 C10.21875,8.90178571 10.5267857,8.77455357 10.8883929,8.77455357 C11.2366071,8.77455357 11.5379464,8.90178571 11.7924107,9.15625 L11.7924107,9.15625 L15.4285714,12.7924107 L19.0647321,9.15625 C19.3191964,8.90178571 19.6205357,8.77455357 19.96875,8.77455357 C20.3303571,8.77455357 20.6383929,8.90178571 20.8928571,9.15625 L20.8928571,9.15625 L22.7008929,10.9642857 C22.9553571,11.21875 23.0825893,11.5267857 23.0825893,11.8883929 C23.0825893,12.2366071 22.9553571,12.5379464 22.7008929,12.7924107 L22.7008929,12.7924107 L19.0647321,16.4285714 L22.7008929,20.0647321 C22.9553571,20.3191964 23.0825893,20.6205357 23.0825893,20.96875 C23.0825893,21.3303571 22.9553571,21.6383929 22.7008929,21.8928571 L22.7008929,21.8928571 L20.8928571,23.7008929 C20.6383929,23.9553571 20.3303571,24.0825893 19.96875,24.0825893 Z"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        focusable: "false",
        width: props.width,
        height: props.height,
        viewBox: "0 0 31 32",
        className: clsname,
        children: [
            title,
            icon
        ]
    });
};
IconApprovedRejected.propTypes = {
    width: (0, _propTypesDefault.default).number,
    height: (0, _propTypesDefault.default).number,
    title: (0, _propTypesDefault.default).string,
    approved: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8lUhq":[function() {},{}],"7jSBw":[function() {},{}],"5toJ3":[function(require,module,exports) {
/**
 * Channel.js
 * /channel/:channelID single channel, page-level component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _reactRouterDom = require("react-router-dom");
var _breadcrumb = require("../subcomponents/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _channelsManageGroups = require("./ChannelsManageGroups");
var _channelsManageGroupsDefault = parcelHelpers.interopDefault(_channelsManageGroups);
var _channelVideos = require("./ChannelVideos");
var _channelVideosDefault = parcelHelpers.interopDefault(_channelVideos);
var _channelEditTags = require("./ChannelEditTags");
var _channelEditTagsDefault = parcelHelpers.interopDefault(_channelEditTags);
var _configuration = require("../../js/Configuration");
var _channelCss = require("./css/Channel.css");
var _utilities = require("../../js/Utilities");
var Channel = function(props) {
    var params = props.params;
    var channelID = params.channelID;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({}), 2), data = _useState[0], setData = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        list: [],
        page: 1,
        perPage: 25,
        total: 1,
        sort: 0,
        ascending: 1,
        loading: true,
        rangelimit: 10,
        start: 1 // Start of the pagination display.
    }), 2), videos = _useState1[0], setVideos = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({
        options: [],
        selected: ""
    }), 2), groups = _useState2[0], setGroups = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([
        {
            path: "/channels/",
            label: "Channels",
            state: {}
        }
    ]), 1), crumbs = _useState3[0];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)({
        tags: "",
        success: false
    }), 2), editTags = _useState4[0], setEditTags = _useState4[1];
    var DATE_FORMAT_TEXT = "PP";
    (0, _react.useEffect)(function() {
        if ((0, _utilities.isEmptyObject)(data)) getChannel(channelID);
        if (!videos.list.length) getVideos();
        if (!groups.options.length) getGroups();
    }, [
        channelID,
        videos
    ]);
    var getChannel = function() {
        var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", id);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_INFO), {
            body: fd
        }, function(data) {
            setData(data);
        });
    };
    var getVideos = function() {
        var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, perPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 25;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", channelID);
        fd.set("page", page);
        fd.set("perPage", perPage);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_GET_VIDEOS), {
            body: fd
        }, function(response) {
            setVideos(function(previous) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                    list: response.list,
                    total: response.total,
                    pages: response.pages,
                    loading: false
                });
            });
        });
    };
    var getGroups = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ALLGROUPS), {
            body: fd
        }, function(data) {
            setGroups((0, _objectSpreadProps._)((0, _objectSpread._)({}, groups), {
                options: (0, _toConsumableArray._)(data)
            }));
        });
    };
    var makeBreadcrumbs = function() {
        var slice = (0, _toConsumableArray._)(crumbs);
        var lastCrumb = [];
        if (Object.hasOwn(data, "channel_title")) lastCrumb = [
            {
                label: data.channel_title,
                state: {}
            }
        ];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbDefault.default), {
            ariaLabel: "Navigate to Channels index page",
            items: slice.concat(lastCrumb)
        });
    };
    var makeCategories = function() {
        if (!data.channel_category_names) return;
        return data.channel_category_names.join(", ");
    };
    var onGroupSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GROUPS_ASSIGN_CHANNEL_TO_GROUP), {
            body: fd
        }, function(response) {
            if (!response.success) return false;
            setData(function(previous) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                    groupList: (0, _toConsumableArray._)(response.list[channelID])
                });
            });
        });
    };
    var onGroupDelete = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REMOVE_CHANNEL_FROM_GROUP), {
            body: fd
        }, function(response) {
            setData(function(previous) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                    groupList: (0, _toConsumableArray._)(response[channelID])
                });
            });
        });
    };
    var onChannelDeleteRequest = function() {
        var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", id);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_REMOVE), {
            body: fd
        }, function(data) {
            if (data.status === "success") window.location.href = "/channels";
        });
    };
    var onChannelDelete = function() {
        var confirmed = window.confirm("Are you sure that you want to delete ".concat(data.channel_title));
        if (confirmed) onChannelDeleteRequest(channelID);
    };
    var onCustomTagsChange = function(domEvent) {
        var value = domEvent.target.value;
        setEditTags(function(previous) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                tags: value
            });
        });
    };
    var onCustomTagsSubmit = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", data.channel_id); // using a numeric ID for now.
        fd.set("tags", editTags.tags);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_SETTAGS), {
            body: fd
        }, function(response) {
            var channelTags = response.channelTags;
            setEditTags(function(previous) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                    tags: channelTags,
                    success: true
                });
            });
            setData(function(previous) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                    channel_customtags: channelTags
                });
            });
        });
    };
    var onPerPageSelect = function(domEvent) {
        var value = domEvent.target.value;
        setVideos(function(previous) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                perPage: +value,
                pages: Math.ceil(previous.total / +value)
            });
        });
        getVideos(videos.page, +value);
    };
    var onPaginationClick = function(domEvent) {
        var value = domEvent.target.value;
        setVideos((0, _objectSpreadProps._)((0, _objectSpread._)({}, videos), {
            page: +value
        }));
        getVideos(+value, videos.perPage);
    };
    var onCustomTagsMessageClose = function() {
        setEditTags(function(previous) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previous), {
                success: false
            });
        });
    };
    var formatDate = function(dateString) {
        var date = "";
        if (dateString) {
            var d = new Date(dateString);
            date = (0, _dateFns.format)(d, DATE_FORMAT_TEXT);
        }
        return date;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ava__view__wrap",
        children: [
            makeBreadcrumbs(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: "channel_single_page_header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        children: [
                            data.channel_title,
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                className: "channel__external",
                                href: "https://youtube.com/channel/".concat(data.channel_youtubechannelid),
                                target: "_blank",
                                rel: "noreferrer",
                                children: "View channel on YouTube"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "channel__single__thumb",
                        src: data.channel_thumbnail
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "channel__single__description",
                        children: data.channel_description
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Channel Stats:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        className: "channel__single__meta",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Added to System:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: formatDate(data.channel_dateaddedtosystem)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Date Updated in System:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: formatDate(data.channel_datelastupdated)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Publication Date:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: formatDate(data.channel_dateadded)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Videos In AVA:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: (0, _utilities.numberFormat)(videos.total)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Subscriber Count:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: (0, _utilities.numberFormat)(data.channel_subscribercount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Videos in Channel:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge",
                                        children: (0, _utilities.numberFormat)(data.channel_videocount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Categories / Topics:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("output", {
                                        className: "itemsBadge textNormal listItemScrollingTextBox resizable--vert",
                                        children: makeCategories()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Keywords:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge textNormal listItemScrollingTextBox resizable--vert",
                                        children: data.channel_keywords
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "listText",
                                        children: "Tags:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "itemsBadge textNormal listItemScrollingTextBox resizable--vert",
                                        children: data.channel_customtags || (0, _configuration.MESSAGE_NO_TAGS)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelsManageGroupsDefault.default), {
                channel: channelID,
                groups: groups.options,
                inGroups: data.groupList,
                onSubmit: onGroupSubmit,
                onChannelDelete: onChannelDelete,
                onGroupDelete: onGroupDelete
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelEditTagsDefault.default), {
                channel: data.channel_youtubechannelid,
                tags: data.channel_customtags,
                onSubmit: onCustomTagsSubmit,
                onChange: onCustomTagsChange,
                success: editTags.success,
                onMessageClose: onCustomTagsMessageClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelVideosDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, videos), {
                onPerPageSelect: onPerPageSelect,
                onPaginationClick: onPaginationClick
            }))
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Channel, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","date-fns":"1h4Hj","react-router-dom":"gMZz4","../subcomponents/Breadcrumb":"e7Haa","./ChannelsManageGroups":"izHMj","./ChannelVideos":"1b4YG","./ChannelEditTags":"9Us1U","../../js/Configuration":"k3dur","./css/Channel.css":"cEN9M","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"izHMj":[function(require,module,exports) {
/**
 * ChannelsManageGroups.js
 * Panel for managing the channel-group relationship.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../../js/Configuration");
var _selectMenu = require("../subcomponents/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _channelsRemoveFromGroup = require("./ChannelsRemoveFromGroup");
var _channelsRemoveFromGroupDefault = parcelHelpers.interopDefault(_channelsRemoveFromGroup);
var _channelsManageGroupsCss = require("./css/ChannelsManageGroups.css");
var _utilities = require("../../js/Utilities");
var ChannelsManageGroups = function(param) {
    var channel = param.channel, inGroups = param.inGroups, groups = param.groups, onSubmit = param.onSubmit, onGroupDelete = param.onGroupDelete, onChannelDelete = param.onChannelDelete;
    var makeMenu = function() {
        if (!groups.length) return;
        var selects = [
            {
                value: "",
                label: "Select Group"
            }
        ];
        var grps = groups.map(function(item) {
            return {
                value: item.group_id,
                label: item.group_name
            };
        });
        return selects.concat(grps);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
        id: "ChannelsManageGroups",
        className: "channel__singlepg__panel",
        open: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Manage Channel Groups"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: "ChannelsManageGroups__body",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        id: "ChannelsManageGroups__addtogroup",
                        onSubmit: onSubmit,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                id: "channelID",
                                name: "channelID",
                                value: channel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                labelText: "Add Channel To Group",
                                options: makeMenu(),
                                onChangeHandler: function() {},
                                name: "groupID",
                                firstEmpty: false,
                                required: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "btn btn--action",
                                children: "Save"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelsRemoveFromGroupDefault.default), {
                        channel: channel,
                        onDelete: onGroupDelete,
                        onGroupDelete: onGroupDelete,
                        inGroups: inGroups
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn btn--destructive",
                            onClick: onChannelDelete,
                            children: "Delete Channel From System"
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = ChannelsManageGroups;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../js/Configuration":"k3dur","../subcomponents/SelectMenu":"da8gs","./ChannelsRemoveFromGroup":"b9hrj","./css/ChannelsManageGroups.css":"2OgA5","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"b9hrj":[function(require,module,exports) {
/**
 * ChannelsRemoveFromGroup.js
 * /channel/:channelID single channel, page-level component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _channelGroupDelete = require("./ChannelGroupDelete");
var _channelGroupDeleteDefault = parcelHelpers.interopDefault(_channelGroupDelete);
var _channelsRemoveFromGroupCss = require("./css/ChannelsRemoveFromGroup.css");
var ChannelsRemoveFromGroup = function(param) {
    var _param_inGroups = param.inGroups, inGroups = _param_inGroups === void 0 ? [] : _param_inGroups, group_id = param.group_id, onGroupDelete = param.onGroupDelete, channel = param.channel;
    var makeBadges = function() {
        if (!inGroups.length) return;
        var badges = inGroups.map(function(g) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelGroupDeleteDefault.default), {
                onSubmit: onGroupDelete,
                group: g.group_id,
                channel: channel,
                name: g.group_name
            }, g.group_id);
        });
        return badges;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        id: "ChannelsManageGroups__remove",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                children: "Remove Channel From Groups"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: makeBadges()
            })
        ]
    });
};
exports.default = ChannelsRemoveFromGroup;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./ChannelGroupDelete":"gIAZR","./css/ChannelsRemoveFromGroup.css":"UgbCt","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gIAZR":[function(require,module,exports) {
/**
 * ChannelGroupDelete.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _channelGroupDeleteCss = require("./css/ChannelGroupDelete.css");
var ChannelGroupDelete = function(param) {
    var onSubmit = param.onSubmit, group = param.group, channel = param.channel, name = param.name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "badge__delete",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "groupID",
                value: group
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "channelID",
                value: channel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    name,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "submit",
                        className: "badge__delete__btn",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                className: "form__access__label",
                                children: [
                                    "Remove channel from ",
                                    name
                                ]
                            }),
                            "\u2715"
                        ]
                    })
                ]
            })
        ]
    }, group);
};
exports.default = ChannelGroupDelete;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./css/ChannelGroupDelete.css":"fauWw","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fauWw":[function() {},{}],"UgbCt":[function() {},{}],"2OgA5":[function() {},{}],"1b4YG":[function(require,module,exports) {
/**
 * ChannelVideos.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _dateFns = require("date-fns");
var _channelVideosCss = require("./css/ChannelVideos.css");
var _paginationBar = require("../subcomponents/PaginationBar");
var _paginationBarDefault = parcelHelpers.interopDefault(_paginationBar);
var _selectPerPage = require("../subcomponents/SelectPerPage");
var _selectPerPageDefault = parcelHelpers.interopDefault(_selectPerPage);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _utilities = require("../../js/Utilities");
var _configurationJs = require("../../js/Configuration.js");
var links = function(s) {
    /*
    The + forces s.isStation to be an integer (0/1) that will be treated as
    a boolean
  */ var path = +s.isStation ? "/stations/series/".concat(s.videoset) : "/destinations/playlist/".concat(s.playlist_id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            className: "channel__videos__link",
            to: {
                pathname: "".concat(path)
            },
            children: make_link_text(s)
        })
    }, s.videoset);
};
var make_link_text = function(obj) {
    var tlt = obj.title ? obj.title : "";
    var rndte;
    switch(obj.rundate){
        case "":
        case "0000-00-00":
            rndte = (0, _configurationJs.NULL_DATE_TEXT_STATIONS);
            break;
        default:
            rndte = (0, _dateFns.format)(new Date(obj.rundate), "[ PP ]");
    }
    return "".concat(obj.destination_name, ": ").concat(obj.set_name, " ").concat(tlt, " ").concat(rndte);
};
var make_sets = function(sets_array) {
    var result;
    if (sets_array.length) result = /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        children: sets_array.map(links)
    });
    else result = "None";
    return result;
};
var ChannelVideos = function(props) {
    var body;
    var tablerows;
    if (props.loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else if (!props.list.length) body = "No videos in AVA.";
    else {
        tablerows = props.list.map(function(item) {
            var isactive = item.active === "y" ? "" : "*";
            var sts = make_sets(item.sets);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "channel__videos__active",
                        children: isactive
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: (0, _utilities.youtubeURL)(item.youtube_id),
                            target: "_blank",
                            rel: "noopener",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: item.thumbnail,
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: (0, _utilities.youtubeURL)(item.youtube_id),
                            target: "_blank",
                            rel: "noopener",
                            className: "channel__videos__link",
                            children: item.title
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "text__tbl__align_duration",
                        children: item.duration
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: sts
                    })
                ]
            }, item.youtube_id);
        });
        body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                children: "Inactive?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                colSpan: "2",
                                children: "Title"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "text__center",
                                children: "Duration"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                children: "Used in"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: tablerows
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
        id: "ChannelsVideosInAVA",
        className: "channel__singlepg__panel",
        open: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                    children: [
                        "Videos in AVA (",
                        props.total || 0,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pagination__selpages",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPerPageDefault.default), {
                        id: "ChannelsVideosInAVAPerPage",
                        value: props.perPage,
                        onChangeHandler: props.onPerPageSelect,
                        options: [
                            "View All|-1",
                            10,
                            25,
                            50,
                            75,
                            100
                        ],
                        replace: true,
                        cssClass: "ChannelVideos__select ava-input-select"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationBarDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                        onClickHandler: props.onPaginationClick
                    }))
                ]
            }),
            body,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pagination__selpages",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPerPageDefault.default), {
                        id: "ChannelsVideosInAVAPerPage_b",
                        value: props.perPage,
                        onChangeHandler: props.onPerPageSelect,
                        options: [
                            "View All|-1",
                            10,
                            25,
                            50,
                            75,
                            100
                        ],
                        replace: true,
                        cssClass: "ChannelVideos__select ava-input-select"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationBarDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                        onClickHandler: props.onPaginationClick
                    }))
                ]
            })
        ]
    });
};
exports.default = ChannelVideos;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","date-fns":"1h4Hj","./css/ChannelVideos.css":"jSIo5","../subcomponents/PaginationBar":"03zHm","../subcomponents/SelectPerPage":"anMUV","../subcomponents/LoaderSimple":"1dSHa","../../js/Utilities":"euxcI","../../js/Configuration.js":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"jSIo5":[function() {},{}],"9Us1U":[function(require,module,exports) {
/**
 * ChannelEditTags.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _channelEditTagsCss = require("./css/ChannelEditTags.css");
var _actionMessageDisplay = require("../subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var ChannelEditTags = function(param) {
    var onSubmit = param.onSubmit, onChange = param.onChange, onMessageClose = param.onMessageClose, success = param.success, channel = param.channel, tags = param.tags;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
        id: "ChannelsEditTags",
        className: "channel__singlepg__panel",
        open: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Edit Tags"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                className: "form__channel__edit__tags",
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
                        mode: "success",
                        hidden: !success,
                        message: "Tags updated.",
                        onClose: onMessageClose
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                name: "channelID",
                                value: channel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "channel_tags",
                                children: "Add or remove tags from the list"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                id: "channel_tags",
                                name: "channel_tags",
                                defaultValue: tags,
                                onChange: onChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        children: "Save Tags"
                    })
                ]
            })
        ]
    });
};
ChannelEditTags.propTypes = {
    onSubmit: (0, _propTypesDefault.default).func,
    onChange: (0, _propTypesDefault.default).func,
    onMessageClose: (0, _propTypesDefault.default).func,
    success: (0, _propTypesDefault.default).bool,
    channel: (0, _propTypesDefault.default).string,
    tags: (0, _propTypesDefault.default).string,
    fullSize: (0, _propTypesDefault.default).bool
};
exports.default = ChannelEditTags;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./css/ChannelEditTags.css":"dQNfi","../subcomponents/ActionMessageDisplay":"bzcdY","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dQNfi":[function() {},{}],"cEN9M":[function() {},{}],"hEfIw":[function(require,module,exports) {
/**
 * UserAdmin.js
 * Displays the UserAdmin interface.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _addUserForm = require("./subcomponents/UserAdmin/AddUserForm");
var _addUserFormDefault = parcelHelpers.interopDefault(_addUserForm);
var _userAdminTable = require("./subcomponents/UserAdmin/UserAdminTable");
var _userAdminTableDefault = parcelHelpers.interopDefault(_userAdminTable);
var _editUserModal = require("./subcomponents/UserAdmin/EditUserModal");
var _editUserModalDefault = parcelHelpers.interopDefault(_editUserModal);
var _modalAlert = require("./subcomponents/ModalAlert");
var _modalAlertDefault = parcelHelpers.interopDefault(_modalAlert);
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _userAdminUtils = require("../actions/UserAdminUtils");
var _userAdminCss = require("../css/UserAdmin.css");
var UserAdmin = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(_userAdminUtils.initialState), 2), state = _useState[0], setState = _useState[1];
    var userPermissionLevel = (0, _utilities.getAuthData)("permissions");
    (0, _react.useEffect)(function() {
        getProjects();
        getRegions();
        getLanguages();
        getUsers();
    });
    var getProjects = function() {
        if (state.projects.length) return;
        var fetchCancel = new AbortController();
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_PROJECTS), {
            body: fd,
            signal: signal
        }, function(data) {
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                projects: (0, _toConsumableArray._)(data)
            }));
        });
        return function() {
            if (state.projects.length) fetchCancel.abort();
        };
    };
    var getRegions = function() {
        if (state.regions.length) return;
        var fetchCancel = new AbortController();
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REGIONS), {
            body: fd,
            signal: signal
        }, function(data) {
            var makeRegions = function() {
                return data.map(function(r) {
                    return {
                        value: r.id,
                        label: r.name
                    };
                });
            };
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                regions: makeRegions()
            }));
        });
        return function() {
            if (state.regions.length) fetchCancel.abort();
        };
    };
    var getLanguages = function() {
        if (state.languages.length) return;
        var fetchCancel = new AbortController();
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_LANGUAGES), {
            body: fd,
            signal: signal
        }, function(data) {
            var makeLanguages = function() {
                return data.map(function(l) {
                    return {
                        value: l.id,
                        label: l.name
                    };
                });
            };
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                languages: makeLanguages()
            }));
        });
        return function() {
            if (state.languages.length) fetchCancel.abort();
        };
    };
    var getUsers = function() {
        if (state.usersList.length) return;
        var fetchCancel = new AbortController();
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_USERS_GETALL), {
            body: fd,
            signal: signal
        }, function(data) {
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                usersList: (0, _toConsumableArray._)(data),
                loading: false
            }));
        });
        return function() {
            if (state.usersList.length) fetchCancel.abort();
        };
    };
    var toggleAddUser = function() {
        setState(_userAdminUtils.setStateOnAddUserToggle(state));
    };
    var deleteUser = function(domEvent) {
        domEvent.preventDefault();
        var isSure = window.confirm((0, _configuration.MESSAGE_USER_DELETE_CONFIRM));
        if (isSure) {
            var fd = new FormData(domEvent.currentTarget);
            fd.set("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_USERS_DELETEUSER), {
                body: fd
            }, function(response) {
                if (response.success) setState(_userAdminUtils.setStateAfterDeleteUser(state, response));
                else alert((0, _configuration.MESSAGE_ERROR_GENERAL));
            });
        }
        setState(function(state) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
                    open: false
                })
            });
        });
    };
    var deactivateUser = function(domEvent) {
        domEvent.preventDefault();
        var uuid = domEvent.currentTarget.uuid.value;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("uuid", uuid);
        (0, _utilities.apirequest)((0, _configuration.API_USERS_DEACTIVATE), {
            body: fd
        }, function(response) {
            setState(_userAdminUtils.setStateAfterDeactivateUser(state, uuid, response));
        });
    };
    var reactivateUser = function(domEvent) {
        domEvent.preventDefault();
        var uuid = domEvent.currentTarget.uuid.value;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("uuid", uuid);
        (0, _utilities.apirequest)((0, _configuration.API_USERS_REACTIVATE), {
            body: fd
        }, function(response) {
            setState(_userAdminUtils.setStateAfterReactivateUser(state, uuid, response));
        });
    };
    var makeEditModal = function() {
        var _state_editUser_form_username;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editUserModalDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
            currentUserName: (_state_editUser_form_username = state.editUser.form.username) === null || _state_editUser_form_username === void 0 ? void 0 : _state_editUser_form_username.valueOf()
        }, state.editUser), {
            regions: (0, _toConsumableArray._)(state.regions),
            languages: (0, _toConsumableArray._)(state.languages),
            onClose: onEditUserClose,
            onSubmit: onEditUserSubmit,
            onChange: onEditUserChange,
            onDeleteUser: deleteUser,
            onReset: onEditUserReset,
            onRequestPassword: resetPassword
        }));
    };
    var onAddUserChange = function(domEvent) {
        var target = domEvent.target;
        var field = target.name;
        var value = target.value;
        var stateSetter = _userAdminUtils.setStateOnAddUserTextBoxChange(state, field, value);
        if ([
            "radio",
            "checkbox"
        ].indexOf(target.type) > -1) stateSetter = _userAdminUtils.setStateOnAddUserToProject(state, target);
        setState(stateSetter);
    };
    var onEditUserOpen = function(domEvent) {
        var uuid = domEvent.target.dataset.uuid;
        var ns = _userAdminUtils.setStateOnEditUserOpen(state, uuid);
        setState(ns);
    };
    var onEditUserClose = function() {
        setState(_userAdminUtils.setStateOnEditUserClose(state));
    };
    var onEditUserChange = function(domEvent) {
        var target = domEvent.target;
        var stateSetter;
        if ([
            "user_language",
            "user_region"
        ].indexOf(target.name) > -1) stateSetter = _userAdminUtils.setStateOnChangeRegionLang(state, target);
        if ([
            "radio",
            "checkbox"
        ].indexOf(target.type) > -1) stateSetter = function(state) {
            return _userAdminUtils.setStateOnChangeUserProjects(state, target);
        };
        if ([
            "text",
            "email"
        ].indexOf(target.type) > -1) stateSetter = function(state) {
            return _userAdminUtils.setStateOnEditUserTextBox(state, target.name, target.value);
        };
        setState(stateSetter);
    };
    var onEditUserReset = function(domEvent) {
        domEvent.preventDefault();
        setState(_userAdminUtils.resetEditUserState);
    };
    var onEditUserSubmit = function(domEvent) {
        domEvent.preventDefault();
        setState((0, _utilities.showLoader)(state));
        updateUser();
    };
    var updateUser = function() {
        var fd = new FormData();
        /*
      Convert the project_access Map to an Object since we can't use
      JSON.stringify with a map.
    */ var projects = (0, _utilities.mapToObject)(state.editUser.form.project_access);
        // The + forces this to be an integer, which we'll treat as a boolean server-side
        fd.set("enabled", +state.editUser.form.enabled);
        fd.set("uuid", state.editUser.form.uuid);
        fd.set("username", state.editUser.form.user_name);
        fd.set("email", state.editUser.form.email);
        fd.set("displayname_first", state.editUser.form.displayname_first);
        fd.set("displayname_second", state.editUser.form.displayname_second || "");
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("region", state.editUser.form.user_region);
        fd.set("lang", state.editUser.form.user_language || "");
        fd.set("projects", JSON.stringify(projects));
        (0, _utilities.apirequest)((0, _configuration.API_USERS_UPDATEUSER), {
            body: fd
        }, function(response) {
            var stateSetter;
            if (response.status === "failed") stateSetter = _userAdminUtils.setStateOnUpdateError(state, response);
            else stateSetter = _userAdminUtils.setStateAfterUserEdit(state, response);
            setState(stateSetter);
        });
    };
    var addUser = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        /*
      Convert the project_access Map to an Object since we can't use
      JSON.stringify with a map.
    */ var projects = (0, _utilities.mapToObject)(state.addUser.form.project_access);
        fd.set("username", state.addUser.form.username);
        fd.set("email", state.addUser.form.email);
        fd.set("displayname_first", state.addUser.form.displayname_first);
        fd.set("displayname_second", state.addUser.form.displayname_second || "");
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("region", state.addUser.form.user_region);
        fd.set("lang", state.addUser.form.user_language || "");
        fd.set("projects", JSON.stringify(projects));
        (0, _utilities.apirequest)((0, _configuration.API_USERS_ADD), {
            body: fd
        }, function(response) {
            if (response.result === "success") setState(function(state) {
                return _userAdminUtils.setStateAfterAddUser(state, response);
            }, resetUserStateAfterAdd);
            else alert(response.message);
        });
    };
    var resetUserStateAfterAdd = function() {
        setState(_userAdminUtils.reSetFormState, getUsers);
    };
    var closeStatusMessage = function() {
        setState(_userAdminUtils.setStateCloseStatusMsg);
    };
    var findUserByUUID = function(uuid) {
        return state.usersList.find(function(item) {
            return item.uuid === uuid;
        });
    };
    var resetPassword = function(domEvent) {
        var uuid = domEvent.target.elements.user_uid.value;
        var userobj = findUserByUUID(uuid);
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("id", uuid);
        fd.set("tok", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_USER_PW_RESET), {
            body: fd
        }, function(response) {
            setState(function(state) {
                return _userAdminUtils.setStateOnPasswordReset(state, response);
            });
        });
    };
    var onCloseAlert = function(domEvent) {
        setState(_userAdminUtils.setStateOnCloseErrorModal(state));
    };
    var onFilterChange = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (!domEvent) return;
        var field = domEvent.target.name;
        var value = domEvent.target.value;
        setState(_userAdminUtils.setStateOnFilterChange(state, field, value));
    };
    if (state.loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addUserFormDefault.default), (0, _objectSpread._)({
                title: "Add a new user",
                onSubmit: addUser,
                onChange: onAddUserChange,
                onToggle: toggleAddUser,
                onMessageClose: closeStatusMessage,
                projects: (0, _toConsumableArray._)(state.projects),
                languages: (0, _toConsumableArray._)(state.languages),
                regions: (0, _toConsumableArray._)(state.regions)
            }, state.addUser)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Manage Users"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAdminTableDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
                projects: (0, _toConsumableArray._)(state.projects),
                filtering: (0, _objectSpread._)({}, state.filtering),
                userPermissionLevel: userPermissionLevel,
                users: state.usersList,
                onEditUser: onEditUserOpen,
                onDelete: deleteUser,
                onDeactivate: deactivateUser,
                onReactivate: reactivateUser,
                onRequestPassword: resetPassword,
                onFilterChange: onFilterChange
            })),
            makeEditModal(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalAlertDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                id: "UserAdminAlertMessage",
                open: state.alert.open,
                title: state.alert.title
            }, state.alert), {
                onClose: onCloseAlert,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    style: {
                        "fontSize": "1.8rem"
                    },
                    dangerouslySetInnerHTML: {
                        __html: state.alert.message
                    }
                })
            }))
        ]
    });
};
exports.default = UserAdmin;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","./subcomponents/LoaderSimple":"1dSHa","./subcomponents/UserAdmin/AddUserForm":"55ipk","./subcomponents/UserAdmin/UserAdminTable":"1o8kX","./subcomponents/UserAdmin/EditUserModal":"7PaG0","./subcomponents/ModalAlert":"2bFMz","../js/Configuration":"k3dur","../js/Utilities":"euxcI","../actions/UserAdminUtils":"eS7Cn","../css/UserAdmin.css":"cQq7n","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"55ipk":[function(require,module,exports) {
/**
 * AddUserForm.js
 * Form for adding a new user
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _addUserFormCss = require("./css/AddUserForm.css");
var _selectMenuControlled = require("../../subcomponents/SelectMenuControlled");
var _selectMenuControlledDefault = parcelHelpers.interopDefault(_selectMenuControlled);
var _actionMessageDisplay = require("../../subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _userAdminActivate = require("./UserAdminActivate");
var _addUserFormProjects = require("./AddUserFormProjects");
var _userAdminButtons = require("./UserAdminButtons");
var AddUserForm = function(props) {
    var showAction = function() {
        if (!Object.hasOwn(props, "mode")) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
            mode: props.mode.mode,
            hidden: props.mode.mode === null,
            message: props.mode.status,
            onClose: props.onMessageClose
        });
    };
    var showEditButtons = function() {
        if (!props.edit) return;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: "user__edit__controls",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAdminActivate.UserAdminActivate), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props.form), {
                    disabled: !props.form.enabled,
                    onDeactivate: props.onDeactivate,
                    onReactivate: props.onReactivate
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAdminButtons.ButtonRemoveUser), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props.form), {
                    onClick: props.onDeleteUser
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAdminButtons.ButtonResetPassword), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props.form), {
                    onClick: props.onRequestPassword
                }))
            ]
        });
    };
    var cssClass = (0, _classnamesDefault.default)(props.cssClass, {
        "useradmin__add__user_wrapper": true,
        "useradmin__add__user_wrapper--open": props.open
    });
    var showCancel = null;
    if (Object.hasOwn(props, "addUser")) showCancel = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "reset",
        className: "btn",
        children: "Cancel"
    });
    if (Object.hasOwn(props, "addUser")) showCancel = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "reset",
        className: "btn",
        children: "Cancel"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: cssClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        hidden: props.edit,
                        type: "button",
                        title: "Toggle this panel",
                        onClick: props.onToggle,
                        className: "button__toggle",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: "\u25B6"
                        })
                    })
                ]
            }),
            showAction(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                hidden: !props.open,
                action: props.action,
                method: "post",
                onSubmit: props.onSubmit,
                onReset: props.onReset,
                className: "useradmin__add__user",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "ua-au-a",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "required",
                                children: "A red asterisk ("
                            }),
                            ") indicates a required field.",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                name: "uuid",
                                id: "uuid",
                                value: props.form.uuid
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                name: "enabled",
                                id: "enabled",
                                value: props.form.enabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "ua-au-b",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "user_name",
                                className: "required",
                                children: "Log In Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                name: "username",
                                id: "user_name",
                                className: "form-control",
                                type: "text",
                                minLength: "2",
                                maxLength: "40",
                                "aria-describedby": "user_name_direction",
                                required: true,
                                onChange: props.onChange,
                                value: props.form.username || props.form.user_name || "",
                                pattern: "\\w{2,40}"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "user_name_direction",
                                className: "aria__description",
                                children: "This is the name the user will use to log in. It can contain letters, numbers, or underscores. It may not contain punctuation or spaces. It must be at least two, but no longer than forty characters long."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "ua-au-c",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "user_email",
                                className: "required",
                                children: "Email Address"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                name: "email",
                                id: "user_email",
                                className: "form-control",
                                type: "email",
                                required: true,
                                onChange: props.onChange,
                                value: props.form.email || ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "ua-au-d",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "common_name",
                                className: "required",
                                children: "First Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                name: "displayname_first",
                                id: "first_name",
                                className: "form-control",
                                type: "text",
                                "aria-describedby": "first_name_hint",
                                required: true,
                                maxLength: "29",
                                onChange: props.onChange,
                                value: props.form.displayname_first || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                id: "first_name_hint",
                                className: "aria__description",
                                children: [
                                    "How the user will be greeted and identified to other producers, i.e. ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                                        children: "Hello, Jane"
                                    }),
                                    ". "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "ua-au-e",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "common_name",
                                children: "Second Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                name: "displayname_second",
                                id: "last_name",
                                className: "form-control",
                                type: "text",
                                maxLength: "30",
                                onChange: props.onChange,
                                value: props.form.displayname_second || ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("fieldset", {
                        className: "ua-au-f",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                    children: "Grant access to:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addUserFormProjects.AddUserFormProjects), {
                                    projects: props.projects,
                                    userprojects: props.form.project_access,
                                    onChange: props.onChange
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ua-au-g",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "user_region"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuControlledDefault.default), {
                                labelText: "Set User Region",
                                name: "user_region",
                                onChange: props.onChange,
                                options: props.regions,
                                isRequired: false,
                                cssClass: "user__admin__select",
                                firstEmpty: false,
                                value: props.form.user_region || "0",
                                describedBy: "user_region_note"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "user_region_note",
                                className: "aria__description",
                                children: "Optional field. Sets a default region search value for YouTube. The curator can change this setting."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ua-au-h",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "user_language"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuControlledDefault.default), {
                                labelText: "Set User Language",
                                name: "user_language",
                                onChange: props.onChange,
                                options: props.languages,
                                firstEmpty: false,
                                isRequired: false,
                                cssClass: "user__admin__select",
                                value: props.form.user_language || "0",
                                describedBy: "user_language_note"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "user_language_note",
                                className: "aria__description",
                                children: "Optional field. Sets a default language search value for YouTube. The curator can change this setting."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "ua-au-i",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "button__group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn--action",
                                    children: "Save"
                                }),
                                showCancel
                            ]
                        })
                    })
                ]
            }),
            showEditButtons()
        ]
    });
};
AddUserForm.propTypes = {
    action: (0, _propTypesDefault.default).string,
    onSubmit: (0, _propTypesDefault.default).func.isRequired,
    onReset: (0, _propTypesDefault.default).func,
    onChange: (0, _propTypesDefault.default).func
};
exports.default = AddUserForm;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","./css/AddUserForm.css":"kO5sJ","../../subcomponents/SelectMenuControlled":"6qOrd","../../subcomponents/ActionMessageDisplay":"bzcdY","./UserAdminActivate":"44AYT","./AddUserFormProjects":"6OPVc","./UserAdminButtons":"ah3cu","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"kO5sJ":[function() {},{}],"44AYT":[function(require,module,exports) {
/**
 * UserAdminActivate.js
 * A control for activating or deactivating a user.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserAdminActivate", function() {
    return UserAdminActivate;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../../../js/Configuration");
var UserAdminActivate = function(props) {
    var prefix = props.enabled ? "Dea" : "A";
    var title = props.missing_pass ? null : (0, _configuration.MESSAGE_USER_NOPASS);
    var submitter = props.enabled ? props.onDeactivate : props.onReactivate;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: submitter,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "uuid",
                id: "uuid",
                value: props.uuid || "",
                onChange: function() {}
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "submit",
                className: "btn btn--action btn__user--activate",
                disabled: props.missing_pass,
                title: title,
                children: [
                    prefix,
                    "ctivate"
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6OPVc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddUserFormProjects", function() {
    return AddUserFormProjects;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var makeFieldId = function(projectId) {
    return "".concat(projectId, "_").concat((0, _lodashUniqueidDefault.default)());
};
var AddUserFormProjects = function(props) {
    var projects = props.projects;
    var makeProjects = function(projObj) {
        var fieldId = makeFieldId(projObj.pid);
        // If the map contains an entry for this project ID, use that. Otherwise set these defaults.
        var boxState = props.userprojects.has(projObj.pid) ? props.userprojects.get(projObj.pid) : {
            checked: false,
            role: 0
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
            className: "user__admin__project",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "fancy__chex",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            id: fieldId,
                            name: "project_access[".concat(projObj.pid, "]"),
                            onChange: props.onChange,
                            checked: boxState.checked
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: fieldId,
                            style: {
                                "justifyContent": "unset"
                            },
                            children: projObj.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    hidden: !boxState.checked,
                    className: "user__admin__p_role",
                    children: makeRoles(projObj, props.userprojects)
                })
            ]
        }, (0, _lodashUniqueidDefault.default)());
    };
    var makeRoles = function(projObj, userProjObj) {
        return projObj.roles.map(function(role) {
            var fieldId = makeFieldId(projObj.pid);
            var checked = userProjObj.has(projObj.pid) ? userProjObj.get(projObj.pid).role == role.level : false;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "fancy__radio",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "radio",
                        id: fieldId,
                        value: role.level,
                        name: "project_role[".concat(projObj.pid, "]"),
                        onChange: props.onChange,
                        checked: checked
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: fieldId,
                        style: {
                            "justifyContent": "unset"
                        },
                        children: role.name
                    })
                ]
            }, (0, _lodashUniqueidDefault.default)());
        });
    };
    var proj = [];
    if (projects) proj = projects;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: proj.map(makeProjects)
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","lodash.uniqueid":"6bf5k","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ah3cu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonEditUser", function() {
    return ButtonEditUser;
});
parcelHelpers.export(exports, "ButtonResetPassword", function() {
    return ButtonResetPassword;
});
parcelHelpers.export(exports, "ButtonRemoveUser", function() {
    return ButtonRemoveUser;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ButtonEditUser = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
        type: "button",
        className: "btn btn--action"
    }, props), {
        children: "Edit User"
    }));
};
var ButtonResetPassword = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        method: "post",
        onSubmit: props.onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "uuid",
                id: "user_uid",
                value: props.uuid || ""
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "btn btn--action",
                children: "Reset Password"
            })
        ]
    });
};
var ButtonRemoveUser = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        method: "post",
        onSubmit: props.onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "uuid",
                id: "user_uid",
                value: props.uuid || ""
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "btn btn--action",
                children: "Remove User"
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1o8kX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return UserAdminTable;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _createSuper = require("@swc/helpers/_/_create_super");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _userAdminActivate = require("./UserAdminActivate");
var _userAdminButtons = require("./UserAdminButtons");
var _selectMenuControlled = require("../SelectMenuControlled");
var _selectMenuControlledDefault = parcelHelpers.interopDefault(_selectMenuControlled);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _userAdminTableCss = require("./css/UserAdminTable.css");
var UserAdminTable = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(UserAdminTable, _React_Component);
    var _super = (0, _createSuper._)(UserAdminTable);
    function UserAdminTable(props) {
        (0, _classCallCheck._)(this, UserAdminTable);
        var _this;
        _this = _super.call(this, props);
        _this.makeTable = _this.makeTable.bind((0, _assertThisInitialized._)(_this));
        _this.makeTableHeader = _this.makeTableHeader.bind((0, _assertThisInitialized._)(_this));
        _this.makeTableRows = _this.makeTableRows.bind((0, _assertThisInitialized._)(_this));
        _this.makeProjectList = _this.makeProjectList.bind((0, _assertThisInitialized._)(_this));
        _this.findProjectById = _this.findProjectById.bind((0, _assertThisInitialized._)(_this));
        _this.getData = _this.getData.bind((0, _assertThisInitialized._)(_this));
        _this.disable = _this.disable.bind((0, _assertThisInitialized._)(_this));
        _this.sortProjects = _this.sortProjects.bind((0, _assertThisInitialized._)(_this));
        return _this;
    }
    (0, _createClass._)(UserAdminTable, [
        {
            key: "findProjectById",
            value: function findProjectById() {
                var seek = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                var value;
                if (seek) value = this.props.projects.find(function(p) {
                    return p.pid === seek;
                }) || {};
                return value;
            }
        },
        {
            key: "makeProjectList",
            value: function makeProjectList(uProjects) {
                var _this = this;
                var listItems;
                if (!uProjects) listItems = "\u2013\u2013";
                else {
                    var li = Object.keys(uProjects).map(function(key) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: _this.findProjectById(key).name
                        }, (0, _lodashUniqueidDefault.default)());
                    });
                    listItems = /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        children: li
                    });
                }
                return listItems;
            }
        },
        {
            key: "disable",
            value: function disable(field) {
                if (!field) return;
                // If the list is being filtered, props.filtering will have multiple
                // properties.
                var isFiltering = Object.keys(this.props.filtering);
                // Exclude the 'filtered' key
                var fields = isFiltering.filter(function(item) {
                    return item !== "filtered";
                });
                return fields.length && fields.indexOf(field) == -1;
            }
        },
        {
            key: "sortProjects",
            value: function sortProjects() {
                var ps = this.props.projects.sort(function(a, b) {
                    return a.name > b.name;
                }).map(function(p) {
                    return {
                        label: p.name,
                        value: p.pid
                    };
                });
                return [
                    {
                        label: "\u2014",
                        value: ""
                    }
                ].concat(ps);
            }
        },
        {
            key: "makeTableHeader",
            value: function makeTableHeader() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                children: [
                                    "Display name",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        id: "UserAdminTableDisplayName",
                                        name: "displayname",
                                        onChange: this.props.onFilterChange,
                                        value: this.props.filtering.displayname || "",
                                        disabled: this.disable("displayname"),
                                        className: "useradmin__filter"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                children: [
                                    "Login name",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        id: "UserAdminTableLoginName",
                                        name: "username",
                                        onChange: this.props.onFilterChange,
                                        value: this.props.filtering.username || "",
                                        disabled: this.disable("username"),
                                        className: "useradmin__filter"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                children: [
                                    "Project",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuControlledDefault.default), {
                                        labelText: "Filter users by project",
                                        name: "project",
                                        onChange: this.props.onFilterChange,
                                        options: this.sortProjects(),
                                        isRequired: false,
                                        cssClass: "useradmin__filter",
                                        firstEmpty: false,
                                        value: this.props.filtering.project || "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                children: "Tools"
                            })
                        ]
                    })
                });
            }
        },
        {
            /*
    Decides whether to use this.props.users, this.props.filtering.filtered or 
    an empty array.
  */ key: "getData",
            value: function getData() {
                var data = [];
                if (this.props.filtering.hasOwnProperty("filtered")) data = this.props.filtering.filtered;
                else if (this.props.users.length) data = this.props.users;
                return data;
            }
        },
        {
            key: "makeTableRows",
            value: function makeTableRows() {
                var _this = this;
                var data = this.getData();
                var rows = data.map(function(r) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                children: [
                                    r.displayname_first,
                                    " ",
                                    r.displayname_second || ""
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: r.username
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: _this.makeProjectList(r.permissions)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    style: {
                                        "display": "flex",
                                        "gap": "1rem",
                                        "justifyContent": "space-between"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAdminButtons.ButtonEditUser), {
                                            "data-uuid": r.uuid,
                                            onClick: _this.props.onEditUser
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAdminActivate.UserAdminActivate), (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                                            onDeactivate: _this.props.onDeactivate,
                                            onReactivate: _this.props.onReactivate
                                        })),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAdminButtons.ButtonResetPassword), (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                                            onClick: _this.props.onRequestPassword
                                        }))
                                    ]
                                })
                            })
                        ]
                    }, (0, _lodashUniqueidDefault.default)());
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: rows
                });
            }
        },
        {
            key: "makeTable",
            value: function makeTable() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "useradmin__table__wrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                        className: "useradmin__table",
                        children: [
                            this.makeTableHeader(),
                            this.makeTableRows()
                        ]
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return this.makeTable();
            }
        }
    ]);
    return UserAdminTable;
}((0, _reactDefault.default).Component);

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_create_super":"4WNpt","react/jsx-runtime":"66j3G","react":"l5IPE","./UserAdminActivate":"44AYT","./UserAdminButtons":"ah3cu","../SelectMenuControlled":"6qOrd","lodash.uniqueid":"6bf5k","./css/UserAdminTable.css":"gXmZX","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gXmZX":[function() {},{}],"7PaG0":[function(require,module,exports) {
/**
 * EditUserModal.jsx
 * Form for adding a new user
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addUserForm = require("./AddUserForm");
var _addUserFormDefault = parcelHelpers.interopDefault(_addUserForm);
var _modalDialog = require("../../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var EditUserModal = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
        id: "UserAdminEditUser",
        title: "Add Songs",
        open: props.open,
        onClose: props.onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addUserFormDefault.default), (0, _objectSpread._)({
            edit: true,
            cssClass: "user__admin__edit__user",
            title: "Editing user: ".concat(props.form.user_name || props.form.username),
            onToggle: null
        }, props))
    });
};
EditUserModal.propTypes = {
    onSubmit: (0, _propTypesDefault.default).func.isRequired,
    onReset: (0, _propTypesDefault.default).func,
    onChange: (0, _propTypesDefault.default).func
};
exports.default = EditUserModal;

},{"@swc/helpers/_/_object_spread":"95yNt","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./AddUserForm":"55ipk","../../subcomponents/ModalDialog":"72kji","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2bFMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _closeButton = require("./CloseButton");
var _modalAlertCss = require("./css/ModalAlert.css");
var ModalAlert = function(param) {
    var open = param.open, children = param.children, id = param.id, onClose = param.onClose, _param_title = param.title, title = _param_title === void 0 ? "" : _param_title;
    var ref = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        if (!open) return;
        var dialog = ref.current;
        dialog.showModal();
        // eslint-disable-next-line consistent-return
        return function() {
            return dialog.close();
        };
    }, [
        open
    ]);
    var makeTitle = function() {
        var titleEl = null;
        if (title) titleEl = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
            id: "".concat(id, "_title"),
            children: title
        });
        return titleEl;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dialog", {
        ref: ref,
        id: id,
        "aria-labelledby": "".concat(id, "_title"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                color: "#CBCBCB",
                className: "dialog__body__close",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dialog__body",
                role: "document",
                children: [
                    makeTitle(),
                    children
                ]
            })
        ]
    });
};
ModalAlert.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    open: (0, _propTypesDefault.default).bool.isRequired,
    title: (0, _propTypesDefault.default).any,
    children: (0, _propTypesDefault.default).any,
    onClose: (0, _propTypesDefault.default).func.isRequired
};
exports.default = ModalAlert;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./CloseButton":"3MmmO","./css/ModalAlert.css":"6UH2V","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6UH2V":[function() {},{}],"eS7Cn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", function() {
    return initialState;
});
parcelHelpers.export(exports, "reSetFormState", function() {
    return reSetFormState;
});
parcelHelpers.export(exports, "resetEditUserState", function() {
    return resetEditUserState;
});
parcelHelpers.export(exports, "setStateCloseStatusMsg", function() {
    return setStateCloseStatusMsg;
});
parcelHelpers.export(exports, "setStateOnEditUserClose", function() {
    return setStateOnEditUserClose;
});
parcelHelpers.export(exports, "setStateOnEditUserOpen", function() {
    return setStateOnEditUserOpen;
});
parcelHelpers.export(exports, "setStateOnEditUserTextBox", function() {
    return setStateOnEditUserTextBox;
});
parcelHelpers.export(exports, "setStateOnAddUserToggle", function() {
    return setStateOnAddUserToggle;
});
parcelHelpers.export(exports, "setStateAfterAddUser", function() {
    return setStateAfterAddUser;
});
parcelHelpers.export(exports, "setStateOnAddUserTextBoxChange", function() {
    return setStateOnAddUserTextBoxChange;
});
parcelHelpers.export(exports, "setStateOnAddUserToProject", function() {
    return setStateOnAddUserToProject;
});
parcelHelpers.export(exports, "setStateOnChangeUserProjects", function() {
    return setStateOnChangeUserProjects;
});
parcelHelpers.export(exports, "setStateOnChangeRegionLang", function() {
    return setStateOnChangeRegionLang;
});
parcelHelpers.export(exports, "setStateAfterUserEdit", function() {
    return setStateAfterUserEdit;
});
parcelHelpers.export(exports, "setStateOnUpdateError", function() {
    return setStateOnUpdateError;
});
parcelHelpers.export(exports, "setStateOnCloseErrorModal", function() {
    return setStateOnCloseErrorModal;
});
parcelHelpers.export(exports, "setStateAfterDeleteUser", function() {
    return setStateAfterDeleteUser;
});
parcelHelpers.export(exports, "setStateAfterDeactivateUser", function() {
    return setStateAfterDeactivateUser;
});
parcelHelpers.export(exports, "setStateAfterReactivateUser", function() {
    return setStateAfterReactivateUser;
});
parcelHelpers.export(exports, "setStateOnPasswordReset", function() {
    return setStateOnPasswordReset;
});
parcelHelpers.export(exports, "setStateOnFilterChange", function() {
    return setStateOnFilterChange;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var initialState = {
    loading: true,
    usersList: [],
    addUser: {
        title: "Add new user",
        open: true,
        mode: {
            mode: null,
            status: null
        },
        form: {
            /* 
       * This map should be in the form:
       * project_id : { checked: <boolean>, role: <integer|numeric string> }
       */ project_access: new Map(),
            user_language: 0,
            user_region: 0,
            username: "",
            displayname_first: "",
            email: ""
        }
    },
    projects: [],
    languages: [],
    regions: [],
    editUser: {
        open: false,
        mode: {
            mode: null,
            status: null
        },
        form: {
            project_access: new Map(),
            user_language: 0,
            user_region: 0,
            user_name: "",
            displayname_first: "",
            email: "",
            uuid: ""
        }
    },
    alert: {
        open: false,
        title: "",
        message: ""
    },
    filtering: {}
};
var reSetFormState = function(state) {
    var updates = {
        addUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser), {
            form: {
                project_access: new Map(),
                user_language: "0",
                user_region: "0"
            }
        })
    };
    return updates;
};
var resetEditUserState = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: false,
            form: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser.form), {
                project_access: new Map(),
                user_language: "0",
                user_region: "0",
                user_name: "",
                displayname_first: "",
                email: ""
            })
        })
    });
};
var setStateCloseStatusMsg = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser), {
            mode: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser.mode), {
                mode: null,
                status: null
            })
        })
    });
};
var setStateOnEditUserClose = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            form: (0, _objectSpread._)({}, initialState.editUser.form),
            open: false
        })
    });
};
/* 
Converts project object from { projectId: roleId }
to a map in the form: { projectId: { checked: true, role: roleId }}
*/ var projectObjectToMap = function(po) {
    var keys = Object.keys(po);
    var projectMap = new Map();
    keys.forEach(function(k) {
        var startState = {
            checked: true,
            role: po[k]
        };
        projectMap.set(k, startState);
    });
    return projectMap;
};
var setStateOnEditUserOpen = function(state, uuid) {
    var currentUser = state.usersList.find(function(u) {
        return u.uuid === uuid;
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            mode: {
                mode: null,
                status: null
            },
            form: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser.form), {
                user_language: currentUser.user_language,
                user_region: currentUser.user_region,
                user_name: currentUser.username,
                displayname_first: currentUser.displayname_first,
                displayname_second: currentUser.displayname_second || "",
                email: currentUser.email,
                enabled: +currentUser.enabled,
                missing_pass: currentUser.missing_pass,
                uuid: currentUser.uuid,
                project_access: projectObjectToMap(currentUser.permissions)
            }),
            open: true
        }),
        alert: (0, _objectSpread._)({}, initialState.alert)
    });
};
var setStateOnEditUserTextBox = function(state, field, value) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: true,
            form: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser.form), (0, _defineProperty._)({}, field, value))
        })
    });
};
var setStateOnAddUserToggle = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser), {
            open: !state.addUser.open
        })
    });
};
var setStateAfterAddUser = function(state, data) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser), {
            mode: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser.mode), {
                mode: data.result,
                status: data.message
            })
        })
    });
};
var roleInfo = function(valueJSON) {
    return JSON.parse(valueJSON);
};
var isUserAdmin = function(projectList, projectId) {
    var project = projectList.find(function(p) {
        return p.pid === projectId;
    });
    var returnvalue = false;
    if (project) returnvalue = project.name === "User Admin";
    return returnvalue;
};
var setStateOnAddUserTextBoxChange = function(state, field, value) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser), {
            form: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser.form), (0, _defineProperty._)({}, field, value))
        })
    });
};
/*
Extracts the project ID from the form field name. Form field must be in the form
project_role[project_identifier] or project_access[project_identifier]
*/ var getProjectIdForRole = function(targetName) {
    var returnValue = false;
    var id = targetName.match(/project_(role|access)\[([-a-z0-9]{1,})\]/i);
    if (id.length) returnValue = id[2];
    return returnValue;
};
var setStateOnAddUserToProject = function(state, eventTarget) {
    var projectId = getProjectIdForRole(eventTarget.name);
    // Copy existing state into a new Map.
    var changedAccess = new Map(state.addUser.form.project_access);
    var details = changedAccess.get(projectId);
    if (eventTarget.type === "checkbox") {
        // If it's not checked, delete it.
        if (!eventTarget.checked && changedAccess.has(projectId)) changedAccess.delete(projectId);
        else changedAccess.set(projectId, (0, _objectSpreadProps._)((0, _objectSpread._)({}, details), {
            checked: eventTarget.checked
        }));
    } else changedAccess.set(projectId, (0, _objectSpreadProps._)((0, _objectSpread._)({}, details), {
        role: +eventTarget.value
    }));
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser), {
            form: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addUser.form), {
                project_access: changedAccess
            })
        })
    });
};
var setStateOnChangeUserProjects = function(state, eventTarget) {
    var projectId = getProjectIdForRole(eventTarget.name);
    // Copy existing state into a new Map.
    var changedAccess = new Map(state.editUser.form.project_access);
    var details = changedAccess.get(projectId);
    if (eventTarget.type === "checkbox") {
        // If it's not checked, delete it.
        if (!eventTarget.checked && changedAccess.has(projectId)) changedAccess.delete(projectId);
        else changedAccess.set(projectId, (0, _objectSpreadProps._)((0, _objectSpread._)({}, details), {
            checked: eventTarget.checked
        }));
    } else // If it's a radio button, update the role property instead.
    changedAccess.set(projectId, (0, _objectSpreadProps._)((0, _objectSpread._)({}, details), {
        role: +eventTarget.value
    }));
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            form: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser.form), {
                project_access: changedAccess
            })
        })
    });
};
var setStateOnChangeRegionLang = function(state, eventTarget) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            form: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser.form), (0, _defineProperty._)({}, eventTarget.name, eventTarget.value))
        })
    });
};
var updateUsersList = function(ul, data) {
    var idx = ul.findIndex(function(x) {
        return data.uuid === x.uuid;
    });
    ul[idx] = Object.assign((0, _objectSpread._)({}, ul[idx]), data);
    return ul;
};
var setStateAfterUserEdit = function(state, response) {
    /*
   * Find the last updated user and update their region and language data
   */ var uIndex = state.usersList.findIndex(function(u) {
        return u.uuid === state.editUser.form.uuid;
    });
    var uList = (0, _toConsumableArray._)(state.usersList);
    uList[uIndex] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, uList[uIndex], response.data), {
        user_language: response.data.lang,
        user_region: response.data.region
    });
    /* Delete these extraneous properties returned by the API */ delete uList[uIndex].region;
    delete uList[uIndex].lang;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        usersList: uList,
        loading: false,
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: false
        })
    });
};
var setStateOnUpdateError = function(state, response) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        alert: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.alert), {
            open: true,
            message: response.message,
            title: "Error \uD83D\uDE1E"
        }),
        loading: false,
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: false
        })
    });
};
var setStateOnCloseErrorModal = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        alert: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.alert), {
            open: false,
            message: "",
            title: ""
        })
    });
};
var setStateAfterDeleteUser = function(state, response) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        alert: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.alert), {
            open: true,
            title: response.success ? "Success \uD83D\uDE01" : "Error \uD83D\uDE1E",
            message: response.message
        }),
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: false
        })
    });
};
var setStateAfterDeactivateUser = function(state, uuid, response) {
    var userIndex = state.usersList.findIndex(function(u) {
        return u.uuid === uuid;
    });
    var uList = (0, _toConsumableArray._)(state.usersList);
    uList[userIndex] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, uList[userIndex]), {
        enabled: false
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        usersList: uList,
        alert: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.alert), {
            open: true,
            title: response.result === "success" ? "Success \uD83D\uDE01" : "Error \uD83D\uDE1E",
            message: response.message
        }),
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: false
        })
    });
};
var setStateAfterReactivateUser = function(state, uuid, response) {
    var userIndex = state.usersList.findIndex(function(u) {
        return u.uuid === uuid;
    });
    var uList = (0, _toConsumableArray._)(state.usersList);
    uList[userIndex] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, uList[userIndex]), {
        enabled: true
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        usersList: uList,
        alert: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.alert), {
            open: true,
            title: response.result === "success" ? "Success \uD83D\uDE01" : "Error \uD83D\uDE1E",
            message: response.message
        }),
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: false
        })
    });
};
var setStateOnPasswordReset = function(state, response) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        alert: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.alert), {
            open: true,
            title: response.result === "success" ? "Success \uD83D\uDE01" : "Error \uD83D\uDE1E",
            message: response.message
        }),
        editUser: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.editUser), {
            open: false
        })
    });
};
var setStateOnFilterChange = function(state, field, value) {
    var returnValue, matching;
    // If there is no value, clear the filtered array and remove other properties.
    if (value.length == 0) returnValue = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        filtering: {}
    });
    else {
        if (field === "project") matching = state.usersList.filter(function(user) {
            return Object.keys(user.permissions).indexOf(value) > -1;
        });
        else matching = state.usersList.filter(function(user) {
            var regexp = new RegExp(value, "ig");
            return regexp.test(user[field]);
        });
        var _obj;
        returnValue = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            filtering: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.filtering), (_obj = {}, (0, _defineProperty._)(_obj, field, value), (0, _defineProperty._)(_obj, "filtered", matching), _obj))
        });
    }
    return returnValue;
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_to_consumable_array":"fRXIP","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"cQq7n":[function() {},{}],"38dnm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _project = require("./Login/Project");
var _projectIcons = require("../js/ProjectIcons");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _utilities = require("../js/Utilities");
var _userProjectsCss = require("../css/UserProjects.css");
var UserProjects = function(props) {
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), projects = _React_useState[0], setProjects = _React_useState[1];
    (0, _reactDefault.default).useEffect(function() {
        if (!projects.length) {
            var fd = new FormData();
            fd.set("token", (0, _utilities.getAuthData)("token"));
            fd.set("uuid", (0, _utilities.getAuthData)("uuid"));
            (0, _utilities.apirequest)("api/projectsforuser", {
                body: fd
            }, function(data) {
                setProjects(data);
            });
        }
    }, []);
    var makeLinks = function() {
        var links = [];
        if (projects && projects.length) links = projects.filter(function(pj) {
            return pj.name !== "User Admin";
        }) // Removes user admin from the list.
        .map(function(pj) {
            var ico = (0, _projectIcons.ProjectIcons)[pj.icon];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _project.Project), {
                path: "/".concat(pj.path),
                name: pj.name,
                icon: ico
            }, (0, _lodashUniqueidDefault.default)());
        });
        return links;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "UserProjects",
        children: makeLinks()
    });
};
exports.default = UserProjects;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","./Login/Project":"2VMAd","../js/ProjectIcons":"gS8eL","lodash.uniqueid":"6bf5k","../js/Utilities":"euxcI","../css/UserProjects.css":"iP7nL","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2VMAd":[function(require,module,exports) {
/**
 * Project.jsx
 * Displays project name, link and icon.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Project", function() {
    return Project;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _projectCss = require("./css/Project.css");
var Project = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
        to: props.path,
        className: "project__link",
        children: [
            props.name,
            props.icon
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./css/Project.css":"RoqXD","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"RoqXD":[function() {},{}],"gS8eL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProjectIcons", function() {
    return ProjectIcons;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _amazonLogo = require("../components/subcomponents/AmazonLogo");
var _amazonLogoDefault = parcelHelpers.interopDefault(_amazonLogo);
var _ytplayIcon = require("../components/subcomponents/YTPlayIcon");
var _ytplayIconDefault = parcelHelpers.interopDefault(_ytplayIcon);
var _appleLogo = require("../components/subcomponents/AppleLogo");
var _appleLogoDefault = parcelHelpers.interopDefault(_appleLogo);
var ProjectIcons = {
    "AmazonLogo": /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amazonLogoDefault.default), {
        cssClass: "project__icon"
    }),
    "YTPlayIcon": /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ytplayIconDefault.default), {
        cssClass: "project__icon"
    }),
    "AppleLogo": /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appleLogoDefault.default), {
        cssClass: "project__icon"
    })
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../components/subcomponents/AmazonLogo":"31L7b","../components/subcomponents/YTPlayIcon":"5wQr0","../components/subcomponents/AppleLogo":"by6Jh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"31L7b":[function(require,module,exports) {
/**
 * AmazonLogo.js
 * Amazon shortened logo in SVG for crispness.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var AmazonLogo = function(param) {
    var _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_title = param.title, title = _param_title === void 0 ? "Amazon" : _param_title, _param_fill = param.fill, fill = _param_fill === void 0 ? "#000" : _param_fill, _param_width = param.width, width = _param_width === void 0 ? "100" : _param_width, _param_height = param.height, height = _param_height === void 0 ? "97.65" : _param_height;
    var cssClasses = (0, _classnamesDefault.default)("prime__logo", cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            aspectRatio: "".concat(width / height)
        },
        className: cssClasses,
        width: width,
        height: height,
        viewBox: "0 0 83 85",
        version: "1.1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    transform: "translate(-1355.000000, -265.000000)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        transform: "translate(770.000000, 195.000000)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: fill,
                            d: "M617.084495,134.393939 L617.932256,134.378102 C620.205779,134.283079 622.416149,133.918824 624.563366,133.285337 C626.710582,132.651851 628.723598,131.64619 630.602412,130.268356 C632.481226,128.890522 634.020591,127.267212 635.220506,125.398426 C635.66258,126.095262 636.057289,126.617888 636.404633,126.966306 L636.404633,126.966306 L637.304569,127.916536 C637.904527,128.550023 638.820252,129.476498 640.051743,130.69596 C641.283235,131.915422 642.530515,133.111129 643.793584,134.283079 L643.793584,134.283079 L654.545455,123.6405 L653.929709,123.117873 C653.487635,122.769455 652.966619,122.262666 652.366661,121.597505 C651.766704,120.932344 651.17464,120.203834 650.590471,119.411975 C650.006302,118.620117 649.501075,117.701561 649.074789,116.656307 C648.648503,115.611054 648.435361,114.597475 648.435361,113.61557 L648.435361,113.61557 L648.435361,85.6312883 C648.435361,84.5543606 648.238006,83.3903285 647.843297,82.139192 C647.448588,80.8880554 646.738112,79.5260587 645.711869,78.0532017 C644.685626,76.5803448 643.406769,75.2658595 641.875299,74.109746 C640.343828,72.9536325 638.299236,71.9796464 635.741522,71.1877879 C633.183808,70.3959293 630.326116,70 627.168445,70 C623.94762,70 620.939938,70.3880107 618.145399,71.1640321 C615.35086,71.9400535 612.958924,72.9773882 610.969591,74.2760363 C608.980258,75.5746844 607.275115,77.0792157 605.854163,78.7896302 C604.433211,80.5000447 603.375391,82.2896451 602.680704,84.1584313 C601.986016,86.0272176 601.638672,87.911841 601.638672,89.8123016 L601.638672,89.8123016 L615.564003,91.0951125 C616.132383,89.3530236 616.890224,87.8326551 617.837526,86.5340071 C618.784827,85.235359 619.668975,84.2930473 620.48997,83.7070719 C621.310964,83.1210966 622.195112,82.6539 623.142414,82.3054823 C624.089715,81.9570645 624.729143,81.7670184 625.060699,81.7353441 C625.392254,81.7036698 625.652762,81.6878326 625.842223,81.6878326 C628.589397,81.6878326 630.499788,82.5272027 631.573396,84.2059429 C632.236507,85.2195218 632.568062,86.7557275 632.568062,88.8145598 L632.568062,88.8145598 L632.568062,94.8485221 C630.989227,94.9118708 629.418285,95.0148124 627.855238,95.157347 C626.292191,95.2998815 624.405482,95.5928692 622.195112,96.03631 C619.984742,96.4797508 617.932256,97.0261332 616.037653,97.6754572 C614.14305,98.3247813 612.208977,99.2275 610.235432,100.383614 C608.261888,101.539727 606.580428,102.854212 605.191052,104.327069 C603.801677,105.799926 602.664915,107.644957 601.780767,109.862161 C600.896619,112.079365 600.454545,114.518289 600.454545,117.178934 C600.454545,120.061299 600.943985,122.63484 601.922863,124.899555 C602.901741,127.164271 604.212174,128.953871 605.854163,130.268356 C607.496152,131.582841 609.351284,132.620176 611.419559,133.38036 C613.487834,134.140545 615.658733,134.473125 617.932256,134.378102 L617.084495,134.393939 Z M626.328298,121.68454 C624.02209,122.376066 621.826454,122.030303 619.74139,120.647252 C617.529958,119.169902 616.424242,117.07961 616.424242,114.376374 C616.424242,112.270365 616.937611,110.470827 617.964347,108.977761 C618.991083,107.484694 620.36533,106.368824 622.087087,105.630149 C623.808845,104.891474 625.491113,104.364972 627.133891,104.050642 C628.776669,103.736312 630.530018,103.547714 632.393939,103.484848 L632.393939,103.484848 L632.393939,111.123061 C632.393939,112.883308 632.172796,114.470673 631.73051,115.885157 C630.782753,118.965588 628.982016,120.898716 626.328298,121.68454 Z M660.714032,149.270248 C660.995176,149.430064 661.401273,149.28623 661.932322,148.838745 C663.525472,147.528253 664.853096,145.546535 665.915196,142.893589 C666.53996,141.327392 666.985105,139.689277 667.25063,137.979246 C667.516155,136.269215 667.477107,135.158493 667.133487,134.647082 C666.696152,134.071744 665.509099,133.688186 663.572329,133.496407 C661.635559,133.304627 659.948695,133.320609 658.511737,133.544351 C656.949826,133.736131 655.341057,134.215579 653.685431,134.982696 C652.029805,135.749813 651.295707,136.389077 651.483136,136.900488 C651.514375,136.964414 651.537803,137.012359 651.553422,137.044322 C651.569041,137.076286 651.60028,137.100258 651.647137,137.11624 C651.693994,137.132221 651.740852,137.140212 651.787709,137.140212 L651.787709,137.140212 L652.256282,137.140212 C652.334378,137.140212 652.443712,137.132221 652.584284,137.11624 C652.724856,137.100258 652.857618,137.084276 652.982571,137.068295 C653.107524,137.052313 653.279334,137.036332 653.498002,137.02035 C653.716669,137.004368 653.919718,136.980396 654.107147,136.948433 C654.138385,136.948433 654.489815,136.916469 655.161437,136.852543 C655.833059,136.788617 656.317252,136.740672 656.614015,136.708709 C656.910778,136.676745 657.40278,136.644782 658.090021,136.612819 C658.777262,136.580856 659.323931,136.580856 659.730028,136.612819 C660.136124,136.644782 660.596888,136.684736 661.112319,136.732681 C661.62775,136.780626 662.049466,136.876515 662.377467,137.02035 C662.705468,137.164184 662.947565,137.347973 663.103756,137.571715 C663.634806,138.274906 663.533281,139.849094 662.799183,142.294279 C662.065085,144.739464 661.370034,146.681228 660.714032,148.119573 C660.432888,148.726874 660.432888,149.110432 660.714032,149.270248 Z M625.272576,155 C629.013848,155 632.652077,154.609383 636.187262,153.828149 C639.722447,153.046916 642.702782,152.12219 645.128268,151.053972 C647.553754,149.985755 649.789006,148.805933 651.834023,147.514505 C653.87904,146.223078 655.392987,145.138917 656.375864,144.262022 C657.358741,143.385127 658.056266,142.691583 658.46844,142.181389 C658.944025,141.575535 659.181818,141.041426 659.181818,140.579063 C659.181818,140.1167 659.007437,139.837688 658.658674,139.742027 C658.309912,139.646366 657.897737,139.694196 657.422152,139.885519 C651.049307,142.914792 644.850843,145.067171 638.826761,146.342655 C625.827425,149.084945 613.161,147.650025 600.827484,142.037897 C597.403268,140.47543 592.647414,137.828801 586.55992,134.098012 C586.401392,133.970463 586.219084,133.898717 586.012997,133.882774 C585.80691,133.86683 585.624602,133.898717 585.466074,133.978435 C585.307545,134.058153 585.180722,134.169758 585.085605,134.313249 C584.990488,134.456741 584.974635,134.648064 585.038047,134.887217 C585.101458,135.12637 585.259987,135.389439 585.513632,135.676423 C586.591626,136.983793 587.923265,138.378854 589.50855,139.861603 C591.093835,141.344353 593.194337,143.018425 595.810057,144.88382 C598.425777,146.749215 601.160394,148.407344 604.013906,149.858207 C606.867419,151.309069 610.180664,152.52875 613.953642,153.51725 C617.72662,154.50575 621.499598,155 625.272576,155 Z",
                            fillRule: "nonzero"
                        })
                    })
                })
            })
        ]
    });
};
exports.default = AmazonLogo;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"by6Jh":[function(require,module,exports) {
/**
 * AppleLogo.js
 * Apple shortened logo in SVG for crispness.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var AppleLogo = function(param) {
    var _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_title = param.title, title = _param_title === void 0 ? "Apple" : _param_title, _param_fill = param.fill, fill = _param_fill === void 0 ? "#000" : _param_fill, _param_width = param.width, width = _param_width === void 0 ? 200 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 200 : _param_height;
    var cssClasses = (0, _classnamesDefault.default)("apple__logo", cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            aspectRation: "1"
        },
        className: cssClasses,
        width: width,
        height: height,
        viewBox: "0 0 1250 1250",
        version: "1.1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: "1250",
                height: "1250",
                style: {
                    "fill": "none"
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "_clip1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    id: "Artboard11",
                    x: "0",
                    y: "0",
                    width: "1250",
                    height: "1250"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#_clip1)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: fill,
                    d: "M1148.33,912.776c-19.536,62.615 -50.342,125.229 -92.419,187.843c-64.618,98.18 -128.986,147.27 -193.103,147.27c-24.545,0 -59.609,-8.015 -105.193,-24.044c-43.078,-16.03 -80.897,-24.044 -113.457,-24.044c-30.556,0 -66.121,8.265 -106.695,24.795c-40.574,17.031 -73.635,25.547 -99.181,25.547c-76.14,0 -151.527,-64.869 -226.164,-194.606c-73.634,-130.739 -110.452,-256.719 -110.452,-377.941c0,-114.209 28.302,-207.88 84.906,-281.014c56.102,-72.131 127.232,-108.197 213.39,-108.197c36.066,0 80.397,7.513 132.993,22.541c52.095,15.027 86.658,22.541 103.689,22.541c22.541,0 58.357,-8.516 107.447,-25.547c51.093,-17.031 94.422,-25.546 129.987,-25.546c59.609,0 112.957,16.279 160.043,48.839c26.048,18.033 52.095,43.079 78.143,75.137c-39.573,33.562 -68.125,63.116 -85.657,88.662c-32.559,47.086 -48.839,98.931 -48.839,155.535c0,62.113 17.281,117.965 51.845,167.556c34.563,49.591 74.135,81.148 118.717,94.673Zm-282.517,-881.361c0,30.556 -7.263,64.618 -21.79,102.187c-15.027,37.568 -38.32,72.132 -69.877,103.689c-27.05,27.05 -54.099,45.083 -81.149,54.099c-18.534,5.51 -44.581,9.768 -78.143,12.773c1.503,-74.636 21.039,-139.004 58.608,-193.103c37.067,-53.598 99.682,-90.665 187.843,-111.203l3.757,16.53l0.751,15.028Z",
                    style: {
                        "fillRule": "nonZero"
                    }
                })
            })
        ]
    });
};
exports.default = AppleLogo;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iP7nL":[function() {},{}],"d895D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _userProjectsCss = require("../css/UserProjects.css");
var UserProjects = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "UserNoProjects",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "No projects \uD83D\uDE1E"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You haven't been assigned to any projects yet. If this sounds wrong, talk to your project lead."
            })
        ]
    });
};
exports.default = UserProjects;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../css/UserProjects.css":"iP7nL","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iP7nL":[function() {},{}],"2KEhZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _avalogoREVPng = require("../media/AVALogoREV.png");
var _avalogoREVPngDefault = parcelHelpers.interopDefault(_avalogoREVPng);
var _reactRouterDom = require("react-router-dom");
var _loginPageCss = require("../css/LoginPage.css");
var _utilities = require("../js/Utilities");
var _loginUtils = require("../actions/LoginUtils");
var _configuration = require("../js/Configuration");
var LoginPage = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), reqtok = _useState[0], setReqTok = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({}), 2), user = _useState2[0], setUser = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), capslock = _useState3[0], setCapsLock = _useState3[1];
    var abortcontroller = new AbortController();
    var signal = abortcontroller.signal;
    (0, _react.useEffect)(function() {
        (0, _utilities.apirequest)("api/requesttoken", {
            signal: signal
        }, function(response) {
            setReqTok(response.request_token);
        });
    }, []);
    var onFocusHandler = function(domEvent) {
        if (error == true) setError(null);
    };
    var isCapsLocked = function(keyboardEvent) {
        if (keyboardEvent.target.value && keyboardEvent.getModifierState && keyboardEvent.getModifierState("CapsLock")) setCapsLock(true);
        else setCapsLock(false);
    };
    var clearIsCapsLocked = function(keyboardEvent) {
        if (keyboardEvent.target.value.length === 0) setCapsLock(false);
    };
    var redirectTo = function() {
        var redirect = "";
        var user = (0, _utilities.getAuthData)();
        if (Object.hasOwn(user, "permissions")) {
            var projectCount = Object.keys(user.permissions);
            switch(projectCount.length){
                case 0:
                    redirect = "/notassigned";
                    break;
                case 1:
                    redirect = "/".concat(user.permissions[projectCount[0]].path);
                    break;
                default:
                    redirect = "/projects";
            }
        }
        if (window.location.search) {
            var params = new URLSearchParams(window.location.search);
            redirect = params.get("redirect");
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
            to: redirect
        });
    };
    var authenticate = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        var callback = function(response) {
            if (response.result === "success") {
                (0, _utilities.setAuthData)(response);
                setUser(response);
            } else setError((0, _configuration.ERROR_LOGIN_FAILED));
        };
        (0, _loginUtils.login)(fd, callback);
    };
    if ((0, _utilities.getAuthData)("token")) return redirectTo();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "login",
        action: "/ava/api/api/api/login",
        method: "post",
        onSubmit: authenticate,
        onReset: (0, _loginUtils.requestPassword),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                id: "form_error",
                className: "alert alert-danger",
                hidden: !error,
                children: (0, _configuration.ERROR_LOGIN_FAILED)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        id: "tok",
                        name: "tok",
                        value: reqtok
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "login_user_name",
                        children: "User Name:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        id: "login_user_name",
                        name: "uname",
                        required: true,
                        onFocus: onFocusHandler,
                        autoComplete: "username"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "login_user_pass",
                        children: "Password:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        onKeyDown: function(domEvent) {
                            isCapsLocked(domEvent);
                        },
                        id: "login_user_pass",
                        type: "password",
                        name: "pword",
                        "aria-labelledby": "login_user_pass_error",
                        onFocus: onFocusHandler,
                        onChange: function(domEvent) {
                            clearIsCapsLocked(domEvent);
                        },
                        autoComplete: "current-password"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        id: "login_user_pass_error",
                        className: "alert alert-warning",
                        hidden: !capslock,
                        children: (0, _configuration.ERROR_LOGIN_CAPSLOCK)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "login__buttons",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn-success login-btn",
                        children: "Login"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "reset",
                        className: "btn",
                        children: "Forgot Password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _avalogoREVPngDefault.default),
                className: "login-logo",
                alt: "logo"
            })
        ]
    });
};
exports.default = LoginPage;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","../media/AVALogoREV.png":"4dfUt","react-router-dom":"gMZz4","../css/LoginPage.css":"dneOb","../js/Utilities":"euxcI","../actions/LoginUtils":"6nFUs","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4dfUt":[function(require,module,exports) {
module.exports = require("dadd45d1c1c482be").getBundleURL("9ZlAP") + "AVALogoREV.487523c0.png";

},{"dadd45d1c1c482be":"ag1ej"}],"dneOb":[function() {},{}],"6nFUs":[function(require,module,exports) {
/*
LoginUtils.js
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "login", function() {
    return login;
});
parcelHelpers.export(exports, "setStatePostLogin", function() {
    return setStatePostLogin;
});
parcelHelpers.export(exports, "requestPassword", function() {
    return requestPassword;
});
parcelHelpers.export(exports, "requestPasswordSuggestion", function() {
    return requestPasswordSuggestion;
});
parcelHelpers.export(exports, "updateOnPasswordSuggestion", function() {
    return updateOnPasswordSuggestion;
});
parcelHelpers.export(exports, "setStatePasswordResetShowHide", function() {
    return setStatePasswordResetShowHide;
});
parcelHelpers.export(exports, "resetPasswordState", function() {
    return resetPasswordState;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var login = function(formdata, callback) {
    var options = {
        method: "POST",
        body: formdata
    };
    (0, _utilities.apirequest)((0, _configuration.API_USER_LOGIN), options, callback);
};
var setStatePostLogin = function(state, data) {
    var response;
    if (data.result === "success") {
        (0, _utilities.setAuthData)(data);
        response = {
            user: data
        };
    } else response = {
        error: (0, _configuration.ERROR_LOGIN_FAILED)
    };
    return response;
};
var requestPassword = function(domEvent) {
    if (!domEvent.target.elements.uname.value) {
        alert((0, _configuration.ERROR_MISSING_USERNAME));
        return;
    }
    domEvent.preventDefault();
    domEvent.persist();
    var fd = new FormData();
    fd.append("id", domEvent.target.elements.uname.value);
    fd.append("tok", domEvent.target.elements.tok.value);
    var options = {
        method: "POST",
        body: fd
    };
    (0, _utilities.apirequest)((0, _configuration.API_USER_PW_RESET), options, function(response) {
        if (response.result === "success") window.location = "/emailsent";
    });
};
var requestPasswordSuggestion = function(reqtok, callback) {
    var fd = new FormData();
    fd.set("tok", reqtok);
    var options = {
        method: "POST",
        body: fd
    };
    (0, _utilities.apirequest)((0, _configuration.API_USER_SUGGEST_PASSWORD), options, callback);
};
var updateOnPasswordSuggestion = function(state, suggestionObj) {
    return {
        password1: {
            value: suggestionObj.suggestion,
            type: "text"
        }
    };
};
var setStatePasswordResetShowHide = function(state, fieldId) {
    var opts = [
        "password",
        "text"
    ]; // Options we can use.
    var index = +(state[fieldId].type === "password"); // + converts this boolean to an integer
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), (0, _defineProperty._)({}, fieldId, (0, _objectSpreadProps._)((0, _objectSpread._)({}, state[fieldId]), {
        type: opts[index]
    })));
};
var resetPasswordState = {
    password1: {
        value: "",
        type: "password"
    },
    password2: {
        value: "",
        type: "password"
    },
    strength: 0,
    length: 0,
    canSave: true,
    token: "",
    reqtok: "",
    expired: false,
    message: null,
    mode: null
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","../js/Utilities":"euxcI","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6PxNd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _utilities = require("../js/Utilities");
var _logoutPageCss = require("../css/logoutPage.css");
var LogoutPage = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(), 2), user = _useState[0], setUser = _useState[1];
    (0, _react.useEffect)(function() {
        (0, _utilities.apirequest)("api/logout", {
            method: "GET"
        }, function() {
            (0, _utilities.removeAuthData)();
            setUser(null);
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "content",
        className: "logout__page",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "You're now logged out."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/",
                    children: "Log in again"
                })
            ]
        })
    });
};
exports.default = LogoutPage;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","../js/Utilities":"euxcI","../css/logoutPage.css":"5zuHZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"5zuHZ":[function() {},{}],"4RSCV":[function(require,module,exports) {
/**
 * UpdateAccountPage.jsx
 * Enables users to update their own account page.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lodashIsnull = require("lodash.isnull");
var _lodashIsnullDefault = parcelHelpers.interopDefault(_lodashIsnull);
var _actionMessageDisplay = require("./subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _passwordResetShowHide = require("./UpdateAccount/PasswordResetShowHide");
var _passwordResetShowHideDefault = parcelHelpers.interopDefault(_passwordResetShowHide);
var _iconApprovedRejected = require("./subcomponents/IconApprovedRejected");
var _meter = require("./subcomponents/Meter");
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _loginUtils = require("../actions/LoginUtils");
var _userUtils = require("../actions/UserUtils");
var _fancyCheckboxesCss = require("./subcomponents/css/fancy-checkboxes.css");
var _updateAccountPageCss = require("./UpdateAccount/css/UpdateAccountPage.css");
var UpdateAccountPage = function() {
    var _pw1ref_current, _pw2ref_current;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        user: "",
        uuid: "",
        email: ""
    }), 2), userData = _useState[0], setUserData = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _loginUtils.resetPasswordState)), 2), passwordData = _useState1[0], setPasswordData = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)((0, _userUtils.formFocusInitState)), 2), updateStatus = _useState2[0], setUpdateStatus = _useState2[1];
    var pw1ref = (0, _react.useRef)(null);
    var pw2ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var fd = new FormData();
        fd.set("id", (0, _utilities.getAuthData)("uid"));
        fd.set("uid", (0, _utilities.getAuthData)("uuid"));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_USERS_GETUSERINFO), {
            body: fd
        }, function(data) {
            setUserData((0, _userUtils.setStateOnLoadUser)(userData, data));
        });
    }, []);
    var onChange = function(domEvent) {
        var _domEvent_target = domEvent.target, name = _domEvent_target.name, value = _domEvent_target.value;
        var data = (0, _userUtils.setStateUpdateField)(userData, name, value);
        setUserData(data);
    };
    var onChangePass = function() {
        checkPassStrength();
        checkPassMatch();
    };
    var updateAccount = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        var user = userData.user, first_name = userData.first_name, second_name = userData.second_name, email = userData.email, uuid = userData.uuid, uid = userData.uid;
        fd.set("username", user);
        fd.set("displayname", "".concat(first_name, "|").concat(second_name));
        fd.set("name1", first_name);
        fd.set("name2", second_name);
        fd.set("email", email);
        fd.set("id", uid);
        fd.set("uuid", uuid);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        if (passwordData.password1.value && passwordData.canSave) fd.set("password", passwordData.password1.value);
        (0, _utilities.apirequest)((0, _configuration.API_USERS_UPDATEUSER), {
            body: fd
        }, function(response) {
            if (response.status === "failed") alert(response.message);
            else alert("Changes saved.");
        });
    };
    var onSuggestionRequest = function() {
        (0, _loginUtils.requestPasswordSuggestion)((0, _utilities.getAuthData)("token"), function(response) {
            var pword = (0, _objectSpreadProps._)((0, _objectSpread._)({}, passwordData), {
                password1: (0, _objectSpreadProps._)((0, _objectSpread._)({}, passwordData.password1), {
                    value: response.suggestion,
                    type: "text" // makes password suggestion visible.
                })
            });
            setPasswordData(pword);
        });
    };
    var onShowPassword = function(domEvent) {
        if (domEvent.target.nodeName !== "BUTTON") return;
        var controls = domEvent.target.dataset.controls;
        var pwData = (0, _loginUtils.setStatePasswordResetShowHide)(passwordData, controls);
        setPasswordData(pwData);
    };
    var checkPassStrength = function() {
        if (!Object.hasOwn(pw1ref, "current")) return;
        var fd = new FormData();
        fd.set("tok", (0, _utilities.getAuthData)("token"));
        fd.set("password1", pw1ref.current.value);
        (0, _utilities.apirequest)((0, _configuration.API_USER_TEST_PASS), {
            body: fd
        }, function(response) {
            var pwData = (0, _objectSpread._)({}, passwordData, response);
            setPasswordData(pwData);
        });
    };
    var checkPassMatch = function() {
        var doesMatch = false;
        if (Object.hasOwn(pw1ref, "current") && Object.hasOwn(pw2ref, "current")) doesMatch = pw1ref.current.value === pw2ref.current.value;
        setPasswordData((0, _objectSpreadProps._)((0, _objectSpread._)({}, passwordData), {
            canSave: doesMatch
        }));
        return doesMatch;
    };
    var showAction = function() {
        var update_status = updateStatus.update_status, action_mode = updateStatus.action_mode;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
            mode: action_mode,
            hidden: action_mode === null,
            message: update_status
        });
    };
    var isStrong = function() {
        var strong = false;
        if (passwordData && Object.hasOwn(passwordData, "strength")) strong = passwordData.strength >= 3;
        return strong;
    };
    var isApproved = function() {
        var approved = false;
        if (isStrong()) approved = true;
        return approved;
    };
    var hasPass1 = function() {
        return Object.hasOwn(pw1ref, "current") && !(0, _lodashIsnullDefault.default)(pw1ref.current) && pw1ref.current.value;
    };
    var hasPass2 = function() {
        return Object.hasOwn(pw2ref, "current") && !(0, _lodashIsnullDefault.default)(pw2ref.current) && pw2ref.current.value;
    };
    var isApproved2 = function() {
        var doesMatch = false;
        if (hasPass1() && hasPass2()) doesMatch = pw1ref.current.value === pw2ref.current.value;
        return doesMatch;
    };
    var saveEnabled = function() {
        var ok = passwordData.canSave;
        if (hasPass1() || hasPass2()) ok = isApproved2();
        return ok;
    };
    var user = userData.user, uuid = userData.uuid, email = userData.email;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "update__account",
        children: [
            showAction(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                action: (0, _configuration.API_USERS_UPDATEUSER),
                method: "POST",
                onSubmit: updateAccount,
                onFocus: function() {
                    return setUpdateStatus((0, _userUtils.formFocusInitState));
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                name: "uuid",
                                id: "uuid",
                                value: uuid
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "name",
                                children: "User Name:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "form-control",
                                type: "text",
                                name: "name",
                                id: "name",
                                value: user,
                                disabled: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "email",
                                children: "User Email:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                className: "form-control",
                                name: "email",
                                id: "email",
                                defaultValue: email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "password1",
                                children: "Enter new password"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn--request",
                                onClick: onSuggestionRequest,
                                children: "Get a password suggestion"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "set__pass__approvable",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordResetShowHideDefault.default), {
                                        ref: pw1ref,
                                        type: passwordData.password1.type,
                                        name: "password1",
                                        id: "password1",
                                        minLength: "12",
                                        defaultValue: passwordData.password1.value,
                                        onChange: onChangePass,
                                        onClick: onShowPassword,
                                        "aria-describedby": "password1-note",
                                        autoComplete: "new-password"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        className: "set__pass__approved",
                                        role: "img",
                                        "aria-label": isStrong() ? "Unacceptable" : "Approved",
                                        hidden: !(pw1ref === null || pw1ref === void 0 ? void 0 : (_pw1ref_current = pw1ref.current) === null || _pw1ref_current === void 0 ? void 0 : _pw1ref_current.value.length) > 0,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconApprovedRejected.IconApprovedRejected), {
                                            approved: isApproved()
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "password1-note",
                                className: "set__pass__note",
                                dangerouslySetInnerHTML: (0, _configuration.SET_PASS_RULES)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "set__pass__passwordindic",
                        children: [
                            "Strength:",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _meter.Meter), {
                                className: "password__strength",
                                max: "4",
                                low: "3",
                                optimum: "3.999",
                                value: passwordData.strength
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "password2",
                                children: "Confirm new password"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "set__pass__approvable",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordResetShowHideDefault.default), {
                                        ref: pw2ref,
                                        type: passwordData.password2.type,
                                        name: "password2",
                                        id: "password2",
                                        minLength: "12",
                                        defaultValue: passwordData.password2.value,
                                        onChange: onChangePass,
                                        onClick: onShowPassword,
                                        ariaDescribedBy: "password2-note",
                                        autoComplete: "new-password",
                                        disabled: !isStrong()
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        className: "set__pass__approved",
                                        role: "img",
                                        "aria-label": isStrong() ? "Unacceptable" : "Approved",
                                        hidden: !(pw2ref === null || pw2ref === void 0 ? void 0 : (_pw2ref_current = pw2ref.current) === null || _pw2ref_current === void 0 ? void 0 : _pw2ref_current.value.length) > 0,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconApprovedRejected.IconApprovedRejected), {
                                            approved: isApproved2()
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "password2-note",
                                className: "set__pass__note",
                                children: (0, _configuration.SET_PASS_RULES2)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Display Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "first_name",
                                        children: "First Name:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "form-control",
                                        name: "first_name",
                                        id: "first_name",
                                        defaultValue: userData.first_name,
                                        onInput: onChange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "second_name",
                                        children: "Second Name:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "form-control",
                                        name: "second_name",
                                        id: "second_name",
                                        defaultValue: userData.second_name,
                                        onInput: onChange
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn--action",
                            disabled: !saveEnabled(),
                            children: "Update Account Info"
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = UpdateAccountPage;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","lodash.isnull":"gPzRz","./subcomponents/ActionMessageDisplay":"bzcdY","./UpdateAccount/PasswordResetShowHide":"iAzs9","./subcomponents/IconApprovedRejected":"x7bFl","./subcomponents/Meter":"iWD1e","../js/Configuration":"k3dur","../js/Utilities":"euxcI","../actions/LoginUtils":"6nFUs","../actions/UserUtils":"be4Pt","./subcomponents/css/fancy-checkboxes.css":"QlDSe","./UpdateAccount/css/UpdateAccountPage.css":"bbMSY","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gPzRz":[function(require,module,exports) {
/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function isNull(value) {
    return value === null;
}
module.exports = isNull;

},{}],"iAzs9":[function(require,module,exports) {
/**
 * PasswordResetShowHide.js
 * Toggle between type="password" and type="text"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _passwordResetShowHideCss = require("./css/PasswordResetShowHide.css");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PasswordResetShowHide = /*#__PURE__*/ (0, _react.forwardRef)(function PasswordResetShowHide(props, ref) {
    var ariaDescribedBy = props.ariaDescribedBy, defaultValue = props.defaultValue, disabled = props.disabled, id = props.id, type = props.type, onClick = props.onClick, onChange = props.onChange, minLength = props.minLength;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "PasswordResetShowHide__item",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                id: id,
                name: id,
                type: type,
                onChange: onChange,
                ref: ref,
                disabled: disabled,
                minLength: minLength,
                "aria-describedby": ariaDescribedBy,
                defaultValue: defaultValue
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                "data-controls": id,
                className: "btn btn--action",
                type: "button",
                hidden: type === "text",
                onClick: onClick,
                children: "Show?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                "data-controls": id,
                className: "btn btn--action",
                type: "button",
                hidden: type === "password",
                onClick: onClick,
                children: "Hide"
            })
        ]
    });
});
PasswordResetShowHide.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    type: (0, _propTypesDefault.default).string.isRequired,
    onClick: (0, _propTypesDefault.default).func.isRequired,
    onChange: (0, _propTypesDefault.default).func.isRequired
};
exports.default = PasswordResetShowHide;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./css/PasswordResetShowHide.css":"2EJTG","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2EJTG":[function() {},{}],"iWD1e":[function(require,module,exports) {
/**
 * Meter.jsx
 * A no-framework meter input
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Meter", function() {
    return Meter;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var Meter = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("meter", (0, _objectSpread._)({}, props));
};

},{"@swc/helpers/_/_object_spread":"95yNt","react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"be4Pt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStateOnLoadUser", function() {
    return setStateOnLoadUser;
});
parcelHelpers.export(exports, "setStateOnPasswordChange", function() {
    return setStateOnPasswordChange;
});
parcelHelpers.export(exports, "setStateUpdateField", function() {
    return setStateUpdateField;
});
parcelHelpers.export(exports, "updateOnPasswordSuggestion", function() {
    return updateOnPasswordSuggestion;
});
parcelHelpers.export(exports, "setStateAfterUpdate", function() {
    return setStateAfterUpdate;
});
parcelHelpers.export(exports, "setStateOnFormFocus", function() {
    return setStateOnFormFocus;
});
parcelHelpers.export(exports, "formFocusInitState", function() {
    return formFocusInitState;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utilities = require("../js/Utilities");
var setStateOnLoadUser = function(state, data) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        user: data.username,
        first_name: data.displayname_first || "",
        second_name: data.displayname_second || "",
        email: data.email,
        uuid: data.uuid,
        uid: data.id
    });
};
var setStateOnPasswordChange = function(state, field, input) {
    var updates = (0, _defineProperty._)({}, field, (0, _objectSpreadProps._)((0, _objectSpread._)({}, state[field]), {
        value: input
    }));
    if (field === "password1" && input === "") updates.password2 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.password2), {
        value: ""
    });
    return updates;
};
var setStateUpdateField = function(state, field, input) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), (0, _defineProperty._)({}, field, input));
};
var updateOnPasswordSuggestion = function(state, suggestionObj) {
    return {
        password1: {
            value: suggestionObj.suggestion,
            type: "text"
        },
        canSave: false
    };
};
var setStateAfterUpdate = function(state, response) {
    /* let updates = {
    action_mode: response.status,
    update_status: response.message
  };

  let userUpdates = {}
  if(response.hasOwnProperty('data')) {
    userUpdates = {
      ...getAuthData(),
      display_name: response.data.displayname,
      email: response.data.email,
      user: response.data.username
    }
    setAuthData(userUpdates);
  }
  return Object.assign(updates, userUpdates); */ console.log(response);
};
var setStateOnFormFocus = function(state) {
    return {
        update_status: null,
        action_mode: null
    };
};
var formFocusInitState = {
    update_status: null,
    action_mode: null
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"QlDSe":[function() {},{}],"bbMSY":[function() {},{}],"8H1vn":[function(require,module,exports) {
/**
 * Created by Webinista, Inc 3/23/18.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listDisplay = require("./Reports/ListDisplay");
var _listDisplayDefault = parcelHelpers.interopDefault(_listDisplay);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _dashboardCounts = require("./Reports/DashboardCounts");
var _dashboardCountsDefault = parcelHelpers.interopDefault(_dashboardCounts);
var _reactRouterDom = require("react-router-dom");
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var _reportsPageCss = require("../css/reportsPage.css");
var ReportsDashboardPage = function() {
    var fetchCancel = new AbortController();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), channels = _useState[0], setChannels = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(0), 2), destinations = _useState1[0], setDestinations = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), reports = _useState2[0], setReports = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(0), 2), stations = _useState3[0], setStations = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(0), 2), videos = _useState4[0], setVideos = _useState4[1];
    (0, _react.useEffect)(function() {
        var signal = fetchCancel.signal;
        if (!reports.length) {
            var fd = new FormData();
            fd.set("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_REPORTS), {
                body: fd,
                signal: signal
            }, function(data) {
                setChannels(+data.count_channels);
                setDestinations(+data.count_destinations);
                setReports(data.reports);
                setVideos(+data.count_videos);
                setStations(+data.count_stations);
            });
        }
        return function() {
            return fetchCancel.abort();
        };
    }, [
        fetchCancel
    ]);
    var display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    if (reports.length) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDisplayDefault.default), {
        items: reports
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Reports"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardCountsDefault.default), {
                videos: videos,
                destinations: destinations,
                channels: channels,
                stations: stations
            }),
            display
        ]
    });
};
// eslint-disable-next-line react/display-name
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsDashboardPage, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useLocation)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","./Reports/ListDisplay":"ldJtc","./subcomponents/LoaderSimple":"1dSHa","./Reports/DashboardCounts":"587lN","react-router-dom":"gMZz4","../js/Utilities":"euxcI","../js/Configuration":"k3dur","../css/reportsPage.css":"67ZQ7","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ldJtc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var ListDisplay = function(param) {
    var items = param.items;
    var reports = items.map(function(item, index) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    className: "reports__link",
                    to: "/reports/display/".concat(item.api_path.split("/")[1]),
                    state: {
                        title: item.title
                    },
                    children: item.title
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                item.description
            ]
        }, index.toString());
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        children: reports
    });
};
exports.default = ListDisplay;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"587lN":[function(require,module,exports) {
/**
 * DashboardCounts.jsx
 * Displays dashboard videos, channels, and destinations counts.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utilities = require("../../js/Utilities");
var DashboardCounts = function(param) {
    var _param_videos = param.videos, videos = _param_videos === void 0 ? 0 : _param_videos, _param_destinations = param.destinations, destinations = _param_destinations === void 0 ? 0 : _param_destinations, _param_channels = param.channels, channels = _param_channels === void 0 ? 0 : _param_channels, _param_stations = param.stations, stations = _param_stations === void 0 ? 0 : _param_stations;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "reports__dashboard__count",
        children: [
            "Cataloguing ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "reports__dashboard__count__num",
                children: (0, _utilities.numberFormat)(videos)
            }),
            " videos and ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "reports__dashboard__count__num",
                children: (0, _utilities.numberFormat)(channels)
            }),
            " channels for",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "reports__dashboard__count__num",
                children: (0, _utilities.numberFormat)(destinations)
            }),
            " destinations and ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "reports__dashboard__count__num",
                children: (0, _utilities.numberFormat)(stations)
            }),
            " stations."
        ]
    });
};
DashboardCounts.propTypes = {
    videos: (0, _propTypesDefault.default).number.isRequired,
    destinations: (0, _propTypesDefault.default).number.isRequired,
    channels: (0, _propTypesDefault.default).number.isRequired,
    stations: (0, _propTypesDefault.default).number.isRequired
};
exports.default = DashboardCounts;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"67ZQ7":[function() {},{}],"4Pu6A":[function(require,module,exports) {
/**
 * ReportsVideoDestinations
 * Displays Top Videos by Destination report results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reportSearch = require("./ReportSearch");
var _reportSearchDefault = parcelHelpers.interopDefault(_reportSearch);
var _reportsResults = require("./ReportsResults");
var _reportsResultsDefault = parcelHelpers.interopDefault(_reportsResults);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var ReportsVideoDestinations = function(param) {
    var _param_params = param.params, params = _param_params === void 0 ? null : _param_params;
    var _params_state;
    var limit = "500";
    var display;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), destination = _useState[0], setDestination = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), destinations = _useState1[0], setDestinations = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(""), 2), end = _useState2[0], setEndDate = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([]), 2), videos = _useState3[0], setVideos = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)([]), 2), results = _useState5[0], setResults = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(""), 2), start = _useState6[0], setStartDate = _useState6[1];
    var massageResults = function(results) {
        var res = results.map(function(result) {
            return {
                title: result["Video Title"],
                url: result.youtubeID,
                frequency: result.Frequency
            };
        });
        // setCount(res.length);
        return res;
    };
    var onSearchSubmit = function(domEvent) {
        domEvent.preventDefault();
        setLoading(true);
        setDestination(domEvent.target.destination.value);
        setStartDate(domEvent.target.start.value);
        setEndDate(domEvent.target.end.value);
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_VIDSBYDEST), {
            body: fd
        }, function(data) {
            if (data) {
                setVideos(data === null || data === void 0 ? void 0 : data.data);
                setResults(data === null || data === void 0 ? void 0 : data.data.length);
                setLoading(false);
            }
        });
    };
    (0, _react.useEffect)(function() {
        if (destinations.length) return;
        var fetchCancel = new AbortController();
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_LIST), {
            body: fd,
            signal: signal
        }, function(data) {
            return setDestinations(data);
        });
        return function() {
            if (destinations.length) fetchCancel.abort();
        };
    });
    if (loading) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsResultsDefault.default), {
        columnHeadings: [
            "Video Title",
            "Frequency"
        ],
        results: massageResults(videos),
        start: start,
        end: end,
        destination: destination,
        downloadURL: "".concat((0, _configuration.API_REPORTS_VIDSBYDEST), "/csv"),
        limit: limit
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: params === null || params === void 0 ? void 0 : (_params_state = params.state) === null || _params_state === void 0 ? void 0 : _params_state.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportSearchDefault.default), {
                apiURL: (0, _configuration.API_REPORTS_VIDSBYDEST),
                destinations: destinations,
                id: "destination",
                labelText: "Select a destination:",
                limit: limit,
                name: "destination",
                onSubmitHandler: onSearchSubmit
            }),
            display
        ]
    });
};
// eslint-disable-next-line react/display-name
exports.default = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVideoDestinations, {
        params: (0, _reactRouterDom.useLocation)()
    });
};

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./ReportSearch":"ehCb2","./ReportsResults":"buFAk","../subcomponents/LoaderSimple":"1dSHa","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ehCb2":[function(require,module,exports) {
/**
 * Search.jsx
 * Search form for Top Channels by Destination, Top Videos by Destination
 * Author: Webinista, Inc 3/24/18.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateInput = require("../subcomponents/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
var _selectMenu = require("../subcomponents/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var ReportSearch = function(param) {
    var name = param.name, onChangeHandler = param.onChangeHandler, onModalClickHandler = param.onModalClickHandler, onSubmitHandler = param.onSubmitHandler, _param_destinations = param.destinations, destinations = _param_destinations === void 0 ? [] : _param_destinations, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_apiURL = param.apiURL, apiURL = _param_apiURL === void 0 ? "" : _param_apiURL, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "NEEDS A LABEL" : _param_labelText, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_limit = param.limit, limit = _param_limit === void 0 ? "500" : _param_limit;
    var defaultDate = function() {
        var theDate = new Date();
        var month = theDate.getMonth().toString().length < 2 ? "0".concat(theDate.getMonth() + 1) : theDate.getMonth();
        var date = theDate.getDate().toString().length < 2 ? "0".concat(theDate.getDate()) : theDate.getDate();
        return "".concat(theDate.getFullYear(), "-").concat(month, "-").concat(date);
    };
    var makeOptions = function(inputArray) {
        return inputArray.map(function(item, index) {
            return {
                label: item.dName,
                value: "".concat(item.dID)
            };
        });
    };
    var cssClasses = (0, _classnamesDefault.default)(cssClass, {
        "reports__destination__search": true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            id: "reports_destination_search",
            action: apiURL,
            method: "POST",
            className: cssClasses,
            onSubmit: onSubmitHandler,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "hidden",
                    id: "limit",
                    name: "limit",
                    value: limit
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                    firstEmpty: true,
                    labelText: labelText,
                    name: name,
                    onChange: onChangeHandler,
                    options: makeOptions(destinations),
                    isRequired: true,
                    cssClass: "destination-select"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                    name: "start",
                    labelText: "Start of date range:",
                    isRequired: false
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                    name: "end",
                    labelText: "End of date range:",
                    isRequired: false
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    className: "btn btn--action",
                    children: "Search"
                })
            ]
        })
    });
};
ReportSearch.propTypes = {
    apiURL: (0, _propTypesDefault.default).string.isRequired,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    name: (0, _propTypesDefault.default).string.isRequired,
    cssClass: (0, _propTypesDefault.default).string,
    onChangeHandler: (0, _propTypesDefault.default).func,
    onSubmitHandler: (0, _propTypesDefault.default).func,
    destinations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        dID: (0, _propTypesDefault.default).string,
        dName: (0, _propTypesDefault.default).string
    })),
    value: (0, _propTypesDefault.default).string.isRequired
};
exports.default = ReportSearch;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/DateInput":"90qRl","../subcomponents/SelectMenu":"da8gs","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"buFAk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utilities = require("../../js/Utilities");
var _downloadCSV = require("../subcomponents/DownloadCSV");
var ReportsResults = function(param) {
    var _param_results = param.results, results = _param_results === void 0 ? [] : _param_results, _param_columnHeadings = param.columnHeadings, columnHeadings = _param_columnHeadings === void 0 ? [] : _param_columnHeadings, _param_destination = param.destination, destination = _param_destination === void 0 ? "0" : _param_destination, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_limit = param.limit, limit = _param_limit === void 0 ? 500 : _param_limit;
    var makeColumnHeadings = function(headingsArray) {
        var ths = headingsArray.map(function(h, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                children: h
            }, index.toString());
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: ths
            })
        });
    };
    var makeCells = function(rowObject) {
        var fields = Object.keys(rowObject).filter(function(key) {
            return key !== "url";
        });
        var tds = fields.map(function(f, index) {
            var cell;
            if (f === "title") {
                if (rowObject.hasOwnProperty("url")) cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: rowObject.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: rowObject.title
                });
                else cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    children: rowObject.title
                });
            } else cell = rowObject[f];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: cell
            }, "".concat(f, "_").concat(index.toString()));
        });
        return tds;
    };
    var makeRows = function(rowsArray) {
        return rowsArray.map(function(item, index) {
            var cells = makeCells(item);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: cells
            }, index.toString());
        });
    };
    var makeTable = function(headerArray, rowsArray) {
        var rows = makeRows(rowsArray);
        var header = makeColumnHeadings(headerArray);
        var css = "reports__table__results reports__results__viddest ".concat(cssClass);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: css,
            children: [
                header,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: rows
                })
            ]
        });
    };
    var onDownload = function(domEvent) {
        domEvent.preventDefault();
        var csvHeaders = Object.keys(results[0]).map(function(c) {
            return "".concat(c.charAt(0).toUpperCase()).concat(c.slice(1));
        });
        var csv = [
            [
                csvHeaders
            ],
            results.map(function(r) {
                return [
                    '"'.concat(r.title, '"'),
                    '"'.concat(r.url, '"'),
                    '"'.concat(r.frequency, '"')
                ];
            })
        ].reduce(function(accumulator, value) {
            return accumulator.concat(value);
        }, []);
        (0, _utilities.pushDownload)(csv);
    };
    // Will stop executing if we don't have a results count.
    if (!results.length) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
        children: "No results for this report."
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downloadCSV.DownloadCSV), {
                count: results.length,
                destination: destination,
                onSubmit: onDownload
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reports__table__overflow",
                children: makeTable(columnHeadings, results)
            })
        ]
    });
};
exports.default = ReportsResults;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../../js/Utilities":"euxcI","../subcomponents/DownloadCSV":"1jJnn","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1jJnn":[function(require,module,exports) {
/**
 * DownloadCSV.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DownloadCSV", function() {
    return DownloadCSV;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loaderSimple = require("./LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _downloadCSVCss = require("./css/DownloadCSV.css");
var DownloadCSV = function(param) {
    var _param_count = param.count, count = _param_count === void 0 ? 0 : _param_count, onSubmit = param.onSubmit, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_working = param.working, working = _param_working === void 0 ? false : _param_working, _param_destination = param.destination, destination = _param_destination === void 0 ? "0" : _param_destination;
    var countString = "".concat(count, " results");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "reports__result_count",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "destination",
                value: destination,
                onChange: function() {}
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: countString
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "submit",
                className: "download",
                disabled: disabled || working,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: "Download CSV"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                        open: working,
                        cssClass: "downloading__indicator",
                        title: "Downloading data"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./LoaderSimple":"1dSHa","./css/DownloadCSV.css":"l4JM8","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"l4JM8":[function() {},{}],"amSfH":[function(require,module,exports) {
/**
 * ReportsChannels
 * Component display for reports/display/channels
 * Last modified: 18 Oct 2023
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reportsResults = require("./ReportsResults");
var _reportsResultsDefault = parcelHelpers.interopDefault(_reportsResults);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var ReportsChannels = function(param) {
    var _param_params = param.params, params = _param_params === void 0 ? null : _param_params;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), channels = _useState[0], setChannels = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(null), 2), results = _useState2[0], setResults = _useState2[1];
    var massageResults = function(results) {
        return results.map(function(result) {
            return {
                title: result["channel_title"],
                url: result["youtubeID"],
                id: result["video_channelID"],
                frequency: result["frequency"]
            };
        });
    };
    (0, _react.useEffect)(function() {
        if (channels.length) return;
        var fetchCancel = new AbortController();
        var fd = new FormData();
        fd.set("limit", 100);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        var signal = fetchCancel.signal;
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_CHANNELS), {
            body: fd,
            signal: signal
        }, function(data) {
            setChannels(data.data);
            setResults(data.data.length), setLoading(false);
        });
        return function() {
            if (channels.length) fetchCancel.abort();
        };
    });
    if (loading) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: loading
    });
    else display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsResultsDefault.default), {
        columnHeadings: [
            "Channel Title",
            "Frequency"
        ],
        results: massageResults(channels),
        count: results,
        downloadURL: "".concat((0, _configuration.API_REPORTS_CHANNELS), "/csv")
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: params.state.title
            }),
            display
        ]
    });
};
exports.default = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsChannels, {
        params: (0, _reactRouterDom.useLocation)()
    });
};

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./ReportsResults":"buFAk","../subcomponents/LoaderSimple":"1dSHa","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fB4ud":[function(require,module,exports) {
/**
 * ReportsVidSetDestinations
 * View for /reports/display/videosetdestinations
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchText = require("./SearchText");
var _searchTextDefault = parcelHelpers.interopDefault(_searchText);
var _reportsResults = require("./ReportsResults");
var _reportsResultsDefault = parcelHelpers.interopDefault(_reportsResults);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _reactRouterDom = require("react-router-dom");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var ReportsVidSetDestinations = function(props) {
    var inputHandler = function inputHandler(domEvent) {
        var fd = new FormData();
        fd.set("search", domEvent.target.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_VIDSET_TYPEAHEAD), {
            body: fd
        }, function(data) {
            setVideoSets(data.data);
            setResults(data.data.length);
        });
    };
    var searchSubmitHandler = function searchSubmitHandler(domEvent) {
        domEvent.preventDefault();
        setLoading(true);
        var videoset = videosets.find(function(vid) {
            return vid.setName.toLowerCase().includes(domEvent.target.videoset.value.toLowerCase());
        });
        var fd = new FormData(domEvent.target);
        fd.set("videoset", videoset.setId);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_DESTINATIONSBYVIDSET), {
            body: fd
        }, function(data) {
            setDestinations(data.data);
            setResults(data.data.length);
            setLoading(false);
        });
    };
    var massageResults = function massageResults(results) {
        var res = results.map(function(result) {
            return {
                title: result.setName,
                id: result.setId,
                frequency: result.frequency
            };
        });
        return res;
    };
    var makeDataListInput = function makeDataListInput() {
        var results = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (!results.length) return;
        var res = results.map(function(result) {
            return {
                title: result.setName,
                id: result.setId
            };
        });
        return res;
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), videoset = _useState[0], setVideoSet = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), videosets = _useState1[0], setVideoSets = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), destinations = _useState2[0], setDestinations = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState3[0], setLoading = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(0), 2), results = _useState4[0], setResults = _useState4[1];
    (0, _react.useEffect)(function() {
        window.scrollTo(0, 0);
    });
    if (loading) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsResultsDefault.default), {
        columnHeadings: [
            "Video set title",
            "Frequency"
        ],
        results: massageResults(destinations),
        count: results,
        downloadURL: "".concat((0, _configuration.API_REPORTS_DESTINATIONSBYVIDSET), "/csv"),
        videoset: videoset
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: props.params.state.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextDefault.default), {
                apiURL: (0, _configuration.API_REPORTS_DESTINATIONSBYVIDSET),
                datalist: makeDataListInput(videosets),
                id: "videoset",
                labelText: "Enter a video set or series title:",
                name: "videoset",
                onSubmit: searchSubmitHandler,
                onInput: inputHandler,
                limit: "50"
            }),
            display
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVidSetDestinations, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useLocation)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","./SearchText":"etbFs","./ReportsResults":"buFAk","../subcomponents/LoaderSimple":"1dSHa","react-router-dom":"gMZz4","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"etbFs":[function(require,module,exports) {
/**
 * SearchText
 * Search form for Top Channels by Destination, Top Videos by Destination reports
 * Author: Webinista, Inc 3/24/18.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _this = undefined;
var SearchText = function(param) {
    var _param_apiURL = param.apiURL, apiURL = _param_apiURL === void 0 ? null : _param_apiURL, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? {} : _param_cssClass, _param_id = param.id, id = _param_id === void 0 ? null : _param_id, _param_name = param.name, name = _param_name === void 0 ? null : _param_name, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "NEEDS A LABEL" : _param_labelText, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit, _param_onInput = param.onInput, onInput = _param_onInput === void 0 ? null : _param_onInput, _param_onSubmit = param.onSubmit, onSubmit = _param_onSubmit === void 0 ? null : _param_onSubmit, _param_datalist = param.datalist, datalist = _param_datalist === void 0 ? [] : _param_datalist, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value;
    var makeDataList = function(arrayOfOptions) {
        return arrayOfOptions.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: item.title
            }, index.toString());
        });
    };
    var cssClasses = (0, _classnamesDefault.default)(cssClass, {
        "reports__vidset__search": true
    });
    var dataList = null;
    var dataListAttr = null;
    if (_this.props.datalist) {
        dataListAttr = "".concat(id, "_dl");
        dataList = /*#__PURE__*/ (0, _jsxRuntime.jsx)("datalist", {
            id: dataListAttr,
            children: makeDataList(datalist)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        id: "reports_videoset_search",
        action: apiURL,
        method: "POST",
        className: cssClasses,
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                id: "limit",
                name: "limit",
                value: limit
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: labelText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        id: id || name,
                        name: name,
                        onChange: onInput,
                        list: dataListAttr,
                        required: true,
                        autoComplete: "off",
                        defaultValue: value
                    }),
                    dataList,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        children: "Search"
                    })
                ]
            })
        ]
    });
};
SearchText.propTypes = {
    apiURL: (0, _propTypesDefault.default).string.isRequired,
    id: (0, _propTypesDefault.default).string,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    limit: (0, _propTypesDefault.default).number,
    name: (0, _propTypesDefault.default).string.isRequired,
    cssClass: (0, _propTypesDefault.default).string,
    onInput: (0, _propTypesDefault.default).func,
    onSubmit: (0, _propTypesDefault.default).func,
    destinations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        dID: (0, _propTypesDefault.default).string,
        dName: (0, _propTypesDefault.default).string
    })),
    value: (0, _propTypesDefault.default).string.isRequired,
    datalist: (0, _propTypesDefault.default).array
};
exports.default = SearchText;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"g33bw":[function(require,module,exports) {
/**
 * ReportsChannelsDestinations
 * Displays reports/display/channels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reportSearch = require("./ReportSearch");
var _reportSearchDefault = parcelHelpers.interopDefault(_reportSearch);
var _reportsResults = require("./ReportsResults");
var _reportsResultsDefault = parcelHelpers.interopDefault(_reportsResults);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var ReportsChannelsDestinations = function(param) {
    var params = param.params;
    var display;
    var limit = "500";
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), destination = _useState[0], setDestination = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), destinations = _useState1[0], setDestinations = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(""), 2), end = _useState2[0], setEndDate = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([]), 2), channels = _useState3[0], setChannels = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(null), 2), results = _useState5[0], setResults = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(""), 2), start = _useState6[0], setStartDate = _useState6[1];
    (0, _react.useEffect)(function() {
        if (destinations.length) return;
        var fetchCancel = new AbortController();
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_LIST), {
            body: fd,
            signal: signal
        }, function(data) {
            return setDestinations(data);
        });
        return function() {
            if (destinations.length) fetchCancel.abort();
        };
    });
    var massageResults = function(results) {
        var res = results.map(function(result) {
            return {
                title: result["channel_title"],
                url: result["youtubeID"],
                frequency: result["frequency"]
            };
        });
        return res;
    };
    var onSearchSubmit = function(domEvent) {
        domEvent.preventDefault();
        setLoading(true);
        setDestination(domEvent.target.destination.value);
        setStartDate(domEvent.target.start.value);
        setEndDate(domEvent.target.end.value);
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_CHANNELSBYDEST), {
            body: fd
        }, function(data) {
            setChannels(data.data);
            setResults(data.data.length);
            setLoading(false);
        });
    };
    if (loading) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsResultsDefault.default), {
        columnHeadings: [
            "Channel Title",
            "Frequency"
        ],
        results: massageResults(channels),
        count: results,
        start: start,
        end: end,
        destination: destination,
        downloadURL: "".concat((0, _configuration.API_REPORTS_CHANNELSBYDEST), "/csv"),
        limit: limit
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: params.state.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportSearchDefault.default), {
                apiURL: (0, _configuration.API_REPORTS_CHANNELSBYDEST),
                destinations: destinations,
                id: "destination",
                labelText: "Select a destination:",
                limit: limit,
                name: "destination",
                onSubmitHandler: onSearchSubmit
            }),
            display
        ]
    });
};
exports.default = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsChannelsDestinations, {
        params: (0, _reactRouterDom.useLocation)()
    });
};

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./ReportSearch":"ehCb2","./ReportsResults":"buFAk","../subcomponents/LoaderSimple":"1dSHa","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"ee3Ui":[function(require,module,exports) {
/**
 * ReportsChannelsUse
 * Retrieves and displays destination information for a particular channel.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchChannelUsage = require("./SearchChannelUsage");
var _searchChannelUsageDefault = parcelHelpers.interopDefault(_searchChannelUsage);
var _reportsChannelUsageResults = require("./ReportsChannelUsageResults");
var _reportsChannelUsageResultsDefault = parcelHelpers.interopDefault(_reportsChannelUsageResults);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _utilities = require("../../js/Utilities");
var _reportsUtils = require("../../actions/ReportsUtils");
var _destinationsUtils = require("../../actions/DestinationsUtils");
var _configuration = require("../../js/Configuration");
var _reportsChannelsUseCss = require("../../css/ReportsChannelsUse.css");
var ReportsChannelsUse = function() {
    var display;
    var limit = 50;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), ascending = _useState[0], setAscending = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), channel = _useState1[0], setChannel = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), channels = _useState2[0], setChannels = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([]), 2), destinations = _useState3[0], setDestinations = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(undefined), 2), forDestination = _useState4[0], setForDestination = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState5[0], setLoading = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)([]), 2), results = _useState6[0], setResults = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(0), 2), count = _useState7[0], setCount = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)({}), 2), csv = _useState8[0], setCSV = _useState8[1];
    var abortcontroller = new AbortController();
    (0, _react.useEffect)(function() {
        // Make sure we're at the top of the page
        window.scrollTo(0, 0);
        // If no destinations are loaded, fetch them.
        if (!destinations.length) (0, _destinationsUtils.getDestinations)(function(response) {
            var destMenu = (0, _reportsUtils.prepareDestinationsMenu)(response);
            setDestinations(destMenu);
        });
        if (results.length) {
            setLoading(false);
            setCount(results.length);
        }
    }, [
        results
    ]);
    var onTextInput = function(domEvent) {
        setChannel(domEvent.target.value);
        var signal = abortcontroller.signal;
        var fd = new FormData();
        fd.set("search", domEvent.target.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        /* Populates SearchChannelUsage's <datalist> HTML element with matches */ (0, _utilities.apirequest)((0, _configuration.API_CHANNELS_TYPEAHEAD), {
            body: fd,
            signal: signal
        }, function(data) {
            setChannels(data.data);
        });
    };
    var onSelectChange = function(value) {
        setForDestination(value);
    };
    var makeFormData = function() {
        var fd = new FormData();
        fd.set("channel", channel);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        return fd;
    };
    var searchDo = function(domEvent) {
        setLoading(true);
        var ch = channels.find(function(c) {
            return domEvent.target.channel.value == c.channel_title;
        });
        if (ch) {
            setChannel(ch.channel_youtubechannelid);
            var signal = abortcontroller.signal;
            var fd = makeFormData();
            fd.set("group_by", "destination");
            fd.set("destination", +domEvent.target.destination.value);
            fd.set("ascending", +ascending);
            (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_USAGE), {
                body: fd,
                signal: signal
            }, function(response) {
                setResults((0, _reportsUtils.reportsChannelUseDetailDefaultState)(response.data.results));
                setCount(response.data.results.length);
                setCSV(response.data.csv);
            });
        }
        setLoading(false);
    };
    var onSearchSubmit = function(domEvent) {
        domEvent.preventDefault();
        searchDo(domEvent);
    };
    var onSearchReset = function(domEvent) {
        setAscending(0);
        setChannel("");
        setDestinations([]);
        setForDestination(0);
        setLoading(false);
        setResults([]);
        setCount(null);
    };
    var massageDataListResults = function(results) {
        if (!results) return;
        return res = results.map(function(result) {
            return {
                title: result.channel_title,
                id: result.channel_youtubechannelid
            };
        });
    };
    var onDownload = function(domEvent) {
        domEvent.preventDefault();
        if (!csv.length) return;
        (0, _reportsUtils.download)(csv, csv[0]);
    };
    var getPage = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var _JSON_parse;
        var page = domEvent ? domEvent.target.value : null;
        var destId = (_JSON_parse = JSON.parse(domEvent.target.dataset.data)) === null || _JSON_parse === void 0 ? void 0 : _JSON_parse.destination;
        var current = results.find(function(r) {
            return +r.destination === +destId;
        });
        var dest = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
            detail: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.detail), {
                loading: !current.detail.loading,
                "page": (0, _utilities.setPageNumber)(page, current.detail)
            })
        });
        fetchDetail(dest);
    };
    var onPanelToggle = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var destination = 0;
        if (Object.hasOwn(domEvent.target.dataset, "destinationId")) destination = +domEvent.target.dataset.destinationId;
        /* Find the destination we want to fetch data for. */ var dest = results.find(function(r) {
            return destination === +r.destination;
        });
        /*
      This is a detail/summary view. domEvent.target is a detail element with an
      open attribute. If it's open, and we don't already have results, fetch them.
      Send the destination as an object
    */ if (domEvent.target.open && !dest.detail.results.length) fetchDetail(dest);
    };
    var onViewToggle = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var _JSON_parse;
        var destId = (_JSON_parse = JSON.parse(domEvent.currentTarget.dataset.data)) === null || _JSON_parse === void 0 ? void 0 : _JSON_parse.destination;
        var current = results.find(function(r) {
            return +r.destination === +destId;
        });
        var dest = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
            detail: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.detail), {
                loading: true,
                toggle: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.detail.toggle), {
                    selected: +!current.detail.toggle.selected,
                    ascending: 0
                })
            })
        });
        fetchDetail(dest);
    };
    var fetchDetail = function() {
        var destination = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, changeView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var groupByOpts = [
            "none",
            "video"
        ];
        /* Find the right destination object */ var dest = (0, _objectSpread._)({}, destination);
        var signal = abortcontroller.signal;
        var fd = makeFormData();
        fd.set("channel", channel); // Use channel from state
        fd.set("group_by", groupByOpts[+dest.detail.toggle.selected]);
        fd.set("destination", +dest.destination);
        fd.set("ascending", +ascending);
        fd.set("page", +dest.detail.page);
        fd.set("perPage", +dest.detail.perPage);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_USAGE), {
            body: fd,
            signal: signal
        }, function(response) {
            setResults(function(previous) {
                // Find which destination object to update from current state
                var next = (0, _toConsumableArray._)(previous);
                var index = next.findIndex(function(r) {
                    return +r.destination === +response.data.destination;
                });
                var update = (0, _objectSpreadProps._)((0, _objectSpread._)({}, dest), {
                    detail: (0, _objectSpreadProps._)((0, _objectSpread._)({}, dest.detail, response.data), {
                        loading: false
                    })
                });
                next[index] = update;
                return next;
            });
        });
    };
    if (loading) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsChannelUsageResultsDefault.default), {
        ascending: ascending,
        channel: channel,
        destinations: destinations,
        results: results,
        count: count,
        csv: csv,
        onDownload: onDownload,
        onPanelToggle: onPanelToggle,
        onViewToggle: onViewToggle,
        onPageClick: getPage
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Channel Usage"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchChannelUsageDefault.default), {
                apiURL: (0, _configuration.API_CHANNEL_USAGE),
                datalist: massageDataListResults(channels),
                id: "channel",
                selectId: "destination",
                labelText: "Enter a channel title:",
                name: "channel",
                onSubmit: onSearchSubmit,
                onReset: onSearchReset,
                onInput: onTextInput,
                onSelectChange: onSelectChange,
                value: channel,
                limit: limit,
                options: destinations
            }),
            display
        ]
    });
};
exports.default = ReportsChannelsUse;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","./SearchChannelUsage":"6ZDpu","./ReportsChannelUsageResults":"fm2AD","../subcomponents/LoaderSimple":"1dSHa","../../js/Utilities":"euxcI","../../actions/ReportsUtils":"8Ctqy","../../actions/DestinationsUtils":"5X8UE","../../js/Configuration":"k3dur","../../css/ReportsChannelsUse.css":"7krV9","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6ZDpu":[function(require,module,exports) {
/**
 * SearchChannelUsage
 * Search form for Top Channels by Destination, Top Videos by Destination reports
 * Author: Webinista, Inc 3/24/18.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _selectMenu = require("../subcomponents/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var SearchChannelUsage = function(param) {
    var apiURL = param.apiURL, cssClass = param.cssClass, onSubmit = param.onSubmit, onReset = param.onReset, onSelectChange = param.onSelectChange, onInput = param.onInput, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "NEEDS A LABEL" : _param_labelText, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit, _param_datalist = param.datalist, datalist = _param_datalist === void 0 ? [] : _param_datalist, _param_options = param.options, options = _param_options === void 0 ? [] : _param_options;
    var makeDataList = function(arrayOfOptions) {
        return arrayOfOptions.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: item.title
            }, index.toString());
        });
    };
    var cssClasses = (0, _classnamesDefault.default)(cssClass, {
        "reports__channeluse__search": true
    });
    var dataList = null;
    var dataListAttr = null;
    var id = "reports_videoset_search_channel";
    if (datalist) {
        dataListAttr = "".concat(id, "_dl");
        dataList = /*#__PURE__*/ (0, _jsxRuntime.jsx)("datalist", {
            id: dataListAttr,
            children: makeDataList(datalist)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        id: "reports_videoset_search",
        action: apiURL,
        method: "POST",
        className: cssClasses,
        onSubmit: onSubmit,
        onReset: onReset,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                id: "limit",
                name: "limit",
                value: limit
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: id,
                        children: labelText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        id: id,
                        name: "channel",
                        onChange: onInput,
                        list: dataListAttr,
                        required: true,
                        autoComplete: "off"
                    }),
                    dataList
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                name: "destination",
                labelText: "Select a Destination or Station",
                onChangeHandler: onSelectChange,
                options: options
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "btn btn--action",
                children: "Search"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "reset",
                className: "btn",
                children: "Reset"
            })
        ]
    });
};
SearchChannelUsage.propTypes = {
    apiURL: (0, _propTypesDefault.default).string.isRequired,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    limit: (0, _propTypesDefault.default).number,
    cssClass: (0, _propTypesDefault.default).string,
    onSelectChange: (0, _propTypesDefault.default).func,
    onChangeHandler: (0, _propTypesDefault.default).func,
    onInput: (0, _propTypesDefault.default).func,
    onSubmit: (0, _propTypesDefault.default).func,
    onReset: (0, _propTypesDefault.default).func,
    options: (0, _propTypesDefault.default).array,
    destinations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        dID: (0, _propTypesDefault.default).string,
        dName: (0, _propTypesDefault.default).string
    })),
    datalist: (0, _propTypesDefault.default).array
};
exports.default = SearchChannelUsage;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../subcomponents/SelectMenu":"da8gs","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fm2AD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _downloadCSV = require("../subcomponents/DownloadCSV");
var _reportsChannelUsageResultPanel = require("./ReportsChannelUsageResultPanel");
var _reportsChannelUsageResultPanelDefault = parcelHelpers.interopDefault(_reportsChannelUsageResultPanel);
var _reportsChannelUsageResultsCss = require("./css/ReportsChannelUsageResults.css");
var ReportsChannelUsageResults = function(param) {
    var _param_onDownload = param.onDownload, onDownload = _param_onDownload === void 0 ? null : _param_onDownload, _param_onPageClick = param.onPageClick, onPageClick = _param_onPageClick === void 0 ? null : _param_onPageClick, _param_onViewToggle = param.onViewToggle, onViewToggle = _param_onViewToggle === void 0 ? null : _param_onViewToggle, _param_onPanelToggle = param.onPanelToggle, onPanelToggle = _param_onPanelToggle === void 0 ? null : _param_onPanelToggle, _param_results = param.results, results = _param_results === void 0 ? {} : _param_results, _param_destinations = param.destinations, destinations = _param_destinations === void 0 ? [] : _param_destinations, _param_csv = param.csv, csv = _param_csv === void 0 ? [] : _param_csv, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_count = param.count, count = _param_count === void 0 ? null : _param_count;
    var abortcontroller = new AbortController();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isDownloading = _useState[0], setDownloading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(new Map()), 2), usageResults = _useState1[0], setUsageResults = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(null), 2), currentPanel = _useState3[0], setCurrentPanel = _useState3[1];
    /**
   props.results is an array of objects that matches the following structure.

  [{
    "destination": "62",
    "Destination or Station": "YouTube Music - Moods",
    "Frequency": 2,
    "detail": {
      "loading": true,
      "open": false,
      "page": 1,
      "perPage": 10,
      "results": [],
      "toggle": {
        "options": [
          "List Each Occurrence",
          "List by Frequency"
        ],
        "selected": 0,
        "ascending": 1
      }
    }
  }]
  **/ var makeFormData = function() {
        var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var signal = abortcontroller.signal;
        var fd = new FormData();
        fd.set("channel", args.channel);
        fd.set("destination", args.destination);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("group_by", args.groupBy);
        fd.set("ascending", args.ascending);
        fd.set("page", 1);
        fd.set("perPage", 10);
        (0, _utilities.apirequest)((0, _configuration.API_CHANNEL_USAGE), {
            body: fd,
            signal: signal
        }, args.callback);
    };
    var makePanel = function(result, index) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
            open: false,
            onToggle: onPanelToggle,
            className: "reports__channel_use_item",
            "data-destination-id": result.destination,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("summary", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: result["Destination or Station"]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "reports__channel_use_item_freq",
                            children: result.Frequency
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsChannelUsageResultPanelDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, result.detail), {
                    onToggleChange: onViewToggle,
                    onPageClick: onPageClick
                }))
            ]
        }, "".concat(result.channel, "_").concat(index));
    };
    var makeResults = function(results) {
        if (!results) return null;
        else return results.map(makePanel);
    };
    if (count === null) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downloadCSV.DownloadCSV), {
                count: count,
                onSubmit: onDownload,
                working: isDownloading,
                disabled: !Object.keys(csv).length
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: makeResults(results)
            })
        ]
    });
};
ReportsChannelUsageResults.propTypes = {
    destinations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    results: (0, _propTypesDefault.default).array,
    count: (0, _propTypesDefault.default).number,
    cssClass: (0, _propTypesDefault.default).string
};
exports.default = ReportsChannelUsageResults;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","lodash.uniqueid":"6bf5k","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../subcomponents/DownloadCSV":"1jJnn","./ReportsChannelUsageResultPanel":"6F49a","./css/ReportsChannelUsageResults.css":"da0kC","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6F49a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _paginationBar = require("../subcomponents/PaginationBar");
var _paginationBarDefault = parcelHelpers.interopDefault(_paginationBar);
var _selectPerPage = require("../subcomponents/SelectPerPage");
var _selectPerPageDefault = parcelHelpers.interopDefault(_selectPerPage);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _toggleSwitch = require("../subcomponents/ToggleSwitch");
var _toggleSwitchDefault = parcelHelpers.interopDefault(_toggleSwitch);
var _reportsChannelUsageResultPanelCss = require("./css/ReportsChannelUsageResultPanel.css");
var _utilities = require("../../js/Utilities");
var ReportsChannelUsageResultPanel = function(props) {
    var makePagingComp = function() {
        var _$props = {};
        if (!Object.hasOwn(_$props, "pages")) return;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationBarDefault.default), {
            className: "reports__channel_use--pag",
            data: JSON.stringify({
                "destination": _$props.destination
            }),
            pages: +_$props.pages,
            page: _$props.page,
            onClickHandler: _$props.onPageClick,
            navSize: 5
        });
    };
    var makeToggle = function() {
        var toggle = null;
        var supplementalData = JSON.stringify({
            destination: +props.destination
        });
        if (Object.hasOwn(props, "toggle")) toggle = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
            onChange: props.onToggleChange,
            data: supplementalData,
            label: "Show:",
            className: "reports__channel_use",
            options: [
                "List Each Occurrence",
                "List Videos by Frequency"
            ],
            name: "view",
            selectedIndex: props.toggle.selected
        });
        return toggle;
    };
    var singlerows = function() {
        var body = null;
        if (!Object.hasOwn(props, "results")) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
            children: "No results found."
        });
        body = props.results.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: item["Series or Video Set"]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: item["Episode Title"]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: item["Run Date"]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: (0, _utilities.youtubeURL)(item.ytid),
                            target: "_blank",
                            children: item.video_title
                        })
                    })
                ]
            }, "ReportsChannelUsageResultPanel__tbl_row_".concat(item.ytid, "_").concat(index));
        });
        return body;
    };
    var singles = function() {
        if (!Object.hasOwn(props, "results")) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            id: "ReportsChannelUsageResultPanel",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "l__flex__sb",
                    children: [
                        makeToggle(),
                        makePagingComp()
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    className: "ReportsChannelUsageResultPanel__tbl",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Series or Video Set"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Episode Title"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Run Date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Video"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            children: singlerows()
                        })
                    ]
                })
            ]
        });
    };
    var groupedrows = function() {
        var body = null;
        if (!Object.hasOwn(props, "detail")) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
            children: "No results found."
        });
        body = props.results.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                            href: (0, _utilities.youtubeURL)(item.ytid),
                            target: "_blank",
                            className: "vidthumb__and__title",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _utilities.youtubeThumbnailURL)(item.ytid),
                                    className: "ReportsChannelUsageResultPanel__thumb",
                                    alt: "",
                                    width: "75"
                                }),
                                item.video_title
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: item["Frequency"]
                    })
                ]
            }, "ReportsChannelUsageResultPanel__tbl_row_".concat(item.ytid, "_").concat(index));
        });
        return body;
    };
    var grouped = function() {
        if (!Object.hasOwn(props, "results")) return;
        var body;
        if (props.loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        else body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            id: "ReportsChannelUsageResultPanel",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "l__flex__sb",
                    children: [
                        makeToggle(),
                        makePagingComp()
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    className: "ReportsChannelUsageResultPanel__tbl",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Video"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Frequency"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            children: groupedrows()
                        })
                    ]
                })
            ]
        });
        return body;
    };
    var body = null;
    if (!!props.toggle.selected) body = grouped();
    else body = singles();
    return body;
};
exports.default = ReportsChannelUsageResultPanel;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/PaginationBar":"03zHm","../subcomponents/SelectPerPage":"anMUV","../subcomponents/LoaderSimple":"1dSHa","../subcomponents/ToggleSwitch":"k29YD","./css/ReportsChannelUsageResultPanel.css":"1Y8YA","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1Y8YA":[function() {},{}],"da0kC":[function() {},{}],"8Ctqy":[function(require,module,exports) {
/*
ReportsUtils.js

Functions that are shared between multiple views in Reports
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "download", function() {
    return download;
});
parcelHelpers.export(exports, "prepareDestinationsMenu", function() {
    return prepareDestinationsMenu;
});
parcelHelpers.export(exports, "setStateForDest", function() {
    return setStateForDest;
});
parcelHelpers.export(exports, "setStateSearchPre", function() {
    return setStateSearchPre;
});
parcelHelpers.export(exports, "setStateSearchPost", function() {
    return setStateSearchPost;
});
parcelHelpers.export(exports, "setStateRequestDetails", function() {
    return setStateRequestDetails;
});
parcelHelpers.export(exports, "setLoading", function() {
    return setLoading;
});
parcelHelpers.export(exports, "setStateAddVideoResults", function() {
    return setStateAddVideoResults;
});
parcelHelpers.export(exports, "setStateReset", function() {
    return setStateReset;
});
parcelHelpers.export(exports, "channelUseDetailSetView", function() {
    return channelUseDetailSetView;
});
parcelHelpers.export(exports, "reportsChannelUseDetailDefaultState", function() {
    return reportsChannelUseDetailDefaultState;
});
parcelHelpers.export(exports, "setChannelUsePanelPage", function() {
    return setChannelUsePanelPage;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utilities = require("../js/Utilities");
var _toolsUtils = require("./ToolsUtils");
var _configuration = require("../js/Configuration");
var download = function(data, channel) {
    var prefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Channel", suffix = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Usage_Report";
    var blob = new Blob([
        (0, _toolsUtils.convertArrayToCSV)(data)
    ], {
        type: "text/csv"
    });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.style = "display: none";
    document.body.appendChild(a);
    a.href = url;
    a.download = "".concat(prefix, "_").concat(channel, "_").concat(suffix, ".csv");
    a.click(); // programatically click the link to trigger the download
    //release the reference to the file by revoking the Object URL
    window.URL.revokeObjectURL(url);
    // Delete the link.
    document.body.removeChild(a);
};
var prepareDestinationsMenu = function() {
    var response = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!response.length) return response;
    return response.map(function(destination) {
        var station = +destination.isStation ? " (Station)" : "";
        return {
            label: "".concat(destination.dName).concat(station),
            value: destination.dID
        };
    });
};
var setStateForDest = function(state, value) {
    return {
        forDestination: +value
    };
};
var setStateSearchPre = function(state, value) {
    return {
        isLoading: true,
        channel: value,
        count: 0
    };
};
var setStateSearchPost = function(state, data) {
    return {
        results: data.data.results,
        isLoading: false,
        count: data.data.results.length,
        csv: data.data.csv
    };
};
/* DONT EXPORT. */ var pageState = function(destinationObj, value) {
    var deets;
    var current;
    var defaultToggle = {
        selected: 0,
        ascending: 1
    };
    if (Object.hasOwn(destinationObj, "detail")) current = (0, _objectSpreadProps._)((0, _objectSpread._)({}, destinationObj.detail), {
        loading: true
    });
    else current = {
        loading: true,
        page: 1,
        perPage: (0, _configuration.REPORTS_CHANNEL_USAGE_PER_PAGE),
        results: [],
        toggle: defaultToggle
    };
    switch(value){
        case "previous":
            deets = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                page: destinationObj.detail.page - 1
            });
            break;
        case "next":
            deets = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                page: destinationObj.detail.page + 1
            });
            break;
        case "first":
        case Number.isNaN(value):
            deets = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                page: 1
            });
            break;
        case "last":
            deets = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                page: destinationObj.detail.pages
            });
            break;
        default:
            deets = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                page: +value
            });
    }
    return deets;
};
var setStateRequestDetails = function(state, destinationId) {
    var pg1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var destinations = (0, _toConsumableArray._)(state.results);
    var update = destinations.findIndex(function(item) {
        return +item.destination === +destinationId;
    });
    if (update === -1) return;
    destinations[update].detail = pageState(destinations[update], pg1);
    return {
        results: destinations
    };
};
var setLoading = function(state) {
    return {
        isLoading: true
    };
};
var setStateAddVideoResults = function(state, data) {
    if (!data.hasOwnProperty("destination")) return;
    var ind = state.results.findIndex(function(item) {
        return +item.destination === +data.destination;
    });
    var ste = (0, _toConsumableArray._)(state.results);
    var deets = {
        pages: data.pages,
        loading: false,
        results: data.results
    };
    ste[ind]["detail"] = Object.assign((0, _objectSpread._)({}, state.results[ind].detail), deets);
    return {
        results: ste
    };
};
var setStateReset = function(state) {
    return {
        ascending: 0,
        channel: "",
        destinations: [],
        forDestination: 0,
        groupBy: "destination",
        isLoading: false,
        results: [],
        count: null // Number of results returned
    };
};
var channelUseDetailSetView = function(state, destinationId, view) {
    var which = state.results.findIndex(function(item) {
        return +item.destination === destinationId;
    });
    var toUpdate = (0, _objectSpread._)({}, state);
    var changes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, toUpdate.results[which].detail), {
        loading: true,
        toggle: (0, _objectSpreadProps._)((0, _objectSpread._)({}, toUpdate.results[which].detail.toggle), {
            selected: +view,
            ascending: !+view
        }),
        page: 1
    });
    toUpdate.results[which].detail = changes;
    return toUpdate;
};
/*
 Accepts a destination object and adds this default state as a
 detail property
*/ var setDetailDefault = function(resultObject) {
    var resultState = {
        loading: true,
        open: false,
        page: 1,
        perPage: (0, _configuration.REPORTS_CHANNEL_USAGE_PER_PAGE),
        results: [],
        toggle: {
            selected: 0,
            ascending: 1
        }
    };
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, resultObject), {
        detail: resultState
    });
};
var reportsChannelUseDetailDefaultState = function(resultArray) {
    return resultArray.map(setDetailDefault);
};
var setChannelUsePanelPage = function(destinationObj, value) {
    switch(value){
        case "previous":
            pg = +destinationObj.detail.page - 1;
            break;
        case "next":
            console.log(value);
            pg = destinationObj.detail.page + 1;
            break;
        case "first":
        case Number.isNaN(value):
            pg = 1;
            break;
        case "last":
            pg = +destinationObj.detail.pages;
            break;
        default:
            pg = +value;
    }
    var update = (0, _objectSpread._)({}, destinationObj);
    update.detail = (0, _objectSpreadProps._)((0, _objectSpread._)({}, update.detail), {
        page: pg
    });
    return update;
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_to_consumable_array":"fRXIP","../js/Utilities":"euxcI","./ToolsUtils":"2sPId","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2sPId":[function(require,module,exports) {
/*
ToolsUtils.js

Functions for the Tools page.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "download", function() {
    return download;
});
parcelHelpers.export(exports, "convertArrayToCSV", function() {
    return convertArrayToCSV;
});
parcelHelpers.export(exports, "setSpreadsheetData", function() {
    return setSpreadsheetData;
});
var _utilities = require("../js/Utilities");
var _configuration = require("../js/Configuration");
var download = function(data, sheetID, sheetName) {
    var blob = new Blob([
        convertArrayToCSV(data)
    ], {
        type: "text/csv"
    });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.style = "display: none";
    document.body.appendChild(a);
    a.href = url;
    a.download = "".concat(sheetID, "_").concat(sheetName, ".csv");
    a.click(); // programatically click the link to trigger the download
    //release the reference to the file by revoking the Object URL
    window.URL.revokeObjectURL(url);
    // Delete the link.
    document.body.removeChild(a);
};
var convertArrayToCSV = function(data) {
    return data.join("\n");
};
var setSpreadsheetData = function(data, callback, sheetID) {
    var sheetName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Sheet1", signal = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, operation = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "averages";
    var fd = new FormData();
    fd.set("token", (0, _utilities.getAuthData)("token"));
    fd.set("url", "https://docs.google.com/spreadsheets/d/".concat(sheetID, "/"));
    fd.set("sheet", sheetName);
    fd.set("values", JSON.stringify(data));
    fd.set("operation", operation);
    (0, _utilities.apirequest)((0, _configuration.API_EXPORT_DURATIONS_TO_GOOG), {
        body: fd,
        signal: signal
    }, callback);
};

},{"../js/Utilities":"euxcI","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7krV9":[function() {},{}],"8uMeP":[function(require,module,exports) {
/**
 * ReportsVideoUse.js
 * 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _searchText = require("./SearchText");
var _searchTextDefault = parcelHelpers.interopDefault(_searchText);
var _reportsResults = require("./ReportsResults");
var _reportsResultsDefault = parcelHelpers.interopDefault(_reportsResults);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var _reportsVideoUseCss = require("../../css/ReportsVideoUse.css");
var ReportsVideoUse = function(param) {
    var _param_params = param.params, params = _param_params === void 0 ? null : _param_params;
    var display;
    var limit = 50;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), videos = _useState[0], setVideos = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(""), 2), video = _useState1[0], setVideo = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), destinations = _useState2[0], setDestinations = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState3[0], setLoading = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(null), 2), results = _useState4[0], setResults = _useState4[1];
    (0, _react.useEffect)(function() {
        window.scrollTo(0, 0);
    }, []);
    var inputHandler = function(domEvent) {
        domEvent.persist(); // Necessary for React to persist the event.
        debouncedInputHandler(domEvent.target.value);
    };
    var debouncedInputHandler = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (!value.length) return;
        var fd = new FormData();
        fd.set("search", value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_VIDEOS_TYPEAHEAD), {
            body: fd
        }, function(data) {
            setVideos(data.data);
        });
    };
    var onSearchSubmit = function(domEvent) {
        domEvent.preventDefault();
        setLoading(true);
        setVideo(domEvent.target.video.value);
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_VIDEO_USAGE), {
            body: fd
        }, function(data) {
            setDestinations(data.data);
            setResults(data.data.length);
            setLoading(false);
        });
    };
    var massageDataListResults = function(results) {
        if (!results) return;
        var res = results.map(function(result) {
            return {
                title: result.video_title,
                id: result.youtubeID
            };
        });
        return res;
    };
    var massageResults = function(results) {
        var res = results.map(function(result) {
            var setname = result["Video Set / Series"] ? ": ".concat(result["Video Set / Series"]) : "";
            var eptitle = result["Episode Title"] ? " (".concat(result["Episode Title"].trim(), ")") : "";
            return {
                title: "".concat(result["Destination or Station"]).concat(setname).concat(eptitle),
                frequency: result.Frequency
            };
        });
        return res;
    };
    if (loading) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsResultsDefault.default), {
        columnHeadings: [
            "Destination or Station Title: Series Name (Episode Title)",
            "Frequency"
        ],
        results: massageResults(destinations),
        count: results,
        downloadURL: "".concat((0, _configuration.API_REPORTS_VIDEO_USAGE), "/csv"),
        limit: limit,
        video: video
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: params.state.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextDefault.default), {
                apiURL: (0, _configuration.API_REPORTS_VIDEO_USAGE),
                datalist: massageDataListResults(videos),
                id: "video",
                labelText: "Enter a video title, URL or YouTube ID:",
                name: "video",
                onInput: inputHandler,
                onSubmit: onSearchSubmit,
                limit: limit
            }),
            display
        ]
    });
};
exports.default = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVideoUse, {
        params: (0, _reactRouterDom.useLocation)()
    });
};

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./SearchText":"etbFs","./ReportsResults":"buFAk","../subcomponents/LoaderSimple":"1dSHa","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","../../css/ReportsVideoUse.css":"eSCL4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"eSCL4":[function() {},{}],"89E0Q":[function(require,module,exports) {
/**
 * Created by Webinista, Inc 9/04/18.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchDates = require("./SearchDates");
var _searchDatesDefault = parcelHelpers.interopDefault(_searchDates);
var _reportsResults = require("./ReportsResults");
var _reportsResultsDefault = parcelHelpers.interopDefault(_reportsResults);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _reactRouterDom = require("react-router-dom");
var _dateFns = require("date-fns");
var _utilities = require("../../js/Utilities");
var _configuration = require("../../js/Configuration");
var _reportsVideoDropOffsCss = require("../../css/ReportsVideoDropOffs.css");
var ReportsVideoDropOffs = function(props) {
    var today = new Date();
    var daysago7 = (0, _dateFns.subDays)(today, 7);
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(""), 2), destination = _React_useState[0], setDestination = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), destinations = _React_useState1[0], setDestinations = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        start: (0, _dateFns.format)(daysago7, "yyyy-MM-dd"),
        end: (0, _dateFns.format)(today, "yyyy-MM-dd")
    }), 2), range = _React_useState2[0], setRange = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)((0, _reactDefault.default).useState([]), 2), videos = _React_useState3[0], setVideos = _React_useState3[1];
    var _React_useState4 = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), loading = _React_useState4[0], setLoading = _React_useState4[1];
    var _React_useState5 = (0, _slicedToArray._)((0, _reactDefault.default).useState(null), 2), results = _React_useState5[0], setResults = _React_useState5[1]; // Number of results returned
    var _React_useState6 = (0, _slicedToArray._)((0, _reactDefault.default).useState(500), 2), limit = _React_useState6[0], setLimit = _React_useState6[1];
    var params = props.params;
    var massageResults = function(results) {
        var res = [
            false
        ];
        res = results.data.map(function(item) {
            return {
                title: item["Video Title"],
                url: item.url,
                vs_title: item["Video Set"],
                episode: item.Episode || (0, _configuration.NULL_VIDEOSET_TITLE_TEXT),
                rundate: item["Run Date"] || (0, _configuration.NULL_DATE_TEXT),
                frequency: (0, _utilities.yyyymmdd)(new Date(item.video_datelastupdated))
            };
        });
        setVideos(res);
        setResults(res.length);
        setLoading(false);
    };
    var doSearch = function() {
        var fd = new FormData();
        fd.set("start", range.start);
        fd.set("end", range.end);
        fd.set("limit", limit);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_REPORTS_DROPOFFS), {
            body: fd
        }, massageResults);
    };
    var onChange = function(domEvent) {
        var _domEvent_target = domEvent.target, name = _domEvent_target.name, value = _domEvent_target.value;
        setRange((0, _defineProperty._)({}, name, value));
    };
    var onSubmit = function(domEvent) {
        domEvent.preventDefault();
        setLoading(true);
        doSearch();
    };
    var onComponentMount = function() {
        setLoading(true);
        doSearch();
    };
    (0, _reactDefault.default).useEffect(function() {
        if (!videos.length) onComponentMount();
    }, [
        results
    ]);
    var display;
    if (loading) display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else display = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportsResultsDefault.default), {
        columnHeadings: [
            "Video Title",
            "Video Set",
            "Video Set Title",
            "Run Date",
            "Date Found Inactive"
        ],
        results: videos,
        count: results,
        destination: destination,
        downloadURL: (0, _configuration.API_REPORTS_DROPOFFS_CSV),
        start: range.start,
        end: range.end,
        limit: limit,
        cssClass: "reports__table__videodropoffs"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reports__page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: params.state.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDatesDefault.default), {
                apiURL: (0, _configuration.API_REPORTS_DROPOFFS),
                cssClass: "reports__dropoffs__searchdates",
                destinations: destinations,
                id: "destination",
                start: range.start,
                end: range.end,
                labelText: "Select a destination:",
                limit: limit,
                name: "destination",
                onChange: onChange,
                onSubmit: onSubmit
            }),
            display
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportsVideoDropOffs, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useLocation)()
    }));
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","./SearchDates":"iU3YK","./ReportsResults":"buFAk","../subcomponents/LoaderSimple":"1dSHa","react-router-dom":"gMZz4","date-fns":"1h4Hj","../../js/Utilities":"euxcI","../../js/Configuration":"k3dur","../../css/ReportsVideoDropOffs.css":"iilq1","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iU3YK":[function(require,module,exports) {
/**
 * SearchDates.jsx
 * Search values that are between a start and an end date
 * Author: Webinista, Inc 2018-09-04.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateInput = require("../subcomponents/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var SearchDates = function(param) {
    var start = param.start, end = param.end, _param_apiURL = param.apiURL, apiURL = _param_apiURL === void 0 ? "" : _param_apiURL, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "NEEDS LABEL TEXT" : _param_labelText, _param_name = param.name, name = _param_name === void 0 ? "" : _param_name, _param_cssClass = param.cssClass, cssClass = _param_cssClass === void 0 ? "" : _param_cssClass, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? null : _param_onChange, _param_onSubmit = param.onSubmit, onSubmit = _param_onSubmit === void 0 ? null : _param_onSubmit, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            id: "reports_dropoff_search",
            action: apiURL,
            method: "POST",
            className: cssClass,
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "hidden",
                    id: "limit",
                    name: "limit",
                    value: limit
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                    name: "start",
                    labelText: "Start of date range:",
                    isRequired: false,
                    onChangeHandler: onChange,
                    value: start
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                    name: "end",
                    labelText: "End of date range:",
                    isRequired: false,
                    onChangeHandler: onChange,
                    value: end
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    className: "btn btn--action",
                    children: "Search"
                })
            ]
        })
    });
};
SearchDates.propTypes = {
    apiURL: (0, _propTypesDefault.default).string.isRequired,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    name: (0, _propTypesDefault.default).string.isRequired,
    cssClass: (0, _propTypesDefault.default).string,
    onChange: (0, _propTypesDefault.default).func,
    onSubmit: (0, _propTypesDefault.default).func.isRequired,
    value: (0, _propTypesDefault.default).string
};
exports.default = SearchDates;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/DateInput":"90qRl","prop-types":"fUIWk","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iilq1":[function() {},{}],"hHFhc":[function(require,module,exports) {
/**
 * Stations.js
 * /stations page-level component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _videoSetEdit = require("./Destinations/VideoSetEdit");
var _videoSetEditDefault = parcelHelpers.interopDefault(_videoSetEdit);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _stationsCss = require("../css/Stations.css");
var Stations = function(props) {
    var project = props.project;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), stations = _useState[0], setStations = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        open: false,
        title: ""
    }), 2), addNew = _useState1[0], setAddNew = _useState1[1];
    (0, _react.useEffect)(function() {
        if (!stations.length) {
            var fd = new FormData();
            fd.set("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_STATIONS), {
                body: fd
            }, function(data) {
                setStations(data);
            });
        }
    }, []);
    var videoSetTitleRef = (0, _react.useRef)(null);
    var videoSetModalRef = (0, _react.useRef)(null);
    var closeModal = function() {
        var _videoSetModalRef_current;
        if (Object.hasOwn(videoSetModalRef, "current")) (_videoSetModalRef_current = videoSetModalRef.current) === null || _videoSetModalRef_current === void 0 ? void 0 : _videoSetModalRef_current.close();
    };
    var onAddNewStation = function() {
        var _videoSetModalRef_current;
        setAddNew((0, _objectSpreadProps._)((0, _objectSpread._)({}, addNew), {
            open: true
        }));
        if (Object.hasOwn(videoSetModalRef, "current")) (_videoSetModalRef_current = videoSetModalRef.current) === null || _videoSetModalRef_current === void 0 ? void 0 : _videoSetModalRef_current.showModal();
    };
    var onAddNewStationInput = function() {
        if (Object.hasOwn(videoSetTitleRef, "current")) setAddNew((0, _objectSpreadProps._)((0, _objectSpread._)({}, addNew), {
            title: videoSetTitleRef.current.value
        }));
    };
    var onAddNewStationSave = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("name", addNew.title.trim());
        fd.set("isstation", 1);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_ADDNEW), {
            body: fd
        }, function(data) {
            if (data.result === "success") {
                var newStation = (0, _toConsumableArray._)(stations);
                newStation.unshift({
                    id: data.d_id,
                    station: data.d_name
                });
                setStations(newStation);
                setAddNew((0, _objectSpreadProps._)((0, _objectSpread._)({}, addNew), {
                    open: false
                }));
                closeModal();
            } else alert(data.message);
        });
    };
    var makeNewStationButton = function() {
        var btn;
        if ((0, _utilities.isAdmin)(project)) btn = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn btn--action",
                onClick: onAddNewStation,
                children: "Add New Station"
            })
        });
        else btn = null;
        return btn;
    };
    var buildLinks = function() {
        var links = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        if (stations.length) links = stations.map(function(item) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: item.id,
                    state: {
                        station: item.station
                    },
                    children: item.station
                })
            }, "station_".concat(item.id));
        });
        return links;
    };
    var makeAddNewStationModal = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoSetEditDefault.default), {
            modalRef: videoSetModalRef,
            ref: videoSetTitleRef,
            apiURL: (0, _configuration.API_DESTINATIONS_ADDNEW),
            id: "VideoSetEdit",
            title: "Add a New Station",
            labelText: "Enter a name for this station",
            open: addNew.open,
            value: addNew.title,
            onInput: onAddNewStationInput,
            onSubmit: onAddNewStationSave,
            onClose: closeModal,
            error: addNew.error
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        className: "stations__view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                children: "Stations"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Click a station name to view series"
                            })
                        ]
                    }),
                    makeNewStationButton()
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "stations__list",
                children: buildLinks()
            }),
            makeAddNewStationModal()
        ]
    });
};
exports.default = Stations;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./Destinations/VideoSetEdit":"6ByaZ","./subcomponents/LoaderSimple":"1dSHa","../js/Configuration":"k3dur","../js/Utilities":"euxcI","../css/Stations.css":"4p1nx","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6ByaZ":[function(require,module,exports) {
/**
 * VideoSetEdit.jsx
 * Allows for renaming of video sets.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _videoSetEditCss = require("../../css/VideoSetEdit.css");
var VideoSetEdit = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function VideoSetEdit(props, ref) {
    var open = props.open, onSubmit = props.onSubmit, onClose = props.onClose, onReset = props.onReset, modalRef = props.modalRef, id = props.id, value = props.value, apiURL = props.apiURL, labelText = props.labelText, error = props.error, title = props.title;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "VideoSetEdit",
        title: "Add Songs",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                action: apiURL,
                onSubmit: onSubmit,
                className: "video__set__edit__form",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "destinations_new_set_name",
                            children: labelText
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    required: true,
                                    type: "text",
                                    ref: ref,
                                    name: id,
                                    id: id,
                                    defaultValue: value,
                                    "aria-describedby": "video_set_edit_error"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn--action",
                                    children: "Save"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            id: "video_set_edit_error",
                            className: "video__set__edit__error",
                            hidden: !error,
                            children: error
                        })
                    ]
                })
            })
        ]
    });
});
VideoSetEdit.propTypes = {
    onSubmit: (0, _propTypesDefault.default).func.isRequired,
    onReset: (0, _propTypesDefault.default).func,
    onClose: (0, _propTypesDefault.default).func.isRequired,
    apiURL: (0, _propTypesDefault.default).string,
    value: (0, _propTypesDefault.default).string,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    id: (0, _propTypesDefault.default).string.isRequired,
    title: (0, _propTypesDefault.default).string.isRequired,
    error: (0, _propTypesDefault.default).any
};
exports.default = VideoSetEdit;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/ModalDialog":"72kji","../../css/VideoSetEdit.css":"g8Nmw","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"g8Nmw":[function() {},{}],"4p1nx":[function() {},{}],"AJus3":[function(require,module,exports) {
/**
 * StationView.js
 * /stations page-level component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _breadcrumb = require("../subcomponents/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _stationsSeriesTable = require("./StationsSeriesTable");
var _stationsSeriesTableDefault = parcelHelpers.interopDefault(_stationsSeriesTable);
var _stationsFilter = require("./StationsFilter");
var _stationsFilterDefault = parcelHelpers.interopDefault(_stationsFilter);
var _episodesList = require("./EpisodesList");
var _episodesListDefault = parcelHelpers.interopDefault(_episodesList);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _videoSetEdit = require("../Destinations/VideoSetEdit");
var _videoSetEditDefault = parcelHelpers.interopDefault(_videoSetEdit);
var _seriesEdit = require("../Destinations/SeriesEdit");
var _seriesEditDefault = parcelHelpers.interopDefault(_seriesEdit);
var _editModal = require("../subcomponents/EditModal");
var _editModalDefault = parcelHelpers.interopDefault(_editModal);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _stationsUtils = require("../../actions/StationsUtils");
var _stationViewCss = require("./css/StationView.css");
var StationView = function(param) {
    var params = param.params, project = param.project;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), list = _useState[0], setList = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _stationsUtils.initEpisodes)), 2), episodes = _useState1[0], setEpisodes = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([
        {
            path: "/stations",
            label: "Stations"
        }
    ]), 2), breadcrumbs = _useState2[0], setBreadcrumbs = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)({}), 2), meta = _useState3[0], setMeta = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)([]), 2), filtered = _useState5[0], setFiltered = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)((0, _stationsUtils.initEditSeries)), 2), editseries = _useState6[0], setEditSeries = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)((0, _stationsUtils.initAddNewSeries)), 2), addnewseries = _useState7[0], setAddNewSeries = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(""), 2), addNewSeriesTitle = _useState8[0], setAddNewSeriesTitle = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)((0, _stationsUtils.initAddNewEp)), 2), addnew = _useState9[0], setAddNew = _useState9[1];
    var addNewModalRef = (0, _react.useRef)(null);
    var editSeriesRef = (0, _react.useRef)(null);
    var viewEpisodesRef = (0, _react.useRef)(null);
    var episodesListRef = (0, _react.useRef)(null);
    var fd = new FormData(); // We'll reuse the FormData object in this component.
    fd.set("token", (0, _utilities.getAuthData)("token")); // Set the user token.
    var stationID = params.stationID;
    (0, _react.useEffect)(function() {
        if (!Object.keys(meta).length) getStationMeta();
        if (!list.length) getSeries();
    }, [
        meta,
        list
    ]);
    var getSeries = function() {
        fd.set("id", params.stationID);
        fd.set("isStation", 1);
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_ASSIGNMENTS), {
            body: fd
        }, function(data) {
            if (data.length) setList(data);
            else setList([
                0
            ]);
            setFiltered(data);
            setLoading(false);
        });
    };
    var getStationMeta = function() {
        fd.set("id", stationID);
        (0, _utilities.apirequest)((0, _configuration.API_STATIONS), {
            body: fd
        }, function(data) {
            if (!data.length) return;
            var slice = [
                {
                    path: "/stations/".concat(data[0].id),
                    label: data[0].station
                }
            ];
            setBreadcrumbs((0, _toConsumableArray._)(breadcrumbs).concat(slice));
            setMeta(data[0]);
        });
    };
    var filterSeries = function(domEvent) {
        if (domEvent.target.value === "") {
            setFiltered((0, _toConsumableArray._)(list));
            return;
        }
        fd.set("keyword", domEvent.target.value);
        fd.set("station", stationID);
        (0, _utilities.apirequest)((0, _configuration.API_STATIONS_FIND_SERIES), {
            body: fd
        }, function(data) {
            setFiltered(data);
        });
    };
    var onViewEpisodes = function(domEvent) {
        var epState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, episodes), {
            meta: {
                id: domEvent.target.dataset.episode,
                title: domEvent.target.dataset.setname
            }
        });
        setEpisodes(epState);
        if (episodesListRef === null || episodesListRef === void 0 ? void 0 : episodesListRef.current) episodesListRef.current.showModal();
    };
    var onEpisodesClose = function(domEvent) {
        if (episodesListRef === null || episodesListRef === void 0 ? void 0 : episodesListRef.current) episodesListRef === null || episodesListRef === void 0 ? void 0 : episodesListRef.current.close();
        setEpisodes((0, _stationsUtils.initEpisodes));
    };
    var onEpisodeDuplicate = function(domEvent) {
        domEvent.preventDefault();
        fd.set("id", domEvent.target.elements.id.value);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_DUPLICATE), {
            body: fd
        }, function(data) {
            if (data) window.location = "/stations/episode/".concat(data);
        });
    };
    var onBatchSave = function(episodesList) {
        if (!episodesList.length) return;
        episodesList.forEach(function(ep) {
            (0, _stationsUtils.saveSeasonEp)(ep.vsb_id, ep.season, ep.episode, function(data) {
                setEpisodes((0, _stationsUtils.initEpisodes));
            });
        });
    };
    var onBatchEdit = function(domEvent) {
        var epState = (0, _objectSpread._)({}, episodes);
        setEpisodes((0, _objectSpreadProps._)((0, _objectSpread._)({}, episodes), {
            mode: "edit"
        }));
    };
    var onAddEpisode = function(domEvent) {
        if (viewEpisodesRef === null || viewEpisodesRef === void 0 ? void 0 : viewEpisodesRef.current) viewEpisodesRef.current.showModal();
        setAddNew((0, _objectSpreadProps._)((0, _objectSpread._)({}, addnew), {
            setId: domEvent.target.dataset.series
        }));
    };
    var onAddEpisodeChange = function(domEvent) {
        setAddNew((0, _objectSpreadProps._)((0, _objectSpread._)({}, addnew), {
            title: domEvent.target.value
        }));
    };
    var onAddEpisodeSave = function(domEvent) {
        fd.set("setID", addnew.setId);
        fd.set("title", addnew.title);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_ADDNEW), {
            body: fd
        }, function(data) {
            if (data.result === "success") {
                setAddNew((0, _stationsUtils.initAddNewEp));
                if (viewEpisodesRef === null || viewEpisodesRef === void 0 ? void 0 : viewEpisodesRef.current) viewEpisodesRef.current.close();
                showCreatedEpisode(data.blockID);
            } else alert(data.result);
        });
    };
    var onAddEpisodeClose = function(dialogRef) {
        console.log(dialogRef);
        setAddNew((0, _stationsUtils.initAddNewEp));
        addNewModalRef === null || addNewModalRef === void 0 ? void 0 : addNewModalRef.current.close();
    };
    var onAddSeries = function(domEvent) {
        setAddNewSeries((0, _objectSpreadProps._)((0, _objectSpread._)({}, addnewseries), {
            mode: "series",
            setId: domEvent.target.dataset.series
        }));
        if (addNewModalRef === null || addNewModalRef === void 0 ? void 0 : addNewModalRef.current) addNewModalRef.current.showModal();
    };
    var onAddSeriesInput = function(domEvent) {
        var value = domEvent.target.value;
        setAddNewSeriesTitle(value);
    };
    var onAddSeriesSave = function(domEvent) {
        domEvent.preventDefault();
        fd.set("name", addNewSeriesTitle);
        fd.set("destination", stationID);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ADDNEW), {
            body: fd
        }, function(data) {
            if (data.result === "success") {
                setAddNewSeries({
                    error: null
                });
                setAddNewSeriesTitle("");
                showCreatedSeries(data);
            } else alert(data.result);
        });
    };
    var onAddSeriesClose = function() {
        if (addNewModalRef === null || addNewModalRef === void 0 ? void 0 : addNewModalRef.current) addNewModalRef.current.close();
        setAddNewSeries((0, _stationsUtils.initAddNewSeries));
    };
    var onEditSeriesTitle = function(domEvent) {
        var dataset = domEvent.target.dataset;
        setEditSeries((0, _objectSpreadProps._)((0, _objectSpread._)({}, editseries), {
            series_id: dataset.episode,
            value: dataset.setname
        }));
        if (editSeriesRef === null || editSeriesRef === void 0 ? void 0 : editSeriesRef.current) editSeriesRef.current.showModal();
    };
    var onEditSeriesTitleInput = function(domEvent) {
        setEditSeries((0, _objectSpreadProps._)((0, _objectSpread._)({}, editseries), {
            value: domEvent.target.value
        }));
    };
    var onEditSeriesTitleClose = function(dialogRef) {
        setState(function(state) {
            var combinedstate = (0, _objectSpreadProps._)((0, _objectSpread._)({}, editseries), {
                error: null,
                value: "",
                series_id: null,
                open: false
            });
            return {
                editseries: combinedstate
            };
        }, function() {
            dialogRef.current.close();
        });
    };
    var updateSeriesTitleInList = function(id, title) {
        var newlist = (0, _toConsumableArray._)(list);
        // Find the current object to update...
        var current = newlist.findIndex(function(item) {
            return item.setID == id;
        });
        newlist[current].setName = title;
        return newlist;
    };
    var onEditSeriesTitleSave = function() {
        fd.set("id", editseries.series_id);
        fd.set("title", editseries.value);
        (0, _utilities.apirequest)((0, _configuration.API_STATIONS_SERIES_EDIT), {
            body: fd
        }, function(response) {
            if (!response.success) {
                var newlist = updateSeriesTitleInList(editseries.series_id, editseries.value);
                setList(newlist);
                setEditSeries((0, _stationsUtils.initEditSeries));
            } else throw new Error("Something went wrong. Please contact an administrator.");
        });
    };
    var showCreatedEpisode = function(episodeid) {
        window.location = "/stations/episode/".concat(episodeid);
    };
    var showCreatedSeries = function(data) {
        // Instead of redirecting to the /series/:id view, 
        // Let's go directly to the blank episode.
        fd.set("id", data.setID);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ASSIGNMENTS), {
            body: fd
        }, function(resp) {
            window.location = "/stations/episode/".concat(resp[0].vsb_id);
        });
    };
    var makeEpisodesModal = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _episodesListDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, episodes), {
            modalRef: episodesListRef,
            onClose: onEpisodesClose,
            breadcrumbs: breadcrumbs,
            onDuplicateEpisode: onEpisodeDuplicate,
            onBatchEdit: onBatchEdit,
            onBatchSave: onBatchSave
        }));
    };
    var makeAddNewEpisodeModal = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoSetEditDefault.default), {
            apiURL: "api/videosetrename",
            id: "VideoSetEdit",
            modalRef: viewEpisodesRef,
            title: addnew.modalTitle,
            labelText: addnew.labelText,
            open: addnew.open,
            value: addnew.title,
            onInput: onAddEpisodeChange,
            onSubmit: onAddEpisodeSave,
            onClose: onAddEpisodeClose,
            error: addnew.error
        });
    };
    var makeAddNewModal = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seriesEditDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, addnewseries), {
            modalRef: addNewModalRef,
            id: "destinations_new_set_name",
            apiURL: (0, _configuration.API_VIDEOSET_RENAME),
            onInput: onAddSeriesInput,
            onSubmit: onAddSeriesSave,
            onClose: onAddSeriesClose,
            onReset: onAddSeriesClose
        }));
    };
    var makeEditSeriesModal = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editModalDefault.default), {
            id: "stations-editseries",
            modalRef: editSeriesRef,
            onSubmit: onEditSeriesTitleSave,
            onClose: onEditSeriesTitleClose,
            onInput: onEditSeriesTitleInput,
            apiURL: "/",
            labelText: "Edit a new name for this series",
            title: "Change series title",
            value: editseries.value
        });
    };
    var isLoaded = function() {
        if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        else return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stationsFilterDefault.default), {
                    onFilterType: filterSeries
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stationsSeriesTableDefault.default), {
                    modalRef: editSeriesRef,
                    header: [
                        "Series",
                        "Actions"
                    ],
                    rows: filtered,
                    onViewEpisodes: onViewEpisodes,
                    onAddEpisode: onAddEpisode,
                    onEditSeriesTitle: onEditSeriesTitle
                })
            ]
        });
    };
    var makeNewSeriesButton = function() {
        var btn = null;
        if ((0, _utilities.isAdmin)(project)) btn = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn btn--action",
                onClick: onAddSeries,
                children: "Add New Series"
            })
        });
        return btn;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "stations__view stations__view--withbreadcrumb",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbDefault.default), {
                        items: breadcrumbs,
                        ariaLabel: "Stations navigation"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                children: [
                                    "Series for ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: meta.station
                                    })
                                ]
                            }),
                            makeNewSeriesButton()
                        ]
                    })
                ]
            }),
            isLoaded(),
            makeEpisodesModal(),
            makeAddNewEpisodeModal(),
            makeAddNewModal(),
            makeEditSeriesModal()
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StationView, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","../subcomponents/Breadcrumb":"e7Haa","./StationsSeriesTable":"f8ACM","./StationsFilter":"5nr6K","./EpisodesList":"2dqN7","../subcomponents/LoaderSimple":"1dSHa","../Destinations/VideoSetEdit":"6ByaZ","../Destinations/SeriesEdit":"1313R","../subcomponents/EditModal":"9N2qs","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/StationsUtils":"Ja4lj","./css/StationView.css":"beCvR","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"f8ACM":[function(require,module,exports) {
/**
 * StationsSeriesTable
 * Display table data for the stations series.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _stationsSeriesTableCss = require("./css/StationsSeriesTable.css");
var StationsSeriesTable = function(param) {
    var onEditSeriesTitle = param.onEditSeriesTitle, onAddEpisode = param.onAddEpisode, onViewEpisodes = param.onViewEpisodes, _param_headers = param.headers, headers = _param_headers === void 0 ? [] : _param_headers, _param_rows = param.rows, rows = _param_rows === void 0 ? [] : _param_rows;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), stations = _useState[0], setStations = _useState[1];
    var makeHeader = function() {
        var ths = headers.map(function(thd, idx) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                children: thd
            }, idx);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: ths
            })
        });
    };
    var makeLink = function(item) {
        var link;
        if (!Object.hasOwn(item, "isSeries") || Object.hasOwn(item, "isSeries") && (item === null || item === void 0 ? void 0 : item.isSeries) === true) link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/stations/series/".concat(item.setID),
            children: item.setName
        });
        else link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/stations/episode/".concat(item.setID),
            children: item.setName
        });
        return link;
    };
    var makeControls = function(item) {
        var controls;
        if (!Object.hasOwn(item, "isSeries") || Object.hasOwn(item, "isSeries") && (item === null || item === void 0 ? void 0 : item.isSeries) === true) controls = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "btn btn-sm btn-light stations__btn__editseries",
                    "data-episode": item.setID,
                    "data-setname": item.setName,
                    onClick: onEditSeriesTitle,
                    children: "Edit Series Title"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "btn btn-sm btn--action",
                    "data-episode": item.setID,
                    "data-setname": item.setName,
                    onClick: onViewEpisodes,
                    children: "View Episodes"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "btn btn-sm btn--action",
                    "data-series": item.setID,
                    onClick: onAddEpisode,
                    children: "Add Episode"
                })
            ]
        });
        else controls = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/stations/episode/".concat(item.setID),
            children: "View episode"
        });
        return controls;
    };
    var makeRows = function() {
        var trs = rows.map(function(trd, idx) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: makeLink(trd)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: makeControls(trd)
                    })
                ]
            }, "row_".concat(idx));
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
            children: trs
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
        className: "stations__series__table",
        children: [
            makeHeader(),
            makeRows()
        ]
    });
};
exports.default = StationsSeriesTable;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./css/StationsSeriesTable.css":"3eGr4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3eGr4":[function() {},{}],"5nr6K":[function(require,module,exports) {
/**
 * StationsFilter.js
 * Simple form + button component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _stationsFilterCss = require("./css/StationsFilter.css");
var StationsFilter = function(param) {
    var onFilterType = param.onFilterType;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        method: "dialog",
        className: "stations__filter",
        onChange: onFilterType,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "filter_eps",
                children: "Find series or episodes"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "search",
                name: "filter_eps",
                id: "filter_eps",
                "aria-describedby": "filter_eps_describe"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                id: "filter_eps_describe",
                className: "aria__description",
                children: "Enter a keyword or partial title. Limited to the current station."
            })
        ]
    });
};
StationsFilter.propTypes = {
    onFilterType: (0, _propTypesDefault.default).func.isRequired
};
exports.default = StationsFilter;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/StationsFilter.css":"1c4no","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1c4no":[function() {},{}],"2dqN7":[function(require,module,exports) {
/**
 * EpisodesList.jsx
 * Displays modal list of episodes within a video set.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _closeButton = require("../subcomponents/CloseButton");
var _dateFns = require("date-fns");
var _reactRouterDom = require("react-router-dom");
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _seasonsEpsInput = require("./SeasonsEpsInput");
var _seasonsEpsInputDefault = parcelHelpers.interopDefault(_seasonsEpsInput);
var _episodeListCount = require("./EpisodeListCount");
var _episodeListCountDefault = parcelHelpers.interopDefault(_episodeListCount);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _episodesListCss = require("./css/EpisodesList.css");
var EpisodesList = function(param) {
    var breadcrumbs = param.breadcrumbs, meta = param.meta, modalRef = param.modalRef, mode = param.mode, onClose = param.onClose, onBatchEdit = param.onBatchEdit, onBatchSave = param.onBatchSave, onDuplicateEpisode = param.onDuplicateEpisode;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), list = _useState[0], setList = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    (0, _react.useEffect)(function() {
        if (+meta.id) getEpisodes();
    }, [
        meta
    ]);
    var getEpisodes = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", meta.id);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ASSIGNMENTS), {
            body: fd
        }, function(data) {
            // Add place holder properties for season and episode
            var episodes = data.map(function(ep) {
                var s_e = {
                    season: +ep.season || 0,
                    episode: +ep.episode || 0
                };
                return Object.assign(ep, s_e);
            });
            setList(episodes);
            setLoading(false);
        });
    };
    var onBatchSaver = function(domEvent) {
        domEvent.preventDefault();
        if (onBatchSave) onBatchSave(list);
    };
    var onSeasonEpChange = function(domEvent) {
        var episodes = (0, _toConsumableArray._)(list);
        /*
    Seasons and episodes follow the format y:nnnn where y is either
    's' for 'season' or 'e' for 'episode.'
    
    line tells us whether we need to set the season or the
    episode property, and gives us the episode ID.
    */ var sEandID = domEvent.target.name.split(":");
        var which = episodes.findIndex(function(item) {
            return +sEandID[1] === +item.vsb_id;
        });
        if (sEandID[0] === "s") episodes[which].season = +domEvent.target.value;
        if (sEandID[0] === "e") episodes[which].episode = +domEvent.target.value;
        setList(episodes);
    };
    var makeEpisodesView = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "episodes__display__batch",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--action",
                        onClick: onBatchEdit,
                        hidden: mode === "page",
                        children: "Batch Edit"
                    })
                }),
                makeEpisodesTable()
            ]
        });
    };
    var makeBatchView = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                    id: "EpisodesViewBatchSave",
                    method: "post",
                    onSubmit: onBatchSaver
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "episodes__display__batch",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        form: "EpisodesViewBatchSave",
                        className: "btn btn--action",
                        children: "Save Changes"
                    })
                }),
                makeEpisodesTable()
            ]
        });
    };
    var makeBody = function() {
        var body;
        if (loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: loading
        });
        else body = mode === "edit" ? makeBatchView() : makeEpisodesView();
        return body;
    };
    var makeEpisodesTable = function() {
        var table;
        if (!list.length) table = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
            children: "No episodes in set"
        });
        else {
            var season_count = countSeasons();
            var rows = list.map(function(item, idx) {
                var runtime = item.duration ? item.duration : 0;
                var rundate = (0, _dateFns.isValid)(item.vsb_datetimetorun) ? (0, _dateFns.format)(new Date(item.vsb_datetimetorun), "D MMM yyyy") : (0, _configuration.NULL_DATE_TEXT_STATIONS);
                var season, episode;
                if (mode === "edit") {
                    season = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seasonsEpsInputDefault.default), {
                        value: item.season || 0,
                        id: "s:".concat(item.vsb_id),
                        onChange: onSeasonEpChange,
                        form: "EpisodesViewBatchSave",
                        label: "Season Number"
                    });
                    episode = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seasonsEpsInputDefault.default), {
                        value: item.episode || 0,
                        id: "e:".concat(item.vsb_id),
                        onChange: onSeasonEpChange,
                        form: "EpisodesViewBatchSave",
                        label: "Episode Number"
                    });
                } else {
                    season = item.season || "\u2015";
                    episode = item.episode || "\u2015";
                }
                var fruntime = runtime === 0 ? "00:00:00" : (0, _utilities.formatTime)(runtime);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: item.title || (0, _configuration.NULL_EPISODE_TITLE)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: rundate
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: item.video_count
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: fruntime
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: makeControls(item.vsb_id)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: season
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: episode
                        })
                    ]
                }, item.vsb_id);
            });
            table = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _episodeListCountDefault.default), {
                        episodes: list.length,
                        seasons: season_count.seasons,
                        unassigned: season_count.unassigned
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                        className: "episodes__display__table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Title"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Run date"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Video count"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Run time"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Actions"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Season"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Episode"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                children: rows
                            })
                        ]
                    })
                ]
            });
        }
        return table;
    };
    var makeControls = function(episodeid) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: {
                        pathname: "/stations/episode/".concat(episodeid),
                        state: {
                            set: meta,
                            list: list,
                            breadcrumbs: (0, _toConsumableArray._)(breadcrumbs)
                        }
                    },
                    children: "View / Edit"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    className: "episodes__list__dup",
                    method: "post",
                    onSubmit: onDuplicateEpisode,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            name: "id",
                            value: episodeid
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn__link",
                            children: "Duplicate"
                        })
                    ]
                })
            ]
        });
    };
    var countSeasons = function() {
        var eps = list;
        if (!eps.length) return;
        // Extract the season number from every episode
        var season_numbers = eps.map(function(item) {
            return item.season;
        });
        // Find unique season values that aren't NULL
        var unique = season_numbers.filter(function(item, index, arr) {
            return item && arr.indexOf(item) === index;
        });
        // Find unique season values that are falsy (0 or NULL)
        var unassigned = season_numbers.filter(function(item) {
            return item == false;
        });
        // Return the number of values
        return {
            seasons: unique.length,
            unassigned: unassigned.length
        };
    };
    if (Object.hasOwn(meta, "title")) title = meta.title ? meta.title.trim() : (0, _configuration.NULL_SET_TITLE);
    if (mode === "page") mode = makeBody();
    else mode = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        setid: meta.id,
        id: "EpisodesView",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                children: [
                    "Episodes for ",
                    "\u201C".concat(title, "\u201D")
                ]
            }),
            makeBody()
        ]
    });
    return mode;
};
EpisodesList.propTypes = {
    onDuplicateEpisode: (0, _propTypesDefault.default).func.isRequired,
    onClose: (0, _propTypesDefault.default).func.isRequired,
    meta: (0, _propTypesDefault.default).object
};
exports.default = EpisodesList;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/CloseButton":"3MmmO","date-fns":"1h4Hj","react-router-dom":"gMZz4","../subcomponents/LoaderSimple":"1dSHa","./SeasonsEpsInput":"3XeB2","./EpisodeListCount":"5vF0T","../subcomponents/ModalDialog":"72kji","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","./css/EpisodesList.css":"fcq8N","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3XeB2":[function(require,module,exports) {
/**
 * SeasonsEpsInput.jsx
 * Simple number input component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _seasonsEpsInputCss = require("./css/SeasonsEpsInput.css");
var SeasonsEpsInput = function(param) {
    var id = param.id, label = param.label, onChange = param.onChange, form = param.form, value = param.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "seasons__ep__input",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                className: "form__access__label",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "number",
                name: id,
                id: id,
                onChange: onChange,
                form: form,
                value: value,
                step: "1",
                min: "0",
                size: "3"
            })
        ]
    });
};
SeasonsEpsInput.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    value: (0, _propTypesDefault.default).number,
    onChange: (0, _propTypesDefault.default).func.isRequired
};
exports.default = SeasonsEpsInput;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/SeasonsEpsInput.css":"2BgHw","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2BgHw":[function() {},{}],"5vF0T":[function(require,module,exports) {
/**
 * EpisodeListCount.js
 * Simple number input component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _episodeListCountCss = require("./css/EpisodeListCount.css");
var EpisodeListCount = function(props) {
    var episodes = props.episodes, seasons = props.seasons, unassigned = props.unassigned;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "episodes__list__count",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                className: "episodes__list__count_num",
                children: episodes
            }),
            " ",
            "total episodes in",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                className: "episodes__list__count_num",
                children: [
                    " ",
                    seasons
                ]
            }),
            " ",
            "seasons (",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                children: unassigned
            }),
            " ",
            "unsorted)"
        ]
    });
};
EpisodeListCount.propTypes = {
    episodes: (0, _propTypesDefault.default).number.isRequired,
    seasons: (0, _propTypesDefault.default).number.isRequired,
    unassigned: (0, _propTypesDefault.default).number.isRequired
};
exports.default = EpisodeListCount;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/EpisodeListCount.css":"288xZ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"288xZ":[function() {},{}],"fcq8N":[function() {},{}],"1313R":[function(require,module,exports) {
/**
 * SeriesEdit.js
 * Allows for renaming of series. Mostly the same as VideoSetEdit.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _closeButton = require("../subcomponents/CloseButton");
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _videoSetEditCss = require("../../css/VideoSetEdit.css");
var SeriesEdit = function(param) {
    var error = param.error, modalRef = param.modalRef, title = param.title, open = param.open, onClose = param.onClose, onInput = param.onInput, onSubmit = param.onSubmit, onReset = param.onReset, value = param.value, apiURL = param.apiURL, id = param.id, _param_labelText = param.labelText, labelText = _param_labelText === void 0 ? "Enter a name for this video set" : _param_labelText;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "SeriesEditModal",
        className: "edit__modal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                action: apiURL,
                method: "dialog",
                onSubmit: onSubmit,
                onReset: onReset,
                className: "video__set__edit__form",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "destinations_new_set_name",
                            children: labelText
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    onChange: onInput,
                                    name: id,
                                    id: id,
                                    defaultValue: value,
                                    "aria-describedby": "video_set_edit_error",
                                    required: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn--action",
                                    children: "Save"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "reset",
                                    className: "btn",
                                    children: "Cancel"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            id: "video_set_edit_error",
                            className: "video__set__edit__error",
                            hidden: !error,
                            children: error
                        })
                    ]
                })
            })
        ]
    });
};
SeriesEdit.propTypes = {
    onInput: (0, _propTypesDefault.default).func.isRequired,
    onSubmit: (0, _propTypesDefault.default).func.isRequired,
    onReset: (0, _propTypesDefault.default).func,
    onClose: (0, _propTypesDefault.default).func.isRequired,
    apiURL: (0, _propTypesDefault.default).string.isRequired,
    value: (0, _propTypesDefault.default).string,
    id: (0, _propTypesDefault.default).string.isRequired
};
exports.default = SeriesEdit;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../subcomponents/CloseButton":"3MmmO","../subcomponents/ModalDialog":"72kji","../../css/VideoSetEdit.css":"g8Nmw","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"g8Nmw":[function() {},{}],"9N2qs":[function(require,module,exports) {
/**
 * EditModal.js
 * Allows for renaming of series. Mostly the same as VideoSetEdit.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _closeButton = require("./CloseButton");
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _videoSetEditCss = require("../../css/VideoSetEdit.css");
var _editModalCss = require("./css/EditModal.css");
var EditModal = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function EditModal(props, ref) {
    var apiURL = props.apiURL, cssClass = props.cssClass, error = props.error, id = props.id, labelText = props.labelText, modalRef = props.modalRef, onInput = props.onInput, onSubmit = props.onSubmit, title = props.title, value = props.value;
    var onClose = function() {
        if (modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) modalRef.current.close();
    };
    var onReset = function(domEvent) {
        if (modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) modalRef.current.close();
    };
    var cssClasses = (0, _classnamesDefault.default)({
        "edit__modal": true
    }, cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        className: cssClasses,
        ref: modalRef,
        id: "EditModal",
        title: "Add Songs",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                action: apiURL,
                method: "dialog",
                onSubmit: onSubmit,
                onReset: onReset,
                className: "video__set__edit__form",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "destinations_new_set_name",
                            children: labelText
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    ref: ref,
                                    onChange: onInput,
                                    name: id,
                                    id: id,
                                    defaultValue: value,
                                    required: true,
                                    "aria-describedby": "video_set_edit_error"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn--action",
                                    children: "Save"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "reset",
                                    className: "btn",
                                    children: "Cancel"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            id: "video_set_edit_error",
                            className: "video__set__edit__error",
                            hidden: !error,
                            children: error
                        })
                    ]
                })
            })
        ]
    });
});
EditModal.propTypes = {
    onInput: (0, _propTypesDefault.default).func.isRequired,
    onSubmit: (0, _propTypesDefault.default).func.isRequired,
    onReset: (0, _propTypesDefault.default).func,
    onClose: (0, _propTypesDefault.default).func.isRequired,
    apiURL: (0, _propTypesDefault.default).string.isRequired,
    value: (0, _propTypesDefault.default).string,
    id: (0, _propTypesDefault.default).string.isRequired,
    title: (0, _propTypesDefault.default).string.isRequired,
    labelText: (0, _propTypesDefault.default).string.isRequired
};
exports.default = EditModal;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","./CloseButton":"3MmmO","./ModalDialog":"72kji","../../css/VideoSetEdit.css":"g8Nmw","./css/EditModal.css":"e7H0U","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"g8Nmw":[function() {},{}],"e7H0U":[function() {},{}],"beCvR":[function() {},{}],"70p5f":[function(require,module,exports) {
/**
 * EpisodeView.js
 * View a single episode. Page page-level component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _addVideosByURL = require("../Destinations/AddVideosByURL");
var _addVideosByURLDefault = parcelHelpers.interopDefault(_addVideosByURL);
var _breadcrumb = require("../subcomponents/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _checkForDuplicatesModal = require("../Destinations/CheckForDuplicatesModal");
var _checkForDuplicatesModalDefault = parcelHelpers.interopDefault(_checkForDuplicatesModal);
var _checkForUpdates = require("../Destinations/CheckForUpdates");
var _checkForUpdatesDefault = parcelHelpers.interopDefault(_checkForUpdates);
var _checkForUpdatesProgress = require("../Destinations/CheckForUpdatesProgress");
var _checkForUpdatesProgressDefault = parcelHelpers.interopDefault(_checkForUpdatesProgress);
var _crtstatus = require("../Destinations/CRTStatus");
var _crtstatusDefault = parcelHelpers.interopDefault(_crtstatus);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _dragSortList = require("../DragSortList");
var _dragSortListDefault = parcelHelpers.interopDefault(_dragSortList);
var _destinationsToggleView = require("../Destinations/DestinationsToggleView");
var _episodeViewTitle = require("./EpisodeViewTitle");
var _episodeViewTitleDefault = parcelHelpers.interopDefault(_episodeViewTitle);
var _episodeMoveModal = require("./EpisodeMoveModal");
var _episodeMoveModalDefault = parcelHelpers.interopDefault(_episodeMoveModal);
var _exportCSV = require("../Destinations/ExportCSV");
var _exportCSVDefault = parcelHelpers.interopDefault(_exportCSV);
var _runtimeRatings = require("../Destinations/RuntimeRatings");
var _runtimeRatingsDefault = parcelHelpers.interopDefault(_runtimeRatings);
var _runDate = require("../Stations/RunDate");
var _runDateDefault = parcelHelpers.interopDefault(_runDate);
var _seasonsEpsDisplay = require("./SeasonsEpsDisplay");
var _seasonsEpsDisplayDefault = parcelHelpers.interopDefault(_seasonsEpsDisplay);
var _videoDragItem = require("../subcomponents/VideoDragItem");
var _videoDragItemDefault = parcelHelpers.interopDefault(_videoDragItem);
var _videoModal = require("../subcomponents/Videos/VideoModal");
var _videoModalDefault = parcelHelpers.interopDefault(_videoModal);
var _videoSetEdit = require("../Destinations/VideoSetEdit");
var _videoSetEditDefault = parcelHelpers.interopDefault(_videoSetEdit);
var _videosList = require("../VideosList");
var _videosListDefault = parcelHelpers.interopDefault(_videosList);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _stationsUtils = require("../../actions/StationsUtils");
var _destinationsPlaylistUtils = require("../../actions/DestinationsPlaylistUtils");
var _destinationsUtils = require("../../actions/DestinationsUtils");
var _episodeViewCss = require("./css/EpisodeView.css");
var _videoDisplayCss = require("../Destinations/css/VideoDisplay.css");
var EpisodeView = function(param) {
    var params = param.params, project = param.project;
    var episodeReNameRef = (0, _react.useRef)(null);
    var episodeDeleteDialog = (0, _react.useRef)(null);
    var addVideosByUrlRef = (0, _react.useRef)(null);
    var addVideosFromAvaRef = (0, _react.useRef)(null);
    var checkForDupesModal = (0, _react.useRef)(null);
    var episodeMoveRef = (0, _react.useRef)(null);
    var videoModalRef = (0, _react.useRef)(null);
    var cfupRef = (0, _react.useRef)(null);
    var episodeID = params.episodeID;
    var canAdmin = (0, _utilities.isAdmin)(project);
    var initEditTitle = {
        meta: {},
        list: [],
        open: false,
        value: "",
        error: null,
        id: 0
    };
    var initAddByUrl = {
        open: false,
        value: "",
        maxIds: false,
        working: false
    };
    var initVideosToAdd = {
        open: false,
        isloading: true,
        available: [],
        page: 1,
        pageCount: 1,
        results: 0,
        perPage: 10,
        sortBy: "video_addeddate",
        ascending: false,
        filterKeyword: "",
        filterOn: "",
        selected: []
    };
    var initMeta = {
        se: {
            season: 0,
            episode: 0
        },
        vsb_datetimetorun: null
    };
    var initCheckForUpdates = {
        open: false,
        updates: [],
        loading: true,
        mode: "" // One of 'checking', 'adding'
    };
    var initMoveEp = {
        open: false,
        value: "",
        series: []
    };
    var initCheckForDupes = {
        open: false,
        loading: true,
        dupes: [],
        mode: "adding",
        working: false,
        response: {},
        message: ""
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), series = _useState[0], setSeries = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), list = _useState1[0], setList = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([
        {
            path: null,
            label: ""
        }
    ]), 2), breadcrumbs = _useState2[0], setBreadcrumbs = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(""), 2), title = _useState3[0], setTitle = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(initEditTitle), 2), editTitle = _useState4[0], setEditTitle = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(initAddByUrl), 2), addByURL = _useState5[0], setAddByURL = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(initVideosToAdd), 2), videostoadd = _useState6[0], setVideosToAdd = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(""), 2), videopreview = _useState7[0], setVideoPreview = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)({}), 2), crtstatus = _useState8[0], setCRTStatus = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)(initMeta), 2), meta = _useState9[0], setMeta = _useState9[1];
    var _useState10 = (0, _slicedToArray._)((0, _react.useState)(""), 2), rating = _useState10[0], setRating = _useState10[1];
    var _useState11 = (0, _slicedToArray._)((0, _react.useState)(0), 2), runtime = _useState11[0], setRuntime = _useState11[1];
    var _useState12 = (0, _slicedToArray._)((0, _react.useState)(initCheckForUpdates), 2), checkForUpdates = _useState12[0], setCheckForUpdates = _useState12[1];
    var _useState13 = (0, _slicedToArray._)((0, _react.useState)(initMoveEp), 2), moveep = _useState13[0], setMoveEp = _useState13[1];
    var _useState14 = (0, _slicedToArray._)((0, _react.useState)({
        open: false
    }), 2), deleteep = _useState14[0], setDeleteEp = _useState14[1];
    var _useState15 = (0, _slicedToArray._)((0, _react.useState)(true), 2), useGrid = _useState15[0], setUseGrid = _useState15[1];
    var _useState16 = (0, _slicedToArray._)((0, _react.useState)(initCheckForDupes), 2), checkForDupes = _useState16[0], setCheckForDupes = _useState16[1];
    var _useState17 = (0, _slicedToArray._)((0, _react.useState)(true), 2), hideSaveStatus = _useState17[0], setHideSaveStatus = _useState17[1];
    var _useState18 = (0, _slicedToArray._)((0, _react.useState)([]), 2), submissions = _useState18[0], setSubmissions = _useState18[1];
    (0, _react.useEffect)(function() {
        if (!list.length) getVideosForBlock();
        if ((0, _utilities.isEmptyObject)(crtstatus)) getEpisodeCRTStatus();
        if (!rating) getEpisodeRating();
    }, [
        list,
        crtstatus
    ]);
    var closeModal = function() {
        episodeDeleteDialog === null || episodeDeleteDialog === void 0 ? void 0 : episodeDeleteDialog.current.close();
    };
    var changePerPageHandler = function(domEvent) {
        domEvent.persist();
        getVideoListBatchRequest(domEvent.target.value);
    };
    var getVideosForBlock = function() {
        var fd = new FormData();
        if (!episodeID) {
            alert("ERROR: Try refreshing the page.");
            return;
        }
        fd.set("id", episodeID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        // Fetch the block's videos.
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_INFO), {
            body: fd
        }, function(response) {
            var videoList = response.videoList, vsb_setID = response.vsb_setID, title = response.title, Station = response.Station, station_id = response.station_id, Video_Set = response.Video_Set;
            // If this is an empty set don't do anything.
            if (!response.vsb_setID) {
                setList([
                    false
                ]);
                return;
            }
            var returnData = videoList.returnData;
            var crumb = [
                {
                    path: "/stations/".concat(station_id),
                    label: response.Station
                },
                {
                    path: "/stations/series/".concat(vsb_setID),
                    label: Video_Set || (0, _configuration.NULL_SET_TITLE)
                },
                {
                    path: "",
                    label: title || (0, _configuration.NULL_EPISODE_TITLE)
                }
            ];
            setBreadcrumbs(crumb);
            setSeries(vsb_setID);
            if (returnData.length) setList((0, _stationsUtils.formatVideoList)(returnData));
            else setList([
                false
            ]);
            setTitle(response.title);
            setMeta(response);
            setVideosToAdd((0, _objectSpreadProps._)((0, _objectSpread._)({}, videostoadd), {
                selected: returnData
            }));
            setRuntime((0, _utilities.totalRunTime)(returnData));
            setEditTitle(title);
            setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
                working: false
            }));
        });
    };
    var getEpisodeCRTStatus = function() {
        if ((0, _utilities.isEmptyObject)(params) || !Object.hasOwn(params, "episodeID")) throw new Error("Missing the episode ID. Please check the URL.");
        var fd = new FormData();
        fd.set("videoset", episodeID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CRTAPPROVALS_GETVIDSETSTATUS), {
            body: fd
        }, function(data) {
            setCRTStatus((0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                loading: false
            }));
        });
    };
    var getEpisodeRating = function() {
        var fd = new FormData();
        fd.set("videosetblockid", episodeID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        // Make the network request here.
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_RATING), {
            body: fd
        }, function(data) {
            if (data.message === "success") setRating(data.rating);
        });
    };
    var makeBreadcrumb = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbDefault.default), {
            items: breadcrumbs,
            ariaLabel: "Destinations menu"
        });
    };
    var onCloseAddByUrlModal = function() {
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            value: ""
        }));
        if (addVideosByUrlRef === null || addVideosByUrlRef === void 0 ? void 0 : addVideosByUrlRef.current) addVideosByUrlRef.current.close();
    };
    var makeAddVidsByURL = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addVideosByURLDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            modalRef: addVideosByUrlRef,
            block: episodeID,
            onClose: onCloseAddByUrlModal,
            onSubmit: onAddVideoByUrlSubmit,
            onChange: onAddVideoByUrlChange
        }));
    };
    var onVideoSelected = function(domEvent) {
        var picked = domEvent.target.value.toString();
        var nselected;
        var toAdd;
        if (addByURL.value) toAdd = addByURL.value.split(/[,\s]/);
        else toAdd = [];
        // If the box is checked and it's not already in the list...
        if (domEvent.target.checked) {
            // Find the item in the videosAvailable list
            var addThis = videostoadd.available.find(function(item) {
                return item.video_youtubeID === picked;
            });
            nselected = (0, _toConsumableArray._)(videostoadd.selected).concat([
                addThis
            ]);
            toAdd.push(picked);
        } else {
            nselected = videostoadd.selected.filter(function(item) {
                return item.video_youtubeID !== picked;
            });
            toAdd = toAdd.filter(function(item) {
                return item !== picked;
            });
        }
        setVideosToAdd((0, _objectSpreadProps._)((0, _objectSpread._)({}, videostoadd), {
            selected: nselected
        }));
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByUrl), {
            value: toAdd.join(",")
        }));
    };
    var getVideoListBatchRequest = function() {
        var perPage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, sort = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", keyword = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", criteria = arguments.length > 4 ? arguments[4] : void 0, orderby = arguments.length > 5 ? arguments[5] : void 0;
        var fd = new FormData();
        fd.set("perpage", perPage);
        fd.set("page", page);
        fd.set("sort_by", sort);
        fd.set("filter_by", keyword);
        fd.set("filter_on", criteria);
        fd.set("order", orderby);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_GETBATCH), {
            body: fd
        }, function(response) {
            setVideosToAdd((0, _objectSpreadProps._)((0, _objectSpread._)({}, videostoadd), {
                available: response.videos,
                page: response.current_page,
                pageCount: response.pages,
                results: response.num_results,
                isloading: false
            }));
        });
    };
    var getVideoListBatchSortDir = function() {
        var direction = [
            "descending",
            "ascending"
        ];
        var dirKey = +videostoadd.ascending;
        return direction[dirKey];
    };
    var onSearchFilterChangeHandler = function(domEvent) {
        var keyword = domEvent.target.value;
        var criterion = domEvent.target.form.elements.filterOn.value.split("|")[0];
        setVideosToAdd((0, _objectSpreadProps._)((0, _objectSpread._)({}, videostoadd), {
            filterKeyword: keyword,
            filterOn: criterion,
            page: 1,
            pageCount: 1
        }));
        getVideoListBatchRequest(undefined, undefined, videostoadd.sortBy, keyword, criterion, videostoadd.sortBy);
    };
    var onVideoInfoClose = function() {
        setVideoPreview("");
        if (videoModalRef.current) videoModalRef.current.close();
    };
    var onSeasonEpChange = function(domEvent) {
        var _domEvent_target = domEvent.target, id = _domEvent_target.id, value = _domEvent_target.value;
        var newmeta = (0, _objectSpreadProps._)((0, _objectSpread._)({}, meta), {
            se: (0, _objectSpreadProps._)((0, _objectSpread._)({}, meta.se), (0, _defineProperty._)({}, id, value))
        });
        setMeta(newmeta);
    };
    var onSeasonEpSave = function() {
        var vsb_id = meta.vsb_id, se = meta.se;
        var season = se.season, episode = se.episode;
        (0, _stationsUtils.saveSeasonEp)(vsb_id, season, episode, function(data) {
            setHideSaveStatus(false);
            manageSaveAlert();
        });
    };
    var onRunDateChange = function(domEvent) {
        var value = domEvent.target.value;
        setMeta((0, _objectSpreadProps._)((0, _objectSpread._)({}, meta), {
            vsb_datetimetorun: value
        }));
        var fd = new FormData();
        fd.set("id", meta.vsb_id);
        fd.set("rundate", value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_UPDATE), {
            body: fd
        }, function(response) {
            setHideSaveStatus(false);
            setTimeout(function() {
                setHideSaveStatus(true);
            }, 3000);
        });
    };
    /*
    Duplicates DestinationPlaylist methods. Need to normalize the names that the
    API returns. Then we can consolidate these into a Utility module.
  */ var onCRTsubmit = function(data) {
        if (data.status !== "success") return;
        var vl = (0, _toConsumableArray._)(list);
        var whichVideo = vl.findIndex(function(item) {
            return item.ytID === data.video_ytid;
        });
        vl[whichVideo].crt = data.crt;
        setList(vl);
    };
    var onMeowSave = function(data) {
        if (data.status !== "success") return;
        var vl = (0, _toConsumableArray._)(list);
        var whichVideo = vl.findIndex(function(item) {
            return item.ytID === data.video_ytid;
        });
        vl[whichVideo].meow = data.meow;
        setList(vl);
    };
    var makeSeriesOptions = function(item) {
        return {
            label: item.setName,
            value: item.setID
        };
    };
    var makeVideoList = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videosListDefault.default), {
            modalRef: addVideosFromAvaRef,
            currentSet: list,
            blockId: episodeID,
            onSubmit: function() {
                setList([]);
            }
        });
    };
    // Shows the video modal
    var onAddVideoFromAva = function() {
        if (addVideosByUrlRef === null || addVideosByUrlRef === void 0 ? void 0 : addVideosByUrlRef.current) addVideosByUrlRef.current.close();
        if (addVideosFromAvaRef === null || addVideosFromAvaRef === void 0 ? void 0 : addVideosFromAvaRef.current) addVideosFromAvaRef.current.showModal();
        getVideoListBatchRequest();
    };
    var onAddVideoFromAvaClose = function() {
        if (addVideosFromAvaRef === null || addVideosFromAvaRef === void 0 ? void 0 : addVideosFromAvaRef.current) addVideosFromAvaRef.current.close();
        setVideosToAdd(initVideosToAdd);
    };
    var onAddVideoByURLClose = function() {
        if (addVideosByUrlRef === null || addVideosByUrlRef === void 0 ? void 0 : addVideosByUrlRef.current) addVideosByUrlRef.current.close();
        setVideosToAdd(initVideosToAdd);
    };
    var onAddVideoByUrlChange = function(domEvent) {
        var value = domEvent.target.value;
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            value: value,
            maxIds: (0, _destinationsUtils.tooManyURLs)(value)
        }));
    };
    var onAddVideoByURLResponse = function(response) {
        var videoList = response.videoList;
        var returnData = videoList.returnData;
        setList((0, _stationsUtils.formatVideoList)(returnData));
        setVideosToAdd((0, _objectSpreadProps._)((0, _objectSpread._)({}, videostoadd), {
            selected: returnData,
            open: false
        }));
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            open: false,
            working: false,
            value: ""
        }));
        setRuntime((0, _utilities.totalRunTime)(returnData));
    };
    var makeVideos = function() {
        if (!list || list[0] === false) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
            children: "No videos in this episode."
        });
        var cssClass = (0, _classnamesDefault.default)({
            "video__display": true,
            "video__display--grid": useGrid,
            "video__display--listview": !useGrid
        });
        var grid = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "draggable__grid episode__videolist",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            children: "Drag videos to reorder. Click thumbnail to view video information."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "episode__savestatus",
                            hidden: hideSaveStatus,
                            children: "Saved"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _destinationsToggleView.DestinationsToggleView), {
                    useGrid: useGrid,
                    onChange: onGridToggleChange
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: cssClass,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dragSortListDefault.default), {
                        items: list,
                        onPlayVideo: oOnPlayVideo,
                        onDeleteVideo: deleteVideo,
                        onReSort: function(newOrder) {
                            setList(newOrder);
                            gridUpdated(newOrder);
                        }
                    })
                })
            ]
        });
        return grid;
    };
    var oOnPlayVideo = function(videoId) {
        setVideoPreview(videoId);
        if (videoModalRef.current) videoModalRef.current.showModal();
    };
    var gridUpdated = function(videos) {
        var ordered;
        if (videos.length) {
            ordered = videos.map(function(vid) {
                return vid.ytID;
            });
            // Saves the new order to the server.
            saveNewOrder(ordered);
        }
    };
    var saveNewOrder = function(order) {
        var fd = new FormData();
        var id = meta.vsb_id;
        fd.set("id", id);
        fd.set("videos", order.join(","));
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSETBLOCK_REORDERED), {
            body: fd
        }, function(data) {
            var returnData = data.returnData;
            if (!returnData.length) return;
            setList((0, _stationsUtils.formatVideoList)(returnData));
            setRuntime((0, _utilities.totalRunTime)(returnData));
        });
    };
    var onEpisodeEdit = function() {
        if (episodeReNameRef === null || episodeReNameRef === void 0 ? void 0 : episodeReNameRef.current) episodeReNameRef === null || episodeReNameRef === void 0 ? void 0 : episodeReNameRef.current.showModal();
    };
    var onEpisodeEditClose = function() {
        if (episodeReNameRef === null || episodeReNameRef === void 0 ? void 0 : episodeReNameRef.current) episodeReNameRef === null || episodeReNameRef === void 0 ? void 0 : episodeReNameRef.current.close();
    };
    var onEpisodeEditSave = function(domEvent) {
        domEvent.preventDefault();
        var target = domEvent.target;
        var fd = new FormData(target);
        fd.set("id", episodeID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_STATIONS_EPISODE_EDIT), {
            body: fd
        }, function(response) {
            if (response.result === "success") {
                var bc = (0, _toConsumableArray._)(breadcrumbs);
                // Update the last crumb with the new title.
                bc[breadcrumbs.length - 1] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, bc[breadcrumbs.length - 1]), {
                    label: response.title
                });
                setBreadcrumbs(bc);
                setTitle(response.title);
                if (episodeReNameRef === null || episodeReNameRef === void 0 ? void 0 : episodeReNameRef.current) episodeReNameRef === null || episodeReNameRef === void 0 ? void 0 : episodeReNameRef.current.close();
            } else setEditTitle((0, _objectSpreadProps._)((0, _objectSpread._)({}, editTitle), {
                error: response.message
            }));
        });
    };
    var onEpisodeMove = function() {
        var fd = new FormData();
        fd.set("id", +meta.station_id);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_ASSIGNMENTS), {
            body: fd
        }, function(response) {
            var options = response.map(makeSeriesOptions);
            setMoveEp((0, _objectSpreadProps._)((0, _objectSpread._)({}, moveep), {
                series: options
            }));
            if (episodeMoveRef === null || episodeMoveRef === void 0 ? void 0 : episodeMoveRef.current) episodeMoveRef === null || episodeMoveRef === void 0 ? void 0 : episodeMoveRef.current.showModal();
        });
    };
    var onEpisodeMoveClose = function() {
        setMoveEp(initMoveEp);
        if (episodeMoveRef === null || episodeMoveRef === void 0 ? void 0 : episodeMoveRef.current) episodeMoveRef === null || episodeMoveRef === void 0 ? void 0 : episodeMoveRef.current.close();
    };
    var onEpisodeMoveSave = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (Object.hasOwn(domEvent, "preventDefault")) domEvent.preventDefault();
        var fd = new FormData();
        fd.set("id", episodeID);
        fd.set("series", domEvent.target.elements.series.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        var callback1 = function(response) {
            if (response.error) window.alert(response.error);
            if (!response.series) return;
            var loaf = (0, _toConsumableArray._)(breadcrumbs);
            var sliced = {
                label: response.series.Video_Set,
                path: "/stations/series/".concat(response.series.vs_id)
            };
            // Replaces previous breadcrumb with new one.
            loaf.splice(1, 1, sliced);
            setBreadcrumbs(loaf);
        };
        (0, _utilities.apirequest)((0, _configuration.API_STATIONS_EPISODE_EDIT), {
            body: fd
        }, callback1);
    };
    var onEpisodeMoveChange = function(newValue) {
        setMoveEp((0, _objectSpreadProps._)((0, _objectSpread._)({}, moveep), {
            value: newValue
        }));
    };
    var onEpisodeDelete = function() {
        episodeDeleteDialog === null || episodeDeleteDialog === void 0 ? void 0 : episodeDeleteDialog.current.showModal();
    };
    var onEpisodeDeleteClose = function() {
        episodeDeleteDialog === null || episodeDeleteDialog === void 0 ? void 0 : episodeDeleteDialog.current.close();
    };
    var onEpisodeDeleteConfirm = function() {
        var fakeDomEvent = {
            target: {
                elements: {
                    series: {
                        value: "00000"
                    }
                }
            }
        };
        onEpisodeMoveSave(fakeDomEvent);
        episodeDeleteDialog === null || episodeDeleteDialog === void 0 ? void 0 : episodeDeleteDialog.current.close();
        window.location = "/stations/series/".concat(series);
    };
    var onCheckForUpdates = function(domEvent) {
        setCheckForUpdates((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForUpdates), {
            loading: true
        }));
        requestVideoUpdates();
        if (cfupRef.current) cfupRef.current.showModal();
    };
    var requestVideoUpdates = function() {
        var fd = new FormData();
        fd.set("id", meta.vsb_id);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_DESTINATIONS_CHECKFORUPDATES), {
            body: fd
        }, function(response) {
            if (!response.changed.length) setCheckForUpdates((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForUpdates), {
                loading: false
            }));
            else {
                var currentlist = (0, _toConsumableArray._)(list);
                // Update the current state for each changed item in the list.
                response.changed.forEach(function(item) {
                    var updateIt = currentlist.findIndex(function(vid, index) {
                        return vid.ytID === item.YouTube_ID;
                    });
                    currentlist[updateIt].name = item.Current_Title;
                });
                setList(currentlist);
                setCheckForUpdates((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForUpdates), {
                    updates: response.changed,
                    loading: false
                }));
            }
        });
    };
    var makeEpisodeEditModal = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoSetEditDefault.default), {
            modalRef: episodeReNameRef,
            id: "title",
            labelText: "Enter a new name for this episode",
            title: "Edit episode title",
            value: title,
            onSubmit: onEpisodeEditSave,
            onClose: onEpisodeEditClose,
            error: editTitle === null || editTitle === void 0 ? void 0 : editTitle.error
        });
    };
    var deleteVideo = function(videoObj) {
        var yes = window.confirm("Are you sure that you want to delete this video?");
        if (yes) {
            var fd = new FormData();
            fd.set("playlist", episodeID);
            fd.set("video", videoObj.id);
            fd.set("order", videoObj.position);
            fd.set("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_VIDEO_REMOVEFROMSET), {
                body: fd
            }, function(response) {
                if (response.itemsDeleted) {
                    alert("Video deleted.");
                    setList([]);
                }
            });
        }
    };
    var onAddVideoByURL = function() {
        if (addVideosByUrlRef === null || addVideosByUrlRef === void 0 ? void 0 : addVideosByUrlRef.current) addVideosByUrlRef.current.showModal();
    };
    var onAddVideoByUrlSubmit = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        domEvent.preventDefault();
        var postdupecheck = false;
        // Videos from the first submission.
        var add_videos_by_url_urls = domEvent.target.add_videos_by_url_urls;
        if (add_videos_by_url_urls) setSubmissions((0, _destinationsPlaylistUtils.splitURLs)(add_videos_by_url_urls.value));
        if (domEvent) postdupecheck = Object.hasOwn(domEvent.target.elements, "PostDupeCheck");
        // Find duplicates, then get unique values.
        var dupes = (0, _destinationsPlaylistUtils.checkUrlsForDupes)(addByURL.value, list);
        dupes = Array.from(new Set(dupes));
        console.log(dupes);
        /*
      If we have duplicates, and this form isn't being submitted after the duplicate
      checked display the 'Duplicates Found' modal.
    */ if (dupes.length && !postdupecheck) setTimeout(function() {
            addVideosByUrlRef.current.close();
            checkForDupesModal.current.showModal();
            setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                dupes: dupes,
                loading: false
            }));
        }, 100);
        else {
            setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                loading: true
            }));
            onSubmitUrlPostConfirmation(domEvent.target);
        }
    };
    var onSubmitUrlPostConfirmation = function(formElement) {
        var duplicates = formElement.elements.duplicates;
        // Returned the YouTube IDs for checked boxes only.
        var exclude = [];
        if (duplicates.length) exclude = Array.from(duplicates).filter(function(d) {
            return !d.checked;
        }).map(function(d) {
            return d.value;
        });
        /*
     Filter the excluded values from the submitted ones.
    */ var submits = submissions.map((0, _utilities.expandShortYouTubeUrl)).map((0, _utilities.extractYouTubeIdFromUrl)).filter(function(s) {
            return exclude.indexOf(s) == -1;
        });
        if (submits.length) {
            var fd = new FormData();
            fd.set("blockid", episodeID);
            fd.set("userID", (0, _utilities.getAuthData)("uuid"));
            fd.set("token", (0, _utilities.getAuthData)("token"));
            fd.set("videoids", submits.join(","));
            fd.set("prepend", +!addByURL.toggle.selected);
            (0, _utilities.apirequest)((0, _configuration.API_VIDEO_ADDBATCH), {
                body: fd
            }, function(response) {
                if (!response || Object.hasOwn(response, "error") && response.error) window.alert("ERROR: ".concat(response.message));
                else {
                    setCheckForDupes(initCheckForDupesState);
                    setAddByURL(initAddByUrlState);
                    setList([]);
                    if (checkForDupesModal.current) checkForDupesModal.current.close();
                    if (addByUrlModal.current) addByUrlModal.current.close();
                }
            });
        } else setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            maxIds: true
        }));
    };
    var saveVideosToEpisode = function() {
        var fd = new FormData();
        fd.set("blockid", meta.vsb_id);
        fd.set("userID", (0, _utilities.getAuthData)("uuid"));
        fd.set("videoids", addByURL.value);
        saveURLsToBlock(fd, callback, prepend = 0);
    };
    var onRatingsSubmit = function(response) {
        var youtubeid = response.youtubeid, rating = response.rating;
        var index = list.findIndex(function(f) {
            return f.ytID == youtubeid;
        });
        var changedList = (0, _toConsumableArray._)(list);
        var update = (0, _objectSpread._)({}, changedList[index]);
        update.rating = rating;
        changedList[index] = update;
        setList(changedList);
    };
    var manageSaveAlert = function() {
        var disappear = function() {
            setHideSaveStatus(true);
        };
        setTimeout(disappear, 3000);
    };
    var onCheckForUpdatesClose = function() {
        if (cfupRef.current) cfupRef.current.close();
    };
    var makeCheckForUpdatesModal = function() {
        var cfum = null;
        cfum = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForUpdatesProgressDefault.default), {
            apiurl: (0, _configuration.API_DESTINATIONS_CHECKFORUPDATES_CSV),
            modalRef: cfupRef,
            videoset: meta.vsb_id,
            videos: checkForUpdates.updates,
            loading: checkForUpdates.loading,
            onClose: onCheckForUpdatesClose
        });
        return cfum;
    };
    var makeMoveEpisodeModal = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _episodeMoveModalDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, moveep), {
            modalRef: episodeMoveRef,
            station: meta.station_id,
            onChange: onEpisodeMoveChange,
            onSubmit: onEpisodeMoveSave,
            onClose: onEpisodeMoveClose
        }));
    };
    var makeDeleteEpisodeModal = function() {
        var clickHandler = function(domEvent) {
            switch(domEvent.target.value){
                case "Yes":
                    onEpisodeDeleteConfirm();
                    break;
                default:
                    onEpisodeDeleteClose();
            }
        };
        var confirm = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            method: "dialog",
            onClick: clickHandler,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                    children: [
                        "Delete ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: title
                        }),
                        " from ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: meta.Video_Set
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    children: "Are you sure?"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn btn--action",
                            name: "confirm",
                            value: "Yes",
                            children: "Yes"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn btn--action",
                            name: "confirm",
                            value: "No",
                            children: "No"
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDialogDefault.default), {
            ref: episodeDeleteDialog,
            id: "EpisodeViewDeleteModal",
            onClose: onEpisodeDeleteClose,
            children: confirm
        });
    };
    var onGridToggleChange = function(domEvent) {
        /*
    `+domEvent.target.value` Converts the value to an integer. !! converts it to a boolean
    */ setUseGrid(!!+domEvent.target.value);
    };
    var onCheckForDuplicates = function(domEvent) {
        setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
            loading: true,
            dupes: (0, _utilities.unique)((0, _destinationsPlaylistUtils.checkDupes)((0, _toConsumableArray._)(list))),
            mode: "checking"
        }));
        setTimeout(function() {
            setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                dupes: (0, _utilities.unique)((0, _destinationsPlaylistUtils.checkDupes)((0, _toConsumableArray._)(list))),
                loading: false
            }));
        }, 1500);
        if (checkForDupesModal.current) checkForDupesModal.current.showModal();
    };
    var onCloseCheckForDupes = function() {
        setCheckForDupes(initCheckForDupes);
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            working: false
        }));
        if (checkForDupesModal.current) checkForDupesModal === null || checkForDupesModal === void 0 ? void 0 : checkForDupesModal.current.close();
    };
    var onCheckDupesChange = function(domEvent) {
        var value = domEvent.target.value;
        var checked = domEvent.target.checked;
        setAddByURL((0, _objectSpreadProps._)((0, _objectSpread._)({}, addByURL), {
            working: false,
            value: (0, _destinationsPlaylistUtils.excludeUrlFromValue)(addByURL.value, value, checked)
        }));
    };
    var onCheckDupesErrorClose = function(domEvent) {
        setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
            mode: "checking",
            message: ""
        }));
    };
    var onRemoveInstance = function(domEvent) {
        domEvent.preventDefault();
        var confirm = false;
        var video = false;
        var video_id = domEvent.target.elements["video"].value;
        if (video_id) video = list.find(function(item) {
            return item.ytID === video_id;
        });
        if (!video) return;
        confirm = window.confirm('Are you sure you want to delete this instance of "'.concat(video.name, '"?'));
        if (confirm) {
            var form = domEvent.target;
            setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                working: true,
                message: "I deleted that instance of <q>".concat(title, "</q>.")
            }));
            onRemoveInstanceSubmit(form);
        }
    };
    var onRemoveInstanceSubmit = function(form) {
        var fd = new FormData(form);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        var ac = new AbortController;
        var signal = ac.signal;
        setList([]);
        (0, _utilities.apirequest)((0, _configuration.API_VIDEO_REMOVEFROMSET), {
            body: fd,
            signal: signal
        }, function(data) {
            setCheckForDupes((0, _objectSpreadProps._)((0, _objectSpread._)({}, checkForDupes), {
                working: false,
                loading: false,
                mode: "checked",
                response: data
            }));
        });
    };
    var disableButtons;
    if (list) disableButtons = list[0] === false;
    else disableButtons = true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            makeBreadcrumb(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "should__be__acollapsible__panel",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _episodeViewTitleDefault.default), {
                        title: title,
                        id: list.vsb_id,
                        onEpisodeEdit: onEpisodeEdit,
                        onEpisodeMove: onEpisodeMove,
                        onEpisodeDelete: onEpisodeDelete,
                        isAdmin: canAdmin
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seasonsEpsDisplayDefault.default), {
                        season: meta.se.season || "\u2014",
                        episode: meta.se.episode || "\u2014",
                        onSave: onSeasonEpSave,
                        onChange: onSeasonEpChange,
                        isAdmin: canAdmin
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        id: "episode__view__ratingcrt",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeRatingsDefault.default), {
                                runtime: (0, _utilities.formatTime)(runtime),
                                rating: rating,
                                videos: list.length
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crtstatusDefault.default), {
                                approved: crtstatus.approved,
                                status: crtstatus.status,
                                loading: crtstatus.loading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runDateDefault.default), {
                        date: meta.vsb_datetimetorun || "",
                        onInputChange: onRunDateChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "episode__view__controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-sm btn--action",
                                        onClick: onAddVideoByURL,
                                        children: "Add Videos by URL"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-sm btn--action",
                                        onClick: onAddVideoFromAva,
                                        children: "Add Videos from AVA"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        disabled: disableButtons,
                                        type: "button",
                                        className: "btn btn-sm btn--action playAllBtn playListBtn",
                                        onClick: function() {
                                            (0, _destinationsUtils.playAllVideos)(list);
                                        },
                                        children: "Play All Videos"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        disabled: disableButtons,
                                        type: "button",
                                        className: "btn btn-sm btn--action exportDataBtn playListBtn",
                                        onClick: function() {
                                            (0, _destinationsUtils.exportVideoData)(list);
                                        },
                                        children: "Export IDs"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exportCSVDefault.default), {
                                        actionURL: (0, _configuration.API_VIDEOSETBLOCK_INFO_CSV),
                                        videosetID: +meta.vsb_id,
                                        disabled: disableButtons
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForUpdatesDefault.default), {
                                        onClick: onCheckForUpdates,
                                        disabled: disableButtons
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        disabled: disableButtons,
                                        type: "button",
                                        className: "btn btn--action btn-sm",
                                        onClick: onCheckForDuplicates,
                                        children: "Check for Duplicate Videos"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            makeVideos(),
            makeEpisodeEditModal(),
            makeAddVidsByURL(),
            makeVideoList(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoModalDefault.default), {
                modalRef: videoModalRef,
                isAdmin: canAdmin,
                id: "DestinationPlaylistVideoModal",
                mode: "videos_in_system",
                youtubeId: videopreview,
                onClose: onVideoInfoClose,
                onCRTSave: onCRTsubmit,
                onRatingSave: onRatingsSubmit,
                onMeowSave: onMeowSave
            }),
            makeCheckForUpdatesModal(),
            makeMoveEpisodeModal(),
            makeDeleteEpisodeModal(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkForDuplicatesModalDefault.default), (0, _objectSpread._)({
                modalRef: checkForDupesModal,
                onClose: onCloseCheckForDupes,
                inSet: list,
                playlist: episodeID,
                onRemove: onRemoveInstance,
                onSubmit: onAddVideoByUrlSubmit,
                onErrorClose: onCheckDupesErrorClose
            }, checkForDupes))
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EpisodeView, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","classnames":"8N3a2","lodash.uniqueid":"6bf5k","../Destinations/AddVideosByURL":"5T0Rm","../subcomponents/Breadcrumb":"e7Haa","../Destinations/CheckForDuplicatesModal":"4ZmTu","../Destinations/CheckForUpdates":"gvTXy","../Destinations/CheckForUpdatesProgress":"9F7am","../Destinations/CRTStatus":"2l3mr","../subcomponents/ModalDialog":"72kji","../DragSortList":"tQbiV","../Destinations/DestinationsToggleView":"ilkFj","./EpisodeViewTitle":"iTJEr","./EpisodeMoveModal":"jNy6r","../Destinations/ExportCSV":"gnFlW","../Destinations/RuntimeRatings":"cfBio","../Stations/RunDate":"2wBau","./SeasonsEpsDisplay":"4Mn0U","../subcomponents/VideoDragItem":"4r79B","../subcomponents/Videos/VideoModal":"aQAN2","../Destinations/VideoSetEdit":"6ByaZ","../VideosList":"h4I1m","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/StationsUtils":"Ja4lj","../../actions/DestinationsPlaylistUtils":"73dnb","../../actions/DestinationsUtils":"5X8UE","./css/EpisodeView.css":"em5jp","../Destinations/css/VideoDisplay.css":"jiXKe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"iTJEr":[function(require,module,exports) {
/**
 * EpisodeViewTitle.jsx
 * Title and change title component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../../js/Configuration");
var _episodeViewTitleCss = require("./css/EpisodeViewTitle.css");
var EpisodeViewTitle = function(param) {
    var onEpisodeDelete = param.onEpisodeDelete, onEpisodeEdit = param.onEpisodeEdit, onEpisodeMove = param.onEpisodeMove, _param_title = param.title, title = _param_title === void 0 ? (0, _configuration.NULL_EPISODE_TITLE) : _param_title, _param_isAdmin = param.isAdmin, isAdmin = _param_isAdmin === void 0 ? false : _param_isAdmin;
    var del = null;
    if (isAdmin) del = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: onEpisodeDelete,
        className: "btn btn-sm btn-light",
        children: "Delete Episode"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
        className: "episode__view__title",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                onClick: onEpisodeEdit,
                className: "btn btn-sm btn--action",
                children: "Edit Episode Name"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                onClick: onEpisodeMove,
                className: "btn btn-sm btn--action",
                children: "Move Episode"
            }),
            del
        ]
    });
};
exports.default = EpisodeViewTitle;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../js/Configuration":"k3dur","./css/EpisodeViewTitle.css":"bSs4O","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bSs4O":[function() {},{}],"jNy6r":[function(require,module,exports) {
/**
 * EpisodeMoveModal.js
 * Displays playlist URL and comments form fields.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _selectMenu = require("../subcomponents/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _utilities = require("../../js/Utilities");
var _episodeMoveModalCss = require("./css/EpisodeMoveModal.css");
var EpisodeMoveModal = function(param) {
    var cssClass = param.cssClass, onChange = param.onChange, onClose = param.onClose, onSubmit = param.onSubmit, series = param.series, modalRef = param.modalRef, _param_block = param.block, block = _param_block === void 0 ? null : _param_block;
    var makeOptions = function(item) {
        return {
            label: item.setName,
            value: item.setID
        };
    };
    var oOnClose = function() {
        if (onClose) onClose();
    };
    var oOnChange = function(domEvent) {
        if (!onChange) return;
        onChange(domEvent);
    };
    var oOnSubmit = function(domEvent) {
        domEvent.preventDefault();
        domEvent.persist();
        if (onSubmit) onSubmit(domEvent);
        oOnClose();
    };
    var cssClasses = (0, _classnamesDefault.default)({
        "stations__move__ep": true
    }, cssClass);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        id: "EpisodeMoveModal",
        onClose: oOnClose,
        ref: modalRef,
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Move this episode"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                id: "EpisodeMoveModal__menu",
                action: "/",
                method: "dialog",
                onSubmit: oOnSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                            labelText: "Select a new series",
                            id: "stations_move_ep_list",
                            name: "series",
                            onChangeHandler: oOnChange,
                            options: series,
                            size: "20",
                            firstEmpty: false
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn--action",
                            children: "Save"
                        })
                    })
                ]
            })
        ]
    });
};
EpisodeMoveModal.propTypes = {
    modalRef: (0, _propTypesDefault.default).any,
    block: (0, _propTypesDefault.default).any,
    cssClass: (0, _propTypesDefault.default).string,
    onChange: (0, _propTypesDefault.default).func.isRequired,
    onSubmit: (0, _propTypesDefault.default).func.isRequired
};
exports.default = EpisodeMoveModal;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","classnames":"8N3a2","../subcomponents/SelectMenu":"da8gs","../subcomponents/ModalDialog":"72kji","../../js/Utilities":"euxcI","./css/EpisodeMoveModal.css":"dDnnS","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dDnnS":[function() {},{}],"4Mn0U":[function(require,module,exports) {
/**
 * SeasonsEpsDisplay.jsx
 * Show the season and episode for a video set block.
 * See PropTypes definitions at the end of this file for parameters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _configuration = require("../../js/Configuration");
var _seasonsEpsDisplayCss = require("./css/SeasonsEpsDisplay.css");
var SeasonsEpsDisplay = function(props) {
    var onChange = props.onChange, isAdmin = props.isAdmin, onSave = props.onSave;
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState("display"), 2), mode = _React_useState[0], setMode = _React_useState[1];
    var oOnEdit = function() {
        setMode("edit");
    };
    var makeInput = function() {
        var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "season";
        var inp;
        if (mode !== "edit") inp = props[id];
        else inp = /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
            type: "number",
            id: id,
            name: id,
            defaultValue: props[id],
            onChange: onChange
        });
        return inp;
    };
    var makeLabel = function() {
        var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "season";
        var lbl;
        if (mode !== "edit") lbl = text;
        else lbl = /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
            htmlFor: text,
            children: text
        });
        return lbl;
    };
    var onSaver = function(domEvent) {
        domEvent.preventDefault();
        domEvent.persist();
        setMode("display");
        props.onSave();
    };
    var onCancel = function(domEvent) {
        setMode("display");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        action: (0, _configuration.API_SAVE_SEASONEPS),
        method: "post",
        className: "s__e__display",
        onSubmit: onSaver,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: makeLabel("season")
            }),
            " ",
            makeInput("season"),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: makeLabel("episode")
            }),
            " ",
            makeInput("episode"),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn__link btn",
                onClick: oOnEdit,
                hidden: !isAdmin || mode === "edit",
                children: "Change"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "btn btn--action",
                hidden: mode !== "edit",
                children: "Save"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn__link btn",
                onClick: onCancel,
                hidden: !isAdmin || mode !== "edit",
                children: "Cancel"
            })
        ]
    });
};
SeasonsEpsDisplay.propTypes = {
    season: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]).isRequired,
    episode: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]).isRequired,
    onSave: (0, _propTypesDefault.default).func,
    onChange: (0, _propTypesDefault.default).func
};
exports.default = SeasonsEpsDisplay;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","../../js/Configuration":"k3dur","./css/SeasonsEpsDisplay.css":"29Usn","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"29Usn":[function() {},{}],"em5jp":[function() {},{}],"jiXKe":[function() {},{}],"3vdfC":[function(require,module,exports) {
/**
 * SeriesView.js
 * /stations page-level component
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _breadcrumb = require("../subcomponents/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _episodesList = require("./EpisodesList");
var _episodesListDefault = parcelHelpers.interopDefault(_episodesList);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var SeriesView = function(param) {
    var params = param.params;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([
        {
            path: "/stations",
            label: "Stations"
        }
    ]), 2), breadcrumbs = _useState[0], setBreadcrumbs = _useState[1];
    var initEpState = {
        open: false,
        list: [],
        meta: {
            id: 0,
            title: null
        },
        mode: "view"
    };
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        title: null,
        id: null
    }), 2), seriesMeta = _useState1[0], setSeriesMeta = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), list = _useState2[0], setList = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState3[0], setLoading = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(initEpState), 2), episodes = _useState4[0], setEpisodes = _useState4[1];
    (0, _react.useEffect)(function() {
        if (!list.length) {
            getSeriesMeta();
            getSeries();
        }
    }, []);
    var getSeries = function() {
        var fd = new FormData();
        fd.set("id", params.seriesID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_ASSIGNMENTS), {
            body: fd
        }, function(data) {
            setList(data);
            setLoading(false);
        });
    };
    var getSeriesMeta = function() {
        var fd = new FormData();
        fd.set("id", params.seriesID);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_SERIES), {
            body: fd
        }, function(data) {
            var slice = [
                {
                    path: "/stations/".concat(data.station_id),
                    label: data.Station
                },
                {
                    path: "/stations/series/".concat(params.seriesID),
                    label: data.Video_Set || (0, _configuration.NULL_SET_TITLE)
                }
            ];
            setBreadcrumbs((0, _toConsumableArray._)(breadcrumbs).concat(slice));
            setSeriesMeta({
                title: data.Video_Set || (0, _configuration.NULL_SET_TITLE),
                id: data.vs_id
            });
        });
    };
    var onEpisodesClose = function(domEvent) {
        setEpisodes(initEpState);
    };
    var onBatchSave = function() {};
    var onBatchEdit = function() {};
    var onEpisodeDuplicate = function(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData();
        fd.set("id", domEvent.target.elements.id.value);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_VIDEOSET_DUPLICATE), {
            body: fd
        }, function(data) {
            if (Number.isNaN(+data)) throw new TypeError("Invalid response. Please notify an administrator.");
            else window.location = "/stations/episode/".concat(data);
        });
    };
    var makeEpisodesList = function() {
        var body;
        if (loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        else body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _episodesListDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
            meta: {
                id: params.seriesID
            },
            mode: "page"
        }, list), {
            onClose: onEpisodesClose,
            breadcrumbs: breadcrumbs.slice(0, 2),
            onDuplicateEpisode: onEpisodeDuplicate,
            onBatchEdit: onBatchEdit,
            onBatchSave: onBatchSave
        }));
        return body;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "stations__view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbDefault.default), {
                items: breadcrumbs,
                ariaLabel: "Stations navigation"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                children: [
                    "Episodes for ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                        children: seriesMeta.title
                    })
                ]
            }),
            makeEpisodesList()
        ]
    });
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SeriesView, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","../subcomponents/Breadcrumb":"e7Haa","./EpisodesList":"2dqN7","../subcomponents/LoaderSimple":"1dSHa","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hKn0E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _meter = require("./subcomponents/Meter");
var _actionMessageDisplay = require("./subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _iconApprovedRejected = require("./subcomponents/IconApprovedRejected");
var _passwordResetShowHide = require("./UpdateAccount/PasswordResetShowHide");
var _passwordResetShowHideDefault = parcelHelpers.interopDefault(_passwordResetShowHide);
var _utilities = require("../js/Utilities");
var _loginUtils = require("../actions/LoginUtils");
var _configuration = require("../js/Configuration");
var _resetPasswordCss = require("../css/ResetPassword.css");
var ResetPassword = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _loginUtils.resetPasswordState)), 2), state = _useState[0], setState = _useState[1];
    var params = props.params;
    var pwordReqID = params.pwordReqID;
    /* Loads hooks JSON file from a URL. */ (0, _react.useEffect)(function() {
        if (!state.reqtok) {
            var fd = new FormData();
            fd.set("guid", pwordReqID);
            (0, _utilities.apirequest)((0, _configuration.API_USER_CHECK_SET_PASS_ID), {
                body: fd
            }, function(response) {
                var newState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    expired: response.expired,
                    reqtok: response.request_token || null
                });
                setState(newState);
            });
        }
    }, []);
    var checkPass = function() {
        if (!state.password1.value) return;
        var fd = new FormData();
        fd.set("tok", state.reqtok);
        fd.set("password_token", pwordReqID);
        fd.set("password1", state.password1.value);
        (0, _utilities.apirequest)((0, _configuration.API_USER_TEST_PASS), {
            body: fd
        }, function(response) {
            // response is an object {length: xxx, strength: xxx}
            setState((0, _objectSpread._)({}, state, response));
        });
    };
    var disableSave = function() {
        return state.password1.value === "" || state.password2.value === "" || state.password1.value !== state.password2.value || state.strength < 3;
    };
    var postSaveMessage = function(message, mode) {
        var msg = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
            hidden: !message,
            message: message,
            mode: mode
        });
        return msg;
    };
    var savePass = function() {
        var fd = new FormData();
        fd.set("tok", state.reqtok);
        fd.set("password_token", pwordReqID);
        fd.set("password1", state.password1.value);
        fd.set("password2", state.password2.value);
        (0, _utilities.apirequest)((0, _configuration.API_USER_SET_PASS), {
            body: fd
        }, function(response) {
            var newstate = {
                message: "Could not save your password. Tell an administrator.",
                mode: "failed"
            };
            if (Object.hasOwn(response, "status") && response.status === "success") {
                newstate.message = 'Your new password has been saved. <a href="/">Log in now</a>';
                newstate.mode = response.status;
            }
            setState((0, _objectSpread._)({}, state, newstate));
        });
    };
    var onChange = function(domEvent) {
        var newstate = (0, _defineProperty._)({}, domEvent.target.name, (0, _objectSpreadProps._)((0, _objectSpread._)({}, state[domEvent.target.name]), {
            value: domEvent.target.value
        }));
        setState(Object.assign(state, newstate));
        checkPass();
    };
    var onSubmit = function(domEvent) {
        domEvent.preventDefault();
        // Send a request to the server containing the change request GUID and the password,
        // but only if the passwords match
        if (!(0, _utilities.isSameString)(state.password1.value, state.password2.value)) alert((0, _configuration.PASSWORDS_MISMATCH));
        else if (!(0, _utilities.meetsMinLength)(state.password2.value)) alert("".concat((0, _configuration.SET_PASS_RULES), " Please try again."));
        else // send the request to the server.
        savePass();
    };
    var onSuggestionRequest = function() {
        (0, _loginUtils.requestPasswordSuggestion)(state.reqtok, function(response) {
            var suggested = (0, _loginUtils.updateOnPasswordSuggestion)(state, response);
            setState((0, _objectSpread._)({}, state, suggested));
        });
        checkPass();
    };
    var onShowPassword = function(domEvent) {
        if (domEvent.target.nodeName !== "BUTTON") return;
        var fieldId = domEvent.target.dataset.controls;
        var newState = (0, _loginUtils.setStatePasswordResetShowHide)(state, fieldId);
        setState((0, _objectSpread._)({}, state, newState));
    };
    var body = null;
    var isStrong = state.strength < 3;
    var isApproved = isStrong ? false : true;
    var p1ref = (0, _react.useRef)(null);
    body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: "page__set__password",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Set a new password"
                    }),
                    postSaveMessage(state.message, state.mode)
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                method: "post",
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                name: "password_token",
                                value: pwordReqID
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "password1",
                                children: "Enter new password"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn--request",
                                onClick: onSuggestionRequest,
                                children: "Get a password suggestion"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "set__pass__approvable",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordResetShowHideDefault.default), {
                                        ref: p1ref,
                                        type: state.password1.type,
                                        name: "password1",
                                        id: "password1",
                                        minLength: "12",
                                        onChange: onChange,
                                        onClick: onShowPassword,
                                        "aria-describedby": "password1-note",
                                        autoComplete: "new-password",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        className: "set__pass__approved",
                                        role: "img",
                                        "aria-label": isStrong ? "Unacceptable" : "Approved",
                                        hidden: !state.password1.value.length > 0,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconApprovedRejected.IconApprovedRejected), {
                                            approved: isApproved
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "password1-note",
                                className: "set__pass__note",
                                dangerouslySetInnerHTML: (0, _configuration.SET_PASS_RULES)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "set__pass__passwordindic",
                        children: [
                            "Strength:",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _meter.Meter), {
                                className: "password__strength",
                                max: "4",
                                low: "3",
                                optimum: "3.999",
                                value: state.strength
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "password2",
                                children: "Confirm new password"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "set__pass__approvable",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordResetShowHideDefault.default), {
                                        type: state.password2.type,
                                        name: "password2",
                                        id: "password2",
                                        minLength: "12",
                                        onChange: onChange,
                                        onClick: onShowPassword,
                                        "aria-describedby": "password2-note",
                                        autoComplete: "new-password",
                                        required: true,
                                        disabled: isStrong
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        className: "set__pass__approved",
                                        role: "img",
                                        "aria-label": isStrong ? "Unacceptable" : "Approved",
                                        hidden: disableSave(),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconApprovedRejected.IconApprovedRejected), {
                                            approved: isApproved
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "password2-note",
                                className: "set__pass__note",
                                children: (0, _configuration.SET_PASS_RULES2)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn btn--action",
                            disabled: disableSave(),
                            children: "Submit"
                        })
                    })
                ]
            })
        ]
    });
    if (state.expired === true) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
        className: "page__set__password",
        children: (0, _configuration.PASSWORD_REQUEST_EXPIRED)
    });
    if (Object.hasOwn(p1ref, "current") && p1ref.current !== null) p1ref.current.focus();
    return body;
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResetPassword, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./subcomponents/Meter":"iWD1e","./subcomponents/ActionMessageDisplay":"bzcdY","./subcomponents/IconApprovedRejected":"x7bFl","./UpdateAccount/PasswordResetShowHide":"iAzs9","../js/Utilities":"euxcI","../actions/LoginUtils":"6nFUs","../js/Configuration":"k3dur","../css/ResetPassword.css":"25FqB","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"25FqB":[function() {},{}],"7lOZm":[function(require,module,exports) {
/**
 * RequestPasswordNoToken.js
 * Displayed when there is no password token in the URL.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResetPasswordNoToken", function() {
    return ResetPasswordNoToken;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../js/Configuration");
var ResetPasswordNoToken = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
        className: "page__set__password",
        children: (0, _configuration.PASSWORD_REQUEST_NO_TOKEN)
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"c3YKH":[function(require,module,exports) {
/**
 * ResetPasswordEmailSent.js
 * Displayed when there is no password token in the URL.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResetPasswordEmailSent", function() {
    return ResetPasswordEmailSent;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../js/Configuration");
var ResetPasswordEmailSent = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "page__set__password",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Thanks!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: (0, _configuration.PASSWORD_REQUEST_SENT)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "/",
                    children: "Log in"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1Nmb0":[function(require,module,exports) {
/**
 * Tools.jsx
 * Tools for calculating statistics about lists of video IDs
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _importSpreadsheet = require("./Import/ImportSpreadsheet");
var _importSpreadsheetDefault = parcelHelpers.interopDefault(_importSpreadsheet);
var _utilities = require("../js/Utilities");
var _toolsCss = require("../css/Tools.css");
var _fancyRadiobuttonsCss = require("./subcomponents/css/fancy-radiobuttons.css");
var Tools = function(props) {
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        total: 0,
        median: 0,
        mean: 0,
        mode: [],
        min: 0,
        max: 0
    }), 2), calcs = _React_useState[0], setCalcs = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        url: "",
        sheet: "Sheet1",
        operation: "" // can be an empty string, 'averages', or 'durations'
    }), 2), sheetObj = _React_useState1[0], setSheetObj = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), loading = _React_useState2[0], setLoading = _React_useState2[1];
    var onSubmit = function(domEvent) {
        domEvent.preventDefault();
        var operation = sheetObj.operation, url = sheetObj.url, sheet = sheetObj.sheet;
        var view = operation === "durations" ? "durationmode" : "averages";
        window.location = "/tools/".concat(view, "/").concat((0, _utilities.getSheetId)(url), "/").concat(sheet);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tools__start",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Video List Calculator"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importSpreadsheetDefault.default), (0, _objectSpread._)({
                loading: loading,
                onSubmit: onSubmit
            }, sheetObj))
        ]
    });
};
exports.default = Tools;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","./Import/ImportSpreadsheet":"63oII","../js/Utilities":"euxcI","../css/Tools.css":"hGBch","./subcomponents/css/fancy-radiobuttons.css":"1fWvp","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"63oII":[function(require,module,exports) {
/**
 * ImportSpreadsheet
 * Enables users to import data into AVA from GoogleSheet.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _importSpreadsheetFields = require("./ImportSpreadsheetFields");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _importSpreadsheetCss = require("./css/ImportSpreadsheet.css");
var ImportSpreadsheet = function(param) {
    var url = param.url, sheet = param.sheet, operation = param.operation, className = param.className;
    var fetchController = new AbortController();
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(true), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)((0, _reactDefault.default).useState(""), 2), email = _React_useState1[0], setEmail = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        url: url,
        sheet: sheet,
        operation: ""
    }), 2), formInput = _React_useState2[0], setFormInput = _React_useState2[1];
    (0, _reactDefault.default).useEffect(function() {
        if (!email) getEmail();
        return function() {
            return fetchController.abort();
        };
    }, [
        fetchController
    ]);
    var getEmail = function() {
        var fd = new FormData();
        fd.append("token", (0, _utilities.getAuthData)("token"));
        var signal = fetchController.signal;
        (0, _utilities.apirequest)((0, _configuration.API_IMPORT_EMAIL), {
            body: fd,
            signal: signal
        }, function(response) {
            setEmail(response.email);
            setLoading(false);
        });
    };
    var onChange = function(domEvent) {
        var _domEvent_target = domEvent.target, name = _domEvent_target.name, value = _domEvent_target.value;
        setFormInput((0, _objectSpreadProps._)((0, _objectSpread._)({}, formInput), (0, _defineProperty._)({}, name, value)));
    };
    var onSubmit = function(domEvent) {
        domEvent.preventDefault();
        var operation = sheetObj.operation, url = sheetObj.url, sheet = sheetObj.sheet;
        var view = operation === "durations" ? "durationmode" : "averages";
        window.location = "/tools/".concat(view, "/").concat((0, _utilities.getSheetId)(url), "/").concat(sheet);
    };
    /* Render the component */ var body;
    var cssClasses = (0, _classnamesDefault.default)({
        "spreadsheet__import": true,
        "spreadsheet__import__disabled": !email
    }, className);
    if (loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    else body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        method: "post",
        id: "tools_import_sheet",
        onSubmit: onSubmit,
        className: cssClasses,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importSpreadsheetFields.ImportSpreadsheetFields), (0, _objectSpreadProps._)((0, _objectSpread._)({
                email: email
            }, formInput), {
                onChange: onChange
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("fieldset", {
                hidden: false,
                disabled: !email,
                onChange: onChange,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                            children: "What do you want to do?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "fancy__radio",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "radio",
                                    name: "operation",
                                    id: "averages",
                                    value: "averages",
                                    selected: formInput.operation === "averages"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "averages",
                                    children: "Calculate average and total duration"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "fancy__radio",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "radio",
                                    name: "operation",
                                    id: "durations",
                                    value: "durations",
                                    selected: formInput.operation === "durations"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "durations",
                                    children: "Count videos by duration"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !email || !formInput.operation || !formInput.url,
                type: "submit",
                className: "btn btn--action",
                children: "Import"
            })
        ]
    });
    return body;
};
exports.default = ImportSpreadsheet;

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","../subcomponents/LoaderSimple":"1dSHa","./ImportSpreadsheetFields":"fi3zf","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","./css/ImportSpreadsheet.css":"bqXXN","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"bqXXN":[function() {},{}],"hGBch":[function() {},{}],"1fWvp":[function() {},{}],"iU9wX":[function(require,module,exports) {
/**
 * ToolsDurationMode
 * Enables users to update their own account page.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _toolsAddToGoogleSheet = require("./ToolsAddToGoogleSheet");
var _toolsImportAnother = require("./ToolsImportAnother");
var _toolsSpreadsheetUpdated = require("./ToolsSpreadsheetUpdated");
var _toolsSpreadsheetFailed = require("./ToolsSpreadsheetFailed");
var _toolsSheetLoading = require("./ToolsSheetLoading");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _toolsUtils = require("../../actions/ToolsUtils");
// import '../css/ToolsDurationMode.css';
var _fancyRadiobuttonsCss = require("../subcomponents/css/fancy-radiobuttons.css");
var ToolsDurationMode = function(props) {
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        count: 0
    }), 2), results = _React_useState1[0], setResults = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)((0, _reactDefault.default).useState("importing"), 2), mode = _React_useState2[0], setMode = _React_useState2[1]; // 'importing', 'imported', or 'pushed'
    var _React_useState3 = (0, _slicedToArray._)((0, _reactDefault.default).useState({
        loading: false
    }), 2), exporting = _React_useState3[0], setExporting = _React_useState3[1];
    var fetchCancel = new AbortController();
    var params = props.params;
    (0, _react.useEffect)(function() {
        if (Object.keys(results).length == 1) requestModeRanges();
        return function() {
            return fetchCancel.abort();
        };
    }, []);
    var requestModeRanges = function() {
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("url", "https://docs.google.com/spreadsheets/d/".concat(params.spreadsheetID, "/"));
        fd.set("sheet", params.sheetName);
        (0, _utilities.apirequest)((0, _configuration.API_IMPORT_SPREADSHEET_FINDRANGES), {
            body: fd,
            signal: signal
        }, function(response) {
            if (response.status != 200) {
                setMode("failed");
                return;
            }
            setResults((0, _objectSpread._)({}, results, response.results));
            setMode("imported");
            setLoading(true);
        });
    };
    var prepareData = function() {
        var bands = Object.keys(results).filter(function(b) {
            return b !== "count";
        }).map(function(b) {
            return [
                "".concat(b, " minutes"),
                results[b],
                "".concat((0, _utilities.precision)((0, _utilities.percentage)(+results.count, +results[b]), 2), "%")
            ];
        });
        var data = [
            [
                "Statistics for ".concat(params.spreadsheetID, " (").concat(params.sheetName, ")")
            ],
            [
                ""
            ],
            [
                "Number of videos",
                results.count
            ],
            [
                ""
            ],
            [
                "Range",
                "Number of videos",
                "Percentage"
            ]
        ];
        return data.concat(bands);
    };
    var ddownload = function() {
        var dta = prepareData();
        (0, _toolsUtils.download)(dta, params.spreadsheetID, params.sheetName);
    };
    var makeResponseDisplay = function() {
        var bands = Object.keys(results).filter(function(key) {
            return key !== "count";
        });
        var results = bands.map(function(b, ind) {
            var pctg = (0, _utilities.percentage)(+results.count, +results[b]);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                        children: [
                            b,
                            " minutes:"
                        ]
                    }),
                    " ",
                    results[b],
                    " videos or ",
                    (0, _utilities.precision)(pctg, 2),
                    "%"
                ]
            }, ind);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "tools__imported",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                    children: [
                        "Video count by duration for ",
                        params.sheetName
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: "Videos in sheet:"
                                }),
                                " ",
                                (0, _utilities.numberFormat)(results.count)
                            ]
                        }),
                        results
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "tools__imported__controls",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: ddownload,
                            className: "btn btn--action",
                            children: "Download Statistics"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsAddToGoogleSheet.ToolsAddToGoogleSheet), {
                            onClick: setData,
                            loading: exporting.loading
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsImportAnother.ToolsImportAnother), {})
                    ]
                })
            ]
        });
    };
    var setData = function() {
        var data = prepareData();
        var cb = function(response) {
            if (response.spreadsheetId) {
                setExporting({
                    loading: false
                });
                setMode("pushed");
            } else alert((0, _configuration.MESSAGE_ERROR_GENERAL));
        };
        (0, _toolsUtils.setSpreadsheetData)(data, cb, params.spreadsheetID, params.sheetName, null, "durations");
    };
    var body;
    switch(mode){
        case "importing":
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsSheetLoading.ToolsSheetLoading), {});
            break;
        case "failed":
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsSpreadsheetFailed.ToolsSpreadsheetFailed), {});
            break;
        case "imported":
            body = makeResponseDisplay();
            break;
        case "pushed":
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsSpreadsheetUpdated.ToolsSpreadsheetUpdated), {
                spreadsheetID: params.spreadsheetID
            });
            break;
    }
    return body;
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolsDurationMode, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./ToolsAddToGoogleSheet":"2QRS2","./ToolsImportAnother":"4Iodd","./ToolsSpreadsheetUpdated":"aDmUT","./ToolsSpreadsheetFailed":"a07jo","./ToolsSheetLoading":"08lFu","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/ToolsUtils":"2sPId","../subcomponents/css/fancy-radiobuttons.css":"1fWvp","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2QRS2":[function(require,module,exports) {
/**
 * ToolsAddToGoogleSheet
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolsAddToGoogleSheet", function() {
    return ToolsAddToGoogleSheet;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var ToolsAddToGoogleSheet = function(props) {
    var text = props.loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    }) : "Add Statistics to Google Sheet";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        className: "btn btn--action ToolsAddToGoogleSheet",
        children: text
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/LoaderSimple":"1dSHa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"4Iodd":[function(require,module,exports) {
/**
 * ToolsImportAnother.jsx
 * 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolsImportAnother", function() {
    return ToolsImportAnother;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var ToolsImportAnother = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        className: "btn btn--action",
        to: "/tools",
        children: "Import another sheet?"
    }, "tools");
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"aDmUT":[function(require,module,exports) {
/**
 * ToolsSpreadsheetUpdated.js
 * 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolsSpreadsheetUpdated", function() {
    return ToolsSpreadsheetUpdated;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toolsImportAnother = require("./ToolsImportAnother");
var ToolsSpreadsheetUpdated = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tools__pushed",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Video List Calculator"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "alert alert-success",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: "Success!"
                    }),
                    " Your spreadsheet was updated."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "tools__pushed__link",
                        href: "https://docs.google.com/spreadsheets/d/".concat(props.spreadsheetID, "/"),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Visit your spreadsheet"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: "or"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsImportAnother.ToolsImportAnother), {})
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","./ToolsImportAnother":"4Iodd","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"a07jo":[function(require,module,exports) {
/**
 * ToolsSpreadsheetFailed.js
 * 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolsSpreadsheetFailed", function() {
    return ToolsSpreadsheetFailed;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ToolsSpreadsheetFailed = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tools__failed",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "I coud not retrieve those videos"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    children: "Things to try:"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: "Check that you've entered the correct page name."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: "Check that you've entered the correct URL."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: "Check that the page you've submitted isn't empty."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "/tools",
                    children: "Try again"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"08lFu":[function(require,module,exports) {
/**
 * ToolsSheetLoading.jsx
 * 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolsSheetLoading", function() {
    return ToolsSheetLoading;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var ToolsSheetLoading = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tools__importing",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Now crunching those numbers"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "This could take a few minutes."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
                open: true
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/LoaderSimple":"1dSHa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1fWvp":[function() {},{}],"7IeK0":[function(require,module,exports) {
/**
 * ToolsAverages.js
 * Calculate and display averages for a list of videos.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _toggleSwitch = require("../subcomponents/ToggleSwitch");
var _toggleSwitchDefault = parcelHelpers.interopDefault(_toggleSwitch);
var _toolsAddToGoogleSheet = require("./ToolsAddToGoogleSheet");
var _toolsImportAnother = require("./ToolsImportAnother");
var _toolsSpreadsheetUpdated = require("./ToolsSpreadsheetUpdated");
var _toolsSpreadsheetFailed = require("./ToolsSpreadsheetFailed");
var _toolsSheetLoading = require("./ToolsSheetLoading");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _toolsUtils = require("../../actions/ToolsUtils");
var _fancyRadiobuttonsCss = require("../subcomponents/css/fancy-radiobuttons.css");
var ToolsAverages = function(props) {
    var params = props.params;
    var fetchCancel = new AbortController();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        total: 0,
        median: 0,
        mean: 0,
        mode: [],
        min: 0,
        max: 0
    }), 2), calcs = _useState1[0], setCalcs = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)("importing"), 2), mode = _useState2[0], setMode = _useState2[1]; // 'importing', 'imported', or 'pushed'
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)({
        options: [
            "Hours",
            "Days"
        ],
        useDays: true // Convert to Boolean.
    }), 2), timedisplay = _useState3[0], setTimeDisplay = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)({
        loading: false
    }), 2), exporting = _useState4[0], setExporting = _useState4[1];
    (0, _react.useEffect)(function() {
        if (!calcs.mode.length) requestModeRanges();
        return function() {
            return fetchCancel.abort();
        };
    }, [
        calcs
    ]);
    var ddownload = function() {
        var dta = prepareData();
        (0, _toolsUtils.download)(dta, params.spreadsheetID, params.sheetName);
    };
    var onToggleTimeDisplay = function(domEvent) {
        var td = (0, _objectSpread._)({}, timedisplay);
        var value = domEvent.target.value;
        setTimeDisplay((0, _objectSpreadProps._)((0, _objectSpread._)({}, timedisplay), {
            useDays: !+value // + converts to integer / boolean. ! inverts it.
        }));
    };
    var prepareData = function() {
        var count = calcs.count, mean = calcs.mean, min = calcs.min, max = calcs.max, total1 = calcs.total;
        var data = [
            [
                "Statistics for ".concat(params.spreadsheetID, " (").concat(params.sheetName, ")")
            ],
            [
                "Number of Videos",
                +count
            ],
            [
                "Total Duration",
                "".concat((0, _utilities.formatTime)(total1, false), " (").concat((0, _utilities.formatTime)(total1, true), ")")
            ],
            [
                "Average Length",
                (0, _utilities.formatTime)(mean)
            ],
            [
                "Shortest",
                (0, _utilities.formatTime)(min)
            ],
            [
                "Longest",
                (0, _utilities.formatTime)(max)
            ]
        ];
        return data;
    };
    var setData = function() {
        var data = prepareData();
        var cb = function(response) {
            if (response.spreadsheetId) {
                setExporting((0, _objectSpreadProps._)((0, _objectSpread._)({}, exporting), {
                    loading: false
                }));
                setMode("pushed");
            } else alert((0, _configuration.MESSAGE_ERROR_GENERAL));
        };
        (0, _toolsUtils.setSpreadsheetData)(data, cb, params.spreadsheetID, params.sheetName, null, "durations");
    };
    var makeAverages = function() {
        var count = calcs.count, mean = calcs.mean, min = calcs.min, max = calcs.max;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "tools__imported",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                    children: [
                        "Statistics for ",
                        params.sheetName
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: "Videos in sheet:"
                                }),
                                " ",
                                (0, _utilities.numberFormat)(calcs.count)
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: "Total:"
                                }),
                                " ",
                                (0, _utilities.formatTime)(total, !timedisplay.useDays),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                                    onChange: onToggleTimeDisplay,
                                    label: "Show in:",
                                    className: "tools--toggle",
                                    options: timedisplay.options,
                                    name: "PlaylistCalcTimeDisplay",
                                    selectedIndex: +!timedisplay.useDays
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: "Average Length:"
                                }),
                                " ",
                                (0, _utilities.formatTime)(mean)
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: "Shortest:"
                                }),
                                " ",
                                (0, _utilities.formatTime)(min)
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: "Longest:"
                                }),
                                " ",
                                (0, _utilities.formatTime)(max)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "tools__imported__controls",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: ddownload,
                            className: "btn btn--action",
                            children: "Download Statistics"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsAddToGoogleSheet.ToolsAddToGoogleSheet), {
                            onClick: setData,
                            loading: exporting.loading
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsImportAnother.ToolsImportAnother), {})
                    ]
                })
            ]
        });
    };
    var requestModeRanges = function() {
        var signal = fetchCancel.signal;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("url", "https://docs.google.com/spreadsheets/d/".concat(params.spreadsheetID, "/"));
        fd.set("sheet", params.sheetName);
        (0, _utilities.apirequest)((0, _configuration.API_IMPORT_SPREADSHEET), {
            body: fd,
            signal: signal
        }, function(response) {
            if (+response.status != 200) {
                setMode("failed");
                return;
            }
            setCalcs(response.results);
            setMode("imported");
            setLoading(false);
        });
    };
    var body;
    switch(mode){
        case "importing":
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsSheetLoading.ToolsSheetLoading), {});
            break;
        case "failed":
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsSpreadsheetFailed.ToolsSpreadsheetFailed), {});
            break;
        case "imported":
            body = makeAverages();
            break;
        case "pushed":
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolsSpreadsheetUpdated.ToolsSpreadsheetUpdated), {
                spreadsheetID: params.spreadsheetID
            });
            break;
    }
    return body;
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolsAverages, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","../subcomponents/ToggleSwitch":"k29YD","./ToolsAddToGoogleSheet":"2QRS2","./ToolsImportAnother":"4Iodd","./ToolsSpreadsheetUpdated":"aDmUT","./ToolsSpreadsheetFailed":"a07jo","./ToolsSheetLoading":"08lFu","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/ToolsUtils":"2sPId","../subcomponents/css/fancy-radiobuttons.css":"1fWvp","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1fWvp":[function() {},{}],"4XDRr":[function(require,module,exports) {
/**
 * AmzGenres
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _loaderSimple = require("./subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _amzGenreAddNew = require("./Music/AmzGenreAddNew");
var _amzGenreRemove = require("./Music/AmzGenreRemove");
var _amzGenreRemoveDefault = parcelHelpers.interopDefault(_amzGenreRemove);
var _configuration = require("../js/Configuration");
var _utilities = require("../js/Utilities");
var _amzUtils = require("../actions/AmzUtils");
var _amzGenresCss = require("./Music/css/AmzGenres.css");
var Genres = function() {
    var getGenres = function getGenres() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("perPage", state.perPage);
        fd.set("page", state.page);
        fd.set("ascending", state.ascending);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_GENRES), {
            body: fd
        }, function(response) {
            var update = [
                false
            ];
            if (response.results.length) update = response.results;
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                genres: update,
                loading: false
            }));
        });
    };
    var onAddNewOpen = function onAddNewOpen() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (ref && Object.hasOwn(ref, "current")) ref.current.showModal();
    };
    var onAddNewChange = function onAddNewChange(domEvent) {
        var field = domEvent.target.name;
        var value = domEvent.target.value;
        setState(function() {
            return (0, _amzUtils.setStateAddGenreChange)(state, field, value);
        });
    };
    var onAddNewSubmit = function onAddNewSubmit(domEvent) {
        domEvent.preventDefault();
        var fd = new FormData(domEvent.target);
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_GENREADD), {
            body: fd
        }, function(response) {
            var cb = function() {
                return (0, _amzUtils.setStateAddGenrePostSubmit)(state, response);
            };
            setState(cb);
            if (!Object.hasOwn(response, "error")) onAddNewClose(refAddNewGenre);
        });
    };
    var afterGenreRemove = function afterGenreRemove(response) {
        if (!response.success) // eslint-disable-next-line no-alert
        setState({
            loading: false
        }, function() {
            alert((0, _configuration.MESSAGE_ERROR_GENERAL));
        });
        else setState(function() {
            return (0, _amzUtils.setStateAfterGenreRemoval)(state, response);
        });
    };
    var onGenreRemove = function onGenreRemove(domEvent) {
        domEvent.preventDefault();
        var form = domEvent.target;
        setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            loading: true
        }));
        (0, _amzUtils.genreRemove)(form, afterGenreRemove);
    };
    var makeLinks = function makeLinks() {
        if (Object.hasOwn(state, "genres") && !state.genres.length) return null;
        var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        if (state.loading === false) {
            var links = state.genres.map(function(l) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: {
                                pathname: "/music/clusters/".concat(l.id)
                            },
                            children: l.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzGenreRemoveDefault.default), {
                            id: l.id,
                            onSubmit: onGenreRemove
                        })
                    ]
                }, "genre_".concat((0, _lodashUniqueidDefault.default)()));
            });
            body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "genres__list",
                children: links
            });
        }
        return body;
    };
    var initState = {
        loading: true,
        genres: [],
        perPage: 1000,
        page: 1,
        ascending: 1,
        addNew: {
            name: "",
            notes: ""
        }
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initState), 2), state = _useState[0], setState = _useState[1];
    (0, _react.useEffect)(function() {
        if (!state.genres.length) getGenres();
    }, [
        state
    ]);
    var refAddNewGenre = (0, _react.useRef)(null);
    var onAddNewClose = function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (ref && Object.hasOwn(ref, "current")) ref.current.close();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        id: "AmzGenres",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Genres"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Click a genre name to view clusters."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzGenreAddNew.AmzGenreAddNew), (0, _objectSpreadProps._)((0, _objectSpread._)({
                modalRef: refAddNewGenre,
                id: "AmzGenreAddNew"
            }, state.addNew), {
                onClose: onAddNewClose,
                onChange: onAddNewChange,
                onOpen: onAddNewOpen,
                onSubmit: onAddNewSubmit
            })),
            makeLinks()
        ]
    });
};
exports.default = Genres;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","lodash.uniqueid":"6bf5k","./subcomponents/LoaderSimple":"1dSHa","./Music/AmzGenreAddNew":"c7CTv","./Music/AmzGenreRemove":"lQPIS","../js/Configuration":"k3dur","../js/Utilities":"euxcI","../actions/AmzUtils":"dPdUh","./Music/css/AmzGenres.css":"hU5Ok","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"c7CTv":[function(require,module,exports) {
/**
 * AmzGenreAddNew.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmzGenreAddNew", function() {
    return AmzGenreAddNew;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionMessageDisplay = require("../subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _utilities = require("../../js/Utilities");
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _amzGenreAddNewCss = require("./css/AmzGenreAddNew.css");
var AmzGenreAddNew = function(param) {
    var id = param.id, modalRef = param.modalRef, error = param.error, message = param.message, name = param.name, notes = param.notes, onChange = param.onChange, onClose = param.onClose, onOpen = param.onOpen, onSubmit = param.onSubmit, onErrorClose = param.onErrorClose;
    var openModal = function() {
        if (modalRef.current) modalRef.current.showModal();
    };
    var closeModal = function() {
        if (modalRef.current) modalRef.current.close();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    "textAlign": "right"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    onClick: openModal,
                    className: "btn btn--action",
                    children: "Add New Genre"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
                ref: modalRef,
                id: "AmzGenreAddNewModal",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Add New Genre"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
                        mode: "failed",
                        hidden: !error,
                        message: message,
                        onClose: onErrorClose
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        id: "AmzGenreAddNewForm",
                        style: {
                            "margin": "3rem 0"
                        },
                        onSubmit: onSubmit,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                id: "parent",
                                name: "parent",
                                onChange: onChange,
                                value: "0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "name",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        autoComplete: "off",
                                        type: "text",
                                        id: "name",
                                        name: "name",
                                        className: "form-control",
                                        required: true,
                                        value: name || "",
                                        onChange: onChange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "notes",
                                        children: "Notes\xa0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "form-note",
                                        children: "(optional)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                        id: "notes",
                                        name: "notes",
                                        rows: "6",
                                        className: "form-control",
                                        value: notes || "",
                                        onChange: onChange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "button__group",
                                style: {
                                    "textAlign": "right"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn--action",
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn",
                                        onClick: closeModal,
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/ActionMessageDisplay":"bzcdY","lodash.uniqueid":"6bf5k","../../js/Utilities":"euxcI","../subcomponents/ModalDialog":"72kji","./css/AmzGenreAddNew.css":"fZHce","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fZHce":[function() {},{}],"lQPIS":[function(require,module,exports) {
/**
 * AmzGenreRemove.jsx
 * A form for removing songs from a cluster.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var AmzGenreRemove = function(props) {
    var onSubmit = props.onSubmit, id = props.id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "AmzGenreRemove",
        id: (0, _lodashUniqueidDefault.default)("AmzGenreRemove_"),
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "id",
                value: id,
                onChange: function() {}
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "btn btn--action",
                children: "Remove"
            })
        ]
    });
};
exports.default = AmzGenreRemove;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","lodash.uniqueid":"6bf5k","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"dPdUh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "amzUrl", function() {
    return amzUrl;
});
parcelHelpers.export(exports, "setStateOnClusterTitle", function() {
    return setStateOnClusterTitle;
});
parcelHelpers.export(exports, "makeSaveRequest", function() {
    return makeSaveRequest;
});
parcelHelpers.export(exports, "setStateOnAddNew", function() {
    return setStateOnAddNew;
});
parcelHelpers.export(exports, "setStateOnAddNewChange", function() {
    return setStateOnAddNewChange;
});
parcelHelpers.export(exports, "setStateOnAddNewSubmit", function() {
    return setStateOnAddNewSubmit;
});
parcelHelpers.export(exports, "setStateOnAddNewSubmitResponse", function() {
    return setStateOnAddNewSubmitResponse;
});
parcelHelpers.export(exports, "setStateOnReportResponse", function() {
    return setStateOnReportResponse;
});
parcelHelpers.export(exports, "setStateAddGenreOpen", function() {
    return setStateAddGenreOpen;
});
parcelHelpers.export(exports, "setStateAddGenreClose", function() {
    return setStateAddGenreClose;
});
parcelHelpers.export(exports, "setStateAddGenreChange", function() {
    return setStateAddGenreChange;
});
parcelHelpers.export(exports, "setStateAddGenrePostSubmit", function() {
    return setStateAddGenrePostSubmit;
});
parcelHelpers.export(exports, "genreRemove", function() {
    return genreRemove;
});
parcelHelpers.export(exports, "setStateAfterGenreRemoval", function() {
    return setStateAfterGenreRemoval;
});
parcelHelpers.export(exports, "filterGenres", function() {
    return filterGenres;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utilities = require("../js/Utilities");
var _destinationsUtils = require("./DestinationsUtils");
var _configuration = require("../js/Configuration");
var amzUrl = function(asin) {
    return "https://amazon.com/dp/".concat(asin);
};
var setStateOnClusterTitle = function(state, response) {
    var rmeta;
    if (Object.hasOwn(response, "id")) rmeta = {
        meta: response
    };
    else rmeta = {
        meta: {
            error: true
        }
    };
    return (0, _objectSpread._)({}, state, rmeta);
};
var makeSaveRequest = function(cluster, data, callback) {
    var fd = new FormData();
    fd.set("token", (0, _utilities.getAuthData)("token"));
    fd.set("uuid", (0, _utilities.getAuthData)("uuid"));
    fd.set("cluster", cluster);
    fd.set("data", JSON.stringify(data));
    (0, _utilities.apirequest)("api/importasin", {
        body: fd
    }, callback);
};
var setStateOnAddNew = function(state, response) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addcluster: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addcluster), {
            open: true,
            menu: response
        })
    });
};
var setStateOnAddNewChange = function(state, field, value) {
    var setError = field === "size" ? value === "0" : state.addcluster.error;
    var _obj;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addcluster: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addcluster), (_obj = {}, (0, _defineProperty._)(_obj, field, value), (0, _defineProperty._)(_obj, "error", setError), _obj))
    });
};
var setStateOnAddNewSubmit = function(state, field, value) {
    return {
        addcluster: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addcluster), (0, _defineProperty._)({}, field, value))
    };
};
var setStateOnAddNewSubmitResponse = function(state, response) {
    var hasError = Object.hasOwn(response, "error");
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addcluster: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addcluster), {
            open: hasError,
            error: hasError ? response.error : "",
            message: hasError ? response.message : ""
        }),
        genres: Array.from(response).concat((0, _toConsumableArray._)(state.genres))
    });
};
var setStateOnReportResponse = function(state, response) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        loading: false,
        results: response.results
    });
};
var setStateAddGenreOpen = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addNew: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addNew), {
            open: true
        })
    });
};
var setStateAddGenreClose = function(state) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addNew: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addNew), {
            open: false
        })
    });
};
var setStateAddGenreChange = function(state, field, value) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        addNew: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addNew), (0, _defineProperty._)({}, field, value))
    });
};
var setStateAddGenrePostSubmit = function(state, response) {
    var updated = (0, _toConsumableArray._)(state.genres);
    updated.unshift(response);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        genres: updated,
        addNew: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addNew), {
            open: false
        })
    });
};
var genreRemove = function(form) {
    var responseCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fd = new FormData(form);
    fd.set("token", (0, _utilities.getAuthData)("token"));
    (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_GENREREMOVE), {
        body: fd
    }, responseCallback);
};
var setStateAfterGenreRemoval = function(state, response) {
    var currentgenres = (0, _toConsumableArray._)(state.genres);
    var newgenres = currentgenres.filter(function(g) {
        return +response.genre !== +g.id;
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        genres: newgenres,
        loading: false
    });
};
var filterGenres = function(query, genres) {
    if (!query) return genres;
    var regexp = new RegExp(query, "i");
    return genres.filter(function(g) {
        return regexp.test(g.name);
    });
};

},{"@swc/helpers/_/_define_property":"cmFWv","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_to_consumable_array":"fRXIP","../js/Utilities":"euxcI","./DestinationsUtils":"5X8UE","../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hU5Ok":[function() {},{}],"fIV3Z":[function(require,module,exports) {
/**
 * AmzClusters.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _paginationBar = require("../subcomponents/PaginationBar");
var _paginationBarDefault = parcelHelpers.interopDefault(_paginationBar);
var _amzClustersSearch = require("./AmzClustersSearch");
var _amzClustersSearchDefault = parcelHelpers.interopDefault(_amzClustersSearch);
var _amzClustersAddNew = require("./AmzClustersAddNew");
var _amzGenreRemove = require("./AmzGenreRemove");
var _amzGenreRemoveDefault = parcelHelpers.interopDefault(_amzGenreRemove);
var _toggleSwitch = require("../subcomponents/ToggleSwitch");
var _toggleSwitchDefault = parcelHelpers.interopDefault(_toggleSwitch);
var _amzGenreImport = require("./AmzGenreImport");
var _amzGenreImportDefault = parcelHelpers.interopDefault(_amzGenreImport);
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _amzClustersCss = require("./css/AmzClusters.css");
var _amzGenresCss = require("./css/AmzGenres.css");
var _amzUtils = require("../../actions/AmzUtils");
var AmzClusters = function() {
    var initState = {
        loading: true,
        genres: [],
        filtered: [],
        meta: {},
        pagination: {
            perPage: 15,
            page: 1,
            pages: 1,
            ascending: 1
        },
        search: {
            value: ""
        },
        addcluster: {
            open: false,
            menu: [],
            size: 0,
            error: false,
            message: ""
        }
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _objectSpread._)({}, initState)), 2), state = _useState[0], setState = _useState[1];
    var params = (0, _reactRouterDom.useParams)();
    var addNewCluster = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        if (!Object.hasOwn(state.meta).length) getClusterTitle();
        /**
     * If state.genres is a strict false value, assume that we haven't requested
     * the genres yet and do that now.
     */ if (!state.genres.length) getGenres();
    });
    var fd = new FormData();
    var resetFormKeys = function() {
        var keys = Array.from(fd.keys()).filter(function(f) {
            return f !== "token";
        });
        keys.forEach(function(k) {
            return fd.delete(k);
        });
    };
    var getGenres = function() {
        resetFormKeys();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("perPage", state.pagination.perPage);
        fd.set("page", state.pagination.page);
        fd.set("parent", params.id);
        fd.set("ascending", state.pagination.ascending);
        fd.set("keyword", state.search.value);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_GENRES), {
            body: fd
        }, function(response) {
            var update = [
                false
            ];
            if (response.results.length) update = (0, _toConsumableArray._)(response.results);
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                loading: false,
                genres: update,
                pagination: (0, _objectSpread._)({}, state.pagination, response.paginaiton)
            }));
        });
    };
    var getClusterTitle = function() {
        if (state.meta.name) return;
        resetFormKeys();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", params.id);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_SINGLEGENRE), {
            body: fd
        }, function(response) {
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                meta: (0, _objectSpread._)({}, state.meta, response)
            }));
        });
    };
    var getPage = function(domEvent) {
        var pg = 1;
        if (domEvent && Object.hasOwn(domEvent, "target")) {
            var value = domEvent.target.value;
            switch(value){
                case "first":
                    pg = 1;
                    break;
                case "last":
                    pg = +state.pagination.pages;
                    break;
                case "next":
                    pg = +state.pagination.page + 1;
                    break;
                case "previous":
                    pg = +state.pagination.page - 1;
                    break;
                case value > state.pagination.pages:
                    pg = +state.pagination.page;
                    break;
                default:
                    pg = +value;
            }
        }
        setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            pagination: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.pagination), {
                page: pg
            }),
            genres: []
        }));
    };
    var getSizesOnAddNewResponse = function(response) {
        setState(function() {
            return setStateOnAddNew(state, response);
        });
    };
    var getSizesOnAddNew = function(formObj) {
        if (!state.addcluster.menu.length) (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_GENRESIZES), {
            body: formObj
        }, getSizesOnAddNewResponse);
        else setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            addcluster: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.addcluster), {
                open: true
            })
        }));
    };
    var onSearchChange = function(domEvent) {
        var filtered = (0, _amzUtils.filterGenres)(domEvent.target.value, state.genres);
        setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            filtered: filtered
        }));
    };
    var onSearchReset = function() {
        setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            filtered: [],
            search: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.search), {
                value: ""
            })
        }));
    };
    var onSortChange = function(domEvent) {
        domEvent.preventDefault();
        var value = domEvent.target.value;
        setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            pagination: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.pagination), {
                ascending: +!state.pagination.ascending
            }),
            genres: []
        }));
    };
    var onAddNew = function(domEvent) {
        domEvent.preventDefault();
        resetFormKeys();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        getSizesOnAddNew(fd);
        if (Object.hasOwn(addNewCluster, "current") && addNewCluster.current) addNewCluster.current.showModal();
    };
    var onAddNewClose = function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (Object.hasOwn(ref, "current") && ref.current) ref.current.close();
    };
    var onAddNewChange = function(domEvent) {
        var field = domEvent.target.name;
        var value = domEvent.target.value;
        setState(function() {
            return (0, _amzUtils.setStateOnAddNewChange)(state, field, value);
        });
    };
    var onAddNewSubmit = function(domEvent) {
        domEvent.preventDefault();
        var submission = new FormData(domEvent.target);
        submission.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_GENREADD), {
            body: submission
        }, function(response) {
            var cb = function() {
                return (0, _amzUtils.setStateOnAddNewSubmitResponse)(state, response);
            };
            setState(cb);
            getGenres();
            onAddNewClose(addNewCluster);
        });
    };
    var afterGenreRemove = function(response) {
        if (!response.success) {
            setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                loading: false
            }));
            // eslint-disable-next-line no-alert
            alert((0, _configuration.MESSAGE_ERROR_GENERAL));
        } else setState(function() {
            return (0, _amzUtils.setStateAfterGenreRemoval)(state, response);
        });
    };
    var onGenreRemove = function(domEvent) {
        domEvent.preventDefault();
        var form = domEvent.target;
        setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            loading: true
        }));
        (0, _amzUtils.genreRemove)(form, afterGenreRemove);
    };
    var exportGenreCsv = function() {
        var exportRequest = new FormData();
        exportRequest.set("id", state.meta.id);
        exportRequest.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_GENRES_EXPORTCSV), {
            body: exportRequest
        }, function(response) {
            var fixSingleQuote = response.map(function(row) {
                return row.map(function(r) {
                    return r.replace("\\'", "'");
                });
            });
            var fNameDate = Intl.DateTimeFormat("en-US").format(Date.now());
            (0, _utilities.pushDownload)(fixSingleQuote, state.meta.name.replace(/\W/g, "_"), fNameDate.replace(/\//g, "-"));
        });
    };
    var onImportSubmit = function() {
        setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            genres: []
        }));
    };
    var makeListItem = function(l) {
        var link = null;
        if (l) link = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/music/songs/".concat(l.id),
                    children: l.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzGenreRemoveDefault.default), {
                    id: l.id,
                    onSubmit: onGenreRemove
                })
            ]
        }, "cluster_".concat((0, _lodashUniqueidDefault.default)()));
        return link;
    };
    var makeLinks = function() {
        var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        if (state.loading === false && !state.genres[0]) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "This genre doesn't have any clusters"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/music/",
                        children: "Back to Genres"
                    })
                })
            ]
        });
        var genres = state.search.value || state.filtered.length ? state.filtered : state.genres;
        if (state.loading === false && Array.isArray(genres) && genres.length) {
            var links = genres.map(makeListItem);
            body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "l__flex__sb l-shelf-flex50",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                                label: "Sort alphabetically: ",
                                selectedIndex: +!state.pagination.ascending,
                                options: [
                                    "A - Z",
                                    "Z - A"
                                ],
                                disabled: !Array.isArray(state.genres),
                                onChange: onSortChange,
                                name: "AmzClustersSort_".concat(params.id)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationBarDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.pagination), {
                                onClickHandler: getPage
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzClustersSearchDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.search), {
                        onChange: onSearchChange,
                        onReset: onSearchReset
                    })),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        className: "genres__list",
                        children: links
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationBarDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.pagination), {
                        onClickHandler: getPage
                    }))
                ]
            });
        }
        return body;
    };
    var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        id: "AmzGenres",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "l-shelf-flex50",
                        style: {
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "button__group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        disabled: !state.genres.length,
                                        to: "/music/reports/songs/".concat(state.meta.id),
                                        className: "btn btn--action",
                                        children: "Duplicate Songs Report"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        disabled: !state.genres.length,
                                        to: "/music/reports/artists/".concat(state.meta.id),
                                        className: "btn btn--action",
                                        style: {
                                            marginRight: ".5rem"
                                        },
                                        children: "Duplicate Artists Report"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        disabled: !state.genres.length,
                                        className: "btn btn--action",
                                        type: "button",
                                        style: {
                                            margin: "0"
                                        },
                                        onClick: exportGenreCsv,
                                        children: "Export CSV"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "end"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzClustersAddNew.AmzClustersAddNew), (0, _objectSpread._)({
                                        ref: addNewCluster,
                                        onOpen: onAddNew,
                                        onSubmit: onAddNewSubmit,
                                        onClose: onAddNewClose,
                                        onChange: onAddNewChange,
                                        cluster: (0, _objectSpread._)({}, state.meta)
                                    }, state.addcluster)),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzGenreImportDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                                        id: "AmzGenreImport"
                                    }, state.import), {
                                        parent: params.id,
                                        onClose: onImportSubmit
                                    }))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        children: [
                            "Clusters in",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                                children: state.meta.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: state.meta.meta
                    })
                ]
            }),
            makeLinks()
        ]
    });
    return body;
};
exports.default = AmzClusters;

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","lodash.uniqueid":"6bf5k","../subcomponents/LoaderSimple":"1dSHa","../subcomponents/PaginationBar":"03zHm","./AmzClustersSearch":"19O5K","./AmzClustersAddNew":"kh8oE","./AmzGenreRemove":"lQPIS","../subcomponents/ToggleSwitch":"k29YD","./AmzGenreImport":"9BvqW","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","./css/AmzClusters.css":"cIZgL","./css/AmzGenres.css":"hU5Ok","../../actions/AmzUtils":"dPdUh","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"19O5K":[function(require,module,exports) {
/**
 * AmzClustersSearch.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _amzClustersSearchCss = require("./css/AmzClustersSearch.css");
var AmzClustersSearch = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        method: "dialog",
        id: "AmzClustersSearch",
        onSubmit: props.onSubmit,
        onReset: props.onReset,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "q",
                children: "Filter Clusters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "form__input_button_group",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "search",
                            id: "q",
                            name: "q",
                            defaultValue: props.value,
                            onChange: props.onChange,
                            autoComplete: "off",
                            onFocus: props.onFocus
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "reset",
                            className: "btn btn--action",
                            children: "Reset"
                        })
                    ]
                })
            })
        ]
    });
};
AmzClustersSearch.propTypes = {
    value: (0, _propTypesDefault.default).string
};
exports.default = AmzClustersSearch;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","prop-types":"fUIWk","./css/AmzClustersSearch.css":"fXDZT","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fXDZT":[function() {},{}],"kh8oE":[function(require,module,exports) {
/**
 * AmzClustersAddNew.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmzClustersAddNew", function() {
    return AmzClustersAddNew;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeButton = require("../subcomponents/CloseButton");
var _actionMessageDisplay = require("../subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _utilities = require("../../js/Utilities");
var _amzClustersAddNewCss = require("./css/AmzClustersAddNew.css");
var MakeMenu = function(options, value, onChangeHandler) {
    /*
   Since the option keys function as their values, we need to keep the key/value
   association intact. But since 0 is not a value we want to allow in the menu
   or the database, we'll exclude it by only grabbing a portion of the array,
   beginning with index = 1
  */ var optz = new Map(options.slice(1).map(function(o, idx) {
        var descript = o.description ? "(".concat(o.description, ")") : "";
        return [
            idx + 1,
            "".concat(o.long, " ").concat(descript)
        ];
    }));
    var opts = []; // Initialize array because forEach doesn't do return values.
    optz.forEach(function(o, key) {
        opts.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
            value: key,
            children: o
        }, (0, _lodashUniqueidDefault.default)()));
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
        id: "size",
        name: "size",
        className: "form-control",
        onChange: onChangeHandler,
        value: value,
        required: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: "",
                children: "\u2014"
            }),
            opts
        ]
    });
};
var AddForm = function(props) {
    var ttl = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
        children: [
            "Add New Cluster to ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                children: props.cluster.name
            })
        ]
    });
    var err = props.error ? "failed" : "";
    var onClose = function() {
        if (Object.hasOwn(props, "onClose")) props.onClose(props.modal);
        if (Object.hasOwn(props.modal, "current") && props.modal.current.open) props.modal.current.close();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dialog", {
        id: "AmzClustersAddNewModal",
        ref: props.modal,
        title: ttl,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                color: "#CBCBCB",
                className: "dialog__body__close",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: ttl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMessageDisplayDefault.default), {
                mode: "failed",
                hidden: !props.error,
                message: props.message,
                onClose: props.onErrorClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                id: "AmzClustersAddNewForm",
                style: {
                    "margin": "3rem 0"
                },
                onSubmit: props.onSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        id: "parent",
                        name: "parent",
                        onChange: props.onChange,
                        value: props.cluster.id || ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "name",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                id: "name",
                                name: "name",
                                className: "form-control",
                                required: true,
                                value: props.name || "",
                                onChange: props.onChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "size",
                                children: "Size"
                            }),
                            MakeMenu(props.menu, props.size, props.onChange)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "meta",
                                children: "Short description"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                id: "meta",
                                name: "meta",
                                className: "form-control",
                                value: props.meta || "",
                                onChange: props.onChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "examples",
                                children: "Example songs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                id: "examples",
                                name: "examples",
                                className: "form-control",
                                value: props.examples || "",
                                onChange: props.onChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "notes",
                                children: "Notes"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                id: "notes",
                                name: "notes",
                                className: "form-control",
                                value: props.notes || "",
                                onChange: props.onChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "button__group",
                        style: {
                            "textAlign": "right"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "btn btn--action",
                                children: "Save"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn",
                                onClick: onClose,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AmzClustersAddNew = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    "textAlign": "right"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "btn btn--action",
                    onClick: props.onOpen,
                    children: "Add New Cluster"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddForm, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                modal: ref
            }))
        ]
    });
});

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/CloseButton":"3MmmO","../subcomponents/ActionMessageDisplay":"bzcdY","lodash.uniqueid":"6bf5k","../../js/Utilities":"euxcI","./css/AmzClustersAddNew.css":"gcqlH","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"gcqlH":[function() {},{}],"9BvqW":[function(require,module,exports) {
/**
 * AmzGenreImport.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../../js/Configuration");
var _actionMessageDisplay = require("../subcomponents/ActionMessageDisplay");
var _actionMessageDisplayDefault = parcelHelpers.interopDefault(_actionMessageDisplay);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _utilities = require("../../js/Utilities");
var _amzGenreAddNewCss = require("./css/AmzGenreAddNew.css");
var AddForm = function(props) {
    var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    if (!props.loading) body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: props.onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: "url",
                    children: "Google Sheet URL"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        id: "parent",
                        name: "parent",
                        value: props.parent,
                        onChange: function() {}
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        disabled: !props.email,
                        type: "url",
                        id: "url",
                        name: "url",
                        value: props.url,
                        "aria-describedby": "url_note",
                        onChange: props.onChange,
                        required: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        children: "Import"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                id: "url_note",
                children: [
                    "Make sure that you've shared this spreadsheet with",
                    " ",
                    "the email address ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        className: "nobreak",
                        children: props.email
                    }),
                    "."
                ]
            })
        ]
    });
    if (!props.loading && props.completed.length) {
        var li = props.completed.map(function(line) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                children: line
            }, (0, _lodashUniqueidDefault.default)());
        });
        body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
            className: "bulleted-disc",
            children: li
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        id: "AmzGenresImport",
        ref: props.modal,
        onClose: props.onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Import Genres"
            }),
            body
        ]
    });
};
var AmzGenreImport = function(props) {
    var modalRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(""), 2), url = _useState1[0], setUrl = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([]), 2), completed = _useState3[0], setCompleted = _useState3[1];
    var onOpen = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        (0, _utilities.apirequest)((0, _configuration.API_IMPORT_EMAIL), {
            body: fd
        }, function(response) {
            setEmail(response.email);
            if (modalRef.current) modalRef.current.showModal();
        });
    };
    var onClose = function() {
        if (modalRef.current) modalRef.current.close();
        if (props.onClose) props.onClose();
    };
    var onSubmit = function(domEvent) {
        domEvent.preventDefault();
        var url = domEvent.target.url;
        setLoading(true);
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("url", url);
        fd.set("parent", props.parent);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_GENREIMPORT), {
            body: fd
        }, function(response) {
            if (response.error) window.alert(response.message);
            else {
                setCompleted(response);
                onClose();
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    "textAlign": "right",
                    "marginLeft": "1rem"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "btn btn--action",
                    onClick: onOpen,
                    children: "Import Genres"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddForm, {
                loading: loading,
                completed: completed,
                email: email,
                onClose: onClose,
                onSubmit: onSubmit,
                modal: modalRef
            })
        ]
    });
};
exports.default = AmzGenreImport;

},{"@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","../../js/Configuration":"k3dur","../subcomponents/ActionMessageDisplay":"bzcdY","../subcomponents/LoaderSimple":"1dSHa","../subcomponents/ModalDialog":"72kji","lodash.uniqueid":"6bf5k","../../js/Utilities":"euxcI","./css/AmzGenreAddNew.css":"fZHce","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fZHce":[function() {},{}],"cIZgL":[function() {},{}],"hU5Ok":[function() {},{}],"7SIPZ":[function(require,module,exports) {
/*
  eslint react/destructuring-assignment: 0

*/ /**
 * AmzSongs.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _amzSongSearch = require("./AmzSongSearch");
var _amzSongAddSongs = require("./AmzSongAddSongs");
var _amzSongAddSongsDefault = parcelHelpers.interopDefault(_amzSongAddSongs);
var _amzSongsReorder = require("./AmzSongsReorder");
var _amzSongsRemove = require("./AmzSongsRemove");
var _amzSongsReorderTrigger = require("./AmzSongsReorderTrigger");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _destinationsUtils = require("../../actions/DestinationsUtils");
var _reportsUtils = require("../../actions/ReportsUtils");
var _amzUtils = require("../../actions/AmzUtils");
var _amzSongsCss = require("./css/AmzSongs.css");
var withParams = function(Component) {
    return function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            params: (0, _reactRouterDom.useParams)()
        }));
    };
};
var AmzSongs = function(param) {
    var params = param.params;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), songs = _useState1[0], setSongs = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(0), 2), count = _useState2[0], setCount = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)({
        page: 1,
        count: 0,
        pages: 0
    }), 2), pagination = _useState3[0], setPagination = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)({}), 2), meta = _useState4[0], setMeta = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(1), 2), ascending = _useState5[0], setAscending = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)("artist"), 2), _sortfield = _useState6[0], set_Sortfield = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)({
        value: "",
        loading: false
    }), 2), search = _useState7[0], setSearch = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)({
        open: false,
        value: "",
        maxIds: false,
        working: false,
        data: [],
        mode: "add"
    }), 2), addSongs = _useState8[0], setAddSongs = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)("display"), 2), mode = _useState9[0], setMode = _useState9[1]; // One of ['reorder', 'display']
    var addSongsRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        if (!meta.name) getClusterTitle();
        if (!songs.length) getSongs();
    }, [
        meta,
        songs
    ]);
    var onSearchChange = function(domEvent) {
        var value1 = domEvent.target.value;
        setSearch({
            value: value1,
            loading: true
        });
        setSongs([]);
    };
    var onSearchSubmit = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (domEvent) domEvent.preventDefault();
        setSearch({
            value: value,
            loading: true
        });
        setSongs([]);
    };
    var onAddSongsRequest = function() {
        if (addSongsRef.current) addSongsRef.current.showModal();
    };
    var onAddSongsClose = function() {
        setAddSongs((0, _objectSpreadProps._)((0, _objectSpread._)({}, addSongs), {
            data: [],
            mode: "add",
            working: false,
            value: ""
        }));
        if (addSongsRef.current) addSongsRef.current.close();
    };
    var onAddSongsChange = function(domEvent) {
        var value1 = domEvent.target.value;
        setAddSongs({
            value: value1,
            maxIds: (0, _destinationsUtils.tooManyURLs)(value1, 10)
        });
    };
    var onAddSongsSubmit = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (domEvent) domEvent.preventDefault();
        getScrapedAsin();
    };
    var onAddSongsSave = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (domEvent) domEvent.preventDefault();
        var elements = domEvent.target.elements;
        /*
      Filter form elements to:
      
      1. Return checkboxes only;
      2. Narrow that down to checked checkboxes; then
      3. Return the id attribute values of the checked boxes.
    */ var submits = Array.from(elements).filter(function(i) {
            return i.type === "checkbox";
        }).filter(function(i) {
            return i.checked;
        }).map(function(i) {
            return i.id;
        });
        var send = (0, _toConsumableArray._)(addSongs.data).filter(function(s) {
            return submits.indexOf(s.asin) > -1;
        });
        if (send.length === 0) alert("No songs to save. Please try again.");
        else (0, _amzUtils.makeSaveRequest)(params.id, send, function(response) {
            setLoading(true);
            setAddSongs({
                open: false,
                value: "",
                maxIds: false,
                working: false,
                data: [],
                mode: "add"
            });
            setSongs([]);
        });
    };
    /* Change when adding a song */ var onAsinOrderChange = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var _domEvent_target = domEvent.target, value1 = _domEvent_target.value, id = _domEvent_target.id;
        var asin = id.replace(/order\[/, "").replace(/\]/, "");
        var songs = (0, _toConsumableArray._)(addSongs.data);
        var index = songs.findIndex(function(s) {
            return asin === s.asin;
        });
        songs[index]["ordinal"] = +value1;
        setAddSongs((0, _objectSpreadProps._)((0, _objectSpread._)({}, addSongs), {
            data: songs
        }));
    };
    var onRemoveSubmit = function() {
        var domEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (!domEvent) return;
        domEvent.preventDefault();
        var asin = domEvent.target.asin;
        var todelete = songs.find(function(s) {
            return asin.value === s.ASIN;
        });
        // eslint-disable-next-line no-alert
        var confirm = window.confirm("Are you sure that you want to remove \u201C".concat(todelete["Song Title"], "\u201D from this cluster?"));
        if (confirm) {
            setLoading(true);
            var fd = new FormData(domEvent.target);
            fd.set("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_SONG_REMOVE), {
                body: fd
            }, function(response) {
                if (response.success) {
                    var newsongs = (0, _toConsumableArray._)(songs).filter(function(s) {
                        return response.asin !== s.ASIN;
                    });
                    setSongs(newsongs);
                    setLoading(false);
                }
            });
        }
    };
    /* Change in reordering mode */ var onChangeOrder = function(domEvent) {
        var _domEvent_target = domEvent.target, id = _domEvent_target.id, value1 = _domEvent_target.value;
        var oldSongs = (0, _toConsumableArray._)(songs);
        // Find which item to change
        var update = oldSongs.findIndex(function(song) {
            return id === song.ASIN;
        });
        oldSongs[update].ordinal = value1;
        setSongs(oldSongs);
    };
    var onAddSongsSubmitResponse = function(response) {
        var songs = response.map(function(r) {
            var x = (0, _objectSpread._)({}, r);
            x.ordinal = 0;
            return x;
        });
        setAddSongs((0, _objectSpreadProps._)((0, _objectSpread._)({}, addSongs), {
            working: false,
            data: songs,
            mode: "save"
        }));
    };
    var onSortFieldChange = function(domEvent) {
        var sortfield = domEvent.target.dataset.sortfield;
        if (_sortfield === sortfield) setAscending(+!ascending);
        set_Sortfield(sortfield);
        setSearch((0, _objectSpreadProps._)((0, _objectSpread._)({}, search), {
            loading: true
        }));
        setSongs([]);
    };
    var getClusterTitle = function() {
        if (Object.hasOwn(meta, "name")) return;
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", params.id);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_SINGLEGENRE), {
            body: fd
        }, function(response) {
            if (Object.hasOwn(response, "id")) setMeta((0, _objectSpread._)({}, response));
            else setMeta({
                error: true
            });
        });
    };
    var getSongs = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", params.id);
        fd.set("sortfield", _sortfield);
        fd.set("ascending", ascending);
        if (search.value && search.value.length > 2) fd.set("keyword", search.value);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_SONGS), {
            body: fd
        }, function(response) {
            setLoading(false);
            if (response.results.length) setSongs(response.results);
            else setSongs([
                false
            ]);
            setCount(response.count);
            setPagination(pagination);
            setSearch((0, _objectSpreadProps._)((0, _objectSpread._)({}, search), {
                loading: false
            }));
            setMode("display");
        });
    };
    var getScrapedAsin = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("asin", addSongs.value);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_SONG_GET_ASINDATA), {
            body: fd
        }, onAddSongsSubmitResponse);
    };
    var changeMode = function() {
        if (mode === "display") {
            var current = [
                "reorder",
                "display"
            ].find(function(m) {
                return m === mode;
            });
            setMode("reorder");
        } else {
            var updated = songs.map(function(song) {
                return {
                    asin: song.ASIN,
                    ordinal: song.ordinal
                };
            });
            var fd = new FormData();
            fd.set("genre", params.id);
            fd.set("order", JSON.stringify(updated));
            fd.set("token", (0, _utilities.getAuthData)("token"));
            (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_SONGSREORDER), {
                body: fd
            }, function(response) {
                setLoading(false);
                setSearch((0, _objectSpreadProps._)((0, _objectSpread._)({}, search), {
                    loading: false
                }));
                setMode("display");
                setPagination((0, _objectSpread._)({}, response.pagination));
                setCount(response.pagination.count);
            });
        }
    };
    var goBack = function(domEvent) {
        domEvent.preventDefault();
        window.history.go(-1);
    };
    var makeDisplay = function() {
        var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        if (Object.hasOwn(meta, "error")) body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "No such cluster"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "/music/clusters/",
                        onClick: goBack,
                        children: "Back to Clusters"
                    })
                })
            ]
        });
        else if (loading === false) {
            if (songs.length || search.value) body = makeTheResults();
            else body = makeNoResults();
        }
        return body;
    };
    var makeTable = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "amz__songs__tbl",
            children: [
                makeTableHeader(),
                makeTableRows()
            ]
        });
    };
    var makeTableRows = function() {
        var rows = null;
        if (!songs[0]) return rows;
        rows = songs.map(function(song) {
            var tds = Object.values(song).map(function(f, idx) {
                /* eslint-disable no-param-reassign */ if (idx === 0 && mode === "reorder") f = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongsReorder.AmzSongsReorder), (0, _objectSpreadProps._)((0, _objectSpread._)({}, song), {
                    onChange: onChangeOrder
                }));
                // Add exception for ASINs
                if (idx === 1) f = /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: (0, _amzUtils.amzUrl)(f),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: f
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: f
                }, (0, _lodashUniqueidDefault.default)());
            /* eslint-enable */ });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    tds,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongsRemove.AmzSongsRemove), (0, _objectSpreadProps._)((0, _objectSpread._)({}, song), {
                            cluster: params.id,
                            onSubmit: onRemoveSubmit
                        }))
                    })
                ]
            }, (0, _lodashUniqueidDefault.default)());
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
            children: rows
        });
    };
    var makeTableHeader = function() {
        if (songs[0] === false) return null;
        var ths = Object.keys(songs[0]).map(function(h) {
            var txt = h === "ordinal" ? "Order" : h;
            var th = /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    "data-sortfield": txt.toLowerCase().replace(/\s/g, ""),
                    className: "tbl__sort_trigger",
                    onClick: onSortFieldChange,
                    children: txt
                })
            }, (0, _lodashUniqueidDefault.default)());
            return th;
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    ths,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                        children: "Remove"
                    })
                ]
            })
        });
    };
    var makeNoResults = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "There are no songs in this cluster."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "/music/clusters/",
                        onClick: goBack,
                        children: "Back to Clusters"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--action",
                        onClick: onAddSongsRequest,
                        children: "Add songs"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongAddSongsDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, addSongs), {
                    cluster: params.id,
                    onClose: onAddSongsClose,
                    onChange: onAddSongsChange,
                    onSubmit: onAddSongsSubmit,
                    onSave: onAddSongsSave,
                    onOrderChange: onAsinOrderChange
                }))
            ]
        });
    };
    var makeTheResults = function() {
        var _meta_meta, _meta_notes;
        var loading = search.loading;
        var body = loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        }) : makeTable();
        var songCount = 0;
        if (songs[0] !== false) songCount = songs.length;
        /* eslint-disable react/jsx-one-expression-per-line */ return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                    className: "amz__songs__head",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                            children: [
                                "Songs in ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                                    children: meta.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: meta === null || meta === void 0 ? void 0 : (_meta_meta = meta.meta) === null || _meta_meta === void 0 ? void 0 : _meta_meta.trim()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: meta === null || meta === void 0 ? void 0 : (_meta_notes = meta.notes) === null || _meta_notes === void 0 ? void 0 : _meta_notes.trim()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            style: {
                                textAlign: "right"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn btn--action",
                                onClick: onAddSongsRequest,
                                children: "Add songs"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "l__flex__sb",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    style: {
                                        fontSize: "2rem"
                                    },
                                    children: [
                                        songCount,
                                        " songs"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                            children: "Curated by: "
                                        }),
                                        meta.curator
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongSearch.AmzSongSearch), (0, _objectSpreadProps._)((0, _objectSpread._)({}, search), {
                        onChange: onSearchChange,
                        onSubmit: onSearchSubmit
                    }))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongsReorderTrigger.AmzSongsReorderTrigger), {
                                mode: mode,
                                disabled: !songs[0],
                                onClick: changeMode
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: makeCSV,
                            disabled: !songs[0],
                            className: "btn btn--action",
                            children: "Export as CSV"
                        })
                    ]
                }),
                body,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongAddSongsDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, addSongs), {
                    modalRef: addSongsRef,
                    cluster: params.id,
                    onClose: onAddSongsClose,
                    onChange: onAddSongsChange,
                    onSubmit: onAddSongsSubmit,
                    onSave: onAddSongsSave,
                    onOrderChange: onAsinOrderChange
                }))
            ]
        });
    /* eslint-enable */ };
    var makeCSV = function() {
        if (!songs.length) return;
        var headers = [
            [
                "ASIN",
                "Artist",
                "Song Name",
                "Album Name",
                "Genre",
                "Sub-genre",
                "Curator",
                "Entry #"
            ]
        ];
        var rows = songs.map(function(song) {
            return [
                '"'.concat(song.ASIN, '"'),
                '"'.concat(song.Artist, '"'),
                '"'.concat(song["Song Title"], '"'),
                '"'.concat(song.Album, '"'),
                '"'.concat(meta.parent.name, '"'),
                '"'.concat(meta.name, '"'),
                "",
                song.ordinal
            ];
        });
        var csv = headers.concat(rows);
        (0, _reportsUtils.download)(csv, meta.name.replace(/\s/g, "_"), "Music", "");
    };
    var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    if (loading === false) body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
        id: "AmzGenres",
        children: makeDisplay()
    });
    return body;
};
exports.default = withParams(AmzSongs);

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","@swc/helpers/_/_to_consumable_array":"fRXIP","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","lodash.uniqueid":"6bf5k","../subcomponents/LoaderSimple":"1dSHa","./AmzSongSearch":"6euh6","./AmzSongAddSongs":"8tFGT","./AmzSongsReorder":"a1z6V","./AmzSongsRemove":"hNAlh","./AmzSongsReorderTrigger":"j0fSx","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/DestinationsUtils":"5X8UE","../../actions/ReportsUtils":"8Ctqy","../../actions/AmzUtils":"dPdUh","./css/AmzSongs.css":"1RoCG","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6euh6":[function(require,module,exports) {
/**
 * AmzSongSearch.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmzSongSearch", function() {
    return AmzSongSearch;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utilities = require("../../js/Utilities");
var AmzSongSearch = function(props) {
    var autocomp = "off";
    switch(props.autocomplete){
        case true:
            autocomp = "on";
            break;
        case props.autocomplete !== true:
            autocomp = props.autocomplete;
            break;
        default:
            autocomp = "off";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        id: "AmzSongSearch",
        onSubmit: props.onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: "q",
                    children: "Search Songs by Title or ASIN"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        value: (0, _utilities.getAuthData)("token"),
                        name: "token",
                        id: "token",
                        onChange: function() {}
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: props.value,
                        name: "q",
                        id: "q",
                        onChange: props.onChange,
                        autoComplete: autocomp
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        disabled: !props.value,
                        children: "Search"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"8tFGT":[function(require,module,exports) {
/**
 * AmzSongAddSongs.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalDialog = require("../subcomponents/ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _amzSongAddSongsForm = require("./AmzSongAddSongsForm");
var _amzSongAddSongsSave = require("./AmzSongAddSongsSave");
var _amzSongAddSongsSaveDefault = parcelHelpers.interopDefault(_amzSongAddSongsSave);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var AmzSongAddSongs = function(props) {
    var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
        open: true
    });
    var working = props.working, modalRef = props.modalRef, mode = props.mode, open = props.open, onClose = props.onClose;
    if (mode === "save") body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongAddSongsSaveDefault.default), (0, _objectSpread._)({}, props));
    else body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amzSongAddSongsForm.AmzSongAddSongsForm), (0, _objectSpread._)({}, props));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalDialogDefault.default), {
        ref: modalRef,
        id: "AmzSongAddSongs",
        title: "Add Songs",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Add songs to cluster"
            }),
            body
        ]
    });
};
exports.default = AmzSongAddSongs;

},{"@swc/helpers/_/_object_spread":"95yNt","react/jsx-runtime":"66j3G","react":"l5IPE","../subcomponents/ModalDialog":"72kji","./AmzSongAddSongsForm":"lk7x8","./AmzSongAddSongsSave":"9tStC","../subcomponents/LoaderSimple":"1dSHa","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lk7x8":[function(require,module,exports) {
/**
 * AmzSongAddSongs.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmzSongAddSongsForm", function() {
    return AmzSongAddSongsForm;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _configuration = require("../../js/Configuration");
var AmzSongAddSongsForm = function(param) {
    var maxIds = param.maxIds, value = param.value, cluster = param.cluster, onChange = param.onChange, onClose = param.onClose, onSubmit = param.onSubmit;
    var txtAreaRef = (0, _reactDefault.default).useRef(null);
    var submitDisabled = function() {
        var disabled = true;
        if (txtAreaRef.current) disabled = !txtAreaRef.current.value;
        return disabled;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        id: "AmzSongAddSongs__form",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                hidden: !maxIds,
                className: "form__instructions form__error",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("i", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: (0, _configuration.MESSAGE_ERROR_TOO_MANY_URLS)[0]
                        }),
                        " ".concat((0, _configuration.MESSAGE_ERROR_TOO_MANY_URLS)[1], " "),
                        (0, _configuration.MESSAGE_ERROR_TOO_MANY_URLS)[2]
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        id: "clusterid",
                        name: "clusterid",
                        defaultValue: cluster,
                        onChange: function() {}
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "name",
                        children: "Amazon ASIN IDs or Song URLs"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        id: "name",
                        name: "name",
                        className: "form-control",
                        "aria-describedby": "cluster_note",
                        defaultValue: value,
                        onChange: onChange,
                        rows: "6",
                        ref: txtAreaRef
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "form__instructions aria__description",
                        id: "cluster_note",
                        children: [
                            "Use valid Amazon URLs or song ASIN IDs. URLs or IDs should be separated either by a comma (,) or new line. If using URLs, include the protocol for each, e.g.: ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "http://"
                            }),
                            " or",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "https://"
                            }),
                            ". Limit 15."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "button__group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        disabled: submitDisabled(),
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--light",
                        onClick: onClose,
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","../../js/Configuration":"k3dur","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"9tStC":[function(require,module,exports) {
/**
 * AmzSongAddSongsSave.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _configuration = require("../../js/Configuration");
var _noImageImg = require("../subcomponents/NoImageImg");
var _fancyCheckboxesCss = require("../subcomponents/css/fancy-checkboxes.css");
var AmzSongAddSongsSave = function(param) {
    var data = param.data, onOrderChange = param.onOrderChange, onExcludeToggle = param.onExcludeToggle, onClose = param.onClose, onSave = param.onSave;
    var makeHeader = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                        scope: "col",
                        className: "asin__table_order",
                        children: "Order"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                        colSpan: "2",
                        scope: "col",
                        children: "Title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                        scope: "col",
                        children: "ASIN"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                        scope: "col",
                        children: "Artist"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                        scope: "col",
                        children: "Album"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                        scope: "col",
                        children: [
                            "Confirm",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "table__note",
                                children: "Uncheck to exclude"
                            })
                        ]
                    })
                ]
            })
        });
    };
    var makeRow = function(obj) {
        var artist_name, album_title, cover_img;
        // Property can exist, but be empty, so we need to check for both.
        if (!Object.hasOwn(obj, "artist")) artist_name = "No Artist Info";
        else artist_name = obj.artist.name ? obj.artist.name : "No Artist Info";
        if (!Object.hasOwn(obj, "album")) album_title = obj.album.title ? obj.album.title : "No Album Info";
        if (!Object.hasOwn(obj, "imgpath")) cover_img = obj.imgpath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: obj.imgpath,
            alt: '"'.concat(obj.title, '"" cover'),
            className: "asin__thumb"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noImageImg.NoImageImg), {
            height: "75px",
            width: "75px"
        });
        else cover_img = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noImageImg.NoImageImg), {
            height: "75px",
            width: "75px"
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        size: "4",
                        type: "number",
                        id: "order[".concat(obj.asin, "]"),
                        name: "order[".concat(obj.asin, "]"),
                        onChange: onOrderChange,
                        defaultValue: obj.ordinal,
                        min: "-1",
                        max: "125",
                        step: "0.5"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: cover_img
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "order[".concat(obj.asin, "]"),
                        children: obj.title || "No Title Info"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: obj.asin
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: artist_name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: album_title
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "fancy__chex",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                id: obj.asin,
                                name: obj.asin,
                                defaultChecked: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: obj.asin,
                                className: "asin__label",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "form__access__label",
                                    children: obj.asin
                                })
                            })
                        ]
                    })
                })
            ]
        }, (0, _lodashUniqueidDefault.default)());
    };
    var sty = {
        "textAlign": "right"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        id: "AmzSongAddSongs__save",
        onSubmit: onSave,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "button__group",
                style: sty,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--light",
                        onClick: onClose,
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "asin__table_add",
                children: [
                    makeHeader(),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: data.map(makeRow)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "button__group",
                style: sty,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn btn--action",
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--light",
                        onClick: onClose,
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
};
exports.default = AmzSongAddSongsSave;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","lodash.uniqueid":"6bf5k","../../js/Configuration":"k3dur","../subcomponents/NoImageImg":"6NpEM","../subcomponents/css/fancy-checkboxes.css":"QlDSe","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"6NpEM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoImageImg", function() {
    return NoImageImg;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var NoImageImg = function(props) {
    var hw = {
        height: "300px",
        width: "300px"
    };
    var prps = Object.assign(hw, props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({}, prps), {
        viewBox: "0 0 300 300",
        className: "NoImageImg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "No image available"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fillOpacity: "0.2",
                        fill: "#98C3DD",
                        x: "0",
                        y: "0",
                        width: "300",
                        height: "300"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M149.52381,290 C168.417659,290 186.493986,286.305429 203.75279,278.916288 C221.011595,271.527147 235.848111,261.594203 248.262339,249.117456 C260.676567,236.640709 270.57767,221.741294 277.96565,204.419208 C285.353629,187.097123 289.047619,168.927104 289.047619,149.90915 C289.047619,130.891196 285.353629,112.781743 277.96565,95.5807917 C270.57767,78.2587065 260.676567,63.3592905 248.262339,50.8825438 C235.848111,38.4057971 221.011595,28.4728531 203.75279,21.0837119 C186.493986,13.6945706 168.417659,10 149.52381,10 C130.62996,10 112.553633,13.6945706 95.2948289,21.0837119 C78.0360243,28.4728531 63.1995081,38.4057971 50.7852803,50.8825438 C38.3710524,63.3592905 28.4699487,78.2284231 21.0819692,95.4899416 C13.6939897,112.75146 10,130.891196 10,149.90915 C10,168.927104 13.6939897,187.097123 21.0819692,204.419208 C28.4699487,221.741294 38.3710524,236.640709 50.7852803,249.117456 C63.1995081,261.594203 78.0360243,271.527147 95.2948289,278.916288 C112.553633,286.305429 130.62996,290 149.52381,290 Z M67.1214173,205.238095 C56.3420597,188.561848 50.952381,170.364046 50.952381,150.644689 C50.952381,132.629473 55.3731287,115.953226 64.2146242,100.615948 C73.0561198,85.27867 85.0466411,73.1670893 100.186188,64.281206 C115.325735,55.3953226 131.858121,50.952381 149.783345,50.952381 C169.767547,50.952381 187.935003,56.4908425 204.285714,67.5677656 L204.285714,67.5677656 L67.1214173,205.238095 Z M148.911726,250 C129.463979,250 111.414038,244.597519 94.7619048,233.792557 L94.7619048,233.792557 L232.233169,96.6666667 C242.807882,112.934811 248.095238,130.841911 248.095238,150.387965 C248.095238,163.863816 245.481947,176.762998 240.255365,189.085511 C235.028783,201.408023 227.978974,212.000528 219.10594,220.863025 C210.232905,229.725521 199.688579,236.797308 187.472963,242.078385 C175.257347,247.359462 162.403601,250 148.911726,250 Z",
                        fill: "#98C3DD",
                        fillRule: "nonzero"
                    })
                ]
            })
        ]
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"QlDSe":[function() {},{}],"a1z6V":[function(require,module,exports) {
/**
 * AmzSongsReorder.jsx
 * An input field for reordering songs in a list.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmzSongsReorder", function() {
    return AmzSongsReorder;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var AmzSongsReorder = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "AmzSongsReorder",
        style: {
            "display": "flex"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                htmlFor: props.ASIN,
                className: "form__access__label",
                children: [
                    "Change position of ",
                    props["Song Title"]
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "number",
                step: "1",
                min: "0",
                max: "1000",
                id: props.ASIN,
                name: props.ASIN,
                value: props.ordinal,
                onChange: props.onChange
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hNAlh":[function(require,module,exports) {
/**
 * AmzSongsRemove.jsx
 * A form for removing songs from a cluster.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmzSongsRemove", function() {
    return AmzSongsRemove;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var AmzSongsRemove = function(param) {
    var onSubmit = param.onSubmit, ASIN = param.ASIN, cluster = param.cluster;
    var emptyOnChange = function() {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "AmzSongsRemove",
        id: (0, _lodashUniqueidDefault.default)("AmzSongsRemove_"),
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "asin",
                value: ASIN,
                onChange: emptyOnChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: "cluster",
                value: cluster,
                onChange: emptyOnChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "btn btn--action",
                children: "Remove from Cluster"
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","lodash.uniqueid":"6bf5k","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"j0fSx":[function(require,module,exports) {
/**
 * AmzSongsReorderTrigger.js
 * Button to enter and exit reordering mode.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmzSongsReorderTrigger", function() {
    return AmzSongsReorderTrigger;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var AmzSongsReorderTrigger = function(param) {
    var onClick = param.onClick, mode = param.mode, disabled = param.disabled;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "AmzSongsReorderTrigger",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn btn--action",
                onClick: onClick,
                disabled: disabled,
                hidden: mode !== "display",
                children: "Re-order list"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "btn btn--action",
                onClick: onClick,
                hidden: mode !== "reorder",
                children: "Save changes"
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","lodash.uniqueid":"6bf5k","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1RoCG":[function() {},{}],"ePHwU":[function(require,module,exports) {
/**
 * AmzReports.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _amzSongSearch = require("./AmzSongSearch");
var _amzSongAddSongs = require("./AmzSongAddSongs");
var _noSuchReport = require("./NoSuchReport");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _reportsUtils = require("../../actions/ReportsUtils");
var _amzReportsCss = require("./css/AmzReports.css");
var AmzReports = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), results = _useState1[0], setResults = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)("frequency"), 2), sortby = _useState2[0], setSortby = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(0), 2), ascending = _useState3[0], setAscending = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)({}), 2), meta = _useState4[0], setMeta = _useState4[1];
    var params = props.params;
    (0, _react.useEffect)(function() {
        if (!Object.hasOwn(meta, "name")) getGenreTitle();
        if (!results.length) getDuplicates();
    }, [
        meta
    ]);
    var getGenreTitle = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", params.id);
        (0, _utilities.apirequest)((0, _configuration.API_CLUSTERS_SINGLEGENRE), {
            body: fd
        }, function(response) {
            if (Object.hasOwn(response, "id")) setMeta(response);
            else setMeta({
                error: true
            });
        });
    };
    var getDuplicates = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("report", params.report);
        fd.set("genre", params.id);
        fd.set("ascending", ascending);
        fd.set("sort", sortby);
        (0, _utilities.apirequest)((0, _configuration.API_GENRES_REPORTS), {
            body: fd
        }, function(response) {
            setLoading(false);
            setResults(response.results);
        });
    };
    var makeTable = function() {
        var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        if (results.length) body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "reports__table__results",
            children: [
                makeTableHeader(),
                makeTableRows()
            ]
        });
        return body;
    };
    var makeTableHeader = function() {
        if (!results.length) return null;
        var fields = Object.keys(results[0]);
        var th = fields.filter(function(f) {
            return [
                "sASIN",
                "aASIN"
            ].indexOf(f) < 0;
        }).map(function(f) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                children: (0, _utilities.capitalize)(f)
            }, (0, _lodashUniqueidDefault.default)());
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: th
            })
        });
    };
    var makeTableRows = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {});
    };
    var makeTitle = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                    style: {
                        "textTransform": "capitalize"
                    },
                    children: [
                        "Duplicate ",
                        params.report,
                        " Report for ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("q", {
                            children: meta.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                        className: "amz__reports_backlink",
                        href: "/music/clusters/".concat(params.id, "/"),
                        children: [
                            "Return to ",
                            meta.name
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "button__group",
                    style: {
                        "textAlign": "right"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn btn--action",
                        onClick: makeCSV,
                        children: "Export CSV"
                    })
                })
            ]
        });
    };
    var makeCSV = function() {
        if (!results.length) return;
        var exclude = [
            "ASIN",
            "sASIN",
            "aASIN",
            "sgid",
            "gid"
        ];
        var csv = [];
        var headers = Object.keys(results[0]);
        csv[0] = headers.filter(function(h) {
            return exclude.indexOf(h) < 0;
        }).map(function(h) {
            return '"'.concat((0, _utilities.capitalize)(h), '"');
        });
        var rws = results.map(function(r) {
            var fields = Object.keys(r).filter(function(r) {
                return exclude.indexOf(r) < 0;
            });
            return fields.map(function(f) {
                return '"'.concat(r[f], '"');
            });
        });
        var filename = "".concat((0, _utilities.capitalize)(params.report), "_Report_for_").concat(meta.name);
        (0, _reportsUtils.download)(csv.concat(rws), filename, "Duplicate", "");
    };
    var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noSuchReport.NoSuchReport), {});
    if ([
        "artists",
        "songs"
    ].indexOf(params.report) > -1) body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            makeTitle(),
            makeTable()
        ]
    });
    return body;
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzReports, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","lodash.uniqueid":"6bf5k","../subcomponents/LoaderSimple":"1dSHa","./AmzSongSearch":"6euh6","./AmzSongAddSongs":"8tFGT","./NoSuchReport":"7aE1k","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/ReportsUtils":"8Ctqy","./css/AmzReports.css":"etKLw","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7aE1k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoSuchReport", function() {
    return NoSuchReport;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var NoSuchReport = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "NoSuchReport",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "That report does not exist."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Please double-check the URL."
            })
        ]
    });
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"etKLw":[function() {},{}],"liMRL":[function(require,module,exports) {
/**
 * AmzReportsDetails.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _loaderSimple = require("../subcomponents/LoaderSimple");
var _loaderSimpleDefault = parcelHelpers.interopDefault(_loaderSimple);
var _amzSongSearch = require("./AmzSongSearch");
var _amzSongAddSongs = require("./AmzSongAddSongs");
var _noSuchReport = require("./NoSuchReport");
var _configuration = require("../../js/Configuration");
var _utilities = require("../../js/Utilities");
var _reportsUtils = require("../../actions/ReportsUtils");
var _amzUtils = require("../../actions/AmzUtils");
var _amzReportsCss = require("./css/AmzReports.css");
var AmzReportsDetails = function(param) {
    var params = param.params;
    var location = (0, _reactRouterDom.useLocation)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), results = _useState1[0], setResults = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({}), 2), meta = _useState2[0], setMeta = _useState2[1];
    (0, _react.useEffect)(function() {
        if (params.report) resetStateOnSongTitleDupes();
    }, [
        params
    ]);
    var resetStateOnSongTitleDupes = function() {
        var report = params.report;
        setLoading(true);
        if (report === "title") getSongTitleDupes();
        else getArtistNameDupes();
    };
    var getSongTitleDupes = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", params.id);
        if (Object.hasOwn(params, "genre")) fd.set("genre", params.genre);
        (0, _utilities.apirequest)((0, _configuration.API_GENRES_SONGDUPES), {
            body: fd
        }, function(response) {
            setLoading(false);
            setMeta({
                name: response.title
            });
            setResults(response.genres);
        });
    };
    var getArtistNameDupes = function() {
        var fd = new FormData();
        fd.set("token", (0, _utilities.getAuthData)("token"));
        fd.set("id", params.id);
        (0, _utilities.apirequest)((0, _configuration.API_GENRES_ARTISTDUPES), {
            body: fd
        }, function(response) {
            setLoading(false);
            setMeta({
                name: response.name
            });
            setResults(response.genres);
        });
    };
    var makeBackLink = function() {
        var link = null;
        var report = params.report;
        if (Object.hasOwn(location, "state")) link = /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                to: "/music/reports/".concat(report, "/"),
                className: "amz__reports_backlink",
                children: "Return to report"
            })
        });
        return link;
    };
    var makeTable = function() {
        var body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderSimpleDefault.default), {
            open: true
        });
        if (results.length) body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "reports__table__results",
            children: [
                makeTableHeader(),
                makeTableRows()
            ]
        });
        return body;
    };
    var makeTableHeader = function() {
        if (!results.length) return null;
        var fields = Object.keys(results[0]);
        var th = fields.filter(function(f) {
            return [
                "sASIN",
                "aASIN",
                "gid"
            ].indexOf(f) < 0;
        }).map(function(f) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                children: (0, _utilities.capitalize)(f)
            }, (0, _lodashUniqueidDefault.default)());
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: th
            })
        });
    };
    var makeTableRows = function() {
        if (!results.length) return null;
        var results = results;
        var rows = results.map(function(f, index, results) {
            var cols = Object.keys(f).filter(function(f) {
                return [
                    "gid"
                ].indexOf(f) < 0;
            });
            var td = cols.map(function(c) {
                var cell = f[c];
                if (c === "Sub-genre" && f.hasOwnProperty("gid")) cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: {
                        pathname: "/music/songs/".concat(f.gid)
                    },
                    children: f["Sub-genre"]
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: cell
                }, (0, _lodashUniqueidDefault.default)());
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: td
            }, (0, _lodashUniqueidDefault.default)());
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
            children: rows
        });
    };
    var makeDisplay = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                            children: [
                                "Details for ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                    children: meta.name
                                })
                            ]
                        }),
                        makeBackLink(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "button__group",
                            style: {
                                "textAlign": "right"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn btn--action",
                                onClick: makeCSV,
                                disabled: !results.length,
                                children: "Export CSV"
                            })
                        })
                    ]
                }),
                makeTable()
            ]
        });
    };
    var makeCSV = function() {
        if (!results.length) return;
        var exclude = [
            "gid",
            "sASIN",
            "aASIN"
        ];
        var csv = [];
        var headers = Object.keys(results[0]);
        csv[0] = headers.filter(function(h) {
            return exclude.indexOf(h) < 0;
        }).map(function(h) {
            return '"'.concat((0, _utilities.capitalize)(h), '"');
        });
        var rws = results.map(function(r) {
            var fields = Object.keys(r).filter(function(r) {
                return exclude.indexOf(r) < 0;
            });
            return fields.map(function(f) {
                return '"'.concat(r[f], '"');
            });
        });
        var filename = "".concat((0, _utilities.capitalize)(params.report), "_Report_for_").concat(meta.name);
        (0, _reportsUtils.download)(csv.concat(rws), filename, "Duplicate", "");
    };
    return makeDisplay();
};
exports.default = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmzReportsDetails, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        params: (0, _reactRouterDom.useParams)()
    }));
};

},{"@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_object_spread_props":"8JXDR","@swc/helpers/_/_sliced_to_array":"9bl3C","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","lodash.uniqueid":"6bf5k","../subcomponents/LoaderSimple":"1dSHa","./AmzSongSearch":"6euh6","./AmzSongAddSongs":"8tFGT","./NoSuchReport":"7aE1k","../../js/Configuration":"k3dur","../../js/Utilities":"euxcI","../../actions/ReportsUtils":"8Ctqy","../../actions/AmzUtils":"dPdUh","./css/AmzReports.css":"etKLw","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"etKLw":[function() {},{}],"jwuXm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _createSuper = require("@swc/helpers/_/_create_super");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _youTubeHeader = require("./subcomponents/YouTubeHeader");
var _youTubeHeaderDefault = parcelHelpers.interopDefault(_youTubeHeader);
var _amzHeader = require("./subcomponents/AmzHeader");
var _amzHeaderDefault = parcelHelpers.interopDefault(_amzHeader);
var _userAdminHeader = require("./subcomponents/UserAdminHeader");
var _userAdminHeaderDefault = parcelHelpers.interopDefault(_userAdminHeader);
var _updateAccountHeader = require("./subcomponents/UpdateAccountHeader");
var _updateAccountHeaderDefault = parcelHelpers.interopDefault(_updateAccountHeader);
var _noProjectHeader = require("./subcomponents/NoProjectHeader");
var _utilities = require("../js/Utilities");
var _projectUtils = require("../actions/ProjectUtils");
var Projects = {
    "d157f6f8-43b7-11ea-b50b-1902bdae": (0, _youTubeHeaderDefault.default),
    "ea9298b7-6ddd-11ea-b7f4-008cfa070708": (0, _userAdminHeaderDefault.default),
    "dec4be2a-43b7-11ea-b50b-1902bdae": (0, _amzHeaderDefault.default),
    "999999": (0, _updateAccountHeaderDefault.default),
    "000000": (0, _noProjectHeader.NoProjectHeader)
};
var ProjectWrapper = function(projectId, WrappedComponent, props) {
    return /*#__PURE__*/ function(_React_Component) {
        "use strict";
        (0, _inherits._)(_class, _React_Component);
        var _super = (0, _createSuper._)(_class);
        function _class(props) {
            (0, _classCallCheck._)(this, _class);
            var _this;
            _this = _super.call(this, props);
            _this.state = {
                menu: {
                    open: false
                }
            };
            _this.toggleMenu = _this.toggleMenu.bind((0, _assertThisInitialized._)(_this));
            return _this;
        }
        (0, _createClass._)(_class, [
            {
                key: "toggleMenu",
                value: function toggleMenu(domEvent) {
                    this.setState((0, _projectUtils.setStateProjectMenuToggle));
                }
            },
            {
                key: "render",
                value: function render() {
                    var ProjectHeader = Projects[projectId];
                    var body;
                    var user = (0, _utilities.getAuthData)();
                    var requestedURL = window.location;
                    var destination = {
                        pathname: "/"
                    };
                    if (user && user.hasOwnProperty("token")) body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), (0, _objectSpread._)({}, (0, _utilities.getAuthData)())),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProjectHeader, {
                                onSwitch: this.toggleMenu,
                                canswitch: (0, _utilities.getAuthData)("permissions").length,
                                menuopen: this.state.menu.open
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedComponent, (0, _objectSpread._)({
                                project: projectId
                            }, this.state, this.props))
                        ]
                    });
                    else {
                        if (requestedURL.pathname !== "/") destination.search = "?redirect=".concat(requestedURL.pathname);
                        body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                            to: destination
                        });
                    }
                    return body;
                }
            }
        ]);
        return _class;
    }((0, _reactDefault.default).Component);
};
exports.default = ProjectWrapper;

},{"@swc/helpers/_/_assert_this_initialized":"3Eye5","@swc/helpers/_/_class_call_check":"lXJPT","@swc/helpers/_/_create_class":"jl0TM","@swc/helpers/_/_inherits":"8RuOX","@swc/helpers/_/_object_spread":"95yNt","@swc/helpers/_/_create_super":"4WNpt","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./Header":"116D9","./subcomponents/YouTubeHeader":"aaWNJ","./subcomponents/AmzHeader":"fnxwc","./subcomponents/UserAdminHeader":"laYeF","./subcomponents/UpdateAccountHeader":"2wjBK","./subcomponents/NoProjectHeader":"3JTHI","../js/Utilities":"euxcI","../actions/ProjectUtils":"fcpCK","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"116D9":[function(require,module,exports) {
/**
 * Header.js
 * Manages the navigation display
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactRouterDom = require("react-router-dom");
var _logo1021 = require("./subcomponents/Logo1021");
var _logo1021Default = parcelHelpers.interopDefault(_logo1021);
var _utilities = require("../js/Utilities");
var _headerCss = require("../css/Header.css");
var Header = function(param) {
    var displayname_first = param.displayname_first;
    if (!(0, _utilities.getAuthData)()) return null;
    var canAdmin = function() {
        var links = null;
        if ((0, _utilities.canAdminProject)("User Admin")) links = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    children: "\u2022"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    className: function(param) {
                        var isActive = param.isActive;
                        isActive;
                    },
                    to: "/admin",
                    children: "Admin"
                }, "admin")
            ]
        });
        return links;
    };
    var display_name = "Friend";
    if (displayname_first) display_name = displayname_first;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
        id: "SiteHeader",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "Logo1021",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logo1021Default.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "account",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Hello, ".concat(display_name),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/update_account",
                            children: "Update Account Info"
                        }, "update_account"),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: "\u2022"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/logout",
                            children: "Log Out"
                        }, "logout"),
                        canAdmin()
                    ]
                })
            })
        ]
    });
};
exports.default = Header;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","classnames":"8N3a2","react-router-dom":"gMZz4","./subcomponents/Logo1021":"1OCHu","../js/Utilities":"euxcI","../css/Header.css":"g13fQ","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"g13fQ":[function() {},{}],"aaWNJ":[function(require,module,exports) {
/**
 * YouTubeHeader.jsx
 * Manages the navigation display for the video curation section of the site.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _switchProjects = require("./SwitchProjects");
var _switchProjectsDefault = parcelHelpers.interopDefault(_switchProjects);
var _switchProjectsMenu = require("./SwitchProjectsMenu");
var _switchProjectsMenuDefault = parcelHelpers.interopDefault(_switchProjectsMenu);
var _utilities = require("../../js/Utilities");
var YouTubeHeader = function(param) {
    var menuopen = param.menuopen, canswitch = param.canswitch, onSwitch = param.onSwitch;
    var switcher = canswitch ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchProjectsDefault.default), {
        onClick: onSwitch
    }) : null;
    var activeClassName = function(param) {
        var isActive = param.isActive, isPending = param.isPending;
        return isActive ? "header__selected" : "";
    };
    var nav = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "nav__project__wrap",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                id: "YouTubeHeader",
                className: "nav__project",
                "aria-label": "YouTube Project Menu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        className: "nav__project_label",
                        children: "YouTube"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/search",
                        children: "Search"
                    }, "search"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/videos",
                        children: "Videos"
                    }, "videos"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/stations",
                        children: "Stations"
                    }, "stations"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/destinations",
                        children: "Destinations"
                    }, "linear"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/channels",
                        children: "Channels"
                    }, "channels"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/groups",
                        children: "Groups"
                    }, "groups"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/reports",
                        children: "Reports"
                    }, "reports"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/tools",
                        children: "Tools"
                    }, "tools")
                ]
            }),
            switcher,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchProjectsMenuDefault.default), {
                open: menuopen,
                onClose: onSwitch
            })
        ]
    });
    return nav;
};
exports.default = YouTubeHeader;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./SwitchProjects":"1dXHe","./SwitchProjectsMenu":"dFFvH","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"1dXHe":[function(require,module,exports) {
/**
 * SwitchProjects.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _switchProjectsCss = require("./css/SwitchProjects.css");
var SwitchProjects = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        type: "button",
        className: "switch__projects",
        onClick: props.onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                width: "15px",
                height: "15px",
                viewBox: "0 0 15 15",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    stroke: "none",
                    strokeWidth: "1",
                    fill: "#c00",
                    fillRule: "evenodd",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M15.0714286,4.71428571 C15.2455357,4.71428571 15.3962054,4.65066964 15.5234375,4.5234375 C15.6506696,4.39620536 15.7142857,4.24553571 15.7142857,4.07142857 L15.7142857,4.07142857 L15.7142857,2.78571429 C15.7142857,2.61160714 15.6506696,2.4609375 15.5234375,2.33370536 C15.3962054,2.20647321 15.2455357,2.14285714 15.0714286,2.14285714 L15.0714286,2.14285714 L0.928571429,2.14285714 C0.754464286,2.14285714 0.603794643,2.20647321 0.4765625,2.33370536 C0.349330357,2.4609375 0.285714286,2.61160714 0.285714286,2.78571429 L0.285714286,2.78571429 L0.285714286,4.07142857 C0.285714286,4.24553571 0.349330357,4.39620536 0.4765625,4.5234375 C0.603794643,4.65066964 0.754464286,4.71428571 0.928571429,4.71428571 L0.928571429,4.71428571 L15.0714286,4.71428571 Z M15.0714286,9.85714286 C15.2455357,9.85714286 15.3962054,9.79352679 15.5234375,9.66629464 C15.6506696,9.5390625 15.7142857,9.38839286 15.7142857,9.21428571 L15.7142857,9.21428571 L15.7142857,7.92857143 C15.7142857,7.75446429 15.6506696,7.60379464 15.5234375,7.4765625 C15.3962054,7.34933036 15.2455357,7.28571429 15.0714286,7.28571429 L15.0714286,7.28571429 L0.928571429,7.28571429 C0.754464286,7.28571429 0.603794643,7.34933036 0.4765625,7.4765625 C0.349330357,7.60379464 0.285714286,7.75446429 0.285714286,7.92857143 L0.285714286,7.92857143 L0.285714286,9.21428571 C0.285714286,9.38839286 0.349330357,9.5390625 0.4765625,9.66629464 C0.603794643,9.79352679 0.754464286,9.85714286 0.928571429,9.85714286 L0.928571429,9.85714286 L15.0714286,9.85714286 Z M15.0714286,15 C15.2455357,15 15.3962054,14.9363839 15.5234375,14.8091518 C15.6506696,14.6819196 15.7142857,14.53125 15.7142857,14.3571429 L15.7142857,14.3571429 L15.7142857,13.0714286 C15.7142857,12.8973214 15.6506696,12.7466518 15.5234375,12.6194196 C15.3962054,12.4921875 15.2455357,12.4285714 15.0714286,12.4285714 L15.0714286,12.4285714 L0.928571429,12.4285714 C0.754464286,12.4285714 0.603794643,12.4921875 0.4765625,12.6194196 C0.349330357,12.7466518 0.285714286,12.8973214 0.285714286,13.0714286 L0.285714286,13.0714286 L0.285714286,14.3571429 C0.285714286,14.53125 0.349330357,14.6819196 0.4765625,14.8091518 C0.603794643,14.9363839 0.754464286,15 0.928571429,15 L0.928571429,15 L15.0714286,15 Z",
                        fillRule: "nonzero"
                    })
                })
            }),
            "Switch Projects"
        ]
    });
};
exports.default = SwitchProjects;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./css/SwitchProjects.css":"7v5kj","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"7v5kj":[function() {},{}],"dFFvH":[function(require,module,exports) {
/**
 * SwitchProjects.jsx
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodashUniqueid = require("lodash.uniqueid");
var _lodashUniqueidDefault = parcelHelpers.interopDefault(_lodashUniqueid);
var _closeButton = require("./CloseButton");
var _project = require("../Login/Project");
var _switchProjects = require("./SwitchProjects");
var _switchProjectsDefault = parcelHelpers.interopDefault(_switchProjects);
var _projectIcons = require("../../js/ProjectIcons");
var _utilities = require("../../js/Utilities");
var _switchProjectsMenuCss = require("./css/SwitchProjectsMenu.css");
var SwitchProjectsMenu = function(param) {
    var open = param.open, onClose = param.onClose;
    var isOpen = (0, _classnamesDefault.default)({
        "open": open
    });
    var menu = null;
    if ((0, _utilities.getAuthData)("permissions").length) {
        var projects = (0, _utilities.getAuthData)("permissions").filter(function(pj) {
            return pj.name !== "User Admin";
        }).map(function(pj) {
            var ico = (0, _projectIcons.ProjectIcons)[pj.icon];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _project.Project), {
                path: "/".concat(pj.path),
                name: pj.name,
                icon: ico
            }, (0, _lodashUniqueidDefault.default)());
        });
        menu = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
            id: "SwitchProjectsMenu",
            className: isOpen,
            hidden: !open,
            "aria-labelledby": "SwitchProjectsMenuHeading",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                    color: "#fff",
                    className: "switch__project__ctrl",
                    onClick: onClose,
                    title: "Close Projects menu"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    id: "SwitchProjectsMenuHeading",
                    children: "Switch Projects"
                }),
                projects
            ]
        });
    }
    return menu;
};
exports.default = SwitchProjectsMenu;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","classnames":"8N3a2","lodash.uniqueid":"6bf5k","./CloseButton":"3MmmO","../Login/Project":"2VMAd","./SwitchProjects":"1dXHe","../../js/ProjectIcons":"gS8eL","../../js/Utilities":"euxcI","./css/SwitchProjectsMenu.css":"hxltW","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"hxltW":[function() {},{}],"fnxwc":[function(require,module,exports) {
/**
 * AmzHeader.js
 * Manages the navigation display for the Amazon Music project
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _switchProjects = require("./SwitchProjects");
var _switchProjectsDefault = parcelHelpers.interopDefault(_switchProjects);
var _switchProjectsMenu = require("./SwitchProjectsMenu");
var _switchProjectsMenuDefault = parcelHelpers.interopDefault(_switchProjectsMenu);
var AmzHeader = function(props) {
    var canswitch = props.canswitch, onSwitch = props.onSwitch, menuopen = props.menuopen;
    var cluster = (0, _reactRouterDom.useLocation)();
    var clust = null;
    if (Object.hasOwn(cluster, "state")) clust = (0, _objectSpread._)({}, cluster.state);
    var switcher = canswitch ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchProjectsDefault.default), {
        onClick: onSwitch
    }) : null;
    var activeClassName = function(param) {
        var isActive = param.isActive;
        return isActive ? "header__selected" : "";
    };
    var nav = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "nav__project__wrap",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                id: "AmzHeader",
                className: "nav__project",
                "aria-label": "Amazon Project Menu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        className: "nav__project_label",
                        children: "Music"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/music",
                        children: "Genres"
                    }, "genres"),
                    // eslint-disable-next-line operator-linebreak
                    clust && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        className: activeClassName,
                        to: "/music/clusters/".concat(clust.clusterId),
                        children: clust.clusterName
                    }, "clusters")
                ]
            }),
            switcher,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchProjectsMenuDefault.default), {
                open: menuopen,
                onClose: onSwitch
            })
        ]
    });
    return nav;
};
exports.default = AmzHeader;

},{"@swc/helpers/_/_object_spread":"95yNt","react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./SwitchProjects":"1dXHe","./SwitchProjectsMenu":"dFFvH","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"laYeF":[function(require,module,exports) {
/**
 * UserAdminHeader.jsx
 * The navigation display for the UserAdmin page(s).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _switchProjects = require("./SwitchProjects");
var _switchProjectsDefault = parcelHelpers.interopDefault(_switchProjects);
var _switchProjectsMenu = require("./SwitchProjectsMenu");
var _switchProjectsMenuDefault = parcelHelpers.interopDefault(_switchProjectsMenu);
var _utilities = require("../../js/Utilities");
var UserAdminHeader = function(param) {
    var _param_canswitch = param.canswitch, canswitch = _param_canswitch === void 0 ? false : _param_canswitch, _param_menuopen = param.menuopen, menuopen = _param_menuopen === void 0 ? false : _param_menuopen, _param_onSwitch = param.onSwitch, onSwitch = _param_onSwitch === void 0 ? function() {} : _param_onSwitch;
    var switcher = canswitch ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchProjectsDefault.default), {
        onClick: onSwitch
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "nav__project__wrap",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                id: "UserAdminHeader",
                className: "nav__project",
                "aria-label": "User Admin Menu",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    className: "nav__project_label",
                    children: "User Administration"
                })
            }),
            switcher,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchProjectsMenuDefault.default), {
                open: menuopen,
                onClose: onSwitch
            })
        ]
    });
};
exports.default = UserAdminHeader;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","./SwitchProjects":"1dXHe","./SwitchProjectsMenu":"dFFvH","../../js/Utilities":"euxcI","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"2wjBK":[function(require,module,exports) {
/**
 * UpdateAccountHeader.jsx
 * Manages the navigation display for the Update Account page
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var UpdateAccountHeader = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "nav__project__wrap",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
            id: "UserAdminHeader",
            className: "nav__project",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    className: "nav__project_label",
                    children: "Update Your Account"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/search",
                    children: "Search"
                }, "search"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/videos",
                    children: "Videos"
                }, "videos"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/stations",
                    children: "Stations"
                }, "stations"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/destinations",
                    children: "Destinations"
                }, "linear"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/channels",
                    children: "Channels"
                }, "channels"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/groups",
                    children: "Groups"
                }, "groups"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/reports",
                    children: "Reports"
                }, "reports"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: "/tools",
                    children: "Tools"
                }, "tools")
            ]
        })
    });
};
exports.default = UpdateAccountHeader;

},{"react/jsx-runtime":"66j3G","react":"l5IPE","react-router-dom":"gMZz4","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"3JTHI":[function(require,module,exports) {
/**
 * NoProjectHeader.jsx
 * Empty header for pages that do not requires a header
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoProjectHeader", function() {
    return NoProjectHeader;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var NoProjectHeader = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
};

},{"react/jsx-runtime":"66j3G","react":"l5IPE","@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"fcpCK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStateProjectMenuToggle", function() {
    return setStateProjectMenuToggle;
});
var setStateProjectMenuToggle = function(state) {
    return {
        menu: {
            open: !state.menu.open
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iRwqC"}],"lieWz":[function() {},{}],"jY5Cf":[function() {},{}],"hxw3o":[function() {},{}],"8qWlU":[function() {},{}],"idP1K":[function() {},{}],"kWrfi":[function() {},{}],"67ZQ7":[function() {},{}]},["jUsSX"], "jUsSX", "parcelRequire62a9")

//# sourceMappingURL=index.79354fcb.js.map
